var kh = Object.defineProperty;
var zc = (e) => {
  throw TypeError(e);
};
var bh = (e, t, n) => t in e ? kh(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var nn = (e, t, n) => bh(e, typeof t != "symbol" ? t + "" : t, n), Pi = (e, t, n) => t.has(e) || zc("Cannot " + n);
var ne = (e, t, n) => (Pi(e, t, "read from private field"), n ? n.call(e) : t.get(e)), An = (e, t, n) => t.has(e) ? zc("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), wn = (e, t, n, o) => (Pi(e, t, "write to private field"), o ? o.call(e, n) : t.set(e, n), n), xt = (e, t, n) => (Pi(e, t, "access private method"), n);
var Sc = (e, t, n, o) => ({
  set _(a) {
    wn(e, t, a, n);
  },
  get _() {
    return ne(e, t, o);
  }
});
import { FontAwesomeIcon as Fo } from "@fortawesome/vue-fontawesome";
import { computed as S, toValue as pn, getCurrentInstance as qn, withCtx as M, hasInjectionContext as wh, ref as N, readonly as Un, toRef as vt, watchEffect as se, markRaw as xo, nextTick as wl, defineComponent as J, renderSlot as Et, createCommentVNode as Q, unref as l, createRenderer as xh, camelize as $d, provide as $o, h as $h, watch as pt, onMounted as zd, onUnmounted as xl, warn as Sd, toRefs as we, createBlock as H, openBlock as $, createElementBlock as E, createElementVNode as z, normalizeStyle as Qt, createVNode as x, Fragment as me, inject as Cd, shallowRef as zh, mergeModels as Te, useModel as Ue, resolveComponent as De, withModifiers as yo, Transition as Qe, mergeProps as Qs, createTextVNode as Pe, toDisplayString as j, reactive as Ad, renderList as Ce, normalizeClass as ye, isRef as Ft, createStaticVNode as Pd, withDirectives as kt, withKeys as vs, vModelText as zn, createSlots as Zr, useTemplateRef as Xo, resolveDynamicComponent as $l, vModelRadio as gs, TransitionGroup as Sh, vShow as Ch, defineCustomElement as Ah } from "vue";
import { useIdle as Td, useDevicePixelRatio as Ph, useDebounceFn as Th, useTimeoutFn as Cc, useConfirmDialog as Mh, toRef as Ih, useStorage as Eh, useMousePressed as Md, useMouseInElement as Id, clamp as Kr, toRefs as Oh, useFocus as Ed, useEyeDropper as Rh, useScroll as Od, useDropZone as Lh, useFileDialog as jh, watchDebounced as Dh, useMediaQuery as Nh, useTimeout as Vh, useResizeObserver as Ac } from "@vueuse/core";
import { defineStore as rt, storeToRefs as L, createPinia as Uh } from "pinia";
import { useMutation as ct, useQueryClient as ut, useQuery as zt, useInfiniteQuery as Jo, VueQueryPlugin as Fh } from "@tanstack/vue-query";
import * as qh from "pixi.js";
import { ExtensionType as Rd, LoaderParserPriority as Bh, Text as Ld, TilingSprite as Hh, Sprite as jd, RenderLayer as Gh, RenderContainer as Wh, PerspectiveMesh as Zh, ParticleContainer as Kh, NineSliceSprite as Qh, NineSlicePlane as Xh, MeshSimple as Jh, MeshRope as Yh, MeshPlane as e_, Mesh as t_, HTMLText as n_, Graphics as o_, Container as a_, BitmapText as s_, AnimatedSprite as i_, extensions as r_, Application as l_, AbstractText as c_, Texture as Dd, WorkerManager as Pc, loadImageBitmap as u_, ImageSource as d_, getResolutionOfUrl as m_, createTexture as p_, GraphicsContext as Ss, Point as f_, Assets as Tc, WebGPURenderer as h_, WebGLRenderer as __ } from "pixi.js";
import { Plugin as zl, Viewport as v_ } from "pixi-viewport";
import { useI18n as dt, I18nT as Ti, createI18n as g_, I18nInjectionKey as y_ } from "vue-i18n";
import { setTag as Nd, startSpan as k_, setUser as b_ } from "@sentry/vue";
import { ToastRoot as w_, DialogTitle as sn, DialogRoot as rn, DialogTrigger as Vd, DialogPortal as ln, DialogOverlay as cn, DialogContent as un, Primitive as x_, DialogClose as Wt, SelectItem as Ud, SelectItemText as Fd, SelectRoot as qd, SelectTrigger as Bd, SelectValue as Hd, SelectIcon as $_, SelectPortal as Gd, SelectContent as Wd, SelectViewport as Zd, TabsTrigger as Kd, TooltipProvider as z_, TooltipRoot as S_, TooltipTrigger as C_, TooltipPortal as A_, TooltipContent as P_, TooltipArrow as T_, SelectScrollDownButton as M_, PopoverRoot as Qd, PopoverTrigger as Xd, PopoverPortal as Jd, PopoverContent as Yd, PopoverClose as em, PopoverArrow as I_, TabsRoot as Sl, TabsList as Cl, TabsContent as wa, VisuallyHidden as E_, AccordionRoot as O_, AccordionItem as R_, AccordionHeader as L_, AccordionTrigger as j_, AccordionContent as D_, DialogDescription as N_, CollapsibleRoot as V_, CollapsibleContent as U_, CollapsibleTrigger as F_, RadioGroupItem as q_, RadioGroupIndicator as B_, RadioGroupRoot as H_, TabsIndicator as G_, SliderRoot as W_, SliderTrack as Z_, SliderThumb as K_, ToastProvider as Q_, ToastViewport as X_ } from "radix-vue";
import { klona as to } from "klona";
import { extendTailwindMerge as J_ } from "tailwind-merge";
import { vInfiniteScroll as Ea } from "@vueuse/components";
import { findIconDefinition as Y_, config as ev, library as tv } from "@fortawesome/fontawesome-svg-core";
class eo extends Error {
  constructor(n, o, a) {
    const s = n.status || n.status === 0 ? n.status : "", i = n.statusText ?? "", r = `${s} ${i}`.trim(), c = r ? `status code ${r}` : "an unknown error";
    super(`Request failed with ${c}: ${o.method} ${o.url}`);
    nn(this, "response");
    nn(this, "request");
    nn(this, "options");
    this.name = "HTTPError", this.response = n, this.request = o, this.options = a;
  }
}
class tm extends Error {
  constructor(n) {
    let o = "Non-error value was thrown";
    try {
      typeof n == "string" ? o = n : n && typeof n == "object" && "message" in n && typeof n.message == "string" && (o = n.message);
    } catch {
    }
    super(o);
    nn(this, "name", "NonError");
    nn(this, "value");
    this.value = n;
  }
}
class Mi extends Error {
  constructor(n) {
    const o = n != null && n.cause ? n.cause instanceof Error ? n.cause : new tm(n.cause) : void 0;
    super(n != null && n.code ? `Forced retry: ${n.code}` : "Forced retry", o ? { cause: o } : void 0);
    nn(this, "name", "ForceRetryError");
    nn(this, "customDelay");
    nn(this, "code");
    nn(this, "customRequest");
    this.customDelay = n == null ? void 0 : n.delay, this.code = n == null ? void 0 : n.code, this.customRequest = n == null ? void 0 : n.request;
  }
}
const Mc = (() => {
  let e = !1, t = !1;
  const n = typeof globalThis.ReadableStream == "function", o = typeof globalThis.Request == "function";
  if (n && o)
    try {
      t = new globalThis.Request("https://empty.invalid", {
        body: new globalThis.ReadableStream(),
        method: "POST",
        // @ts-expect-error - Types are outdated.
        get duplex() {
          return e = !0, "half";
        }
      }).headers.has("Content-Type");
    } catch (a) {
      if (a instanceof Error && a.message === "unsupported BodyInit type")
        return !1;
      throw a;
    }
  return e && !t;
})(), nv = typeof globalThis.AbortController == "function", nm = typeof globalThis.AbortSignal == "function" && typeof globalThis.AbortSignal.any == "function", ov = typeof globalThis.ReadableStream == "function", av = typeof globalThis.FormData == "function", om = ["get", "post", "put", "patch", "head", "delete"], sv = {
  json: "application/json",
  text: "text/*",
  formData: "multipart/form-data",
  arrayBuffer: "*/*",
  blob: "*/*",
  // Supported in modern Fetch implementations (for example, browsers and recent Node.js/undici).
  // We still feature-check at runtime before exposing the shortcut.
  bytes: "*/*"
}, Ii = 2147483647, iv = new TextEncoder().encode("------WebKitFormBoundaryaxpyiPgbbPti10Rw").length, am = Symbol("stop");
class sm {
  constructor(t) {
    nn(this, "options");
    this.options = t;
  }
}
const rv = (e) => new sm(e), lv = {
  json: !0,
  parseJson: !0,
  stringifyJson: !0,
  searchParams: !0,
  prefixUrl: !0,
  retry: !0,
  timeout: !0,
  hooks: !0,
  throwHttpErrors: !0,
  onDownloadProgress: !0,
  onUploadProgress: !0,
  fetch: !0,
  context: !0
}, cv = {
  next: !0
  // Next.js cache revalidation (revalidate, tags)
}, uv = {
  method: !0,
  headers: !0,
  body: !0,
  mode: !0,
  credentials: !0,
  cache: !0,
  redirect: !0,
  referrer: !0,
  referrerPolicy: !0,
  integrity: !0,
  keepalive: !0,
  signal: !0,
  window: !0,
  duplex: !0
}, dv = (e) => {
  if (!e)
    return 0;
  if (e instanceof FormData) {
    let t = 0;
    for (const [n, o] of e)
      t += iv, t += new TextEncoder().encode(`Content-Disposition: form-data; name="${n}"`).length, t += typeof o == "string" ? new TextEncoder().encode(o).length : o.size;
    return t;
  }
  if (e instanceof Blob)
    return e.size;
  if (e instanceof ArrayBuffer)
    return e.byteLength;
  if (typeof e == "string")
    return new TextEncoder().encode(e).length;
  if (e instanceof URLSearchParams)
    return new TextEncoder().encode(e.toString()).length;
  if ("byteLength" in e)
    return e.byteLength;
  if (typeof e == "object" && e !== null)
    try {
      const t = JSON.stringify(e);
      return new TextEncoder().encode(t).length;
    } catch {
      return 0;
    }
  return 0;
}, im = (e, t, n) => {
  let o, a = 0;
  return e.pipeThrough(new TransformStream({
    transform(s, i) {
      if (i.enqueue(s), o) {
        a += o.byteLength;
        let r = t === 0 ? 0 : a / t;
        r >= 1 && (r = 1 - Number.EPSILON), n == null || n({ percent: r, totalBytes: Math.max(t, a), transferredBytes: a }, o);
      }
      o = s;
    },
    flush() {
      o && (a += o.byteLength, n == null || n({ percent: 1, totalBytes: Math.max(t, a), transferredBytes: a }, o));
    }
  }));
}, mv = (e, t) => {
  if (!e.body)
    return e;
  if (e.status === 204)
    return new Response(null, {
      status: e.status,
      statusText: e.statusText,
      headers: e.headers
    });
  const n = Math.max(0, Number(e.headers.get("content-length")) || 0);
  return new Response(im(e.body, n, t), {
    status: e.status,
    statusText: e.statusText,
    headers: e.headers
  });
}, pv = (e, t, n) => {
  if (!e.body)
    return e;
  const o = dv(n ?? e.body);
  return new Request(e, {
    // @ts-expect-error - Types are outdated.
    duplex: "half",
    body: im(e.body, o, t)
  });
}, fo = (e) => e !== null && typeof e == "object", ls = (...e) => {
  for (const t of e)
    if ((!fo(t) || Array.isArray(t)) && t !== void 0)
      throw new TypeError("The `options` argument must be an object");
  return Al({}, ...e);
}, rm = (e = {}, t = {}) => {
  const n = new globalThis.Headers(e), o = t instanceof globalThis.Headers, a = new globalThis.Headers(t);
  for (const [s, i] of a.entries())
    o && i === "undefined" || i === void 0 ? n.delete(s) : n.set(s, i);
  return n;
};
function cs(e, t, n) {
  return Object.hasOwn(t, n) && t[n] === void 0 ? [] : Al(e[n] ?? [], t[n] ?? []);
}
const lm = (e = {}, t = {}) => ({
  beforeRequest: cs(e, t, "beforeRequest"),
  beforeRetry: cs(e, t, "beforeRetry"),
  afterResponse: cs(e, t, "afterResponse"),
  beforeError: cs(e, t, "beforeError")
}), fv = (e, t) => {
  const n = new URLSearchParams();
  for (const o of [e, t])
    if (o !== void 0)
      if (o instanceof URLSearchParams)
        for (const [a, s] of o.entries())
          n.append(a, s);
      else if (Array.isArray(o))
        for (const a of o) {
          if (!Array.isArray(a) || a.length !== 2)
            throw new TypeError("Array search parameters must be provided in [[key, value], ...] format");
          n.append(String(a[0]), String(a[1]));
        }
      else if (fo(o))
        for (const [a, s] of Object.entries(o))
          s !== void 0 && n.append(a, String(s));
      else {
        const a = new URLSearchParams(o);
        for (const [s, i] of a.entries())
          n.append(s, i);
      }
  return n;
}, Al = (...e) => {
  let t = {}, n = {}, o = {}, a;
  const s = [];
  for (const i of e)
    if (Array.isArray(i))
      Array.isArray(t) || (t = []), t = [...t, ...i];
    else if (fo(i)) {
      for (let [r, c] of Object.entries(i)) {
        if (r === "signal" && c instanceof globalThis.AbortSignal) {
          s.push(c);
          continue;
        }
        if (r === "context") {
          if (c != null && (!fo(c) || Array.isArray(c)))
            throw new TypeError("The `context` option must be an object");
          t = {
            ...t,
            context: c == null ? {} : { ...t.context, ...c }
          };
          continue;
        }
        if (r === "searchParams") {
          c == null ? a = void 0 : a = a === void 0 ? c : fv(a, c);
          continue;
        }
        fo(c) && r in t && (c = Al(t[r], c)), t = { ...t, [r]: c };
      }
      fo(i.hooks) && (o = lm(o, i.hooks), t.hooks = o), fo(i.headers) && (n = rm(n, i.headers), t.headers = n);
    }
  return a !== void 0 && (t.searchParams = a), s.length > 0 && (s.length === 1 ? t.signal = s[0] : nm ? t.signal = AbortSignal.any(s) : t.signal = s.at(-1)), t.context === void 0 && (t.context = {}), t;
}, hv = (e) => om.includes(e) ? e.toUpperCase() : e, _v = ["get", "put", "head", "delete", "options", "trace"], vv = [408, 413, 429, 500, 502, 503, 504], gv = [413, 429, 503], Ic = {
  limit: 2,
  methods: _v,
  statusCodes: vv,
  afterStatusCodes: gv,
  maxRetryAfter: Number.POSITIVE_INFINITY,
  backoffLimit: Number.POSITIVE_INFINITY,
  delay: (e) => 0.3 * 2 ** (e - 1) * 1e3,
  jitter: void 0,
  retryOnTimeout: !1
}, yv = (e = {}) => {
  if (typeof e == "number")
    return {
      ...Ic,
      limit: e
    };
  if (e.methods && !Array.isArray(e.methods))
    throw new Error("retry.methods must be an array");
  if (e.statusCodes && !Array.isArray(e.statusCodes))
    throw new Error("retry.statusCodes must be an array");
  return {
    ...Ic,
    ...e
  };
};
class Qr extends Error {
  constructor(n) {
    super(`Request timed out: ${n.method} ${n.url}`);
    nn(this, "request");
    this.name = "TimeoutError", this.request = n;
  }
}
async function kv(e, t, n, o) {
  return new Promise((a, s) => {
    const i = setTimeout(() => {
      n && n.abort(), s(new Qr(e));
    }, o.timeout);
    o.fetch(e, t).then(a).catch(s).then(() => {
      clearTimeout(i);
    });
  });
}
async function bv(e, { signal: t }) {
  return new Promise((n, o) => {
    t && (t.throwIfAborted(), t.addEventListener("abort", a, { once: !0 }));
    function a() {
      clearTimeout(s), o(t.reason);
    }
    const s = setTimeout(() => {
      t == null || t.removeEventListener("abort", a), n();
    }, e);
  });
}
const wv = (e, t) => {
  const n = {};
  for (const o in t)
    Object.hasOwn(t, o) && !(o in uv) && !(o in lv) && (!(o in e) || o in cv) && (n[o] = t[o]);
  return n;
}, xv = (e) => e === void 0 ? !1 : Array.isArray(e) ? e.length > 0 : e instanceof URLSearchParams ? e.size > 0 : typeof e == "object" ? Object.keys(e).length > 0 : typeof e == "string" ? e.trim().length > 0 : !!e;
function $v(e) {
  return e instanceof eo || (e == null ? void 0 : e.name) === eo.name;
}
function zv(e) {
  return e instanceof Qr || (e == null ? void 0 : e.name) === Qr.name;
}
var Ks, cm, xn, mn, jt, fe, Jn, Mn, go, tt, ys, um, Xr, Jr, dm, ya, ks, Yr;
const za = class za {
  // eslint-disable-next-line complexity
  constructor(t, n = {}) {
    An(this, tt);
    nn(this, "request");
    An(this, xn);
    An(this, mn, 0);
    // eslint-disable-next-line @typescript-eslint/prefer-readonly -- False positive: #input is reassigned on line 202
    An(this, jt);
    An(this, fe);
    An(this, Jn);
    An(this, Mn);
    An(this, go);
    var a, s, i;
    if (wn(this, jt, t), wn(this, fe, {
      ...n,
      headers: rm(ne(this, jt).headers, n.headers),
      hooks: lm({
        beforeRequest: [],
        beforeRetry: [],
        beforeError: [],
        afterResponse: []
      }, n.hooks),
      method: hv(n.method ?? ne(this, jt).method ?? "GET"),
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      prefixUrl: String(n.prefixUrl || ""),
      retry: yv(n.retry),
      throwHttpErrors: n.throwHttpErrors ?? !0,
      timeout: n.timeout ?? 1e4,
      fetch: n.fetch ?? globalThis.fetch.bind(globalThis),
      context: n.context ?? {}
    }), typeof ne(this, jt) != "string" && !(ne(this, jt) instanceof URL || ne(this, jt) instanceof globalThis.Request))
      throw new TypeError("`input` must be a string, URL, or Request");
    if (ne(this, fe).prefixUrl && typeof ne(this, jt) == "string") {
      if (ne(this, jt).startsWith("/"))
        throw new Error("`input` must not begin with a slash when using `prefixUrl`");
      ne(this, fe).prefixUrl.endsWith("/") || (ne(this, fe).prefixUrl += "/"), wn(this, jt, ne(this, fe).prefixUrl + ne(this, jt));
    }
    nv && nm && (wn(this, Mn, ne(this, fe).signal ?? ne(this, jt).signal), wn(this, xn, new globalThis.AbortController()), ne(this, fe).signal = ne(this, Mn) ? AbortSignal.any([ne(this, Mn), ne(this, xn).signal]) : ne(this, xn).signal), Mc && (ne(this, fe).duplex = "half"), ne(this, fe).json !== void 0 && (ne(this, fe).body = ((s = (a = ne(this, fe)).stringifyJson) == null ? void 0 : s.call(a, ne(this, fe).json)) ?? JSON.stringify(ne(this, fe).json), ne(this, fe).headers.set("content-type", ne(this, fe).headers.get("content-type") ?? "application/json"));
    const o = n.headers && new globalThis.Headers(n.headers).has("content-type");
    if (ne(this, jt) instanceof globalThis.Request && (av && ne(this, fe).body instanceof globalThis.FormData || ne(this, fe).body instanceof URLSearchParams) && !o && ne(this, fe).headers.delete("content-type"), this.request = new globalThis.Request(ne(this, jt), ne(this, fe)), xv(ne(this, fe).searchParams)) {
      const c = "?" + (typeof ne(this, fe).searchParams == "string" ? ne(this, fe).searchParams.replace(/^\?/, "") : new URLSearchParams(xt(i = za, Ks, cm).call(i, ne(this, fe).searchParams)).toString()), u = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, c);
      this.request = new globalThis.Request(u, ne(this, fe));
    }
    if (ne(this, fe).onUploadProgress) {
      if (typeof ne(this, fe).onUploadProgress != "function")
        throw new TypeError("The `onUploadProgress` option must be a function");
      if (!Mc)
        throw new Error("Request streams are not supported in your environment. The `duplex` option for `Request` is not available.");
      this.request = xt(this, tt, Yr).call(this, this.request, ne(this, fe).body ?? void 0);
    }
  }
  static create(t, n) {
    var i, r, c;
    const o = new za(t, n), a = async () => {
      var d, p, _, y, k, w, f;
      if (typeof ne(o, fe).timeout == "number" && ne(o, fe).timeout > Ii)
        throw new RangeError(`The \`timeout\` option cannot be greater than ${Ii}`);
      await Promise.resolve();
      let u = await xt(d = o, tt, dm).call(d);
      for (const g of ne(o, fe).hooks.afterResponse) {
        const b = xt(p = o, tt, Xr).call(p, u.clone()), A = await g(o.request, xt(_ = o, tt, ya).call(_), b, { retryCount: ne(o, mn) });
        if (A instanceof globalThis.Response && (u = A), A instanceof sm)
          throw await Promise.all([
            (y = b.body) == null ? void 0 : y.cancel(),
            (k = u.body) == null ? void 0 : k.cancel()
          ]), new Mi(A.options);
      }
      if (xt(w = o, tt, Xr).call(w, u), !u.ok && (typeof ne(o, fe).throwHttpErrors == "function" ? ne(o, fe).throwHttpErrors(u.status) : ne(o, fe).throwHttpErrors)) {
        let g = new eo(u, o.request, xt(f = o, tt, ya).call(f));
        for (const b of ne(o, fe).hooks.beforeError)
          g = await b(g, { retryCount: ne(o, mn) });
        throw g;
      }
      if (ne(o, fe).onDownloadProgress) {
        if (typeof ne(o, fe).onDownloadProgress != "function")
          throw new TypeError("The `onDownloadProgress` option must be a function");
        if (!ov)
          throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");
        return mv(u.clone(), ne(o, fe).onDownloadProgress);
      }
      return u;
    }, s = xt(i = o, tt, Jr).call(i, a).finally(async () => {
      var p, _;
      const u = ne(o, Jn), d = [];
      u && !u.bodyUsed && d.push((p = u.body) == null ? void 0 : p.cancel()), o.request.bodyUsed || d.push((_ = o.request.body) == null ? void 0 : _.cancel()), await Promise.all(d);
    });
    for (const [u, d] of Object.entries(sv))
      u === "bytes" && typeof ((c = (r = globalThis.Response) == null ? void 0 : r.prototype) == null ? void 0 : c.bytes) != "function" || (s[u] = async () => {
        o.request.headers.set("accept", o.request.headers.get("accept") || d);
        const p = await s;
        if (u === "json") {
          if (p.status === 204)
            return "";
          const _ = await p.text();
          return _ === "" ? "" : n.parseJson ? n.parseJson(_) : JSON.parse(_);
        }
        return p[u]();
      });
    return s;
  }
};
Ks = new WeakSet(), cm = function(t) {
  return t && typeof t == "object" && !Array.isArray(t) && !(t instanceof URLSearchParams) ? Object.fromEntries(Object.entries(t).filter(([, n]) => n !== void 0)) : t;
}, xn = new WeakMap(), mn = new WeakMap(), jt = new WeakMap(), fe = new WeakMap(), Jn = new WeakMap(), Mn = new WeakMap(), go = new WeakMap(), tt = new WeakSet(), ys = function() {
  const t = ne(this, fe).retry.delay(ne(this, mn));
  let n = t;
  return ne(this, fe).retry.jitter === !0 ? n = Math.random() * t : typeof ne(this, fe).retry.jitter == "function" && (n = ne(this, fe).retry.jitter(t), (!Number.isFinite(n) || n < 0) && (n = t)), Math.min(ne(this, fe).retry.backoffLimit, n);
}, um = async function(t) {
  if (Sc(this, mn)._++, ne(this, mn) > ne(this, fe).retry.limit)
    throw t;
  const n = t instanceof Error ? t : new tm(t);
  if (n instanceof Mi)
    return n.customDelay ?? xt(this, tt, ys).call(this);
  if (!ne(this, fe).retry.methods.includes(this.request.method.toLowerCase()))
    throw t;
  if (ne(this, fe).retry.shouldRetry !== void 0) {
    const o = await ne(this, fe).retry.shouldRetry({ error: n, retryCount: ne(this, mn) });
    if (o === !1)
      throw t;
    if (o === !0)
      return xt(this, tt, ys).call(this);
  }
  if (zv(t) && !ne(this, fe).retry.retryOnTimeout)
    throw t;
  if ($v(t)) {
    if (!ne(this, fe).retry.statusCodes.includes(t.response.status))
      throw t;
    const o = t.response.headers.get("Retry-After") ?? t.response.headers.get("RateLimit-Reset") ?? t.response.headers.get("X-RateLimit-Retry-After") ?? t.response.headers.get("X-RateLimit-Reset") ?? t.response.headers.get("X-Rate-Limit-Reset");
    if (o && ne(this, fe).retry.afterStatusCodes.includes(t.response.status)) {
      let a = Number(o) * 1e3;
      Number.isNaN(a) ? a = Date.parse(o) - Date.now() : a >= Date.parse("2024-01-01") && (a -= Date.now());
      const s = ne(this, fe).retry.maxRetryAfter ?? a;
      return a < s ? a : s;
    }
    if (t.response.status === 413)
      throw t;
  }
  return xt(this, tt, ys).call(this);
}, Xr = function(t) {
  return ne(this, fe).parseJson && (t.json = async () => ne(this, fe).parseJson(await t.text())), t;
}, Jr = async function(t) {
  try {
    return await t();
  } catch (n) {
    const o = Math.min(await xt(this, tt, um).call(this, n), Ii);
    if (ne(this, mn) < 1)
      throw n;
    if (await bv(o, ne(this, Mn) ? { signal: ne(this, Mn) } : {}), n instanceof Mi && n.customRequest) {
      const a = ne(this, fe).signal ? new globalThis.Request(n.customRequest, { signal: ne(this, fe).signal }) : new globalThis.Request(n.customRequest);
      xt(this, tt, ks).call(this, a);
    }
    for (const a of ne(this, fe).hooks.beforeRetry) {
      const s = await a({
        request: this.request,
        options: xt(this, tt, ya).call(this),
        error: n,
        retryCount: ne(this, mn)
      });
      if (s instanceof globalThis.Request) {
        xt(this, tt, ks).call(this, s);
        break;
      }
      if (s instanceof globalThis.Response)
        return s;
      if (s === am)
        return;
    }
    return xt(this, tt, Jr).call(this, t);
  }
}, dm = async function() {
  var n;
  (n = ne(this, xn)) != null && n.signal.aborted && (wn(this, xn, new globalThis.AbortController()), ne(this, fe).signal = ne(this, Mn) ? AbortSignal.any([ne(this, Mn), ne(this, xn).signal]) : ne(this, xn).signal, this.request = new globalThis.Request(this.request, { signal: ne(this, fe).signal }));
  for (const o of ne(this, fe).hooks.beforeRequest) {
    const a = await o(this.request, xt(this, tt, ya).call(this), { retryCount: ne(this, mn) });
    if (a instanceof Response)
      return a;
    if (a instanceof globalThis.Request) {
      xt(this, tt, ks).call(this, a);
      break;
    }
  }
  const t = wv(this.request, ne(this, fe));
  return wn(this, Jn, this.request), this.request = ne(this, Jn).clone(), ne(this, fe).timeout === !1 ? ne(this, fe).fetch(ne(this, Jn), t) : kv(ne(this, Jn), t, ne(this, xn), ne(this, fe));
}, ya = function() {
  if (!ne(this, go)) {
    const { hooks: t, ...n } = ne(this, fe);
    wn(this, go, Object.freeze(n));
  }
  return ne(this, go);
}, ks = function(t) {
  wn(this, go, void 0), this.request = xt(this, tt, Yr).call(this, t);
}, Yr = function(t, n) {
  return !ne(this, fe).onUploadProgress || !t.body ? t : pv(t, ne(this, fe).onUploadProgress, n ?? ne(this, fe).body ?? void 0);
}, An(za, Ks);
let Cs = za;
/*! MIT License © Sindre Sorhus */
const el = (e) => {
  const t = (n, o) => Cs.create(n, ls(e, o));
  for (const n of om)
    t[n] = (o, a) => Cs.create(o, ls(e, a, { method: n }));
  return t.create = (n) => el(ls(n)), t.extend = (n) => (typeof n == "function" && (n = n(e ?? {})), el(ls(e, n))), t.stop = am, t.retry = rv, t;
}, mm = el();
var Ec = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function pm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Sv(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function o() {
      return this instanceof o ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(o) {
    var a = Object.getOwnPropertyDescriptor(e, o);
    Object.defineProperty(n, o, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[o];
      }
    });
  }), n;
}
var Ei, Oc;
function Yo() {
  return Oc || (Oc = 1, Ei = TypeError), Ei;
}
const Cv = {}, Av = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Cv
}, Symbol.toStringTag, { value: "Module" })), Pv = /* @__PURE__ */ Sv(Av);
var Oi, Rc;
function Xs() {
  if (Rc) return Oi;
  Rc = 1;
  var e = typeof Map == "function" && Map.prototype, t = Object.getOwnPropertyDescriptor && e ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, n = e && t && typeof t.get == "function" ? t.get : null, o = e && Map.prototype.forEach, a = typeof Set == "function" && Set.prototype, s = Object.getOwnPropertyDescriptor && a ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, i = a && s && typeof s.get == "function" ? s.get : null, r = a && Set.prototype.forEach, c = typeof WeakMap == "function" && WeakMap.prototype, u = c ? WeakMap.prototype.has : null, d = typeof WeakSet == "function" && WeakSet.prototype, p = d ? WeakSet.prototype.has : null, _ = typeof WeakRef == "function" && WeakRef.prototype, y = _ ? WeakRef.prototype.deref : null, k = Boolean.prototype.valueOf, w = Object.prototype.toString, f = Function.prototype.toString, g = String.prototype.match, b = String.prototype.slice, A = String.prototype.replace, P = String.prototype.toUpperCase, I = String.prototype.toLowerCase, D = RegExp.prototype.test, R = Array.prototype.concat, U = Array.prototype.join, G = Array.prototype.slice, F = Math.floor, de = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, K = Object.getOwnPropertySymbols, ce = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, ue = typeof Symbol == "function" && typeof Symbol.iterator == "object", Ae = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === ue || !0) ? Symbol.toStringTag : null, te = Object.prototype.propertyIsEnumerable, X = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(q) {
    return q.__proto__;
  } : null);
  function ee(q, W) {
    if (q === 1 / 0 || q === -1 / 0 || q !== q || q && q > -1e3 && q < 1e3 || D.call(/e/, W))
      return W;
    var Ge = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof q == "number") {
      var Je = q < 0 ? -F(-q) : F(q);
      if (Je !== q) {
        var qe = String(Je), je = b.call(W, qe.length + 1);
        return A.call(qe, Ge, "$&_") + "." + A.call(A.call(je, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return A.call(W, Ge, "$&_");
  }
  var ie = Pv, he = ie.custom, ve = at(he) ? he : null, ze = {
    __proto__: null,
    double: '"',
    single: "'"
  }, ot = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  Oi = function q(W, Ge, Je, qe) {
    var je = Ge || {};
    if (it(je, "quoteStyle") && !it(ze, je.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (it(je, "maxStringLength") && (typeof je.maxStringLength == "number" ? je.maxStringLength < 0 && je.maxStringLength !== 1 / 0 : je.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var Ut = it(je, "customInspect") ? je.customInspect : !0;
    if (typeof Ut != "boolean" && Ut !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (it(je, "indent") && je.indent !== null && je.indent !== "	" && !(parseInt(je.indent, 10) === je.indent && je.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (it(je, "numericSeparator") && typeof je.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var jn = je.numericSeparator;
    if (typeof W > "u")
      return "undefined";
    if (W === null)
      return "null";
    if (typeof W == "boolean")
      return W ? "true" : "false";
    if (typeof W == "string")
      return Xa(W, je);
    if (typeof W == "number") {
      if (W === 0)
        return 1 / 0 / W > 0 ? "0" : "-0";
      var Lt = String(W);
      return jn ? ee(W, Lt) : Lt;
    }
    if (typeof W == "bigint") {
      var kn = String(W) + "n";
      return jn ? ee(W, kn) : kn;
    }
    var Do = typeof je.depth > "u" ? 5 : je.depth;
    if (typeof Je > "u" && (Je = 0), Je >= Do && Do > 0 && typeof W == "object")
      return _t(W) ? "[Array]" : "[Object]";
    var Dn = ca(je, Je);
    if (typeof qe > "u")
      qe = [];
    else if (Rn(qe, W) >= 0)
      return "[Circular]";
    function tn(Cn, Zn, ki) {
      if (Zn && (qe = G.call(qe), qe.push(Zn)), ki) {
        var as = {
          depth: je.depth
        };
        return it(je, "quoteStyle") && (as.quoteStyle = je.quoteStyle), q(Cn, as, Je + 1, qe);
      }
      return q(Cn, je, Je + 1, qe);
    }
    if (typeof W == "function" && !et(W)) {
      var Ya = io(W), es = jo(W, tn);
      return "[Function" + (Ya ? ": " + Ya : " (anonymous)") + "]" + (es.length > 0 ? " { " + U.call(es, ", ") + " }" : "");
    }
    if (at(W)) {
      var co = ue ? A.call(String(W), /^(Symbol\(.*\))_[^)]*$/, "$1") : ce.call(W);
      return typeof W == "object" && !ue ? ro(co) : co;
    }
    if (_i(W)) {
      for (var uo = "<" + I.call(String(W.nodeName)), No = W.attributes || [], Vo = 0; Vo < No.length; Vo++)
        uo += " " + No[Vo].name + "=" + Ie(ae(No[Vo].value), "double", je);
      return uo += ">", W.childNodes && W.childNodes.length && (uo += "..."), uo += "</" + I.call(String(W.nodeName)) + ">", uo;
    }
    if (_t(W)) {
      if (W.length === 0)
        return "[]";
      var ua = jo(W, tn);
      return Dn && !gi(ua) ? "[" + lo(ua, Dn) + "]" : "[ " + U.call(ua, ", ") + " ]";
    }
    if (Ne(W)) {
      var da = jo(W, tn);
      return !("cause" in Error.prototype) && "cause" in W && !te.call(W, "cause") ? "{ [" + String(W) + "] " + U.call(R.call("[cause]: " + tn(W.cause), da), ", ") + " }" : da.length === 0 ? "[" + String(W) + "]" : "{ [" + String(W) + "] " + U.call(da, ", ") + " }";
    }
    if (typeof W == "object" && Ut) {
      if (ve && typeof W[ve] == "function" && ie)
        return ie(W, { depth: Do - Je });
      if (Ut !== "symbol" && typeof W.inspect == "function")
        return W.inspect();
    }
    if (Ln(W)) {
      var ts = [];
      return o && o.call(W, function(Cn, Zn) {
        ts.push(tn(Zn, W, !0) + " => " + tn(Cn, W));
      }), Ja("Map", n.call(W), ts, Dn);
    }
    if (Wn(W)) {
      var ns = [];
      return r && r.call(W, function(Cn) {
        ns.push(tn(Cn, W));
      }), Ja("Set", i.call(W), ns, Dn);
    }
    if (en(W))
      return la("WeakMap");
    if (Xe(W))
      return la("WeakSet");
    if (yn(W))
      return la("WeakRef");
    if (Fe(W))
      return ro(tn(Number(W)));
    if (mt(W))
      return ro(tn(de.call(W)));
    if (Ke(W))
      return ro(k.call(W));
    if (xe(W))
      return ro(tn(String(W)));
    if (typeof window < "u" && W === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && W === globalThis || typeof Ec < "u" && W === Ec)
      return "{ [object globalThis] }";
    if (!St(W) && !et(W)) {
      var ma = jo(W, tn), pa = X ? X(W) === Object.prototype : W instanceof Object || W.constructor === Object, bn = W instanceof Object ? "" : "null prototype", os = !pa && Ae && Object(W) === W && Ae in W ? b.call(Rt(W), 8, -1) : bn ? "Object" : "", yi = pa || typeof W.constructor != "function" ? "" : W.constructor.name ? W.constructor.name + " " : "", fa = yi + (os || bn ? "[" + U.call(R.call([], os || [], bn || []), ": ") + "] " : "");
      return ma.length === 0 ? fa + "{}" : Dn ? fa + "{" + lo(ma, Dn) + "}" : fa + "{ " + U.call(ma, ", ") + " }";
    }
    return String(W);
  };
  function Ie(q, W, Ge) {
    var Je = Ge.quoteStyle || W, qe = ze[Je];
    return qe + q + qe;
  }
  function ae(q) {
    return A.call(String(q), /"/g, "&quot;");
  }
  function _e(q) {
    return !Ae || !(typeof q == "object" && (Ae in q || typeof q[Ae] < "u"));
  }
  function _t(q) {
    return Rt(q) === "[object Array]" && _e(q);
  }
  function St(q) {
    return Rt(q) === "[object Date]" && _e(q);
  }
  function et(q) {
    return Rt(q) === "[object RegExp]" && _e(q);
  }
  function Ne(q) {
    return Rt(q) === "[object Error]" && _e(q);
  }
  function xe(q) {
    return Rt(q) === "[object String]" && _e(q);
  }
  function Fe(q) {
    return Rt(q) === "[object Number]" && _e(q);
  }
  function Ke(q) {
    return Rt(q) === "[object Boolean]" && _e(q);
  }
  function at(q) {
    if (ue)
      return q && typeof q == "object" && q instanceof Symbol;
    if (typeof q == "symbol")
      return !0;
    if (!q || typeof q != "object" || !ce)
      return !1;
    try {
      return ce.call(q), !0;
    } catch {
    }
    return !1;
  }
  function mt(q) {
    if (!q || typeof q != "object" || !de)
      return !1;
    try {
      return de.call(q), !0;
    } catch {
    }
    return !1;
  }
  var Ht = Object.prototype.hasOwnProperty || function(q) {
    return q in this;
  };
  function it(q, W) {
    return Ht.call(q, W);
  }
  function Rt(q) {
    return w.call(q);
  }
  function io(q) {
    if (q.name)
      return q.name;
    var W = g.call(f.call(q), /^function\s*([\w$]+)/);
    return W ? W[1] : null;
  }
  function Rn(q, W) {
    if (q.indexOf)
      return q.indexOf(W);
    for (var Ge = 0, Je = q.length; Ge < Je; Ge++)
      if (q[Ge] === W)
        return Ge;
    return -1;
  }
  function Ln(q) {
    if (!n || !q || typeof q != "object")
      return !1;
    try {
      n.call(q);
      try {
        i.call(q);
      } catch {
        return !0;
      }
      return q instanceof Map;
    } catch {
    }
    return !1;
  }
  function en(q) {
    if (!u || !q || typeof q != "object")
      return !1;
    try {
      u.call(q, u);
      try {
        p.call(q, p);
      } catch {
        return !0;
      }
      return q instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function yn(q) {
    if (!y || !q || typeof q != "object")
      return !1;
    try {
      return y.call(q), !0;
    } catch {
    }
    return !1;
  }
  function Wn(q) {
    if (!i || !q || typeof q != "object")
      return !1;
    try {
      i.call(q);
      try {
        n.call(q);
      } catch {
        return !0;
      }
      return q instanceof Set;
    } catch {
    }
    return !1;
  }
  function Xe(q) {
    if (!p || !q || typeof q != "object")
      return !1;
    try {
      p.call(q, p);
      try {
        u.call(q, u);
      } catch {
        return !0;
      }
      return q instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function _i(q) {
    return !q || typeof q != "object" ? !1 : typeof HTMLElement < "u" && q instanceof HTMLElement ? !0 : typeof q.nodeName == "string" && typeof q.getAttribute == "function";
  }
  function Xa(q, W) {
    if (q.length > W.maxStringLength) {
      var Ge = q.length - W.maxStringLength, Je = "... " + Ge + " more character" + (Ge > 1 ? "s" : "");
      return Xa(b.call(q, 0, W.maxStringLength), W) + Je;
    }
    var qe = ot[W.quoteStyle || "single"];
    qe.lastIndex = 0;
    var je = A.call(A.call(q, qe, "\\$1"), /[\x00-\x1f]/g, vi);
    return Ie(je, "single", W);
  }
  function vi(q) {
    var W = q.charCodeAt(0), Ge = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[W];
    return Ge ? "\\" + Ge : "\\x" + (W < 16 ? "0" : "") + P.call(W.toString(16));
  }
  function ro(q) {
    return "Object(" + q + ")";
  }
  function la(q) {
    return q + " { ? }";
  }
  function Ja(q, W, Ge, Je) {
    var qe = Je ? lo(Ge, Je) : U.call(Ge, ", ");
    return q + " (" + W + ") {" + qe + "}";
  }
  function gi(q) {
    for (var W = 0; W < q.length; W++)
      if (Rn(q[W], `
`) >= 0)
        return !1;
    return !0;
  }
  function ca(q, W) {
    var Ge;
    if (q.indent === "	")
      Ge = "	";
    else if (typeof q.indent == "number" && q.indent > 0)
      Ge = U.call(Array(q.indent + 1), " ");
    else
      return null;
    return {
      base: Ge,
      prev: U.call(Array(W + 1), Ge)
    };
  }
  function lo(q, W) {
    if (q.length === 0)
      return "";
    var Ge = `
` + W.prev + W.base;
    return Ge + U.call(q, "," + Ge) + `
` + W.prev;
  }
  function jo(q, W) {
    var Ge = _t(q), Je = [];
    if (Ge) {
      Je.length = q.length;
      for (var qe = 0; qe < q.length; qe++)
        Je[qe] = it(q, qe) ? W(q[qe], q) : "";
    }
    var je = typeof K == "function" ? K(q) : [], Ut;
    if (ue) {
      Ut = {};
      for (var jn = 0; jn < je.length; jn++)
        Ut["$" + je[jn]] = je[jn];
    }
    for (var Lt in q)
      it(q, Lt) && (Ge && String(Number(Lt)) === Lt && Lt < q.length || ue && Ut["$" + Lt] instanceof Symbol || (D.call(/[^\w$]/, Lt) ? Je.push(W(Lt, q) + ": " + W(q[Lt], q)) : Je.push(Lt + ": " + W(q[Lt], q))));
    if (typeof K == "function")
      for (var kn = 0; kn < je.length; kn++)
        te.call(q, je[kn]) && Je.push("[" + W(je[kn]) + "]: " + W(q[je[kn]], q));
    return Je;
  }
  return Oi;
}
var Ri, Lc;
function Tv() {
  if (Lc) return Ri;
  Lc = 1;
  var e = /* @__PURE__ */ Xs(), t = /* @__PURE__ */ Yo(), n = function(r, c, u) {
    for (var d = r, p; (p = d.next) != null; d = p)
      if (p.key === c)
        return d.next = p.next, u || (p.next = /** @type {NonNullable<typeof list.next>} */
        r.next, r.next = p), p;
  }, o = function(r, c) {
    if (r) {
      var u = n(r, c);
      return u && u.value;
    }
  }, a = function(r, c, u) {
    var d = n(r, c);
    d ? d.value = u : r.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: c,
      next: r.next,
      value: u
    };
  }, s = function(r, c) {
    return r ? !!n(r, c) : !1;
  }, i = function(r, c) {
    if (r)
      return n(r, c, !0);
  };
  return Ri = function() {
    var c, u = {
      assert: function(d) {
        if (!u.has(d))
          throw new t("Side channel does not contain " + e(d));
      },
      delete: function(d) {
        var p = c && c.next, _ = i(c, d);
        return _ && p && p === _ && (c = void 0), !!_;
      },
      get: function(d) {
        return o(c, d);
      },
      has: function(d) {
        return s(c, d);
      },
      set: function(d, p) {
        c || (c = {
          next: void 0
        }), a(
          /** @type {NonNullable<typeof $o>} */
          c,
          d,
          p
        );
      }
    };
    return u;
  }, Ri;
}
var Li, jc;
function fm() {
  return jc || (jc = 1, Li = Object), Li;
}
var ji, Dc;
function Mv() {
  return Dc || (Dc = 1, ji = Error), ji;
}
var Di, Nc;
function Iv() {
  return Nc || (Nc = 1, Di = EvalError), Di;
}
var Ni, Vc;
function Ev() {
  return Vc || (Vc = 1, Ni = RangeError), Ni;
}
var Vi, Uc;
function Ov() {
  return Uc || (Uc = 1, Vi = ReferenceError), Vi;
}
var Ui, Fc;
function Rv() {
  return Fc || (Fc = 1, Ui = SyntaxError), Ui;
}
var Fi, qc;
function Lv() {
  return qc || (qc = 1, Fi = URIError), Fi;
}
var qi, Bc;
function jv() {
  return Bc || (Bc = 1, qi = Math.abs), qi;
}
var Bi, Hc;
function Dv() {
  return Hc || (Hc = 1, Bi = Math.floor), Bi;
}
var Hi, Gc;
function Nv() {
  return Gc || (Gc = 1, Hi = Math.max), Hi;
}
var Gi, Wc;
function Vv() {
  return Wc || (Wc = 1, Gi = Math.min), Gi;
}
var Wi, Zc;
function Uv() {
  return Zc || (Zc = 1, Wi = Math.pow), Wi;
}
var Zi, Kc;
function Fv() {
  return Kc || (Kc = 1, Zi = Math.round), Zi;
}
var Ki, Qc;
function qv() {
  return Qc || (Qc = 1, Ki = Number.isNaN || function(t) {
    return t !== t;
  }), Ki;
}
var Qi, Xc;
function Bv() {
  if (Xc) return Qi;
  Xc = 1;
  var e = /* @__PURE__ */ qv();
  return Qi = function(n) {
    return e(n) || n === 0 ? n : n < 0 ? -1 : 1;
  }, Qi;
}
var Xi, Jc;
function Hv() {
  return Jc || (Jc = 1, Xi = Object.getOwnPropertyDescriptor), Xi;
}
var Ji, Yc;
function hm() {
  if (Yc) return Ji;
  Yc = 1;
  var e = /* @__PURE__ */ Hv();
  if (e)
    try {
      e([], "length");
    } catch {
      e = null;
    }
  return Ji = e, Ji;
}
var Yi, eu;
function Gv() {
  if (eu) return Yi;
  eu = 1;
  var e = Object.defineProperty || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return Yi = e, Yi;
}
var er, tu;
function Wv() {
  return tu || (tu = 1, er = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, n = Symbol("test"), o = Object(n);
    if (typeof n == "string" || Object.prototype.toString.call(n) !== "[object Symbol]" || Object.prototype.toString.call(o) !== "[object Symbol]")
      return !1;
    var a = 42;
    t[n] = a;
    for (var s in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var i = Object.getOwnPropertySymbols(t);
    if (i.length !== 1 || i[0] !== n || !Object.prototype.propertyIsEnumerable.call(t, n))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var r = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(t, n)
      );
      if (r.value !== a || r.enumerable !== !0)
        return !1;
    }
    return !0;
  }), er;
}
var tr, nu;
function Zv() {
  if (nu) return tr;
  nu = 1;
  var e = typeof Symbol < "u" && Symbol, t = Wv();
  return tr = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, tr;
}
var nr, ou;
function _m() {
  return ou || (ou = 1, nr = typeof Reflect < "u" && Reflect.getPrototypeOf || null), nr;
}
var or, au;
function vm() {
  if (au) return or;
  au = 1;
  var e = /* @__PURE__ */ fm();
  return or = e.getPrototypeOf || null, or;
}
var ar, su;
function Kv() {
  if (su) return ar;
  su = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, n = Math.max, o = "[object Function]", a = function(c, u) {
    for (var d = [], p = 0; p < c.length; p += 1)
      d[p] = c[p];
    for (var _ = 0; _ < u.length; _ += 1)
      d[_ + c.length] = u[_];
    return d;
  }, s = function(c, u) {
    for (var d = [], p = u, _ = 0; p < c.length; p += 1, _ += 1)
      d[_] = c[p];
    return d;
  }, i = function(r, c) {
    for (var u = "", d = 0; d < r.length; d += 1)
      u += r[d], d + 1 < r.length && (u += c);
    return u;
  };
  return ar = function(c) {
    var u = this;
    if (typeof u != "function" || t.apply(u) !== o)
      throw new TypeError(e + u);
    for (var d = s(arguments, 1), p, _ = function() {
      if (this instanceof p) {
        var g = u.apply(
          this,
          a(d, arguments)
        );
        return Object(g) === g ? g : this;
      }
      return u.apply(
        c,
        a(d, arguments)
      );
    }, y = n(0, u.length - d.length), k = [], w = 0; w < y; w++)
      k[w] = "$" + w;
    if (p = Function("binder", "return function (" + i(k, ",") + "){ return binder.apply(this,arguments); }")(_), u.prototype) {
      var f = function() {
      };
      f.prototype = u.prototype, p.prototype = new f(), f.prototype = null;
    }
    return p;
  }, ar;
}
var sr, iu;
function Js() {
  if (iu) return sr;
  iu = 1;
  var e = Kv();
  return sr = Function.prototype.bind || e, sr;
}
var ir, ru;
function Pl() {
  return ru || (ru = 1, ir = Function.prototype.call), ir;
}
var rr, lu;
function gm() {
  return lu || (lu = 1, rr = Function.prototype.apply), rr;
}
var lr, cu;
function Qv() {
  return cu || (cu = 1, lr = typeof Reflect < "u" && Reflect && Reflect.apply), lr;
}
var cr, uu;
function Xv() {
  if (uu) return cr;
  uu = 1;
  var e = Js(), t = gm(), n = Pl(), o = Qv();
  return cr = o || e.call(n, t), cr;
}
var ur, du;
function ym() {
  if (du) return ur;
  du = 1;
  var e = Js(), t = /* @__PURE__ */ Yo(), n = Pl(), o = Xv();
  return ur = function(s) {
    if (s.length < 1 || typeof s[0] != "function")
      throw new t("a function is required");
    return o(e, n, s);
  }, ur;
}
var dr, mu;
function Jv() {
  if (mu) return dr;
  mu = 1;
  var e = ym(), t = /* @__PURE__ */ hm(), n;
  try {
    n = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (i) {
    if (!i || typeof i != "object" || !("code" in i) || i.code !== "ERR_PROTO_ACCESS")
      throw i;
  }
  var o = !!n && t && t(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), a = Object, s = a.getPrototypeOf;
  return dr = o && typeof o.get == "function" ? e([o.get]) : typeof s == "function" ? (
    /** @type {import('./get')} */
    function(r) {
      return s(r == null ? r : a(r));
    }
  ) : !1, dr;
}
var mr, pu;
function Yv() {
  if (pu) return mr;
  pu = 1;
  var e = _m(), t = vm(), n = /* @__PURE__ */ Jv();
  return mr = e ? function(a) {
    return e(a);
  } : t ? function(a) {
    if (!a || typeof a != "object" && typeof a != "function")
      throw new TypeError("getProto: not an object");
    return t(a);
  } : n ? function(a) {
    return n(a);
  } : null, mr;
}
var pr, fu;
function eg() {
  if (fu) return pr;
  fu = 1;
  const e = (
    /** @type {import('.').AsyncFunctionConstructor} */
    (async function() {
    }).constructor
  );
  return pr = () => e, pr;
}
var fr, hu;
function tg() {
  if (hu) return fr;
  hu = 1;
  const e = (
    /** @type {GeneratorFunctionConstructor} */
    (function* () {
    }).constructor
  );
  return fr = () => e, fr;
}
var hr, _u;
function ng() {
  if (_u) return hr;
  _u = 1;
  const e = (
    /** @type {import('.').AsyncGeneratorFunctionConstructor} */
    (async function* () {
    }).constructor
  );
  return hr = () => e, hr;
}
var _r, vu;
function og() {
  if (vu) return _r;
  vu = 1;
  var e = Function.prototype.call, t = Object.prototype.hasOwnProperty, n = Js();
  return _r = n.call(e, t), _r;
}
var vr, gu;
function Tl() {
  if (gu) return vr;
  gu = 1;
  var e, t = /* @__PURE__ */ fm(), n = /* @__PURE__ */ Mv(), o = /* @__PURE__ */ Iv(), a = /* @__PURE__ */ Ev(), s = /* @__PURE__ */ Ov(), i = /* @__PURE__ */ Rv(), r = /* @__PURE__ */ Yo(), c = /* @__PURE__ */ Lv(), u = /* @__PURE__ */ jv(), d = /* @__PURE__ */ Dv(), p = /* @__PURE__ */ Nv(), _ = /* @__PURE__ */ Vv(), y = /* @__PURE__ */ Uv(), k = /* @__PURE__ */ Fv(), w = /* @__PURE__ */ Bv(), f = /* @__PURE__ */ hm(), g = /* @__PURE__ */ Gv(), b = function() {
    throw new r();
  }, A = f ? (function() {
    try {
      return arguments.callee, b;
    } catch {
      try {
        return f(arguments, "callee").get;
      } catch {
        return b;
      }
    }
  })() : b, P = Zv()(), I = Yv(), D = vm(), R = _m(), U = gm(), G = Pl(), F = {}, de = typeof Uint8Array > "u" || !I ? e : I(Uint8Array), K = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? e : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? e : ArrayBuffer,
    "%ArrayIteratorPrototype%": P && I ? I([][Symbol.iterator]()) : e,
    "%AsyncFromSyncIteratorPrototype%": e,
    "%AsyncFunction%": F,
    "%AsyncGenerator%": F,
    "%AsyncGeneratorFunction%": F,
    "%AsyncIteratorPrototype%": F,
    "%Atomics%": typeof Atomics > "u" ? e : Atomics,
    "%BigInt%": typeof BigInt > "u" ? e : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? e : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? e : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? e : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": n,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": o,
    "%Float16Array%": typeof Float16Array > "u" ? e : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? e : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? e : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? e : FinalizationRegistry,
    "%Function%": Function,
    "%GeneratorFunction%": F,
    "%Int8Array%": typeof Int8Array > "u" ? e : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? e : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? e : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": P && I ? I(I([][Symbol.iterator]())) : e,
    "%JSON%": typeof JSON == "object" ? JSON : e,
    "%Map%": typeof Map > "u" ? e : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !P || !I ? e : I((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": t,
    "%Object.getOwnPropertyDescriptor%": f,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? e : Promise,
    "%Proxy%": typeof Proxy > "u" ? e : Proxy,
    "%RangeError%": a,
    "%ReferenceError%": s,
    "%Reflect%": typeof Reflect > "u" ? e : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? e : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !P || !I ? e : I((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? e : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": P && I ? I(""[Symbol.iterator]()) : e,
    "%Symbol%": P ? Symbol : e,
    "%SyntaxError%": i,
    "%ThrowTypeError%": A,
    "%TypedArray%": de,
    "%TypeError%": r,
    "%Uint8Array%": typeof Uint8Array > "u" ? e : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? e : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? e : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? e : Uint32Array,
    "%URIError%": c,
    "%WeakMap%": typeof WeakMap > "u" ? e : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? e : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? e : WeakSet,
    "%Function.prototype.call%": G,
    "%Function.prototype.apply%": U,
    "%Object.defineProperty%": g,
    "%Object.getPrototypeOf%": D,
    "%Math.abs%": u,
    "%Math.floor%": d,
    "%Math.max%": p,
    "%Math.min%": _,
    "%Math.pow%": y,
    "%Math.round%": k,
    "%Math.sign%": w,
    "%Reflect.getPrototypeOf%": R
  };
  if (I)
    try {
      null.error;
    } catch (Ne) {
      var ce = I(I(Ne));
      K["%Error.prototype%"] = ce;
    }
  var ue = eg(), Ae = /* @__PURE__ */ tg(), te = ng(), X = function Ne(xe) {
    var Fe;
    if (xe === "%AsyncFunction%")
      Fe = ue() || void 0;
    else if (xe === "%GeneratorFunction%")
      Fe = Ae() || void 0;
    else if (xe === "%AsyncGeneratorFunction%")
      Fe = te() || void 0;
    else if (xe === "%AsyncGenerator%") {
      var Ke = Ne("%AsyncGeneratorFunction%");
      Ke && (Fe = Ke.prototype);
    } else if (xe === "%AsyncIteratorPrototype%") {
      var at = Ne("%AsyncGenerator%");
      at && I && (Fe = I(at.prototype));
    }
    return K[xe] = Fe, Fe;
  }, ee = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, ie = Js(), he = /* @__PURE__ */ og(), ve = ie.call(G, Array.prototype.concat), ze = ie.call(U, Array.prototype.splice), ot = ie.call(G, String.prototype.replace), Ie = ie.call(G, String.prototype.slice), ae = ie.call(G, RegExp.prototype.exec), _e = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, _t = /\\(\\)?/g, St = function(xe) {
    var Fe = Ie(xe, 0, 1), Ke = Ie(xe, -1);
    if (Fe === "%" && Ke !== "%")
      throw new i("invalid intrinsic syntax, expected closing `%`");
    if (Ke === "%" && Fe !== "%")
      throw new i("invalid intrinsic syntax, expected opening `%`");
    var at = [];
    return ot(xe, _e, function(mt, Ht, it, Rt) {
      at[at.length] = it ? ot(Rt, _t, "$1") : Ht || mt;
    }), at;
  }, et = function(xe, Fe) {
    var Ke = xe, at;
    if (he(ee, Ke) && (at = ee[Ke], Ke = "%" + at[0] + "%"), he(K, Ke)) {
      var mt = K[Ke];
      if (mt === F && (mt = X(Ke)), typeof mt > "u" && !Fe)
        throw new r("intrinsic " + xe + " exists, but is not available. Please file an issue!");
      return {
        alias: at,
        name: Ke,
        value: mt
      };
    }
    throw new i("intrinsic " + xe + " does not exist!");
  };
  return vr = function(xe, Fe) {
    if (typeof xe != "string" || xe.length === 0)
      throw new r("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof Fe != "boolean")
      throw new r('"allowMissing" argument must be a boolean');
    if (ae(/^%?[^%]*%?$/, xe) === null)
      throw new i("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var Ke = St(xe), at = Ke.length > 0 ? Ke[0] : "", mt = et("%" + at + "%", Fe), Ht = mt.name, it = mt.value, Rt = !1, io = mt.alias;
    io && (at = io[0], ze(Ke, ve([0, 1], io)));
    for (var Rn = 1, Ln = !0; Rn < Ke.length; Rn += 1) {
      var en = Ke[Rn], yn = Ie(en, 0, 1), Wn = Ie(en, -1);
      if ((yn === '"' || yn === "'" || yn === "`" || Wn === '"' || Wn === "'" || Wn === "`") && yn !== Wn)
        throw new i("property names with quotes must have matching quotes");
      if ((en === "constructor" || !Ln) && (Rt = !0), at += "." + en, Ht = "%" + at + "%", he(K, Ht))
        it = K[Ht];
      else if (it != null) {
        if (!(en in it)) {
          if (!Fe)
            throw new r("base intrinsic for " + xe + " exists, but the property is not available.");
          return;
        }
        if (f && Rn + 1 >= Ke.length) {
          var Xe = f(it, en);
          Ln = !!Xe, Ln && "get" in Xe && !("originalValue" in Xe.get) ? it = Xe.get : it = it[en];
        } else
          Ln = he(it, en), it = it[en];
        Ln && !Rt && (K[Ht] = it);
      }
    }
    return it;
  }, vr;
}
var gr, yu;
function km() {
  if (yu) return gr;
  yu = 1;
  var e = /* @__PURE__ */ Tl(), t = ym(), n = t([e("%String.prototype.indexOf%")]);
  return gr = function(a, s) {
    var i = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      e(a, !!s)
    );
    return typeof i == "function" && n(a, ".prototype.") > -1 ? t(
      /** @type {const} */
      [i]
    ) : i;
  }, gr;
}
var yr, ku;
function bm() {
  if (ku) return yr;
  ku = 1;
  var e = /* @__PURE__ */ Tl(), t = /* @__PURE__ */ km(), n = /* @__PURE__ */ Xs(), o = /* @__PURE__ */ Yo(), a = e("%Map%", !0), s = t("Map.prototype.get", !0), i = t("Map.prototype.set", !0), r = t("Map.prototype.has", !0), c = t("Map.prototype.delete", !0), u = t("Map.prototype.size", !0);
  return yr = !!a && /** @type {Exclude<import('.'), false>} */
  function() {
    var p, _ = {
      assert: function(y) {
        if (!_.has(y))
          throw new o("Side channel does not contain " + n(y));
      },
      delete: function(y) {
        if (p) {
          var k = c(p, y);
          return u(p) === 0 && (p = void 0), k;
        }
        return !1;
      },
      get: function(y) {
        if (p)
          return s(p, y);
      },
      has: function(y) {
        return p ? r(p, y) : !1;
      },
      set: function(y, k) {
        p || (p = new a()), i(p, y, k);
      }
    };
    return _;
  }, yr;
}
var kr, bu;
function ag() {
  if (bu) return kr;
  bu = 1;
  var e = /* @__PURE__ */ Tl(), t = /* @__PURE__ */ km(), n = /* @__PURE__ */ Xs(), o = bm(), a = /* @__PURE__ */ Yo(), s = e("%WeakMap%", !0), i = t("WeakMap.prototype.get", !0), r = t("WeakMap.prototype.set", !0), c = t("WeakMap.prototype.has", !0), u = t("WeakMap.prototype.delete", !0);
  return kr = s ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var p, _, y = {
        assert: function(k) {
          if (!y.has(k))
            throw new a("Side channel does not contain " + n(k));
        },
        delete: function(k) {
          if (s && k && (typeof k == "object" || typeof k == "function")) {
            if (p)
              return u(p, k);
          } else if (o && _)
            return _.delete(k);
          return !1;
        },
        get: function(k) {
          return s && k && (typeof k == "object" || typeof k == "function") && p ? i(p, k) : _ && _.get(k);
        },
        has: function(k) {
          return s && k && (typeof k == "object" || typeof k == "function") && p ? c(p, k) : !!_ && _.has(k);
        },
        set: function(k, w) {
          s && k && (typeof k == "object" || typeof k == "function") ? (p || (p = new s()), r(p, k, w)) : o && (_ || (_ = o()), _.set(k, w));
        }
      };
      return y;
    }
  ) : o, kr;
}
var br, wu;
function sg() {
  if (wu) return br;
  wu = 1;
  var e = /* @__PURE__ */ Yo(), t = /* @__PURE__ */ Xs(), n = Tv(), o = bm(), a = ag(), s = a || o || n;
  return br = function() {
    var r, c = {
      assert: function(u) {
        if (!c.has(u))
          throw new e("Side channel does not contain " + t(u));
      },
      delete: function(u) {
        return !!r && r.delete(u);
      },
      get: function(u) {
        return r && r.get(u);
      },
      has: function(u) {
        return !!r && r.has(u);
      },
      set: function(u, d) {
        r || (r = s()), r.set(u, d);
      }
    };
    return c;
  }, br;
}
var wr, xu;
function Ml() {
  if (xu) return wr;
  xu = 1;
  var e = String.prototype.replace, t = /%20/g, n = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return wr = {
    default: n.RFC3986,
    formatters: {
      RFC1738: function(o) {
        return e.call(o, t, "+");
      },
      RFC3986: function(o) {
        return String(o);
      }
    },
    RFC1738: n.RFC1738,
    RFC3986: n.RFC3986
  }, wr;
}
var xr, $u;
function wm() {
  if ($u) return xr;
  $u = 1;
  var e = /* @__PURE__ */ Ml(), t = Object.prototype.hasOwnProperty, n = Array.isArray, o = (function() {
    for (var f = [], g = 0; g < 256; ++g)
      f.push("%" + ((g < 16 ? "0" : "") + g.toString(16)).toUpperCase());
    return f;
  })(), a = function(g) {
    for (; g.length > 1; ) {
      var b = g.pop(), A = b.obj[b.prop];
      if (n(A)) {
        for (var P = [], I = 0; I < A.length; ++I)
          typeof A[I] < "u" && P.push(A[I]);
        b.obj[b.prop] = P;
      }
    }
  }, s = function(g, b) {
    for (var A = b && b.plainObjects ? { __proto__: null } : {}, P = 0; P < g.length; ++P)
      typeof g[P] < "u" && (A[P] = g[P]);
    return A;
  }, i = function f(g, b, A) {
    if (!b)
      return g;
    if (typeof b != "object" && typeof b != "function") {
      if (n(g))
        g.push(b);
      else if (g && typeof g == "object")
        (A && (A.plainObjects || A.allowPrototypes) || !t.call(Object.prototype, b)) && (g[b] = !0);
      else
        return [g, b];
      return g;
    }
    if (!g || typeof g != "object")
      return [g].concat(b);
    var P = g;
    return n(g) && !n(b) && (P = s(g, A)), n(g) && n(b) ? (b.forEach(function(I, D) {
      if (t.call(g, D)) {
        var R = g[D];
        R && typeof R == "object" && I && typeof I == "object" ? g[D] = f(R, I, A) : g.push(I);
      } else
        g[D] = I;
    }), g) : Object.keys(b).reduce(function(I, D) {
      var R = b[D];
      return t.call(I, D) ? I[D] = f(I[D], R, A) : I[D] = R, I;
    }, P);
  }, r = function(g, b) {
    return Object.keys(b).reduce(function(A, P) {
      return A[P] = b[P], A;
    }, g);
  }, c = function(f, g, b) {
    var A = f.replace(/\+/g, " ");
    if (b === "iso-8859-1")
      return A.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(A);
    } catch {
      return A;
    }
  }, u = 1024, d = function(g, b, A, P, I) {
    if (g.length === 0)
      return g;
    var D = g;
    if (typeof g == "symbol" ? D = Symbol.prototype.toString.call(g) : typeof g != "string" && (D = String(g)), A === "iso-8859-1")
      return escape(D).replace(/%u[0-9a-f]{4}/gi, function(ce) {
        return "%26%23" + parseInt(ce.slice(2), 16) + "%3B";
      });
    for (var R = "", U = 0; U < D.length; U += u) {
      for (var G = D.length >= u ? D.slice(U, U + u) : D, F = [], de = 0; de < G.length; ++de) {
        var K = G.charCodeAt(de);
        if (K === 45 || K === 46 || K === 95 || K === 126 || K >= 48 && K <= 57 || K >= 65 && K <= 90 || K >= 97 && K <= 122 || I === e.RFC1738 && (K === 40 || K === 41)) {
          F[F.length] = G.charAt(de);
          continue;
        }
        if (K < 128) {
          F[F.length] = o[K];
          continue;
        }
        if (K < 2048) {
          F[F.length] = o[192 | K >> 6] + o[128 | K & 63];
          continue;
        }
        if (K < 55296 || K >= 57344) {
          F[F.length] = o[224 | K >> 12] + o[128 | K >> 6 & 63] + o[128 | K & 63];
          continue;
        }
        de += 1, K = 65536 + ((K & 1023) << 10 | G.charCodeAt(de) & 1023), F[F.length] = o[240 | K >> 18] + o[128 | K >> 12 & 63] + o[128 | K >> 6 & 63] + o[128 | K & 63];
      }
      R += F.join("");
    }
    return R;
  }, p = function(g) {
    for (var b = [{ obj: { o: g }, prop: "o" }], A = [], P = 0; P < b.length; ++P)
      for (var I = b[P], D = I.obj[I.prop], R = Object.keys(D), U = 0; U < R.length; ++U) {
        var G = R[U], F = D[G];
        typeof F == "object" && F !== null && A.indexOf(F) === -1 && (b.push({ obj: D, prop: G }), A.push(F));
      }
    return a(b), g;
  }, _ = function(g) {
    return Object.prototype.toString.call(g) === "[object RegExp]";
  }, y = function(g) {
    return !g || typeof g != "object" ? !1 : !!(g.constructor && g.constructor.isBuffer && g.constructor.isBuffer(g));
  }, k = function(g, b) {
    return [].concat(g, b);
  }, w = function(g, b) {
    if (n(g)) {
      for (var A = [], P = 0; P < g.length; P += 1)
        A.push(b(g[P]));
      return A;
    }
    return b(g);
  };
  return xr = {
    arrayToObject: s,
    assign: r,
    combine: k,
    compact: p,
    decode: c,
    encode: d,
    isBuffer: y,
    isRegExp: _,
    maybeMap: w,
    merge: i
  }, xr;
}
var $r, zu;
function ig() {
  if (zu) return $r;
  zu = 1;
  var e = sg(), t = /* @__PURE__ */ wm(), n = /* @__PURE__ */ Ml(), o = Object.prototype.hasOwnProperty, a = {
    brackets: function(f) {
      return f + "[]";
    },
    comma: "comma",
    indices: function(f, g) {
      return f + "[" + g + "]";
    },
    repeat: function(f) {
      return f;
    }
  }, s = Array.isArray, i = Array.prototype.push, r = function(w, f) {
    i.apply(w, s(f) ? f : [f]);
  }, c = Date.prototype.toISOString, u = n.default, d = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    commaRoundTrip: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: t.encode,
    encodeValuesOnly: !1,
    filter: void 0,
    format: u,
    formatter: n.formatters[u],
    // deprecated
    indices: !1,
    serializeDate: function(f) {
      return c.call(f);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, p = function(f) {
    return typeof f == "string" || typeof f == "number" || typeof f == "boolean" || typeof f == "symbol" || typeof f == "bigint";
  }, _ = {}, y = function w(f, g, b, A, P, I, D, R, U, G, F, de, K, ce, ue, Ae, te, X) {
    for (var ee = f, ie = X, he = 0, ve = !1; (ie = ie.get(_)) !== void 0 && !ve; ) {
      var ze = ie.get(f);
      if (he += 1, typeof ze < "u") {
        if (ze === he)
          throw new RangeError("Cyclic object value");
        ve = !0;
      }
      typeof ie.get(_) > "u" && (he = 0);
    }
    if (typeof G == "function" ? ee = G(g, ee) : ee instanceof Date ? ee = K(ee) : b === "comma" && s(ee) && (ee = t.maybeMap(ee, function(mt) {
      return mt instanceof Date ? K(mt) : mt;
    })), ee === null) {
      if (I)
        return U && !Ae ? U(g, d.encoder, te, "key", ce) : g;
      ee = "";
    }
    if (p(ee) || t.isBuffer(ee)) {
      if (U) {
        var ot = Ae ? g : U(g, d.encoder, te, "key", ce);
        return [ue(ot) + "=" + ue(U(ee, d.encoder, te, "value", ce))];
      }
      return [ue(g) + "=" + ue(String(ee))];
    }
    var Ie = [];
    if (typeof ee > "u")
      return Ie;
    var ae;
    if (b === "comma" && s(ee))
      Ae && U && (ee = t.maybeMap(ee, U)), ae = [{ value: ee.length > 0 ? ee.join(",") || null : void 0 }];
    else if (s(G))
      ae = G;
    else {
      var _e = Object.keys(ee);
      ae = F ? _e.sort(F) : _e;
    }
    var _t = R ? String(g).replace(/\./g, "%2E") : String(g), St = A && s(ee) && ee.length === 1 ? _t + "[]" : _t;
    if (P && s(ee) && ee.length === 0)
      return St + "[]";
    for (var et = 0; et < ae.length; ++et) {
      var Ne = ae[et], xe = typeof Ne == "object" && Ne && typeof Ne.value < "u" ? Ne.value : ee[Ne];
      if (!(D && xe === null)) {
        var Fe = de && R ? String(Ne).replace(/\./g, "%2E") : String(Ne), Ke = s(ee) ? typeof b == "function" ? b(St, Fe) : St : St + (de ? "." + Fe : "[" + Fe + "]");
        X.set(f, he);
        var at = e();
        at.set(_, X), r(Ie, w(
          xe,
          Ke,
          b,
          A,
          P,
          I,
          D,
          R,
          b === "comma" && Ae && s(ee) ? null : U,
          G,
          F,
          de,
          K,
          ce,
          ue,
          Ae,
          te,
          at
        ));
      }
    }
    return Ie;
  }, k = function(f) {
    if (!f)
      return d;
    if (typeof f.allowEmptyArrays < "u" && typeof f.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof f.encodeDotInKeys < "u" && typeof f.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (f.encoder !== null && typeof f.encoder < "u" && typeof f.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var g = f.charset || d.charset;
    if (typeof f.charset < "u" && f.charset !== "utf-8" && f.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var b = n.default;
    if (typeof f.format < "u") {
      if (!o.call(n.formatters, f.format))
        throw new TypeError("Unknown format option provided.");
      b = f.format;
    }
    var A = n.formatters[b], P = d.filter;
    (typeof f.filter == "function" || s(f.filter)) && (P = f.filter);
    var I;
    if (f.arrayFormat in a ? I = f.arrayFormat : "indices" in f ? I = f.indices ? "indices" : "repeat" : I = d.arrayFormat, "commaRoundTrip" in f && typeof f.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var D = typeof f.allowDots > "u" ? f.encodeDotInKeys === !0 ? !0 : d.allowDots : !!f.allowDots;
    return {
      addQueryPrefix: typeof f.addQueryPrefix == "boolean" ? f.addQueryPrefix : d.addQueryPrefix,
      allowDots: D,
      allowEmptyArrays: typeof f.allowEmptyArrays == "boolean" ? !!f.allowEmptyArrays : d.allowEmptyArrays,
      arrayFormat: I,
      charset: g,
      charsetSentinel: typeof f.charsetSentinel == "boolean" ? f.charsetSentinel : d.charsetSentinel,
      commaRoundTrip: !!f.commaRoundTrip,
      delimiter: typeof f.delimiter > "u" ? d.delimiter : f.delimiter,
      encode: typeof f.encode == "boolean" ? f.encode : d.encode,
      encodeDotInKeys: typeof f.encodeDotInKeys == "boolean" ? f.encodeDotInKeys : d.encodeDotInKeys,
      encoder: typeof f.encoder == "function" ? f.encoder : d.encoder,
      encodeValuesOnly: typeof f.encodeValuesOnly == "boolean" ? f.encodeValuesOnly : d.encodeValuesOnly,
      filter: P,
      format: b,
      formatter: A,
      serializeDate: typeof f.serializeDate == "function" ? f.serializeDate : d.serializeDate,
      skipNulls: typeof f.skipNulls == "boolean" ? f.skipNulls : d.skipNulls,
      sort: typeof f.sort == "function" ? f.sort : null,
      strictNullHandling: typeof f.strictNullHandling == "boolean" ? f.strictNullHandling : d.strictNullHandling
    };
  };
  return $r = function(w, f) {
    var g = w, b = k(f), A, P;
    typeof b.filter == "function" ? (P = b.filter, g = P("", g)) : s(b.filter) && (P = b.filter, A = P);
    var I = [];
    if (typeof g != "object" || g === null)
      return "";
    var D = a[b.arrayFormat], R = D === "comma" && b.commaRoundTrip;
    A || (A = Object.keys(g)), b.sort && A.sort(b.sort);
    for (var U = e(), G = 0; G < A.length; ++G) {
      var F = A[G], de = g[F];
      b.skipNulls && de === null || r(I, y(
        de,
        F,
        D,
        R,
        b.allowEmptyArrays,
        b.strictNullHandling,
        b.skipNulls,
        b.encodeDotInKeys,
        b.encode ? b.encoder : null,
        b.filter,
        b.sort,
        b.allowDots,
        b.serializeDate,
        b.format,
        b.formatter,
        b.encodeValuesOnly,
        b.charset,
        U
      ));
    }
    var K = I.join(b.delimiter), ce = b.addQueryPrefix === !0 ? "?" : "";
    return b.charsetSentinel && (b.charset === "iso-8859-1" ? ce += "utf8=%26%2310003%3B&" : ce += "utf8=%E2%9C%93&"), K.length > 0 ? ce + K : "";
  }, $r;
}
var zr, Su;
function rg() {
  if (Su) return zr;
  Su = 1;
  var e = /* @__PURE__ */ wm(), t = Object.prototype.hasOwnProperty, n = Array.isArray, o = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: e.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictNullHandling: !1,
    throwOnLimitExceeded: !1
  }, a = function(_) {
    return _.replace(/&#(\d+);/g, function(y, k) {
      return String.fromCharCode(parseInt(k, 10));
    });
  }, s = function(_, y, k) {
    if (_ && typeof _ == "string" && y.comma && _.indexOf(",") > -1)
      return _.split(",");
    if (y.throwOnLimitExceeded && k >= y.arrayLimit)
      throw new RangeError("Array limit exceeded. Only " + y.arrayLimit + " element" + (y.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
    return _;
  }, i = "utf8=%26%2310003%3B", r = "utf8=%E2%9C%93", c = function(y, k) {
    var w = { __proto__: null }, f = k.ignoreQueryPrefix ? y.replace(/^\?/, "") : y;
    f = f.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var g = k.parameterLimit === 1 / 0 ? void 0 : k.parameterLimit, b = f.split(
      k.delimiter,
      k.throwOnLimitExceeded ? g + 1 : g
    );
    if (k.throwOnLimitExceeded && b.length > g)
      throw new RangeError("Parameter limit exceeded. Only " + g + " parameter" + (g === 1 ? "" : "s") + " allowed.");
    var A = -1, P, I = k.charset;
    if (k.charsetSentinel)
      for (P = 0; P < b.length; ++P)
        b[P].indexOf("utf8=") === 0 && (b[P] === r ? I = "utf-8" : b[P] === i && (I = "iso-8859-1"), A = P, P = b.length);
    for (P = 0; P < b.length; ++P)
      if (P !== A) {
        var D = b[P], R = D.indexOf("]="), U = R === -1 ? D.indexOf("=") : R + 1, G, F;
        U === -1 ? (G = k.decoder(D, o.decoder, I, "key"), F = k.strictNullHandling ? null : "") : (G = k.decoder(D.slice(0, U), o.decoder, I, "key"), F = e.maybeMap(
          s(
            D.slice(U + 1),
            k,
            n(w[G]) ? w[G].length : 0
          ),
          function(K) {
            return k.decoder(K, o.decoder, I, "value");
          }
        )), F && k.interpretNumericEntities && I === "iso-8859-1" && (F = a(String(F))), D.indexOf("[]=") > -1 && (F = n(F) ? [F] : F);
        var de = t.call(w, G);
        de && k.duplicates === "combine" ? w[G] = e.combine(w[G], F) : (!de || k.duplicates === "last") && (w[G] = F);
      }
    return w;
  }, u = function(_, y, k, w) {
    var f = 0;
    if (_.length > 0 && _[_.length - 1] === "[]") {
      var g = _.slice(0, -1).join("");
      f = Array.isArray(y) && y[g] ? y[g].length : 0;
    }
    for (var b = w ? y : s(y, k, f), A = _.length - 1; A >= 0; --A) {
      var P, I = _[A];
      if (I === "[]" && k.parseArrays)
        P = k.allowEmptyArrays && (b === "" || k.strictNullHandling && b === null) ? [] : e.combine([], b);
      else {
        P = k.plainObjects ? { __proto__: null } : {};
        var D = I.charAt(0) === "[" && I.charAt(I.length - 1) === "]" ? I.slice(1, -1) : I, R = k.decodeDotInKeys ? D.replace(/%2E/g, ".") : D, U = parseInt(R, 10);
        !k.parseArrays && R === "" ? P = { 0: b } : !isNaN(U) && I !== R && String(U) === R && U >= 0 && k.parseArrays && U <= k.arrayLimit ? (P = [], P[U] = b) : R !== "__proto__" && (P[R] = b);
      }
      b = P;
    }
    return b;
  }, d = function(y, k, w, f) {
    if (y) {
      var g = w.allowDots ? y.replace(/\.([^.[]+)/g, "[$1]") : y, b = /(\[[^[\]]*])/, A = /(\[[^[\]]*])/g, P = w.depth > 0 && b.exec(g), I = P ? g.slice(0, P.index) : g, D = [];
      if (I) {
        if (!w.plainObjects && t.call(Object.prototype, I) && !w.allowPrototypes)
          return;
        D.push(I);
      }
      for (var R = 0; w.depth > 0 && (P = A.exec(g)) !== null && R < w.depth; ) {
        if (R += 1, !w.plainObjects && t.call(Object.prototype, P[1].slice(1, -1)) && !w.allowPrototypes)
          return;
        D.push(P[1]);
      }
      if (P) {
        if (w.strictDepth === !0)
          throw new RangeError("Input depth exceeded depth option of " + w.depth + " and strictDepth is true");
        D.push("[" + g.slice(P.index) + "]");
      }
      return u(D, k, w, f);
    }
  }, p = function(y) {
    if (!y)
      return o;
    if (typeof y.allowEmptyArrays < "u" && typeof y.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof y.decodeDotInKeys < "u" && typeof y.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (y.decoder !== null && typeof y.decoder < "u" && typeof y.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof y.charset < "u" && y.charset !== "utf-8" && y.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    if (typeof y.throwOnLimitExceeded < "u" && typeof y.throwOnLimitExceeded != "boolean")
      throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
    var k = typeof y.charset > "u" ? o.charset : y.charset, w = typeof y.duplicates > "u" ? o.duplicates : y.duplicates;
    if (w !== "combine" && w !== "first" && w !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var f = typeof y.allowDots > "u" ? y.decodeDotInKeys === !0 ? !0 : o.allowDots : !!y.allowDots;
    return {
      allowDots: f,
      allowEmptyArrays: typeof y.allowEmptyArrays == "boolean" ? !!y.allowEmptyArrays : o.allowEmptyArrays,
      allowPrototypes: typeof y.allowPrototypes == "boolean" ? y.allowPrototypes : o.allowPrototypes,
      allowSparse: typeof y.allowSparse == "boolean" ? y.allowSparse : o.allowSparse,
      arrayLimit: typeof y.arrayLimit == "number" ? y.arrayLimit : o.arrayLimit,
      charset: k,
      charsetSentinel: typeof y.charsetSentinel == "boolean" ? y.charsetSentinel : o.charsetSentinel,
      comma: typeof y.comma == "boolean" ? y.comma : o.comma,
      decodeDotInKeys: typeof y.decodeDotInKeys == "boolean" ? y.decodeDotInKeys : o.decodeDotInKeys,
      decoder: typeof y.decoder == "function" ? y.decoder : o.decoder,
      delimiter: typeof y.delimiter == "string" || e.isRegExp(y.delimiter) ? y.delimiter : o.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof y.depth == "number" || y.depth === !1 ? +y.depth : o.depth,
      duplicates: w,
      ignoreQueryPrefix: y.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof y.interpretNumericEntities == "boolean" ? y.interpretNumericEntities : o.interpretNumericEntities,
      parameterLimit: typeof y.parameterLimit == "number" ? y.parameterLimit : o.parameterLimit,
      parseArrays: y.parseArrays !== !1,
      plainObjects: typeof y.plainObjects == "boolean" ? y.plainObjects : o.plainObjects,
      strictDepth: typeof y.strictDepth == "boolean" ? !!y.strictDepth : o.strictDepth,
      strictNullHandling: typeof y.strictNullHandling == "boolean" ? y.strictNullHandling : o.strictNullHandling,
      throwOnLimitExceeded: typeof y.throwOnLimitExceeded == "boolean" ? y.throwOnLimitExceeded : !1
    };
  };
  return zr = function(_, y) {
    var k = p(y);
    if (_ === "" || _ === null || typeof _ > "u")
      return k.plainObjects ? { __proto__: null } : {};
    for (var w = typeof _ == "string" ? c(_, k) : _, f = k.plainObjects ? { __proto__: null } : {}, g = Object.keys(w), b = 0; b < g.length; ++b) {
      var A = g[b], P = d(A, w[A], k, typeof _ == "string");
      f = e.merge(f, P, k);
    }
    return k.allowSparse === !0 ? f : e.compact(f);
  }, zr;
}
var Sr, Cu;
function lg() {
  if (Cu) return Sr;
  Cu = 1;
  var e = /* @__PURE__ */ ig(), t = /* @__PURE__ */ rg(), n = /* @__PURE__ */ Ml();
  return Sr = {
    formats: n,
    parse: t,
    stringify: e
  }, Sr;
}
var cg = /* @__PURE__ */ lg();
const ug = /* @__PURE__ */ pm(cg);
var dg = Object.defineProperty, mg = (e, t, n) => t in e ? dg(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, As = (e, t, n) => mg(e, typeof t != "symbol" ? t + "" : t, n), tl = /* @__PURE__ */ ((e) => (e[e.INPUT = 0] = "INPUT", e[e.OUTPUT = 1] = "OUTPUT", e))(tl || {});
class pg extends Error {
  constructor(t, n, o) {
    let a = `Endpoint validation error in ${t === 0 ? "input" : "output"} of "${o.key ?? ""}"
${xm(n.issues)}`;
    a.length > 5e5 && (a = a.slice(0, 499997) + "..."), super(a), As(this, "name", "EndpointValidationError");
  }
}
function Au(e, t, n, o, a) {
  if (e) {
    const s = e.safeParse(t);
    if (s.success)
      return s.data;
    {
      const i = new pg(
        n,
        s.error,
        o
      );
      if (a)
        a(i);
      else
        throw i;
    }
  }
  return t;
}
function xm(e, t = 0) {
  const n = /* @__PURE__ */ new Set();
  for (const o of e) {
    const { path: a, ...s } = o;
    let i = `${a.map((r) => typeof r == "number" ? "[]" : r).join(".")}: `;
    if (s.code === "invalid_union") {
      const { unionErrors: r, ...c } = s;
      i += `${JSON.stringify(c)}
`;
      const u = [];
      for (const d of r)
        u.push(
          xm(d.issues, t + 1)
        );
      i += u.join(
        `
${"  ".repeat(t + 1)}---
`
      );
    } else
      i += JSON.stringify(s);
    n.add(i);
  }
  return `${"  ".repeat(t)}${[...n].join(`
${"  ".repeat(t)}`)}`;
}
let Ys = class {
  constructor(t, n, o, a, s, i, r = (d) => d.json(), c, u) {
    As(this, "inputType"), As(this, "outputType"), this.kyInstance = t, this.middlewares = n, this.resolver = o, this.onValidationError = a, this.inputSchema = s, this.outputSchema = i, this.responseTransformer = r, this.onSuccess = c, this.key = u;
  }
  async fetch(t, n, o, a, ...s) {
    if (!o.value)
      throw new Error(`Not enabled. Key: ${JSON.stringify(a.key)}`);
    const i = Au(
      this.inputSchema,
      t,
      tl.INPUT,
      this,
      this.onValidationError
    );
    let r = this.resolver(i, ...s);
    for (const _ of n)
      r = _(r, a);
    const { url: c, ...u } = r, d = await this.responseTransformer(
      this.kyInstance(c, {
        ...u,
        searchParams: u.searchParams ? ug.stringify(u.searchParams, {
          arrayFormat: "comma",
          skipNulls: !0
        }) : void 0
      })
    ), p = Au(
      this.outputSchema,
      d,
      tl.OUTPUT,
      this,
      this.onValidationError
    );
    try {
      M(
        () => {
          var _;
          return (_ = this.onSuccess) == null ? void 0 : _.call(this, {
            input: i,
            output: p
          });
        },
        a.context
      )();
    } catch {
    }
    return p;
  }
  runMiddlewares() {
    if (!wh())
      throw new Error(
        "Middlewares outside of injection context not supported"
      );
    const t = this.middlewares.map(
      (n) => n()
    );
    return {
      beforeRequest: t.map(({ beforeRequest: n }) => n).filter((n) => n !== void 0),
      enabled: t.map(({ enabled: n }) => n).filter((n) => n !== void 0),
      key: t.map(({ key: n }) => n).filter((n) => n !== void 0)
    };
  }
}, fg = class $m extends Ys {
  constructor(t, n, o, ...a) {
    super(...a), As(this, "pageParamType"), this.initialPageParam = t, this.getNextPageParam = n, this.getPreviousPageParam = o;
  }
  static create(t, n, o) {
    return (a, s) => new $m(
      s.initialPageParam,
      s.getNextPageParam,
      s.getPreviousPageParam,
      t,
      n,
      a,
      o,
      s.input,
      s.output,
      s.responseTransformer,
      s.onSuccess
    );
  }
  getQueryKey(t) {
    const { key: n } = this.runMiddlewares();
    return t === void 0 ? [this.key, n] : [this.key, n, t];
  }
  use(...[t]) {
    const {
      beforeRequest: n,
      enabled: o,
      key: a
    } = this.runMiddlewares(), s = S(
      () => o.every((r) => pn(r))
    ), i = qn();
    return {
      enabled: s,
      getNextPageParam: this.getNextPageParam,
      getPreviousPageParam: this.getPreviousPageParam,
      initialPageParam: this.initialPageParam,
      queryFn: async ({
        pageParam: r,
        queryKey: c
      }) => this.fetch(
        c[2],
        n,
        s,
        { context: i, key: c },
        r
      ),
      queryKey: [this.key, a, t]
    };
  }
  useWithManualPageParam(...[t, n]) {
    const {
      beforeRequest: o,
      enabled: a,
      key: s
    } = this.runMiddlewares(), i = S(
      () => a.every((c) => pn(c))
    ), r = qn();
    return {
      enabled: i,
      queryFn: async ({
        queryKey: c
      }) => this.fetch(
        c[2],
        o,
        i,
        { context: r, key: c },
        c[3]
      ),
      queryKey: [
        this.key,
        s,
        t,
        n
      ]
    };
  }
}, hg = class zm extends Ys {
  static create(t, n, o) {
    return (a, s) => new zm(
      t,
      n,
      a,
      o,
      s == null ? void 0 : s.input,
      s == null ? void 0 : s.output,
      s == null ? void 0 : s.responseTransformer,
      s == null ? void 0 : s.onSuccess
    );
  }
  use() {
    const {
      beforeRequest: t,
      enabled: n,
      key: o
    } = this.runMiddlewares(), a = S(
      () => n.every((i) => pn(i))
    ), s = qn();
    return {
      mutationFn: async (...[i]) => this.fetch(i, t, a, { context: s }),
      mutationKey: [this.key, o]
    };
  }
};
class Il extends Ys {
  static create(t, n, o) {
    return (a, s) => new Il(
      t,
      n,
      a,
      o,
      s == null ? void 0 : s.input,
      s == null ? void 0 : s.output,
      s == null ? void 0 : s.responseTransformer,
      s == null ? void 0 : s.onSuccess
    );
  }
  async fetchPlain(t) {
    const { beforeRequest: n, enabled: o } = this.runMiddlewares(), a = S(
      () => o.every((i) => pn(i))
    ), s = qn();
    return this.fetch(t, n, a, {
      context: s
    });
  }
  getQueryKey(t) {
    const { key: n } = this.runMiddlewares();
    return t === void 0 ? [this.key, n] : [this.key, n, t];
  }
  use(...[t]) {
    const {
      beforeRequest: n,
      enabled: o,
      key: a
    } = this.runMiddlewares(), s = S(
      () => o.every((r) => pn(r))
    ), i = qn();
    return {
      enabled: s,
      queryFn: async ({
        queryKey: r
      }) => this.fetch(r[2], n, s, {
        context: i,
        key: r
      }),
      queryKey: [this.key, a, t]
    };
  }
}
function Sm(e, t = []) {
  const { onValidationError: n, ...o } = e, a = mm.extend({ retry: 0, ...o });
  return {
    infiniteQuery: fg.create(
      a,
      t,
      n
    ),
    mutation: hg.create(
      a,
      t,
      n
    ),
    query: Il.create(a, t, n),
    use: (s) => Sm(e, [
      ...t,
      s
    ])
  };
}
function bt(e, t) {
  for (const [n, o] of Object.entries(e)) {
    const a = t ? `${t}.${n}` : n;
    o instanceof Ys ? o.key = a : bt(o, a);
  }
  return e;
}
var We;
(function(e) {
  e.assertEqual = (a) => {
  };
  function t(a) {
  }
  e.assertIs = t;
  function n(a) {
    throw new Error();
  }
  e.assertNever = n, e.arrayToEnum = (a) => {
    const s = {};
    for (const i of a)
      s[i] = i;
    return s;
  }, e.getValidEnumValues = (a) => {
    const s = e.objectKeys(a).filter((r) => typeof a[a[r]] != "number"), i = {};
    for (const r of s)
      i[r] = a[r];
    return e.objectValues(i);
  }, e.objectValues = (a) => e.objectKeys(a).map(function(s) {
    return a[s];
  }), e.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const s = [];
    for (const i in a)
      Object.prototype.hasOwnProperty.call(a, i) && s.push(i);
    return s;
  }, e.find = (a, s) => {
    for (const i of a)
      if (s(i))
        return i;
  }, e.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && Number.isFinite(a) && Math.floor(a) === a;
  function o(a, s = " | ") {
    return a.map((i) => typeof i == "string" ? `'${i}'` : i).join(s);
  }
  e.joinValues = o, e.jsonStringifyReplacer = (a, s) => typeof s == "bigint" ? s.toString() : s;
})(We || (We = {}));
var Pu;
(function(e) {
  e.mergeShapes = (t, n) => ({
    ...t,
    ...n
    // second overwrites first
  });
})(Pu || (Pu = {}));
const ge = We.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Xn = (e) => {
  switch (typeof e) {
    case "undefined":
      return ge.undefined;
    case "string":
      return ge.string;
    case "number":
      return Number.isNaN(e) ? ge.nan : ge.number;
    case "boolean":
      return ge.boolean;
    case "function":
      return ge.function;
    case "bigint":
      return ge.bigint;
    case "symbol":
      return ge.symbol;
    case "object":
      return Array.isArray(e) ? ge.array : e === null ? ge.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? ge.promise : typeof Map < "u" && e instanceof Map ? ge.map : typeof Set < "u" && e instanceof Set ? ge.set : typeof Date < "u" && e instanceof Date ? ge.date : ge.object;
    default:
      return ge.unknown;
  }
}, oe = We.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class Bn extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (o) => {
      this.issues = [...this.issues, o];
    }, this.addIssues = (o = []) => {
      this.issues = [...this.issues, ...o];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const n = t || function(s) {
      return s.message;
    }, o = { _errors: [] }, a = (s) => {
      for (const i of s.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(a);
        else if (i.code === "invalid_return_type")
          a(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          a(i.argumentsError);
        else if (i.path.length === 0)
          o._errors.push(n(i));
        else {
          let r = o, c = 0;
          for (; c < i.path.length; ) {
            const u = i.path[c];
            c === i.path.length - 1 ? (r[u] = r[u] || { _errors: [] }, r[u]._errors.push(n(i))) : r[u] = r[u] || { _errors: [] }, r = r[u], c++;
          }
        }
    };
    return a(this), o;
  }
  static assert(t) {
    if (!(t instanceof Bn))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, We.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (n) => n.message) {
    const n = {}, o = [];
    for (const a of this.issues)
      if (a.path.length > 0) {
        const s = a.path[0];
        n[s] = n[s] || [], n[s].push(t(a));
      } else
        o.push(t(a));
    return { formErrors: o, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
Bn.create = (e) => new Bn(e);
const nl = (e, t) => {
  let n;
  switch (e.code) {
    case oe.invalid_type:
      e.received === ge.undefined ? n = "Required" : n = `Expected ${e.expected}, received ${e.received}`;
      break;
    case oe.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(e.expected, We.jsonStringifyReplacer)}`;
      break;
    case oe.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${We.joinValues(e.keys, ", ")}`;
      break;
    case oe.invalid_union:
      n = "Invalid input";
      break;
    case oe.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${We.joinValues(e.options)}`;
      break;
    case oe.invalid_enum_value:
      n = `Invalid enum value. Expected ${We.joinValues(e.options)}, received '${e.received}'`;
      break;
    case oe.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case oe.invalid_return_type:
      n = "Invalid function return type";
      break;
    case oe.invalid_date:
      n = "Invalid date";
      break;
    case oe.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (n = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? n = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? n = `Invalid input: must end with "${e.validation.endsWith}"` : We.assertNever(e.validation) : e.validation !== "regex" ? n = `Invalid ${e.validation}` : n = "Invalid";
      break;
    case oe.too_small:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "bigint" ? n = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : n = "Invalid input";
      break;
    case oe.too_big:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? n = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : n = "Invalid input";
      break;
    case oe.custom:
      n = "Invalid input";
      break;
    case oe.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case oe.not_multiple_of:
      n = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case oe.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = t.defaultError, We.assertNever(e);
  }
  return { message: n };
};
let _g = nl;
function vg() {
  return _g;
}
const gg = (e) => {
  const { data: t, path: n, errorMaps: o, issueData: a } = e, s = [...n, ...a.path || []], i = {
    ...a,
    path: s
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: s,
      message: a.message
    };
  let r = "";
  const c = o.filter((u) => !!u).slice().reverse();
  for (const u of c)
    r = u(i, { data: t, defaultError: r }).message;
  return {
    ...a,
    path: s,
    message: r
  };
};
function pe(e, t) {
  const n = vg(), o = gg({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      n,
      // then global override map
      n === nl ? void 0 : nl
      // then global default map
    ].filter((a) => !!a)
  });
  e.common.issues.push(o);
}
class an {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, n) {
    const o = [];
    for (const a of n) {
      if (a.status === "aborted")
        return Me;
      a.status === "dirty" && t.dirty(), o.push(a.value);
    }
    return { status: t.value, value: o };
  }
  static async mergeObjectAsync(t, n) {
    const o = [];
    for (const a of n) {
      const s = await a.key, i = await a.value;
      o.push({
        key: s,
        value: i
      });
    }
    return an.mergeObjectSync(t, o);
  }
  static mergeObjectSync(t, n) {
    const o = {};
    for (const a of n) {
      const { key: s, value: i } = a;
      if (s.status === "aborted" || i.status === "aborted")
        return Me;
      s.status === "dirty" && t.dirty(), i.status === "dirty" && t.dirty(), s.value !== "__proto__" && (typeof i.value < "u" || a.alwaysSet) && (o[s.value] = i.value);
    }
    return { status: t.value, value: o };
  }
}
const Me = Object.freeze({
  status: "aborted"
}), ka = (e) => ({ status: "dirty", value: e }), hn = (e) => ({ status: "valid", value: e }), Tu = (e) => e.status === "aborted", Mu = (e) => e.status === "dirty", Go = (e) => e.status === "valid", Ps = (e) => typeof Promise < "u" && e instanceof Promise;
var be;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(be || (be = {}));
class no {
  constructor(t, n, o, a) {
    this._cachedPath = [], this.parent = t, this.data = n, this._path = o, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Iu = (e, t) => {
  if (Go(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new Bn(e.common.issues);
      return this._error = n, this._error;
    }
  };
};
function Ve(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: n, required_error: o, description: a } = e;
  if (t && (n || o))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: a } : { errorMap: (i, r) => {
    const { message: c } = e;
    return i.code === "invalid_enum_value" ? { message: c ?? r.defaultError } : typeof r.data > "u" ? { message: c ?? o ?? r.defaultError } : i.code !== "invalid_type" ? { message: r.defaultError } : { message: c ?? n ?? r.defaultError };
  }, description: a };
}
class Be {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return Xn(t.data);
  }
  _getOrReturnCtx(t, n) {
    return n || {
      common: t.parent.common,
      data: t.data,
      parsedType: Xn(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new an(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: Xn(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const n = this._parse(t);
    if (Ps(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(t) {
    const n = this._parse(t);
    return Promise.resolve(n);
  }
  parse(t, n) {
    const o = this.safeParse(t, n);
    if (o.success)
      return o.data;
    throw o.error;
  }
  safeParse(t, n) {
    const o = {
      common: {
        issues: [],
        async: (n == null ? void 0 : n.async) ?? !1,
        contextualErrorMap: n == null ? void 0 : n.errorMap
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Xn(t)
    }, a = this._parseSync({ data: t, path: o.path, parent: o });
    return Iu(o, a);
  }
  "~validate"(t) {
    var o, a;
    const n = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Xn(t)
    };
    if (!this["~standard"].async)
      try {
        const s = this._parseSync({ data: t, path: [], parent: n });
        return Go(s) ? {
          value: s.value
        } : {
          issues: n.common.issues
        };
      } catch (s) {
        (a = (o = s == null ? void 0 : s.message) == null ? void 0 : o.toLowerCase()) != null && a.includes("encountered") && (this["~standard"].async = !0), n.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: t, path: [], parent: n }).then((s) => Go(s) ? {
      value: s.value
    } : {
      issues: n.common.issues
    });
  }
  async parseAsync(t, n) {
    const o = await this.safeParseAsync(t, n);
    if (o.success)
      return o.data;
    throw o.error;
  }
  async safeParseAsync(t, n) {
    const o = {
      common: {
        issues: [],
        contextualErrorMap: n == null ? void 0 : n.errorMap,
        async: !0
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Xn(t)
    }, a = this._parse({ data: t, path: o.path, parent: o }), s = await (Ps(a) ? a : Promise.resolve(a));
    return Iu(o, s);
  }
  refine(t, n) {
    const o = (a) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(a) : n;
    return this._refinement((a, s) => {
      const i = t(a), r = () => s.addIssue({
        code: oe.custom,
        ...o(a)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((c) => c ? !0 : (r(), !1)) : i ? !0 : (r(), !1);
    });
  }
  refinement(t, n) {
    return this._refinement((o, a) => t(o) ? !0 : (a.addIssue(typeof n == "function" ? n(o, a) : n), !1));
  }
  _refinement(t) {
    return new Co({
      schema: this,
      typeName: Ee.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (n) => this["~validate"](n)
    };
  }
  optional() {
    return Fn.create(this, this._def);
  }
  nullable() {
    return Ao.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return In.create(this);
  }
  promise() {
    return Ls.create(this, this._def);
  }
  or(t) {
    return Ms.create([this, t], this._def);
  }
  and(t) {
    return Is.create(this, t, this._def);
  }
  transform(t) {
    return new Co({
      ...Ve(this._def),
      schema: this,
      typeName: Ee.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const n = typeof t == "function" ? t : () => t;
    return new js({
      ...Ve(this._def),
      innerType: this,
      defaultValue: n,
      typeName: Ee.ZodDefault
    });
  }
  brand() {
    return new Tm({
      typeName: Ee.ZodBranded,
      type: this,
      ...Ve(this._def)
    });
  }
  catch(t) {
    const n = typeof t == "function" ? t : () => t;
    return new Ds({
      ...Ve(this._def),
      innerType: this,
      catchValue: n,
      typeName: Ee.ZodCatch
    });
  }
  describe(t) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return Ol.create(this, t);
  }
  readonly() {
    return Ns.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const yg = /^c[^\s-]{8,}$/i, kg = /^[0-9a-z]+$/, bg = /^[0-9A-HJKMNP-TV-Z]{26}$/i, wg = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, xg = /^[a-z0-9_-]{21}$/i, $g = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, zg = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Sg = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Cg = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Cr;
const Ag = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Pg = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Tg = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Mg = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Ig = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Eg = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Cm = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Og = new RegExp(`^${Cm}$`);
function Am(e) {
  let t = "[0-5]\\d";
  e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`);
  const n = e.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${t})${n}`;
}
function Rg(e) {
  return new RegExp(`^${Am(e)}$`);
}
function Lg(e) {
  let t = `${Cm}T${Am(e)}`;
  const n = [];
  return n.push(e.local ? "Z?" : "Z"), e.offset && n.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${n.join("|")})`, new RegExp(`^${t}$`);
}
function jg(e, t) {
  return !!((t === "v4" || !t) && Ag.test(e) || (t === "v6" || !t) && Tg.test(e));
}
function Dg(e, t) {
  if (!$g.test(e))
    return !1;
  try {
    const [n] = e.split(".");
    if (!n)
      return !1;
    const o = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), a = JSON.parse(atob(o));
    return !(typeof a != "object" || a === null || "typ" in a && (a == null ? void 0 : a.typ) !== "JWT" || !a.alg || t && a.alg !== t);
  } catch {
    return !1;
  }
}
function Ng(e, t) {
  return !!((t === "v4" || !t) && Pg.test(e) || (t === "v6" || !t) && Mg.test(e));
}
class Yn extends Be {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== ge.string) {
      const s = this._getOrReturnCtx(t);
      return pe(s, {
        code: oe.invalid_type,
        expected: ge.string,
        received: s.parsedType
      }), Me;
    }
    const o = new an();
    let a;
    for (const s of this._def.checks)
      if (s.kind === "min")
        t.data.length < s.value && (a = this._getOrReturnCtx(t, a), pe(a, {
          code: oe.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), o.dirty());
      else if (s.kind === "max")
        t.data.length > s.value && (a = this._getOrReturnCtx(t, a), pe(a, {
          code: oe.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), o.dirty());
      else if (s.kind === "length") {
        const i = t.data.length > s.value, r = t.data.length < s.value;
        (i || r) && (a = this._getOrReturnCtx(t, a), i ? pe(a, {
          code: oe.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }) : r && pe(a, {
          code: oe.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }), o.dirty());
      } else if (s.kind === "email")
        Sg.test(t.data) || (a = this._getOrReturnCtx(t, a), pe(a, {
          validation: "email",
          code: oe.invalid_string,
          message: s.message
        }), o.dirty());
      else if (s.kind === "emoji")
        Cr || (Cr = new RegExp(Cg, "u")), Cr.test(t.data) || (a = this._getOrReturnCtx(t, a), pe(a, {
          validation: "emoji",
          code: oe.invalid_string,
          message: s.message
        }), o.dirty());
      else if (s.kind === "uuid")
        wg.test(t.data) || (a = this._getOrReturnCtx(t, a), pe(a, {
          validation: "uuid",
          code: oe.invalid_string,
          message: s.message
        }), o.dirty());
      else if (s.kind === "nanoid")
        xg.test(t.data) || (a = this._getOrReturnCtx(t, a), pe(a, {
          validation: "nanoid",
          code: oe.invalid_string,
          message: s.message
        }), o.dirty());
      else if (s.kind === "cuid")
        yg.test(t.data) || (a = this._getOrReturnCtx(t, a), pe(a, {
          validation: "cuid",
          code: oe.invalid_string,
          message: s.message
        }), o.dirty());
      else if (s.kind === "cuid2")
        kg.test(t.data) || (a = this._getOrReturnCtx(t, a), pe(a, {
          validation: "cuid2",
          code: oe.invalid_string,
          message: s.message
        }), o.dirty());
      else if (s.kind === "ulid")
        bg.test(t.data) || (a = this._getOrReturnCtx(t, a), pe(a, {
          validation: "ulid",
          code: oe.invalid_string,
          message: s.message
        }), o.dirty());
      else if (s.kind === "url")
        try {
          new URL(t.data);
        } catch {
          a = this._getOrReturnCtx(t, a), pe(a, {
            validation: "url",
            code: oe.invalid_string,
            message: s.message
          }), o.dirty();
        }
      else s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(t.data) || (a = this._getOrReturnCtx(t, a), pe(a, {
        validation: "regex",
        code: oe.invalid_string,
        message: s.message
      }), o.dirty())) : s.kind === "trim" ? t.data = t.data.trim() : s.kind === "includes" ? t.data.includes(s.value, s.position) || (a = this._getOrReturnCtx(t, a), pe(a, {
        code: oe.invalid_string,
        validation: { includes: s.value, position: s.position },
        message: s.message
      }), o.dirty()) : s.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : s.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : s.kind === "startsWith" ? t.data.startsWith(s.value) || (a = this._getOrReturnCtx(t, a), pe(a, {
        code: oe.invalid_string,
        validation: { startsWith: s.value },
        message: s.message
      }), o.dirty()) : s.kind === "endsWith" ? t.data.endsWith(s.value) || (a = this._getOrReturnCtx(t, a), pe(a, {
        code: oe.invalid_string,
        validation: { endsWith: s.value },
        message: s.message
      }), o.dirty()) : s.kind === "datetime" ? Lg(s).test(t.data) || (a = this._getOrReturnCtx(t, a), pe(a, {
        code: oe.invalid_string,
        validation: "datetime",
        message: s.message
      }), o.dirty()) : s.kind === "date" ? Og.test(t.data) || (a = this._getOrReturnCtx(t, a), pe(a, {
        code: oe.invalid_string,
        validation: "date",
        message: s.message
      }), o.dirty()) : s.kind === "time" ? Rg(s).test(t.data) || (a = this._getOrReturnCtx(t, a), pe(a, {
        code: oe.invalid_string,
        validation: "time",
        message: s.message
      }), o.dirty()) : s.kind === "duration" ? zg.test(t.data) || (a = this._getOrReturnCtx(t, a), pe(a, {
        validation: "duration",
        code: oe.invalid_string,
        message: s.message
      }), o.dirty()) : s.kind === "ip" ? jg(t.data, s.version) || (a = this._getOrReturnCtx(t, a), pe(a, {
        validation: "ip",
        code: oe.invalid_string,
        message: s.message
      }), o.dirty()) : s.kind === "jwt" ? Dg(t.data, s.alg) || (a = this._getOrReturnCtx(t, a), pe(a, {
        validation: "jwt",
        code: oe.invalid_string,
        message: s.message
      }), o.dirty()) : s.kind === "cidr" ? Ng(t.data, s.version) || (a = this._getOrReturnCtx(t, a), pe(a, {
        validation: "cidr",
        code: oe.invalid_string,
        message: s.message
      }), o.dirty()) : s.kind === "base64" ? Ig.test(t.data) || (a = this._getOrReturnCtx(t, a), pe(a, {
        validation: "base64",
        code: oe.invalid_string,
        message: s.message
      }), o.dirty()) : s.kind === "base64url" ? Eg.test(t.data) || (a = this._getOrReturnCtx(t, a), pe(a, {
        validation: "base64url",
        code: oe.invalid_string,
        message: s.message
      }), o.dirty()) : We.assertNever(s);
    return { status: o.value, value: t.data };
  }
  _regex(t, n, o) {
    return this.refinement((a) => t.test(a), {
      validation: n,
      code: oe.invalid_string,
      ...be.errToObj(o)
    });
  }
  _addCheck(t) {
    return new Yn({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...be.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...be.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...be.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...be.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...be.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...be.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...be.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...be.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...be.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({
      kind: "base64url",
      ...be.errToObj(t)
    });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...be.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...be.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...be.errToObj(t) });
  }
  datetime(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (t == null ? void 0 : t.offset) ?? !1,
      local: (t == null ? void 0 : t.local) ?? !1,
      ...be.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...be.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...be.errToObj(t) });
  }
  regex(t, n) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...be.errToObj(n)
    });
  }
  includes(t, n) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: n == null ? void 0 : n.position,
      ...be.errToObj(n == null ? void 0 : n.message)
    });
  }
  startsWith(t, n) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...be.errToObj(n)
    });
  }
  endsWith(t, n) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...be.errToObj(n)
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...be.errToObj(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...be.errToObj(n)
    });
  }
  length(t, n) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...be.errToObj(n)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(t) {
    return this.min(1, be.errToObj(t));
  }
  trim() {
    return new Yn({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Yn({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Yn({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
Yn.create = (e) => new Yn({
  checks: [],
  typeName: Ee.ZodString,
  coerce: (e == null ? void 0 : e.coerce) ?? !1,
  ...Ve(e)
});
function Vg(e, t) {
  const n = (e.toString().split(".")[1] || "").length, o = (t.toString().split(".")[1] || "").length, a = n > o ? n : o, s = Number.parseInt(e.toFixed(a).replace(".", "")), i = Number.parseInt(t.toFixed(a).replace(".", ""));
  return s % i / 10 ** a;
}
class Wo extends Be {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== ge.number) {
      const s = this._getOrReturnCtx(t);
      return pe(s, {
        code: oe.invalid_type,
        expected: ge.number,
        received: s.parsedType
      }), Me;
    }
    let o;
    const a = new an();
    for (const s of this._def.checks)
      s.kind === "int" ? We.isInteger(t.data) || (o = this._getOrReturnCtx(t, o), pe(o, {
        code: oe.invalid_type,
        expected: "integer",
        received: "float",
        message: s.message
      }), a.dirty()) : s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (o = this._getOrReturnCtx(t, o), pe(o, {
        code: oe.too_small,
        minimum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (o = this._getOrReturnCtx(t, o), pe(o, {
        code: oe.too_big,
        maximum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? Vg(t.data, s.value) !== 0 && (o = this._getOrReturnCtx(t, o), pe(o, {
        code: oe.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : s.kind === "finite" ? Number.isFinite(t.data) || (o = this._getOrReturnCtx(t, o), pe(o, {
        code: oe.not_finite,
        message: s.message
      }), a.dirty()) : We.assertNever(s);
    return { status: a.value, value: t.data };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, be.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, be.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, be.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, be.toString(n));
  }
  setLimit(t, n, o, a) {
    return new Wo({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: o,
          message: be.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Wo({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: be.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: be.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: be.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: be.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: be.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: be.toString(n)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: be.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: be.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: be.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && We.isInteger(t.value));
  }
  get isFinite() {
    let t = null, n = null;
    for (const o of this._def.checks) {
      if (o.kind === "finite" || o.kind === "int" || o.kind === "multipleOf")
        return !0;
      o.kind === "min" ? (n === null || o.value > n) && (n = o.value) : o.kind === "max" && (t === null || o.value < t) && (t = o.value);
    }
    return Number.isFinite(n) && Number.isFinite(t);
  }
}
Wo.create = (e) => new Wo({
  checks: [],
  typeName: Ee.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...Ve(e)
});
class Sa extends Be {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce)
      try {
        t.data = BigInt(t.data);
      } catch {
        return this._getInvalidInput(t);
      }
    if (this._getType(t) !== ge.bigint)
      return this._getInvalidInput(t);
    let o;
    const a = new an();
    for (const s of this._def.checks)
      s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (o = this._getOrReturnCtx(t, o), pe(o, {
        code: oe.too_small,
        type: "bigint",
        minimum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (o = this._getOrReturnCtx(t, o), pe(o, {
        code: oe.too_big,
        type: "bigint",
        maximum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? t.data % s.value !== BigInt(0) && (o = this._getOrReturnCtx(t, o), pe(o, {
        code: oe.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : We.assertNever(s);
    return { status: a.value, value: t.data };
  }
  _getInvalidInput(t) {
    const n = this._getOrReturnCtx(t);
    return pe(n, {
      code: oe.invalid_type,
      expected: ge.bigint,
      received: n.parsedType
    }), Me;
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, be.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, be.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, be.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, be.toString(n));
  }
  setLimit(t, n, o, a) {
    return new Sa({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: o,
          message: be.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Sa({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: be.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: be.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: be.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: be.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: be.toString(n)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
Sa.create = (e) => new Sa({
  checks: [],
  typeName: Ee.ZodBigInt,
  coerce: (e == null ? void 0 : e.coerce) ?? !1,
  ...Ve(e)
});
class ol extends Be {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== ge.boolean) {
      const o = this._getOrReturnCtx(t);
      return pe(o, {
        code: oe.invalid_type,
        expected: ge.boolean,
        received: o.parsedType
      }), Me;
    }
    return hn(t.data);
  }
}
ol.create = (e) => new ol({
  typeName: Ee.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...Ve(e)
});
class Ca extends Be {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== ge.date) {
      const s = this._getOrReturnCtx(t);
      return pe(s, {
        code: oe.invalid_type,
        expected: ge.date,
        received: s.parsedType
      }), Me;
    }
    if (Number.isNaN(t.data.getTime())) {
      const s = this._getOrReturnCtx(t);
      return pe(s, {
        code: oe.invalid_date
      }), Me;
    }
    const o = new an();
    let a;
    for (const s of this._def.checks)
      s.kind === "min" ? t.data.getTime() < s.value && (a = this._getOrReturnCtx(t, a), pe(a, {
        code: oe.too_small,
        message: s.message,
        inclusive: !0,
        exact: !1,
        minimum: s.value,
        type: "date"
      }), o.dirty()) : s.kind === "max" ? t.data.getTime() > s.value && (a = this._getOrReturnCtx(t, a), pe(a, {
        code: oe.too_big,
        message: s.message,
        inclusive: !0,
        exact: !1,
        maximum: s.value,
        type: "date"
      }), o.dirty()) : We.assertNever(s);
    return {
      status: o.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new Ca({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: be.toString(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: be.toString(n)
    });
  }
  get minDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
}
Ca.create = (e) => new Ca({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: Ee.ZodDate,
  ...Ve(e)
});
class Eu extends Be {
  _parse(t) {
    if (this._getType(t) !== ge.symbol) {
      const o = this._getOrReturnCtx(t);
      return pe(o, {
        code: oe.invalid_type,
        expected: ge.symbol,
        received: o.parsedType
      }), Me;
    }
    return hn(t.data);
  }
}
Eu.create = (e) => new Eu({
  typeName: Ee.ZodSymbol,
  ...Ve(e)
});
class al extends Be {
  _parse(t) {
    if (this._getType(t) !== ge.undefined) {
      const o = this._getOrReturnCtx(t);
      return pe(o, {
        code: oe.invalid_type,
        expected: ge.undefined,
        received: o.parsedType
      }), Me;
    }
    return hn(t.data);
  }
}
al.create = (e) => new al({
  typeName: Ee.ZodUndefined,
  ...Ve(e)
});
class Ts extends Be {
  _parse(t) {
    if (this._getType(t) !== ge.null) {
      const o = this._getOrReturnCtx(t);
      return pe(o, {
        code: oe.invalid_type,
        expected: ge.null,
        received: o.parsedType
      }), Me;
    }
    return hn(t.data);
  }
}
Ts.create = (e) => new Ts({
  typeName: Ee.ZodNull,
  ...Ve(e)
});
class Aa extends Be {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return hn(t.data);
  }
}
Aa.create = (e) => new Aa({
  typeName: Ee.ZodAny,
  ...Ve(e)
});
class sl extends Be {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return hn(t.data);
  }
}
sl.create = (e) => new sl({
  typeName: Ee.ZodUnknown,
  ...Ve(e)
});
class oo extends Be {
  _parse(t) {
    const n = this._getOrReturnCtx(t);
    return pe(n, {
      code: oe.invalid_type,
      expected: ge.never,
      received: n.parsedType
    }), Me;
  }
}
oo.create = (e) => new oo({
  typeName: Ee.ZodNever,
  ...Ve(e)
});
class Ou extends Be {
  _parse(t) {
    if (this._getType(t) !== ge.undefined) {
      const o = this._getOrReturnCtx(t);
      return pe(o, {
        code: oe.invalid_type,
        expected: ge.void,
        received: o.parsedType
      }), Me;
    }
    return hn(t.data);
  }
}
Ou.create = (e) => new Ou({
  typeName: Ee.ZodVoid,
  ...Ve(e)
});
class In extends Be {
  _parse(t) {
    const { ctx: n, status: o } = this._processInputParams(t), a = this._def;
    if (n.parsedType !== ge.array)
      return pe(n, {
        code: oe.invalid_type,
        expected: ge.array,
        received: n.parsedType
      }), Me;
    if (a.exactLength !== null) {
      const i = n.data.length > a.exactLength.value, r = n.data.length < a.exactLength.value;
      (i || r) && (pe(n, {
        code: i ? oe.too_big : oe.too_small,
        minimum: r ? a.exactLength.value : void 0,
        maximum: i ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), o.dirty());
    }
    if (a.minLength !== null && n.data.length < a.minLength.value && (pe(n, {
      code: oe.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), o.dirty()), a.maxLength !== null && n.data.length > a.maxLength.value && (pe(n, {
      code: oe.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), o.dirty()), n.common.async)
      return Promise.all([...n.data].map((i, r) => a.type._parseAsync(new no(n, i, n.path, r)))).then((i) => an.mergeArray(o, i));
    const s = [...n.data].map((i, r) => a.type._parseSync(new no(n, i, n.path, r)));
    return an.mergeArray(o, s);
  }
  get element() {
    return this._def.type;
  }
  min(t, n) {
    return new In({
      ...this._def,
      minLength: { value: t, message: be.toString(n) }
    });
  }
  max(t, n) {
    return new In({
      ...this._def,
      maxLength: { value: t, message: be.toString(n) }
    });
  }
  length(t, n) {
    return new In({
      ...this._def,
      exactLength: { value: t, message: be.toString(n) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
In.create = (e, t) => new In({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Ee.ZodArray,
  ...Ve(t)
});
function Uo(e) {
  if (e instanceof $t) {
    const t = {};
    for (const n in e.shape) {
      const o = e.shape[n];
      t[n] = Fn.create(Uo(o));
    }
    return new $t({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof In ? new In({
    ...e._def,
    type: Uo(e.element)
  }) : e instanceof Fn ? Fn.create(Uo(e.unwrap())) : e instanceof Ao ? Ao.create(Uo(e.unwrap())) : e instanceof zo ? zo.create(e.items.map((t) => Uo(t))) : e;
}
class $t extends Be {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), n = We.objectKeys(t);
    return this._cached = { shape: t, keys: n }, this._cached;
  }
  _parse(t) {
    if (this._getType(t) !== ge.object) {
      const u = this._getOrReturnCtx(t);
      return pe(u, {
        code: oe.invalid_type,
        expected: ge.object,
        received: u.parsedType
      }), Me;
    }
    const { status: o, ctx: a } = this._processInputParams(t), { shape: s, keys: i } = this._getCached(), r = [];
    if (!(this._def.catchall instanceof oo && this._def.unknownKeys === "strip"))
      for (const u in a.data)
        i.includes(u) || r.push(u);
    const c = [];
    for (const u of i) {
      const d = s[u], p = a.data[u];
      c.push({
        key: { status: "valid", value: u },
        value: d._parse(new no(a, p, a.path, u)),
        alwaysSet: u in a.data
      });
    }
    if (this._def.catchall instanceof oo) {
      const u = this._def.unknownKeys;
      if (u === "passthrough")
        for (const d of r)
          c.push({
            key: { status: "valid", value: d },
            value: { status: "valid", value: a.data[d] }
          });
      else if (u === "strict")
        r.length > 0 && (pe(a, {
          code: oe.unrecognized_keys,
          keys: r
        }), o.dirty());
      else if (u !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const d of r) {
        const p = a.data[d];
        c.push({
          key: { status: "valid", value: d },
          value: u._parse(
            new no(a, p, a.path, d)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: d in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const d of c) {
        const p = await d.key, _ = await d.value;
        u.push({
          key: p,
          value: _,
          alwaysSet: d.alwaysSet
        });
      }
      return u;
    }).then((u) => an.mergeObjectSync(o, u)) : an.mergeObjectSync(o, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return be.errToObj, new $t({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (n, o) => {
          var s, i;
          const a = ((i = (s = this._def).errorMap) == null ? void 0 : i.call(s, n, o).message) ?? o.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: be.errToObj(t).message ?? a
          } : {
            message: a
          };
        }
      } : {}
    });
  }
  strip() {
    return new $t({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new $t({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new $t({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new $t({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: Ee.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, n) {
    return this.augment({ [t]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new $t({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const n = {};
    for (const o of We.objectKeys(t))
      t[o] && this.shape[o] && (n[o] = this.shape[o]);
    return new $t({
      ...this._def,
      shape: () => n
    });
  }
  omit(t) {
    const n = {};
    for (const o of We.objectKeys(this.shape))
      t[o] || (n[o] = this.shape[o]);
    return new $t({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return Uo(this);
  }
  partial(t) {
    const n = {};
    for (const o of We.objectKeys(this.shape)) {
      const a = this.shape[o];
      t && !t[o] ? n[o] = a : n[o] = a.optional();
    }
    return new $t({
      ...this._def,
      shape: () => n
    });
  }
  required(t) {
    const n = {};
    for (const o of We.objectKeys(this.shape))
      if (t && !t[o])
        n[o] = this.shape[o];
      else {
        let s = this.shape[o];
        for (; s instanceof Fn; )
          s = s._def.innerType;
        n[o] = s;
      }
    return new $t({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return Pm(We.objectKeys(this.shape));
  }
}
$t.create = (e, t) => new $t({
  shape: () => e,
  unknownKeys: "strip",
  catchall: oo.create(),
  typeName: Ee.ZodObject,
  ...Ve(t)
});
$t.strictCreate = (e, t) => new $t({
  shape: () => e,
  unknownKeys: "strict",
  catchall: oo.create(),
  typeName: Ee.ZodObject,
  ...Ve(t)
});
$t.lazycreate = (e, t) => new $t({
  shape: e,
  unknownKeys: "strip",
  catchall: oo.create(),
  typeName: Ee.ZodObject,
  ...Ve(t)
});
class Ms extends Be {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), o = this._def.options;
    function a(s) {
      for (const r of s)
        if (r.result.status === "valid")
          return r.result;
      for (const r of s)
        if (r.result.status === "dirty")
          return n.common.issues.push(...r.ctx.common.issues), r.result;
      const i = s.map((r) => new Bn(r.ctx.common.issues));
      return pe(n, {
        code: oe.invalid_union,
        unionErrors: i
      }), Me;
    }
    if (n.common.async)
      return Promise.all(o.map(async (s) => {
        const i = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await s._parseAsync({
            data: n.data,
            path: n.path,
            parent: i
          }),
          ctx: i
        };
      })).then(a);
    {
      let s;
      const i = [];
      for (const c of o) {
        const u = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, d = c._parseSync({
          data: n.data,
          path: n.path,
          parent: u
        });
        if (d.status === "valid")
          return d;
        d.status === "dirty" && !s && (s = { result: d, ctx: u }), u.common.issues.length && i.push(u.common.issues);
      }
      if (s)
        return n.common.issues.push(...s.ctx.common.issues), s.result;
      const r = i.map((c) => new Bn(c));
      return pe(n, {
        code: oe.invalid_union,
        unionErrors: r
      }), Me;
    }
  }
  get options() {
    return this._def.options;
  }
}
Ms.create = (e, t) => new Ms({
  options: e,
  typeName: Ee.ZodUnion,
  ...Ve(t)
});
const Vn = (e) => e instanceof Es ? Vn(e.schema) : e instanceof Co ? Vn(e.innerType()) : e instanceof Os ? [e.value] : e instanceof So ? e.options : e instanceof Rs ? We.objectValues(e.enum) : e instanceof js ? Vn(e._def.innerType) : e instanceof al ? [void 0] : e instanceof Ts ? [null] : e instanceof Fn ? [void 0, ...Vn(e.unwrap())] : e instanceof Ao ? [null, ...Vn(e.unwrap())] : e instanceof Tm || e instanceof Ns ? Vn(e.unwrap()) : e instanceof Ds ? Vn(e._def.innerType) : [];
class El extends Be {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== ge.object)
      return pe(n, {
        code: oe.invalid_type,
        expected: ge.object,
        received: n.parsedType
      }), Me;
    const o = this.discriminator, a = n.data[o], s = this.optionsMap.get(a);
    return s ? n.common.async ? s._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : s._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (pe(n, {
      code: oe.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [o]
    }), Me);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, n, o) {
    const a = /* @__PURE__ */ new Map();
    for (const s of n) {
      const i = Vn(s.shape[t]);
      if (!i.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const r of i) {
        if (a.has(r))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(r)}`);
        a.set(r, s);
      }
    }
    return new El({
      typeName: Ee.ZodDiscriminatedUnion,
      discriminator: t,
      options: n,
      optionsMap: a,
      ...Ve(o)
    });
  }
}
function il(e, t) {
  const n = Xn(e), o = Xn(t);
  if (e === t)
    return { valid: !0, data: e };
  if (n === ge.object && o === ge.object) {
    const a = We.objectKeys(t), s = We.objectKeys(e).filter((r) => a.indexOf(r) !== -1), i = { ...e, ...t };
    for (const r of s) {
      const c = il(e[r], t[r]);
      if (!c.valid)
        return { valid: !1 };
      i[r] = c.data;
    }
    return { valid: !0, data: i };
  } else if (n === ge.array && o === ge.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const a = [];
    for (let s = 0; s < e.length; s++) {
      const i = e[s], r = t[s], c = il(i, r);
      if (!c.valid)
        return { valid: !1 };
      a.push(c.data);
    }
    return { valid: !0, data: a };
  } else return n === ge.date && o === ge.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class Is extends Be {
  _parse(t) {
    const { status: n, ctx: o } = this._processInputParams(t), a = (s, i) => {
      if (Tu(s) || Tu(i))
        return Me;
      const r = il(s.value, i.value);
      return r.valid ? ((Mu(s) || Mu(i)) && n.dirty(), { status: n.value, value: r.data }) : (pe(o, {
        code: oe.invalid_intersection_types
      }), Me);
    };
    return o.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: o.data,
        path: o.path,
        parent: o
      }),
      this._def.right._parseAsync({
        data: o.data,
        path: o.path,
        parent: o
      })
    ]).then(([s, i]) => a(s, i)) : a(this._def.left._parseSync({
      data: o.data,
      path: o.path,
      parent: o
    }), this._def.right._parseSync({
      data: o.data,
      path: o.path,
      parent: o
    }));
  }
}
Is.create = (e, t, n) => new Is({
  left: e,
  right: t,
  typeName: Ee.ZodIntersection,
  ...Ve(n)
});
class zo extends Be {
  _parse(t) {
    const { status: n, ctx: o } = this._processInputParams(t);
    if (o.parsedType !== ge.array)
      return pe(o, {
        code: oe.invalid_type,
        expected: ge.array,
        received: o.parsedType
      }), Me;
    if (o.data.length < this._def.items.length)
      return pe(o, {
        code: oe.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), Me;
    !this._def.rest && o.data.length > this._def.items.length && (pe(o, {
      code: oe.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const s = [...o.data].map((i, r) => {
      const c = this._def.items[r] || this._def.rest;
      return c ? c._parse(new no(o, i, o.path, r)) : null;
    }).filter((i) => !!i);
    return o.common.async ? Promise.all(s).then((i) => an.mergeArray(n, i)) : an.mergeArray(n, s);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new zo({
      ...this._def,
      rest: t
    });
  }
}
zo.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new zo({
    items: e,
    typeName: Ee.ZodTuple,
    rest: null,
    ...Ve(t)
  });
};
class Ru extends Be {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: o } = this._processInputParams(t);
    if (o.parsedType !== ge.map)
      return pe(o, {
        code: oe.invalid_type,
        expected: ge.map,
        received: o.parsedType
      }), Me;
    const a = this._def.keyType, s = this._def.valueType, i = [...o.data.entries()].map(([r, c], u) => ({
      key: a._parse(new no(o, r, o.path, [u, "key"])),
      value: s._parse(new no(o, c, o.path, [u, "value"]))
    }));
    if (o.common.async) {
      const r = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of i) {
          const u = await c.key, d = await c.value;
          if (u.status === "aborted" || d.status === "aborted")
            return Me;
          (u.status === "dirty" || d.status === "dirty") && n.dirty(), r.set(u.value, d.value);
        }
        return { status: n.value, value: r };
      });
    } else {
      const r = /* @__PURE__ */ new Map();
      for (const c of i) {
        const u = c.key, d = c.value;
        if (u.status === "aborted" || d.status === "aborted")
          return Me;
        (u.status === "dirty" || d.status === "dirty") && n.dirty(), r.set(u.value, d.value);
      }
      return { status: n.value, value: r };
    }
  }
}
Ru.create = (e, t, n) => new Ru({
  valueType: t,
  keyType: e,
  typeName: Ee.ZodMap,
  ...Ve(n)
});
class Pa extends Be {
  _parse(t) {
    const { status: n, ctx: o } = this._processInputParams(t);
    if (o.parsedType !== ge.set)
      return pe(o, {
        code: oe.invalid_type,
        expected: ge.set,
        received: o.parsedType
      }), Me;
    const a = this._def;
    a.minSize !== null && o.data.size < a.minSize.value && (pe(o, {
      code: oe.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), n.dirty()), a.maxSize !== null && o.data.size > a.maxSize.value && (pe(o, {
      code: oe.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), n.dirty());
    const s = this._def.valueType;
    function i(c) {
      const u = /* @__PURE__ */ new Set();
      for (const d of c) {
        if (d.status === "aborted")
          return Me;
        d.status === "dirty" && n.dirty(), u.add(d.value);
      }
      return { status: n.value, value: u };
    }
    const r = [...o.data.values()].map((c, u) => s._parse(new no(o, c, o.path, u)));
    return o.common.async ? Promise.all(r).then((c) => i(c)) : i(r);
  }
  min(t, n) {
    return new Pa({
      ...this._def,
      minSize: { value: t, message: be.toString(n) }
    });
  }
  max(t, n) {
    return new Pa({
      ...this._def,
      maxSize: { value: t, message: be.toString(n) }
    });
  }
  size(t, n) {
    return this.min(t, n).max(t, n);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Pa.create = (e, t) => new Pa({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: Ee.ZodSet,
  ...Ve(t)
});
class Es extends Be {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
Es.create = (e, t) => new Es({
  getter: e,
  typeName: Ee.ZodLazy,
  ...Ve(t)
});
class Os extends Be {
  _parse(t) {
    if (t.data !== this._def.value) {
      const n = this._getOrReturnCtx(t);
      return pe(n, {
        received: n.data,
        code: oe.invalid_literal,
        expected: this._def.value
      }), Me;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
Os.create = (e, t) => new Os({
  value: e,
  typeName: Ee.ZodLiteral,
  ...Ve(t)
});
function Pm(e, t) {
  return new So({
    values: e,
    typeName: Ee.ZodEnum,
    ...Ve(t)
  });
}
class So extends Be {
  _parse(t) {
    if (typeof t.data != "string") {
      const n = this._getOrReturnCtx(t), o = this._def.values;
      return pe(n, {
        expected: We.joinValues(o),
        received: n.parsedType,
        code: oe.invalid_type
      }), Me;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(t.data)) {
      const n = this._getOrReturnCtx(t), o = this._def.values;
      return pe(n, {
        received: n.data,
        code: oe.invalid_enum_value,
        options: o
      }), Me;
    }
    return hn(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Values() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  extract(t, n = this._def) {
    return So.create(t, {
      ...this._def,
      ...n
    });
  }
  exclude(t, n = this._def) {
    return So.create(this.options.filter((o) => !t.includes(o)), {
      ...this._def,
      ...n
    });
  }
}
So.create = Pm;
class Rs extends Be {
  _parse(t) {
    const n = We.getValidEnumValues(this._def.values), o = this._getOrReturnCtx(t);
    if (o.parsedType !== ge.string && o.parsedType !== ge.number) {
      const a = We.objectValues(n);
      return pe(o, {
        expected: We.joinValues(a),
        received: o.parsedType,
        code: oe.invalid_type
      }), Me;
    }
    if (this._cache || (this._cache = new Set(We.getValidEnumValues(this._def.values))), !this._cache.has(t.data)) {
      const a = We.objectValues(n);
      return pe(o, {
        received: o.data,
        code: oe.invalid_enum_value,
        options: a
      }), Me;
    }
    return hn(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
Rs.create = (e, t) => new Rs({
  values: e,
  typeName: Ee.ZodNativeEnum,
  ...Ve(t)
});
class Ls extends Be {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== ge.promise && n.common.async === !1)
      return pe(n, {
        code: oe.invalid_type,
        expected: ge.promise,
        received: n.parsedType
      }), Me;
    const o = n.parsedType === ge.promise ? n.data : Promise.resolve(n.data);
    return hn(o.then((a) => this._def.type.parseAsync(a, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
Ls.create = (e, t) => new Ls({
  type: e,
  typeName: Ee.ZodPromise,
  ...Ve(t)
});
class Co extends Be {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Ee.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: n, ctx: o } = this._processInputParams(t), a = this._def.effect || null, s = {
      addIssue: (i) => {
        pe(o, i), i.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return o.path;
      }
    };
    if (s.addIssue = s.addIssue.bind(s), a.type === "preprocess") {
      const i = a.transform(o.data, s);
      if (o.common.async)
        return Promise.resolve(i).then(async (r) => {
          if (n.value === "aborted")
            return Me;
          const c = await this._def.schema._parseAsync({
            data: r,
            path: o.path,
            parent: o
          });
          return c.status === "aborted" ? Me : c.status === "dirty" || n.value === "dirty" ? ka(c.value) : c;
        });
      {
        if (n.value === "aborted")
          return Me;
        const r = this._def.schema._parseSync({
          data: i,
          path: o.path,
          parent: o
        });
        return r.status === "aborted" ? Me : r.status === "dirty" || n.value === "dirty" ? ka(r.value) : r;
      }
    }
    if (a.type === "refinement") {
      const i = (r) => {
        const c = a.refinement(r, s);
        if (o.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return r;
      };
      if (o.common.async === !1) {
        const r = this._def.schema._parseSync({
          data: o.data,
          path: o.path,
          parent: o
        });
        return r.status === "aborted" ? Me : (r.status === "dirty" && n.dirty(), i(r.value), { status: n.value, value: r.value });
      } else
        return this._def.schema._parseAsync({ data: o.data, path: o.path, parent: o }).then((r) => r.status === "aborted" ? Me : (r.status === "dirty" && n.dirty(), i(r.value).then(() => ({ status: n.value, value: r.value }))));
    }
    if (a.type === "transform")
      if (o.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: o.data,
          path: o.path,
          parent: o
        });
        if (!Go(i))
          return Me;
        const r = a.transform(i.value, s);
        if (r instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: r };
      } else
        return this._def.schema._parseAsync({ data: o.data, path: o.path, parent: o }).then((i) => Go(i) ? Promise.resolve(a.transform(i.value, s)).then((r) => ({
          status: n.value,
          value: r
        })) : Me);
    We.assertNever(a);
  }
}
Co.create = (e, t, n) => new Co({
  schema: e,
  typeName: Ee.ZodEffects,
  effect: t,
  ...Ve(n)
});
Co.createWithPreprocess = (e, t, n) => new Co({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: Ee.ZodEffects,
  ...Ve(n)
});
class Fn extends Be {
  _parse(t) {
    return this._getType(t) === ge.undefined ? hn(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Fn.create = (e, t) => new Fn({
  innerType: e,
  typeName: Ee.ZodOptional,
  ...Ve(t)
});
class Ao extends Be {
  _parse(t) {
    return this._getType(t) === ge.null ? hn(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ao.create = (e, t) => new Ao({
  innerType: e,
  typeName: Ee.ZodNullable,
  ...Ve(t)
});
class js extends Be {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    let o = n.data;
    return n.parsedType === ge.undefined && (o = this._def.defaultValue()), this._def.innerType._parse({
      data: o,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
js.create = (e, t) => new js({
  innerType: e,
  typeName: Ee.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...Ve(t)
});
class Ds extends Be {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), o = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: o.data,
      path: o.path,
      parent: {
        ...o
      }
    });
    return Ps(a) ? a.then((s) => ({
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new Bn(o.common.issues);
        },
        input: o.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new Bn(o.common.issues);
        },
        input: o.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Ds.create = (e, t) => new Ds({
  innerType: e,
  typeName: Ee.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...Ve(t)
});
class Lu extends Be {
  _parse(t) {
    if (this._getType(t) !== ge.nan) {
      const o = this._getOrReturnCtx(t);
      return pe(o, {
        code: oe.invalid_type,
        expected: ge.nan,
        received: o.parsedType
      }), Me;
    }
    return { status: "valid", value: t.data };
  }
}
Lu.create = (e) => new Lu({
  typeName: Ee.ZodNaN,
  ...Ve(e)
});
class Tm extends Be {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), o = n.data;
    return this._def.type._parse({
      data: o,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Ol extends Be {
  _parse(t) {
    const { status: n, ctx: o } = this._processInputParams(t);
    if (o.common.async)
      return (async () => {
        const s = await this._def.in._parseAsync({
          data: o.data,
          path: o.path,
          parent: o
        });
        return s.status === "aborted" ? Me : s.status === "dirty" ? (n.dirty(), ka(s.value)) : this._def.out._parseAsync({
          data: s.value,
          path: o.path,
          parent: o
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: o.data,
        path: o.path,
        parent: o
      });
      return a.status === "aborted" ? Me : a.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: o.path,
        parent: o
      });
    }
  }
  static create(t, n) {
    return new Ol({
      in: t,
      out: n,
      typeName: Ee.ZodPipeline
    });
  }
}
class Ns extends Be {
  _parse(t) {
    const n = this._def.innerType._parse(t), o = (a) => (Go(a) && (a.value = Object.freeze(a.value)), a);
    return Ps(n) ? n.then((a) => o(a)) : o(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ns.create = (e, t) => new Ns({
  innerType: e,
  typeName: Ee.ZodReadonly,
  ...Ve(t)
});
function ju(e, t) {
  const n = typeof e == "function" ? e(t) : typeof e == "string" ? { message: e } : e;
  return typeof n == "string" ? { message: n } : n;
}
function Mm(e, t = {}, n) {
  return e ? Aa.create().superRefine((o, a) => {
    const s = e(o);
    if (s instanceof Promise)
      return s.then((i) => {
        if (!i) {
          const r = ju(t, o), c = r.fatal ?? n ?? !0;
          a.addIssue({ code: "custom", ...r, fatal: c });
        }
      });
    if (!s) {
      const i = ju(t, o), r = i.fatal ?? n ?? !0;
      a.addIssue({ code: "custom", ...i, fatal: r });
    }
  }) : Aa.create();
}
var Ee;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(Ee || (Ee = {}));
const Ug = (e, t = {
  message: `Input not instance of ${e.name}`
}) => Mm((n) => n instanceof e, t), V = Yn.create, O = Wo.create, Gt = ol.create, ho = Ca.create, Ta = Ts.create;
Aa.create;
const Fg = sl.create;
oo.create;
const ht = In.create, B = $t.create, ao = Ms.create, Rl = El.create;
Is.create;
const so = zo.create, Ll = Es.create, lt = Os.create;
So.create;
const _n = Rs.create;
Ls.create;
Fn.create;
Ao.create;
const It = [];
for (let e = 0; e < 256; ++e)
  It.push((e + 256).toString(16).slice(1));
function qg(e, t = 0) {
  return (It[e[t + 0]] + It[e[t + 1]] + It[e[t + 2]] + It[e[t + 3]] + "-" + It[e[t + 4]] + It[e[t + 5]] + "-" + It[e[t + 6]] + It[e[t + 7]] + "-" + It[e[t + 8]] + It[e[t + 9]] + "-" + It[e[t + 10]] + It[e[t + 11]] + It[e[t + 12]] + It[e[t + 13]] + It[e[t + 14]] + It[e[t + 15]]).toLowerCase();
}
let Ar;
const Bg = new Uint8Array(16);
function Hg() {
  if (!Ar) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Ar = crypto.getRandomValues.bind(crypto);
  }
  return Ar(Bg);
}
const Gg = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Du = { randomUUID: Gg };
function Im(e, t, n) {
  var a;
  if (Du.randomUUID && !e)
    return Du.randomUUID();
  e = e || {};
  const o = e.random ?? ((a = e.rng) == null ? void 0 : a.call(e)) ?? Hg();
  if (o.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, qg(o);
}
function Em(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Wg } = Object.prototype, { getPrototypeOf: jl } = Object, { iterator: ei, toStringTag: Om } = Symbol, ti = /* @__PURE__ */ ((e) => (t) => {
  const n = Wg.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Sn = (e) => (e = e.toLowerCase(), (t) => ti(t) === e), ni = (e) => (t) => typeof t === e, { isArray: ea } = Array, Zo = ni("undefined");
function Oa(e) {
  return e !== null && !Zo(e) && e.constructor !== null && !Zo(e.constructor) && Zt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Rm = Sn("ArrayBuffer");
function Zg(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Rm(e.buffer), t;
}
const Kg = ni("string"), Zt = ni("function"), Lm = ni("number"), Ra = (e) => e !== null && typeof e == "object", Qg = (e) => e === !0 || e === !1, bs = (e) => {
  if (ti(e) !== "object")
    return !1;
  const t = jl(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Om in e) && !(ei in e);
}, Xg = (e) => {
  if (!Ra(e) || Oa(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, Jg = Sn("Date"), Yg = Sn("File"), e1 = Sn("Blob"), t1 = Sn("FileList"), n1 = (e) => Ra(e) && Zt(e.pipe), o1 = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Zt(e.append) && ((t = ti(e)) === "formdata" || // detect form-data instance
  t === "object" && Zt(e.toString) && e.toString() === "[object FormData]"));
}, a1 = Sn("URLSearchParams"), [s1, i1, r1, l1] = ["ReadableStream", "Request", "Response", "Headers"].map(Sn), c1 = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function La(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let o, a;
  if (typeof e != "object" && (e = [e]), ea(e))
    for (o = 0, a = e.length; o < a; o++)
      t.call(null, e[o], o, e);
  else {
    if (Oa(e))
      return;
    const s = n ? Object.getOwnPropertyNames(e) : Object.keys(e), i = s.length;
    let r;
    for (o = 0; o < i; o++)
      r = s[o], t.call(null, e[r], r, e);
  }
}
function jm(e, t) {
  if (Oa(e))
    return null;
  t = t.toLowerCase();
  const n = Object.keys(e);
  let o = n.length, a;
  for (; o-- > 0; )
    if (a = n[o], t === a.toLowerCase())
      return a;
  return null;
}
const _o = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Dm = (e) => !Zo(e) && e !== _o;
function rl() {
  const { caseless: e, skipUndefined: t } = Dm(this) && this || {}, n = {}, o = (a, s) => {
    const i = e && jm(n, s) || s;
    bs(n[i]) && bs(a) ? n[i] = rl(n[i], a) : bs(a) ? n[i] = rl({}, a) : ea(a) ? n[i] = a.slice() : (!t || !Zo(a)) && (n[i] = a);
  };
  for (let a = 0, s = arguments.length; a < s; a++)
    arguments[a] && La(arguments[a], o);
  return n;
}
const u1 = (e, t, n, { allOwnKeys: o } = {}) => (La(t, (a, s) => {
  n && Zt(a) ? e[s] = Em(a, n) : e[s] = a;
}, { allOwnKeys: o }), e), d1 = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), m1 = (e, t, n, o) => {
  e.prototype = Object.create(t.prototype, o), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, p1 = (e, t, n, o) => {
  let a, s, i;
  const r = {};
  if (t = t || {}, e == null) return t;
  do {
    for (a = Object.getOwnPropertyNames(e), s = a.length; s-- > 0; )
      i = a[s], (!o || o(i, e, t)) && !r[i] && (t[i] = e[i], r[i] = !0);
    e = n !== !1 && jl(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, f1 = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const o = e.indexOf(t, n);
  return o !== -1 && o === n;
}, h1 = (e) => {
  if (!e) return null;
  if (ea(e)) return e;
  let t = e.length;
  if (!Lm(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, _1 = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && jl(Uint8Array)), v1 = (e, t) => {
  const o = (e && e[ei]).call(e);
  let a;
  for (; (a = o.next()) && !a.done; ) {
    const s = a.value;
    t.call(e, s[0], s[1]);
  }
}, g1 = (e, t) => {
  let n;
  const o = [];
  for (; (n = e.exec(t)) !== null; )
    o.push(n);
  return o;
}, y1 = Sn("HTMLFormElement"), k1 = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, o, a) {
    return o.toUpperCase() + a;
  }
), Nu = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), b1 = Sn("RegExp"), Nm = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), o = {};
  La(n, (a, s) => {
    let i;
    (i = t(a, s, e)) !== !1 && (o[s] = i || a);
  }), Object.defineProperties(e, o);
}, w1 = (e) => {
  Nm(e, (t, n) => {
    if (Zt(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const o = e[n];
    if (Zt(o)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, x1 = (e, t) => {
  const n = {}, o = (a) => {
    a.forEach((s) => {
      n[s] = !0;
    });
  };
  return ea(e) ? o(e) : o(String(e).split(t)), n;
}, $1 = () => {
}, z1 = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function S1(e) {
  return !!(e && Zt(e.append) && e[Om] === "FormData" && e[ei]);
}
const C1 = (e) => {
  const t = new Array(10), n = (o, a) => {
    if (Ra(o)) {
      if (t.indexOf(o) >= 0)
        return;
      if (Oa(o))
        return o;
      if (!("toJSON" in o)) {
        t[a] = o;
        const s = ea(o) ? [] : {};
        return La(o, (i, r) => {
          const c = n(i, a + 1);
          !Zo(c) && (s[r] = c);
        }), t[a] = void 0, s;
      }
    }
    return o;
  };
  return n(e, 0);
}, A1 = Sn("AsyncFunction"), P1 = (e) => e && (Ra(e) || Zt(e)) && Zt(e.then) && Zt(e.catch), Vm = ((e, t) => e ? setImmediate : t ? ((n, o) => (_o.addEventListener("message", ({ source: a, data: s }) => {
  a === _o && s === n && o.length && o.shift()();
}, !1), (a) => {
  o.push(a), _o.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  Zt(_o.postMessage)
), T1 = typeof queueMicrotask < "u" ? queueMicrotask.bind(_o) : typeof process < "u" && process.nextTick || Vm, M1 = (e) => e != null && Zt(e[ei]), Z = {
  isArray: ea,
  isArrayBuffer: Rm,
  isBuffer: Oa,
  isFormData: o1,
  isArrayBufferView: Zg,
  isString: Kg,
  isNumber: Lm,
  isBoolean: Qg,
  isObject: Ra,
  isPlainObject: bs,
  isEmptyObject: Xg,
  isReadableStream: s1,
  isRequest: i1,
  isResponse: r1,
  isHeaders: l1,
  isUndefined: Zo,
  isDate: Jg,
  isFile: Yg,
  isBlob: e1,
  isRegExp: b1,
  isFunction: Zt,
  isStream: n1,
  isURLSearchParams: a1,
  isTypedArray: _1,
  isFileList: t1,
  forEach: La,
  merge: rl,
  extend: u1,
  trim: c1,
  stripBOM: d1,
  inherits: m1,
  toFlatObject: p1,
  kindOf: ti,
  kindOfTest: Sn,
  endsWith: f1,
  toArray: h1,
  forEachEntry: v1,
  matchAll: g1,
  isHTMLForm: y1,
  hasOwnProperty: Nu,
  hasOwnProp: Nu,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Nm,
  freezeMethods: w1,
  toObjectSet: x1,
  toCamelCase: k1,
  noop: $1,
  toFiniteNumber: z1,
  findKey: jm,
  global: _o,
  isContextDefined: Dm,
  isSpecCompliantForm: S1,
  toJSONObject: C1,
  isAsyncFn: A1,
  isThenable: P1,
  setImmediate: Vm,
  asap: T1,
  isIterable: M1
};
function Le(e, t, n, o, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), o && (this.request = o), a && (this.response = a, this.status = a.status ? a.status : null);
}
Z.inherits(Le, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: Z.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Um = Le.prototype, Fm = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Fm[e] = { value: e };
});
Object.defineProperties(Le, Fm);
Object.defineProperty(Um, "isAxiosError", { value: !0 });
Le.from = (e, t, n, o, a, s) => {
  const i = Object.create(Um);
  Z.toFlatObject(e, i, function(d) {
    return d !== Error.prototype;
  }, (u) => u !== "isAxiosError");
  const r = e && e.message ? e.message : "Error", c = t == null && e ? e.code : t;
  return Le.call(i, r, c, n, o, a), e && i.cause == null && Object.defineProperty(i, "cause", { value: e, configurable: !0 }), i.name = e && e.name || "Error", s && Object.assign(i, s), i;
};
const I1 = null;
function ll(e) {
  return Z.isPlainObject(e) || Z.isArray(e);
}
function qm(e) {
  return Z.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Vu(e, t, n) {
  return e ? e.concat(t).map(function(a, s) {
    return a = qm(a), !n && s ? "[" + a + "]" : a;
  }).join(n ? "." : "") : t;
}
function E1(e) {
  return Z.isArray(e) && !e.some(ll);
}
const O1 = Z.toFlatObject(Z, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function oi(e, t, n) {
  if (!Z.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = Z.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(w, f) {
    return !Z.isUndefined(f[w]);
  });
  const o = n.metaTokens, a = n.visitor || d, s = n.dots, i = n.indexes, c = (n.Blob || typeof Blob < "u" && Blob) && Z.isSpecCompliantForm(t);
  if (!Z.isFunction(a))
    throw new TypeError("visitor must be a function");
  function u(k) {
    if (k === null) return "";
    if (Z.isDate(k))
      return k.toISOString();
    if (Z.isBoolean(k))
      return k.toString();
    if (!c && Z.isBlob(k))
      throw new Le("Blob is not supported. Use a Buffer instead.");
    return Z.isArrayBuffer(k) || Z.isTypedArray(k) ? c && typeof Blob == "function" ? new Blob([k]) : Buffer.from(k) : k;
  }
  function d(k, w, f) {
    let g = k;
    if (k && !f && typeof k == "object") {
      if (Z.endsWith(w, "{}"))
        w = o ? w : w.slice(0, -2), k = JSON.stringify(k);
      else if (Z.isArray(k) && E1(k) || (Z.isFileList(k) || Z.endsWith(w, "[]")) && (g = Z.toArray(k)))
        return w = qm(w), g.forEach(function(A, P) {
          !(Z.isUndefined(A) || A === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? Vu([w], P, s) : i === null ? w : w + "[]",
            u(A)
          );
        }), !1;
    }
    return ll(k) ? !0 : (t.append(Vu(f, w, s), u(k)), !1);
  }
  const p = [], _ = Object.assign(O1, {
    defaultVisitor: d,
    convertValue: u,
    isVisitable: ll
  });
  function y(k, w) {
    if (!Z.isUndefined(k)) {
      if (p.indexOf(k) !== -1)
        throw Error("Circular reference detected in " + w.join("."));
      p.push(k), Z.forEach(k, function(g, b) {
        (!(Z.isUndefined(g) || g === null) && a.call(
          t,
          g,
          Z.isString(b) ? b.trim() : b,
          w,
          _
        )) === !0 && y(g, w ? w.concat(b) : [b]);
      }), p.pop();
    }
  }
  if (!Z.isObject(e))
    throw new TypeError("data must be an object");
  return y(e), t;
}
function Uu(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(o) {
    return t[o];
  });
}
function Dl(e, t) {
  this._pairs = [], e && oi(e, this, t);
}
const Bm = Dl.prototype;
Bm.append = function(t, n) {
  this._pairs.push([t, n]);
};
Bm.toString = function(t) {
  const n = t ? function(o) {
    return t.call(this, o, Uu);
  } : Uu;
  return this._pairs.map(function(a) {
    return n(a[0]) + "=" + n(a[1]);
  }, "").join("&");
};
function R1(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Hm(e, t, n) {
  if (!t)
    return e;
  const o = n && n.encode || R1;
  Z.isFunction(n) && (n = {
    serialize: n
  });
  const a = n && n.serialize;
  let s;
  if (a ? s = a(t, n) : s = Z.isURLSearchParams(t) ? t.toString() : new Dl(t, n).toString(o), s) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class Fu {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, o) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: o ? o.synchronous : !1,
      runWhen: o ? o.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    Z.forEach(this.handlers, function(o) {
      o !== null && t(o);
    });
  }
}
const Gm = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, L1 = typeof URLSearchParams < "u" ? URLSearchParams : Dl, j1 = typeof FormData < "u" ? FormData : null, D1 = typeof Blob < "u" ? Blob : null, N1 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: L1,
    FormData: j1,
    Blob: D1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Nl = typeof window < "u" && typeof document < "u", cl = typeof navigator == "object" && navigator || void 0, V1 = Nl && (!cl || ["ReactNative", "NativeScript", "NS"].indexOf(cl.product) < 0), U1 = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", F1 = Nl && window.location.href || "http://localhost", q1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Nl,
  hasStandardBrowserEnv: V1,
  hasStandardBrowserWebWorkerEnv: U1,
  navigator: cl,
  origin: F1
}, Symbol.toStringTag, { value: "Module" })), Dt = {
  ...q1,
  ...N1
};
function B1(e, t) {
  return oi(e, new Dt.classes.URLSearchParams(), {
    visitor: function(n, o, a, s) {
      return Dt.isNode && Z.isBuffer(n) ? (this.append(o, n.toString("base64")), !1) : s.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function H1(e) {
  return Z.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function G1(e) {
  const t = {}, n = Object.keys(e);
  let o;
  const a = n.length;
  let s;
  for (o = 0; o < a; o++)
    s = n[o], t[s] = e[s];
  return t;
}
function Wm(e) {
  function t(n, o, a, s) {
    let i = n[s++];
    if (i === "__proto__") return !0;
    const r = Number.isFinite(+i), c = s >= n.length;
    return i = !i && Z.isArray(a) ? a.length : i, c ? (Z.hasOwnProp(a, i) ? a[i] = [a[i], o] : a[i] = o, !r) : ((!a[i] || !Z.isObject(a[i])) && (a[i] = []), t(n, o, a[i], s) && Z.isArray(a[i]) && (a[i] = G1(a[i])), !r);
  }
  if (Z.isFormData(e) && Z.isFunction(e.entries)) {
    const n = {};
    return Z.forEachEntry(e, (o, a) => {
      t(H1(o), a, n, 0);
    }), n;
  }
  return null;
}
function W1(e, t, n) {
  if (Z.isString(e))
    try {
      return (t || JSON.parse)(e), Z.trim(e);
    } catch (o) {
      if (o.name !== "SyntaxError")
        throw o;
    }
  return (n || JSON.stringify)(e);
}
const ja = {
  transitional: Gm,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const o = n.getContentType() || "", a = o.indexOf("application/json") > -1, s = Z.isObject(t);
    if (s && Z.isHTMLForm(t) && (t = new FormData(t)), Z.isFormData(t))
      return a ? JSON.stringify(Wm(t)) : t;
    if (Z.isArrayBuffer(t) || Z.isBuffer(t) || Z.isStream(t) || Z.isFile(t) || Z.isBlob(t) || Z.isReadableStream(t))
      return t;
    if (Z.isArrayBufferView(t))
      return t.buffer;
    if (Z.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let r;
    if (s) {
      if (o.indexOf("application/x-www-form-urlencoded") > -1)
        return B1(t, this.formSerializer).toString();
      if ((r = Z.isFileList(t)) || o.indexOf("multipart/form-data") > -1) {
        const c = this.env && this.env.FormData;
        return oi(
          r ? { "files[]": t } : t,
          c && new c(),
          this.formSerializer
        );
      }
    }
    return s || a ? (n.setContentType("application/json", !1), W1(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || ja.transitional, o = n && n.forcedJSONParsing, a = this.responseType === "json";
    if (Z.isResponse(t) || Z.isReadableStream(t))
      return t;
    if (t && Z.isString(t) && (o && !this.responseType || a)) {
      const i = !(n && n.silentJSONParsing) && a;
      try {
        return JSON.parse(t, this.parseReviver);
      } catch (r) {
        if (i)
          throw r.name === "SyntaxError" ? Le.from(r, Le.ERR_BAD_RESPONSE, this, null, this.response) : r;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Dt.classes.FormData,
    Blob: Dt.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
Z.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  ja.headers[e] = {};
});
const Z1 = Z.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), K1 = (e) => {
  const t = {};
  let n, o, a;
  return e && e.split(`
`).forEach(function(i) {
    a = i.indexOf(":"), n = i.substring(0, a).trim().toLowerCase(), o = i.substring(a + 1).trim(), !(!n || t[n] && Z1[n]) && (n === "set-cookie" ? t[n] ? t[n].push(o) : t[n] = [o] : t[n] = t[n] ? t[n] + ", " + o : o);
  }), t;
}, qu = Symbol("internals");
function va(e) {
  return e && String(e).trim().toLowerCase();
}
function ws(e) {
  return e === !1 || e == null ? e : Z.isArray(e) ? e.map(ws) : String(e);
}
function Q1(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let o;
  for (; o = n.exec(e); )
    t[o[1]] = o[2];
  return t;
}
const X1 = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Pr(e, t, n, o, a) {
  if (Z.isFunction(o))
    return o.call(this, t, n);
  if (a && (t = n), !!Z.isString(t)) {
    if (Z.isString(o))
      return t.indexOf(o) !== -1;
    if (Z.isRegExp(o))
      return o.test(t);
  }
}
function J1(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, o) => n.toUpperCase() + o);
}
function Y1(e, t) {
  const n = Z.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((o) => {
    Object.defineProperty(e, o + n, {
      value: function(a, s, i) {
        return this[o].call(this, t, a, s, i);
      },
      configurable: !0
    });
  });
}
let Kt = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, o) {
    const a = this;
    function s(r, c, u) {
      const d = va(c);
      if (!d)
        throw new Error("header name must be a non-empty string");
      const p = Z.findKey(a, d);
      (!p || a[p] === void 0 || u === !0 || u === void 0 && a[p] !== !1) && (a[p || c] = ws(r));
    }
    const i = (r, c) => Z.forEach(r, (u, d) => s(u, d, c));
    if (Z.isPlainObject(t) || t instanceof this.constructor)
      i(t, n);
    else if (Z.isString(t) && (t = t.trim()) && !X1(t))
      i(K1(t), n);
    else if (Z.isObject(t) && Z.isIterable(t)) {
      let r = {}, c, u;
      for (const d of t) {
        if (!Z.isArray(d))
          throw TypeError("Object iterator must return a key-value pair");
        r[u = d[0]] = (c = r[u]) ? Z.isArray(c) ? [...c, d[1]] : [c, d[1]] : d[1];
      }
      i(r, n);
    } else
      t != null && s(n, t, o);
    return this;
  }
  get(t, n) {
    if (t = va(t), t) {
      const o = Z.findKey(this, t);
      if (o) {
        const a = this[o];
        if (!n)
          return a;
        if (n === !0)
          return Q1(a);
        if (Z.isFunction(n))
          return n.call(this, a, o);
        if (Z.isRegExp(n))
          return n.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = va(t), t) {
      const o = Z.findKey(this, t);
      return !!(o && this[o] !== void 0 && (!n || Pr(this, this[o], o, n)));
    }
    return !1;
  }
  delete(t, n) {
    const o = this;
    let a = !1;
    function s(i) {
      if (i = va(i), i) {
        const r = Z.findKey(o, i);
        r && (!n || Pr(o, o[r], r, n)) && (delete o[r], a = !0);
      }
    }
    return Z.isArray(t) ? t.forEach(s) : s(t), a;
  }
  clear(t) {
    const n = Object.keys(this);
    let o = n.length, a = !1;
    for (; o--; ) {
      const s = n[o];
      (!t || Pr(this, this[s], s, t, !0)) && (delete this[s], a = !0);
    }
    return a;
  }
  normalize(t) {
    const n = this, o = {};
    return Z.forEach(this, (a, s) => {
      const i = Z.findKey(o, s);
      if (i) {
        n[i] = ws(a), delete n[s];
        return;
      }
      const r = t ? J1(s) : String(s).trim();
      r !== s && delete n[s], n[r] = ws(a), o[r] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return Z.forEach(this, (o, a) => {
      o != null && o !== !1 && (n[a] = t && Z.isArray(o) ? o.join(", ") : o);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const o = new this(t);
    return n.forEach((a) => o.set(a)), o;
  }
  static accessor(t) {
    const o = (this[qu] = this[qu] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function s(i) {
      const r = va(i);
      o[r] || (Y1(a, i), o[r] = !0);
    }
    return Z.isArray(t) ? t.forEach(s) : s(t), this;
  }
};
Kt.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
Z.reduceDescriptors(Kt.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(o) {
      this[n] = o;
    }
  };
});
Z.freezeMethods(Kt);
function Tr(e, t) {
  const n = this || ja, o = t || n, a = Kt.from(o.headers);
  let s = o.data;
  return Z.forEach(e, function(r) {
    s = r.call(n, s, a.normalize(), t ? t.status : void 0);
  }), a.normalize(), s;
}
function Zm(e) {
  return !!(e && e.__CANCEL__);
}
function ta(e, t, n) {
  Le.call(this, e ?? "canceled", Le.ERR_CANCELED, t, n), this.name = "CanceledError";
}
Z.inherits(ta, Le, {
  __CANCEL__: !0
});
function Km(e, t, n) {
  const o = n.config.validateStatus;
  !n.status || !o || o(n.status) ? e(n) : t(new Le(
    "Request failed with status code " + n.status,
    [Le.ERR_BAD_REQUEST, Le.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function e0(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function t0(e, t) {
  e = e || 10;
  const n = new Array(e), o = new Array(e);
  let a = 0, s = 0, i;
  return t = t !== void 0 ? t : 1e3, function(c) {
    const u = Date.now(), d = o[s];
    i || (i = u), n[a] = c, o[a] = u;
    let p = s, _ = 0;
    for (; p !== a; )
      _ += n[p++], p = p % e;
    if (a = (a + 1) % e, a === s && (s = (s + 1) % e), u - i < t)
      return;
    const y = d && u - d;
    return y ? Math.round(_ * 1e3 / y) : void 0;
  };
}
function n0(e, t) {
  let n = 0, o = 1e3 / t, a, s;
  const i = (u, d = Date.now()) => {
    n = d, a = null, s && (clearTimeout(s), s = null), e(...u);
  };
  return [(...u) => {
    const d = Date.now(), p = d - n;
    p >= o ? i(u, d) : (a = u, s || (s = setTimeout(() => {
      s = null, i(a);
    }, o - p)));
  }, () => a && i(a)];
}
const Vs = (e, t, n = 3) => {
  let o = 0;
  const a = t0(50, 250);
  return n0((s) => {
    const i = s.loaded, r = s.lengthComputable ? s.total : void 0, c = i - o, u = a(c), d = i <= r;
    o = i;
    const p = {
      loaded: i,
      total: r,
      progress: r ? i / r : void 0,
      bytes: c,
      rate: u || void 0,
      estimated: u && r && d ? (r - i) / u : void 0,
      event: s,
      lengthComputable: r != null,
      [t ? "download" : "upload"]: !0
    };
    e(p);
  }, n);
}, Bu = (e, t) => {
  const n = e != null;
  return [(o) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: o
  }), t[1]];
}, Hu = (e) => (...t) => Z.asap(() => e(...t)), o0 = Dt.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, Dt.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(Dt.origin),
  Dt.navigator && /(msie|trident)/i.test(Dt.navigator.userAgent)
) : () => !0, a0 = Dt.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, o, a, s, i) {
      if (typeof document > "u") return;
      const r = [`${e}=${encodeURIComponent(t)}`];
      Z.isNumber(n) && r.push(`expires=${new Date(n).toUTCString()}`), Z.isString(o) && r.push(`path=${o}`), Z.isString(a) && r.push(`domain=${a}`), s === !0 && r.push("secure"), Z.isString(i) && r.push(`SameSite=${i}`), document.cookie = r.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const t = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
      return t ? decodeURIComponent(t[1]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function s0(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function i0(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Qm(e, t, n) {
  let o = !s0(t);
  return e && (o || n == !1) ? i0(e, t) : t;
}
const Gu = (e) => e instanceof Kt ? { ...e } : e;
function Po(e, t) {
  t = t || {};
  const n = {};
  function o(u, d, p, _) {
    return Z.isPlainObject(u) && Z.isPlainObject(d) ? Z.merge.call({ caseless: _ }, u, d) : Z.isPlainObject(d) ? Z.merge({}, d) : Z.isArray(d) ? d.slice() : d;
  }
  function a(u, d, p, _) {
    if (Z.isUndefined(d)) {
      if (!Z.isUndefined(u))
        return o(void 0, u, p, _);
    } else return o(u, d, p, _);
  }
  function s(u, d) {
    if (!Z.isUndefined(d))
      return o(void 0, d);
  }
  function i(u, d) {
    if (Z.isUndefined(d)) {
      if (!Z.isUndefined(u))
        return o(void 0, u);
    } else return o(void 0, d);
  }
  function r(u, d, p) {
    if (p in t)
      return o(u, d);
    if (p in e)
      return o(void 0, u);
  }
  const c = {
    url: s,
    method: s,
    data: s,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: r,
    headers: (u, d, p) => a(Gu(u), Gu(d), p, !0)
  };
  return Z.forEach(Object.keys({ ...e, ...t }), function(d) {
    const p = c[d] || a, _ = p(e[d], t[d], d);
    Z.isUndefined(_) && p !== r || (n[d] = _);
  }), n;
}
const Xm = (e) => {
  const t = Po({}, e);
  let { data: n, withXSRFToken: o, xsrfHeaderName: a, xsrfCookieName: s, headers: i, auth: r } = t;
  if (t.headers = i = Kt.from(i), t.url = Hm(Qm(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), r && i.set(
    "Authorization",
    "Basic " + btoa((r.username || "") + ":" + (r.password ? unescape(encodeURIComponent(r.password)) : ""))
  ), Z.isFormData(n)) {
    if (Dt.hasStandardBrowserEnv || Dt.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if (Z.isFunction(n.getHeaders)) {
      const c = n.getHeaders(), u = ["content-type", "content-length"];
      Object.entries(c).forEach(([d, p]) => {
        u.includes(d.toLowerCase()) && i.set(d, p);
      });
    }
  }
  if (Dt.hasStandardBrowserEnv && (o && Z.isFunction(o) && (o = o(t)), o || o !== !1 && o0(t.url))) {
    const c = a && s && a0.read(s);
    c && i.set(a, c);
  }
  return t;
}, r0 = typeof XMLHttpRequest < "u", l0 = r0 && function(e) {
  return new Promise(function(n, o) {
    const a = Xm(e);
    let s = a.data;
    const i = Kt.from(a.headers).normalize();
    let { responseType: r, onUploadProgress: c, onDownloadProgress: u } = a, d, p, _, y, k;
    function w() {
      y && y(), k && k(), a.cancelToken && a.cancelToken.unsubscribe(d), a.signal && a.signal.removeEventListener("abort", d);
    }
    let f = new XMLHttpRequest();
    f.open(a.method.toUpperCase(), a.url, !0), f.timeout = a.timeout;
    function g() {
      if (!f)
        return;
      const A = Kt.from(
        "getAllResponseHeaders" in f && f.getAllResponseHeaders()
      ), I = {
        data: !r || r === "text" || r === "json" ? f.responseText : f.response,
        status: f.status,
        statusText: f.statusText,
        headers: A,
        config: e,
        request: f
      };
      Km(function(R) {
        n(R), w();
      }, function(R) {
        o(R), w();
      }, I), f = null;
    }
    "onloadend" in f ? f.onloadend = g : f.onreadystatechange = function() {
      !f || f.readyState !== 4 || f.status === 0 && !(f.responseURL && f.responseURL.indexOf("file:") === 0) || setTimeout(g);
    }, f.onabort = function() {
      f && (o(new Le("Request aborted", Le.ECONNABORTED, e, f)), f = null);
    }, f.onerror = function(P) {
      const I = P && P.message ? P.message : "Network Error", D = new Le(I, Le.ERR_NETWORK, e, f);
      D.event = P || null, o(D), f = null;
    }, f.ontimeout = function() {
      let P = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const I = a.transitional || Gm;
      a.timeoutErrorMessage && (P = a.timeoutErrorMessage), o(new Le(
        P,
        I.clarifyTimeoutError ? Le.ETIMEDOUT : Le.ECONNABORTED,
        e,
        f
      )), f = null;
    }, s === void 0 && i.setContentType(null), "setRequestHeader" in f && Z.forEach(i.toJSON(), function(P, I) {
      f.setRequestHeader(I, P);
    }), Z.isUndefined(a.withCredentials) || (f.withCredentials = !!a.withCredentials), r && r !== "json" && (f.responseType = a.responseType), u && ([_, k] = Vs(u, !0), f.addEventListener("progress", _)), c && f.upload && ([p, y] = Vs(c), f.upload.addEventListener("progress", p), f.upload.addEventListener("loadend", y)), (a.cancelToken || a.signal) && (d = (A) => {
      f && (o(!A || A.type ? new ta(null, e, f) : A), f.abort(), f = null);
    }, a.cancelToken && a.cancelToken.subscribe(d), a.signal && (a.signal.aborted ? d() : a.signal.addEventListener("abort", d)));
    const b = e0(a.url);
    if (b && Dt.protocols.indexOf(b) === -1) {
      o(new Le("Unsupported protocol " + b + ":", Le.ERR_BAD_REQUEST, e));
      return;
    }
    f.send(s || null);
  });
}, c0 = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let o = new AbortController(), a;
    const s = function(u) {
      if (!a) {
        a = !0, r();
        const d = u instanceof Error ? u : this.reason;
        o.abort(d instanceof Le ? d : new ta(d instanceof Error ? d.message : d));
      }
    };
    let i = t && setTimeout(() => {
      i = null, s(new Le(`timeout ${t} of ms exceeded`, Le.ETIMEDOUT));
    }, t);
    const r = () => {
      e && (i && clearTimeout(i), i = null, e.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(s) : u.removeEventListener("abort", s);
      }), e = null);
    };
    e.forEach((u) => u.addEventListener("abort", s));
    const { signal: c } = o;
    return c.unsubscribe = () => Z.asap(r), c;
  }
}, u0 = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let o = 0, a;
  for (; o < n; )
    a = o + t, yield e.slice(o, a), o = a;
}, d0 = async function* (e, t) {
  for await (const n of m0(e))
    yield* u0(n, t);
}, m0 = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: o } = await t.read();
      if (n)
        break;
      yield o;
    }
  } finally {
    await t.cancel();
  }
}, Wu = (e, t, n, o) => {
  const a = d0(e, t);
  let s = 0, i, r = (c) => {
    i || (i = !0, o && o(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: u, value: d } = await a.next();
        if (u) {
          r(), c.close();
          return;
        }
        let p = d.byteLength;
        if (n) {
          let _ = s += p;
          n(_);
        }
        c.enqueue(new Uint8Array(d));
      } catch (u) {
        throw r(u), u;
      }
    },
    cancel(c) {
      return r(c), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, Zu = 64 * 1024, { isFunction: us } = Z, p0 = (({ Request: e, Response: t }) => ({
  Request: e,
  Response: t
}))(Z.global), {
  ReadableStream: Ku,
  TextEncoder: Qu
} = Z.global, Xu = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, f0 = (e) => {
  e = Z.merge.call({
    skipUndefined: !0
  }, p0, e);
  const { fetch: t, Request: n, Response: o } = e, a = t ? us(t) : typeof fetch == "function", s = us(n), i = us(o);
  if (!a)
    return !1;
  const r = a && us(Ku), c = a && (typeof Qu == "function" ? /* @__PURE__ */ ((k) => (w) => k.encode(w))(new Qu()) : async (k) => new Uint8Array(await new n(k).arrayBuffer())), u = s && r && Xu(() => {
    let k = !1;
    const w = new n(Dt.origin, {
      body: new Ku(),
      method: "POST",
      get duplex() {
        return k = !0, "half";
      }
    }).headers.has("Content-Type");
    return k && !w;
  }), d = i && r && Xu(() => Z.isReadableStream(new o("").body)), p = {
    stream: d && ((k) => k.body)
  };
  a && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((k) => {
    !p[k] && (p[k] = (w, f) => {
      let g = w && w[k];
      if (g)
        return g.call(w);
      throw new Le(`Response type '${k}' is not supported`, Le.ERR_NOT_SUPPORT, f);
    });
  });
  const _ = async (k) => {
    if (k == null)
      return 0;
    if (Z.isBlob(k))
      return k.size;
    if (Z.isSpecCompliantForm(k))
      return (await new n(Dt.origin, {
        method: "POST",
        body: k
      }).arrayBuffer()).byteLength;
    if (Z.isArrayBufferView(k) || Z.isArrayBuffer(k))
      return k.byteLength;
    if (Z.isURLSearchParams(k) && (k = k + ""), Z.isString(k))
      return (await c(k)).byteLength;
  }, y = async (k, w) => {
    const f = Z.toFiniteNumber(k.getContentLength());
    return f ?? _(w);
  };
  return async (k) => {
    let {
      url: w,
      method: f,
      data: g,
      signal: b,
      cancelToken: A,
      timeout: P,
      onDownloadProgress: I,
      onUploadProgress: D,
      responseType: R,
      headers: U,
      withCredentials: G = "same-origin",
      fetchOptions: F
    } = Xm(k), de = t || fetch;
    R = R ? (R + "").toLowerCase() : "text";
    let K = c0([b, A && A.toAbortSignal()], P), ce = null;
    const ue = K && K.unsubscribe && (() => {
      K.unsubscribe();
    });
    let Ae;
    try {
      if (D && u && f !== "get" && f !== "head" && (Ae = await y(U, g)) !== 0) {
        let ve = new n(w, {
          method: "POST",
          body: g,
          duplex: "half"
        }), ze;
        if (Z.isFormData(g) && (ze = ve.headers.get("content-type")) && U.setContentType(ze), ve.body) {
          const [ot, Ie] = Bu(
            Ae,
            Vs(Hu(D))
          );
          g = Wu(ve.body, Zu, ot, Ie);
        }
      }
      Z.isString(G) || (G = G ? "include" : "omit");
      const te = s && "credentials" in n.prototype, X = {
        ...F,
        signal: K,
        method: f.toUpperCase(),
        headers: U.normalize().toJSON(),
        body: g,
        duplex: "half",
        credentials: te ? G : void 0
      };
      ce = s && new n(w, X);
      let ee = await (s ? de(ce, F) : de(w, X));
      const ie = d && (R === "stream" || R === "response");
      if (d && (I || ie && ue)) {
        const ve = {};
        ["status", "statusText", "headers"].forEach((ae) => {
          ve[ae] = ee[ae];
        });
        const ze = Z.toFiniteNumber(ee.headers.get("content-length")), [ot, Ie] = I && Bu(
          ze,
          Vs(Hu(I), !0)
        ) || [];
        ee = new o(
          Wu(ee.body, Zu, ot, () => {
            Ie && Ie(), ue && ue();
          }),
          ve
        );
      }
      R = R || "text";
      let he = await p[Z.findKey(p, R) || "text"](ee, k);
      return !ie && ue && ue(), await new Promise((ve, ze) => {
        Km(ve, ze, {
          data: he,
          headers: Kt.from(ee.headers),
          status: ee.status,
          statusText: ee.statusText,
          config: k,
          request: ce
        });
      });
    } catch (te) {
      throw ue && ue(), te && te.name === "TypeError" && /Load failed|fetch/i.test(te.message) ? Object.assign(
        new Le("Network Error", Le.ERR_NETWORK, k, ce),
        {
          cause: te.cause || te
        }
      ) : Le.from(te, te && te.code, k, ce);
    }
  };
}, h0 = /* @__PURE__ */ new Map(), Jm = (e) => {
  let t = e && e.env || {};
  const { fetch: n, Request: o, Response: a } = t, s = [
    o,
    a,
    n
  ];
  let i = s.length, r = i, c, u, d = h0;
  for (; r--; )
    c = s[r], u = d.get(c), u === void 0 && d.set(c, u = r ? /* @__PURE__ */ new Map() : f0(t)), d = u;
  return u;
};
Jm();
const Vl = {
  http: I1,
  xhr: l0,
  fetch: {
    get: Jm
  }
};
Z.forEach(Vl, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Ju = (e) => `- ${e}`, _0 = (e) => Z.isFunction(e) || e === null || e === !1;
function v0(e, t) {
  e = Z.isArray(e) ? e : [e];
  const { length: n } = e;
  let o, a;
  const s = {};
  for (let i = 0; i < n; i++) {
    o = e[i];
    let r;
    if (a = o, !_0(o) && (a = Vl[(r = String(o)).toLowerCase()], a === void 0))
      throw new Le(`Unknown adapter '${r}'`);
    if (a && (Z.isFunction(a) || (a = a.get(t))))
      break;
    s[r || "#" + i] = a;
  }
  if (!a) {
    const i = Object.entries(s).map(
      ([c, u]) => `adapter ${c} ` + (u === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let r = n ? i.length > 1 ? `since :
` + i.map(Ju).join(`
`) : " " + Ju(i[0]) : "as no adapter specified";
    throw new Le(
      "There is no suitable adapter to dispatch the request " + r,
      "ERR_NOT_SUPPORT"
    );
  }
  return a;
}
const Ym = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: v0,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: Vl
};
function Mr(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new ta(null, e);
}
function Yu(e) {
  return Mr(e), e.headers = Kt.from(e.headers), e.data = Tr.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Ym.getAdapter(e.adapter || ja.adapter, e)(e).then(function(o) {
    return Mr(e), o.data = Tr.call(
      e,
      e.transformResponse,
      o
    ), o.headers = Kt.from(o.headers), o;
  }, function(o) {
    return Zm(o) || (Mr(e), o && o.response && (o.response.data = Tr.call(
      e,
      e.transformResponse,
      o.response
    ), o.response.headers = Kt.from(o.response.headers))), Promise.reject(o);
  });
}
const ep = "1.13.2", ai = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  ai[e] = function(o) {
    return typeof o === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const ed = {};
ai.transitional = function(t, n, o) {
  function a(s, i) {
    return "[Axios v" + ep + "] Transitional option '" + s + "'" + i + (o ? ". " + o : "");
  }
  return (s, i, r) => {
    if (t === !1)
      throw new Le(
        a(i, " has been removed" + (n ? " in " + n : "")),
        Le.ERR_DEPRECATED
      );
    return n && !ed[i] && (ed[i] = !0, console.warn(
      a(
        i,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(s, i, r) : !0;
  };
};
ai.spelling = function(t) {
  return (n, o) => (console.warn(`${o} is likely a misspelling of ${t}`), !0);
};
function g0(e, t, n) {
  if (typeof e != "object")
    throw new Le("options must be an object", Le.ERR_BAD_OPTION_VALUE);
  const o = Object.keys(e);
  let a = o.length;
  for (; a-- > 0; ) {
    const s = o[a], i = t[s];
    if (i) {
      const r = e[s], c = r === void 0 || i(r, s, e);
      if (c !== !0)
        throw new Le("option " + s + " must be " + c, Le.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new Le("Unknown option " + s, Le.ERR_BAD_OPTION);
  }
}
const xs = {
  assertOptions: g0,
  validators: ai
}, Pn = xs.validators;
let ko = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new Fu(),
      response: new Fu()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (o) {
      if (o instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const s = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          o.stack ? s && !String(o.stack).endsWith(s.replace(/^.+\n.+\n/, "")) && (o.stack += `
` + s) : o.stack = s;
        } catch {
        }
      }
      throw o;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = Po(this.defaults, n);
    const { transitional: o, paramsSerializer: a, headers: s } = n;
    o !== void 0 && xs.assertOptions(o, {
      silentJSONParsing: Pn.transitional(Pn.boolean),
      forcedJSONParsing: Pn.transitional(Pn.boolean),
      clarifyTimeoutError: Pn.transitional(Pn.boolean)
    }, !1), a != null && (Z.isFunction(a) ? n.paramsSerializer = {
      serialize: a
    } : xs.assertOptions(a, {
      encode: Pn.function,
      serialize: Pn.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), xs.assertOptions(n, {
      baseUrl: Pn.spelling("baseURL"),
      withXsrfToken: Pn.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let i = s && Z.merge(
      s.common,
      s[n.method]
    );
    s && Z.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (k) => {
        delete s[k];
      }
    ), n.headers = Kt.concat(i, s);
    const r = [];
    let c = !0;
    this.interceptors.request.forEach(function(w) {
      typeof w.runWhen == "function" && w.runWhen(n) === !1 || (c = c && w.synchronous, r.unshift(w.fulfilled, w.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(w) {
      u.push(w.fulfilled, w.rejected);
    });
    let d, p = 0, _;
    if (!c) {
      const k = [Yu.bind(this), void 0];
      for (k.unshift(...r), k.push(...u), _ = k.length, d = Promise.resolve(n); p < _; )
        d = d.then(k[p++], k[p++]);
      return d;
    }
    _ = r.length;
    let y = n;
    for (; p < _; ) {
      const k = r[p++], w = r[p++];
      try {
        y = k(y);
      } catch (f) {
        w.call(this, f);
        break;
      }
    }
    try {
      d = Yu.call(this, y);
    } catch (k) {
      return Promise.reject(k);
    }
    for (p = 0, _ = u.length; p < _; )
      d = d.then(u[p++], u[p++]);
    return d;
  }
  getUri(t) {
    t = Po(this.defaults, t);
    const n = Qm(t.baseURL, t.url, t.allowAbsoluteUrls);
    return Hm(n, t.params, t.paramsSerializer);
  }
};
Z.forEach(["delete", "get", "head", "options"], function(t) {
  ko.prototype[t] = function(n, o) {
    return this.request(Po(o || {}, {
      method: t,
      url: n,
      data: (o || {}).data
    }));
  };
});
Z.forEach(["post", "put", "patch"], function(t) {
  function n(o) {
    return function(s, i, r) {
      return this.request(Po(r || {}, {
        method: t,
        headers: o ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: i
      }));
    };
  }
  ko.prototype[t] = n(), ko.prototype[t + "Form"] = n(!0);
});
let y0 = class tp {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(s) {
      n = s;
    });
    const o = this;
    this.promise.then((a) => {
      if (!o._listeners) return;
      let s = o._listeners.length;
      for (; s-- > 0; )
        o._listeners[s](a);
      o._listeners = null;
    }), this.promise.then = (a) => {
      let s;
      const i = new Promise((r) => {
        o.subscribe(r), s = r;
      }).then(a);
      return i.cancel = function() {
        o.unsubscribe(s);
      }, i;
    }, t(function(s, i, r) {
      o.reason || (o.reason = new ta(s, i, r), n(o.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (o) => {
      t.abort(o);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new tp(function(a) {
        t = a;
      }),
      cancel: t
    };
  }
};
function k0(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function b0(e) {
  return Z.isObject(e) && e.isAxiosError === !0;
}
const ul = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(ul).forEach(([e, t]) => {
  ul[t] = e;
});
function np(e) {
  const t = new ko(e), n = Em(ko.prototype.request, t);
  return Z.extend(n, ko.prototype, t, { allOwnKeys: !0 }), Z.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(a) {
    return np(Po(e, a));
  }, n;
}
const gt = np(ja);
gt.Axios = ko;
gt.CanceledError = ta;
gt.CancelToken = y0;
gt.isCancel = Zm;
gt.VERSION = ep;
gt.toFormData = oi;
gt.AxiosError = Le;
gt.Cancel = gt.CanceledError;
gt.all = function(t) {
  return Promise.all(t);
};
gt.spread = k0;
gt.isAxiosError = b0;
gt.mergeConfig = Po;
gt.AxiosHeaders = Kt;
gt.formToJSON = (e) => Wm(Z.isHTMLForm(e) ? new FormData(e) : e);
gt.getAdapter = Ym.getAdapter;
gt.HttpStatusCode = ul;
gt.default = gt;
const {
  Axios: Pre,
  AxiosError: Tre,
  CanceledError: Mre,
  isCancel: Ire,
  CancelToken: Ere,
  VERSION: Ore,
  all: Rre,
  Cancel: Lre,
  isAxiosError: jre,
  spread: Dre,
  toFormData: Nre,
  AxiosHeaders: Vre,
  HttpStatusCode: Ure,
  formToJSON: Fre,
  getAdapter: qre,
  mergeConfig: Bre
} = gt;
var Ir = { exports: {} };
/*!
 * Pusher JavaScript Library v8.4.0
 * https://pusher.com/
 *
 * Copyright 2020, Pusher
 * Released under the MIT licence.
 */
var td;
function w0() {
  return td || (td = 1, (function(e, t) {
    (function(o, a) {
      e.exports = a();
    })(window, function() {
      return (
        /******/
        (function(n) {
          var o = {};
          function a(s) {
            if (o[s])
              return o[s].exports;
            var i = o[s] = {
              /******/
              i: s,
              /******/
              l: !1,
              /******/
              exports: {}
              /******/
            };
            return n[s].call(i.exports, i, i.exports, a), i.l = !0, i.exports;
          }
          return a.m = n, a.c = o, a.d = function(s, i, r) {
            a.o(s, i) || Object.defineProperty(s, i, { enumerable: !0, get: r });
          }, a.r = function(s) {
            typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
          }, a.t = function(s, i) {
            if (i & 1 && (s = a(s)), i & 8 || i & 4 && typeof s == "object" && s && s.__esModule) return s;
            var r = /* @__PURE__ */ Object.create(null);
            if (a.r(r), Object.defineProperty(r, "default", { enumerable: !0, value: s }), i & 2 && typeof s != "string") for (var c in s) a.d(r, c, (function(u) {
              return s[u];
            }).bind(null, c));
            return r;
          }, a.n = function(s) {
            var i = s && s.__esModule ? (
              /******/
              function() {
                return s.default;
              }
            ) : (
              /******/
              function() {
                return s;
              }
            );
            return a.d(i, "a", i), i;
          }, a.o = function(s, i) {
            return Object.prototype.hasOwnProperty.call(s, i);
          }, a.p = "", a(a.s = 2);
        })([
          /* 0 */
          /***/
          (function(n, o, a) {
            var s = this && this.__extends || /* @__PURE__ */ (function() {
              var w = function(f, g) {
                return w = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(b, A) {
                  b.__proto__ = A;
                } || function(b, A) {
                  for (var P in A) A.hasOwnProperty(P) && (b[P] = A[P]);
                }, w(f, g);
              };
              return function(f, g) {
                w(f, g);
                function b() {
                  this.constructor = f;
                }
                f.prototype = g === null ? Object.create(g) : (b.prototype = g.prototype, new b());
              };
            })();
            Object.defineProperty(o, "__esModule", { value: !0 });
            var i = 256, r = (
              /** @class */
              (function() {
                function w(f) {
                  f === void 0 && (f = "="), this._paddingCharacter = f;
                }
                return w.prototype.encodedLength = function(f) {
                  return this._paddingCharacter ? (f + 2) / 3 * 4 | 0 : (f * 8 + 5) / 6 | 0;
                }, w.prototype.encode = function(f) {
                  for (var g = "", b = 0; b < f.length - 2; b += 3) {
                    var A = f[b] << 16 | f[b + 1] << 8 | f[b + 2];
                    g += this._encodeByte(A >>> 18 & 63), g += this._encodeByte(A >>> 12 & 63), g += this._encodeByte(A >>> 6 & 63), g += this._encodeByte(A >>> 0 & 63);
                  }
                  var P = f.length - b;
                  if (P > 0) {
                    var A = f[b] << 16 | (P === 2 ? f[b + 1] << 8 : 0);
                    g += this._encodeByte(A >>> 18 & 63), g += this._encodeByte(A >>> 12 & 63), P === 2 ? g += this._encodeByte(A >>> 6 & 63) : g += this._paddingCharacter || "", g += this._paddingCharacter || "";
                  }
                  return g;
                }, w.prototype.maxDecodedLength = function(f) {
                  return this._paddingCharacter ? f / 4 * 3 | 0 : (f * 6 + 7) / 8 | 0;
                }, w.prototype.decodedLength = function(f) {
                  return this.maxDecodedLength(f.length - this._getPaddingLength(f));
                }, w.prototype.decode = function(f) {
                  if (f.length === 0)
                    return new Uint8Array(0);
                  for (var g = this._getPaddingLength(f), b = f.length - g, A = new Uint8Array(this.maxDecodedLength(b)), P = 0, I = 0, D = 0, R = 0, U = 0, G = 0, F = 0; I < b - 4; I += 4)
                    R = this._decodeChar(f.charCodeAt(I + 0)), U = this._decodeChar(f.charCodeAt(I + 1)), G = this._decodeChar(f.charCodeAt(I + 2)), F = this._decodeChar(f.charCodeAt(I + 3)), A[P++] = R << 2 | U >>> 4, A[P++] = U << 4 | G >>> 2, A[P++] = G << 6 | F, D |= R & i, D |= U & i, D |= G & i, D |= F & i;
                  if (I < b - 1 && (R = this._decodeChar(f.charCodeAt(I)), U = this._decodeChar(f.charCodeAt(I + 1)), A[P++] = R << 2 | U >>> 4, D |= R & i, D |= U & i), I < b - 2 && (G = this._decodeChar(f.charCodeAt(I + 2)), A[P++] = U << 4 | G >>> 2, D |= G & i), I < b - 3 && (F = this._decodeChar(f.charCodeAt(I + 3)), A[P++] = G << 6 | F, D |= F & i), D !== 0)
                    throw new Error("Base64Coder: incorrect characters for decoding");
                  return A;
                }, w.prototype._encodeByte = function(f) {
                  var g = f;
                  return g += 65, g += 25 - f >>> 8 & 6, g += 51 - f >>> 8 & -75, g += 61 - f >>> 8 & -15, g += 62 - f >>> 8 & 3, String.fromCharCode(g);
                }, w.prototype._decodeChar = function(f) {
                  var g = i;
                  return g += (42 - f & f - 44) >>> 8 & -i + f - 43 + 62, g += (46 - f & f - 48) >>> 8 & -i + f - 47 + 63, g += (47 - f & f - 58) >>> 8 & -i + f - 48 + 52, g += (64 - f & f - 91) >>> 8 & -i + f - 65 + 0, g += (96 - f & f - 123) >>> 8 & -i + f - 97 + 26, g;
                }, w.prototype._getPaddingLength = function(f) {
                  var g = 0;
                  if (this._paddingCharacter) {
                    for (var b = f.length - 1; b >= 0 && f[b] === this._paddingCharacter; b--)
                      g++;
                    if (f.length < 4 || g > 2)
                      throw new Error("Base64Coder: incorrect padding");
                  }
                  return g;
                }, w;
              })()
            );
            o.Coder = r;
            var c = new r();
            function u(w) {
              return c.encode(w);
            }
            o.encode = u;
            function d(w) {
              return c.decode(w);
            }
            o.decode = d;
            var p = (
              /** @class */
              (function(w) {
                s(f, w);
                function f() {
                  return w !== null && w.apply(this, arguments) || this;
                }
                return f.prototype._encodeByte = function(g) {
                  var b = g;
                  return b += 65, b += 25 - g >>> 8 & 6, b += 51 - g >>> 8 & -75, b += 61 - g >>> 8 & -13, b += 62 - g >>> 8 & 49, String.fromCharCode(b);
                }, f.prototype._decodeChar = function(g) {
                  var b = i;
                  return b += (44 - g & g - 46) >>> 8 & -i + g - 45 + 62, b += (94 - g & g - 96) >>> 8 & -i + g - 95 + 63, b += (47 - g & g - 58) >>> 8 & -i + g - 48 + 52, b += (64 - g & g - 91) >>> 8 & -i + g - 65 + 0, b += (96 - g & g - 123) >>> 8 & -i + g - 97 + 26, b;
                }, f;
              })(r)
            );
            o.URLSafeCoder = p;
            var _ = new p();
            function y(w) {
              return _.encode(w);
            }
            o.encodeURLSafe = y;
            function k(w) {
              return _.decode(w);
            }
            o.decodeURLSafe = k, o.encodedLength = function(w) {
              return c.encodedLength(w);
            }, o.maxDecodedLength = function(w) {
              return c.maxDecodedLength(w);
            }, o.decodedLength = function(w) {
              return c.decodedLength(w);
            };
          }),
          /* 1 */
          /***/
          (function(n, o, a) {
            Object.defineProperty(o, "__esModule", { value: !0 });
            var s = "utf8: invalid string", i = "utf8: invalid source encoding";
            function r(d) {
              for (var p = new Uint8Array(c(d)), _ = 0, y = 0; y < d.length; y++) {
                var k = d.charCodeAt(y);
                k < 128 ? p[_++] = k : k < 2048 ? (p[_++] = 192 | k >> 6, p[_++] = 128 | k & 63) : k < 55296 ? (p[_++] = 224 | k >> 12, p[_++] = 128 | k >> 6 & 63, p[_++] = 128 | k & 63) : (y++, k = (k & 1023) << 10, k |= d.charCodeAt(y) & 1023, k += 65536, p[_++] = 240 | k >> 18, p[_++] = 128 | k >> 12 & 63, p[_++] = 128 | k >> 6 & 63, p[_++] = 128 | k & 63);
              }
              return p;
            }
            o.encode = r;
            function c(d) {
              for (var p = 0, _ = 0; _ < d.length; _++) {
                var y = d.charCodeAt(_);
                if (y < 128)
                  p += 1;
                else if (y < 2048)
                  p += 2;
                else if (y < 55296)
                  p += 3;
                else if (y <= 57343) {
                  if (_ >= d.length - 1)
                    throw new Error(s);
                  _++, p += 4;
                } else
                  throw new Error(s);
              }
              return p;
            }
            o.encodedLength = c;
            function u(d) {
              for (var p = [], _ = 0; _ < d.length; _++) {
                var y = d[_];
                if (y & 128) {
                  var k = void 0;
                  if (y < 224) {
                    if (_ >= d.length)
                      throw new Error(i);
                    var w = d[++_];
                    if ((w & 192) !== 128)
                      throw new Error(i);
                    y = (y & 31) << 6 | w & 63, k = 128;
                  } else if (y < 240) {
                    if (_ >= d.length - 1)
                      throw new Error(i);
                    var w = d[++_], f = d[++_];
                    if ((w & 192) !== 128 || (f & 192) !== 128)
                      throw new Error(i);
                    y = (y & 15) << 12 | (w & 63) << 6 | f & 63, k = 2048;
                  } else if (y < 248) {
                    if (_ >= d.length - 2)
                      throw new Error(i);
                    var w = d[++_], f = d[++_], g = d[++_];
                    if ((w & 192) !== 128 || (f & 192) !== 128 || (g & 192) !== 128)
                      throw new Error(i);
                    y = (y & 15) << 18 | (w & 63) << 12 | (f & 63) << 6 | g & 63, k = 65536;
                  } else
                    throw new Error(i);
                  if (y < k || y >= 55296 && y <= 57343)
                    throw new Error(i);
                  if (y >= 65536) {
                    if (y > 1114111)
                      throw new Error(i);
                    y -= 65536, p.push(String.fromCharCode(55296 | y >> 10)), y = 56320 | y & 1023;
                  }
                }
                p.push(String.fromCharCode(y));
              }
              return p.join("");
            }
            o.decode = u;
          }),
          /* 2 */
          /***/
          (function(n, o, a) {
            n.exports = a(3).default;
          }),
          /* 3 */
          /***/
          (function(n, o, a) {
            a.r(o);
            class s {
              constructor(m, h) {
                this.lastId = 0, this.prefix = m, this.name = h;
              }
              create(m) {
                this.lastId++;
                var h = this.lastId, C = this.prefix + h, T = this.name + "[" + h + "]", Y = !1, le = function() {
                  Y || (m.apply(null, arguments), Y = !0);
                };
                return this[h] = le, { number: h, id: C, name: T, callback: le };
              }
              remove(m) {
                delete this[m.number];
              }
            }
            var i = new s("_pusher_script_", "Pusher.ScriptReceivers"), r = {
              VERSION: "8.4.0",
              PROTOCOL: 7,
              wsPort: 80,
              wssPort: 443,
              wsPath: "",
              httpHost: "sockjs.pusher.com",
              httpPort: 80,
              httpsPort: 443,
              httpPath: "/pusher",
              stats_host: "stats.pusher.com",
              authEndpoint: "/pusher/auth",
              authTransport: "ajax",
              activityTimeout: 12e4,
              pongTimeout: 3e4,
              unavailableTimeout: 1e4,
              userAuthentication: {
                endpoint: "/pusher/user-auth",
                transport: "ajax"
              },
              channelAuthorization: {
                endpoint: "/pusher/auth",
                transport: "ajax"
              },
              cdn_http: "http://js.pusher.com",
              cdn_https: "https://js.pusher.com",
              dependency_suffix: ""
            }, c = r;
            class u {
              constructor(m) {
                this.options = m, this.receivers = m.receivers || i, this.loading = {};
              }
              load(m, h, C) {
                var T = this;
                if (T.loading[m] && T.loading[m].length > 0)
                  T.loading[m].push(C);
                else {
                  T.loading[m] = [C];
                  var Y = Re.createScriptRequest(T.getPath(m, h)), le = T.receivers.create(function(ke) {
                    if (T.receivers.remove(le), T.loading[m]) {
                      var Oe = T.loading[m];
                      delete T.loading[m];
                      for (var Ze = function(wt) {
                        wt || Y.cleanup();
                      }, Ye = 0; Ye < Oe.length; Ye++)
                        Oe[Ye](ke, Ze);
                    }
                  });
                  Y.send(le);
                }
              }
              getRoot(m) {
                var h, C = Re.getDocument().location.protocol;
                return m && m.useTLS || C === "https:" ? h = this.options.cdn_https : h = this.options.cdn_http, h.replace(/\/*$/, "") + "/" + this.options.version;
              }
              getPath(m, h) {
                return this.getRoot(h) + "/" + m + this.options.suffix + ".js";
              }
            }
            var d = new s("_pusher_dependencies", "Pusher.DependenciesReceivers"), p = new u({
              cdn_http: c.cdn_http,
              cdn_https: c.cdn_https,
              version: c.VERSION,
              suffix: c.dependency_suffix,
              receivers: d
            });
            const _ = {
              baseUrl: "https://pusher.com",
              urls: {
                authenticationEndpoint: {
                  path: "/docs/channels/server_api/authenticating_users"
                },
                authorizationEndpoint: {
                  path: "/docs/channels/server_api/authorizing-users/"
                },
                javascriptQuickStart: {
                  path: "/docs/javascript_quick_start"
                },
                triggeringClientEvents: {
                  path: "/docs/client_api_guide/client_events#trigger-events"
                },
                encryptedChannelSupport: {
                  fullUrl: "https://github.com/pusher/pusher-js/tree/cc491015371a4bde5743d1c87a0fbac0feb53195#encrypted-channel-support"
                }
              }
            };
            var k = { buildLogSuffix: function(v) {
              const m = "See:", h = _.urls[v];
              if (!h)
                return "";
              let C;
              return h.fullUrl ? C = h.fullUrl : h.path && (C = _.baseUrl + h.path), C ? `${m} ${C}` : "";
            } }, w;
            (function(v) {
              v.UserAuthentication = "user-authentication", v.ChannelAuthorization = "channel-authorization";
            })(w || (w = {}));
            class f extends Error {
              constructor(m) {
                super(m), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class g extends Error {
              constructor(m) {
                super(m), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class b extends Error {
              constructor(m) {
                super(m), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class A extends Error {
              constructor(m) {
                super(m), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class P extends Error {
              constructor(m) {
                super(m), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class I extends Error {
              constructor(m) {
                super(m), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class D extends Error {
              constructor(m) {
                super(m), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class R extends Error {
              constructor(m) {
                super(m), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class U extends Error {
              constructor(m, h) {
                super(h), this.status = m, Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            var F = function(v, m, h, C, T) {
              const Y = Re.createXHR();
              Y.open("POST", h.endpoint, !0), Y.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
              for (var le in h.headers)
                Y.setRequestHeader(le, h.headers[le]);
              if (h.headersProvider != null) {
                let ke = h.headersProvider();
                for (var le in ke)
                  Y.setRequestHeader(le, ke[le]);
              }
              return Y.onreadystatechange = function() {
                if (Y.readyState === 4)
                  if (Y.status === 200) {
                    let ke, Oe = !1;
                    try {
                      ke = JSON.parse(Y.responseText), Oe = !0;
                    } catch {
                      T(new U(200, `JSON returned from ${C.toString()} endpoint was invalid, yet status code was 200. Data was: ${Y.responseText}`), null);
                    }
                    Oe && T(null, ke);
                  } else {
                    let ke = "";
                    switch (C) {
                      case w.UserAuthentication:
                        ke = k.buildLogSuffix("authenticationEndpoint");
                        break;
                      case w.ChannelAuthorization:
                        ke = `Clients must be authorized to join private or presence channels. ${k.buildLogSuffix("authorizationEndpoint")}`;
                        break;
                    }
                    T(new U(Y.status, `Unable to retrieve auth string from ${C.toString()} endpoint - received status: ${Y.status} from ${h.endpoint}. ${ke}`), null);
                  }
              }, Y.send(m), Y;
            };
            function de(v) {
              return X(Ae(v));
            }
            var K = String.fromCharCode, ce = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ue = function(v) {
              var m = v.charCodeAt(0);
              return m < 128 ? v : m < 2048 ? K(192 | m >>> 6) + K(128 | m & 63) : K(224 | m >>> 12 & 15) + K(128 | m >>> 6 & 63) + K(128 | m & 63);
            }, Ae = function(v) {
              return v.replace(/[^\x00-\x7F]/g, ue);
            }, te = function(v) {
              var m = [0, 2, 1][v.length % 3], h = v.charCodeAt(0) << 16 | (v.length > 1 ? v.charCodeAt(1) : 0) << 8 | (v.length > 2 ? v.charCodeAt(2) : 0), C = [
                ce.charAt(h >>> 18),
                ce.charAt(h >>> 12 & 63),
                m >= 2 ? "=" : ce.charAt(h >>> 6 & 63),
                m >= 1 ? "=" : ce.charAt(h & 63)
              ];
              return C.join("");
            }, X = window.btoa || function(v) {
              return v.replace(/[\s\S]{1,3}/g, te);
            };
            class ee {
              constructor(m, h, C, T) {
                this.clear = h, this.timer = m(() => {
                  this.timer && (this.timer = T(this.timer));
                }, C);
              }
              isRunning() {
                return this.timer !== null;
              }
              ensureAborted() {
                this.timer && (this.clear(this.timer), this.timer = null);
              }
            }
            var ie = ee;
            function he(v) {
              window.clearTimeout(v);
            }
            function ve(v) {
              window.clearInterval(v);
            }
            class ze extends ie {
              constructor(m, h) {
                super(setTimeout, he, m, function(C) {
                  return h(), null;
                });
              }
            }
            class ot extends ie {
              constructor(m, h) {
                super(setInterval, ve, m, function(C) {
                  return h(), C;
                });
              }
            }
            var Ie = {
              now() {
                return Date.now ? Date.now() : (/* @__PURE__ */ new Date()).valueOf();
              },
              defer(v) {
                return new ze(0, v);
              },
              method(v, ...m) {
                var h = Array.prototype.slice.call(arguments, 1);
                return function(C) {
                  return C[v].apply(C, h.concat(arguments));
                };
              }
            }, ae = Ie;
            function _e(v, ...m) {
              for (var h = 0; h < m.length; h++) {
                var C = m[h];
                for (var T in C)
                  C[T] && C[T].constructor && C[T].constructor === Object ? v[T] = _e(v[T] || {}, C[T]) : v[T] = C[T];
              }
              return v;
            }
            function _t() {
              for (var v = ["Pusher"], m = 0; m < arguments.length; m++)
                typeof arguments[m] == "string" ? v.push(arguments[m]) : v.push(yn(arguments[m]));
              return v.join(" : ");
            }
            function St(v, m) {
              var h = Array.prototype.indexOf;
              if (v === null)
                return -1;
              if (h && v.indexOf === h)
                return v.indexOf(m);
              for (var C = 0, T = v.length; C < T; C++)
                if (v[C] === m)
                  return C;
              return -1;
            }
            function et(v, m) {
              for (var h in v)
                Object.prototype.hasOwnProperty.call(v, h) && m(v[h], h, v);
            }
            function Ne(v) {
              var m = [];
              return et(v, function(h, C) {
                m.push(C);
              }), m;
            }
            function xe(v) {
              var m = [];
              return et(v, function(h) {
                m.push(h);
              }), m;
            }
            function Fe(v, m, h) {
              for (var C = 0; C < v.length; C++)
                m.call(h || window, v[C], C, v);
            }
            function Ke(v, m) {
              for (var h = [], C = 0; C < v.length; C++)
                h.push(m(v[C], C, v, h));
              return h;
            }
            function at(v, m) {
              var h = {};
              return et(v, function(C, T) {
                h[T] = m(C);
              }), h;
            }
            function mt(v, m) {
              m = m || function(T) {
                return !!T;
              };
              for (var h = [], C = 0; C < v.length; C++)
                m(v[C], C, v, h) && h.push(v[C]);
              return h;
            }
            function Ht(v, m) {
              var h = {};
              return et(v, function(C, T) {
                (m && m(C, T, v, h) || C) && (h[T] = C);
              }), h;
            }
            function it(v) {
              var m = [];
              return et(v, function(h, C) {
                m.push([C, h]);
              }), m;
            }
            function Rt(v, m) {
              for (var h = 0; h < v.length; h++)
                if (m(v[h], h, v))
                  return !0;
              return !1;
            }
            function io(v, m) {
              for (var h = 0; h < v.length; h++)
                if (!m(v[h], h, v))
                  return !1;
              return !0;
            }
            function Rn(v) {
              return at(v, function(m) {
                return typeof m == "object" && (m = yn(m)), encodeURIComponent(de(m.toString()));
              });
            }
            function Ln(v) {
              var m = Ht(v, function(C) {
                return C !== void 0;
              }), h = Ke(it(Rn(m)), ae.method("join", "=")).join("&");
              return h;
            }
            function en(v) {
              var m = [], h = [];
              return (function C(T, Y) {
                var le, ke, Oe;
                switch (typeof T) {
                  case "object":
                    if (!T)
                      return null;
                    for (le = 0; le < m.length; le += 1)
                      if (m[le] === T)
                        return { $ref: h[le] };
                    if (m.push(T), h.push(Y), Object.prototype.toString.apply(T) === "[object Array]")
                      for (Oe = [], le = 0; le < T.length; le += 1)
                        Oe[le] = C(T[le], Y + "[" + le + "]");
                    else {
                      Oe = {};
                      for (ke in T)
                        Object.prototype.hasOwnProperty.call(T, ke) && (Oe[ke] = C(T[ke], Y + "[" + JSON.stringify(ke) + "]"));
                    }
                    return Oe;
                  case "number":
                  case "string":
                  case "boolean":
                    return T;
                }
              })(v, "$");
            }
            function yn(v) {
              try {
                return JSON.stringify(v);
              } catch {
                return JSON.stringify(en(v));
              }
            }
            class Wn {
              constructor() {
                this.globalLog = (m) => {
                  window.console && window.console.log && window.console.log(m);
                };
              }
              debug(...m) {
                this.log(this.globalLog, m);
              }
              warn(...m) {
                this.log(this.globalLogWarn, m);
              }
              error(...m) {
                this.log(this.globalLogError, m);
              }
              globalLogWarn(m) {
                window.console && window.console.warn ? window.console.warn(m) : this.globalLog(m);
              }
              globalLogError(m) {
                window.console && window.console.error ? window.console.error(m) : this.globalLogWarn(m);
              }
              log(m, ...h) {
                var C = _t.apply(this, arguments);
                Si.log ? Si.log(C) : Si.logToConsole && m.bind(this)(C);
              }
            }
            var Xe = new Wn(), _i = function(v, m, h, C, T) {
              (h.headers !== void 0 || h.headersProvider != null) && Xe.warn(`To send headers with the ${C.toString()} request, you must use AJAX, rather than JSONP.`);
              var Y = v.nextAuthCallbackID.toString();
              v.nextAuthCallbackID++;
              var le = v.getDocument(), ke = le.createElement("script");
              v.auth_callbacks[Y] = function(Ye) {
                T(null, Ye);
              };
              var Oe = "Pusher.auth_callbacks['" + Y + "']";
              ke.src = h.endpoint + "?callback=" + encodeURIComponent(Oe) + "&" + m;
              var Ze = le.getElementsByTagName("head")[0] || le.documentElement;
              Ze.insertBefore(ke, Ze.firstChild);
            }, Xa = _i;
            class vi {
              constructor(m) {
                this.src = m;
              }
              send(m) {
                var h = this, C = "Error loading " + h.src;
                h.script = document.createElement("script"), h.script.id = m.id, h.script.src = h.src, h.script.type = "text/javascript", h.script.charset = "UTF-8", h.script.addEventListener ? (h.script.onerror = function() {
                  m.callback(C);
                }, h.script.onload = function() {
                  m.callback(null);
                }) : h.script.onreadystatechange = function() {
                  (h.script.readyState === "loaded" || h.script.readyState === "complete") && m.callback(null);
                }, h.script.async === void 0 && document.attachEvent && /opera/i.test(navigator.userAgent) ? (h.errorScript = document.createElement("script"), h.errorScript.id = m.id + "_error", h.errorScript.text = m.name + "('" + C + "');", h.script.async = h.errorScript.async = !1) : h.script.async = !0;
                var T = document.getElementsByTagName("head")[0];
                T.insertBefore(h.script, T.firstChild), h.errorScript && T.insertBefore(h.errorScript, h.script.nextSibling);
              }
              cleanup() {
                this.script && (this.script.onload = this.script.onerror = null, this.script.onreadystatechange = null), this.script && this.script.parentNode && this.script.parentNode.removeChild(this.script), this.errorScript && this.errorScript.parentNode && this.errorScript.parentNode.removeChild(this.errorScript), this.script = null, this.errorScript = null;
              }
            }
            class ro {
              constructor(m, h) {
                this.url = m, this.data = h;
              }
              send(m) {
                if (!this.request) {
                  var h = Ln(this.data), C = this.url + "/" + m.number + "?" + h;
                  this.request = Re.createScriptRequest(C), this.request.send(m);
                }
              }
              cleanup() {
                this.request && this.request.cleanup();
              }
            }
            var la = function(v, m) {
              return function(h, C) {
                var T = "http" + (m ? "s" : "") + "://", Y = T + (v.host || v.options.host) + v.options.path, le = Re.createJSONPRequest(Y, h), ke = Re.ScriptReceivers.create(function(Oe, Ze) {
                  i.remove(ke), le.cleanup(), Ze && Ze.host && (v.host = Ze.host), C && C(Oe, Ze);
                });
                le.send(ke);
              };
            }, Ja = {
              name: "jsonp",
              getAgent: la
            }, gi = Ja;
            function ca(v, m, h) {
              var C = v + (m.useTLS ? "s" : ""), T = m.useTLS ? m.hostTLS : m.hostNonTLS;
              return C + "://" + T + h;
            }
            function lo(v, m) {
              var h = "/app/" + v, C = "?protocol=" + c.PROTOCOL + "&client=js&version=" + c.VERSION + (m ? "&" + m : "");
              return h + C;
            }
            var jo = {
              getInitial: function(v, m) {
                var h = (m.httpPath || "") + lo(v, "flash=false");
                return ca("ws", m, h);
              }
            }, q = {
              getInitial: function(v, m) {
                var h = (m.httpPath || "/pusher") + lo(v);
                return ca("http", m, h);
              }
            }, W = {
              getInitial: function(v, m) {
                return ca("http", m, m.httpPath || "/pusher");
              },
              getPath: function(v, m) {
                return lo(v);
              }
            };
            class Ge {
              constructor() {
                this._callbacks = {};
              }
              get(m) {
                return this._callbacks[Je(m)];
              }
              add(m, h, C) {
                var T = Je(m);
                this._callbacks[T] = this._callbacks[T] || [], this._callbacks[T].push({
                  fn: h,
                  context: C
                });
              }
              remove(m, h, C) {
                if (!m && !h && !C) {
                  this._callbacks = {};
                  return;
                }
                var T = m ? [Je(m)] : Ne(this._callbacks);
                h || C ? this.removeCallback(T, h, C) : this.removeAllCallbacks(T);
              }
              removeCallback(m, h, C) {
                Fe(m, function(T) {
                  this._callbacks[T] = mt(this._callbacks[T] || [], function(Y) {
                    return h && h !== Y.fn || C && C !== Y.context;
                  }), this._callbacks[T].length === 0 && delete this._callbacks[T];
                }, this);
              }
              removeAllCallbacks(m) {
                Fe(m, function(h) {
                  delete this._callbacks[h];
                }, this);
              }
            }
            function Je(v) {
              return "_" + v;
            }
            class qe {
              constructor(m) {
                this.callbacks = new Ge(), this.global_callbacks = [], this.failThrough = m;
              }
              bind(m, h, C) {
                return this.callbacks.add(m, h, C), this;
              }
              bind_global(m) {
                return this.global_callbacks.push(m), this;
              }
              unbind(m, h, C) {
                return this.callbacks.remove(m, h, C), this;
              }
              unbind_global(m) {
                return m ? (this.global_callbacks = mt(this.global_callbacks || [], (h) => h !== m), this) : (this.global_callbacks = [], this);
              }
              unbind_all() {
                return this.unbind(), this.unbind_global(), this;
              }
              emit(m, h, C) {
                for (var T = 0; T < this.global_callbacks.length; T++)
                  this.global_callbacks[T](m, h);
                var Y = this.callbacks.get(m), le = [];
                if (C ? le.push(h, C) : h && le.push(h), Y && Y.length > 0)
                  for (var T = 0; T < Y.length; T++)
                    Y[T].fn.apply(Y[T].context || window, le);
                else this.failThrough && this.failThrough(m, h);
                return this;
              }
            }
            class je extends qe {
              constructor(m, h, C, T, Y) {
                super(), this.initialize = Re.transportConnectionInitializer, this.hooks = m, this.name = h, this.priority = C, this.key = T, this.options = Y, this.state = "new", this.timeline = Y.timeline, this.activityTimeout = Y.activityTimeout, this.id = this.timeline.generateUniqueID();
              }
              handlesActivityChecks() {
                return !!this.hooks.handlesActivityChecks;
              }
              supportsPing() {
                return !!this.hooks.supportsPing;
              }
              connect() {
                if (this.socket || this.state !== "initialized")
                  return !1;
                var m = this.hooks.urls.getInitial(this.key, this.options);
                try {
                  this.socket = this.hooks.getSocket(m, this.options);
                } catch (h) {
                  return ae.defer(() => {
                    this.onError(h), this.changeState("closed");
                  }), !1;
                }
                return this.bindListeners(), Xe.debug("Connecting", { transport: this.name, url: m }), this.changeState("connecting"), !0;
              }
              close() {
                return this.socket ? (this.socket.close(), !0) : !1;
              }
              send(m) {
                return this.state === "open" ? (ae.defer(() => {
                  this.socket && this.socket.send(m);
                }), !0) : !1;
              }
              ping() {
                this.state === "open" && this.supportsPing() && this.socket.ping();
              }
              onOpen() {
                this.hooks.beforeOpen && this.hooks.beforeOpen(this.socket, this.hooks.urls.getPath(this.key, this.options)), this.changeState("open"), this.socket.onopen = void 0;
              }
              onError(m) {
                this.emit("error", { type: "WebSocketError", error: m }), this.timeline.error(this.buildTimelineMessage({ error: m.toString() }));
              }
              onClose(m) {
                m ? this.changeState("closed", {
                  code: m.code,
                  reason: m.reason,
                  wasClean: m.wasClean
                }) : this.changeState("closed"), this.unbindListeners(), this.socket = void 0;
              }
              onMessage(m) {
                this.emit("message", m);
              }
              onActivity() {
                this.emit("activity");
              }
              bindListeners() {
                this.socket.onopen = () => {
                  this.onOpen();
                }, this.socket.onerror = (m) => {
                  this.onError(m);
                }, this.socket.onclose = (m) => {
                  this.onClose(m);
                }, this.socket.onmessage = (m) => {
                  this.onMessage(m);
                }, this.supportsPing() && (this.socket.onactivity = () => {
                  this.onActivity();
                });
              }
              unbindListeners() {
                this.socket && (this.socket.onopen = void 0, this.socket.onerror = void 0, this.socket.onclose = void 0, this.socket.onmessage = void 0, this.supportsPing() && (this.socket.onactivity = void 0));
              }
              changeState(m, h) {
                this.state = m, this.timeline.info(this.buildTimelineMessage({
                  state: m,
                  params: h
                })), this.emit(m, h);
              }
              buildTimelineMessage(m) {
                return _e({ cid: this.id }, m);
              }
            }
            class Ut {
              constructor(m) {
                this.hooks = m;
              }
              isSupported(m) {
                return this.hooks.isSupported(m);
              }
              createConnection(m, h, C, T) {
                return new je(this.hooks, m, h, C, T);
              }
            }
            var jn = new Ut({
              urls: jo,
              handlesActivityChecks: !1,
              supportsPing: !1,
              isInitialized: function() {
                return !!Re.getWebSocketAPI();
              },
              isSupported: function() {
                return !!Re.getWebSocketAPI();
              },
              getSocket: function(v) {
                return Re.createWebSocket(v);
              }
            }), Lt = {
              urls: q,
              handlesActivityChecks: !1,
              supportsPing: !0,
              isInitialized: function() {
                return !0;
              }
            }, kn = _e({
              getSocket: function(v) {
                return Re.HTTPFactory.createStreamingSocket(v);
              }
            }, Lt), Do = _e({
              getSocket: function(v) {
                return Re.HTTPFactory.createPollingSocket(v);
              }
            }, Lt), Dn = {
              isSupported: function() {
                return Re.isXHRSupported();
              }
            }, tn = new Ut(_e({}, kn, Dn)), Ya = new Ut(_e({}, Do, Dn)), es = {
              ws: jn,
              xhr_streaming: tn,
              xhr_polling: Ya
            }, co = es, uo = new Ut({
              file: "sockjs",
              urls: W,
              handlesActivityChecks: !0,
              supportsPing: !1,
              isSupported: function() {
                return !0;
              },
              isInitialized: function() {
                return window.SockJS !== void 0;
              },
              getSocket: function(v, m) {
                return new window.SockJS(v, null, {
                  js_path: p.getPath("sockjs", {
                    useTLS: m.useTLS
                  }),
                  ignore_null_origin: m.ignoreNullOrigin
                });
              },
              beforeOpen: function(v, m) {
                v.send(JSON.stringify({
                  path: m
                }));
              }
            }), No = {
              isSupported: function(v) {
                var m = Re.isXDRSupported(v.useTLS);
                return m;
              }
            }, Vo = new Ut(_e({}, kn, No)), ua = new Ut(_e({}, Do, No));
            co.xdr_streaming = Vo, co.xdr_polling = ua, co.sockjs = uo;
            var da = co;
            class ts extends qe {
              constructor() {
                super();
                var m = this;
                window.addEventListener !== void 0 && (window.addEventListener("online", function() {
                  m.emit("online");
                }, !1), window.addEventListener("offline", function() {
                  m.emit("offline");
                }, !1));
              }
              isOnline() {
                return window.navigator.onLine === void 0 ? !0 : window.navigator.onLine;
              }
            }
            var ns = new ts();
            class ma {
              constructor(m, h, C) {
                this.manager = m, this.transport = h, this.minPingDelay = C.minPingDelay, this.maxPingDelay = C.maxPingDelay, this.pingDelay = void 0;
              }
              createConnection(m, h, C, T) {
                T = _e({}, T, {
                  activityTimeout: this.pingDelay
                });
                var Y = this.transport.createConnection(m, h, C, T), le = null, ke = function() {
                  Y.unbind("open", ke), Y.bind("closed", Oe), le = ae.now();
                }, Oe = (Ze) => {
                  if (Y.unbind("closed", Oe), Ze.code === 1002 || Ze.code === 1003)
                    this.manager.reportDeath();
                  else if (!Ze.wasClean && le) {
                    var Ye = ae.now() - le;
                    Ye < 2 * this.maxPingDelay && (this.manager.reportDeath(), this.pingDelay = Math.max(Ye / 2, this.minPingDelay));
                  }
                };
                return Y.bind("open", ke), Y;
              }
              isSupported(m) {
                return this.manager.isAlive() && this.transport.isSupported(m);
              }
            }
            const pa = {
              decodeMessage: function(v) {
                try {
                  var m = JSON.parse(v.data), h = m.data;
                  if (typeof h == "string")
                    try {
                      h = JSON.parse(m.data);
                    } catch {
                    }
                  var C = {
                    event: m.event,
                    channel: m.channel,
                    data: h
                  };
                  return m.user_id && (C.user_id = m.user_id), C;
                } catch (T) {
                  throw { type: "MessageParseError", error: T, data: v.data };
                }
              },
              encodeMessage: function(v) {
                return JSON.stringify(v);
              },
              processHandshake: function(v) {
                var m = pa.decodeMessage(v);
                if (m.event === "pusher:connection_established") {
                  if (!m.data.activity_timeout)
                    throw "No activity timeout specified in handshake";
                  return {
                    action: "connected",
                    id: m.data.socket_id,
                    activityTimeout: m.data.activity_timeout * 1e3
                  };
                } else {
                  if (m.event === "pusher:error")
                    return {
                      action: this.getCloseAction(m.data),
                      error: this.getCloseError(m.data)
                    };
                  throw "Invalid handshake";
                }
              },
              getCloseAction: function(v) {
                return v.code < 4e3 ? v.code >= 1002 && v.code <= 1004 ? "backoff" : null : v.code === 4e3 ? "tls_only" : v.code < 4100 ? "refused" : v.code < 4200 ? "backoff" : v.code < 4300 ? "retry" : "refused";
              },
              getCloseError: function(v) {
                return v.code !== 1e3 && v.code !== 1001 ? {
                  type: "PusherError",
                  data: {
                    code: v.code,
                    message: v.reason || v.message
                  }
                } : null;
              }
            };
            var bn = pa;
            class os extends qe {
              constructor(m, h) {
                super(), this.id = m, this.transport = h, this.activityTimeout = h.activityTimeout, this.bindListeners();
              }
              handlesActivityChecks() {
                return this.transport.handlesActivityChecks();
              }
              send(m) {
                return this.transport.send(m);
              }
              send_event(m, h, C) {
                var T = { event: m, data: h };
                return C && (T.channel = C), Xe.debug("Event sent", T), this.send(bn.encodeMessage(T));
              }
              ping() {
                this.transport.supportsPing() ? this.transport.ping() : this.send_event("pusher:ping", {});
              }
              close() {
                this.transport.close();
              }
              bindListeners() {
                var m = {
                  message: (C) => {
                    var T;
                    try {
                      T = bn.decodeMessage(C);
                    } catch (Y) {
                      this.emit("error", {
                        type: "MessageParseError",
                        error: Y,
                        data: C.data
                      });
                    }
                    if (T !== void 0) {
                      switch (Xe.debug("Event recd", T), T.event) {
                        case "pusher:error":
                          this.emit("error", {
                            type: "PusherError",
                            data: T.data
                          });
                          break;
                        case "pusher:ping":
                          this.emit("ping");
                          break;
                        case "pusher:pong":
                          this.emit("pong");
                          break;
                      }
                      this.emit("message", T);
                    }
                  },
                  activity: () => {
                    this.emit("activity");
                  },
                  error: (C) => {
                    this.emit("error", C);
                  },
                  closed: (C) => {
                    h(), C && C.code && this.handleCloseEvent(C), this.transport = null, this.emit("closed");
                  }
                }, h = () => {
                  et(m, (C, T) => {
                    this.transport.unbind(T, C);
                  });
                };
                et(m, (C, T) => {
                  this.transport.bind(T, C);
                });
              }
              handleCloseEvent(m) {
                var h = bn.getCloseAction(m), C = bn.getCloseError(m);
                C && this.emit("error", C), h && this.emit(h, { action: h, error: C });
              }
            }
            class yi {
              constructor(m, h) {
                this.transport = m, this.callback = h, this.bindListeners();
              }
              close() {
                this.unbindListeners(), this.transport.close();
              }
              bindListeners() {
                this.onMessage = (m) => {
                  this.unbindListeners();
                  var h;
                  try {
                    h = bn.processHandshake(m);
                  } catch (C) {
                    this.finish("error", { error: C }), this.transport.close();
                    return;
                  }
                  h.action === "connected" ? this.finish("connected", {
                    connection: new os(h.id, this.transport),
                    activityTimeout: h.activityTimeout
                  }) : (this.finish(h.action, { error: h.error }), this.transport.close());
                }, this.onClosed = (m) => {
                  this.unbindListeners();
                  var h = bn.getCloseAction(m) || "backoff", C = bn.getCloseError(m);
                  this.finish(h, { error: C });
                }, this.transport.bind("message", this.onMessage), this.transport.bind("closed", this.onClosed);
              }
              unbindListeners() {
                this.transport.unbind("message", this.onMessage), this.transport.unbind("closed", this.onClosed);
              }
              finish(m, h) {
                this.callback(_e({ transport: this.transport, action: m }, h));
              }
            }
            class fa {
              constructor(m, h) {
                this.timeline = m, this.options = h || {};
              }
              send(m, h) {
                this.timeline.isEmpty() || this.timeline.send(Re.TimelineTransport.getAgent(this, m), h);
              }
            }
            class Cn extends qe {
              constructor(m, h) {
                super(function(C, T) {
                  Xe.debug("No callbacks on " + m + " for " + C);
                }), this.name = m, this.pusher = h, this.subscribed = !1, this.subscriptionPending = !1, this.subscriptionCancelled = !1;
              }
              authorize(m, h) {
                return h(null, { auth: "" });
              }
              trigger(m, h) {
                if (m.indexOf("client-") !== 0)
                  throw new f("Event '" + m + "' does not start with 'client-'");
                if (!this.subscribed) {
                  var C = k.buildLogSuffix("triggeringClientEvents");
                  Xe.warn(`Client event triggered before channel 'subscription_succeeded' event . ${C}`);
                }
                return this.pusher.send_event(m, h, this.name);
              }
              disconnect() {
                this.subscribed = !1, this.subscriptionPending = !1;
              }
              handleEvent(m) {
                var h = m.event, C = m.data;
                if (h === "pusher_internal:subscription_succeeded")
                  this.handleSubscriptionSucceededEvent(m);
                else if (h === "pusher_internal:subscription_count")
                  this.handleSubscriptionCountEvent(m);
                else if (h.indexOf("pusher_internal:") !== 0) {
                  var T = {};
                  this.emit(h, C, T);
                }
              }
              handleSubscriptionSucceededEvent(m) {
                this.subscriptionPending = !1, this.subscribed = !0, this.subscriptionCancelled ? this.pusher.unsubscribe(this.name) : this.emit("pusher:subscription_succeeded", m.data);
              }
              handleSubscriptionCountEvent(m) {
                m.data.subscription_count && (this.subscriptionCount = m.data.subscription_count), this.emit("pusher:subscription_count", m.data);
              }
              subscribe() {
                this.subscribed || (this.subscriptionPending = !0, this.subscriptionCancelled = !1, this.authorize(this.pusher.connection.socket_id, (m, h) => {
                  m ? (this.subscriptionPending = !1, Xe.error(m.toString()), this.emit("pusher:subscription_error", Object.assign({}, {
                    type: "AuthError",
                    error: m.message
                  }, m instanceof U ? { status: m.status } : {}))) : this.pusher.send_event("pusher:subscribe", {
                    auth: h.auth,
                    channel_data: h.channel_data,
                    channel: this.name
                  });
                }));
              }
              unsubscribe() {
                this.subscribed = !1, this.pusher.send_event("pusher:unsubscribe", {
                  channel: this.name
                });
              }
              cancelSubscription() {
                this.subscriptionCancelled = !0;
              }
              reinstateSubscription() {
                this.subscriptionCancelled = !1;
              }
            }
            class Zn extends Cn {
              authorize(m, h) {
                return this.pusher.config.channelAuthorizer({
                  channelName: this.name,
                  socketId: m
                }, h);
              }
            }
            class ki {
              constructor() {
                this.reset();
              }
              get(m) {
                return Object.prototype.hasOwnProperty.call(this.members, m) ? {
                  id: m,
                  info: this.members[m]
                } : null;
              }
              each(m) {
                et(this.members, (h, C) => {
                  m(this.get(C));
                });
              }
              setMyID(m) {
                this.myID = m;
              }
              onSubscription(m) {
                this.members = m.presence.hash, this.count = m.presence.count, this.me = this.get(this.myID);
              }
              addMember(m) {
                return this.get(m.user_id) === null && this.count++, this.members[m.user_id] = m.user_info, this.get(m.user_id);
              }
              removeMember(m) {
                var h = this.get(m.user_id);
                return h && (delete this.members[m.user_id], this.count--), h;
              }
              reset() {
                this.members = {}, this.count = 0, this.myID = null, this.me = null;
              }
            }
            var as = function(v, m, h, C) {
              function T(Y) {
                return Y instanceof h ? Y : new h(function(le) {
                  le(Y);
                });
              }
              return new (h || (h = Promise))(function(Y, le) {
                function ke(Ye) {
                  try {
                    Ze(C.next(Ye));
                  } catch (wt) {
                    le(wt);
                  }
                }
                function Oe(Ye) {
                  try {
                    Ze(C.throw(Ye));
                  } catch (wt) {
                    le(wt);
                  }
                }
                function Ze(Ye) {
                  Ye.done ? Y(Ye.value) : T(Ye.value).then(ke, Oe);
                }
                Ze((C = C.apply(v, m || [])).next());
              });
            };
            class nf extends Zn {
              constructor(m, h) {
                super(m, h), this.members = new ki();
              }
              authorize(m, h) {
                super.authorize(m, (C, T) => as(this, void 0, void 0, function* () {
                  if (!C)
                    if (T = T, T.channel_data != null) {
                      var Y = JSON.parse(T.channel_data);
                      this.members.setMyID(Y.user_id);
                    } else if (yield this.pusher.user.signinDonePromise, this.pusher.user.user_data != null)
                      this.members.setMyID(this.pusher.user.user_data.id);
                    else {
                      let le = k.buildLogSuffix("authorizationEndpoint");
                      Xe.error(`Invalid auth response for channel '${this.name}', expected 'channel_data' field. ${le}, or the user should be signed in.`), h("Invalid auth response");
                      return;
                    }
                  h(C, T);
                }));
              }
              handleEvent(m) {
                var h = m.event;
                if (h.indexOf("pusher_internal:") === 0)
                  this.handleInternalEvent(m);
                else {
                  var C = m.data, T = {};
                  m.user_id && (T.user_id = m.user_id), this.emit(h, C, T);
                }
              }
              handleInternalEvent(m) {
                var h = m.event, C = m.data;
                switch (h) {
                  case "pusher_internal:subscription_succeeded":
                    this.handleSubscriptionSucceededEvent(m);
                    break;
                  case "pusher_internal:subscription_count":
                    this.handleSubscriptionCountEvent(m);
                    break;
                  case "pusher_internal:member_added":
                    var T = this.members.addMember(C);
                    this.emit("pusher:member_added", T);
                    break;
                  case "pusher_internal:member_removed":
                    var Y = this.members.removeMember(C);
                    Y && this.emit("pusher:member_removed", Y);
                    break;
                }
              }
              handleSubscriptionSucceededEvent(m) {
                this.subscriptionPending = !1, this.subscribed = !0, this.subscriptionCancelled ? this.pusher.unsubscribe(this.name) : (this.members.onSubscription(m.data), this.emit("pusher:subscription_succeeded", this.members));
              }
              disconnect() {
                this.members.reset(), super.disconnect();
              }
            }
            var of = a(1), bi = a(0);
            class af extends Zn {
              constructor(m, h, C) {
                super(m, h), this.key = null, this.nacl = C;
              }
              authorize(m, h) {
                super.authorize(m, (C, T) => {
                  if (C) {
                    h(C, T);
                    return;
                  }
                  let Y = T.shared_secret;
                  if (!Y) {
                    h(new Error(`No shared_secret key in auth payload for encrypted channel: ${this.name}`), null);
                    return;
                  }
                  this.key = Object(bi.decode)(Y), delete T.shared_secret, h(null, T);
                });
              }
              trigger(m, h) {
                throw new I("Client events are not currently supported for encrypted channels");
              }
              handleEvent(m) {
                var h = m.event, C = m.data;
                if (h.indexOf("pusher_internal:") === 0 || h.indexOf("pusher:") === 0) {
                  super.handleEvent(m);
                  return;
                }
                this.handleEncryptedEvent(h, C);
              }
              handleEncryptedEvent(m, h) {
                if (!this.key) {
                  Xe.debug("Received encrypted event before key has been retrieved from the authEndpoint");
                  return;
                }
                if (!h.ciphertext || !h.nonce) {
                  Xe.error("Unexpected format for encrypted event, expected object with `ciphertext` and `nonce` fields, got: " + h);
                  return;
                }
                let C = Object(bi.decode)(h.ciphertext);
                if (C.length < this.nacl.secretbox.overheadLength) {
                  Xe.error(`Expected encrypted event ciphertext length to be ${this.nacl.secretbox.overheadLength}, got: ${C.length}`);
                  return;
                }
                let T = Object(bi.decode)(h.nonce);
                if (T.length < this.nacl.secretbox.nonceLength) {
                  Xe.error(`Expected encrypted event nonce length to be ${this.nacl.secretbox.nonceLength}, got: ${T.length}`);
                  return;
                }
                let Y = this.nacl.secretbox.open(C, T, this.key);
                if (Y === null) {
                  Xe.debug("Failed to decrypt an event, probably because it was encrypted with a different key. Fetching a new key from the authEndpoint..."), this.authorize(this.pusher.connection.socket_id, (le, ke) => {
                    if (le) {
                      Xe.error(`Failed to make a request to the authEndpoint: ${ke}. Unable to fetch new key, so dropping encrypted event`);
                      return;
                    }
                    if (Y = this.nacl.secretbox.open(C, T, this.key), Y === null) {
                      Xe.error("Failed to decrypt event with new key. Dropping encrypted event");
                      return;
                    }
                    this.emit(m, this.getDataToEmit(Y));
                  });
                  return;
                }
                this.emit(m, this.getDataToEmit(Y));
              }
              getDataToEmit(m) {
                let h = Object(of.decode)(m);
                try {
                  return JSON.parse(h);
                } catch {
                  return h;
                }
              }
            }
            class sf extends qe {
              constructor(m, h) {
                super(), this.state = "initialized", this.connection = null, this.key = m, this.options = h, this.timeline = this.options.timeline, this.usingTLS = this.options.useTLS, this.errorCallbacks = this.buildErrorCallbacks(), this.connectionCallbacks = this.buildConnectionCallbacks(this.errorCallbacks), this.handshakeCallbacks = this.buildHandshakeCallbacks(this.errorCallbacks);
                var C = Re.getNetwork();
                C.bind("online", () => {
                  this.timeline.info({ netinfo: "online" }), (this.state === "connecting" || this.state === "unavailable") && this.retryIn(0);
                }), C.bind("offline", () => {
                  this.timeline.info({ netinfo: "offline" }), this.connection && this.sendActivityCheck();
                }), this.updateStrategy();
              }
              connect() {
                if (!(this.connection || this.runner)) {
                  if (!this.strategy.isSupported()) {
                    this.updateState("failed");
                    return;
                  }
                  this.updateState("connecting"), this.startConnecting(), this.setUnavailableTimer();
                }
              }
              send(m) {
                return this.connection ? this.connection.send(m) : !1;
              }
              send_event(m, h, C) {
                return this.connection ? this.connection.send_event(m, h, C) : !1;
              }
              disconnect() {
                this.disconnectInternally(), this.updateState("disconnected");
              }
              isUsingTLS() {
                return this.usingTLS;
              }
              startConnecting() {
                var m = (h, C) => {
                  h ? this.runner = this.strategy.connect(0, m) : C.action === "error" ? (this.emit("error", {
                    type: "HandshakeError",
                    error: C.error
                  }), this.timeline.error({ handshakeError: C.error })) : (this.abortConnecting(), this.handshakeCallbacks[C.action](C));
                };
                this.runner = this.strategy.connect(0, m);
              }
              abortConnecting() {
                this.runner && (this.runner.abort(), this.runner = null);
              }
              disconnectInternally() {
                if (this.abortConnecting(), this.clearRetryTimer(), this.clearUnavailableTimer(), this.connection) {
                  var m = this.abandonConnection();
                  m.close();
                }
              }
              updateStrategy() {
                this.strategy = this.options.getStrategy({
                  key: this.key,
                  timeline: this.timeline,
                  useTLS: this.usingTLS
                });
              }
              retryIn(m) {
                this.timeline.info({ action: "retry", delay: m }), m > 0 && this.emit("connecting_in", Math.round(m / 1e3)), this.retryTimer = new ze(m || 0, () => {
                  this.disconnectInternally(), this.connect();
                });
              }
              clearRetryTimer() {
                this.retryTimer && (this.retryTimer.ensureAborted(), this.retryTimer = null);
              }
              setUnavailableTimer() {
                this.unavailableTimer = new ze(this.options.unavailableTimeout, () => {
                  this.updateState("unavailable");
                });
              }
              clearUnavailableTimer() {
                this.unavailableTimer && this.unavailableTimer.ensureAborted();
              }
              sendActivityCheck() {
                this.stopActivityCheck(), this.connection.ping(), this.activityTimer = new ze(this.options.pongTimeout, () => {
                  this.timeline.error({ pong_timed_out: this.options.pongTimeout }), this.retryIn(0);
                });
              }
              resetActivityCheck() {
                this.stopActivityCheck(), this.connection && !this.connection.handlesActivityChecks() && (this.activityTimer = new ze(this.activityTimeout, () => {
                  this.sendActivityCheck();
                }));
              }
              stopActivityCheck() {
                this.activityTimer && this.activityTimer.ensureAborted();
              }
              buildConnectionCallbacks(m) {
                return _e({}, m, {
                  message: (h) => {
                    this.resetActivityCheck(), this.emit("message", h);
                  },
                  ping: () => {
                    this.send_event("pusher:pong", {});
                  },
                  activity: () => {
                    this.resetActivityCheck();
                  },
                  error: (h) => {
                    this.emit("error", h);
                  },
                  closed: () => {
                    this.abandonConnection(), this.shouldRetry() && this.retryIn(1e3);
                  }
                });
              }
              buildHandshakeCallbacks(m) {
                return _e({}, m, {
                  connected: (h) => {
                    this.activityTimeout = Math.min(this.options.activityTimeout, h.activityTimeout, h.connection.activityTimeout || 1 / 0), this.clearUnavailableTimer(), this.setConnection(h.connection), this.socket_id = this.connection.id, this.updateState("connected", { socket_id: this.socket_id });
                  }
                });
              }
              buildErrorCallbacks() {
                let m = (h) => (C) => {
                  C.error && this.emit("error", { type: "WebSocketError", error: C.error }), h(C);
                };
                return {
                  tls_only: m(() => {
                    this.usingTLS = !0, this.updateStrategy(), this.retryIn(0);
                  }),
                  refused: m(() => {
                    this.disconnect();
                  }),
                  backoff: m(() => {
                    this.retryIn(1e3);
                  }),
                  retry: m(() => {
                    this.retryIn(0);
                  })
                };
              }
              setConnection(m) {
                this.connection = m;
                for (var h in this.connectionCallbacks)
                  this.connection.bind(h, this.connectionCallbacks[h]);
                this.resetActivityCheck();
              }
              abandonConnection() {
                if (this.connection) {
                  this.stopActivityCheck();
                  for (var m in this.connectionCallbacks)
                    this.connection.unbind(m, this.connectionCallbacks[m]);
                  var h = this.connection;
                  return this.connection = null, h;
                }
              }
              updateState(m, h) {
                var C = this.state;
                if (this.state = m, C !== m) {
                  var T = m;
                  T === "connected" && (T += " with new socket ID " + h.socket_id), Xe.debug("State changed", C + " -> " + T), this.timeline.info({ state: m, params: h }), this.emit("state_change", { previous: C, current: m }), this.emit(m, h);
                }
              }
              shouldRetry() {
                return this.state === "connecting" || this.state === "connected";
              }
            }
            class rf {
              constructor() {
                this.channels = {};
              }
              add(m, h) {
                return this.channels[m] || (this.channels[m] = lf(m, h)), this.channels[m];
              }
              all() {
                return xe(this.channels);
              }
              find(m) {
                return this.channels[m];
              }
              remove(m) {
                var h = this.channels[m];
                return delete this.channels[m], h;
              }
              disconnect() {
                et(this.channels, function(m) {
                  m.disconnect();
                });
              }
            }
            function lf(v, m) {
              if (v.indexOf("private-encrypted-") === 0) {
                if (m.config.nacl)
                  return Nn.createEncryptedChannel(v, m, m.config.nacl);
                let h = "Tried to subscribe to a private-encrypted- channel but no nacl implementation available", C = k.buildLogSuffix("encryptedChannelSupport");
                throw new I(`${h}. ${C}`);
              } else {
                if (v.indexOf("private-") === 0)
                  return Nn.createPrivateChannel(v, m);
                if (v.indexOf("presence-") === 0)
                  return Nn.createPresenceChannel(v, m);
                if (v.indexOf("#") === 0)
                  throw new g('Cannot create a channel with name "' + v + '".');
                return Nn.createChannel(v, m);
              }
            }
            var cf = {
              createChannels() {
                return new rf();
              },
              createConnectionManager(v, m) {
                return new sf(v, m);
              },
              createChannel(v, m) {
                return new Cn(v, m);
              },
              createPrivateChannel(v, m) {
                return new Zn(v, m);
              },
              createPresenceChannel(v, m) {
                return new nf(v, m);
              },
              createEncryptedChannel(v, m, h) {
                return new af(v, m, h);
              },
              createTimelineSender(v, m) {
                return new fa(v, m);
              },
              createHandshake(v, m) {
                return new yi(v, m);
              },
              createAssistantToTheTransportManager(v, m, h) {
                return new ma(v, m, h);
              }
            }, Nn = cf;
            class dc {
              constructor(m) {
                this.options = m || {}, this.livesLeft = this.options.lives || 1 / 0;
              }
              getAssistant(m) {
                return Nn.createAssistantToTheTransportManager(this, m, {
                  minPingDelay: this.options.minPingDelay,
                  maxPingDelay: this.options.maxPingDelay
                });
              }
              isAlive() {
                return this.livesLeft > 0;
              }
              reportDeath() {
                this.livesLeft -= 1;
              }
            }
            class mo {
              constructor(m, h) {
                this.strategies = m, this.loop = !!h.loop, this.failFast = !!h.failFast, this.timeout = h.timeout, this.timeoutLimit = h.timeoutLimit;
              }
              isSupported() {
                return Rt(this.strategies, ae.method("isSupported"));
              }
              connect(m, h) {
                var C = this.strategies, T = 0, Y = this.timeout, le = null, ke = (Oe, Ze) => {
                  Ze ? h(null, Ze) : (T = T + 1, this.loop && (T = T % C.length), T < C.length ? (Y && (Y = Y * 2, this.timeoutLimit && (Y = Math.min(Y, this.timeoutLimit))), le = this.tryStrategy(C[T], m, { timeout: Y, failFast: this.failFast }, ke)) : h(!0));
                };
                return le = this.tryStrategy(C[T], m, { timeout: Y, failFast: this.failFast }, ke), {
                  abort: function() {
                    le.abort();
                  },
                  forceMinPriority: function(Oe) {
                    m = Oe, le && le.forceMinPriority(Oe);
                  }
                };
              }
              tryStrategy(m, h, C, T) {
                var Y = null, le = null;
                return C.timeout > 0 && (Y = new ze(C.timeout, function() {
                  le.abort(), T(!0);
                })), le = m.connect(h, function(ke, Oe) {
                  ke && Y && Y.isRunning() && !C.failFast || (Y && Y.ensureAborted(), T(ke, Oe));
                }), {
                  abort: function() {
                    Y && Y.ensureAborted(), le.abort();
                  },
                  forceMinPriority: function(ke) {
                    le.forceMinPriority(ke);
                  }
                };
              }
            }
            class wi {
              constructor(m) {
                this.strategies = m;
              }
              isSupported() {
                return Rt(this.strategies, ae.method("isSupported"));
              }
              connect(m, h) {
                return uf(this.strategies, m, function(C, T) {
                  return function(Y, le) {
                    if (T[C].error = Y, Y) {
                      df(T) && h(!0);
                      return;
                    }
                    Fe(T, function(ke) {
                      ke.forceMinPriority(le.transport.priority);
                    }), h(null, le);
                  };
                });
              }
            }
            function uf(v, m, h) {
              var C = Ke(v, function(T, Y, le, ke) {
                return T.connect(m, h(Y, ke));
              });
              return {
                abort: function() {
                  Fe(C, mf);
                },
                forceMinPriority: function(T) {
                  Fe(C, function(Y) {
                    Y.forceMinPriority(T);
                  });
                }
              };
            }
            function df(v) {
              return io(v, function(m) {
                return !!m.error;
              });
            }
            function mf(v) {
              !v.error && !v.aborted && (v.abort(), v.aborted = !0);
            }
            class pf {
              constructor(m, h, C) {
                this.strategy = m, this.transports = h, this.ttl = C.ttl || 1800 * 1e3, this.usingTLS = C.useTLS, this.timeline = C.timeline;
              }
              isSupported() {
                return this.strategy.isSupported();
              }
              connect(m, h) {
                var C = this.usingTLS, T = ff(C), Y = T && T.cacheSkipCount ? T.cacheSkipCount : 0, le = [this.strategy];
                if (T && T.timestamp + this.ttl >= ae.now()) {
                  var ke = this.transports[T.transport];
                  ke && (["ws", "wss"].includes(T.transport) || Y > 3 ? (this.timeline.info({
                    cached: !0,
                    transport: T.transport,
                    latency: T.latency
                  }), le.push(new mo([ke], {
                    timeout: T.latency * 2 + 1e3,
                    failFast: !0
                  }))) : Y++);
                }
                var Oe = ae.now(), Ze = le.pop().connect(m, function Ye(wt, rs) {
                  wt ? (mc(C), le.length > 0 ? (Oe = ae.now(), Ze = le.pop().connect(m, Ye)) : h(wt)) : (hf(C, rs.transport.name, ae.now() - Oe, Y), h(null, rs));
                });
                return {
                  abort: function() {
                    Ze.abort();
                  },
                  forceMinPriority: function(Ye) {
                    m = Ye, Ze && Ze.forceMinPriority(Ye);
                  }
                };
              }
            }
            function xi(v) {
              return "pusherTransport" + (v ? "TLS" : "NonTLS");
            }
            function ff(v) {
              var m = Re.getLocalStorage();
              if (m)
                try {
                  var h = m[xi(v)];
                  if (h)
                    return JSON.parse(h);
                } catch {
                  mc(v);
                }
              return null;
            }
            function hf(v, m, h, C) {
              var T = Re.getLocalStorage();
              if (T)
                try {
                  T[xi(v)] = yn({
                    timestamp: ae.now(),
                    transport: m,
                    latency: h,
                    cacheSkipCount: C
                  });
                } catch {
                }
            }
            function mc(v) {
              var m = Re.getLocalStorage();
              if (m)
                try {
                  delete m[xi(v)];
                } catch {
                }
            }
            class ss {
              constructor(m, { delay: h }) {
                this.strategy = m, this.options = { delay: h };
              }
              isSupported() {
                return this.strategy.isSupported();
              }
              connect(m, h) {
                var C = this.strategy, T, Y = new ze(this.options.delay, function() {
                  T = C.connect(m, h);
                });
                return {
                  abort: function() {
                    Y.ensureAborted(), T && T.abort();
                  },
                  forceMinPriority: function(le) {
                    m = le, T && T.forceMinPriority(le);
                  }
                };
              }
            }
            class ha {
              constructor(m, h, C) {
                this.test = m, this.trueBranch = h, this.falseBranch = C;
              }
              isSupported() {
                var m = this.test() ? this.trueBranch : this.falseBranch;
                return m.isSupported();
              }
              connect(m, h) {
                var C = this.test() ? this.trueBranch : this.falseBranch;
                return C.connect(m, h);
              }
            }
            class _f {
              constructor(m) {
                this.strategy = m;
              }
              isSupported() {
                return this.strategy.isSupported();
              }
              connect(m, h) {
                var C = this.strategy.connect(m, function(T, Y) {
                  Y && C.abort(), h(T, Y);
                });
                return C;
              }
            }
            function _a(v) {
              return function() {
                return v.isSupported();
              };
            }
            var vf = function(v, m, h) {
              var C = {};
              function T(xc, _h, vh, gh, yh) {
                var $c = h(v, xc, _h, vh, gh, yh);
                return C[xc] = $c, $c;
              }
              var Y = Object.assign({}, m, {
                hostNonTLS: v.wsHost + ":" + v.wsPort,
                hostTLS: v.wsHost + ":" + v.wssPort,
                httpPath: v.wsPath
              }), le = Object.assign({}, Y, {
                useTLS: !0
              }), ke = Object.assign({}, m, {
                hostNonTLS: v.httpHost + ":" + v.httpPort,
                hostTLS: v.httpHost + ":" + v.httpsPort,
                httpPath: v.httpPath
              }), Oe = {
                loop: !0,
                timeout: 15e3,
                timeoutLimit: 6e4
              }, Ze = new dc({
                minPingDelay: 1e4,
                maxPingDelay: v.activityTimeout
              }), Ye = new dc({
                lives: 2,
                minPingDelay: 1e4,
                maxPingDelay: v.activityTimeout
              }), wt = T("ws", "ws", 3, Y, Ze), rs = T("wss", "ws", 3, le, Ze), dh = T("sockjs", "sockjs", 1, ke), vc = T("xhr_streaming", "xhr_streaming", 1, ke, Ye), mh = T("xdr_streaming", "xdr_streaming", 1, ke, Ye), gc = T("xhr_polling", "xhr_polling", 1, ke), ph = T("xdr_polling", "xdr_polling", 1, ke), yc = new mo([wt], Oe), fh = new mo([rs], Oe), hh = new mo([dh], Oe), kc = new mo([
                new ha(_a(vc), vc, mh)
              ], Oe), bc = new mo([
                new ha(_a(gc), gc, ph)
              ], Oe), wc = new mo([
                new ha(_a(kc), new wi([
                  kc,
                  new ss(bc, { delay: 4e3 })
                ]), bc)
              ], Oe), Ci = new ha(_a(wc), wc, hh), Ai;
              return m.useTLS ? Ai = new wi([
                yc,
                new ss(Ci, { delay: 2e3 })
              ]) : Ai = new wi([
                yc,
                new ss(fh, { delay: 2e3 }),
                new ss(Ci, { delay: 5e3 })
              ]), new pf(new _f(new ha(_a(wt), Ai, Ci)), C, {
                ttl: 18e5,
                timeline: m.timeline,
                useTLS: m.useTLS
              });
            }, gf = vf, yf = (function() {
              var v = this;
              v.timeline.info(v.buildTimelineMessage({
                transport: v.name + (v.options.useTLS ? "s" : "")
              })), v.hooks.isInitialized() ? v.changeState("initialized") : v.hooks.file ? (v.changeState("initializing"), p.load(v.hooks.file, { useTLS: v.options.useTLS }, function(m, h) {
                v.hooks.isInitialized() ? (v.changeState("initialized"), h(!0)) : (m && v.onError(m), v.onClose(), h(!1));
              })) : v.onClose();
            }), kf = {
              getRequest: function(v) {
                var m = new window.XDomainRequest();
                return m.ontimeout = function() {
                  v.emit("error", new b()), v.close();
                }, m.onerror = function(h) {
                  v.emit("error", h), v.close();
                }, m.onprogress = function() {
                  m.responseText && m.responseText.length > 0 && v.onChunk(200, m.responseText);
                }, m.onload = function() {
                  m.responseText && m.responseText.length > 0 && v.onChunk(200, m.responseText), v.emit("finished", 200), v.close();
                }, m;
              },
              abortRequest: function(v) {
                v.ontimeout = v.onerror = v.onprogress = v.onload = null, v.abort();
              }
            }, bf = kf;
            const wf = 256 * 1024;
            class xf extends qe {
              constructor(m, h, C) {
                super(), this.hooks = m, this.method = h, this.url = C;
              }
              start(m) {
                this.position = 0, this.xhr = this.hooks.getRequest(this), this.unloader = () => {
                  this.close();
                }, Re.addUnloadListener(this.unloader), this.xhr.open(this.method, this.url, !0), this.xhr.setRequestHeader && this.xhr.setRequestHeader("Content-Type", "application/json"), this.xhr.send(m);
              }
              close() {
                this.unloader && (Re.removeUnloadListener(this.unloader), this.unloader = null), this.xhr && (this.hooks.abortRequest(this.xhr), this.xhr = null);
              }
              onChunk(m, h) {
                for (; ; ) {
                  var C = this.advanceBuffer(h);
                  if (C)
                    this.emit("chunk", { status: m, data: C });
                  else
                    break;
                }
                this.isBufferTooLong(h) && this.emit("buffer_too_long");
              }
              advanceBuffer(m) {
                var h = m.slice(this.position), C = h.indexOf(`
`);
                return C !== -1 ? (this.position += C + 1, h.slice(0, C)) : null;
              }
              isBufferTooLong(m) {
                return this.position === m.length && m.length > wf;
              }
            }
            var $i;
            (function(v) {
              v[v.CONNECTING = 0] = "CONNECTING", v[v.OPEN = 1] = "OPEN", v[v.CLOSED = 3] = "CLOSED";
            })($i || ($i = {}));
            var po = $i, $f = 1;
            class zf {
              constructor(m, h) {
                this.hooks = m, this.session = fc(1e3) + "/" + Pf(8), this.location = Sf(h), this.readyState = po.CONNECTING, this.openStream();
              }
              send(m) {
                return this.sendRaw(JSON.stringify([m]));
              }
              ping() {
                this.hooks.sendHeartbeat(this);
              }
              close(m, h) {
                this.onClose(m, h, !0);
              }
              sendRaw(m) {
                if (this.readyState === po.OPEN)
                  try {
                    return Re.createSocketRequest("POST", pc(Cf(this.location, this.session))).start(m), !0;
                  } catch {
                    return !1;
                  }
                else
                  return !1;
              }
              reconnect() {
                this.closeStream(), this.openStream();
              }
              onClose(m, h, C) {
                this.closeStream(), this.readyState = po.CLOSED, this.onclose && this.onclose({
                  code: m,
                  reason: h,
                  wasClean: C
                });
              }
              onChunk(m) {
                if (m.status === 200) {
                  this.readyState === po.OPEN && this.onActivity();
                  var h, C = m.data.slice(0, 1);
                  switch (C) {
                    case "o":
                      h = JSON.parse(m.data.slice(1) || "{}"), this.onOpen(h);
                      break;
                    case "a":
                      h = JSON.parse(m.data.slice(1) || "[]");
                      for (var T = 0; T < h.length; T++)
                        this.onEvent(h[T]);
                      break;
                    case "m":
                      h = JSON.parse(m.data.slice(1) || "null"), this.onEvent(h);
                      break;
                    case "h":
                      this.hooks.onHeartbeat(this);
                      break;
                    case "c":
                      h = JSON.parse(m.data.slice(1) || "[]"), this.onClose(h[0], h[1], !0);
                      break;
                  }
                }
              }
              onOpen(m) {
                this.readyState === po.CONNECTING ? (m && m.hostname && (this.location.base = Af(this.location.base, m.hostname)), this.readyState = po.OPEN, this.onopen && this.onopen()) : this.onClose(1006, "Server lost session", !0);
              }
              onEvent(m) {
                this.readyState === po.OPEN && this.onmessage && this.onmessage({ data: m });
              }
              onActivity() {
                this.onactivity && this.onactivity();
              }
              onError(m) {
                this.onerror && this.onerror(m);
              }
              openStream() {
                this.stream = Re.createSocketRequest("POST", pc(this.hooks.getReceiveURL(this.location, this.session))), this.stream.bind("chunk", (m) => {
                  this.onChunk(m);
                }), this.stream.bind("finished", (m) => {
                  this.hooks.onFinished(this, m);
                }), this.stream.bind("buffer_too_long", () => {
                  this.reconnect();
                });
                try {
                  this.stream.start();
                } catch (m) {
                  ae.defer(() => {
                    this.onError(m), this.onClose(1006, "Could not start streaming", !1);
                  });
                }
              }
              closeStream() {
                this.stream && (this.stream.unbind_all(), this.stream.close(), this.stream = null);
              }
            }
            function Sf(v) {
              var m = /([^\?]*)\/*(\??.*)/.exec(v);
              return {
                base: m[1],
                queryString: m[2]
              };
            }
            function Cf(v, m) {
              return v.base + "/" + m + "/xhr_send";
            }
            function pc(v) {
              var m = v.indexOf("?") === -1 ? "?" : "&";
              return v + m + "t=" + +/* @__PURE__ */ new Date() + "&n=" + $f++;
            }
            function Af(v, m) {
              var h = /(https?:\/\/)([^\/:]+)((\/|:)?.*)/.exec(v);
              return h[1] + m + h[3];
            }
            function fc(v) {
              return Re.randomInt(v);
            }
            function Pf(v) {
              for (var m = [], h = 0; h < v; h++)
                m.push(fc(32).toString(32));
              return m.join("");
            }
            var Tf = zf, Mf = {
              getReceiveURL: function(v, m) {
                return v.base + "/" + m + "/xhr_streaming" + v.queryString;
              },
              onHeartbeat: function(v) {
                v.sendRaw("[]");
              },
              sendHeartbeat: function(v) {
                v.sendRaw("[]");
              },
              onFinished: function(v, m) {
                v.onClose(1006, "Connection interrupted (" + m + ")", !1);
              }
            }, If = Mf, Ef = {
              getReceiveURL: function(v, m) {
                return v.base + "/" + m + "/xhr" + v.queryString;
              },
              onHeartbeat: function() {
              },
              sendHeartbeat: function(v) {
                v.sendRaw("[]");
              },
              onFinished: function(v, m) {
                m === 200 ? v.reconnect() : v.onClose(1006, "Connection interrupted (" + m + ")", !1);
              }
            }, Of = Ef, Rf = {
              getRequest: function(v) {
                var m = Re.getXHRAPI(), h = new m();
                return h.onreadystatechange = h.onprogress = function() {
                  switch (h.readyState) {
                    case 3:
                      h.responseText && h.responseText.length > 0 && v.onChunk(h.status, h.responseText);
                      break;
                    case 4:
                      h.responseText && h.responseText.length > 0 && v.onChunk(h.status, h.responseText), v.emit("finished", h.status), v.close();
                      break;
                  }
                }, h;
              },
              abortRequest: function(v) {
                v.onreadystatechange = null, v.abort();
              }
            }, Lf = Rf, jf = {
              createStreamingSocket(v) {
                return this.createSocket(If, v);
              },
              createPollingSocket(v) {
                return this.createSocket(Of, v);
              },
              createSocket(v, m) {
                return new Tf(v, m);
              },
              createXHR(v, m) {
                return this.createRequest(Lf, v, m);
              },
              createRequest(v, m, h) {
                return new xf(v, m, h);
              }
            }, hc = jf;
            hc.createXDR = function(v, m) {
              return this.createRequest(bf, v, m);
            };
            var Df = hc, Nf = {
              nextAuthCallbackID: 1,
              auth_callbacks: {},
              ScriptReceivers: i,
              DependenciesReceivers: d,
              getDefaultStrategy: gf,
              Transports: da,
              transportConnectionInitializer: yf,
              HTTPFactory: Df,
              TimelineTransport: gi,
              getXHRAPI() {
                return window.XMLHttpRequest;
              },
              getWebSocketAPI() {
                return window.WebSocket || window.MozWebSocket;
              },
              setup(v) {
                window.Pusher = v;
                var m = () => {
                  this.onDocumentBody(v.ready);
                };
                window.JSON ? m() : p.load("json2", {}, m);
              },
              getDocument() {
                return document;
              },
              getProtocol() {
                return this.getDocument().location.protocol;
              },
              getAuthorizers() {
                return { ajax: F, jsonp: Xa };
              },
              onDocumentBody(v) {
                document.body ? v() : setTimeout(() => {
                  this.onDocumentBody(v);
                }, 0);
              },
              createJSONPRequest(v, m) {
                return new ro(v, m);
              },
              createScriptRequest(v) {
                return new vi(v);
              },
              getLocalStorage() {
                try {
                  return window.localStorage;
                } catch {
                  return;
                }
              },
              createXHR() {
                return this.getXHRAPI() ? this.createXMLHttpRequest() : this.createMicrosoftXHR();
              },
              createXMLHttpRequest() {
                var v = this.getXHRAPI();
                return new v();
              },
              createMicrosoftXHR() {
                return new ActiveXObject("Microsoft.XMLHTTP");
              },
              getNetwork() {
                return ns;
              },
              createWebSocket(v) {
                var m = this.getWebSocketAPI();
                return new m(v);
              },
              createSocketRequest(v, m) {
                if (this.isXHRSupported())
                  return this.HTTPFactory.createXHR(v, m);
                if (this.isXDRSupported(m.indexOf("https:") === 0))
                  return this.HTTPFactory.createXDR(v, m);
                throw "Cross-origin HTTP requests are not supported";
              },
              isXHRSupported() {
                var v = this.getXHRAPI();
                return !!v && new v().withCredentials !== void 0;
              },
              isXDRSupported(v) {
                var m = v ? "https:" : "http:", h = this.getProtocol();
                return !!window.XDomainRequest && h === m;
              },
              addUnloadListener(v) {
                window.addEventListener !== void 0 ? window.addEventListener("unload", v, !1) : window.attachEvent !== void 0 && window.attachEvent("onunload", v);
              },
              removeUnloadListener(v) {
                window.addEventListener !== void 0 ? window.removeEventListener("unload", v, !1) : window.detachEvent !== void 0 && window.detachEvent("onunload", v);
              },
              randomInt(v) {
                return Math.floor(function() {
                  return (window.crypto || window.msCrypto).getRandomValues(new Uint32Array(1))[0] / Math.pow(2, 32);
                }() * v);
              }
            }, Re = Nf, zi;
            (function(v) {
              v[v.ERROR = 3] = "ERROR", v[v.INFO = 6] = "INFO", v[v.DEBUG = 7] = "DEBUG";
            })(zi || (zi = {}));
            var is = zi;
            class Vf {
              constructor(m, h, C) {
                this.key = m, this.session = h, this.events = [], this.options = C || {}, this.sent = 0, this.uniqueID = 0;
              }
              log(m, h) {
                m <= this.options.level && (this.events.push(_e({}, h, { timestamp: ae.now() })), this.options.limit && this.events.length > this.options.limit && this.events.shift());
              }
              error(m) {
                this.log(is.ERROR, m);
              }
              info(m) {
                this.log(is.INFO, m);
              }
              debug(m) {
                this.log(is.DEBUG, m);
              }
              isEmpty() {
                return this.events.length === 0;
              }
              send(m, h) {
                var C = _e({
                  session: this.session,
                  bundle: this.sent + 1,
                  key: this.key,
                  lib: "js",
                  version: this.options.version,
                  cluster: this.options.cluster,
                  features: this.options.features,
                  timeline: this.events
                }, this.options.params);
                return this.events = [], m(C, (T, Y) => {
                  T || this.sent++, h && h(T, Y);
                }), !0;
              }
              generateUniqueID() {
                return this.uniqueID++, this.uniqueID;
              }
            }
            class Uf {
              constructor(m, h, C, T) {
                this.name = m, this.priority = h, this.transport = C, this.options = T || {};
              }
              isSupported() {
                return this.transport.isSupported({
                  useTLS: this.options.useTLS
                });
              }
              connect(m, h) {
                if (this.isSupported()) {
                  if (this.priority < m)
                    return _c(new A(), h);
                } else return _c(new R(), h);
                var C = !1, T = this.transport.createConnection(this.name, this.priority, this.options.key, this.options), Y = null, le = function() {
                  T.unbind("initialized", le), T.connect();
                }, ke = function() {
                  Y = Nn.createHandshake(T, function(wt) {
                    C = !0, Ye(), h(null, wt);
                  });
                }, Oe = function(wt) {
                  Ye(), h(wt);
                }, Ze = function() {
                  Ye();
                  var wt;
                  wt = yn(T), h(new P(wt));
                }, Ye = function() {
                  T.unbind("initialized", le), T.unbind("open", ke), T.unbind("error", Oe), T.unbind("closed", Ze);
                };
                return T.bind("initialized", le), T.bind("open", ke), T.bind("error", Oe), T.bind("closed", Ze), T.initialize(), {
                  abort: () => {
                    C || (Ye(), Y ? Y.close() : T.close());
                  },
                  forceMinPriority: (wt) => {
                    C || this.priority < wt && (Y ? Y.close() : T.close());
                  }
                };
              }
            }
            function _c(v, m) {
              return ae.defer(function() {
                m(v);
              }), {
                abort: function() {
                },
                forceMinPriority: function() {
                }
              };
            }
            const { Transports: Ff } = Re;
            var qf = function(v, m, h, C, T, Y) {
              var le = Ff[h];
              if (!le)
                throw new D(h);
              var ke = (!v.enabledTransports || St(v.enabledTransports, m) !== -1) && (!v.disabledTransports || St(v.disabledTransports, m) === -1), Oe;
              return ke ? (T = Object.assign({ ignoreNullOrigin: v.ignoreNullOrigin }, T), Oe = new Uf(m, C, Y ? Y.getAssistant(le) : le, T)) : Oe = Bf, Oe;
            }, Bf = {
              isSupported: function() {
                return !1;
              },
              connect: function(v, m) {
                var h = ae.defer(function() {
                  m(new R());
                });
                return {
                  abort: function() {
                    h.ensureAborted();
                  },
                  forceMinPriority: function() {
                  }
                };
              }
            };
            function Hf(v) {
              if (v == null)
                throw "You must pass an options object";
              if (v.cluster == null)
                throw "Options object must provide a cluster";
              "disableStats" in v && Xe.warn("The disableStats option is deprecated in favor of enableStats");
            }
            const Gf = (v, m) => {
              var h = "socket_id=" + encodeURIComponent(v.socketId);
              for (var C in m.params)
                h += "&" + encodeURIComponent(C) + "=" + encodeURIComponent(m.params[C]);
              if (m.paramsProvider != null) {
                let T = m.paramsProvider();
                for (var C in T)
                  h += "&" + encodeURIComponent(C) + "=" + encodeURIComponent(T[C]);
              }
              return h;
            };
            var Wf = (v) => {
              if (typeof Re.getAuthorizers()[v.transport] > "u")
                throw `'${v.transport}' is not a recognized auth transport`;
              return (m, h) => {
                const C = Gf(m, v);
                Re.getAuthorizers()[v.transport](Re, C, v, w.UserAuthentication, h);
              };
            };
            const Zf = (v, m) => {
              var h = "socket_id=" + encodeURIComponent(v.socketId);
              h += "&channel_name=" + encodeURIComponent(v.channelName);
              for (var C in m.params)
                h += "&" + encodeURIComponent(C) + "=" + encodeURIComponent(m.params[C]);
              if (m.paramsProvider != null) {
                let T = m.paramsProvider();
                for (var C in T)
                  h += "&" + encodeURIComponent(C) + "=" + encodeURIComponent(T[C]);
              }
              return h;
            };
            var Kf = (v) => {
              if (typeof Re.getAuthorizers()[v.transport] > "u")
                throw `'${v.transport}' is not a recognized auth transport`;
              return (m, h) => {
                const C = Zf(m, v);
                Re.getAuthorizers()[v.transport](Re, C, v, w.ChannelAuthorization, h);
              };
            };
            const Qf = (v, m, h) => {
              const C = {
                authTransport: m.transport,
                authEndpoint: m.endpoint,
                auth: {
                  params: m.params,
                  headers: m.headers
                }
              };
              return (T, Y) => {
                const le = v.channel(T.channelName);
                h(le, C).authorize(T.socketId, Y);
              };
            };
            function Xf(v, m) {
              let h = {
                activityTimeout: v.activityTimeout || c.activityTimeout,
                cluster: v.cluster,
                httpPath: v.httpPath || c.httpPath,
                httpPort: v.httpPort || c.httpPort,
                httpsPort: v.httpsPort || c.httpsPort,
                pongTimeout: v.pongTimeout || c.pongTimeout,
                statsHost: v.statsHost || c.stats_host,
                unavailableTimeout: v.unavailableTimeout || c.unavailableTimeout,
                wsPath: v.wsPath || c.wsPath,
                wsPort: v.wsPort || c.wsPort,
                wssPort: v.wssPort || c.wssPort,
                enableStats: nh(v),
                httpHost: Jf(v),
                useTLS: th(v),
                wsHost: Yf(v),
                userAuthenticator: oh(v),
                channelAuthorizer: sh(v, m)
              };
              return "disabledTransports" in v && (h.disabledTransports = v.disabledTransports), "enabledTransports" in v && (h.enabledTransports = v.enabledTransports), "ignoreNullOrigin" in v && (h.ignoreNullOrigin = v.ignoreNullOrigin), "timelineParams" in v && (h.timelineParams = v.timelineParams), "nacl" in v && (h.nacl = v.nacl), h;
            }
            function Jf(v) {
              return v.httpHost ? v.httpHost : v.cluster ? `sockjs-${v.cluster}.pusher.com` : c.httpHost;
            }
            function Yf(v) {
              return v.wsHost ? v.wsHost : eh(v.cluster);
            }
            function eh(v) {
              return `ws-${v}.pusher.com`;
            }
            function th(v) {
              return Re.getProtocol() === "https:" ? !0 : v.forceTLS !== !1;
            }
            function nh(v) {
              return "enableStats" in v ? v.enableStats : "disableStats" in v ? !v.disableStats : !1;
            }
            function oh(v) {
              const m = Object.assign(Object.assign({}, c.userAuthentication), v.userAuthentication);
              return "customHandler" in m && m.customHandler != null ? m.customHandler : Wf(m);
            }
            function ah(v, m) {
              let h;
              return "channelAuthorization" in v ? h = Object.assign(Object.assign({}, c.channelAuthorization), v.channelAuthorization) : (h = {
                transport: v.authTransport || c.authTransport,
                endpoint: v.authEndpoint || c.authEndpoint
              }, "auth" in v && ("params" in v.auth && (h.params = v.auth.params), "headers" in v.auth && (h.headers = v.auth.headers)), "authorizer" in v && (h.customHandler = Qf(m, h, v.authorizer))), h;
            }
            function sh(v, m) {
              const h = ah(v, m);
              return "customHandler" in h && h.customHandler != null ? h.customHandler : Kf(h);
            }
            class ih extends qe {
              constructor(m) {
                super(function(h, C) {
                  Xe.debug(`No callbacks on watchlist events for ${h}`);
                }), this.pusher = m, this.bindWatchlistInternalEvent();
              }
              handleEvent(m) {
                m.data.events.forEach((h) => {
                  this.emit(h.name, h);
                });
              }
              bindWatchlistInternalEvent() {
                this.pusher.connection.bind("message", (m) => {
                  var h = m.event;
                  h === "pusher_internal:watchlist_events" && this.handleEvent(m);
                });
              }
            }
            function rh() {
              let v, m;
              return { promise: new Promise((C, T) => {
                v = C, m = T;
              }), resolve: v, reject: m };
            }
            var lh = rh;
            class ch extends qe {
              constructor(m) {
                super(function(h, C) {
                  Xe.debug("No callbacks on user for " + h);
                }), this.signin_requested = !1, this.user_data = null, this.serverToUserChannel = null, this.signinDonePromise = null, this._signinDoneResolve = null, this._onAuthorize = (h, C) => {
                  if (h) {
                    Xe.warn(`Error during signin: ${h}`), this._cleanup();
                    return;
                  }
                  this.pusher.send_event("pusher:signin", {
                    auth: C.auth,
                    user_data: C.user_data
                  });
                }, this.pusher = m, this.pusher.connection.bind("state_change", ({ previous: h, current: C }) => {
                  h !== "connected" && C === "connected" && this._signin(), h === "connected" && C !== "connected" && (this._cleanup(), this._newSigninPromiseIfNeeded());
                }), this.watchlist = new ih(m), this.pusher.connection.bind("message", (h) => {
                  var C = h.event;
                  C === "pusher:signin_success" && this._onSigninSuccess(h.data), this.serverToUserChannel && this.serverToUserChannel.name === h.channel && this.serverToUserChannel.handleEvent(h);
                });
              }
              signin() {
                this.signin_requested || (this.signin_requested = !0, this._signin());
              }
              _signin() {
                this.signin_requested && (this._newSigninPromiseIfNeeded(), this.pusher.connection.state === "connected" && this.pusher.config.userAuthenticator({
                  socketId: this.pusher.connection.socket_id
                }, this._onAuthorize));
              }
              _onSigninSuccess(m) {
                try {
                  this.user_data = JSON.parse(m.user_data);
                } catch {
                  Xe.error(`Failed parsing user data after signin: ${m.user_data}`), this._cleanup();
                  return;
                }
                if (typeof this.user_data.id != "string" || this.user_data.id === "") {
                  Xe.error(`user_data doesn't contain an id. user_data: ${this.user_data}`), this._cleanup();
                  return;
                }
                this._signinDoneResolve(), this._subscribeChannels();
              }
              _subscribeChannels() {
                const m = (h) => {
                  h.subscriptionPending && h.subscriptionCancelled ? h.reinstateSubscription() : !h.subscriptionPending && this.pusher.connection.state === "connected" && h.subscribe();
                };
                this.serverToUserChannel = new Cn(`#server-to-user-${this.user_data.id}`, this.pusher), this.serverToUserChannel.bind_global((h, C) => {
                  h.indexOf("pusher_internal:") === 0 || h.indexOf("pusher:") === 0 || this.emit(h, C);
                }), m(this.serverToUserChannel);
              }
              _cleanup() {
                this.user_data = null, this.serverToUserChannel && (this.serverToUserChannel.unbind_all(), this.serverToUserChannel.disconnect(), this.serverToUserChannel = null), this.signin_requested && this._signinDoneResolve();
              }
              _newSigninPromiseIfNeeded() {
                if (!this.signin_requested || this.signinDonePromise && !this.signinDonePromise.done)
                  return;
                const { promise: m, resolve: h } = lh();
                m.done = !1;
                const C = () => {
                  m.done = !0;
                };
                m.then(C).catch(C), this.signinDonePromise = m, this._signinDoneResolve = h;
              }
            }
            class Mt {
              static ready() {
                Mt.isReady = !0;
                for (var m = 0, h = Mt.instances.length; m < h; m++)
                  Mt.instances[m].connect();
              }
              static getClientFeatures() {
                return Ne(Ht({ ws: Re.Transports.ws }, function(m) {
                  return m.isSupported({});
                }));
              }
              constructor(m, h) {
                uh(m), Hf(h), this.key = m, this.config = Xf(h, this), this.channels = Nn.createChannels(), this.global_emitter = new qe(), this.sessionID = Re.randomInt(1e9), this.timeline = new Vf(this.key, this.sessionID, {
                  cluster: this.config.cluster,
                  features: Mt.getClientFeatures(),
                  params: this.config.timelineParams || {},
                  limit: 50,
                  level: is.INFO,
                  version: c.VERSION
                }), this.config.enableStats && (this.timelineSender = Nn.createTimelineSender(this.timeline, {
                  host: this.config.statsHost,
                  path: "/timeline/v2/" + Re.TimelineTransport.name
                }));
                var C = (T) => Re.getDefaultStrategy(this.config, T, qf);
                this.connection = Nn.createConnectionManager(this.key, {
                  getStrategy: C,
                  timeline: this.timeline,
                  activityTimeout: this.config.activityTimeout,
                  pongTimeout: this.config.pongTimeout,
                  unavailableTimeout: this.config.unavailableTimeout,
                  useTLS: !!this.config.useTLS
                }), this.connection.bind("connected", () => {
                  this.subscribeAll(), this.timelineSender && this.timelineSender.send(this.connection.isUsingTLS());
                }), this.connection.bind("message", (T) => {
                  var Y = T.event, le = Y.indexOf("pusher_internal:") === 0;
                  if (T.channel) {
                    var ke = this.channel(T.channel);
                    ke && ke.handleEvent(T);
                  }
                  le || this.global_emitter.emit(T.event, T.data);
                }), this.connection.bind("connecting", () => {
                  this.channels.disconnect();
                }), this.connection.bind("disconnected", () => {
                  this.channels.disconnect();
                }), this.connection.bind("error", (T) => {
                  Xe.warn(T);
                }), Mt.instances.push(this), this.timeline.info({ instances: Mt.instances.length }), this.user = new ch(this), Mt.isReady && this.connect();
              }
              channel(m) {
                return this.channels.find(m);
              }
              allChannels() {
                return this.channels.all();
              }
              connect() {
                if (this.connection.connect(), this.timelineSender && !this.timelineSenderTimer) {
                  var m = this.connection.isUsingTLS(), h = this.timelineSender;
                  this.timelineSenderTimer = new ot(6e4, function() {
                    h.send(m);
                  });
                }
              }
              disconnect() {
                this.connection.disconnect(), this.timelineSenderTimer && (this.timelineSenderTimer.ensureAborted(), this.timelineSenderTimer = null);
              }
              bind(m, h, C) {
                return this.global_emitter.bind(m, h, C), this;
              }
              unbind(m, h, C) {
                return this.global_emitter.unbind(m, h, C), this;
              }
              bind_global(m) {
                return this.global_emitter.bind_global(m), this;
              }
              unbind_global(m) {
                return this.global_emitter.unbind_global(m), this;
              }
              unbind_all(m) {
                return this.global_emitter.unbind_all(), this;
              }
              subscribeAll() {
                var m;
                for (m in this.channels.channels)
                  this.channels.channels.hasOwnProperty(m) && this.subscribe(m);
              }
              subscribe(m) {
                var h = this.channels.add(m, this);
                return h.subscriptionPending && h.subscriptionCancelled ? h.reinstateSubscription() : !h.subscriptionPending && this.connection.state === "connected" && h.subscribe(), h;
              }
              unsubscribe(m) {
                var h = this.channels.find(m);
                h && h.subscriptionPending ? h.cancelSubscription() : (h = this.channels.remove(m), h && h.subscribed && h.unsubscribe());
              }
              send_event(m, h, C) {
                return this.connection.send_event(m, h, C);
              }
              shouldUseTLS() {
                return this.config.useTLS;
              }
              signin() {
                this.user.signin();
              }
            }
            Mt.instances = [], Mt.isReady = !1, Mt.logToConsole = !1, Mt.Runtime = Re, Mt.ScriptReceivers = Re.ScriptReceivers, Mt.DependenciesReceivers = Re.DependenciesReceivers, Mt.auth_callbacks = Re.auth_callbacks;
            var Si = o.default = Mt;
            function uh(v) {
              if (v == null)
                throw "You must pass your app key when you instantiate Pusher.";
            }
            Re.setup(Mt);
          })
          /******/
        ])
      );
    });
  })(Ir)), Ir.exports;
}
var x0 = w0();
const $0 = /* @__PURE__ */ pm(x0);
var z0 = Object.defineProperty, S0 = (e, t, n) => t in e ? z0(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, C0 = (e, t, n) => S0(e, t + "", n);
function op(e, t, n) {
  const o = vt(e);
  se((a) => {
    const s = o.value;
    s && (s.bind(t, n), a(() => {
      s.unbind(t, n);
    }));
  });
}
function A0(e) {
  try {
    return { data: e() };
  } catch (t) {
    return { error: t };
  }
}
function ap(e) {
  const t = N(ds()), n = N();
  return se(() => {
    const o = A0(e);
    if (!(n.value !== void 0 && P0(o, n.value))) {
      if (n.value = o, o.data) {
        t.value.settled && (t.value = ds()), t.value.resolve(void 0);
        return;
      }
      if ("error" in o) {
        t.value.settled && (t.value = ds()), t.value.reject(o.error);
        return;
      }
      t.value = ds();
    }
  }), S(() => t.value.promise);
}
function ds() {
  function e(i) {
    a(i), s.settled = !0;
  }
  function t(i) {
    o(i), s.settled = !0;
  }
  const {
    promise: n,
    reject: o,
    resolve: a
  } = Promise.withResolvers(), s = { promise: n, reject: t, resolve: e, settled: !1 };
  return s;
}
function P0(e, t) {
  return "data" in e && "data" in t && e.data === t.data || "error" in e && "error" in t && e.error === t.error;
}
const $s = /* @__PURE__ */ J({
  __name: "SmuFeature",
  props: {
    name: {}
  },
  setup(e) {
    const { hasAccess: t } = Na();
    return (n, o) => l(t)(n.name) ? Et(n.$slots, "default", { key: 0 }) : Q("", !0);
  }
});
function T0(e) {
  return Da(sp(e));
}
function sp(e) {
  const { cyan: t, key: n, magenta: o, yellow: a } = e;
  return {
    blue: Math.round(255 * (1 - a / 100) * (1 - n / 100)),
    green: Math.round(255 * (1 - o / 100) * (1 - n / 100)),
    red: Math.round(255 * (1 - t / 100) * (1 - n / 100))
  };
}
function si(e) {
  if (!lp(e)) return;
  e.length === 4 && (e = `#${e[1] ?? ""}${e[1] ?? ""}${e[2] ?? ""}${e[2] ?? ""}${e[3] ?? ""}${e[3] ?? ""}`);
  const t = ip(e);
  if (t)
    return Da(t);
}
function ip(e) {
  if (lp(e))
    return e.length === 4 && (e = `#${e[1] ?? ""}${e[1] ?? ""}${e[2] ?? ""}${e[2] ?? ""}${e[3] ?? ""}${e[3] ?? ""}`), {
      blue: Number.parseInt(e.slice(5, 7), 16),
      green: Number.parseInt(e.slice(3, 5), 16),
      red: Number.parseInt(e.slice(1, 3), 16)
    };
}
function M0(e) {
  const t = bo(e);
  return I0(t);
}
function rp(e) {
  return E0(bo(e));
}
function bo(e) {
  const { hue: t, saturation: n, value: o } = e, a = t / 360, s = n / 100, i = o / 100;
  let r = 0, c = 0, u = 0;
  const d = Math.floor(a * 6), p = a * 6 - d, _ = i * (1 - s), y = i * (1 - p * s), k = i * (1 - (1 - p) * s);
  switch (d % 6) {
    case 0:
      r = i, c = k, u = _;
      break;
    case 1:
      r = y, c = i, u = _;
      break;
    case 2:
      r = _, c = i, u = k;
      break;
    case 3:
      r = _, c = y, u = i;
      break;
    case 4:
      r = k, c = _, u = i;
      break;
    case 5:
      r = i, c = _, u = y;
      break;
  }
  return {
    blue: Math.round(u * 255),
    green: Math.round(c * 255),
    red: Math.round(r * 255)
  };
}
function dl(e, t) {
  return e.red === t.red && e.green === t.green && e.blue === t.blue;
}
function lp(e) {
  return /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(e);
}
function I0(e) {
  const { blue: t, green: n, red: o } = e, a = o / 255, s = t / 255, i = n / 255, r = 1 - Math.max(a, i, s);
  return r === 1 ? {
    cyan: 0,
    key: 100,
    magenta: 0,
    yellow: 0
  } : {
    cyan: (1 - a - r) / (1 - r) * 100,
    key: r * 100,
    magenta: (1 - i - r) / (1 - r) * 100,
    yellow: (1 - s - r) / (1 - r) * 100
  };
}
function E0({ blue: e, green: t, red: n }) {
  return `#${(1 << 24 | n << 16 | t << 8 | e).toString(16).slice(1).toUpperCase()}`;
}
function Da(e) {
  const { blue: t, green: n, red: o } = e, a = o / 255, s = n / 255, i = t / 255, r = Math.max(a, s, i), c = Math.min(a, s, i), u = r - c;
  let d = 0;
  if (u !== 0) {
    switch (r) {
      case i:
        d = (a - s) / u + 4;
        break;
      case s:
        d = (i - a) / u + 2;
        break;
      case a:
        d = (s - i) / u + (s < i ? 6 : 0);
        break;
    }
    d *= 60;
  }
  const p = r === 0 ? 0 : u / r;
  return {
    hue: d,
    saturation: p * 100,
    value: r * 100
  };
}
function O0(e) {
  const t = N({ hue: 0, saturation: 0, value: 0 });
  return {
    colorHSV: S({
      get() {
        return R0(e.value, bo(t.value)) ? t.value : Da({ ...e.value });
      },
      set(n) {
        t.value = { ...n }, e.value = bo({ ...n });
      }
    })
  };
}
function R0(e, t) {
  return e.red === t.red && e.green === t.green && e.blue === t.blue;
}
function ii(e) {
  const t = S({
    get() {
      return bo(e.value);
    },
    set(s) {
      e.value = Da(s);
    }
  }), n = N("#000"), o = S({
    get() {
      const s = ip(n.value);
      if (!s)
        throw new Error("unexpected error in hex to rgb conversion");
      return dl(bo(e.value), s) ? n.value : rp(e.value);
    },
    set(s) {
      const i = si(s);
      i && (n.value = s, e.value = i);
    }
  }), a = N({ cyan: 0, key: 0, magenta: 0, yellow: 0 });
  return {
    colorCMYK: S({
      get() {
        return dl(bo(e.value), sp(a.value)) ? a.value : M0({ ...e.value });
      },
      set(s) {
        a.value = { ...s }, e.value = T0({ ...s });
      }
    }),
    colorHex: o,
    colorRGB: t
  };
}
const cp = (e, t = 250) => {
  async function n(o) {
    if (!e.value) return;
    const a = getComputedStyle(e.value).height;
    o(), await wl();
    const s = getComputedStyle(e.value).height, i = Number.parseInt(a) > Number.parseInt(s);
    i && o();
    const r = e.value.animate(
      [
        { height: a, overflow: "hidden" },
        { height: s, overflow: "hidden" }
      ],
      { duration: t, easing: "cubic-bezier(0.4, 0, 0.2, 1)" }
    );
    i && (await r.finished, o());
  }
  return {
    animateHeight: n
  };
};
var ml = /* @__PURE__ */ ((e) => (e[e.ACCEPTED = 202] = "ACCEPTED", e[e.CREATED = 201] = "CREATED", e[e.NO_CONTENT = 204] = "NO_CONTENT", e[e.NOT_MODIFIED = 304] = "NOT_MODIFIED", e[e.OK = 200] = "OK", e))(ml || {});
const L0 = 10080 * 60 * 1e3, j0 = (e, t, n) => {
  const o = N(3), a = N(
    Object.assign({}, e.defaults.headers)
  );
  s();
  function s() {
    a.value.common = Object.fromEntries(
      Object.entries(a.value.common).filter((g) => {
        const b = g[0];
        return n ? !n.excludedHeadersForCacheKey.includes(b) : !0;
      })
    );
  }
  async function i(g, b) {
    const A = await e.get(
      g,
      w(g, b)
    );
    if (A.status === ml.NOT_MODIFIED) {
      const P = k(
        g,
        b == null ? void 0 : b.headers
      );
      if (P !== null)
        return P;
      if (o.value === 0)
        throw new Error("Unexpected local storage state occurred.");
      return await i(g, b);
    }
    return p(A, g, b == null ? void 0 : b.headers), o.value = 3, A;
  }
  function r(g) {
    return g ? (
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix next time
      g.expire_timestamp !== void 0 && // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix next time
      g.entries !== void 0
    ) : !1;
  }
  function c() {
    const g = localStorage.getItem(t);
    if (!g)
      return u();
    try {
      const b = JSON.parse(g);
      return r(b) ? b.expire_timestamp < Date.now() ? (localStorage.removeItem(t), u()) : b : u();
    } catch {
      return u();
    }
  }
  function u() {
    return {
      entries: [],
      expire_timestamp: new Date(
        Date.now() + L0
      ).getTime()
    };
  }
  function d(g, b) {
    return JSON.stringify({
      defaultHeaders: a.value,
      requestSpecificHeaders: b,
      url: g
    });
  }
  function p(g, b, A) {
    const P = g.headers.etag;
    if (!P)
      return;
    const I = c(), D = d(
      b,
      A
    );
    I.entries = I.entries.filter(
      (R) => R.request_identifier !== D
    ), I.entries.push({
      etag: P,
      request_identifier: D,
      response: g
    }), localStorage.setItem(
      t,
      JSON.stringify(I)
    );
  }
  function _(g, b) {
    return c().entries.find(
      (A) => A.request_identifier === d(g, b)
    ) ?? null;
  }
  function y(g, b) {
    var A;
    return ((A = _(
      g,
      b
    )) == null ? void 0 : A.etag) ?? null;
  }
  function k(g, b) {
    var A;
    const P = d(
      g,
      b
    );
    return ((A = c().entries.find(
      (I) => I.request_identifier === P
      // eslint-disable-next-line unicorn/no-null -- fix next time
    )) == null ? void 0 : A.response) ?? null;
  }
  function w(g, b) {
    return b ? (b.data ?? (b.data = {}), b.headers = {
      // eslint-disable-next-line @typescript-eslint/no-misused-spread -- fix next time
      ...b.headers,
      "If-None-Match": y(g, b.headers) ?? void 0
    }, b.validateStatus = f, b) : {
      data: {},
      headers: {
        "If-None-Match": y(g) ?? void 0
      },
      validateStatus: f
    };
  }
  function f(g) {
    return g <= 300 || g === ml.NOT_MODIFIED;
  }
  return {
    get: i
  };
}, D0 = rt("smake-use-feature-flag-store", () => ({
  featureFlags: N(/* @__PURE__ */ new Map())
}));
function Na() {
  const { featureFlags: e } = L(D0());
  function t(a) {
    return e.value.get(a) ?? !1;
  }
  function n(a) {
    e.value.set(a, !0);
  }
  function o(a) {
    e.value.set(a, !1);
  }
  return {
    featureFlags: e,
    giveAccessToFeature: n,
    hasAccess: t,
    removeAccessFromFeature: o
  };
}
const ri = () => {
  function e(o, a, s) {
    return new Intl.NumberFormat(a, {
      currency: s,
      style: "currency"
    }).format(o);
  }
  function t(o, a, s) {
    return new Intl.NumberFormat(a, {
      maximumFractionDigits: 2,
      minimumFractionDigits: s,
      style: "decimal"
    }).format(o);
  }
  function n(o, a, s, i) {
    const r = a ?? 1;
    return e(
      o + o / 100 * r,
      s,
      i
    );
  }
  return {
    currencyFormat: e,
    decimalFormat: t,
    priceWithTax: n
  };
}, Kn = gt.create(), N0 = 24, { idle: V0 } = Td(N0 * 60 * 60 * 1e3), Qn = N(!1), ms = N(""), Er = N(0), Or = N(), Pt = () => {
  async function e(c) {
    Qn.value = !1, Kn.defaults.baseURL = c.baseUrl, ms.value = Im(), localStorage.getItem("designer-locale") !== c.acceptLanguage && (localStorage.removeItem("designer-api-client-cache"), localStorage.setItem(
      "designer-locale",
      c.acceptLanguage
    )), Kn.defaults.headers.common = {
      Accept: "application/json",
      "Accept-Language": c.acceptLanguage,
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "X-Api-Version": c.apiVersion ?? "2024-07-15",
      "X-App-User": c.user_external_identifier,
      "X-Tab-Session-Id": ms.value
    };
    try {
      if (await n(c))
        return;
      await o(c.token);
    } catch (u) {
      throw Qn.value = !0, new nd(u);
    }
  }
  async function t(c) {
    try {
      await o(c);
    } catch (u) {
      throw Qn.value = !0, new nd(u);
    }
    Qn.value = !1;
  }
  async function n(c) {
    if (!c.user_external_identifier)
      return !1;
    Kn.defaults.headers.common["X-Designer-Token"] = c.token;
    try {
      const u = await Lr().endpoints.auth.login({
        designer_token: c.token,
        external_identifier: c.user_external_identifier
      });
      i(u);
    } catch {
      return !1;
    }
    return delete Kn.defaults.headers.common["X-Designer-Token"], !0;
  }
  async function o(c) {
    Kn.defaults.headers.common.Authorization = `Bearer ${c}`, delete Kn.defaults.headers.common["X-Designer-Token"], i(await Lr().endpoints.auth.token.refresh());
  }
  function a(c) {
    const u = c * 1e3, d = 60 * 1e3, p = u - d - Date.now();
    setTimeout(s, p);
  }
  async function s() {
    if (V0.value) {
      Qn.value = !0;
      return;
    }
    try {
      i(await Lr().endpoints.auth.token.refresh());
    } catch {
      Qn.value = !0;
    }
  }
  function i(c) {
    Or.value = c, Kn.defaults.headers.common.Authorization = `Bearer ${c.token_string}`, a(c.expire_date), Er.value = c.user_id;
  }
  function r() {
    Or.value = void 0, Er.value = 0, ms.value = "", Qn.value = !1;
  }
  return {
    axiosInstance: Kn,
    init: e,
    isDesignerSessionExpired: Qn,
    renewToken: t,
    resetGlobals: r,
    tokenData: Un(Or),
    userId: Un(Er),
    xTabSessionId: Un(ms)
  };
}, U0 = () => {
  const { axiosInstance: e } = Pt();
  async function t(n) {
    return (await e.post("auth/login", n)).data;
  }
  return {
    login: t
  };
}, F0 = 3, Rr = N(0), q0 = () => {
  const { axiosInstance: e } = Pt();
  async function t() {
    try {
      const n = (
        // eslint-disable-next-line unicorn/no-await-expression-member -- fix next time
        (await e.post("auth/token/refresh", {})).data
      );
      return Rr.value = 0, n;
    } catch (n) {
      if (Rr.value < F0)
        return Rr.value += 1, t();
      throw n;
    }
  }
  return {
    refresh: t
  };
}, B0 = () => ({
  token: {
    ...q0()
  },
  ...U0()
}), En = () => j0(
  Pt().axiosInstance,
  "designer-api-client-cache",
  {
    excludedHeadersForCacheKey: ["X-Tab-Session-Id", "Authorization"]
  }
), H0 = () => {
  const { get: e } = En();
  async function t() {
    return (await e("colors?per_page=100")).data;
  }
  return { list: t };
}, G0 = () => ({
  ...H0()
}), W0 = () => {
  const { get: e } = En();
  async function t(n) {
    return (
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, unicorn/no-await-expression-member -- fix next time, fix next time
      (await e(`products/${n}/color-variants`)).data
    );
  }
  return { listByProductId: t };
}, Z0 = () => ({
  ...W0()
}), K0 = () => {
  const { get: e } = En();
  async function t() {
    return (await e("configurations")).data;
  }
  async function n() {
    return (await e("configurations/app")).data;
  }
  async function o() {
    return (await e("configurations/designer")).data;
  }
  return {
    get: t,
    getForApp: n,
    getForDesigner: o
  };
}, Q0 = () => ({
  ...K0()
}), X0 = () => {
  const { axiosInstance: e } = Pt();
  async function t(o) {
    return (await e.get("customer-logos", {
      params: o
    })).data;
  }
  async function n() {
    return (await e.get(
      "customer-logos/count"
    )).data;
  }
  return {
    count: n,
    list: t
  };
}, J0 = () => {
  const { axiosInstance: e } = Pt();
  async function t(n) {
    return (await e.patch(
      `customer-logos/${n.id.toString()}`,
      {
        ...n,
        id: void 0
      }
    )).data;
  }
  return {
    update: t
  };
}, Y0 = () => ({
  ...X0(),
  ...J0()
}), ey = () => {
  const { axiosInstance: e } = Pt();
  async function t(n) {
    return (await e.post(
      "designs/preview",
      n
    )).data;
  }
  return {
    fetchPreview: t
  };
}, ty = () => {
  const { axiosInstance: e } = Pt();
  async function t(r) {
    return (await e.post(
      "designs/favored",
      r
    )).data;
  }
  async function n(r) {
    return (await e.get(
      `designs/favored/${r.toString()}`
    )).data;
  }
  async function o(r) {
    return (await e.get("designs/favored", {
      params: r
    })).data;
  }
  async function a() {
    return (await e.get(
      "designs/favored/count"
    )).data;
  }
  async function s(r) {
    return (await e.patch(
      `designs/favored/${r.id.toString()}`,
      {
        ...r,
        id: void 0
      }
    )).data;
  }
  async function i(r) {
    await e.delete(
      `designs/favored/${r.toString()}`
    );
  }
  return {
    count: a,
    create: t,
    delete: i,
    getById: n,
    list: o,
    update: s
  };
}, ny = () => ({
  ...ey(),
  favored: ty()
}), oy = () => {
  const { get: e } = En();
  async function t() {
    return (await e("fonts?per_page=100")).data;
  }
  return { list: t };
}, ay = () => ({
  ...oy()
}), sy = () => {
  const { axiosInstance: e } = Pt();
  async function t(a) {
    return (await e.get(`logos/${a}`)).data;
  }
  async function n(a) {
    return (await e.get("logos", {
      params: a
    })).data;
  }
  async function o() {
    return (await e.get(
      "logos/count"
    )).data.count;
  }
  return {
    count: o,
    get: t,
    list: n
  };
}, iy = () => ({
  ...sy()
}), ry = () => {
  const { axiosInstance: e } = Pt();
  async function t(n) {
    return (await e.post(
      "prices",
      n
    )).data;
  }
  return { getByItems: t };
}, ly = () => ({
  ...ry()
}), cy = () => {
  const { get: e } = En();
  async function t() {
    return (await e("production-methods")).data;
  }
  return { list: t };
}, uy = () => ({
  ...cy()
}), dy = () => {
  const { get: e } = En();
  async function t(n, o) {
    return (await e("products", {
      params: {
        page: n,
        per_page: o
      }
    })).data;
  }
  return { list: t };
}, my = () => ({
  ...dy()
}), py = () => {
  const e = En();
  async function t() {
    return (await e.get("settings")).data;
  }
  return { get: t };
}, fy = () => ({
  ...py()
}), hy = () => {
  const { axiosInstance: e } = Pt();
  async function t(n) {
    return (await e.post(
      "texts/preview",
      n
    )).data;
  }
  return {
    fetchPreview: t
  };
}, _y = () => {
  const { get: e } = En();
  async function t(n) {
    return (await e(`texts/${n}`)).data;
  }
  return { getById: t };
}, vy = () => {
  const { axiosInstance: e } = Pt();
  async function t(n) {
    const o = await e.post("texts", n);
    return Number.parseInt(o.headers["x-identifier"]);
  }
  return {
    storeText: t
  };
}, gy = () => {
  const { axiosInstance: e } = Pt();
  async function t(n, o) {
    return await e.put(
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands -- fix next time
      "texts/" + o,
      n
    );
  }
  return { updateText: t };
}, yy = () => ({
  ...vy(),
  ...gy(),
  ..._y(),
  ...hy()
}), ky = () => {
  const { axiosInstance: e } = Pt(), { get: t } = En();
  async function n() {
    try {
      return (await t("users/current")).data;
    } catch {
      return (await e.post("/users", {
        external_identifier: e.defaults.headers.common["X-App-User"]
      })).data;
    }
  }
  return { current: n };
}, by = () => ({
  ...ky()
}), wy = () => {
  const { axiosInstance: e } = Pt();
  async function t(a, s) {
    const i = await e.post(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/${a}/design-for-pdf-download`,
      s
    );
    return Number.parseInt(i.headers["x-identifier"]);
  }
  async function n(a) {
    const s = await e.get(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/${a}/pdf-download`,
      {
        responseType: "arraybuffer"
      }
    );
    return new Blob([s.data], { type: "application/pdf" });
  }
  async function o(a) {
    return (await e.get(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/${a}/preview-html`,
      {
        data: {}
      }
    )).data;
  }
  return {
    getHTMLPreviewByVariantId: o,
    getPdfByVariantId: n,
    storeVariantForPdfDownload: t
  };
}, xy = () => {
  const { axiosInstance: e } = Pt();
  async function t(n) {
    return await e.delete(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/archived/${n}`,
      { data: {} }
    );
  }
  return {
    deleteVariantByIdFromArchive: t
  };
}, $y = () => {
  const { axiosInstance: e } = Pt();
  async function t(o) {
    return (await e.get("favorites/variants", { params: o })).data;
  }
  async function n(o) {
    return (await e.get(
      `favorites/variants/${o.toString()}`
    )).data;
  }
  return {
    getById: n,
    list: t
  };
}, zy = () => {
  const { get: e } = En();
  async function t(i) {
    return (await e(
      `variants/cached/variant-id/${i.toString()}`
    )).data;
  }
  async function n(i) {
    return i = encodeURIComponent(
      i
    ), (await e(
      `variants/cached/external-identifier/${i}`
    )).data;
  }
  async function o(i) {
    return (await e("variants", {
      params: i
    })).data;
  }
  async function a(i, r) {
    return (await e("variants/archived", {
      params: {
        page: i,
        per_page: r
      }
    })).data;
  }
  async function s(i) {
    return (await e(
      `variants/archived/${i.toString()}`
    )).data;
  }
  return {
    getArchivedById: s,
    getByExternalIdentifier: n,
    getById: t,
    list: o,
    listArchived: a
  };
}, Sy = () => {
  const { axiosInstance: e } = Pt();
  async function t(o, a) {
    const s = await e.post(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/${o}/archive`,
      a
    );
    return Number.parseInt(s.headers["x-identifier"]);
  }
  async function n(o, a) {
    const s = await e.post(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/${o}/design`,
      a
    );
    return Number.parseInt(s.headers["x-identifier"]);
  }
  return {
    storeVariant: n,
    storeVariantToArchive: t
  };
}, Cy = () => ({
  ...zy(),
  ...Sy(),
  ...wy(),
  ...xy(),
  favorite: $y()
}), Ay = () => {
  const { axiosInstance: e } = Pt();
  async function t() {
    return (await e.get(
      "logos/category-tree"
    )).data;
  }
  async function n() {
    return (await e.get("logos/categories")).data;
  }
  return {
    getTree: t,
    list: n
  };
}, Py = () => ({
  ...Ay()
}), {
  init: Ty,
  isDesignerSessionExpired: My,
  renewToken: Iy,
  resetGlobals: Ey,
  tokenData: Oy,
  userId: Ry,
  xTabSessionId: Ly
} = Pt(), Lr = () => ({
  endpoints: {
    auth: B0(),
    colors: G0(),
    colorVariants: Z0(),
    configurations: Q0(),
    customerLogos: Y0(),
    designs: ny(),
    fonts: ay(),
    logoCategories: Py(),
    logos: iy(),
    prices: ly(),
    productionMethods: uy(),
    products: my(),
    settings: fy(),
    texts: yy(),
    users: by(),
    variants: Cy()
  },
  init: Ty,
  isDesignerSessionExpired: My,
  renewToken: Iy,
  resetGlobals: Ey,
  tokenData: Oy,
  userId: Ry,
  xTabSessionId: Ly
});
let jy = class extends Error {
  constructor(t) {
    super(), C0(this, "previous"), this.message = this.constructor.name, this.previous = t ?? null;
  }
};
class nd extends jy {
}
const ps = gt.create(), jr = N(!1), Dy = () => {
  function e(n) {
    jr.value = !1, ps.defaults.baseURL = n.baseUrl, ps.defaults.headers.common = {
      Accept: "application/json",
      "Accept-Language": n.acceptLanguage,
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${n.token}`,
      "Content-Type": "application/json"
    }, jr.value = !0;
  }
  function t(n) {
    ps.defaults.headers.common.Authorization = `Bearer ${n}`;
  }
  return {
    axiosInstance: ps,
    init: e,
    isInitialized: Un(jr),
    renewToken: t
  };
};
Dy();
function Ny(e, t) {
  const n = N(), o = vt(e), a = typeof t == "function" ? N(t) : vt(t), s = N();
  se((r) => {
    n.value && (n.value.connection.callbacks.add(
      "state_change",
      ({ current: c }) => {
        s.value = c;
      },
      void 0
    ), n.value.connection.callbacks.add(
      "error",
      (c) => {
        a.value && a.value(c);
      },
      void 0
    ), r(() => {
      var c, u, d;
      (c = n.value) == null || c.connection.callbacks.remove("connected"), (u = n.value) == null || u.connection.callbacks.remove("usePusher"), (d = n.value) == null || d.connection.callbacks.remove("disconnected");
    }));
  });
  const i = ap(() => {
    if (s.value === "failed")
      throw new Error("connection failed");
    return s.value === "connected";
  });
  return se((r) => {
    o.value && (n.value = xo(
      new $0(o.value.appKey, {
        cluster: o.value.cluster
      })
    ), s.value = "connecting", r(() => {
      var c;
      (c = n.value) == null || c.disconnect(), n.value = void 0;
    }));
  }), {
    /**
     * @description Promise that can be awaited to ensure to pusher connection is available. This is probably only needed in automated tests
     **/
    connected: i,
    /**
     * @description Connection state as ref. Useful when setting up a new project with pusher to verify the conenction works.
     **/
    connectionStatus: Un(s),
    pusher: n
  };
}
function od(e, t, n) {
  const o = vt(e), a = vt(t), s = vt(n), i = N(), r = N(!1), c = ap(() => r.value);
  return se(() => {
    i.value && o.value && (i.value.callbacks.add(
      "pusher:subscription_succeeded",
      () => {
        r.value = !0;
      },
      void 0
    ), i.value.callbacks.add(
      "pusher:subscription_error",
      (u) => {
        r.value = !1, s.value && s.value(u);
      },
      void 0
    ));
  }), se((u) => {
    if (!o.value || a.value === void 0) return;
    const d = a.value;
    i.value = xo(o.value.subscribe(a.value)), u(() => {
      var p;
      (p = o.value) == null || p.unsubscribe(d), i.value = void 0;
    });
  }), {
    channel: i,
    isSubscribed: r,
    subcription: c
  };
}
/**
* @vue/shared v3.5.22
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
process.env.NODE_ENV !== "production" && Object.freeze({});
process.env.NODE_ENV !== "production" && Object.freeze([]);
const up = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return ((n) => t[n] || (t[n] = e(n)));
}, Vy = /-\w/g, Uy = up(
  (e) => e.replace(Vy, (t) => t.slice(1).toUpperCase())
), Fy = up((e) => e.charAt(0).toUpperCase() + e.slice(1)), qy = [
  "AnimatedSprite",
  "BitmapText",
  "Container",
  "Graphics",
  "HtmlText",
  "Mesh",
  "MeshPlane",
  "MeshRope",
  "MeshSimple",
  "NineSlicePlane",
  "NineSliceSprite",
  "ParticleContainer",
  "PerspectiveMesh",
  "RenderContainer",
  "RenderLayer",
  "Sprite",
  "Text",
  "TilingSprite"
];
function By(e) {
  return qy.includes(e);
}
function Hy(e) {
  return e = Fy(Uy(e)), e.startsWith("Pixi") && (e = e.slice(4)), e;
}
/*! Fast Average Color | © 2025 Denis Seleznev | MIT License | https://github.com/fast-average-color/fast-average-color */
function Gy(e) {
  var t = e.toString(16);
  return t.length === 1 ? "0" + t : t;
}
function ad(e) {
  return "#" + e.map(Gy).join("");
}
function Wy(e) {
  var t = (e[0] * 299 + e[1] * 587 + e[2] * 114) / 1e3;
  return t < 128;
}
function Zy(e) {
  return e ? Ky(e) ? e : [e] : [];
}
function Ky(e) {
  return Array.isArray(e[0]);
}
function Ul(e, t, n) {
  for (var o = 0; o < n.length; o++)
    if (Qy(e, t, n[o]))
      return !0;
  return !1;
}
function Qy(e, t, n) {
  switch (n.length) {
    case 3:
      if (Xy(e, t, n))
        return !0;
      break;
    case 4:
      if (Jy(e, t, n))
        return !0;
      break;
    case 5:
      if (Yy(e, t, n))
        return !0;
      break;
    default:
      return !1;
  }
}
function Xy(e, t, n) {
  return e[t + 3] !== 255 || e[t] === n[0] && e[t + 1] === n[1] && e[t + 2] === n[2];
}
function Jy(e, t, n) {
  return e[t + 3] && n[3] ? e[t] === n[0] && e[t + 1] === n[1] && e[t + 2] === n[2] && e[t + 3] === n[3] : e[t + 3] === n[3];
}
function fs(e, t, n) {
  return e >= t - n && e <= t + n;
}
function Yy(e, t, n) {
  var o = n[0], a = n[1], s = n[2], i = n[3], r = n[4], c = e[t + 3], u = fs(c, i, r);
  return i ? !!(!c && u || fs(e[t], o, r) && fs(e[t + 1], a, r) && fs(e[t + 2], s, r) && u) : u;
}
var ek = 24;
function tk(e, t, n) {
  for (var o = {}, a = n.dominantDivider || ek, s = n.ignoredColor, i = n.step, r = [0, 0, 0, 0, 0], c = 0; c < t; c += i) {
    var u = e[c], d = e[c + 1], p = e[c + 2], _ = e[c + 3];
    if (!(s && Ul(e, c, s))) {
      var y = Math.round(u / a) + "," + Math.round(d / a) + "," + Math.round(p / a);
      o[y] ? o[y] = [
        o[y][0] + u * _,
        o[y][1] + d * _,
        o[y][2] + p * _,
        o[y][3] + _,
        o[y][4] + 1
      ] : o[y] = [u * _, d * _, p * _, _, 1], r[4] < o[y][4] && (r = o[y]);
    }
  }
  var k = r[0], w = r[1], f = r[2], g = r[3], b = r[4];
  return g ? [
    Math.round(k / g),
    Math.round(w / g),
    Math.round(f / g),
    Math.round(g / b)
  ] : n.defaultColor;
}
function nk(e, t, n) {
  for (var o = 0, a = 0, s = 0, i = 0, r = 0, c = n.ignoredColor, u = n.step, d = 0; d < t; d += u) {
    var p = e[d + 3], _ = e[d] * p, y = e[d + 1] * p, k = e[d + 2] * p;
    c && Ul(e, d, c) || (o += _, a += y, s += k, i += p, r++);
  }
  return i ? [
    Math.round(o / i),
    Math.round(a / i),
    Math.round(s / i),
    Math.round(i / r)
  ] : n.defaultColor;
}
function ok(e, t, n) {
  for (var o = 0, a = 0, s = 0, i = 0, r = 0, c = n.ignoredColor, u = n.step, d = 0; d < t; d += u) {
    var p = e[d], _ = e[d + 1], y = e[d + 2], k = e[d + 3];
    c && Ul(e, d, c) || (o += p * p * k, a += _ * _ * k, s += y * y * k, i += k, r++);
  }
  return i ? [
    Math.round(Math.sqrt(o / i)),
    Math.round(Math.sqrt(a / i)),
    Math.round(Math.sqrt(s / i)),
    Math.round(i / r)
  ] : n.defaultColor;
}
function sd(e) {
  return ba(e, "defaultColor", [0, 0, 0, 0]);
}
function ba(e, t, n) {
  return e[t] === void 0 ? n : e[t];
}
var id = 10, pl = 100;
function ak(e) {
  return e.search(/\.svg(\?|$)/i) !== -1;
}
function sk(e) {
  if (dp(e)) {
    var t = e.naturalWidth, n = e.naturalHeight;
    return !e.naturalWidth && ak(e.src) && (t = n = pl), {
      width: t,
      height: n
    };
  }
  return rk(e) ? {
    width: e.videoWidth,
    height: e.videoHeight
  } : pp(e) ? {
    width: e.codedWidth,
    height: e.codedHeight
  } : {
    width: e.width,
    height: e.height
  };
}
function rd(e) {
  return lk(e) ? "canvas" : ik(e) ? "offscreencanvas" : pp(e) ? "videoframe" : ck(e) ? "imagebitmap" : e.src;
}
function dp(e) {
  return typeof HTMLImageElement < "u" && e instanceof HTMLImageElement;
}
var mp = typeof OffscreenCanvas < "u";
function ik(e) {
  return mp && e instanceof OffscreenCanvas;
}
function rk(e) {
  return typeof HTMLVideoElement < "u" && e instanceof HTMLVideoElement;
}
function pp(e) {
  return typeof VideoFrame < "u" && e instanceof VideoFrame;
}
function lk(e) {
  return typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement;
}
function ck(e) {
  return typeof ImageBitmap < "u" && e instanceof ImageBitmap;
}
function uk(e, t) {
  var n = ba(t, "left", 0), o = ba(t, "top", 0), a = ba(t, "width", e.width), s = ba(t, "height", e.height), i = a, r = s;
  if (t.mode === "precision")
    return {
      srcLeft: n,
      srcTop: o,
      srcWidth: a,
      srcHeight: s,
      destWidth: i,
      destHeight: r
    };
  var c;
  return a > s ? (c = a / s, i = pl, r = Math.round(i / c)) : (c = s / a, r = pl, i = Math.round(r / c)), (i > a || r > s || i < id || r < id) && (i = a, r = s), {
    srcLeft: n,
    srcTop: o,
    srcWidth: a,
    srcHeight: s,
    destWidth: i,
    destHeight: r
  };
}
var dk = typeof window > "u";
function mk() {
  return dk ? mp ? new OffscreenCanvas(1, 1) : null : document.createElement("canvas");
}
var pk = "FastAverageColor: ";
function Tn(e) {
  return Error(pk + e);
}
function ga(e, t) {
  t || console.error(e);
}
var fk = (
  /** @class */
  (function() {
    function e() {
      this.canvas = null, this.ctx = null;
    }
    return e.prototype.getColorAsync = function(t, n) {
      if (!t)
        return Promise.reject(Tn("call .getColorAsync() without resource"));
      if (typeof t == "string") {
        if (typeof Image > "u")
          return Promise.reject(Tn("resource as string is not supported in this environment"));
        var o = new Image();
        return o.crossOrigin = n && n.crossOrigin || "", o.src = t, this.bindImageEvents(o, n);
      } else {
        if (dp(t) && !t.complete)
          return this.bindImageEvents(t, n);
        var a = this.getColor(t, n);
        return a.error ? Promise.reject(a.error) : Promise.resolve(a);
      }
    }, e.prototype.getColor = function(t, n) {
      n = n || {};
      var o = sd(n);
      if (!t) {
        var a = Tn("call .getColor() without resource");
        return ga(a, n.silent), this.prepareResult(o, a);
      }
      var s = sk(t), i = uk(s, n);
      if (!i.srcWidth || !i.srcHeight || !i.destWidth || !i.destHeight) {
        var a = Tn('incorrect sizes for resource "'.concat(rd(t), '"'));
        return ga(a, n.silent), this.prepareResult(o, a);
      }
      if (!this.canvas && (this.canvas = mk(), !this.canvas)) {
        var a = Tn("OffscreenCanvas is not supported in this browser");
        return ga(a, n.silent), this.prepareResult(o, a);
      }
      if (!this.ctx) {
        if (this.ctx = this.canvas.getContext("2d", { willReadFrequently: !0 }), !this.ctx) {
          var a = Tn("Canvas Context 2D is not supported in this browser");
          return ga(a, n.silent), this.prepareResult(o);
        }
        this.ctx.imageSmoothingEnabled = !1;
      }
      this.canvas.width = i.destWidth, this.canvas.height = i.destHeight;
      try {
        this.ctx.clearRect(0, 0, i.destWidth, i.destHeight), this.ctx.drawImage(t, i.srcLeft, i.srcTop, i.srcWidth, i.srcHeight, 0, 0, i.destWidth, i.destHeight);
        var r = this.ctx.getImageData(0, 0, i.destWidth, i.destHeight).data;
        return this.prepareResult(this.getColorFromArray4(r, n));
      } catch (c) {
        var a = Tn("security error (CORS) for resource ".concat(rd(t), `.
Details: https://developer.mozilla.org/en/docs/Web/HTML/CORS_enabled_image`));
        return ga(a, n.silent), n.silent || console.error(c), this.prepareResult(o, a);
      }
    }, e.prototype.getColorFromArray4 = function(t, n) {
      n = n || {};
      var o = 4, a = t.length, s = sd(n);
      if (a < o)
        return s;
      var i = a - a % o, r = (n.step || 1) * o, c;
      switch (n.algorithm || "sqrt") {
        case "simple":
          c = nk;
          break;
        case "sqrt":
          c = ok;
          break;
        case "dominant":
          c = tk;
          break;
        default:
          throw Tn("".concat(n.algorithm, " is unknown algorithm"));
      }
      return c(t, i, {
        defaultColor: s,
        ignoredColor: Zy(n.ignoredColor),
        step: r,
        dominantDivider: n.dominantDivider
      });
    }, e.prototype.prepareResult = function(t, n) {
      var o = t.slice(0, 3), a = [t[0], t[1], t[2], t[3] / 255], s = Wy(t);
      return {
        value: [t[0], t[1], t[2], t[3]],
        rgb: "rgb(" + o.join(",") + ")",
        rgba: "rgba(" + a.join(",") + ")",
        hex: ad(o),
        hexa: ad(t),
        isDark: s,
        isLight: !s,
        error: n
      };
    }, e.prototype.destroy = function() {
      this.canvas && (this.canvas.width = 1, this.canvas.height = 1, this.canvas = null), this.ctx = null;
    }, e.prototype.bindImageEvents = function(t, n) {
      var o = this;
      return new Promise(function(a, s) {
        var i = function() {
          u();
          var d = o.getColor(t, n);
          d.error ? s(d.error) : a(d);
        }, r = function() {
          u(), s(Tn('Error loading image "'.concat(t.src, '"')));
        }, c = function() {
          u(), s(Tn('Image "'.concat(t.src, '" loading aborted')));
        }, u = function() {
          t.removeEventListener("load", i), t.removeEventListener("error", r), t.removeEventListener("abort", c);
        };
        t.addEventListener("load", i), t.addEventListener("error", r), t.addEventListener("abort", c);
      });
    }, e;
  })()
), hk = Object.defineProperty, _k = (e, t, n) => t in e ? hk(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, fn = (e, t, n) => _k(e, typeof t != "symbol" ? t + "" : t, n);
const Fl = rt("designer-core.apiClient", () => {
  const e = N(), t = N("2024-07-15"), n = N(), o = N(Im());
  return { acceptLanguage: n, apiVersion: t, baseUrl: e, sessionId: o };
});
function vk() {
  const { acceptLanguage: e, apiVersion: t, baseUrl: n, sessionId: o } = L(Fl());
  return {
    beforeRequest: (a) => ({
      ...a,
      headers: {
        // eslint-disable-next-line @typescript-eslint/no-misused-spread
        ...a.headers,
        "Accept-Language": e.value,
        "X-Api-Version": t.value,
        "X-Tab-Session-Id": o.value
      },
      prefixUrl: n.value,
      timeout: 3e4
    }),
    enabled: S(() => !!(n.value && e.value)),
    key: [n, t, e]
  };
}
let fl;
function gk(e) {
  fl = e;
}
const ql = Sm(
  {
    headers: { "Content-Type": "application/json" },
    onValidationError: (e) => fl == null ? void 0 : fl(e)
  },
  [vk]
), yk = ql.mutation(
  ({ token: e, userExternalIdentifier: t }) => ({
    headers: { "X-Designer-Token": e },
    json: {
      designer_token: e,
      external_identifier: t
    },
    method: "post",
    url: "auth/login"
  }),
  {
    input: B({
      token: V(),
      userExternalIdentifier: V()
    }),
    output: B({
      expire_date: O(),
      token_string: V(),
      user_id: O()
    })
  }
), kk = ql.mutation(
  (e) => ({
    headers: { Authorization: `Bearer ${e}` },
    method: "post",
    url: "auth/token/refresh"
  }),
  {
    input: V(),
    output: B({
      expire_date: O(),
      token_string: V(),
      user_id: O()
    })
  }
), bk = bt({ refresh: kk }), wk = bt({ login: yk, token: bk }), Va = rt("designer-core.token", () => {
  const e = N(), t = N(), n = N(), o = N(!1), {
    data: a,
    error: s,
    mutate: i,
    reset: r
  } = ct(re.auth.login.use()), c = N();
  se(() => {
    a.value && (c.value = a.value);
  });
  const {
    data: u,
    error: d,
    mutate: p,
    reset: _
  } = ct(re.auth.token.refresh.use()), y = N();
  se(() => {
    u.value && (y.value = u.value);
  });
  const k = S(
    () => e.value ?? y.value ?? c.value
  );
  function w() {
    t.value = void 0, c.value = void 0, y.value = void 0, r(), _();
  }
  se(() => {
    !t.value || e.value || (n.value ? i({
      token: t.value,
      userExternalIdentifier: n.value
    }) : p(t.value));
  }), se(() => {
    !s.value || !t.value || e.value || p(t.value);
  });
  const { idle: f } = Td(1440 * 60 * 1e3);
  return se(() => {
    !d.value && !f.value || e.value || (o.value = !0, w());
  }), se((g) => {
    if (!k.value || e.value) return;
    o.value = !1;
    const b = setTimeout(
      () => {
        if (!k.value) throw new Error("tokenData not set");
        p(k.value.token_string);
      },
      k.value.expire_date * 1e3 - 60 * 1e3 - Date.now()
    );
    g(() => {
      clearTimeout(b);
    });
  }), {
    initialToken: t,
    isSessionExpired: Un(o),
    logout: w,
    manualTokenData: e,
    tokenData: k,
    userExternalIdentifier: n
  };
}), fp = ql.use(() => {
  const { tokenData: e, userExternalIdentifier: t } = L(Va());
  return {
    beforeRequest: (n) => ({
      ...n,
      headers: {
        // eslint-disable-next-line @typescript-eslint/no-misused-spread
        ...n.headers,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        Authorization: `Bearer ${e.value.token_string}`,
        "X-App-User": t.value
      }
    }),
    enabled: S(() => {
      var n;
      return !!((n = e.value) != null && n.token_string);
    }),
    key: S(() => {
      var n;
      return (n = e.value) == null ? void 0 : n.user_id;
    })
  };
}), He = fp;
var hp = /* @__PURE__ */ ((e) => (e.Black = "Black", e.BlackItalic = "Black Italic", e.Bold = "Bold", e.BoldItalic = "Bold Italic", e.DemiBold = "Demi Bold", e.DemiBoldItalic = "Demi Bold Italic", e.Italic = "Italic", e.Light = "Light", e.Medium = "Medium", e.Normal = "Normal", e.Regular = "Regular", e))(hp || {});
const xk = B({
  id: O(),
  description: V(),
  display_name: V(),
  handle: V(),
  is_digitizable: Gt(),
  is_using_color_picker: Gt(),
  preview_url: V(),
  production_type: B({
    id: O(),
    handle: V()
  })
}), $k = B({
  id: O(),
  code: V(),
  custom_attributes: V().array().nullable()
}), zk = B({
  id: O(),
  name: V(),
  code: V(),
  thickness: V().nullable()
}), Dr = B({
  id: O(),
  blue: O(),
  display_name: V(),
  external_identifier: V().nullable(),
  green: O(),
  is_customer_logo_color: Gt(),
  is_standard: Gt(),
  production_methods: B({ id: O() }).array(),
  red: O()
}), _p = Rl("color_details_type", [
  B({
    color_details: $k,
    color_details_type: lt("manual-color-details")
  }).merge(Dr),
  B({
    color_details: zk,
    color_details_type: lt("embroidery-color-details")
  }).merge(Dr),
  B({ color_details: Ta(), color_details_type: Ta() }).merge(Dr)
]), Sk = B({
  id: O(),
  name: V(),
  display_name: V(),
  family_name: V(),
  font_url: V().nullable(),
  group_handle: V(),
  letter_case_set: ao([
    lt("upper-and-lowercase"),
    lt("only-uppercase")
  ]),
  max: O(),
  min: O(),
  preview_url: V().nullable(),
  production_methods: B({ id: O() }).array(),
  style: _n(hp)
}), Ck = He.query(() => ({ url: "configurations/app" }), {
  output: B({
    colors: _p.array(),
    fonts: Sk.array(),
    productionMethods: xk.array()
  })
}), Ak = bt({ get: Ck }), Pk = B({
  id: O(),
  customer_upload: B({
    allowed_logo_file_types: ht(V()),
    dpi: O(),
    max_file_size_mb: O(),
    min_dimension: O()
  }).nullable(),
  description: V(),
  display_name: V(),
  handle: V(),
  is_digitizable: Gt(),
  is_using_color_picker: Gt(),
  preview_url: V(),
  production_type: B({
    id: O(),
    handle: V()
  })
}), Tk = He.query(
  () => ({ url: "configurations/designer" }),
  {
    output: B({
      settings: B({
        attributes: B({
          company_name: V().nullable(),
          phone: V().nullable()
        }),
        is_internal: Gt(),
        production_methods: Pk.array().optional(),
        // for now optional as not online available
        settings: B({
          customization_positioning_mode: V(),
          include_tax: Gt(),
          locale: V(),
          units: B({
            currency: V(),
            length: V()
          })
        })
      })
    })
  }
), Mk = bt({ get: Tk }), Ik = bt({ app: Ak, designer: Mk }), Ek = He.query(
  (e) => ({ searchParams: { filter: e }, url: "customer-logos/count" }),
  {
    input: B({ production_method: ht(O()) }).partial().optional(),
    output: O(),
    responseTransformer: async (e) => (await e.json()).count
  }
);
function Ok(e, t) {
  if (t && t.pages[0])
    return {
      ...t,
      pages: [
        {
          ...t.pages[0],
          data: [e, ...t.pages[0].data]
        },
        ...t.pages.slice(1)
      ]
    };
}
function vp(e, t) {
  if (t)
    return {
      ...t,
      pages: t.pages.map((n) => ({
        ...n,
        data: n.data.filter((o) => o.id !== e)
      }))
    };
}
function gp({ id: e, name: t }, n) {
  if (n)
    return {
      ...n,
      pages: n.pages.map((o) => ({
        ...o,
        data: o.data.map(
          (a) => a.id === e ? {
            ...a,
            name: t
          } : a
        )
      }))
    };
}
const Rk = He.mutation(
  (e) => ({ method: "delete", url: `customer-logos/${e.toString()}` }),
  {
    input: O(),
    onSuccess: ({ input: e }) => {
      const t = ut();
      t.setQueriesData(
        { queryKey: re.customerLogos.list.getQueryKey() },
        (n) => vp(e, n)
      ), t.invalidateQueries({
        queryKey: re.customerLogos.count.getQueryKey()
      });
    },
    output: B({ message: V() })
  }
);
function Ua(e) {
  return B({
    data: e.array(),
    links: B({
      first: V().nullable(),
      last: V().nullable(),
      next: V().nullable(),
      prev: V().nullable()
    }),
    meta: B({
      next_cursor: V().nullable(),
      path: V(),
      per_page: O(),
      prev_cursor: V().nullable()
    })
  });
}
var na = /* @__PURE__ */ ((e) => (e.INNER = "inner", e.OUTER = "outer", e))(na || {}), Io = /* @__PURE__ */ ((e) => (e.BOTTOM_CENTER = "bc", e.BOTTOM_LEFT = "bl", e.BOTTOM_RIGHT = "br", e.LEFT_BOTTOM = "lb", e.LEFT_CENTER = "lc", e.LEFT_TOP = "lt", e.RIGHT_BOTTOM = "rb", e.RIGHT_CENTER = "rc", e.RIGHT_TOP = "rt", e.TOP_CENTER = "tc", e.TOP_LEFT = "tl", e.TOP_RIGHT = "tr", e))(Io || {});
const Bl = B({
  id: O(),
  name: V(),
  base_logo_id: O().nullable(),
  color_assignments: B({
    id: O(),
    apply_to: lt("fill"),
    blue: O(),
    color: _p.nullable(),
    created_at: V().datetime({ offset: !0 }),
    green: O(),
    is_color_picker: Gt().nullable(),
    red: O(),
    updated_at: V().datetime({ offset: !0 })
  }).array(),
  created_at: V().datetime({ offset: !0 }),
  design_settings: B({
    next_element_alignment: B({
      anchor_type: lt(na.OUTER),
      anchor_value: _n(Io),
      offset: B({ x: O(), y: O() }),
      rotation: O()
    })
  }),
  external_identifier: V().nullable(),
  height: O().nullable(),
  is_customer_logo: Gt(),
  is_editable: Gt(),
  is_scaleable: Gt(),
  max_height: O().nullable(),
  max_width: O().nullable(),
  min_height: O().nullable(),
  min_width: O().nullable(),
  preview_url: V().nullable(),
  production_method: B({ id: O() }),
  production_type: B({ id: O() }),
  texts: Fg().array(),
  updated_at: V().datetime({ offset: !0 }),
  width: O().nullable()
}), Lk = He.query(
  (e) => ({ url: `logos/${e.toString()}` }),
  {
    input: O(),
    output: Bl
  }
), Hl = B({
  id: O(),
  name: V().nullable(),
  created_at: V().datetime({ offset: !0 }),
  logo: Bl,
  updated_at: V().datetime({ offset: !0 })
}), jk = He.infiniteQuery(
  (e, t) => ({
    searchParams: { cursor: t, filter: e },
    url: "customer-logos"
  }),
  {
    getNextPageParam: (e) => e.meta.next_cursor,
    // eslint-disable-next-line unicorn/no-null
    initialPageParam: null,
    input: B({ production_method: ht(O()) }).partial().optional(),
    onSuccess: ({ output: e }) => {
      const t = ut();
      for (const n of e.data) {
        t.setQueryData(
          re.customerLogos.get.getQueryKey(n.id),
          n
        );
        const o = n.logo;
        t.setQueryData(
          re.logos.get.getQueryKey(o.id),
          o
        );
      }
    },
    output: Ua(Hl)
  }
), Dk = He.query(
  (e) => ({
    url: `customer-logos/${e.toString()}`
  }),
  {
    input: O(),
    onSuccess: ({ output: e }) => {
      const t = ut(), n = e.logo;
      t.setQueryData(
        re.logos.get.getQueryKey(n.id),
        n
      );
    },
    output: Hl
  }
), Nk = He.mutation(
  (e) => ({
    json: { ...e, id: void 0 },
    method: "patch",
    url: `customer-logos/${e.id.toString()}`
  }),
  {
    input: B({ id: O(), name: V() }),
    onSuccess: ({ output: e }) => {
      ut().setQueriesData(
        { queryKey: re.customerLogos.list.getQueryKey() },
        (t) => gp(e, t)
      );
    },
    output: Hl
  }
), Vk = He.mutation(
  ({ path: e, production_method_id: t }) => ({
    json: {
      path: e,
      production_method: {
        id: t
      }
    },
    method: "post",
    url: "customer-logos"
  }),
  {
    input: B({ path: V(), production_method_id: O() }),
    output: O(),
    responseTransformer: async (e) => {
      const t = await e;
      return Number.parseInt(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.headers.get("x-identifier")
      );
    }
  }
), Uk = He.mutation(
  (e) => ({
    json: e,
    method: "post",
    url: "customer-logos/temporary-upload-url"
  }),
  {
    input: B({ content_type: V(), file_name: V() }),
    output: B({
      path: V(),
      url: V()
    })
  }
), Fk = bt({
  count: Ek,
  delete: Rk,
  get: Dk,
  list: jk,
  patch: Nk,
  post: Vk,
  temporaryUploadUrl: Uk
}), qk = He.query(
  (e) => ({ searchParams: { filter: e }, url: "designs/favored/count" }),
  {
    input: B({ production_method: ht(O()) }).partial().optional(),
    output: O(),
    responseTransformer: async (e) => (await e.json()).count
  }
);
function yp(e, t) {
  if (t) {
    if (t.pages.some(
      (n) => n.data.some((o) => o.id === e.id)
    )) {
      Gl(e, t);
      return;
    }
    if (t.pages[0])
      return {
        ...t,
        pages: [
          {
            ...t.pages[0],
            data: [e, ...t.pages[0].data]
          },
          ...t.pages.slice(1)
        ]
      };
  }
}
function kp(e, t) {
  if (t)
    return {
      ...t,
      pages: t.pages.map((n) => ({
        ...n,
        data: n.data.filter((o) => o.id !== e)
      }))
    };
}
function Gl({ id: e, name: t }, n) {
  if (n)
    return {
      ...n,
      pages: n.pages.map((o) => ({
        ...o,
        data: o.data.map(
          (a) => a.id === e ? {
            ...a,
            name: t
          } : a
        )
      }))
    };
}
const Bk = He.mutation(
  (e) => ({ method: "delete", url: `designs/favored/${e.toString()}` }),
  {
    input: O(),
    onSuccess: ({ input: e }) => {
      const t = ut();
      t.setQueriesData(
        { queryKey: re.designs.favored.list.getQueryKey() },
        (n) => kp(e, n)
      ), t.invalidateQueries({
        queryKey: re.designs.favored.count.getQueryKey()
      });
    },
    output: B({ message: V() })
  }
);
var wo = /* @__PURE__ */ ((e) => (e.CENTER = "center", e.LEFT = "left", e.RIGHT = "right", e))(wo || {});
const bp = ao([
  B({
    id: O(),
    color: B({
      id: O()
    })
  }),
  B({
    id: O(),
    blue: O(),
    color: Ta().optional(),
    green: O(),
    red: O()
  })
]), Hk = B({
  dimension: B({ height: O(), width: O() }).optional(),
  resource: B({
    id: O(),
    name: V(),
    color_assignments: bp.array(),
    created_at: V().datetime({ offset: !0 }),
    design_settings: B({
      next_element_alignment: B({
        anchor_type: lt(na.OUTER),
        anchor_value: _n(Io),
        offset: B({ x: O(), y: O() }),
        rotation: O()
      })
    }),
    external_identifier: V().nullable(),
    height: O(),
    is_customer_logo: Gt(),
    max_height: O(),
    max_width: O(),
    min_height: O(),
    min_width: O(),
    origin: ao([
      lt("merchant-upload"),
      lt("customer-upload"),
      lt("customer-logo")
    ]),
    preview_url: V().nullable(),
    production_method: B({ id: O() }),
    production_type: B({ id: O(), handle: V() }),
    updated_at: V().datetime({ offset: !0 }),
    width: O()
  }),
  resource_type: lt("logo")
}), Gk = B({
  resource: B({
    lines: ht(
      B({
        bending_radius: O(),
        color_assignments: so([bp]),
        font: B({ id: O() }),
        font_size: O(),
        horizontal_alignment: _n(wo),
        offset: O(),
        order_column: O(),
        padding_bottom: O(),
        value: V()
      })
    ),
    preview_url: V().nullable(),
    production_method: B({ id: O() })
  }),
  resource_type: lt("text")
}), Wk = B({ elements: ht(Ll(() => Zk)) }), wp = Rl("resource_type", [
  Hk,
  Gk
]).and(Wk), Zk = wp.and(
  B({
    alignment: B({
      anchor_type: lt(na.OUTER),
      anchor_value: _n(Io),
      offset: B({ x: O(), y: O() })
    })
  })
), Fa = B({
  id: O(),
  name: V().nullable(),
  created_at: V().datetime({ offset: !0 }),
  elements: so([wp]),
  height: O(),
  preview_url: V(),
  production_method: B({ id: O() }),
  updated_at: V().datetime({ offset: !0 }),
  width: O()
}), Kk = He.query(
  (e) => ({ url: `designs/favored/${e.toString()}` }),
  {
    input: O(),
    output: Fa
  }
), Qk = He.infiniteQuery(
  (e, t) => ({
    searchParams: { cursor: t, filter: e },
    url: "designs/favored"
  }),
  {
    getNextPageParam: (e) => e.meta.next_cursor,
    // eslint-disable-next-line unicorn/no-null
    initialPageParam: null,
    input: B({ production_method: ht(O()) }).partial().optional(),
    onSuccess: ({ output: e }) => {
      const t = ut();
      for (const n of e.data)
        t.setQueryData(
          re.designs.favored.get.getQueryKey(n.id),
          n
        );
    },
    output: Ua(Fa)
  }
), Xk = He.mutation(
  ({ id: e, name: t }) => ({
    json: { name: t },
    method: "patch",
    url: `designs/favored/${e.toString()}`
  }),
  {
    input: B({ id: O(), name: V() }),
    onSuccess: ({ output: e }) => {
      ut().setQueriesData(
        { queryKey: re.designs.favored.list.getQueryKey() },
        (t) => Gl(e, t)
      );
    },
    output: Fa
  }
), Jk = B({
  dimension: B({ height: O(), width: O() }).optional(),
  resource: B({
    id: O(),
    color_assignments: ao([
      B({
        id: O(),
        color: B({
          id: O()
        })
      }),
      B({
        id: O(),
        blue: O(),
        color: Ta().optional(),
        green: O(),
        red: O()
      })
    ]).array(),
    production_method: B({ id: O() })
  }),
  resource_type: lt("logo")
}), Yk = B({
  resource: B({
    lines: ht(
      B({
        bending_radius: O(),
        color_assignments: so([
          ao([
            B({
              color: B({
                id: O()
              })
            }),
            B({
              blue: O(),
              color: Ta().optional(),
              green: O(),
              red: O()
            })
          ])
        ]),
        font: B({ id: O() }),
        font_size: O(),
        horizontal_alignment: _n(wo),
        offset: O(),
        order_column: O(),
        padding_bottom: O(),
        value: V()
      })
    ),
    production_method: B({ id: O() })
  }),
  resource_type: lt("text")
}), e2 = B({ elements: ht(Ll(() => t2)) }), oa = Rl("resource_type", [
  Jk,
  Yk
]).and(e2), t2 = oa.and(
  B({
    alignment: B({
      anchor_type: lt(na.OUTER),
      anchor_value: _n(Io),
      offset: B({ x: O(), y: O() }),
      rotation: O()
    })
  })
), n2 = fp.query(
  (e) => ({ json: e, method: "post", url: "designs/preview" }),
  {
    input: B({
      elements: so([oa]),
      production_method: B({ id: O() })
    }),
    output: B({
      content: V(),
      height: O(),
      width: O()
    })
  }
), o2 = He.mutation(
  (e) => ({ json: e, method: "post", url: "designs/favored" }),
  {
    input: B({
      name: V().optional(),
      elements: so([oa]),
      production_method: B({ id: O() })
    }),
    onSuccess: ({ input: e, output: t }) => {
      const n = ut();
      n.setQueriesData(
        {
          queryKey: re.designs.favored.list.getQueryKey({
            production_method: [t.production_method.id]
          })
        },
        (o) => yp(t, o)
      ), n.invalidateQueries({
        queryKey: re.designs.favored.count.getQueryKey({
          production_method: [e.production_method.id]
        })
      });
    },
    output: Fa
  }
), a2 = bt({
  count: qk,
  delete: Bk,
  get: Kk,
  list: Qk,
  patch: Xk,
  post: o2
}), s2 = bt({ favored: a2, preview: n2 });
function xp() {
  const e = ut(), t = re.favorites.variants.list.getQueryKey(), n = re.designs.favored.list.getQueryKey();
  function o(a) {
    e.setQueriesData(
      {
        queryKey: t
      },
      (s) => {
        if (s)
          return {
            ...s,
            pages: s.pages.map((i) => ({
              ...i,
              data: i.data.filter(
                (r) => r.id !== a
              )
            }))
          };
      }
    ), e.setQueriesData(
      {
        queryKey: n
      },
      (s) => {
        if (s)
          return {
            ...s,
            pages: s.pages.map((i) => ({
              ...i,
              data: i.data.filter(
                (r) => r.id !== a
              )
            }))
          };
      }
    );
  }
  return {
    deleteFavorite: o
  };
}
const i2 = He.mutation(
  (e) => ({ method: "delete", url: `favorites/${e.toString()}` }),
  {
    input: O(),
    onSuccess: ({ input: e }) => {
      const { deleteFavorite: t } = xp();
      t(e);
    }
  }
), $p = ao([
  lt("merchant-sketch"),
  lt("customer-sketch"),
  lt("ordered")
]);
var aa = /* @__PURE__ */ ((e) => (e.BOTTOM_CENTER = "bc", e.BOTTOM_LEFT = "bl", e.BOTTOM_RIGHT = "br", e.CENTER_CENTER = "cc", e.CENTER_LEFT = "cl", e.CENTER_RIGHT = "cr", e.TOP_CENTER = "tc", e.TOP_LEFT = "tl", e.TOP_RIGHT = "tr", e))(aa || {});
function r2(e) {
  switch (e) {
    case 0:
      return "tc";
    case 45:
      return "tr";
    case 90:
      return "cr";
    case 135:
      return "br";
    case 180:
      return "bc";
    case 225:
      return "bl";
    case 270:
      return "cl";
    case 315:
      return "tl";
    default:
      return;
  }
}
function Ko(e) {
  switch (e) {
    case "b":
    case "r":
      return 1;
    case "c":
      return 0.5;
    default:
      return 0;
  }
}
function l2(e) {
  switch (e) {
    case "bc":
      return 180;
    case "bl":
      return 225;
    case "br":
      return 135;
    case "cl":
      return 270;
    case "cr":
      return 90;
    case "tc":
      return 0;
    case "tl":
      return 315;
    case "tr":
      return 45;
    default:
      return;
  }
}
const zp = B({
  id: O(),
  description: V(),
  display_name: V(),
  handle: V(),
  preview_url: V(),
  production_type: B({ id: O(), handle: V() })
}), c2 = B({
  id: O(),
  name: V(),
  handle: V()
}), ld = B({
  id: O(),
  annotations: B({
    id: O(),
    created_at: V(),
    description: V(),
    handle: V(),
    updated_at: V()
  }).array(),
  blacklisted_variants: O().array(),
  direction: O(),
  localized_height: O(),
  localized_width: O(),
  order_column: O(),
  position: _n(aa),
  positioning_area_identifier: c2.nullable(),
  positioning_area_identifier_handle: V().nullable(),
  production_method: zp,
  rotation: O(),
  view_type_handle: V(),
  x: O(),
  y: O()
}), u2 = B({
  customizations: B({
    id: O(),
    background_color: V(),
    calculation_type: V(),
    calculation_value: O(),
    created_at: V().datetime({ offset: !0 }),
    design: Fa,
    hash: V(),
    height: O(),
    order: O(),
    position: _n(aa),
    positioningArea: ld,
    price: V(),
    rotation: O(),
    updated_at: V().datetime({ offset: !0 }),
    width: O(),
    x: O(),
    y: O()
  }).array(),
  display_name: V(),
  handle: V(),
  image_urls: B({
    md: V(),
    sm: V(),
    xl: V()
  }),
  long_display_name: V(),
  mockup_urls: B({
    md: V().nullable(),
    sm: V().nullable(),
    xl: V().nullable()
  }),
  positioning_areas: ld.array(),
  production_areas: B({
    id: O(),
    points: B({ x: O(), y: O() }).array(),
    production_method: zp,
    view_type_handle: V()
  }).array(),
  scalefactor: O(),
  short_display_name: V()
}), li = B({
  id: O(),
  name: V(),
  attributes: B({
    name: ao([lt("color"), lt("size")]),
    handle: V(),
    value: V()
  }).array(),
  base: B({
    id: O(),
    external_identifier: V().nullable()
  }),
  collection_name: ao([lt("custom"), lt("catalogue")]),
  created_at: V().datetime({ offset: !0 }),
  external_identifier: V().nullable(),
  id_hash: V(),
  origin: B({
    code: V(),
    external_identifier: V().nullable()
  }),
  product_id: O(),
  state: V(),
  updated_at: V().datetime({ offset: !0 }),
  views: u2.array()
}), d2 = He.query(
  (e) => ({ url: `variants/cached/variant-id/${e.toString()}` }),
  {
    input: O(),
    onSuccess: ({ output: e }) => {
      const t = ut();
      for (const n of e.views)
        for (const { design: o } of n.customizations)
          t.setQueryData(
            re.designs.favored.get.getQueryKey(o.id),
            o
          );
    },
    output: li
  }
), Sp = B({
  id: O(),
  collection_name: $p,
  created_at: V(),
  filter_date: V(),
  id_hash: V(),
  is_active: Gt(),
  resource: li,
  resource_type: lt("variant"),
  updated_at: V()
}), m2 = He.query(
  (e) => ({ url: `favorites/variants/${e.toString()}` }),
  {
    input: O(),
    onSuccess: ({ output: e }) => {
      const t = ut();
      t.setQueryData(
        re.variants.get.getQueryKey(e.resource.id),
        e.resource
      ), e.resource.external_identifier && t.setQueryData(
        re.variants.getByExternalIdentifier.getQueryKey(
          e.resource.external_identifier
        ),
        e.resource
      );
      for (const n of e.resource.views)
        for (const { design: o } of n.customizations)
          t.setQueryData(
            re.designs.favored.get.getQueryKey(o.id),
            o
          );
    },
    output: Sp
  }
), p2 = He.infiniteQuery(
  (e, t) => ({
    searchParams: {
      ...e,
      cursor: t
    },
    url: "favorites/variants"
  }),
  {
    getNextPageParam: (e) => e.meta.next_cursor,
    // eslint-disable-next-line unicorn/no-null
    initialPageParam: null,
    input: B({
      filter: B({
        collection_name: $p,
        filter_date_equals: ho(),
        filter_date_max: ho(),
        filter_date_min: ho()
      }).partial().optional()
    }).optional(),
    onSuccess: ({ output: e }) => {
      const t = ut();
      for (const n of e.data) {
        t.setQueryData(
          re.favorites.variants.get.getQueryKey(
            n.id
          ),
          n
        ), t.setQueryData(
          re.variants.get.getQueryKey(
            n.resource.id
          ),
          n.resource
        ), n.resource.external_identifier && t.setQueryData(
          re.variants.getByExternalIdentifier.getQueryKey(
            n.resource.external_identifier
          ),
          n.resource
        );
        for (const o of n.resource.views)
          for (const { design: a } of o.customizations)
            t.setQueryData(
              re.designs.favored.get.getQueryKey(
                a.id
              ),
              a
            );
      }
    },
    output: Ua(Sp)
  }
), f2 = He.mutation(
  (e) => ({
    // ToDo Request fix from backend for removing this header
    headers: {
      accept: "application/json"
    },
    json: e,
    method: "post",
    url: "favorites/variants"
  }),
  {
    input: B({
      resource: B({
        id: O(),
        views: ht(
          B({
            customizations: ht(
              B({
                design: B({
                  elements: so([oa]),
                  production_method: B({
                    id: O()
                  })
                }),
                order: O(),
                position: _n(aa),
                positioning_area: B({
                  id: O()
                }),
                rotation: O(),
                x: O(),
                y: O()
              })
            ),
            handle: V()
          })
        )
      })
    }),
    output: O(),
    responseTransformer: async (e) => {
      const t = await e;
      return Number.parseInt(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.headers.get("x-identifier")
      );
    }
  }
), h2 = bt({ get: m2, list: p2, post: f2 }), _2 = bt({ delete: i2, variants: h2 }), v2 = He.query(
  (e) => ({ searchParams: { filter: e }, url: "logos/categories" }),
  {
    input: B({ production_method: ht(O()) }).partial().optional(),
    output: B({
      id: O(),
      name: V(),
      left: O(),
      logos: O().array(),
      parent_id: O().nullable(),
      right: O()
    }).array()
  }
), g2 = bt({ list: v2 }), y2 = B({
  node: B({
    id: O(),
    name: V(),
    entries_count: O()
  })
}), Cp = y2.extend({
  children: Ll(() => Cp).array()
}), k2 = He.query(
  () => ({ method: "get", url: "logos/category-tree" }),
  { output: Cp.array() }
), b2 = bt({ get: k2 }), w2 = He.query(
  (e) => ({ searchParams: { filter: e }, url: "logos/count" }),
  {
    input: B({
      name: V(),
      "categories.id": ht(O()),
      name_or_tags: V(),
      production_method: ht(O()),
      tags: V()
    }).partial().optional(),
    output: O(),
    responseTransformer: async (e) => (await e.json()).count
  }
), x2 = He.infiniteQuery(
  (e, t) => ({
    searchParams: {
      cursor: t,
      filter: e
    },
    url: "logos"
  }),
  {
    getNextPageParam: (e) => e.meta.next_cursor,
    // eslint-disable-next-line unicorn/no-null
    initialPageParam: null,
    input: B({
      id: O(),
      name: V(),
      "categories.id": ht(O()),
      created_at_max: ho(),
      created_at_min: ho(),
      name_or_tags: V(),
      production_method: ht(O()),
      tags: V(),
      updated_at_max: ho(),
      updated_at_min: ho()
    }).partial().optional(),
    onSuccess: ({ output: e }) => {
      const t = ut();
      for (const n of e.data)
        t.setQueryData(
          re.logos.get.getQueryKey(n.id),
          n
        );
    },
    output: Ua(Bl)
  }
), $2 = bt({ categories: g2, categoryTree: b2, count: w2, get: Lk, list: x2 }), z2 = He.query(
  (e) => ({
    json: { items: e },
    method: "post",
    url: "prices"
  }),
  {
    input: ht(
      B({
        quantity: O(),
        variant: B({ id: O() })
      })
    ),
    output: B({
      items: B({
        prices: B({
          calculation_quantity: O(),
          model_id: O(),
          model_type: V(),
          price: O(),
          pricing: B({
            calculate_from: O(),
            calculation_type: V(),
            scaled_prices: B({
              from_a_number_of: O(),
              price: O()
            }).array()
          }),
          single_unit_price: O()
        }).array(),
        quantity: O(),
        variant: B({
          id: O()
        })
      }).array()
    })
  }
), S2 = bt({ getByItems: z2 }), C2 = He.query(
  (e) => ({ url: `products/${e.toString()}/color-variants` }),
  {
    input: O(),
    output: B({
      color_handle: V(),
      color_name: V(),
      color_preview_url: V(),
      image_url: V(),
      size_variants: B({
        id: O(),
        external_identifier: V(),
        product_size_label_id: O().nullable(),
        product_size_label_name: V().nullable(),
        product_sizes: ht(
          B({
            id: O(),
            oder_column: O(),
            product_size_scale_id: O(),
            product_size_scale_name: V(),
            value: V()
          })
        ),
        size_handle: V(),
        size_name: V(),
        size_order_column: O()
      }).array()
    }).array()
  }
), A2 = bt({ list: C2 }), P2 = He.infiniteQuery(
  (e, t) => ({
    searchParams: { ...e, page: t },
    url: "products"
  }),
  {
    getNextPageParam: (e) => {
      if (!(e.meta.current_page >= e.meta.to))
        return e.meta.current_page + 1;
    },
    initialPageParam: 1,
    input: B({ per_page: O() }).partial().optional(),
    output: B({
      data: B({
        id: O(),
        created_at: V(),
        description: V(),
        is_test: O(),
        title: V(),
        updated_at: V(),
        variants: O().array()
      }).array(),
      links: B({
        first: V().nullable(),
        last: V().nullable(),
        next: V().nullable(),
        prev: V().nullable()
      }),
      meta: B({
        current_page: O(),
        current_page_url: V(),
        from: O(),
        path: V(),
        per_page: O(),
        to: O()
      })
    })
  }
), T2 = bt({ colorVariants: A2, list: P2 }), M2 = He.query(
  (e) => ({
    url: `variants/cached/external-identifier/${encodeURIComponent(e)}`
  }),
  {
    input: V(),
    onSuccess: ({ output: e }) => {
      const t = ut();
      for (const n of e.views)
        for (const { design: o } of n.customizations)
          t.setQueryData(
            re.designs.favored.get.getQueryKey(o.id),
            o
          );
    },
    output: li
  }
), I2 = He.infiniteQuery(
  (e) => ({ searchParams: { filter: e }, url: "variants" }),
  {
    getNextPageParam: (e) => e.meta.next_cursor,
    // eslint-disable-next-line unicorn/no-null
    initialPageParam: null,
    input: B({
      id: O().or(ht(O())),
      collection_name: V(),
      external_identifier: V()
    }).partial().optional(),
    onSuccess: ({ output: e }) => {
      const t = ut();
      for (const n of e.data) {
        t.setQueryData(
          re.variants.get.getQueryKey(n.id),
          n
        ), n.external_identifier && t.setQueryData(
          re.variants.getByExternalIdentifier.getQueryKey(
            n.external_identifier
          ),
          n
        );
        for (const o of n.views)
          for (const { design: a } of o.customizations)
            t.setQueryData(
              re.designs.favored.get.getQueryKey(
                a.id
              ),
              a
            );
      }
    },
    output: Ua(li)
  }
), E2 = He.query(
  (e) => ({ url: `variants/${e.toString()}/pdf-download` }),
  {
    input: O(),
    output: Ug(Blob).and(
      Mm((e) => e.type === "application/pdf")
    ),
    responseTransformer: (e) => e.blob()
  }
), O2 = He.mutation(
  /**
   * Creates a pdf preview of a custom variant.
   *
   * @param baseId id of the variant that the new one is based on
   * @param views array of views defining the variants content
   *
   * @returns id of the created variant which is used for the pdf.
   *   The created variant needs to be rendered first before it can be retrieved.
   *   A pusher event is emitted when the rendering is done.
   */
  ({ baseId: e, views: t }) => ({
    // ToDo Request fix from backend for removing this header
    headers: {
      accept: "application/json"
    },
    json: { views: t },
    method: "post",
    timeout: !1,
    url: `variants/${e.toString()}/design-for-pdf-download`
  }),
  {
    input: B({
      baseId: O(),
      views: ht(
        B({
          customizations: ht(
            B({
              design: B({
                elements: so([oa]),
                production_method: B({
                  id: O()
                })
              }),
              order: O(),
              position: _n(aa),
              positioning_area: B({
                id: O()
              }),
              rotation: O(),
              x: O(),
              y: O()
            })
          ),
          handle: V()
        })
      )
    }),
    output: O(),
    responseTransformer: async (e) => {
      const t = await e;
      return Number.parseInt(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.headers.get("x-identifier")
      );
    }
  }
), R2 = bt({ getByVariantId: E2, postForDownload: O2 }), L2 = He.mutation(
  /**
   * Creates a new custom variant
   *
   * @param baseId id of the variant that the new one is based on
   * @param views array of views defining the variants content
   *
   * @returns id of the created variant.
   *   The created variant needs to be rendered first before it can be retrieved.
   *   A pusher event is emitted when the rendering is done
   */
  ({ baseId: e, views: t }) => ({
    // ToDo Request fix from backend for removing this header
    headers: {
      accept: "application/json"
    },
    json: { views: t },
    method: "post",
    url: `variants/${e.toString()}/design`
  }),
  {
    input: B({
      baseId: O(),
      views: ht(
        B({
          customizations: ht(
            B({
              design: B({
                elements: so([oa]),
                production_method: B({
                  id: O()
                })
              }),
              order: O(),
              position: _n(aa),
              positioning_area: B({
                id: O()
              }),
              rotation: O(),
              x: O(),
              y: O()
            })
          ),
          handle: V()
        })
      )
    }),
    output: O(),
    responseTransformer: async (e) => {
      const t = await e;
      return Number.parseInt(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.headers.get("x-identifier")
      );
    }
  }
), j2 = He.query(
  (e) => ({ url: `variants/${e.toString()}/preview-html` }),
  { input: O(), output: V() }
), D2 = bt({ getByVariantId: j2 }), N2 = bt({
  get: d2,
  getByExternalIdentifier: M2,
  list: I2,
  pdf: R2,
  post: L2,
  previewHtml: D2
}), re = bt(
  {
    auth: wk,
    configurations: Ik,
    customerLogos: Fk,
    designs: s2,
    favorites: _2,
    logos: $2,
    prices: S2,
    products: T2,
    variants: N2
  },
  "designer-api"
), Wl = rt("designer-core.pusher", () => {
  const { tokenData: e } = L(Va()), { sessionId: t } = L(Fl()), n = N(), o = N(), a = N(), s = N(), i = S(() => {
    if (!(o.value === void 0 || a.value === void 0))
      return {
        appKey: o.value,
        cluster: a.value
      };
  }), { connected: r, connectionStatus: c, pusher: u } = Ny(
    i,
    s
  ), d = S(() => {
    var b;
    if (n.value && (b = e.value) != null && b.user_id)
      return [
        n.value,
        "smake-designer-api",
        e.value.user_id
      ].join("-");
  }), {
    channel: p,
    isSubscribed: _,
    subcription: y
  } = od(u, d), k = S(() => {
    if (d.value)
      return [d.value, t.value].join("-");
  }), {
    channel: w,
    isSubscribed: f,
    subcription: g
  } = od(u, k);
  return {
    appKey: o,
    channelPrefix: n,
    channelSession: w,
    channelSessionIsSubscibed: f,
    channelSessionName: k,
    channelSessionSubscription: g,
    channelUser: p,
    channelUserIsSubscribed: _,
    channelUserName: d,
    channelUserSubscription: y,
    cluster: a,
    connected: r,
    connectionStatus: c,
    onError: s,
    pusher: u
  };
});
function At(e, t) {
  const { channelUser: n } = L(Wl());
  op(n, e, t);
}
function on(e) {
  const t = qn();
  return M(e, t);
}
function V2() {
  const e = ut(), t = re.customerLogos.list.getQueryKey(), n = on(
    (s) => e.fetchQuery({
      ...re.customerLogos.get.use(s),
      retry: !1,
      staleTime: 1 / 0
    })
  ), o = on(
    (s) => s ? re.customerLogos.list.getQueryKey({
      production_method: [s]
    }) : re.customerLogos.list.getQueryKey()
  ), a = on(
    (s) => s ? re.customerLogos.count.getQueryKey({
      production_method: [s]
    }) : re.customerLogos.count.getQueryKey()
  );
  At("customerLogo.updated", (s) => {
    e.setQueriesData(
      {
        queryKey: t
      },
      (i) => gp(s, i)
    );
  }), At("customerLogo.completed", async ({ id: s }) => {
    const i = await n(s);
    e.setQueriesData(
      {
        queryKey: o(
          i.logo.production_method.id
        )
      },
      (r) => Ok(i, r)
    ), await e.invalidateQueries({
      queryKey: a(
        i.logo.production_method.id
      )
    });
  }), At("customerLogo.deleted", async ({ id: s }) => {
    e.setQueriesData(
      { queryKey: o() },
      (i) => vp(s, i)
    ), await e.invalidateQueries({
      queryKey: a()
    });
  });
}
function U2(e) {
  const t = ut();
  At(
    "customVariant.deleteFromArchive.completed",
    ({ id: o }) => {
      const a = re.favorites.variants.list.getQueryKey({
        filter: {
          collection_name: "customer-sketch"
        }
      });
      t.setQueryData(
        a,
        (s) => s && {
          ...s,
          pages: s.pages.map((i) => ({
            ...i,
            data: i.data.filter(
              (r) => r.id !== o
            )
          }))
        }
      );
    }
  ), At(
    "customVariant.customizationsCompletedAfterAssignedToArchive",
    async ({ id: o }) => {
      try {
        const a = await n(o), s = re.favorites.variants.list.getQueryKey({
          filter: {
            collection_name: "customer-sketch"
          }
        }), i = t.getQueryData(
          s
        );
        if (!i) return;
        if (i.pages.some(
          (r) => r.data.some((c) => c.id === o)
        )) {
          t.setQueryData(
            s,
            (r) => {
              if (r)
                return {
                  ...r,
                  pages: r.pages.map((c) => ({
                    ...c,
                    data: c.data.map(
                      (u) => u.id === o ? a : u
                    )
                  }))
                };
            }
          );
          return;
        }
        t.setQueryData(
          s,
          (r) => {
            if (r != null && r.pages[0])
              return {
                ...r,
                pages: [
                  {
                    ...r.pages[0],
                    data: [
                      a,
                      ...r.pages[0].data
                    ]
                  },
                  ...r.pages.slice(1)
                ]
              };
          }
        );
      } catch (a) {
        e && e(a);
      }
    }
  );
  const n = on(
    (o) => t.fetchQuery(re.favorites.variants.get.use(o))
  );
}
function F2(e) {
  const t = ut();
  At(
    "favorite.deleted",
    async ({ resource_id: s, resource_type: i }) => {
      if (i === "design") {
        t.setQueriesData(
          { queryKey: o() },
          (r) => kp(s, r)
        );
        try {
          await t.invalidateQueries({
            queryKey: a()
          });
        } catch (r) {
          e && e(r);
        }
      }
    }
  ), At("favoredDesign.updated", (s) => {
    t.setQueriesData(
      { queryKey: o() },
      (i) => Gl(s, i)
    );
  }), At(
    "favorite.created",
    async ({ resource_id: s, resource_type: i }) => {
      if (i === "design")
        try {
          const r = await n(s);
          t.setQueriesData(
            {
              queryKey: o([
                r.production_method.id
              ])
            },
            (c) => yp(r, c)
          ), await t.invalidateQueries({
            queryKey: a()
          });
        } catch (r) {
          e && e(r);
        }
    }
  );
  const n = on((s) => {
    const i = re.designs.favored.get.use(s);
    return t.fetchQuery(i);
  }), o = on(
    (s) => s === void 0 ? re.designs.favored.list.getQueryKey() : re.designs.favored.list.getQueryKey({
      production_method: s
    })
  ), a = on(() => re.designs.favored.count.getQueryKey());
}
function q2(e) {
  const t = ut(), n = re.favorites.variants.list.getQueryKey({
    filter: { collection_name: "customer-sketch" }
  });
  At("favorite.rendered", async ({ id: s }) => {
    try {
      const i = await a(s), r = t.getQueryData(
        n
      );
      if (!r) return;
      if (r.pages.some(
        (c) => c.data.some((u) => u.id === s)
      )) {
        t.setQueryData(
          n,
          (c) => {
            if (c)
              return {
                ...c,
                pages: c.pages.map((u) => ({
                  ...u,
                  data: u.data.map(
                    (d) => d.id === s ? i : d
                  )
                }))
              };
          }
        );
        return;
      }
      t.setQueryData(
        n,
        (c) => {
          if (c != null && c.pages[0])
            return {
              ...c,
              pages: [
                {
                  ...c.pages[0],
                  data: [i, ...c.pages[0].data]
                },
                ...c.pages.slice(1)
              ]
            };
        }
      );
    } catch (i) {
      e && e(i);
    }
  });
  const { deleteFavorite: o } = xp();
  At("favorite.deleted", ({ id: s, resource_type: i }) => {
    i === "variant" && o(s);
  }), At("favorite.updated", async ({ id: s }) => {
    try {
      const i = await a(s), r = t.getQueryData(
        n
      );
      if (!r) return;
      if (r.pages.some(
        (c) => c.data.some((u) => u.id === s)
      )) {
        t.setQueryData(
          n,
          (c) => {
            if (c)
              return {
                ...c,
                pages: c.pages.map((u) => ({
                  ...u,
                  data: u.data.map(
                    (d) => d.id === s ? i : d
                  )
                }))
              };
          }
        );
        return;
      }
      t.setQueryData(
        n,
        (c) => {
          if (c != null && c.pages[0])
            return {
              ...c,
              pages: [
                {
                  ...c.pages[0],
                  data: [i, ...c.pages[0].data]
                },
                ...c.pages.slice(1)
              ]
            };
        }
      );
    } catch (i) {
      e && e(i);
    }
  }), At("favorite.created", async ({ id: s, resource_type: i }) => {
    if (i === "variant")
      try {
        const r = await a(s), c = t.getQueryData(
          n
        );
        if (!c) return;
        if (c.pages.some(
          (u) => u.data.some((d) => d.id === r.id)
        )) {
          t.setQueryData(
            n,
            (u) => {
              if (u)
                return {
                  ...u,
                  pages: u.pages.map((d) => ({
                    ...d,
                    data: d.data.map(
                      (p) => p.id === s ? r : p
                    )
                  }))
                };
            }
          );
          return;
        }
        t.setQueryData(
          n,
          (u) => {
            if (u != null && u.pages[0])
              return {
                ...u,
                pages: [
                  {
                    ...u.pages[0],
                    data: [r, ...u.pages[0].data]
                  },
                  ...u.pages.slice(1)
                ]
              };
          }
        );
      } catch (r) {
        e && e(r);
      }
  });
  const a = on((s) => {
    const i = re.favorites.variants.get.use(s);
    return t.fetchQuery(i);
  });
}
function B2(e) {
  V2(), q2(e), F2(e), U2(e);
}
class Us extends Error {
}
function Nt(e, t) {
  const n = Cd(e);
  if (!n)
    throw new Error(`injection "${String(e)}" not found`);
  return n;
}
const cd = 4095, Nr = {};
function Zl(e, t) {
  const n = S(
    () => !!pn(e) && !pn(t == null ? void 0 : t.disabled)
  ), o = S(() => {
    const s = pn(t == null ? void 0 : t.placeholder);
    if (s)
      return xo(H2(s));
  }), a = zt({
    enabled: n,
    placeholderData: o,
    queryFn: async () => (
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      xo(await Tc.load(pn(e)))
    ),
    queryKey: ["pixi.js-asset", e],
    staleTime: 1 / 0
  });
  return se(() => {
    const s = pn(e);
    n.value || !s || Tc.backgroundLoad(s);
  }), a;
}
function H2({ height: e, radius: t, width: n }) {
  const o = Math.min(cd / n, cd / e, 1);
  n = Math.round(n * o), e = Math.round(e * o), t = Math.round(t * o);
  const a = `${n.toString()}x${e.toString()}|${t.toString()}}`;
  if (!(a in Nr)) {
    const s = document.createElement("canvas");
    s.width = n, s.height = e;
    const i = s.getContext("2d");
    if (!i) throw new Error("Canvas context couldn't be created");
    i.fillStyle = "#ffffff", i.roundRect(0, 0, n, e, t), i.fill(), Nr[a] = Dd.from(s);
  }
  return Nr[a];
}
var $e = /* @__PURE__ */ ((e) => (e.ANCHOR = "ANCHOR", e.LOGO = "LOGO", e.TEXT = "TEXT", e))($e || {});
function hl(e, t) {
  var n, o, a, s, i, r, c, u, d, p, _;
  let y = { max: 1 / 0, min: -1 / 0 };
  switch (e.type) {
    case $e.ANCHOR: {
      const k = hl(
        e.parent,
        t
      );
      y = {
        max: Math.min(y.max, k.max),
        min: Math.max(y.min, k.min)
      };
      for (const w of e.children) {
        const f = hl(
          w.value,
          t
        );
        y = {
          max: Math.min(y.max, f.max),
          min: Math.max(y.min, f.min)
        };
      }
      break;
    }
    case $e.LOGO:
      e.size && (y = {
        max: Math.min(
          y.max,
          (((o = (n = t.logo) == null ? void 0 : n.size) == null ? void 0 : o.max) ?? 1 / 0) / e.size.width,
          (((s = (a = t.logo) == null ? void 0 : a.size) == null ? void 0 : s.max) ?? 1 / 0) / e.size.height
        ),
        min: Math.max(
          y.min,
          (((r = (i = t.logo) == null ? void 0 : i.size) == null ? void 0 : r.min) ?? -1 / 0) / e.size.width,
          (((u = (c = t.logo) == null ? void 0 : c.size) == null ? void 0 : u.min) ?? -1 / 0) / e.size.height
        )
      });
      break;
    case $e.TEXT:
      for (const k of e.lines) {
        const w = (_ = (p = (d = t.text) == null ? void 0 : d.size) == null ? void 0 : p.find(
          ({ fontId: f }) => f === k.fontId
        )) == null ? void 0 : _.bounds;
        w && (y = {
          max: Math.min(
            y.max,
            (w.max ?? 1 / 0) / k.size
          ),
          min: Math.max(
            y.min,
            (w.min ?? -1 / 0) / k.size
          )
        });
      }
      break;
  }
  return y;
}
function Kl(e, t, n) {
  const o = W2(n, [
    { x: -t.x, y: -t.y },
    { x: e.width - t.x, y: -t.y },
    { x: -t.x, y: e.height - t.y },
    { x: e.width - t.x, y: e.height - t.y }
  ]), a = o.map(({ x: i }) => i), s = o.map(({ y: i }) => i);
  return {
    bottom: Math.max(...s),
    left: Math.min(...a),
    right: Math.max(...a),
    top: Math.min(...s)
  };
}
function Fs({ x: e, y: t }, { x: n, y: o }) {
  return Math.hypot(e - n, t - o);
}
function $n(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
function Vr(e, t, n, o) {
  return (t - e) * (1 - Math.exp(-0.1 * n));
}
function ci(e) {
  return (e % 360 + 360) % 360;
}
function G2(e) {
  return e * (180 / Math.PI);
}
function W2(e, t) {
  const n = Z2(e), o = Math.cos(n), a = Math.sin(n);
  return t.map(({ x: s, y: i }) => ({
    x: s * o - i * a,
    y: s * a + i * o
  }));
}
function ud(e, t, n, o) {
  const { x: a, y: s } = e;
  if (typeof t == "number") {
    const r = a + Vr(a, t, n);
    return e.set(r), Math.abs(r - t);
  }
  const i = {
    x: a + Vr(a, t.x, n),
    y: s + Vr(s, t.y, n)
  };
  return e.copyFrom(i), Fs(i, t);
}
function Z2(e) {
  return e * Math.PI / 180;
}
function _l(e) {
  switch (e.type) {
    case $e.ANCHOR:
      return _l(e.parent) && e.children.every(({ value: t }) => _l(t));
    case $e.LOGO:
      return !!e.size;
    case $e.TEXT:
      return !0;
  }
}
const sa = Symbol("designer_core"), Ql = Symbol("view"), ia = Symbol("positioning_area"), Ap = Symbol("positioning_area_design"), Xl = Symbol("design");
function vl(e, t, n) {
  var o, a, s, i, r, c, u, d, p, _, y, k;
  switch (e.type) {
    case $e.ANCHOR:
      vl(e.parent, t, n);
      for (const w of e.children)
        vl(w.value, t, n);
      break;
    case $e.LOGO:
      if (e.size) {
        const { max: w = 1 / 0, min: f = 0 } = ((o = n == null ? void 0 : n.logo) == null ? void 0 : o.size) ?? {}, { height: g, width: b } = e.size, A = $n(
          t,
          Math.max(f / b, f / g),
          Math.min(w / b, w / g)
        );
        e.size.width *= A, e.size.height *= A;
      }
      break;
    case $e.TEXT:
      for (const w of e.lines) {
        w.offsetLeft && (w.offsetLeft = $n(
          w.offsetLeft * t,
          ((s = (a = n == null ? void 0 : n.text) == null ? void 0 : a.offsetLeft) == null ? void 0 : s.min) ?? -1 / 0,
          ((r = (i = n == null ? void 0 : n.text) == null ? void 0 : i.offsetLeft) == null ? void 0 : r.max) ?? 1 / 0
        )), w.paddingBottom = $n(
          w.paddingBottom * t,
          ((u = (c = n == null ? void 0 : n.text) == null ? void 0 : c.paddingBottom) == null ? void 0 : u.min) ?? -1 / 0,
          ((p = (d = n == null ? void 0 : n.text) == null ? void 0 : d.paddingBottom) == null ? void 0 : p.max) ?? 1 / 0
        );
        const f = (k = (y = (_ = n == null ? void 0 : n.text) == null ? void 0 : _.size) == null ? void 0 : y.find(
          ({ fontId: g }) => g === w.fontId
        )) == null ? void 0 : k.bounds;
        w.size = $n(
          w.size * t,
          (f == null ? void 0 : f.min) ?? 0,
          (f == null ? void 0 : f.max) ?? 1 / 0
        );
      }
      break;
  }
}
const K2 = {
  name: "loadCdnTextures",
  config: {
    crossOrigin: "anonymous",
    preferCreateImageBitmap: !0,
    preferWorkers: !0
  },
  extension: {
    name: "loadCdnTextures",
    priority: Bh.High,
    type: Rd.LoadParser
  },
  // @ts-expect-error: It's like that in the source
  async load(e, t, n) {
    var o, a;
    let s;
    globalThis.createImageBitmap && (o = this.config) != null && o.preferCreateImageBitmap ? s = this.config.preferWorkers && await Pc.isImageBitmapSupported() ? await Pc.loadImageBitmap(e, t) : await u_(e, t) : s = await new Promise((r) => {
      s = new Image(), s.crossOrigin = this.config.crossOrigin, s.src = e, s.complete ? r(s) : s.addEventListener("load", () => {
        r(s);
      });
    });
    const i = new d_({
      alphaMode: "premultiply-alpha-on-upload",
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      resolution: ((a = t.data) == null ? void 0 : a.resolution) || m_(e),
      resource: s,
      ...t.data
    });
    return p_(i, n, e);
  },
  test(e) {
    return /^https:\/\/cdn\.(.+\.)?smake\./.test(e);
  },
  unload(e) {
    e.destroy(!0);
  }
}, Q2 = {
  AnimatedSprite: { createElement: (e) => new i_(e) },
  BitmapText: { createElement: (e) => new s_(e) },
  Container: { createElement: (e) => new a_(e) },
  Graphics: { createElement: (e) => new o_(e) },
  HtmlText: { createElement: (e) => new n_(e) },
  Mesh: { createElement: (e) => new t_(e) },
  MeshPlane: { createElement: (e) => new e_(e) },
  MeshRope: { createElement: (e) => new Yh(e) },
  MeshSimple: { createElement: (e) => new Jh(e) },
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  NineSlicePlane: { createElement: (e) => new Xh(e) },
  NineSliceSprite: { createElement: (e) => new Qh(e) },
  ParticleContainer: {
    createElement: (e) => new Kh(e)
  },
  PerspectiveMesh: { createElement: (e) => new Zh(e) },
  RenderContainer: { createElement: (e) => new Wh(e) },
  RenderLayer: { createElement: (e) => new Gh(e) },
  Sprite: { createElement: (e) => new jd(e) },
  Text: { createElement: (e) => new Ld(e) },
  TilingSprite: { createElement: (e) => new Hh(e) }
};
function X2() {
  const e = new jd(Dd.EMPTY);
  return e.visible = !1, e.renderable = !1, e;
}
function J2(e) {
  const t = {};
  for (const [n, o] of Object.entries(e))
    t[$d(n)] = o;
  return t;
}
function dd(e, t) {
  if (!(e instanceof c_)) {
    Sd("Text is only supported with Text or BitmapText elements");
    return;
  }
  e.text = t;
}
function Y2(e) {
  return e.charAt(0).toLowerCase() + e.slice(1);
}
const Pp = {};
function eb(e, t) {
  Pp[e] = t;
}
const { createApp: tb, render: Gre } = xh({
  createComment: X2,
  // @ts-expect-error: No way found to fix this
  createElement(e, t, n, o) {
    const a = Hy(e), s = By(a) ? Q2[a] : Pp[a];
    if (!s) throw new Error(`Unknown element ${e}`);
    return xo(
      s.createElement(
        // @ts-expect-error: We just have to assume the types are correct
        J2(o ?? {})
      )
    );
  },
  createText(e) {
    return new Ld({ text: e });
  },
  insert(e, t, n) {
    if (n) {
      t.addChildAt(e, t.getChildIndex(n));
      return;
    }
    t.addChild(e);
  },
  nextSibling(e) {
    const t = e.parent.getChildIndex(e);
    return e.parent.children.length <= t + 1 ? (
      // eslint-disable-next-line unicorn/no-null
      null
    ) : e.parent.getChildAt(t + 1);
  },
  parentNode(e) {
    return e.parent;
  },
  patchProp(e, t, n, o) {
    if (t = $d(t), t.startsWith("on")) {
      const a = Y2(t.slice(2));
      if (n !== null)
        if (Array.isArray(n))
          for (const s of n)
            e.off(a, s);
        else
          e.off(a, n);
      if (Array.isArray(o))
        for (const s of o)
          e.on(a, s);
      else
        e.on(a, o);
      return;
    }
    if (!e[`_vp_skip_first_set_${t}`]) {
      e[`_vp_skip_first_set_${t}`] = !0;
      return;
    }
    e[t] = o;
  },
  remove(e) {
    e.destroy();
  },
  setElementText: dd,
  setText: dd
});
r_.add({ ref: K2, type: Rd.LoadParser });
const Tp = Symbol(
  "vue_pixi_application"
);
function nb(e) {
  let t = !1, n;
  return (...o) => {
    n = o, !t && (t = !0, requestAnimationFrame(() => {
      t = !1, e(...n), n = void 0;
    }));
  };
}
const ob = J({
  props: [
    "preference",
    "webgpu",
    "webgl",
    "skipExtensionImports",
    "manageImports",
    "backgroundColor",
    "background",
    "backgroundAlpha",
    "clearBeforeRender",
    "width",
    "height",
    "canvas",
    "view",
    "autoDensity",
    "resolution",
    "antialias",
    "depth",
    "multiView",
    "hello",
    "textureGCActive",
    "textureGCAMaxIdle",
    "textureGCCheckCountMax",
    "eventMode",
    "eventFeatures",
    "failIfMajorPerformanceCaveat",
    "roundPixels",
    "bezierSmoothness",
    "useBackBuffer",
    "context",
    "powerPreference",
    "premultipliedAlpha",
    "preserveDrawingBuffer",
    "preferWebGLVersion",
    "forceFallbackAdapter",
    "resizeTo",
    "autoStart",
    "sharedTicker"
  ],
  setup(e, { expose: t, slots: n }) {
    const o = N(), a = new l_(), s = N(!1), i = S(() => {
      const k = {};
      for (const [w, f] of Object.entries(e))
        f !== void 0 && (k[w] = f);
      return k;
    });
    globalThis.__PIXI_DEVTOOLS__ = {
      app: a,
      pixi: qh
    };
    const r = tb(
      J(() => () => {
        var k;
        return (k = n.default) == null ? void 0 : k.call(n);
      })
    ), c = { app: a, canvas: o, isInitialized: s };
    $o(Tp, c), t(c);
    const u = qn(), d = u.appContext.app;
    r.config.globalProperties = d.config.globalProperties, Object.assign(r._context, d._context), r._context.provides = u.provides, r.mount(a.stage);
    function p(k, w, f) {
      const g = a.renderer, b = k * f, A = w * f;
      if (g instanceof h_) {
        const P = g.gpu.device.limits.maxTextureDimension2D;
        g.resolution = Math.min(
          f,
          f * Math.min(
            Math.min(b, P) / b,
            Math.min(A, P) / A
          )
        ), g.resize(k, w);
      } else g instanceof __ && (g.resolution = f, g.resize(k, w), g.resolution = Math.min(
        f,
        f * Math.min(
          g.gl.drawingBufferWidth / b,
          g.gl.drawingBufferHeight / A
        )
      ));
      a.render();
    }
    const _ = nb(p);
    function y(k, w) {
      const f = Object.keys(e).filter((g) => k[g] !== w[g]);
      (f.includes("width") || f.includes("height") || f.includes("resolution")) && _(
        w.width ?? 1,
        w.height ?? 1,
        w.resolution ?? 1
      );
      for (const g of f)
        if (!["height", "resolution", "width"].includes(g)) {
          if (g in a.renderer) {
            a.renderer[g] = w[g];
            continue;
          }
          if (g in a) {
            a[g] = w[g];
            continue;
          }
          Sd(`Couldn't update app according to prop ${g}`);
        }
    }
    return pt(i, (k, w) => {
      s.value && y(w, k);
    }), zd(async () => {
      const k = {
        ...i.value,
        height: 1,
        resolution: 1,
        width: 1
      };
      await a.init({
        ...k,
        canvas: o.value
      }), y(k, i.value), s.value = !0;
    }), xl(() => {
      r.unmount(), a.destroy();
    }), () => $h("canvas", { ref: o });
  }
});
function qo(e, t) {
  const n = (t == null ? void 0 : t.ticker) ?? ab();
  se((o) => {
    const a = n.value;
    !a || !pn((t == null ? void 0 : t.enabled) ?? !0) || (a.add(e, t == null ? void 0 : t.context, t == null ? void 0 : t.priority), o(() => {
      a.remove(e, t == null ? void 0 : t.context);
    }));
  });
}
function ab() {
  const { app: e, isInitialized: t } = Nt(Tp);
  return S(() => t.value ? e.ticker : void 0);
}
const sb = ["texture", "width", "height", "alpha", "tint"], Mp = /* @__PURE__ */ J({
  __name: "DesignPreview",
  setup(e) {
    const {
      error: t,
      fetchStatus: n,
      isPlaceholderData: o,
      placeholderColor: a,
      size: s,
      texture: i
    } = Nt(Xl), r = S(() => n.value === "fetching"), c = N(1);
    return qo(
      (u) => {
        c.value = Math.sin(u.lastTime / 1e3 * Math.PI) * 0.25 + 0.5;
      },
      { enabled: r }
    ), (u, d) => l(i) && l(s) ? ($(), E("PixiSprite", {
      key: 0,
      label: "DesignPreview",
      texture: l(i),
      width: l(s).width,
      height: l(s).height,
      alpha: l(t) ? 0.5 : r.value ? c.value : 1,
      tint: l(t) ? 16711680 : l(o) ? l(a) : void 0
    }, null, 8, sb)) : Q("", !0);
  }
}), ib = ["angle", "scale", "position", "pivot"], rb = ["context"], lb = ["context", "x", "y", "cursor"], cb = ["context", "x", "y"], ub = ["context", "x", "y"], db = /* @__PURE__ */ J({
  __name: "DesignControls",
  props: {
    deleteable: { type: Boolean },
    deleteIcon: {},
    designBounds: { default: void 0 },
    hidden: { type: Boolean },
    padding: { default: 3 },
    resizeable: { type: Boolean },
    resizeIcon: {},
    rotateable: { type: Boolean },
    rotateIcon: {},
    rotateStep: { default: void 0 },
    rotationControlLength: { default: 15 }
  },
  setup(e) {
    const t = e, {
      deleteable: n,
      deleteIcon: o,
      designBounds: a,
      hidden: s,
      padding: i,
      resizeable: r,
      resizeIcon: c,
      rotateable: u,
      rotateIcon: d,
      rotateStep: p,
      rotationControlLength: _
    } = we(t), { data: y } = Nt(Ap), { size: k, texture: w } = Nt(Xl), { data: f } = Nt(ia), { worldScale: g } = Nt(sa), b = N(), A = N(0), P = N(1), I = N(1), D = S(() => P.value * I.value), R = S(() => g.value * D.value), U = S(
      () => k.value ? { x: k.value.width / 2, y: k.value.height / 2 } : void 0
    ), G = new Ss();
    se(() => {
      if (G.clear(), s.value || !k.value) return;
      const ae = i.value;
      G.rect(
        -ae,
        -ae,
        k.value.width + ae * 2,
        k.value.height + ae * 2
      ), u.value && G.moveTo(k.value.width / 2, -ae).lineTo(
        k.value.width / 2,
        -ae - _.value
      ), G.stroke({
        alignment: 0,
        color: 11717887,
        width: 1 / R.value
      });
    });
    function F(ae) {
      const _e = S(() => {
        const Ne = Math.min(20 / ae.value.width, 20 / ae.value.height);
        return {
          height: ae.value.height * Ne,
          width: ae.value.width * Ne
        };
      }), _t = S(
        () => `data:image/svg+xml;base64,${btoa(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${ae.value.width.toString()} ${ae.value.height.toString()}" width="${(_e.value.width * 2).toString()}px" height="${(_e.value.height * 2).toString()}px"><path d="${ae.value.path}"/></svg>`)}`
      ), { data: St } = Zl(_t), et = new Ss();
      return se(() => {
        if (et.clear(), s.value || !St.value) return;
        const Ne = {
          height: _e.value.height / R.value * 10,
          width: _e.value.width / R.value * 10
        };
        et.circle(0, 0, 15 / R.value * 10).fill({ color: 16777215 }).stroke({
          alignment: 0,
          color: 0,
          width: 1 / R.value * 10
        }).texture(
          St.value,
          16777215,
          -Ne.width / 2,
          -Ne.height / 2,
          Ne.width,
          Ne.height
        );
      }), et;
    }
    const de = F(d), K = F(o), ce = F(c), ue = N();
    function Ae(ae) {
      ae.stopPropagation(), f.value.designs = f.value.designs.filter(
        (_e) => _e !== y.value
      );
    }
    function te(ae) {
      if (!ue.value) return;
      ae.stopPropagation(), ue.value = void 0;
      let _e = A.value;
      p.value && (_e = Math.round(_e / p.value) * p.value), y.value.rotation = ci(
        y.value.rotation + _e
      ), A.value = 0;
    }
    function X(ae) {
      if (!b.value || !U.value || !ue.value) return;
      const { x: _e, y: _t } = U.value, { x: St, y: et } = ue.value, { x: Ne, y: xe } = b.value.parent.worldTransform.applyInverse(
        ae.global
      );
      if (St === Ne && et === xe) {
        A.value = 0;
        return;
      }
      const Fe = St - _e, Ke = et - _t, at = Ne - _e, mt = xe - _t, Ht = Math.acos(
        (Fe * at + Ke * mt) / (Math.hypot(Fe, Ke) * Math.hypot(at, mt))
      );
      A.value = G2(
        Fe * mt - Ke * at < 0 ? 2 * Math.PI - Ht : Ht
      );
    }
    function ee(ae) {
      b.value && (ae.stopPropagation(), ue.value = b.value.parent.worldTransform.applyInverse(
        ae.global
      ), X(ae));
    }
    const ie = S(
      () => !s.value && r.value && _l(y.value.design)
    ), he = S(() => a.value ? hl(
      y.value.design,
      a.value
    ) : { max: 1 / 0, min: -1 / 0 }), ve = N();
    function ze(ae) {
      ve.value && (ae.stopPropagation(), ve.value = void 0, P.value !== 1 && (vl(
        y.value.design,
        P.value,
        a.value
      ), I.value = P.value, P.value = 1));
    }
    function ot(ae) {
      if (!b.value || !U.value || !ve.value) return;
      const { x: _e, y: _t } = b.value.parent.worldTransform.applyInverse(
        ae.global
      );
      P.value = $n(
        Math.sqrt(
          (Math.pow(U.value.x - _e, 2) + Math.pow(U.value.y - _t, 2)) / ve.value
        ),
        he.value.min,
        he.value.max
      );
    }
    function Ie(ae) {
      if (!b.value || !U.value) return;
      ae.stopPropagation();
      const { x: _e, y: _t } = b.value.parent.worldTransform.applyInverse(
        ae.global
      );
      ve.value = Math.pow(U.value.x - _e, 2) + Math.pow(U.value.y - _t, 2), ot(ae);
    }
    return pt(w, () => {
      I.value = 1;
    }), (ae, _e) => ($(), E("PixiContainer", {
      ref_key: "container",
      ref: b,
      label: "DesignControls",
      angle: A.value,
      scale: D.value,
      position: U.value,
      pivot: U.value
    }, [
      Et(ae.$slots, "default", {}, () => [
        x(Mp)
      ]),
      l(s) ? Q("", !0) : ($(), E("PixiGraphics", {
        key: 0,
        label: "DesignControls_Border",
        context: l(G)
      }, null, 8, rb)),
      !l(s) && l(k) && l(u) ? ($(), E("PixiGraphics", {
        key: 1,
        label: "DesignControls_Rotate",
        context: l(de),
        x: l(k).width / 2,
        y: -l(i) - l(_),
        scale: 0.1,
        "event-mode": "static",
        cursor: ue.value ? "grabbing" : "grab",
        onPointerdown: ee,
        onGlobalpointermove: X,
        onPointerup: te,
        onPointerupoutside: te,
        onPointercancel: te
      }, null, 40, lb)) : Q("", !0),
      !l(s) && l(k) && l(n) ? ($(), E("PixiGraphics", {
        key: 2,
        label: "DesignControls_Delete",
        context: l(K),
        x: -l(i),
        y: l(k).height + l(i),
        scale: 0.1,
        "event-mode": "static",
        cursor: "pointer",
        onPointerdown: Ae
      }, null, 40, cb)) : Q("", !0),
      ie.value && l(k) ? ($(), E("PixiGraphics", {
        key: 3,
        label: "DesignControls_Resize",
        context: l(ce),
        x: l(k).width + l(i),
        y: l(k).height + l(i),
        scale: 0.1,
        "event-mode": "static",
        cursor: "nwse-resize",
        onPointerdown: Ie,
        onGlobalpointermove: ot,
        onPointerup: ze,
        onPointerupoutside: ze,
        onPointercancel: ze
      }, null, 40, ub)) : Q("", !0)
    ], 8, ib));
  }
});
function mb(e) {
  let t;
  function n(a) {
    t = a.global.clone();
  }
  function o(a) {
    !t || Fs(a.global, t) > 10 || e(a);
  }
  return { onPointerdown: n, onPointerup: o };
}
const Ip = rt(
  "designer-core.designerCore",
  () => {
    const { pixelRatio: e } = Ph();
    return { devicePixelRatio: e };
  }
);
function Ur({ x: e, y: t }, n, o) {
  return {
    x: (o.x + o.width / 2 - e) / n,
    y: (o.y + o.height / 2 - t) / n
  };
}
function hs({ x: e, y: t }, n, o) {
  return {
    x: o.x + o.width / 2 - e * n,
    y: o.y + o.height / 2 - t * n
  };
}
const pb = {
  axis: "all",
  factor: 1,
  noDrag: !1,
  percent: 1,
  position: void 0
};
class fb extends zl {
  /**
   * This is called by {@link Viewport.pinch}.
   */
  constructor(t, n = {}) {
    super(t), fn(this, "active", !1), fn(this, "options"), fn(this, "pinching", !1), fn(this, "lastCenter"), fn(this, "moved", !1), this.options = Object.assign({}, pb, n);
  }
  down() {
    return this.parent.input.count() >= 2 ? (this.active = !0, !0) : !1;
  }
  isAxisX() {
    return ["all", "x"].includes(this.options.axis);
  }
  isAxisY() {
    return ["all", "y"].includes(this.options.axis);
  }
  move(t) {
    if (this.paused || !this.active)
      return !1;
    const n = t.global.x, o = t.global.y, a = this.parent.input.touches;
    if (a.length >= 2) {
      const s = a[0], i = a[1], r = s.last && i.last ? Math.sqrt(
        Math.pow(i.last.x - s.last.x, 2) + Math.pow(i.last.y - s.last.y, 2)
      ) : void 0;
      if (s.id === t.pointerId ? s.last = { data: t, x: n, y: o } : i.id === t.pointerId && (i.last = { data: t, x: n, y: o }), r) {
        let c;
        const u = new f_(
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          s.last.x + (i.last.x - s.last.x) / 2,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          s.last.y + (i.last.y - s.last.y) / 2
        );
        this.options.position || (c = this.parent.toLocal(u));
        let d = Math.sqrt(
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          Math.pow(i.last.x - s.last.x, 2) + // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          Math.pow(i.last.y - s.last.y, 2)
        );
        d = d === 0 ? d = 1e-10 : d;
        const p = (1 - r / d) * this.options.percent * (this.isAxisX() ? this.parent.scale.x : this.parent.scale.y);
        this.isAxisX() && (this.parent.scale.x += p), this.isAxisY() && (this.parent.scale.y += p), this.parent.emit("zoomed", {
          center: u,
          type: "pinch",
          viewport: this.parent
        });
        const _ = this.parent.plugins.get("clamp-zoom", !0);
        if (_ && _.clamp(), this.options.position)
          this.options.position();
        else {
          const y = this.parent.toGlobal(c);
          this.parent.x += (u.x - y.x) * this.options.factor, this.parent.y += (u.y - y.y) * this.options.factor, this.parent.emit("moved", {
            type: "pinch",
            viewport: this.parent
          });
        }
        !this.options.noDrag && this.lastCenter && (this.parent.x += (u.x - this.lastCenter.x) * this.options.factor, this.parent.y += (u.y - this.lastCenter.y) * this.options.factor, this.parent.emit("moved", {
          type: "pinch",
          viewport: this.parent
        })), this.lastCenter = u, this.moved = !0;
      } else this.pinching || (this.parent.emit("pinch-start", this.parent), this.pinching = !0);
      return !0;
    }
    return !1;
  }
  up() {
    return this.pinching && this.parent.input.touches.length <= 1 ? (this.active = !1, this.lastCenter = void 0, this.pinching = !1, this.moved = !1, this.parent.emit("pinch-end", this.parent), !0) : !1;
  }
}
const hb = {
  axis: "all",
  interrupt: !0,
  keyToPress: void 0,
  lineHeight: 20,
  percent: 0.1,
  position: void 0,
  reverse: !1,
  smooth: !1,
  trackpadPinch: !1,
  wheelZoom: !0
};
class _b extends zl {
  /**
   * This is called by {@link Viewport.wheel}.
   */
  constructor(t, n = {}) {
    super(t), fn(this, "options"), fn(this, "keyIsPressed"), fn(this, "smoothing"), fn(this, "smoothingCenter"), fn(this, "smoothingCount"), this.options = Object.assign({}, hb, n), this.keyIsPressed = !1, this.options.keyToPress && this.handleKeyPresses(this.options.keyToPress);
  }
  down() {
    return this.options.interrupt && (this.smoothing = void 0), !1;
  }
  update() {
    if (this.smoothing) {
      const t = this.smoothingCenter, n = this.smoothing;
      let o;
      this.options.position || (o = this.parent.toLocal(t)), this.isAxisX() && (this.parent.scale.x += n.x), this.isAxisY() && (this.parent.scale.y += n.y), this.parent.emit("zoomed", {
        type: "wheel",
        viewport: this.parent
      });
      const a = this.parent.plugins.get("clamp-zoom", !0);
      if (a && a.clamp(), this.options.position)
        this.options.position();
      else {
        const s = this.parent.toGlobal(o);
        this.parent.x += t.x - s.x, this.parent.y += t.y - s.y;
      }
      this.parent.emit("moved", { type: "wheel", viewport: this.parent }), this.smoothingCount++, this.options.smooth && // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.smoothingCount >= this.options.smooth && (this.smoothing = void 0);
    }
  }
  wheel(t) {
    if (this.paused || !this.checkKeyPress())
      return !1;
    if (t.ctrlKey && this.options.trackpadPinch)
      this.pinch(t);
    else if (this.options.wheelZoom) {
      const n = this.parent.input.getPointerPosition(t), o = (this.options.reverse ? -1 : 1) * -t.deltaY * (t.deltaMode ? this.options.lineHeight : 1) / 500, a = Math.pow(2, (1 + this.options.percent) * o);
      if (this.options.smooth) {
        const s = {
          x: this.smoothing ? this.smoothing.x * // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          (this.options.smooth - this.smoothingCount) : 0,
          y: this.smoothing ? this.smoothing.y * // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          (this.options.smooth - this.smoothingCount) : 0
        };
        this.smoothing = {
          x: ((this.parent.scale.x + s.x) * a - this.parent.scale.x) / this.options.smooth,
          y: ((this.parent.scale.y + s.y) * a - this.parent.scale.y) / this.options.smooth
        }, this.smoothingCount = 0, this.smoothingCenter = n;
      } else {
        let s;
        this.options.position || (s = this.parent.toLocal(n)), this.isAxisX() && (this.parent.scale.x *= a), this.isAxisY() && (this.parent.scale.y *= a), this.parent.emit("zoomed", {
          type: "wheel",
          viewport: this.parent
        });
        const i = this.parent.plugins.get("clamp-zoom", !0);
        if (i && i.clamp(), this.options.position)
          this.options.position();
        else {
          const r = this.parent.toGlobal(s);
          this.parent.x += n.x - r.x, this.parent.y += n.y - r.y;
        }
      }
      this.parent.emit("moved", { type: "wheel", viewport: this.parent }), this.parent.emit("wheel-start", {
        event: t,
        viewport: this.parent
      });
    }
    return !this.parent.options.passiveWheel;
  }
  checkKeyPress() {
    return !this.options.keyToPress || this.keyIsPressed;
  }
  /**
   * Handles keypress events and set the keyIsPressed boolean accordingly
   *
   * @param {array} codes - key codes that can be used to trigger zoom event
   */
  handleKeyPresses(t) {
    globalThis.addEventListener("keydown", (n) => {
      t.includes(n.code) && (this.keyIsPressed = !0);
    }), globalThis.addEventListener("keyup", (n) => {
      t.includes(n.code) && (this.keyIsPressed = !1);
    });
  }
  isAxisX() {
    return ["all", "x"].includes(this.options.axis);
  }
  isAxisY() {
    return ["all", "y"].includes(this.options.axis);
  }
  pinch(t) {
    if (this.paused)
      return;
    const n = this.parent.input.getPointerPosition(t), o = -t.deltaY * (t.deltaMode ? this.options.lineHeight : 1) / 200, a = Math.pow(2, (1 + this.options.percent) * o);
    let s;
    this.options.position || (s = this.parent.toLocal(n)), this.isAxisX() && (this.parent.scale.x *= a), this.isAxisY() && (this.parent.scale.y *= a), this.parent.emit("zoomed", { type: "wheel", viewport: this.parent });
    const i = this.parent.plugins.get("clamp-zoom", !0);
    if (i && i.clamp(), this.options.position)
      this.options.position();
    else {
      const r = this.parent.toGlobal(s);
      this.parent.x += n.x - r.x, this.parent.y += n.y - r.y;
    }
    this.parent.emit("moved", { type: "wheel", viewport: this.parent }), this.parent.emit("wheel-start", {
      event: t,
      viewport: this.parent
    });
  }
}
const vb = {
  stage: void 0
};
class gb extends zl {
  constructor(t, n = {}) {
    super(t), fn(this, "options"), fn(this, "last"), this.options = Object.assign({}, vb, n), this.update();
  }
  move() {
    return this.update(), !1;
  }
  reset() {
    this.update();
  }
  update() {
    if (this.paused) return;
    let t, n;
    const o = this.options.stage;
    o ? (t = $n(
      this.parent.x,
      -this.parent.screenWorldWidth + o.x,
      o.x + o.width
    ), n = $n(
      this.parent.y,
      -this.parent.screenWorldHeight + o.y,
      o.y + o.height
    )) : (t = $n(
      this.parent.x,
      -this.parent.screenWorldWidth,
      this.parent.screenWidth
    ), n = $n(
      this.parent.y,
      -this.parent.screenWorldHeight,
      this.parent.screenHeight
    )), this.parent.position.set(t, n);
  }
}
const yb = ["text"], kb = ["context"], bb = /* @__PURE__ */ J({
  __name: "DebugInfo",
  props: {
    stage: {}
  },
  setup(e) {
    const t = e, { stage: n } = we(t), o = N(0);
    let a = 0, s = Date.now();
    qo(() => {
      if (a === 0) {
        const r = Date.now(), c = r - s;
        s = r, o.value = 3e4 / c;
      }
      a = (a + 1) % 30;
    });
    const i = new Ss();
    return se(() => {
      i.clear(), n.value && i.rect(
        n.value.x,
        n.value.y,
        n.value.width,
        n.value.height
      ).stroke({ alignment: 0, color: 16711935, width: 5 });
    }), (r, c) => ($(), E(me, null, [
      z("PixiText", {
        text: `FPS: ${Math.round(o.value * 100) / 100}`,
        style: { fontSize: 20 }
      }, null, 8, yb),
      z("PixiGraphics", { context: l(i) }, null, 8, kb)
    ], 64));
  }
}), wb = ["events", "screen-width", "screen-height", "world-width", "world-height"], qa = /* @__PURE__ */ J({
  __name: "DesignerCore",
  props: {
    clampZoom: {},
    debug: { type: Boolean },
    draggable: { type: Boolean },
    stage: {}
  },
  emits: ["click", "update:zoom"],
  setup(e, { expose: t, emit: n }) {
    const o = e, { clampZoom: a, debug: s, draggable: i, stage: r } = we(o), c = n, u = N(), d = N(), p = N(), _ = S(() => {
      var X;
      return (X = u.value) == null ? void 0 : X.canvas;
    }), y = N(), k = N([]), w = N([]), {
      onPointerdown: f,
      onPointerup: g
    } = mb((X) => {
      c("click", X);
    }), { devicePixelRatio: b } = L(Ip()), A = N({ height: 5, width: 5 });
    se((X) => {
      if (!_.value) return;
      const ee = new ResizeObserver(([ie]) => {
        var he;
        ie && (A.value = (he = ie.devicePixelContentBoxSize) != null && he[0] ? {
          height: Math.max(
            ie.devicePixelContentBoxSize[0].blockSize / b.value,
            5
          ),
          width: Math.max(
            ie.devicePixelContentBoxSize[0].inlineSize / b.value,
            5
          )
        } : {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          height: Math.max(ie.contentBoxSize[0].blockSize, 5),
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          width: Math.max(ie.contentBoxSize[0].inlineSize, 5)
        });
      });
      try {
        ee.observe(_.value, {
          box: "device-pixel-content-box"
        });
      } catch {
        ee.observe(_.value, { box: "content-box" });
      }
      X(() => {
        ee.disconnect();
      });
    });
    const P = S(() => {
      var X, ee;
      const ie = r.value ?? A.value;
      return {
        height: Math.max(ie.height, 5),
        width: Math.max(ie.width, 5),
        x: ((X = r.value) == null ? void 0 : X.x) ?? 0,
        y: ((ee = r.value) == null ? void 0 : ee.y) ?? 0
      };
    });
    pt(P, (X, ee) => {
      const ie = d.value;
      if (!ie) return;
      const he = Math.min(X.height, X.width) / Math.min(ee.height, ee.width) * ie.scale.x;
      ce(
        hs(
          Ur(ie.position, ie.scale.x, ee),
          he,
          X
        ),
        he,
        !1
      );
    });
    const I = S(
      () => y.value ? Math.min(
        P.value.width / y.value.width,
        P.value.height / y.value.height
      ) : 1
    ), D = S(
      () => a.value ? {
        max: a.value.max * I.value,
        min: a.value.min * I.value
      } : void 0
    ), R = S(
      () => {
        var X;
        return (X = u.value) != null && X.isInitialized ? u.value.app.ticker : void 0;
      }
    ), U = N(1);
    qo(
      () => {
        var X;
        U.value = ((X = d.value) == null ? void 0 : X.scale.x) ?? 1;
      },
      { ticker: R }
    );
    const G = N();
    qo(
      ({ deltaTime: X }) => {
        const ee = G.value;
        if (!ee) return;
        const ie = d.value;
        if (!ie) return;
        const { scale: he } = ie;
        ud(
          he,
          ee,
          X
        ) < 1e-3 && (he.set(ee), G.value = void 0);
      },
      { enabled: () => !!(G.value && d.value), ticker: R }
    );
    const F = N();
    qo(
      ({ deltaTime: X }) => {
        const ee = F.value;
        if (!ee) return;
        const ie = d.value;
        if (!ie) return;
        const { position: he } = ie;
        ud(
          he,
          ee,
          X
        ) < 0.5 && (he.set(ee.x, ee.y), F.value = void 0);
      },
      {
        enabled: () => !!(F.value && d.value),
        ticker: R
      }
    );
    const de = S(
      () => G.value !== void 0 || F.value !== void 0
    );
    function K({ height: X, width: ee, x: ie, y: he }, ve = !0) {
      const ze = P.value, ot = D.value, Ie = $n(
        Math.min(ze.width / ee, ze.height / X),
        (ot == null ? void 0 : ot.min) ?? 0,
        (ot == null ? void 0 : ot.max) ?? 1 / 0
      );
      ce(
        hs({ x: ee / 2 + ie, y: X / 2 + he }, Ie, ze),
        Ie,
        ve
      );
    }
    function ce(X, ee, ie = !0) {
      if (ie)
        G.value = ee, F.value = X;
      else {
        const he = d.value;
        if (!he) throw new Error("Viewport not initialized yet");
        he.scale.set(ee), he.position.set(X.x, X.y);
      }
    }
    function ue(X, ee = !0) {
      const ie = d.value;
      if (!ie) return;
      const he = P.value, ve = D.value, ze = $n(
        X * I.value,
        (ve == null ? void 0 : ve.min) ?? 0,
        (ve == null ? void 0 : ve.max) ?? 1 / 0
      );
      ce(
        hs(
          Ur(ie.position, ie.scale.x, he),
          ze,
          he
        ),
        ze,
        ee
      );
    }
    se(() => {
      c(
        "update:zoom",
        (G.value ?? U.value) / I.value
      );
    }), se(() => {
      const X = d.value;
      if (!X) return;
      X.drag({ wheel: !1 }).decelerate({ friction: 0.9 }).clampZoom({});
      const ee = X.plugins;
      ee.add(
        "wheel",
        new _b(X, { smooth: 10 })
      ), ee.add("pinch", new fb(X)), ee.add("clamp", new gb(X));
    }), se(() => {
      const X = d.value;
      if (!X) return;
      const ee = X.plugins.get("clamp");
      ee && (ee.options.stage = { ...P.value });
    }), se(() => {
      const X = d.value;
      if (!X) return;
      const ee = X.plugins, ie = ee.get("wheel"), he = ee.get("pinch"), ve = ee.get("clamp-zoom");
      D.value ? (ie == null || ie.resume(), he == null || he.resume(), ve && (ve.options.minScale = D.value.min, ve.options.maxScale = D.value.max, ve.resume())) : (ie == null || ie.pause(), he == null || he.pause(), ve && (ve.pause(), ve.options.minScale = null, ve.options.maxScale = null));
    }), se(() => {
      const X = d.value;
      if (!X) return;
      const ee = X.plugins, ie = ee.get("wheel"), he = ee.get("pinch"), ve = ee.get("drag");
      if (i.value)
        ve == null || ve.resume(), ie && (ie.options.position = void 0), he && (he.options.position = void 0, he.options.noDrag = !1);
      else {
        let ze = function() {
          const Ie = d.value;
          if (!Ie) return;
          const { x: ae, y: _e } = hs(
            ot,
            Ie.scale.x,
            P.value
          );
          Ie.position.set(ae, _e);
        };
        ve == null || ve.pause();
        const ot = Ur(
          X.position,
          X.scale.x,
          P.value
        );
        ie && (ie.options.position = ze), he && (he.options.position = ze, he.options.noDrag = !0);
      }
    });
    function Ae(X) {
      f(X), F.value = void 0, G.value = void 0;
    }
    function te() {
      F.value = void 0, G.value = void 0;
    }
    return $o(sa, {
      clampScale: D,
      fetching: w,
      rendering: k,
      scaleMultiplier: I,
      setPosition: K,
      topLayer: p,
      worldScale: U,
      worldSize: y
    }), t({ canvas: _, setPosition: K, setZoom: ue }), (X, ee) => ($(), H(l(ob), {
      ref_key: "appData",
      ref: u,
      "background-color": 16777215,
      width: A.value.width,
      height: A.value.height,
      resolution: l(b),
      "data-animating": de.value,
      "data-rendering": k.value.length > 0,
      "data-fetching": w.value.length > 0,
      preference: "webgl",
      "power-preference": "low-power",
      "preserve-drawing-buffer": !0,
      legacy: !0,
      "auto-density": !1,
      antialias: !0
    }, {
      default: M(() => {
        var ie, he, ve;
        return [
          (ie = u.value) != null && ie.isInitialized && A.value ? ($(), E("PixiViewport", {
            key: 0,
            ref_key: "viewport",
            ref: d,
            events: u.value.app.renderer.events,
            "allow-preserve-drag-outside": !0,
            "passive-wheel": !1,
            "stop-propagation": !0,
            "screen-width": A.value.width,
            "screen-height": A.value.height,
            "world-width": (he = y.value) == null ? void 0 : he.width,
            "world-height": (ve = y.value) == null ? void 0 : ve.height,
            onPointerdown: Ae,
            onPointerup: ee[0] || (ee[0] = //@ts-ignore
            (...ze) => l(g) && l(g)(...ze)),
            onWheel: te
          }, [
            Et(X.$slots, "default"),
            z("PixiRenderLayer", {
              ref_key: "topLayer",
              ref: p
            }, null, 512)
          ], 40, wb)) : Q("", !0),
          l(s) ? ($(), H(bb, {
            key: 1,
            stage: P.value
          }, null, 8, ["stage"])) : Q("", !0)
        ];
      }),
      _: 3
    }, 8, ["width", "height", "resolution", "data-animating", "data-rendering", "data-fetching"]));
  }
}), xb = ["position", "event-mode", "cursor"], $b = /* @__PURE__ */ J({
  __name: "Draggable",
  props: {
    disabled: { type: Boolean }
  },
  emits: ["update:point"],
  setup(e, { emit: t }) {
    const n = e, { disabled: o } = we(n), a = t, s = N(), i = N(), r = N(), c = S(() => {
      if (!r.value || !i.value || !s.value)
        return { x: 0, y: 0 };
      const _ = s.value.parent.worldTransform.applyInverse(
        r.value
      );
      return {
        x: _.x - i.value.x,
        y: _.y - i.value.y
      };
    });
    se(() => {
      a("update:point", r.value);
    });
    function u(_) {
      i.value && (_ == null || _.stopPropagation(), i.value = void 0, r.value = void 0);
    }
    function d(_) {
      o.value || !r.value || r.value.copyFrom(_.global);
    }
    function p(_) {
      o.value || !s.value || (_.stopPropagation(), i.value = s.value.worldTransform.applyInverse(_.global), r.value = _.global.clone(), d(_));
    }
    return pt(o, () => {
      o.value && u();
    }), (_, y) => ($(), E("PixiContainer", {
      ref_key: "container",
      ref: s,
      label: "Draggable",
      position: c.value,
      "event-mode": l(o) ? "passive" : "static",
      cursor: r.value ? "grabbing" : "grab",
      onPointerdown: p,
      onGlobalpointermove: d,
      onPointerup: u,
      onPointerupoutside: u,
      onPointercancel: u
    }, [
      Et(_.$slots, "default")
    ], 40, xb));
  }
});
function zb(e, t, n, o) {
  let a = 0, s = 0;
  for (let i = 0; i < t.length; i++) {
    const r = t[i], c = t[(i + 1) % t.length], u = c.x - r.x, d = c.y - r.y, p = Math.hypot(u, d), _ = { x: u / p, y: d / p };
    let y = 0;
    for (e.moveTo(
      r.x + s * _.x,
      r.y + s * _.y
    ); y <= p; )
      y += s + (a > 0 ? a : n), y > p ? (a = y - p, y = p) : a = 0, e.lineTo(
        r.x + y * _.x,
        r.y + y * _.y
      ), y += o, y > p && a === 0 ? s = y - p : (s = 0, e.moveTo(
        r.x + y * _.x,
        r.y + y * _.y
      ));
  }
}
const Sb = ["x", "y", "pivot", "angle"], Cb = ["context"], Ab = ["resolution", "text", "position"], Ba = /* @__PURE__ */ J({
  __name: "PositioningArea",
  props: {
    data: {},
    fillColor: { default: () => new Uint8Array([0, 0, 0, 0]) },
    hidden: { type: Boolean },
    strokeColor: { default: 4605510 }
  },
  setup(e) {
    const t = e, { data: n, fillColor: o, hidden: a, strokeColor: s } = we(t), { devicePixelRatio: i } = L(Ip()), { clampScale: r, scaleMultiplier: c, worldScale: u } = Nt(sa), d = S(
      () => r.value ? 7 / c.value : 14 / u.value
    ), p = S(
      () => r.value ? 5 / c.value : 10 / u.value
    ), _ = S(
      () => r.value ? Math.max(2 / c.value, 1 / u.value) : 4 / u.value
    ), y = new Ss();
    se(() => {
      y.clear(), !a.value && (zb(
        y,
        [
          { x: 0, y: 0 },
          { x: n.value.width, y: 0 },
          { x: n.value.width, y: n.value.height },
          { x: 0, y: n.value.height }
        ],
        d.value,
        p.value
      ), y.stroke({
        alignment: 1,
        color: s.value,
        width: _.value
      }), y.rect(0, 0, n.value.width, n.value.height).fill({ color: o.value }));
    });
    const k = S(() => ({
      x: n.value.width * // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      Ko(n.value.position[1]),
      y: n.value.height * // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      Ko(n.value.position[0])
    })), w = S(
      () => Math.max(16 / c.value, 12 / u.value)
    ), f = S(
      () => {
        var b;
        return Math.min(
          i.value * Math.max(((b = r.value) == null ? void 0 : b.max) ?? u.value, 1),
          // fontSize * textResolution should be capped at 3500 because otherwise
          // the designer starts to lag, trying to render very large texts
          3500 / w.value
        );
      }
    ), g = S(() => ({
      x: n.value.width / 2,
      y: n.value.height / 2
    }));
    return $o(ia, { data: n }), (b, A) => ($(), E("PixiContainer", {
      label: "PositioningArea",
      x: l(n).x,
      y: l(n).y,
      pivot: k.value,
      angle: l(n).rotation
    }, [
      z("PixiGraphics", {
        label: "PositioningArea_Graphics",
        context: l(y)
      }, null, 8, Cb),
      l(n).handle && l(n).designs.length === 0 && !l(a) ? ($(), E("PixiText", {
        key: 0,
        resolution: f.value,
        text: l(n).handle,
        style: Qt({
          fill: l(s),
          fontSize: w.value,
          fontWeight: "600",
          trim: !0
        }),
        position: g.value,
        anchor: {
          x: 0.5,
          y: 0.5
        }
      }, null, 12, Ab)) : Q("", !0),
      Et(b.$slots, "default")
    ], 8, Sb));
  }
}), qs = { height: 580, width: 520 };
function Eo(e) {
  return e.elements.length > 0 ? {
    children: e.elements.map((t) => ({
      anchor: t.alignment.anchor_value,
      offset: {
        x: t.alignment.offset.x,
        y: t.alignment.offset.y
      },
      value: Eo(t)
    })),
    parent: md(e),
    type: $e.ANCHOR
  } : md(e);
}
function Jl(e) {
  let t;
  return e.width !== null && e.height !== null && e.min_width !== null && e.min_height !== null && e.max_width !== null && e.max_height !== null && e.min_width < e.max_width && e.min_height < e.max_height && (t = { height: e.height, width: e.width }), {
    colorAssignments: e.color_assignments.map((n) => ({
      id: n.id,
      color: n.color ? { id: n.color.id } : {
        blue: n.blue,
        green: n.green,
        red: n.red
      }
    })),
    logoId: e.id,
    size: t,
    type: $e.LOGO
  };
}
function Ep(e, t) {
  return {
    id: e.id,
    designs: t.customizations.filter(
      (n) => n.positioningArea.id === e.id
    ).map((n) => ({
      design: Eo(
        n.design.elements[0]
      ),
      rotation: n.rotation - e.rotation
    })),
    handle: e.positioning_area_identifier_handle ?? void 0,
    height: e.localized_height,
    position: e.position,
    productionMethodId: e.production_method.id,
    rotation: e.rotation,
    width: e.localized_width,
    x: e.x / t.scalefactor,
    y: e.y / t.scalefactor
  };
}
function Yl(e) {
  return {
    handle: e.handle,
    height: qs.height / e.scalefactor,
    imageUrl: e.image_urls.xl,
    positioningAreas: [...e.positioning_areas].sort((t, n) => t.order_column - n.order_column).map(
      (t) => Ep(t, e)
    ),
    width: qs.width / e.scalefactor
  };
}
function Qo({
  design: e,
  productionMethodId: t
}) {
  switch (e.type) {
    case $e.ANCHOR:
      return {
        ...Qo({
          design: e.parent,
          productionMethodId: t
        }),
        elements: e.children.map((n) => ({
          ...Qo({
            design: n.value,
            productionMethodId: t
          }),
          alignment: {
            anchor_type: na.OUTER,
            anchor_value: n.anchor,
            offset: { x: n.offset.x, y: n.offset.y },
            rotation: 0
          }
        }))
      };
    case $e.LOGO:
      return {
        dimension: e.size,
        elements: [],
        resource: {
          id: e.logoId,
          color_assignments: e.colorAssignments.map(
            ({ id: n, color: o }) => "id" in o ? { id: n, color: { id: o.id } } : {
              id: n,
              blue: o.blue,
              green: o.green,
              red: o.red
            }
          ),
          production_method: { id: t }
        },
        resource_type: "logo"
      };
    case $e.TEXT:
      return {
        elements: [],
        resource: {
          lines: e.lines.map((n) => ({
            bending_radius: n.bendingRadius,
            color_assignments: [
              "id" in n.color ? { color: { id: n.color.id } } : {
                blue: n.color.blue,
                green: n.color.green,
                red: n.color.red
              }
            ],
            font: { id: n.fontId },
            font_size: n.size,
            horizontal_alignment: n.horizontalAlignment,
            offset: n.offsetLeft,
            order_column: 1,
            padding_bottom: n.paddingBottom,
            value: n.text
          })),
          production_method: { id: t }
        },
        resource_type: "text"
      };
  }
}
function Op(e) {
  return {
    customizations: e.positioningAreas.filter((t) => !!t.id).flatMap(
      (t) => t.designs.flatMap((n) => ({
        design: {
          elements: [
            Qo({
              design: n.design,
              productionMethodId: t.productionMethodId
            })
          ],
          production_method: {
            id: t.productionMethodId
          }
        },
        order: 0,
        position: Pb(
          t,
          n
        ),
        positioning_area: {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          id: t.id
        },
        rotation: n.rotation + t.rotation,
        x: Math.round(
          qs.width / e.width * t.x
        ),
        y: Math.round(
          qs.height / e.height * t.y
        )
      }))
    ),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    handle: e.handle
  };
}
function md(e) {
  return e.resource_type === "text" ? {
    lines: e.resource.lines.map((t) => {
      const n = t.color_assignments[0];
      return {
        bendingRadius: t.bending_radius,
        color: n.color ? { id: n.color.id } : {
          blue: n.blue,
          green: n.green,
          red: n.red
        },
        fontId: t.font.id,
        horizontalAlignment: t.horizontal_alignment,
        offsetLeft: t.offset,
        paddingBottom: t.padding_bottom,
        size: t.font_size,
        text: t.value
      };
    }),
    type: $e.TEXT
  } : {
    colorAssignments: e.resource.color_assignments.map(
      (t) => ({
        id: t.id,
        color: t.color ? { id: t.color.id } : {
          blue: t.blue,
          green: t.green,
          red: t.red
        }
      })
    ),
    logoId: e.resource.id,
    size: e.dimension ? {
      height: e.dimension.height,
      width: e.dimension.width
    } : void 0,
    type: $e.LOGO
  };
}
function Pb(e, t) {
  const n = l2(
    e.position
  );
  return n === void 0 ? e.position : r2(
    ci(
      n - t.rotation
    )
  ) ?? e.position;
}
function Bs(e) {
  switch (e.type) {
    case $e.ANCHOR: {
      const t = Bs(e.parent);
      if (!t)
        throw new Error(
          "Normalized parent of anchor design is undefined"
        );
      const n = e.children.map((o) => {
        const a = Bs(o.value);
        return a ? { ...o, value: a } : void 0;
      }).filter((o) => o !== void 0);
      return n.length === 0 ? t : {
        children: n,
        parent: t,
        type: $e.ANCHOR
      };
    }
    case $e.LOGO:
      return e;
    case $e.TEXT: {
      const t = {
        lines: e.lines.map((n) => ({ ...n, text: n.text.trim() })).filter((n) => n.text),
        type: $e.TEXT
      };
      return t.lines.length === 0 ? void 0 : t;
    }
  }
}
function ui(e, t) {
  const n = S(
    () => e.value ? Bs(e.value.design) : void 0
  ), o = S(() => (t == null ? void 0 : t.value) ?? !0), a = S(() => {
    if (!e.value || !n.value) return;
    const y = e.value.productionMethodId;
    return {
      elements: [
        Qo({
          design: n.value,
          productionMethodId: y
        })
      ],
      production_method: { id: y }
    };
  }), s = re.designs.preview.use(
    a
  ), {
    data: i,
    error: r,
    fetchStatus: c,
    status: u
  } = zt({
    ...s,
    enabled: S(() => !!a.value && o.value),
    queryFn: Th(s.queryFn, 1e3, {
      rejectOnCancel: !0
    }),
    retry: !1,
    staleTime: 1 / 0
  }), d = N(i.value);
  se(() => {
    i.value && (d.value = i.value);
  });
  const p = S(() => {
    if (d.value)
      return {
        height: d.value.height,
        width: d.value.width
      };
  }), _ = S(() => {
    var y;
    const k = (y = d.value) == null ? void 0 : y.content;
    return k != null && k.startsWith("https://") ? k : k ? `data:image/jpeg;base64,${k}` : void 0;
  });
  return {
    error: r,
    fetchStatus: c,
    imageUrl: _,
    normalizedDesign: n,
    size: p,
    status: u
  };
}
function Tb(e, t) {
  const n = Cd(sa), {
    error: o,
    fetchStatus: a,
    imageUrl: s,
    normalizedDesign: i,
    size: r,
    status: c
  } = ui(e), {
    data: u,
    error: d,
    fetchStatus: p,
    isPlaceholderData: _,
    status: y
  } = Zl(s, {
    placeholder: S(() => {
      var f;
      const g = pn(t);
      if (!g || !r.value) return;
      const b = Math.max(
        ((f = n == null ? void 0 : n.clampScale.value) == null ? void 0 : f.max) ?? (n == null ? void 0 : n.worldScale.value) ?? 1,
        1
      );
      return {
        height: r.value.height * b,
        radius: g.radius * b,
        width: r.value.width * b
      };
    })
  }), k = S(
    () => c.value === "success" ? y.value : c.value
  ), w = S(
    () => a.value === "idle" ? p.value : a.value
  );
  return {
    error: S(
      () => o.value ?? d.value ?? void 0
    ),
    fetchStatus: w,
    isPlaceholderData: _,
    normalizedDesign: i,
    size: r,
    status: k,
    texture: u
  };
}
const Mb = ["angle", "pivot", "position"], Ha = /* @__PURE__ */ J({
  __name: "PositioningAreaDesign",
  props: {
    data: {},
    placeholder: {}
  },
  emits: ["update:boundingBox", "update:error", "update:fetchStatus", "update:size", "update:status"],
  setup(e, { emit: t }) {
    const n = e, { data: o, placeholder: a } = we(n), s = t, { data: i } = Nt(ia), { error: r, fetchStatus: c, isPlaceholderData: u, size: d, status: p, texture: _ } = Tb(
      S(() => ({
        design: o.value.design,
        productionMethodId: i.value.productionMethodId
      })),
      a
    );
    se(() => {
      s("update:error", r.value);
    }), se(() => {
      s("update:fetchStatus", c.value);
    }), se(() => {
      s("update:size", d.value);
    }), se(() => {
      s("update:status", p.value);
    });
    const y = S(
      () => d.value ? {
        x: d.value.width / 2,
        y: d.value.height / 2
      } : void 0
    ), k = S(
      () => d.value && y.value ? Kl(d.value, y.value, o.value.rotation) : void 0
    );
    se(() => {
      s("update:boundingBox", k.value);
    });
    const w = S(() => {
      if (!k.value) return;
      const f = i.value.position[1], g = i.value.position[0], b = i.value.width * Ko(f), A = i.value.height * Ko(g);
      let P = 0;
      f === "l" ? P = k.value.left : f === "r" && (P = k.value.right);
      let I = 0;
      return g === "t" ? I = k.value.top : g === "b" && (I = k.value.bottom), {
        x: b - P,
        y: A - I
      };
    });
    return $o(Xl, {
      error: r,
      fetchStatus: c,
      isPlaceholderData: u,
      placeholderColor: S(() => {
        var f;
        return (f = a.value) == null ? void 0 : f.color;
      }),
      size: d,
      status: p,
      texture: _
    }), $o(Ap, { data: o }), (f, g) => y.value && w.value ? ($(), E("PixiContainer", {
      key: 0,
      label: "PositioningAreaDesign",
      angle: l(o).rotation,
      pivot: y.value,
      position: w.value
    }, [
      Et(f.$slots, "default", {}, () => [
        x(Mp)
      ])
    ], 8, Mb)) : Q("", !0);
  }
}), Ib = /* @__PURE__ */ J({
  __name: "TopLayerTeleport",
  props: {
    disabled: { type: Boolean }
  },
  setup(e) {
    const t = e, { disabled: n } = we(t), { topLayer: o } = Nt(sa), a = N();
    return se((s) => {
      const i = o.value, r = a.value;
      n.value || !i || !r || (i.attach(r), s(() => {
        i.detach(r);
      }));
    }), (s, i) => ($(), E("PixiContainer", {
      ref_key: "container",
      ref: a,
      label: "TopLayerTeleport"
    }, [
      Et(s.$slots, "default")
    ], 512));
  }
}), Eb = ["texture", "width", "height", "alpha", "tint"], Ga = /* @__PURE__ */ J({
  __name: "View",
  props: {
    data: {},
    hidden: { type: Boolean },
    initialPosition: {},
    placeholder: {}
  },
  setup(e) {
    const t = e, { data: n, hidden: o, initialPosition: a, placeholder: s } = we(t), { clampScale: i, setPosition: r, worldScale: c, worldSize: u } = Nt(sa);
    se(() => {
      o.value || (u.value = {
        height: n.value.height,
        width: n.value.width
      });
    });
    function d() {
      o.value || r(
        a.value ?? {
          height: n.value.height,
          width: n.value.width,
          x: 0,
          y: 0
        },
        !1
      );
    }
    zd(d), pt(o, d);
    const {
      data: p,
      isFetching: _,
      isPlaceholderData: y
    } = Zl(
      S(() => n.value.imageUrl),
      {
        disabled: o,
        placeholder: S(() => {
          var f;
          if (!s.value) return;
          const g = Math.max(
            ((f = i.value) == null ? void 0 : f.max) ?? c.value,
            1
          );
          return {
            height: n.value.height * g,
            radius: s.value.radius * g,
            width: n.value.width * g
          };
        })
      }
    ), k = N(1);
    qo(
      (f) => {
        k.value = Math.sin(f.lastTime / 1e3 * Math.PI) * 0.25 + 0.5;
      },
      { enabled: _ }
    );
    const w = N();
    return $o(Ql, { container: w, data: n, texture: p }), (f, g) => {
      var b;
      return l(o) ? Q("", !0) : ($(), E("PixiContainer", {
        key: 0,
        ref_key: "container",
        ref: w,
        label: "View"
      }, [
        z("PixiSprite", {
          label: "View_Sprite",
          texture: l(p),
          width: l(n).width,
          height: l(n).height,
          alpha: l(_) ? k.value : 1,
          tint: l(y) ? (b = l(s)) == null ? void 0 : b.color : void 0
        }, null, 8, Eb),
        Et(f.$slots, "default")
      ], 512));
    };
  }
});
function Ob(e) {
  const t = vt(e);
  return zt({
    enabled: S(() => !!t.value),
    queryFn: () => new Promise((n, o) => {
      const a = new Image();
      a.addEventListener("load", () => {
        n(a);
      }), a.addEventListener("error", o), a.crossOrigin = "Anonymous", a.src = t.value;
    }),
    queryKey: ["image", t],
    retry: !1,
    staleTime: 1 / 0
  });
}
function Rb(e, t, n) {
  const o = [], a = new Map(
    e.colors.map((i) => [i.id, i])
  ), s = e.productionMethods.find(
    (i) => i.id === n
  );
  for (const i of t) {
    const r = Lb(i, a, s);
    o.push({
      color: i,
      status: r
    });
  }
  return o;
}
function Lb(e, t, n) {
  var o;
  return n ? "id" in e ? (o = t.get(e.id)) != null && o.production_methods.some(
    (a) => a.id === n.id
  ) ? "valid" : "color_not_found" : n.is_using_color_picker ? "valid" : "rgb_not_supported" : "color_not_found";
}
function jb(e, t, n) {
  var o;
  const a = /* @__PURE__ */ new Set();
  for (const s of t)
    (o = e.fonts.find((i) => i.id === s)) != null && o.production_methods.find(
      (i) => i.id === n
    ) || a.add(s);
  return a;
}
function Db(e, t) {
  const n = [], o = new Map(
    e.fonts.map((a) => [a.id, a])
  );
  for (const { fontId: a, size: s } of t) {
    const i = o.get(a), r = Nb(s, i);
    n.push({
      fontId: a,
      size: s,
      status: r
    });
  }
  return n;
}
function Nb(e, t) {
  return t ? e < (t.min ?? 0) ? "too_small" : e > (t.max ?? 1 / 0) ? "too_large" : "valid" : "font_not_found";
}
function Hs(e, t, n) {
  const o = t.map(({ fontId: d }) => d), a = jb(
    e,
    o,
    n
  ), s = t.map(({ fontId: d, size: p }) => ({ fontId: d, size: p })), i = Db(e, s), r = t.map(({ color: d }) => d), c = Rb(
    e,
    r,
    n
  ), u = [];
  for (const [d, p] of t.entries()) {
    const _ = {};
    a.has(p.fontId) && (_.font = "not_available");
    const y = i[d];
    (y == null ? void 0 : y.status) !== "valid" && (_.size = y == null ? void 0 : y.status);
    const k = c[d];
    (k == null ? void 0 : k.status) !== "valid" && (_.color = k == null ? void 0 : k.status), Object.keys(_).length > 0 && u.push({
      invalidProperties: _,
      textLine: p
    });
  }
  return u;
}
function To(e, t) {
  const {
    data: n,
    fetchStatus: o,
    status: a
  } = zt(re.configurations.app.get.use()), s = vt(e), i = vt(t), r = S(() => {
    if (n.value && s.value !== void 0 && i.value !== void 0)
      return Hs(
        n.value,
        s.value,
        i.value
      );
  });
  return {
    allTextLinesSupported: S(() => {
      if (r.value)
        return r.value.length === 0;
    }),
    fetchStatus: o,
    status: a,
    unsupportedTextLines: r
  };
}
function Vb(e) {
  const t = vt(e), n = ut(), o = on(
    (u) => n.fetchQuery({
      ...re.customerLogos.get.use(u),
      retry: !1,
      staleTime: 1 / 0
    })
  ), { mutateAsync: a } = ct(
    re.customerLogos.temporaryUploadUrl.use()
  ), { mutateAsync: s } = ct(
    re.customerLogos.post.use()
  );
  let i;
  const r = {};
  At("customerLogo.completed", ({ id: u }) => {
    r[u] = "completed", (i == null ? void 0 : i.pendingCustomerLogoId) === u && (i.resolve(), i = void 0);
  }), At("customerLogo.failed", ({ id: u, message: d }) => {
    if (r[u] = "failed", (i == null ? void 0 : i.pendingCustomerLogoId) === u) {
      switch (d) {
        case "SVG logo contains images.":
          i.reject(
            t.value.ERROR_SVG_CONTAINS_IMAGE
          );
          break;
        case "SVG logo contains texts.":
          i.reject(
            t.value.ERROR_SVG_CONTAINS_TEXT
          );
          break;
        default:
          i.reject(t.value.ERROR_UNEXPECTED);
      }
      i = void 0;
    }
  });
  async function c({
    file: u,
    productionMethodId: d
  }) {
    const { path: p, url: _ } = await a({
      content_type: u.type,
      file_name: u.name
    });
    await Ub(_, u);
    try {
      const y = await s({
        path: p,
        production_method_id: d
      });
      if (y in r) {
        if (r[y] === "failed")
          throw new Error("Failed to render customer logo");
      } else {
        const { promise: k, reject: w, resolve: f } = Promise.withResolvers();
        i = {
          pendingCustomerLogoId: y,
          reject: w,
          resolve: f
        }, await k;
      }
      return await o(y);
    } catch (y) {
      throw y instanceof eo ? y : typeof y == "string" ? new Us(y) : new Us(
        t.value.ERROR_UNEXPECTED
      );
    }
  }
  return { mutationFn: c };
}
function Ub(e, t) {
  return mm.put(e, {
    body: t,
    timeout: !1
  });
}
function ec(e, t) {
  const n = S(
    () => {
      var s;
      return ((s = e.value) == null ? void 0 : s.type) === $e.LOGO ? e.value.logoId : void 0;
    }
  ), o = re.logos.get.use(n), { data: a } = zt({
    ...o,
    enabled: S(
      () => o.enabled.value && !!n.value
    ),
    retry: !1,
    staleTime: 1 / 0
  });
  return S(() => {
    var s;
    switch ((s = e.value) == null ? void 0 : s.type) {
      case $e.LOGO: {
        const i = e.value.size ?? a.value;
        if (i != null && i.width && i.height)
          return { height: i.height, width: i.width };
        break;
      }
      case $e.TEXT:
        return {
          height: 10 / t.value,
          width: 30 / t.value
        };
    }
    return {
      height: 30 / t.value,
      width: 30 / t.value
    };
  });
}
function Rp(e) {
  if (e.type === $e.LOGO)
    return e;
  if (e.type === $e.ANCHOR && e.parent.type === $e.LOGO)
    return e.parent;
}
function tc(e) {
  const t = vt(e);
  return S(() => {
    if (t.value)
      return Rp(t.value);
  });
}
function Bo(e) {
  var t;
  if (e.type === $e.TEXT)
    return e;
  if (e.type === $e.ANCHOR && ((t = e.children[0]) == null ? void 0 : t.value.type) === $e.TEXT)
    return e.children[0].value;
}
function Wa(e) {
  const t = vt(e);
  return S(() => {
    if (t.value)
      return Bo(t.value);
  });
}
function Za(e, t) {
  const n = t ?? Nt(ia).data;
  return S(() => {
    if (!e.value || !n.value) return !1;
    const { height: o, width: a } = n.value, { bottom: s, left: i, right: r, top: c } = e.value;
    return r - i > a || s - c > o;
  });
}
const Lp = Symbol("nearest_positioning_areas");
function Fb(e, t, n) {
  const {
    filter: o = (k, w) => k.productionMethodId === w.productionMethodId && (w.designs.length === 0 || k === w),
    minDistance: a = 10,
    onMove: s
  } = n ?? {}, { container: i, data: r } = Nt(Ql), { data: c } = Nt(ia), u = Nt(Lp), d = N();
  pt(t, (k) => {
    d.value = k ? { ...k } : void 0;
  });
  const p = S(
    () => t.value && d.value && Fs(t.value, d.value) < a
  ), _ = S(() => {
    if (!t.value || !i.value) return;
    if (p.value)
      return c.value;
    const k = c.value, w = i.value.worldTransform;
    let f, g = 1 / 0;
    for (const b of r.value.positioningAreas) {
      if (!o(k, b)) continue;
      const A = Fs(
        t.value,
        w.apply(b)
      );
      A < g && (f = b, g = A);
    }
    return f;
  }), y = zh();
  pt(_, (k, w) => {
    y.value = w;
  }), se(() => {
    const k = y.value, w = c.value;
    if (_.value || !k || w === k)
      return;
    s == null || s(w, k);
    const f = e.value;
    w.designs = w.designs.filter(
      (g) => g !== f
    ), k.designs.push(f);
  }), se((k) => {
    const w = _.value;
    if (!w) return;
    const f = e.value;
    u.value.push({
      positioningArea: w,
      positioningAreaDesign: f
    }), k(() => {
      u.value = u.value.filter(
        ({ positioningAreaDesign: g }) => g !== f
      );
    });
  });
}
function qb() {
  const e = N([]);
  return $o(Lp, e), e;
}
function Bb() {
  const { data: e } = Nt(ia);
  return e;
}
function jp([e, t, n]) {
  return e /= 255, t /= 255, n /= 255, e = e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4), t = t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4), n = n <= 0.04045 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4), e * 0.2126 + t * 0.7152 + n * 0.0722;
}
const Hb = 0.179129;
function nc(e) {
  return jp(e) >= Hb;
}
function Ka(e, t = 0) {
  const n = Kl(
    e,
    {
      x: e.width * // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      Ko(e.position[1]),
      y: e.height * // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      Ko(e.position[0])
    },
    e.rotation
  );
  return n.left -= t, n.top -= t, n.right += t, n.bottom += t, {
    height: n.bottom - n.top,
    width: n.right - n.left,
    x: e.x + n.left,
    y: e.y + n.top
  };
}
const Gb = new fk();
function ra(e, t) {
  const { image: n, view: o } = Wb(t), a = S(
    () => e.value ? Ka(e.value) : void 0
  ), s = S(() => {
    if (!o.value || !a.value || !n.value || !("width" in n.value) || !("height" in n.value)) return;
    const i = {
      x: n.value.width / o.value.width,
      y: n.value.height / o.value.height
    };
    return Gb.getColor(n.value, {
      algorithm: "dominant",
      height: a.value.height * i.y,
      ignoredColor: [0, 0, 0, 0],
      left: a.value.x * i.x,
      top: a.value.y * i.y,
      width: a.value.width * i.x
    }).value;
  });
  return {
    averageColor: s,
    isLight: S(
      () => nc(
        s.value ?? [255, 255, 255]
      )
    )
  };
}
function Wb(e) {
  if (e)
    return {
      image: Ob(S(() => {
        var o;
        return (o = e.value) == null ? void 0 : o.imageUrl;
      })).data,
      view: e
    };
  const { data: t, texture: n } = Nt(Ql);
  return {
    image: S(
      () => {
        var o;
        return (o = n.value) == null ? void 0 : o.source.resource;
      }
    ),
    view: t
  };
}
function Zb() {
  const { mutateAsync: e } = ct(
    re.designs.favored.post.use()
  ), { mutateAsync: t } = ct(
    re.designs.favored.delete.use()
  );
  async function n({
    id: o,
    favoriteDesign: a
  }) {
    const s = await e(a);
    return await t(o), s;
  }
  return { mutationFn: n };
}
const Kb = "UNEXPECTED_FAVORITE_VARIANT_RENDERING_FAILED";
function Qb() {
  let e;
  const { mutateAsync: t } = ct(
    re.favorites.variants.post.use()
  ), n = ut(), o = on(
    (s) => n.fetchQuery({
      ...re.favorites.variants.get.use(s),
      retry: !1,
      staleTime: 1 / 0
    })
  );
  At("favorite.rendered", ({ id: s, resource_id: i }) => {
    (e == null ? void 0 : e.pendingFavoriteVariantId) === i && e.resolve(s);
  }), At("favorite.failed", ({ resource_id: s, resource_type: i }) => {
    i === "variant" && (e == null ? void 0 : e.pendingFavoriteVariantId) === s && e.reject();
  });
  async function a(s) {
    const i = await t(s), { promise: r, reject: c, resolve: u } = Promise.withResolvers();
    e = {
      pendingFavoriteVariantId: i,
      reject: c,
      resolve: u
    };
    try {
      const d = await r;
      return await o(d);
    } catch {
      throw new Us(
        Kb
      );
    }
  }
  return { mutationFn: a };
}
function Xb() {
  const { mutateAsync: e } = ct(
    Qb()
  ), { mutateAsync: t } = ct(
    re.favorites.delete.use()
  );
  async function n({
    favoriteVariantIdToDelete: o,
    favoriteVariantToCreate: a
  }) {
    const s = await e(a);
    return await t(o), s;
  }
  return { mutationFn: n };
}
function Dp(e, t) {
  const { channelSession: n } = L(Wl());
  op(n, e, t);
}
const Jb = {
  install() {
    eb("Viewport", {
      createElement: (e) => new v_(e)
    });
  }
};
function Yb(...e) {
  return e.flatMap((t) => t.resource_type === "text" ? t.resource.lines.flatMap(
    (n) => n.color_assignments
  ) : t.resource.color_assignments);
}
function oc(e) {
  const t = [e];
  return t.push(
    ...e.elements.flatMap((n) => oc(n))
  ), t;
}
const Fr = /* @__PURE__ */ new WeakMap();
let e3 = 0;
function yt(e) {
  return Fr.has(e) || Fr.set(e, ++e3), Fr.get(e);
}
function t3(e, t) {
  return e.positioningAreas.some(
    (n) => n.designs.some(
      (o) => {
        var a;
        return ((a = Rp(o.design)) == null ? void 0 : a.logoId) === t;
      }
    )
  );
}
const Vt = rt("layout", () => {
  const e = N(), t = N(!0);
  return { rootElement: e, showLayout: t };
}), st = rt("configuration", () => {
  const { data: e, status: t } = zt({
    ...re.configurations.app.get.use(),
    retry: !1,
    staleTime: 1 / 0
  }), { data: n } = zt({
    ...re.configurations.designer.get.use(),
    retry: !1,
    staleTime: 1 / 0
  });
  return { appConfiguration: e, designerConfiguration: n, status: t };
}), Jt = rt("variant", () => {
  const e = N();
  se(() => {
    Nd("variant-id", e.value);
  });
  const t = re.variants.get.use(e), n = re.variants.getByExternalIdentifier.use(
    e
  ), { data: o, fetchStatus: a, status: s, suspense: i } = zt(
    S(
      () => typeof e.value == "number" ? {
        ...t,
        retry: !1,
        staleTime: 1 / 0
      } : {
        ...n,
        enabled: S(
          () => n.enabled.value && typeof e.value == "string"
        ),
        retry: !1,
        staleTime: 1 / 0
      }
    )
  );
  return {
    data: o,
    fetchStatus: a,
    status: s,
    suspense: i,
    variantId: e
  };
}), qt = rt("view", () => {
  const { data: e } = L(Jt()), t = N([]), n = N(0);
  return se(() => {
    e.value && (t.value = e.value.views.map((o) => Yl(o)), n.value = 0);
  }), {
    data: t,
    selectedViewIndex: n
  };
});
function n3(e, t) {
  const n = /* @__PURE__ */ new Set();
  for (const o of e)
    t.has(o) && n.add(o);
  return n;
}
const nt = rt("productionMethod", () => {
  const e = N(), { data: t } = L(qt()), { data: n } = L(Jt()), o = S(() => {
    if (n.value)
      return new Set(
        t.value.flatMap(
          (c) => c.positioningAreas.filter(
            (u) => u.designs.length > 0
          ).map((u) => u.productionMethodId)
        )
      );
  }), a = S(() => {
    if (n.value)
      return new Set(
        t.value.flatMap(
          (c) => c.positioningAreas.map(
            (u) => u.productionMethodId
          )
        )
      );
  }), { appConfiguration: s } = L(st()), i = S(() => {
    if (s.value !== void 0)
      return new Set(
        s.value.productionMethods.map((c) => c.id).sort(
          (c, u) => c - u
        )
      );
  }), r = S(() => {
    if (i.value !== void 0 && a.value !== void 0)
      return n3(
        a.value,
        i.value
      );
  });
  return se(() => {
    r.value !== void 0 && (e.value !== void 0 && r.value.has(
      e.value
    ) || o.value !== void 0 && (e.value = o.value.values().next().value, e.value !== void 0) || (e.value = r.value.values().next().value));
  }), {
    activatedProductionMethodIds: i,
    availableProductionMethodIds: r,
    designsProductionMethodIds: o,
    selectedProductionMethodId: e
  };
}), o3 = {
  key: 0,
  class: "smake:pointer-events-auto smake:flex smake:min-h-14 smake:w-full smake:max-w-md smake:flex-col smake:overflow-hidden smake:rounded-lg smake:border smake:border-secondary-2 smake:bg-secondary-3 smake:data-[swipe=cancel]:translate-y-0 smake:data-[swipe=cancel]:duration-200 smake:data-[swipe=end]:hidden smake:data-[swipe=move]:translate-y-(--radix-toast-swipe-move-y)"
}, a3 = { class: "smake:flex smake:grow smake:items-center smake:justify-between smake:gap-2 smake:p-2" }, s3 = { class: "smake:flex smake:grow smake:justify-center" }, i3 = { key: 0 }, Np = /* @__PURE__ */ J({
  __name: "Toast",
  props: /* @__PURE__ */ Te({
    type: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Te(["closed"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = e, { type: o } = we(n), a = t, s = Ue(e, "open");
    s.value || a("closed");
    const i = {
      error: {
        class: "smake:text-danger",
        icon: ["fak", "icon-ciconfig-alert-warning"]
      },
      info: {
        class: "smake:text-info",
        icon: ["fak", "icon-ciconfig-alert-warning"]
      },
      success: {
        class: "smake:text-success",
        icon: ["fak", "icon-ciconfig-alert-check"]
      }
    }, r = S(() => i[o.value]), c = S(() => o.value === "success" ? 3e3 : -1);
    function u(d) {
      o.value === "error" && d.stopImmediatePropagation();
    }
    return (d, p) => {
      const _ = De("FontAwesomeIcon");
      return $(), H(l(w_), {
        open: s.value,
        "onUpdate:open": p[2] || (p[2] = (y) => s.value = y),
        duration: c.value,
        "as-child": "",
        onPointerdown: yo(u, ["left"])
      }, {
        default: M(({ remaining: y }) => [
          x(Qe, {
            "enter-active-class": "smake:motion-preset-rebound-down smake:motion-duration-75",
            "leave-active-class": "smake:duration-300",
            "leave-to-class": "smake:opacity-0",
            appear: "",
            onAfterLeave: p[1] || (p[1] = (k) => a("closed"))
          }, {
            default: M(() => [
              s.value ? ($(), E("li", o3, [
                z("div", a3, [
                  x(_, Qs({ class: "smake:h-5" }, r.value, { "fixed-width": "" }), null, 16),
                  z("div", s3, [
                    Et(d.$slots, "default")
                  ]),
                  l(o) === "info" ? ($(), E("button", {
                    key: 0,
                    type: "button",
                    onClick: p[0] || (p[0] = (k) => s.value = !1)
                  }, [
                    x(_, {
                      icon: ["fak", "icon-x"],
                      "fixed-width": "",
                      class: "smake:h-3.5 smake:text-secondary-1"
                    })
                  ])) : Q("", !0)
                ]),
                l(o) === "success" ? ($(), E("div", i3, [
                  z("div", {
                    class: "smake:h-0.5 smake:bg-success",
                    style: Qt(`width: ${y / c.value * 100}%;`)
                  }, null, 4)
                ])) : Q("", !0)
              ])) : Q("", !0)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 3
      }, 8, ["open", "duration"]);
    };
  }
}), Ot = /* @__PURE__ */ J({
  __name: "TextToast",
  props: /* @__PURE__ */ Te({
    text: {},
    type: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Te(["closed"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = t, o = Ue(e, "open");
    return (a, s) => ($(), H(Np, {
      open: o.value,
      "onUpdate:open": s[0] || (s[0] = (i) => o.value = i),
      type: e.type,
      onClosed: s[1] || (s[1] = (i) => n("closed"))
    }, {
      default: M(() => [
        Pe(j(e.text), 1)
      ]),
      _: 1
    }, 8, ["open", "type"]));
  }
}), Vp = rt("toast", () => ({
  toasts: N([])
}));
function vn() {
  const { toasts: e } = L(Vp()), t = N([]);
  function n(a, ...[s]) {
    const { id: i, input: r = {}, removeOnUnmount: c = !0 } = s ?? {};
    let u = i ? e.value.find((d) => d.id === i) : void 0;
    return u ? () => {
      u.open = !1;
    } : (u = Ad({
      id: i,
      component: xo(a),
      input: r,
      open: !0
    }), e.value.push(u), c && t.value.push(u), () => {
      u.open = !1;
    });
  }
  function o(a) {
    const s = e.value.find((i) => i.id === a);
    s && (s.open = !1);
  }
  return qn() && xl(() => {
    for (const a of t.value)
      a.open = !1;
  }), {
    close: o,
    open: n
  };
}
function r3(e) {
  const { data: t } = L(Jt());
  return S(
    () => {
      var o;
      return (o = t.value) == null ? void 0 : o.views.flatMap((a) => a.positioning_areas).find(
        (a) => a.id === e.value
      );
    }
  );
}
function l3(e) {
  const t = r3(e), n = S(() => {
    var c;
    return (c = t.value) == null ? void 0 : c.annotations;
  }), { close: o, open: a } = vn(), s = N([]);
  pt(n, () => {
    r(), i();
  });
  function i() {
    if (n.value)
      for (const c of n.value) {
        const u = Symbol(
          `annotation-${c.id.toString()}`
        );
        s.value.push(u), a(Ot, {
          id: u,
          input: {
            text: c.description,
            type: "info"
          },
          removeOnUnmount: !0
        });
      }
  }
  function r() {
    for (const c of s.value)
      o(c);
    s.value = [];
  }
}
const Oo = {
  cm: 10,
  in: 25.4,
  mm: 1
}, On = rt("designer", () => {
  const e = N(), t = N(), n = N(1), o = S({
    get: () => n.value,
    set: (r) => {
      var c;
      (c = e.value) == null || c.setZoom(r);
    }
  }), a = N(!1), s = N(), i = N(!1);
  return {
    designerCore: e,
    hidePositioningAreas: a,
    highlightEmptyPositioningAreas: i,
    readOnlyZoom: n,
    selectedPositioningAreaDesign: s,
    stage: t,
    zoom: o
  };
}), gn = rt("designEditDialog", () => {
  const { designerCore: e } = L(On()), { data: t, selectedViewIndex: n } = L(qt()), { showLayout: o } = L(Vt()), { designerConfiguration: a } = L(st()), s = N(!1), i = S(
    () => {
      var w;
      return Oo[((w = a.value) == null ? void 0 : w.settings.settings.units.length) ?? "mm"] ?? 1;
    }
  ), r = N(), c = N(), u = N();
  l3(S(() => {
    var w;
    return (w = r.value) == null ? void 0 : w.id;
  }));
  const d = S({
    get: () => !!r.value && !s.value,
    set: (w) => {
      if (w)
        throw new Error(
          "To open the DesignEditDialog the positioningArea needs to be set"
        );
      r.value = void 0, c.value = void 0;
    }
  });
  se(() => {
    !r.value || !c.value || r.value.designs.includes(c.value) || (c.value = void 0);
  }), pt(
    [r, c],
    ([w, f], [g, b]) => {
      g !== void 0 && (f === b || w === g) || (u.value = to(f));
    }
  ), pt(
    c,
    (w, f) => {
      w || !f || (d.value = !1);
    }
  ), pt([d, r], ([w, f]) => {
    if (o.value = !w, _(), k(), w) {
      p(f);
      return;
    }
    const g = t.value[n.value];
    y(g);
  });
  const { start: p, stop: _ } = Cc(
    (w) => {
      var f;
      w && ((f = e.value) == null || f.setPosition(
        Ka(
          w,
          10 / i.value
        )
      ));
    },
    10
  ), { start: y, stop: k } = Cc(async (w) => {
    var f;
    await wl(), w && ((f = e.value) == null || f.setPosition({
      height: w.height,
      width: w.width,
      x: 0,
      y: 0
    }));
  }, 50);
  return {
    forceClose: s,
    open: d,
    positioningArea: r,
    positioningAreaDesign: c,
    positioningAreaDesignBackup: u
  };
}), Hn = rt("dialog", () => {
  const e = N([]), t = N(!1), n = N();
  function o(a) {
    a.resolve(), e.value = e.value.filter((s) => s !== a);
  }
  return {
    dialogs: e,
    dialogsRoot: n,
    hideAllDialogs: t,
    removeDialog: o
  };
}), qr = Symbol("chooseAPositioningAreaToast"), Br = Symbol(
  "noEmptyPositioningAreaOnCurrentView"
), Xt = rt(
  "selectPositioningArea",
  () => {
    const { close: e, open: t } = vn(), { t: n } = dt(), { highlightEmptyPositioningAreas: o } = L(On()), { hideAllDialogs: a } = L(Hn()), { forceClose: s } = L(gn()), { data: i, selectedViewIndex: r } = L(qt()), { selectedProductionMethodId: c } = L(
      nt()
    ), u = S(() => {
      const g = i.value[r.value];
      return g === void 0 ? !1 : g.positioningAreas.some((b) => b.productionMethodId !== c.value ? !1 : b.designs.length === 0);
    }), d = N(!1), {
      cancel: p,
      confirm: _,
      onCancel: y,
      onConfirm: k,
      onReveal: w,
      reveal: f
    } = Mh(d);
    return se(() => {
      a.value = d.value, s.value = d.value;
    }), w(() => {
      o.value = !0;
    }), se(() => {
      if (o.value) {
        if (u.value) {
          e(Br), t(Ot, {
            id: qr,
            input: {
              text: n("choose_a_positioning_area"),
              type: "info"
            }
          });
          return;
        }
        e(qr), t(Ot, {
          id: Br,
          input: {
            text: n("all_positioning_areas_are_occupied"),
            type: "info"
          }
        });
        return;
      }
      e(qr), e(Br);
    }), y(() => {
      o.value = !1;
    }), k(() => {
      o.value = !1;
    }), {
      cancelSelectingPositioningArea: p,
      isSelectingPositioningArea: Un(d),
      selectPositioningArea: _,
      waitForSelectingPositioningArea: f
    };
  }
), Up = rt(
  "variantChangeEvent",
  () => {
    const { dialogs: e } = L(Hn()), { open: t } = L(
      gn()
    ), n = N(!1);
    return {
      isADialogOpen: S(
        () => e.value.length > 0 || t.value || n.value
      ),
      isProductColorChangeDialogOpen: n
    };
  }
), di = rt("props", () => {
  const e = N(), t = N(), n = N(), o = N();
  return {
    availableVariants: e,
    customerLogoUploadInfo: t,
    termsOfServiceLink: n,
    uploadHelpLink: o
  };
});
function Fp(e) {
  return new Promise((t, n) => {
    const o = new Image();
    o.addEventListener("load", () => {
      t(o);
    }), o.addEventListener("error", n), o.crossOrigin = "Anonymous", o.src = e;
  });
}
async function c3(e) {
  return Promise.all(e.map((t) => Fp(t)));
}
function u3(e) {
  const t = vt(e);
  return zt({
    enabled: S(() => !!t.value),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: () => Fp(t.value),
    queryKey: ["image", t],
    retry: !1,
    staleTime: 1 / 0
  });
}
const d3 = ["src", "data-state"], m3 = ["data-state"], Yt = /* @__PURE__ */ J({
  __name: "Image",
  props: {
    src: {}
  },
  setup(e) {
    const t = e, { src: n } = we(t), { status: o } = u3(n);
    return (a, s) => ($(), H(Qe, {
      "enter-active-class": "smake:duration-300 smake:ease-out",
      "enter-from-class": "smake:opacity-0",
      "leave-active-class": "smake:hidden"
    }, {
      default: M(() => [
        l(o) === "success" ? ($(), E("img", {
          key: 0,
          src: l(n),
          "data-state": l(o)
        }, null, 8, d3)) : ($(), E("div", {
          key: 1,
          "data-state": l(o)
        }, null, 8, m3))
      ]),
      _: 1
    }));
  }
}), p3 = { class: "smake:absolute smake:inset-y-0 smake:right-0 smake:flex smake:w-120 smake:max-w-full smake:flex-col smake:overflow-y-auto smake:bg-secondary-3 smake:p-10 smake:shadow-[0_0_15px_0_rgba(0,0,0,.25)]" }, f3 = { class: "smake:grid smake:grid-cols-auto-fill-14 smake:gap-4" }, h3 = ["disabled", "onClick"], _3 = /* @__PURE__ */ J({
  __name: "ChangeProductColorDialogContent",
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = t, o = Jt(), { data: a, fetchStatus: s, variantId: i } = L(o), { data: r } = L(qt()), { availableVariants: c } = L(di()), u = S(() => {
      var f;
      return (f = a.value) == null ? void 0 : f.product_id;
    }), d = re.products.colorVariants.list.use(
      u
    ), { data: p, isPending: _ } = zt({
      ...d,
      enabled: S(
        () => d.enabled.value && !!u.value
      ),
      retry: !1,
      staleTime: 1 / 0
    }), y = S(
      () => {
        var f;
        return c.value ? (f = p.value) == null ? void 0 : f.filter(
          ({ size_variants: g }) => g.some(
            ({ id: b, external_identifier: A }) => (
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              c.value.some(
                (P) => typeof P == "number" ? P === b : P === A
              )
            )
          )
        ) : p.value;
      }
    ), k = S(() => {
      var g, b, A;
      const f = (b = (g = a.value) == null ? void 0 : g.attributes.find(
        (P) => P.name === "color"
      )) == null ? void 0 : b.handle;
      return (A = y.value) == null ? void 0 : A.find(
        ({ color_handle: P }) => P === f
      );
    });
    async function w(f) {
      var b;
      if (f === ((b = a.value) == null ? void 0 : b.base.id)) {
        n("close");
        return;
      }
      const g = r.value;
      i.value = f, await o.suspense();
      for (const A of r.value)
        for (const P of A.positioningAreas)
          P.id && P.designs.push(
            ...g.flatMap(
              (I) => I.positioningAreas.filter(({ id: D }) => D === P.id).flatMap(({ designs: D }) => D)
            )
          );
      n("close");
    }
    return (f, g) => ($(), E("div", p3, [
      x(l(sn), { class: "smake:mb-10 smake:text-lg smake:font-semibold smake:uppercase" }, {
        default: M(() => [
          Pe(j(f.$t("product_colors")), 1)
        ]),
        _: 1
      }),
      z("div", f3, [
        l(_) ? ($(), E(me, { key: 0 }, Ce(14, (b) => z("div", {
          key: b,
          class: "smake:flex smake:animate-pulse smake:flex-col smake:items-center smake:gap-2"
        }, [...g[0] || (g[0] = [
          z("div", { class: "smake:rounded-full smake:border smake:border-transparent smake:p-1" }, [
            z("div", { class: "smake:size-12 smake:rounded-full smake:bg-secondary-2" })
          ], -1),
          z("div", { class: "smake:h-3 smake:w-10 smake:rounded smake:bg-secondary-2" }, null, -1)
        ])])), 64)) : Q("", !0),
        ($(!0), E(me, null, Ce(y.value, (b) => ($(), E("button", {
          key: b.color_handle,
          class: "smake:flex smake:flex-col smake:items-center smake:gap-2 smake:disabled:grayscale-[80%]",
          disabled: l(s) === "fetching",
          onClick: (A) => w(b.size_variants[0].id)
        }, [
          z("div", {
            class: ye([
              "smake:rounded-full smake:border smake:p-1",
              b === k.value ? "smake:border-black" : "smake:border-transparent"
            ])
          }, [
            x(Yt, {
              src: b.color_preview_url,
              class: "smake:size-12 smake:rounded-full smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2"
            }, null, 8, ["src"])
          ], 2),
          z("div", null, j(b.color_name), 1)
        ], 8, h3))), 128))
      ])
    ]));
  }
}), v3 = { class: "smake:text-xs" }, pd = /* @__PURE__ */ J({
  __name: "ChangeProductColor",
  setup(e) {
    const { rootElement: t } = L(Vt()), { fetchStatus: n } = L(Jt()), { isSelectingPositioningArea: o } = L(
      Xt()
    ), { isProductColorChangeDialogOpen: a } = L(
      Up()
    ), { selectedProductionMethodId: s } = L(nt());
    function i(r) {
      n.value === "fetching" && r.preventDefault();
    }
    return (r, c) => ($(), H(l(rn), {
      open: l(a),
      "onUpdate:open": c[1] || (c[1] = (u) => Ft(a) ? a.value = u : null)
    }, {
      default: M(() => [
        x(l(Vd), {
          type: "button",
          "data-testid": "ChangeProductColor",
          class: "smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:gap-2 smake:disabled:opacity-50",
          disabled: l(o) || l(s) === void 0
        }, {
          default: M(() => [
            c[2] || (c[2] = z("div", { class: "smake:size-16 smake:rounded-full smake:bg-[conic-gradient(red,yellow,lime,aqua,blue,magenta,red)]" }, null, -1)),
            z("div", v3, j(r.$t("product_colors")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        x(l(ln), { to: l(t) }, {
          default: M(() => [
            x(Qe, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:opacity-0"
            }, {
              default: M(() => [
                x(l(cn), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
              ]),
              _: 1
            }),
            x(Qe, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:-right-120",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:-right-120"
            }, {
              default: M(() => [
                x(l(un), {
                  "as-child": "",
                  onInteractOutside: i,
                  onEscapeKeyDown: i
                }, {
                  default: M(() => [
                    x(_3, {
                      onClose: c[0] || (c[0] = (u) => a.value = !1)
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["open"]));
  }
}), Mo = /* @__PURE__ */ J({
  __name: "ButtonIcon",
  props: {
    size: { default: "default" },
    type: {}
  },
  setup(e) {
    return (t, n) => {
      const o = De("FontAwesomeIcon");
      return $(), H(o, {
        class: ye({
          "smake:h-4.75 smake:max-w-4.75": e.size === "default",
          "smake:h-7 smake:max-w-7": e.size === "big",
          "smake:h-3 smake:max-w-3": e.size === "small"
        }),
        "fixed-width": e.type[0] === "fak",
        icon: e.type
      }, null, 8, ["class", "fixed-width", "icon"]);
    };
  }
}), qp = J_({ prefix: "smake" }), dn = /* @__PURE__ */ J({
  inheritAttrs: !1,
  __name: "ButtonShape",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" },
    disabled: { type: Boolean },
    noPadding: { type: Boolean },
    size: { default: "default" },
    type: {}
  },
  setup(e) {
    const t = e, { disabled: n, type: o } = we(t), a = S(
      () => n.value ? "disabled" : o.value
    );
    return (s, i) => ($(), H(l(x_), Qs({ ...s.$attrs, class: void 0 }, {
      as: e.as,
      "as-child": e.asChild,
      disabled: l(n),
      class: l(qp)(
        "smake:flex smake:items-center smake:justify-center smake:gap-3 smake:rounded-[50px] smake:text-xs smake:font-medium",
        // paddings
        e.size === "small" && !e.noPadding && "smake:px-5 smake:py-1.25",
        e.size === "default" && !e.noPadding && "smake:px-7.5 smake:py-1.5",
        e.size === "big" && !e.noPadding && "smake:min-h-14.5 smake:leading-1.75",
        // height
        e.size === "small" && "smake:min-h-7.5",
        e.size === "default" && "smake:min-h-12",
        e.size === "big" && "smake:min-h-14.5 smake:leading-1.75",
        // colors
        a.value === "active" && "smake:bg-black smake:text-white",
        a.value === "secondary" && "smake:border smake:border-secondary-3 smake:bg-secondary-3 smake:text-black smake:hover:bg-secondary-2",
        a.value === "subordinate" && "smake:border smake:border-secondary-2 smake:bg-transparent smake:text-black smake:hover:border-black",
        a.value === "primary" && "smake:border smake:border-primary-1 smake:bg-primary-1 smake:text-white smake:hover:bg-primary-2",
        a.value === "other" && "smake:border smake:border-white smake:bg-white smake:text-black",
        a.value === "disabled" && "smake:border smake:border-secondary-2 smake:bg-transparent smake:text-secondary-2",
        s.$attrs.class
      )
    }), {
      default: M(() => [
        Et(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["as", "as-child", "disabled", "class"]));
  }
}), g3 = { key: 1 }, Se = /* @__PURE__ */ J({
  __name: "Button",
  props: {
    disabled: { type: Boolean, default: !1 },
    icon: { default: void 0 },
    size: { default: "default" },
    text: { default: void 0 },
    type: {}
  },
  setup(e) {
    const t = e, { icon: n } = we(t), o = S(() => {
      if (n.value)
        return n.value.position ? n.value.position : "before";
    });
    return (a, s) => ($(), H(dn, {
      disabled: e.disabled,
      size: e.size,
      type: e.type
    }, {
      default: M(() => [
        o.value === "before" && l(n) ? ($(), H(Mo, {
          key: 0,
          class: ye(l(n).class),
          type: l(n).type
        }, null, 8, ["class", "type"])) : Q("", !0),
        e.text ? ($(), E("div", g3, j(e.text), 1)) : Q("", !0),
        o.value === "after" && l(n) ? ($(), H(Mo, {
          key: 2,
          class: ye(l(n).class),
          type: l(n).type
        }, null, 8, ["class", "type"])) : Q("", !0)
      ]),
      _: 1
    }, 8, ["disabled", "size", "type"]));
  }
});
function mi() {
  const { data: e } = L(qt());
  return S(() => e.value.filter(
    (n) => n.positioningAreas.some(
      (o) => o.designs.length > 0
    ) && !!n.handle
  ).map((n) => Op(n)));
}
const Bp = rt("saveAndContinue", () => {
  const { t: e } = dt(), { open: t } = vn(), n = mi(), { data: o } = L(Jt()), a = S(() => !!s.value), s = S(
    () => {
      if (o.value && n.value.length !== 0)
        return {
          baseId: o.value.id,
          views: n.value
        };
    }
  ), i = N(), { isPending: r, mutate: c } = ct({
    ...re.variants.post.use(),
    onError: () => {
      t(Ot, {
        input: {
          text: e("boot_error.unexpected"),
          type: "info"
        }
      });
    },
    onSuccess(_) {
      i.value = _;
    }
  }), u = S(
    () => r.value || i.value
  );
  function d() {
    s.value && c(s.value);
  }
  const p = N();
  return Dp(
    "customVariant.customizations.completed",
    ({ id: _ }) => {
      i.value === _ && o.value && p.value && p.value({
        id: _,
        base: {
          id: o.value.base.id,
          external_identifier: o.value.base.external_identifier
        },
        external_identifier: o.value.external_identifier
      });
    }
  ), {
    canSaveAndContinue: a,
    isPending: u,
    onContinue: p,
    saveAndContinue: d
  };
}), y3 = { key: 0 }, k3 = /* @__PURE__ */ J({
  __name: "Continue",
  setup(e) {
    const t = Bp(), { saveAndContinue: n } = t, { canSaveAndContinue: o, isPending: a } = L(t);
    return (s, i) => {
      const r = De("FontAwesomeIcon");
      return $(), H(Se, {
        class: "smake:px-8 smake:py-4",
        "data-testid": "Continue",
        type: "primary",
        disabled: !l(o) || !!l(a),
        text: l(a) ? void 0 : s.$t("continue"),
        icon: l(a) ? {
          type: ["fal", "spinner"],
          class: "smake:animate-spin"
        } : void 0,
        onClick: i[0] || (i[0] = (c) => l(n)())
      }, {
        default: M(() => [
          l(a) ? ($(), H(r, {
            key: 1,
            class: "smake:h-7 smake:animate-spin",
            icon: ["fal", "spinner"]
          })) : ($(), E("div", y3, j(s.$t("continue")), 1))
        ]),
        _: 1
      }, 8, ["disabled", "text", "icon"]);
    };
  }
});
function Bt() {
  const { dialogs: e } = L(Hn()), t = N([]);
  function n(o, ...[a = {}]) {
    const { input: s = {}, removeOnUnmount: i = !0 } = a, { promise: r, resolve: c } = Promise.withResolvers(), u = Ad({
      component: xo(o),
      input: s,
      open: !0,
      resolve: c
    });
    return e.value.push(u), i && t.value.push(u), r;
  }
  return qn() && xl(() => {
    for (const o of t.value)
      o.open = !1;
  }), { open: n };
}
function Hp() {
  const { data: e } = L(Jt());
  return (t) => {
    if (e.value) {
      for (const n of e.value.views)
        for (const o of n.positioning_areas)
          if (o.id === t)
            return o;
    }
  };
}
function Ma(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
function Gp(e, t) {
  const { appConfiguration: n } = L(st());
  function o() {
    var u;
    const i = ((u = n.value) == null ? void 0 : u.colors.filter(
      ({ production_methods: d }) => d.some(
        ({ id: p }) => p === e.value
      )
    )) ?? [];
    let r, c = t.value ? 1 / 0 : -1 / 0;
    for (const d of i) {
      const p = jp([
        d.red,
        d.green,
        d.blue
      ]);
      t.value ? c > p && (c = p, r = d) : c < p && (c = p, r = d);
    }
    if (!r) throw new Error("No color found");
    return r;
  }
  function a() {
    var r;
    const i = (r = n.value) == null ? void 0 : r.fonts.filter(
      ({ production_methods: c }) => c.some(
        ({ id: u }) => u === e.value
      )
    ).sort((c, u) => c.family_name < u.family_name ? -1 : c.family_name > u.family_name ? 1 : 0)[0];
    if (!i) throw new Error("No font found");
    return i;
  }
  function s() {
    const i = a();
    return {
      bendingRadius: 0,
      color: { id: o().id },
      fontId: i.id,
      horizontalAlignment: wo.LEFT,
      offsetLeft: 0,
      paddingBottom: 2,
      size: Ma(10, i.min, i.max),
      text: ""
    };
  }
  return s;
}
const ac = {
  dtf: ["fak", "icon-easytransfer"],
  embroidery: ["fak", "icon-direkteinstickung"]
}, b3 = {
  dtf: "production_method_summary_dtf",
  embroidery: "production_method_summary_embroidery"
};
function Tt(e) {
  const t = Ih(e), { t: n } = dt(), { availableProductionMethodIds: o, selectedProductionMethodId: a } = L(nt()), s = S(() => a.value === t.value), i = S(() => o.value === void 0 || t.value === void 0 ? !1 : o.value.has(
    t.value
  )), { appConfiguration: r, designerConfiguration: c } = L(
    st()
  ), u = S(() => {
    var f;
    return (f = r.value) == null ? void 0 : f.productionMethods.find(
      ({ id: g }) => g === t.value
    );
  }), d = S(() => {
    var f, g;
    return (g = (f = c.value) == null ? void 0 : f.settings.production_methods) == null ? void 0 : g.find(
      ({ id: b }) => b === t.value
    );
  }), p = S(() => {
    if (!u.value) return;
    const f = b3[u.value.handle];
    if (f)
      return n(f);
  }), _ = S(() => {
    if (u.value)
      return ac[u.value.handle];
  }), y = S(
    () => {
      var f;
      return !!((f = d.value) != null && f.customer_upload);
    }
  ), k = S(
    () => {
      var f, g;
      return (g = (f = d.value) == null ? void 0 : f.customer_upload) == null ? void 0 : g.allowed_logo_file_types;
    }
  ), w = S(
    () => {
      var f, g;
      return (g = (f = d.value) == null ? void 0 : f.customer_upload) == null ? void 0 : g.max_file_size_mb;
    }
  );
  return {
    allowedExtensions: k,
    icon: _,
    isAvailableOnCurrentVariant: i,
    isCustomerLogoUploadEnabled: y,
    isSelected: s,
    maxFileSizeMb: w,
    productionMethod: u,
    shortDescription: p
  };
}
const w3 = ["disabled"], x3 = { class: "smake:grow smake:text-left smake:font-semibold" }, zs = /* @__PURE__ */ J({
  __name: "AddComponentButton",
  props: {
    icon: {},
    loading: { type: Boolean },
    primary: { type: Boolean },
    text: {}
  },
  setup(e) {
    return (t, n) => {
      const o = De("FontAwesomeIcon");
      return $(), E("button", {
        class: ye(["smake:group smake:flex smake:min-h-30 smake:items-center smake:justify-between smake:gap-6 smake:rounded-2xl smake:border smake:border-secondary-2 smake:px-8 smake:py-4 smake:duration-100 smake:enabled:hover:border-black", { "smake:animate-pulse smake:bg-secondary-3": e.loading }]),
        disabled: e.loading,
        type: "button"
      }, [
        e.loading ? Q("", !0) : ($(), E(me, { key: 0 }, [
          z("div", {
            class: ye(["smake:flex smake:items-center smake:justify-center smake:rounded-full smake:p-3.75", {
              "smake:bg-primary-1 smake:text-white": e.primary,
              "smake:bg-secondary-3 smake:text-black": !e.primary
            }])
          }, [
            x(o, {
              icon: e.icon,
              "fixed-width": "",
              class: "smake:size-5"
            }, null, 8, ["icon"])
          ], 2),
          z("div", x3, j(e.text), 1),
          z("div", null, [
            x(o, {
              class: "smake:h-4",
              icon: ["fal", "plus"]
            })
          ])
        ], 64))
      ], 10, w3);
    };
  }
});
var Ct = /* @__PURE__ */ ((e) => (e.CUSTOMER_LOGO_DELETE = "featureFlagCustomerLogoDelete", e.CUSTOMER_LOGO_UPLOAD = "featureFlagCustomerLogoUpload", e))(Ct || {});
const ft = /* @__PURE__ */ J({
  __name: "IconButton",
  props: {
    disabled: { type: Boolean, default: !1 },
    icon: {},
    size: { default: "small" },
    type: {}
  },
  setup(e) {
    return (t, n) => ($(), H(dn, {
      class: ye({
        "smake:size-7.5 smake:p-1.25": e.size === "small",
        "smake:size-12 smake:p-1.5": e.size === "default",
        "smake:size-14.5": e.size === "big"
      }),
      disabled: e.disabled,
      size: "none",
      type: e.type
    }, {
      default: M(() => [
        x(Mo, {
          size: e.size,
          type: e.icon.type,
          spin: e.icon.spin
        }, null, 8, ["size", "type", "spin"])
      ]),
      _: 1
    }, 8, ["class", "disabled", "type"]));
  }
}), $3 = { class: "smake:flex smake:items-center smake:justify-between smake:gap-2" }, z3 = { class: "smake:h-full smake:overflow-y-auto smake:transition-all" }, Ro = /* @__PURE__ */ J({
  __name: "Dialog",
  props: /* @__PURE__ */ Te({
    fixedHeight: { type: Boolean, default: !1 },
    mobileCentered: { type: Boolean },
    preventClose: { type: Boolean, default: !1 },
    title: {},
    width: { default: "large" }
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Te(["closed"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = e, { preventClose: o } = we(n), a = t, s = Ue(e, "open"), { dialogsRoot: i } = L(Hn());
    function r(c) {
      o.value && c.preventDefault();
    }
    return (c, u) => ($(), H(l(rn), {
      open: s.value,
      "onUpdate:open": u[1] || (u[1] = (d) => s.value = d)
    }, {
      default: M(() => [
        x(l(ln), { to: l(i) }, {
          default: M(() => [
            x(Qe, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:opacity-0",
              onAfterLeave: u[0] || (u[0] = (d) => a("closed"))
            }, {
              default: M(() => [
                x(l(cn), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
              ]),
              _: 1
            }),
            x(Qe, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0"
            }, {
              default: M(() => [
                x(l(un), {
                  "as-child": "",
                  onInteractOutside: r,
                  onEscapeKeyDown: r
                }, {
                  default: M(() => [
                    z("div", {
                      class: ye(["smake:absolute smake:inset-0 smake:mx-auto smake:flex smake:max-w-full smake:justify-center smake:overflow-hidden smake:@sm:max-w-[calc(100%-96px)]", {
                        "smake:w-xl": e.width === "large",
                        "smake:w-200": e.width === "small",
                        "smake:items-end smake:@sm:items-center": !e.mobileCentered,
                        "smake:items-center": e.mobileCentered
                      }])
                    }, [
                      z("div", {
                        class: ye(["smake:flex smake:max-h-full smake:w-full smake:flex-col smake:gap-4 smake:rounded-3xl smake:bg-white smake:p-4.5 smake:@md:p-9", {
                          "smake:h-[calc(100%-96px)]": e.fixedHeight,
                          "smake:rounded-b-none smake:@sm:rounded-b-3xl": !e.mobileCentered
                        }])
                      }, [
                        z("div", $3, [
                          x(l(sn), { class: "smake:text-xl smake:font-bold smake:uppercase" }, {
                            default: M(() => [
                              Pe(j(e.title), 1)
                            ]),
                            _: 1
                          }),
                          x(l(Wt), { "as-child": "" }, {
                            default: M(() => [
                              x(ft, {
                                disabled: l(o),
                                type: "subordinate",
                                icon: {
                                  type: ["fak", "icon-x"]
                                }
                              }, null, 8, ["disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        u[2] || (u[2] = z("hr", { class: "smake:border smake:border-secondary-2" }, null, -1)),
                        z("div", z3, [
                          Et(c.$slots, "default")
                        ])
                      ], 2)
                    ], 2)
                  ]),
                  _: 3
                })
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 8, ["to"])
      ]),
      _: 3
    }, 8, ["open"]));
  }
});
function S3(e, t) {
  const { t: n } = dt(), o = vt(t), a = vt(e), s = S(() => {
    if (a.value instanceof Us)
      return a.value;
  }), i = S(() => {
    if (a.value instanceof eo)
      return a.value;
  }), r = S(() => {
    var _;
    if (((_ = i.value) == null ? void 0 : _.response.status) === 422)
      return i.value;
  }), { data: c } = zt({
    enabled: S(() => !!r.value),
    queryFn: () => {
      var _;
      return (_ = r.value) == null ? void 0 : _.response.json();
    },
    queryKey: [r]
  }), u = S(() => {
    var _;
    if (a.value)
      return s.value ? s.value.message : r.value ? (_ = c.value) == null ? void 0 : _.message : o.value ?? n("boot_error.unexpected");
  }), d = S(() => {
    var _;
    return (_ = c.value) == null ? void 0 : _.errors;
  }), p = S(() => {
    var _;
    return (_ = i.value) == null ? void 0 : _.response.status;
  });
  return {
    fieldMessages: d,
    message: u,
    statusCode: p
  };
}
const C3 = /* @__PURE__ */ J({
  __name: "PositioningArea",
  props: {
    activeProductionMethodId: {},
    data: {}
  },
  setup(e) {
    const t = e, { activeProductionMethodId: n, data: o } = we(t), { isLight: a } = ra(o), s = S(() => [1, 1, 1, 0.5]), i = S(() => {
      if (r.value)
        return s.value;
    }), r = S(() => o.value.designs.length === 0);
    return (c, u) => ($(), H(l(Ba), {
      data: l(o),
      hidden: l(o).productionMethodId !== l(n),
      "stroke-color": l(a) ? 4605510 : 14474460,
      "fill-color": i.value
    }, {
      default: M(() => [
        ($(!0), E(me, null, Ce(l(o).designs, (d) => ($(), H(l(Ha), {
          key: l(yt)(d),
          data: d,
          "production-method-id": l(o).productionMethodId
        }, null, 8, ["data", "production-method-id"]))), 128))
      ]),
      _: 1
    }, 8, ["data", "hidden", "stroke-color", "fill-color"]));
  }
}), A3 = { class: "smake:relative" }, P3 = /* @__PURE__ */ J({
  __name: "ProductionMethodViewsPreview",
  props: /* @__PURE__ */ Te({
    productionMethodId: {}
  }, {
    selectedViewIndex: {
      required: !0
    },
    selectedViewIndexModifiers: {}
  }),
  emits: ["update:selectedViewIndex"],
  setup(e) {
    const { data: t } = L(qt()), n = Ue(e, "selectedViewIndex");
    function o() {
      n.value = (n.value + 1) % t.value.length;
    }
    function a() {
      n.value = (n.value - 1 + t.value.length) % t.value.length;
    }
    return (s, i) => ($(), E("div", A3, [
      x(l(qa), { class: "smake:size-full" }, {
        default: M(() => [
          ($(!0), E(me, null, Ce(l(t), (r, c) => ($(), H(l(Ga), {
            key: l(yt)(r),
            data: r,
            hidden: c !== n.value
          }, {
            default: M(() => [
              ($(!0), E(me, null, Ce(r.positioningAreas, (u) => ($(), H(C3, {
                key: l(yt)(u),
                data: u,
                "active-production-method-id": e.productionMethodId
              }, null, 8, ["data", "active-production-method-id"]))), 128))
            ]),
            _: 2
          }, 1032, ["data", "hidden"]))), 128))
        ]),
        _: 1
      }),
      x(ft, {
        type: "secondary",
        class: "smake:absolute smake:top-1/2 smake:left-0 smake:translate-x-1/2 smake:-translate-y-1/2",
        size: "big",
        icon: {
          type: ["fal", "chevron-left"]
        },
        onClick: a
      }),
      x(ft, {
        type: "secondary",
        class: "smake:absolute smake:top-1/2 smake:right-0 smake:-translate-x-1/2 smake:-translate-y-1/2",
        size: "big",
        icon: {
          type: ["fal", "chevron-right"]
        },
        onClick: o
      })
    ]));
  }
}), T3 = { class: "smake:absolute smake:top-1/2 smake:left-1/2 smake:mx-auto smake:flex smake:h-fit smake:max-h-full smake:w-170 smake:max-w-full smake:-translate-x-1/2 smake:-translate-y-1/2 smake:flex-col smake:gap-6 smake:rounded-3xl smake:bg-white smake:p-4" }, M3 = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, I3 = { class: "smake:flex smake:grow smake:flex-col smake:gap-4 smake:bg-white" }, E3 = { class: "smake:flex smake:items-center smake:gap-3 smake:rounded-xl smake:border smake:border-secondary-2 smake:p-3" }, O3 = { class: "smake:font-semibold" }, R3 = { class: "smake:leading-6" }, L3 = { class: "smake:font-semibold" }, j3 = { class: "smake:h-full" }, D3 = { class: "smake:flex smake:justify-between smake:gap-5" }, N3 = /* @__PURE__ */ J({
  __name: "ChangeProductionMethodDialouge",
  props: /* @__PURE__ */ Te({
    targetProductionMethodId: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Te(["closed", "resolve"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = t, o = Ue(e, "open"), a = e, { targetProductionMethodId: s } = we(a), { rootElement: i } = L(Vt()), { appConfiguration: r } = L(st()), { selectedProductionMethodId: c } = L(nt()), u = S(
      () => {
        var w;
        return (w = r.value) == null ? void 0 : w.productionMethods.find(
          (f) => f.id === c.value
        );
      }
    ), d = S(
      () => {
        var w;
        return (w = r.value) == null ? void 0 : w.productionMethods.find(
          (f) => f.id === s.value
        );
      }
    ), p = S(() => {
      if (d.value)
        return ac[d.value.handle];
    }), { selectedViewIndex: _ } = L(qt()), y = N(_.value);
    function k() {
      _.value = y.value, n("resolve", !0);
    }
    return (w, f) => ($(), H(l(rn), {
      open: o.value,
      "onUpdate:open": f[2] || (f[2] = (g) => o.value = g)
    }, {
      default: M(() => [
        x(l(ln), { to: l(i) }, {
          default: M(() => [
            x(Qe, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:opacity-0",
              onAfterLeave: f[0] || (f[0] = (g) => n("closed"))
            }, {
              default: M(() => [
                x(l(cn), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
              ]),
              _: 1
            }),
            x(Qe, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:scale-95 smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:scale-95 smake:opacity-0"
            }, {
              default: M(() => [
                x(l(un), { "as-child": "" }, {
                  default: M(() => {
                    var g, b;
                    return [
                      z("div", T3, [
                        z("div", M3, [
                          x(l(sn), { class: "smake:flex smake:items-center smake:gap-3 smake:text-2xl smake:font-bold smake:uppercase" }, {
                            default: M(() => {
                              var A;
                              return [
                                p.value ? ($(), H(l(Fo), {
                                  key: 0,
                                  icon: p.value,
                                  "fixed-width": "",
                                  class: "smake:size-6"
                                }, null, 8, ["icon"])) : Q("", !0),
                                Pe(" " + j((A = d.value) == null ? void 0 : A.display_name) + " " + j(w.$t("icon")), 1)
                              ];
                            }),
                            _: 1
                          }),
                          x(l(Wt), { "as-child": "" }, {
                            default: M(() => [
                              x(ft, {
                                icon: {
                                  type: ["fak", "icon-x"]
                                },
                                type: "subordinate"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        z("div", I3, [
                          z("div", E3, [
                            x(l(Fo), {
                              icon: ["fal", "circle-exclamation"],
                              "fixed-width": "",
                              class: "smake:size-6"
                            }),
                            z("div", O3, j(w.$t("change_production_method_info", {
                              fromProductionMethod: (g = u.value) == null ? void 0 : g.display_name
                            })), 1)
                          ]),
                          z("div", R3, j(w.$t(
                            "to_place_motif_change_production_method",
                            {
                              toProductionMethod: (b = d.value) == null ? void 0 : b.display_name
                            }
                          )), 1),
                          z("div", L3, j(w.$t(
                            "preview_of_possibile_positioning_areas"
                          )) + ": ", 1),
                          z("div", j3, [
                            x(P3, {
                              "selected-view-index": y.value,
                              "onUpdate:selectedViewIndex": f[1] || (f[1] = (A) => y.value = A),
                              "production-method-id": l(s)
                            }, null, 8, ["selected-view-index", "production-method-id"])
                          ])
                        ]),
                        z("div", D3, [
                          x(l(Wt), null, {
                            default: M(() => [
                              x(Se, {
                                type: "subordinate",
                                text: w.$t("abort")
                              }, null, 8, ["text"])
                            ]),
                            _: 1
                          }),
                          x(l(Wt), null, {
                            default: M(() => {
                              var A;
                              return [
                                x(Se, {
                                  type: "primary",
                                  text: w.$t("change_to_x", {
                                    x: (A = d.value) == null ? void 0 : A.display_name
                                  }),
                                  onClick: k
                                }, null, 8, ["text"])
                              ];
                            }),
                            _: 1
                          })
                        ])
                      ])
                    ];
                  }),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["open"]));
  }
});
function V3() {
  const e = ut(), t = on(
    (o) => e.fetchQuery({
      ...re.logos.get.use(o),
      retry: !1,
      staleTime: 1 / 0
    })
  );
  async function n(o, a) {
    const s = Gs(o), i = Gs(a), r = i.find(
      (y) => y.type === $e.LOGO
    ), c = i.find(
      (y) => y.type === $e.TEXT
    );
    if (a.type === $e.ANCHOR) return a;
    const u = s.find(
      (y) => y.type === $e.LOGO
    ), d = s.find(
      (y) => y.type === $e.TEXT
    ), p = c ?? d, _ = r ?? u;
    if (_ !== void 0 && p !== void 0) {
      const y = to(await t(_.logoId));
      return {
        children: [
          {
            anchor: y.design_settings.next_element_alignment.anchor_value,
            offset: y.design_settings.next_element_alignment.offset,
            value: p
          }
        ],
        parent: _,
        type: $e.ANCHOR
      };
    }
    if (p)
      return p;
    if (_)
      return _;
    throw new Error("Design Merge Failed. Invalid data");
  }
  return {
    merge: n
  };
}
function Gs(e) {
  return e.type === $e.ANCHOR ? [
    ...Gs(e.parent),
    ...e.children.flatMap((t) => Gs(t.value))
  ] : [e];
}
function U3() {
  const e = ut(), t = on(
    (o) => e.fetchQuery({
      ...re.logos.get.use(o),
      retry: !1,
      staleTime: 1 / 0
    })
  );
  async function n(o, a) {
    const s = await t(o.logoId);
    if (s.width === null || s.height === null || s.min_width === null || s.max_width === null || s.min_height === null || s.max_height === null || s.min_width >= s.max_width || s.min_height >= s.max_height)
      return o;
    const i = Math.min(
      Ma(
        Math.min(
          a.width / s.width,
          a.height / s.height
        ),
        Math.max(
          s.min_width / s.width,
          s.min_height / s.height
        ),
        Math.min(
          s.max_width / s.width,
          s.max_height / s.height
        )
      ),
      1
    );
    return o.size = {
      height: s.height * i,
      width: s.width * i
    }, o;
  }
  return {
    resize: n
  };
}
const pi = rt(
  "placeDesignToPositioningArea",
  () => {
    const { waitForSelectingPositioningArea: e } = Xt(), { open: t } = Bt(), {
      positioningArea: n,
      positioningAreaDesign: o
    } = L(gn()), { selectedPositioningAreaDesign: a } = L(On()), { selectedProductionMethodId: s } = L(
      nt()
    ), { resize: i } = U3(), { merge: r } = V3(), c = Hp();
    async function u(d, p) {
      var w;
      let _ = p == null ? void 0 : p.positioningArea, y = p == null ? void 0 : p.mergePostioningAreaDesign;
      if (_ && _.productionMethodId !== d.productionMethodId && (_ = void 0, y = void 0), !_ || d.productionMethodId !== s.value) {
        if (d.productionMethodId !== s.value && !await t(
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          N3,
          {
            input: {
              targetProductionMethodId: d.productionMethodId
            }
          }
        ))
          return "aborted-production-method-change";
        const f = s.value;
        if (s.value = d.productionMethodId, _ = (await e()).data, !_)
          return s.value = f, "aborted-positioning-area-selection";
      }
      n.value = _, y || (o.value = void 0);
      const k = d.design.type === $e.LOGO ? await i(d.design, _) : d.design;
      return y ? y.design = await r(
        y.design,
        k
      ) : (y = {
        design: k,
        rotation: ((w = c(_.id)) == null ? void 0 : w.direction) ?? 0
      }, _.designs.push(y), a.value = y), o.value = y, "success";
    }
    return {
      placeDesign: u
    };
  }
), Gn = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, a] of t)
    n[o] = a;
  return n;
}, F3 = {}, q3 = {
  id: "Ebene_2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18.89 14.34"
};
function B3(e, t) {
  return $(), E("svg", q3, [...t[0] || (t[0] = [
    Pd('<g id="Ebene_1-2"><g id="Gruppe_32181"><g id="Gruppe_1731"><path fill="currentColor" d="M16.21.23c-.18-.16-.4-.24-.65-.23-.24.01-.46.12-.62.3l-5.87,6.63-2.82-2.82c-.35-.35-.92-.35-1.27,0-.35.35-.35.92,0,1.27l3.5,3.5c.17.17.4.26.64.26h.02s0,0,0,0c.25,0,.48-.12.65-.3l6.51-7.34c.33-.37.3-.94-.08-1.27Z"></path><path id="Pfad_1400" fill="currentColor" d="M18,7.65c-.49,0-.88.39-.88.88v3.15c0,.5-.42.9-.92.9H2.67c-.5,0-.9-.4-.91-.9v-3.15c0-.49-.39-.88-.88-.88s-.88.39-.88.88v3.16c.01,1.47,1.2,2.65,2.66,2.65h13.53c.71.03,1.4-.25,1.89-.77.51-.5.8-1.18.8-1.89v-3.16c0-.49-.39-.88-.88-.88"></path></g></g></g>', 1)
  ])]);
}
const H3 = /* @__PURE__ */ Gn(F3, [["render", B3]]), G3 = {}, W3 = {
  id: "Ebene_2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26.06 22.13"
};
function Z3(e, t) {
  return $(), E("svg", W3, [...t[0] || (t[0] = [
    z("g", { id: "Ebene_1-2" }, [
      z("path", {
        fill: "currentColor",
        d: "M23.85,3.99h-10.6l-3.33-3.27c-.47-.46-1.09-.72-1.75-.72H2.49C1.12,0,0,1.12,0,2.49v17.43c0,1.21.99,2.2,2.2,2.2h21.65c1.21,0,2.2-.99,2.2-2.2V6.19c0-1.21-.99-2.2-2.2-2.2ZM1.8,2.49c0-.38.31-.69.69-.69h5.69c.18,0,.36.07.49.2l2.02,1.99H1.8v-1.5ZM24.26,19.93c0,.22-.18.4-.4.4H2.2c-.22,0-.4-.18-.4-.4V5.79h22.05c.22,0,.4.18.4.4v13.73Z"
      }),
      z("path", {
        fill: "currentColor",
        d: "M9.92,18.46c-.15,0-.29-.05-.41-.13-.22-.16-.32-.42-.28-.68l.53-3.1-2.25-2.2c-.19-.19-.26-.46-.18-.72.08-.25.3-.44.56-.48l3.11-.45,1.39-2.82c.24-.48,1.02-.48,1.26,0l1.39,2.82,3.11.45c.26.04.48.22.56.48.08.25.01.53-.18.72l-2.25,2.2.53,3.1c.04.26-.06.53-.28.68-.22.16-.5.18-.74.05l-2.79-1.46-2.79,1.46c-.1.05-.21.08-.33.08ZM13.03,15.42c.11,0,.22.03.33.08l1.86.98-.35-2.07c-.04-.23.04-.46.2-.62l1.5-1.46-2.08-.3c-.23-.03-.43-.18-.53-.38l-.93-1.88-.93,1.88c-.1.21-.3.35-.53.38l-2.08.3,1.5,1.46c.17.16.24.39.2.62l-.35,2.07,1.86-.98c.1-.05.21-.08.33-.08Z"
      })
    ], -1)
  ])]);
}
const K3 = /* @__PURE__ */ Gn(G3, [["render", Z3]]), Q3 = { class: "smake:flex smake:grow smake:flex-col smake:items-center smake:gap-1 smake:font-semibold" }, X3 = {
  key: 0,
  class: "smake:text-xs"
}, J3 = /* @__PURE__ */ J({
  __name: "SelectItem",
  props: {
    productionMethodId: {},
    selectedProductionMethodId: {}
  },
  setup(e) {
    const t = e, { productionMethodId: n, selectedProductionMethodId: o } = we(t), { isAvailableOnCurrentVariant: a, productionMethod: s, shortDescription: i } = Tt(n);
    return (r, c) => l(s) ? ($(), H(l(Ud), {
      key: 0,
      disabled: !l(a),
      value: l(s).id.toString(),
      class: ye({
        "smake:text-slate-400 smake:grayscale-[98%]": !l(a)
      }),
      "as-child": ""
    }, {
      default: M(() => [
        x(dn, {
          class: "smake:p-1 smake:pr-2",
          "no-padding": "",
          type: l(o) === l(n) ? "active" : "subordinate"
        }, {
          default: M(() => [
            x(Yt, {
              src: l(s).preview_url,
              class: "smake:size-12 smake:rounded-full smake:object-cover smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2"
            }, null, 8, ["src"]),
            z("div", Q3, [
              x(l(Fd), null, {
                default: M(() => [
                  Pe(j(l(s).display_name), 1)
                ]),
                _: 1
              }),
              l(i) ? ($(), E("span", X3, j(l(i)), 1)) : Q("", !0)
            ])
          ]),
          _: 1
        }, 8, ["type"])
      ]),
      _: 1
    }, 8, ["disabled", "value", "class"])) : Q("", !0);
  }
}), Y3 = {
  key: 0,
  class: "smake:rounded-full smake:bg-secondary-3 smake:p-1.5"
}, Wp = /* @__PURE__ */ J({
  __name: "ProductionMethodSelect",
  props: /* @__PURE__ */ Te({
    disabled: { type: Boolean }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = Ue(e, "modelValue"), n = e, { disabled: o } = we(n), a = S({
      get: () => t.value.toString(),
      set: (u) => {
        t.value = Number.parseInt(u);
      }
    }), { icon: s, productionMethod: i } = Tt(t), { rootElement: r } = L(Vt()), { activatedProductionMethodIds: c } = L(
      nt()
    );
    return (u, d) => {
      const p = De("FontAwesomeIcon");
      return $(), H(l(qd), {
        modelValue: a.value,
        "onUpdate:modelValue": d[0] || (d[0] = (_) => a.value = _),
        disabled: l(o)
      }, {
        default: M(() => [
          x(l(Bd), { "as-child": "" }, {
            default: M(() => [
              x(dn, {
                type: "subordinate",
                class: "smake:grow smake:p-2 smake:@sm:grow-0",
                "no-padding": ""
              }, {
                default: M(() => [
                  l(s) ? ($(), E("div", Y3, [
                    x(p, {
                      icon: l(s),
                      "fixed-width": "",
                      class: "smake:size-4.5"
                    }, null, 8, ["icon"])
                  ])) : Q("", !0),
                  l(i) ? ($(), H(l(Hd), {
                    key: 1,
                    class: "smake:grow smake:p-1.5"
                  }, {
                    default: M(() => [
                      Pe(j(l(i).display_name), 1)
                    ]),
                    _: 1
                  })) : Q("", !0),
                  x(l($_), null, {
                    default: M(() => [
                      x(p, {
                        icon: ["fal", "chevron-down"],
                        class: "smake:h-4"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          x(l(Gd), { to: l(r) }, {
            default: M(() => [
              x(l(Wd), {
                class: "smake:rounded-3xl smake:bg-white smake:p-4 smake:shadow-[0_0_15px_0_rgba(0,0,0,0.25)]",
                position: "popper",
                "side-offset": 8,
                align: "center"
              }, {
                default: M(() => [
                  x(l(Zd), { class: "smake:flex smake:flex-col smake:gap-2" }, {
                    default: M(() => [
                      ($(!0), E(me, null, Ce(l(c), (_) => ($(), H(J3, {
                        key: _,
                        "selected-production-method-id": t.value,
                        "production-method-id": _
                      }, null, 8, ["selected-production-method-id", "production-method-id"]))), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"]);
    };
  }
}), xa = /* @__PURE__ */ J({
  __name: "VariantTabsTrigger",
  props: {
    selectedValue: {},
    value: {}
  },
  setup(e) {
    const t = e, { selectedValue: n, value: o } = we(t), a = S(() => n.value === o.value);
    return (s, i) => ($(), H(l(Kd), {
      value: l(o),
      "as-child": ""
    }, {
      default: M(() => [
        x(dn, {
          type: a.value ? "active" : "subordinate"
        }, {
          default: M(() => [
            Et(s.$slots, "default")
          ]),
          _: 3
        }, 8, ["type"])
      ]),
      _: 3
    }, 8, ["value"]));
  }
});
function e6(e) {
  const t = vt(e), { data: n } = L(qt());
  return S(
    () => n.value.some((o) => t3(o, t.value))
  );
}
const Zp = rt("deletedLogo", () => ({
  logoIdsToSuppresInfoToast: N(/* @__PURE__ */ new Set())
})), t6 = { class: "smake:leading-6 smake:tracking-wide" }, n6 = { key: 0 }, o6 = { class: "smake:font-bold smake:text-primary-1" }, a6 = { class: "smake:mt-8 smake:flex smake:flex-col smake:items-center smake:gap-4" }, s6 = {
  key: 0,
  class: "smake:w-full smake:rounded-lg smake:border smake:border-danger smake:p-2 smake:text-danger"
}, i6 = { class: "smake:mt-10.75 smake:flex smake:justify-center smake:gap-5" }, Kp = /* @__PURE__ */ J({
  __name: "DeleteDialog",
  props: /* @__PURE__ */ Te({
    name: {},
    error: {},
    image: {},
    mutationStatus: {},
    showCurrentlyPlacedWarning: { type: Boolean }
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Te(["closed", "delete"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = e, { mutationStatus: o } = we(n), a = t, s = Ue(e, "open"), i = S(() => o.value === "pending");
    return (r, c) => {
      const u = De("I18nT");
      return $(), H(Ro, {
        open: s.value,
        "onUpdate:open": c[2] || (c[2] = (d) => s.value = d),
        title: `${r.$t("attention")}!`,
        "prevent-close": i.value,
        "mobile-centered": "",
        width: "small",
        onClosed: c[3] || (c[3] = (d) => a("closed"))
      }, {
        default: M(() => [
          z("div", t6, [
            e.showCurrentlyPlacedWarning ? ($(), E("div", n6, j(r.$t("motif_placed_in_current_design")), 1)) : Q("", !0),
            x(u, {
              keypath: "are_you_sure_you_want_to_delete",
              tag: "div"
            }, {
              deleteName: M(() => [
                z("span", o6, j(e.name), 1)
              ]),
              _: 1
            })
          ]),
          z("div", a6, [
            x(Yt, {
              class: "smake:size-80 smake:rounded-3xl smake:bg-secondary-3 smake:object-contain smake:p-4 smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2",
              src: e.image
            }, null, 8, ["src"]),
            e.error ? ($(), E("div", s6, j(r.$t("boot_error.unexpected")), 1)) : Q("", !0)
          ]),
          z("div", i6, [
            x(Se, {
              type: "subordinate",
              class: "smake:grow",
              disabled: i.value,
              text: r.$t("abort"),
              onClick: c[0] || (c[0] = (d) => s.value = !1)
            }, null, 8, ["disabled", "text"]),
            x(Se, {
              icon: {
                type: ["fak", "icon-remove"]
              },
              type: "primary",
              class: "smake:grow",
              disabled: i.value,
              text: r.$t("delete"),
              onClick: c[1] || (c[1] = (d) => a("delete"))
            }, null, 8, ["disabled", "text"])
          ])
        ]),
        _: 1
      }, 8, ["open", "title", "prevent-close"]);
    };
  }
}), r6 = { class: "smake:font-bold smake:text-primary-1" }, l6 = { class: "smake:flex smake:flex-col smake:items-center smake:justify-between smake:gap-5" }, c6 = {
  key: 0,
  class: "smake:w-full smake:rounded-lg smake:border smake:border-danger smake:p-2 smake:text-danger"
}, u6 = { class: "smake:w-full smake:flex-col" }, d6 = ["disabled"], m6 = {
  key: 0,
  class: "smake:flex smake:flex-col smake:justify-start smake:gap-2 smake:p-1 smake:text-xs smake:font-bold smake:text-danger"
}, p6 = { class: "smake:mt-10.75 smake:flex smake:justify-center smake:gap-5" }, Qp = /* @__PURE__ */ J({
  __name: "RenameDialog",
  props: /* @__PURE__ */ Te({
    name: {},
    error: {},
    image: {},
    mutationStatus: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Te(["closed", "rename"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = t, o = Ue(e, "open"), a = e, s = a.name, { error: i, mutationStatus: r } = we(a), c = S(() => r.value === "pending"), u = N(), d = N(s);
    se(() => {
      r.value === "success" && (o.value = !1);
    });
    const { t: p } = dt();
    function _() {
      if (d.value === a.name) {
        o.value = !1;
        return;
      }
      n("rename", d.value);
    }
    const { data: y } = zt({
      enabled: S(() => !!i.value),
      queryFn: () => {
        if (i.value instanceof eo)
          return i.value.response.json();
      },
      queryKey: [i]
    }), k = S(() => {
      if (!(!i.value || i.value instanceof eo && i.value.response.status === 422))
        return p("boot_error.unexpected");
    }), w = S(() => {
      var f;
      if (!(!i.value || !(i.value instanceof eo) || i.value.response.status !== 422))
        return (f = y.value) == null ? void 0 : f.errors.name;
    });
    return (f, g) => {
      const b = De("I18nT");
      return $(), H(Ro, {
        open: o.value,
        "onUpdate:open": g[2] || (g[2] = (A) => o.value = A),
        title: `${f.$t("attention")}!`,
        "prevent-close": c.value,
        "mobile-centered": "",
        width: "small",
        onClosed: g[3] || (g[3] = (A) => n("closed"))
      }, {
        default: M(() => [
          x(b, {
            keypath: "do_you_want_to_rename",
            tag: "span",
            class: "smake:align-middle smake:leading-6 smake:tracking-wide"
          }, {
            name: M(() => [
              z("span", r6, j(l(s)), 1)
            ]),
            _: 1
          }),
          z("div", l6, [
            x(Yt, {
              class: "smake:mt-8 smake:size-80 smake:rounded-3xl smake:bg-secondary-3 smake:object-contain smake:p-4 smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2",
              src: e.image
            }, null, 8, ["src"]),
            k.value && !w.value ? ($(), E("div", c6, j(k.value), 1)) : Q("", !0),
            z("div", u6, [
              kt(z("input", {
                ref_key: "newNameInput",
                ref: u,
                "onUpdate:modelValue": g[0] || (g[0] = (A) => d.value = A),
                type: "text",
                maxlength: 60,
                class: ye(["smake:w-full smake:rounded-md smake:border smake:px-4 smake:py-3 smake:outline-none smake:focus:border-black smake:disabled:cursor-not-allowed smake:disabled:text-secondary-2", w.value ? "border-danger" : "border-secondary-2"]),
                placeholder: "Text einfügen",
                disabled: c.value,
                onKeydown: vs(_, ["enter"])
              }, null, 42, d6), [
                [zn, d.value]
              ]),
              w.value ? ($(), E("div", m6, [
                ($(!0), E(me, null, Ce(w.value, (A) => ($(), E("div", { key: A }, j(A), 1))), 128))
              ])) : Q("", !0)
            ])
          ]),
          z("div", p6, [
            x(Se, {
              type: "subordinate",
              class: "smake:grow",
              disabled: c.value,
              text: l(p)("abort"),
              onClick: g[1] || (g[1] = (A) => o.value = !1)
            }, null, 8, ["disabled", "text"]),
            x(Se, {
              type: "primary",
              class: "smake:grow",
              disabled: d.value.length === 0 || c.value,
              text: l(p)("save"),
              icon: { type: ["fal", "save"] },
              onClick: _
            }, null, 8, ["disabled", "text"])
          ])
        ]),
        _: 1
      }, 8, ["open", "title", "prevent-close"]);
    };
  }
}), fd = /* @__PURE__ */ J({
  __name: "Tooltip",
  setup(e) {
    return (t, n) => ($(), H(l(z_), {
      disabled: t.$slots.tooltip === void 0,
      "delay-duration": 0
    }, {
      default: M(() => [
        x(l(S_), null, {
          default: M(() => [
            x(l(C_), {
              as: "div",
              class: "smake:cursor-default"
            }, {
              default: M(() => [
                Et(t.$slots, "default")
              ]),
              _: 3
            }),
            x(l(A_), null, {
              default: M(() => [
                x(l(P_), {
                  class: "smake:data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade smake:data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade smake:data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade smake:data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] will-change-[transform,opacity] smake:rounded smake:bg-white smake:px-3.75 smake:py-2.5 smake:text-[15px] smake:leading-none smake:select-none",
                  "side-offset": 5
                }, {
                  default: M(() => [
                    Et(t.$slots, "tooltip"),
                    x(l(T_), {
                      class: "smake:fill-white",
                      width: 8
                    })
                  ]),
                  _: 3
                })
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["disabled"]));
  }
});
function hd(e, t) {
  return e.length > t ? `${e.slice(0, t)}…` : e;
}
const f6 = { class: "smake:flex smake:h-full smake:flex-col smake:overflow-clip smake:rounded-3xl smake:border smake:border-secondary-2" }, h6 = { class: "smake:flex smake:justify-center smake:pt-1 smake:pb-2" }, _6 = { class: "smake:flex smake:grow smake:flex-col smake:gap-2 smake:px-4 smake:py-4 smake:text-center" }, v6 = { class: "smake:flex smake:flex-col smake:gap-2" }, g6 = { class: "smake:font-bold" }, y6 = { class: "smake:text-xs" }, k6 = { class: "smake:flex smake:flex-wrap smake:justify-center smake:gap-2" }, b6 = {
  key: 0,
  class: "smake:size-4 smake:rounded-full smake:bg-[radial-gradient(#fff_15%,transparent_60%),conic-gradient(red,yellow,lime,aqua,blue,magenta,red)]"
}, w6 = { class: "smake:grow smake:text-xs smake:text-danger" }, x6 = { class: "smake:flex smake:flex-col smake:gap-3" }, Xp = /* @__PURE__ */ J({
  __name: "SelectionCard",
  props: {
    name: {},
    colorAssignments: {},
    deletable: { type: Boolean },
    externalIdentifier: {},
    height: {},
    image: {},
    needsRepair: { type: Boolean },
    productionMethodId: {},
    width: {}
  },
  emits: ["delete", "rename", "repair", "select"],
  setup(e, { emit: t }) {
    const n = e, { colorAssignments: o, productionMethodId: a } = we(n), s = t, { appConfiguration: i, designerConfiguration: r } = L(
      st()
    ), c = S(() => {
      var f;
      return (f = i.value) == null ? void 0 : f.colors;
    }), u = S(
      () => {
        var f;
        return (f = r.value) == null ? void 0 : f.settings.settings.units;
      }
    ), { decimalFormat: d } = ri(), { locale: p } = dt();
    function _(f) {
      if (f !== void 0)
        return d(f, p.value, 2);
    }
    const y = S(() => o.value.length === 0), k = S(() => o.value.map((g) => {
      var b;
      if (g.color) {
        const A = (b = c.value) == null ? void 0 : b.find(
          (P) => g.color.id === P.id
        );
        return A ? {
          blue: A.blue,
          green: A.green,
          red: A.red
        } : void 0;
      }
      return {
        blue: g.blue,
        green: g.green,
        red: g.red
      };
    }).filter((g) => !!g).reduce((g, b) => (g.some((A) => dl(A, b)) || g.push(b), g), [])), { icon: w } = Tt(a);
    return (f, g) => {
      var b;
      return $(), E("div", f6, [
        z("div", {
          class: ye(["smake:relative smake:cursor-pointer smake:p-8", {
            "smake:bg-danger/50": e.needsRepair,
            "smake:bg-secondary-3": !e.needsRepair
          }])
        }, [
          x(Yt, {
            src: e.image,
            class: "smake:aspect-square smake:w-full smake:rounded-2xl smake:object-contain smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2"
          }, null, 8, ["src"]),
          z("div", h6, [
            e.externalIdentifier ? ($(), H(fd, {
              key: 0,
              class: "smake:text-sm"
            }, Zr({
              default: M(() => [
                Pe(" #" + j(l(hd)(e.externalIdentifier, 15)) + " ", 1)
              ]),
              _: 2
            }, [
              e.externalIdentifier.length > 15 ? {
                name: "tooltip",
                fn: M(() => [
                  Pe(" #" + j(e.externalIdentifier), 1)
                ]),
                key: "0"
              } : void 0
            ]), 1024)) : Q("", !0)
          ]),
          e.deletable ? ($(), E("button", {
            key: 0,
            class: "smake:absolute smake:top-3 smake:right-3 smake:flex smake:aspect-square smake:w-10 smake:items-center smake:justify-center smake:rounded-full smake:bg-white smake:p-2 smake:hover:text-secondary-1",
            type: "button",
            onClick: g[0] || (g[0] = (A) => s("delete"))
          }, [
            x(l(Fo), {
              class: "smake:h-4",
              icon: ["fak", "icon-remove"],
              "fixed-width": ""
            })
          ])) : Q("", !0),
          l(w) ? ($(), H(l(Fo), {
            key: 1,
            class: "smake:absolute smake:top-4 smake:left-4 smake:h-4",
            icon: l(w),
            "fixed-width": ""
          }, null, 8, ["icon"])) : Q("", !0),
          e.needsRepair ? ($(), H(l(Fo), {
            key: 2,
            class: "smake:absolute smake:bottom-4 smake:left-4 smake:h-6 smake:rounded-full smake:bg-danger smake:text-white",
            icon: ["fal", "circle-exclamation"]
          })) : Q("", !0)
        ], 2),
        z("div", _6, [
          z("div", v6, [
            x(fd, null, Zr({
              default: M(() => [
                z("div", g6, j(l(hd)(e.name, 60)), 1)
              ]),
              _: 2
            }, [
              e.name.length > 60 ? {
                name: "tooltip",
                fn: M(() => [
                  Pe(j(e.name), 1)
                ]),
                key: "0"
              } : void 0
            ]), 1024),
            z("span", y6, j(_(e.width)) + " x " + j(_(e.height)) + " " + j((b = u.value) == null ? void 0 : b.length), 1)
          ]),
          z("div", k6, [
            y.value ? ($(), E("div", b6)) : Q("", !0),
            ($(!0), E(me, null, Ce(k.value, (A) => ($(), E("div", {
              key: l(yt)(A),
              class: ye([
                "smake:aspect-square smake:w-4 smake:rounded-full smake:border",
                l(nc)([A.red, A.green, A.blue]) ? "smake:border-secondary-2" : "smake:border-transparent"
              ]),
              style: Qt({
                backgroundColor: `rgb(${A.red},${A.green},${A.blue})`
              })
            }, null, 6))), 128))
          ]),
          z("div", w6, [
            Et(f.$slots, "repair-label")
          ]),
          z("div", x6, [
            x(Se, {
              disabled: e.needsRepair,
              type: "secondary",
              icon: {
                type: ["fal", "plus"]
              },
              size: "small",
              text: f.$t("choose"),
              onClick: g[1] || (g[1] = (A) => s("select"))
            }, null, 8, ["disabled", "text"]),
            e.needsRepair ? ($(), H(Se, {
              key: 0,
              type: "primary",
              icon: {
                type: ["fal", "rotate-reverse"]
              },
              size: "small",
              text: f.$t("update"),
              onClick: g[2] || (g[2] = (A) => s("repair"))
            }, null, 8, ["text"])) : ($(), H(Se, {
              key: 1,
              type: "subordinate",
              icon: {
                type: ["fak", "icon-edit"]
              },
              size: "small",
              text: f.$t("rename"),
              onClick: g[3] || (g[3] = (A) => s("rename"))
            }, null, 8, ["text"]))
          ])
        ])
      ]);
    };
  }
}), $6 = /* @__PURE__ */ J({
  __name: "CustomerLogoCard",
  props: {
    customerLogo: {}
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, { customerLogo: o } = we(n), a = t, { hasAccess: s } = Na(), i = N(!1), r = N(!1), {
      error: c,
      mutate: u,
      reset: d,
      status: p
    } = ct({
      ...re.customerLogos.patch.use(),
      onSuccess: () => {
        i.value = !1;
      }
    });
    se(() => {
      i.value || d();
    });
    const { logoIdsToSuppresInfoToast: _ } = L(Zp()), {
      error: y,
      mutate: k,
      status: w
    } = ct({
      ...re.customerLogos.delete.use(),
      onError: () => {
        _.value.delete(o.value.logo.id);
      },
      onMutate: () => {
        _.value.add(o.value.logo.id);
      },
      onSuccess: () => {
        r.value = !1;
      }
    }), f = S(
      () => o.value.name ?? o.value.logo.name
    ), g = S(() => o.value.logo.preview_url ?? void 0), b = e6(
      S(() => o.value.logo.id)
    );
    return (A, P) => ($(), E(me, null, [
      x(Xp, {
        name: f.value,
        "external-identifier": l(o).logo.external_identifier ?? void 0,
        image: g.value,
        width: l(o).logo.width ?? void 0,
        height: l(o).logo.height ?? void 0,
        "color-assignments": l(o).logo.color_assignments,
        "show-rainbow-icon": l(o).logo.color_assignments.length === 0,
        "production-method-id": l(o).logo.production_method.id,
        deletable: l(s)(l(Ct).CUSTOMER_LOGO_DELETE),
        onRename: P[0] || (P[0] = (I) => i.value = !0),
        onSelect: P[1] || (P[1] = (I) => a("select")),
        onDelete: P[2] || (P[2] = (I) => r.value = !0)
      }, null, 8, ["name", "external-identifier", "image", "width", "height", "color-assignments", "show-rainbow-icon", "production-method-id", "deletable"]),
      x(Qp, {
        open: i.value,
        "onUpdate:open": P[3] || (P[3] = (I) => i.value = I),
        name: f.value,
        image: g.value,
        error: l(c) ?? void 0,
        "mutation-status": l(p),
        onRename: P[4] || (P[4] = (I) => l(u)({ id: l(o).id, name: I }))
      }, null, 8, ["open", "name", "image", "error", "mutation-status"]),
      x(Kp, {
        open: r.value,
        "onUpdate:open": P[5] || (P[5] = (I) => r.value = I),
        "show-currently-placed-warning": l(b),
        name: f.value,
        image: g.value,
        "mutation-status": l(w),
        error: l(y) ?? void 0,
        onDelete: P[6] || (P[6] = (I) => l(k)(l(o).id))
      }, null, 8, ["open", "show-currently-placed-warning", "name", "image", "mutation-status", "error"])
    ], 64));
  }
}), z6 = {}, S6 = {
  id: "Ebene_2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18.41 17.09"
};
function C6(e, t) {
  return $(), E("svg", S6, [...t[0] || (t[0] = [
    z("g", { id: "Ebene_1-2" }, [
      z("path", {
        id: "Pfad_1021",
        fill: "currentColor",
        d: "M9.76.21c-.32-.28-.79-.28-1.12,0l-3.34,2.86c-.38.29-.45.83-.16,1.2.29.38.83.45,1.2.16.03-.02.05-.04.07-.06l1.92-1.64v7.67c.02.47.41.85.89.83.45-.02.81-.38.83-.83V2.72l1.92,1.64c.35.32.9.29,1.21-.07s.29-.9-.07-1.21c0,0-.02-.02-.03-.02L9.76.21Z"
      }),
      z("path", {
        id: "Pfad_1022",
        fill: "currentColor",
        d: "M17.54,10.56c-.47,0-.86.38-.86.86h0v3.07c0,.49-.4.88-.89.88H2.6c-.48,0-.88-.39-.89-.87v-3.08c-.02-.47-.41-.85-.89-.83-.45.02-.81.38-.83.83v3.08c.01,1.43,1.17,2.58,2.6,2.59h13.18c.69.03,1.37-.25,1.85-.75.49-.48.77-1.15.78-1.84v-3.08c0-.47-.38-.86-.86-.86,0,0,0,0,0,0Z"
      })
    ], -1)
  ])]);
}
const sc = /* @__PURE__ */ Gn(z6, [["render", C6]]), A6 = { class: "smake:flex smake:items-center smake:justify-center smake:rounded-full smake:bg-primary-1 smake:p-4 smake:text-white" }, P6 = { class: "smake:text-center smake:font-semibold" }, T6 = /* @__PURE__ */ J({
  __name: "CustomerLogoUploadCard",
  props: {
    positioningArea: {},
    positioningAreaDesign: {},
    productionMethodId: {}
  },
  emits: ["placed"],
  setup(e, { emit: t }) {
    const n = e, { productionMethodId: o } = we(n), { isCustomerLogoUploadEnabled: a } = Tt(o), s = t, i = N(!1);
    return (r, c) => l(a) ? ($(), E(me, { key: 0 }, [
      z("button", {
        class: "smake:flex smake:min-h-95 smake:flex-col smake:items-center smake:justify-center smake:gap-4 smake:rounded-3xl smake:border smake:border-secondary-2",
        onClick: c[0] || (c[0] = (u) => i.value = !0)
      }, [
        z("div", A6, [
          x(sc, { class: "smake:size-8" })
        ]),
        z("div", P6, j(r.$t("upload_file")), 1)
      ]),
      x(Qa, {
        open: i.value,
        "onUpdate:open": c[1] || (c[1] = (u) => i.value = u),
        "production-method-id": l(o),
        "positioning-area": e.positioningArea,
        "positioning-area-design": e.positioningAreaDesign,
        onResolve: c[2] || (c[2] = (u) => s("placed"))
      }, null, 8, ["open", "production-method-id", "positioning-area", "positioning-area-design"])
    ], 64)) : Q("", !0);
  }
}), M6 = {}, I6 = {
  href: "https://www.strauss.com/dl/mydesign_logos",
  target: "_blank",
  class: "smake:underline"
};
function E6(e, t) {
  const n = De("I18nT");
  return $(), H(n, {
    keypath: "upload_contact_form_hint",
    tag: "span"
  }, {
    contact_form: M(() => [
      z("a", I6, j(e.$t("contact_form")), 1)
    ]),
    _: 1
  });
}
const Jp = /* @__PURE__ */ Gn(M6, [["render", E6]]), O6 = { class: "smake:grid smake:grid-cols-auto-fill-38 smake:gap-4 smake:overflow-y-auto smake:@sm:grid-cols-auto-fill-45" }, R6 = {
  key: 0,
  class: "smake:-mt-8 smake:flex smake:grow smake:items-center smake:justify-center smake:text-center smake:text-lg smake:text-secondary-1"
}, L6 = { class: "smake:max-w-md" }, j6 = /* @__PURE__ */ J({
  __name: "CustomerLogoSelection",
  props: {
    positioningArea: {},
    positioningAreaDesign: {},
    productionMethodId: {}
  },
  emits: ["customer-logo-selected", "upload-placed"],
  setup(e, { emit: t }) {
    const n = t, o = e, { productionMethodId: a } = we(o), { isCustomerLogoUploadEnabled: s, productionMethod: i } = Tt(a), r = S(() => ({
      production_method: [a.value]
    })), {
      data: c,
      fetchNextPage: u,
      hasNextPage: d,
      isFetching: p,
      status: _
    } = Jo({
      ...re.customerLogos.list.use(r),
      select: (w) => w.pages.flatMap((f) => f.data),
      staleTime: 60 * 1e3
    });
    function y() {
      return _.value === "pending" ? !0 : d.value;
    }
    async function k() {
      _.value !== "pending" && await u();
    }
    return (w, f) => {
      var g, b, A;
      return $(), E(me, null, [
        kt(($(), E("div", O6, [
          x(T6, {
            "production-method-id": l(a),
            "positioning-area": e.positioningArea,
            "positioning-area-design": e.positioningAreaDesign,
            onPlaced: f[0] || (f[0] = (P) => n("upload-placed"))
          }, null, 8, ["production-method-id", "positioning-area", "positioning-area-design"]),
          l(p) || (g = l(c)) != null && g.length ? ($(!0), E(me, { key: 0 }, Ce(l(c), (P) => ($(), E("div", {
            key: P.id
          }, [
            x($6, {
              "customer-logo": P,
              onSelect: (I) => n("customer-logo-selected", l(to)(P))
            }, null, 8, ["customer-logo", "onSelect"])
          ]))), 128)) : Q("", !0),
          ($(!0), E(me, null, Ce(l(p) ? 3 : 0, (P) => ($(), E("div", {
            key: P,
            class: "smake:min-h-95 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3"
          }))), 128))
        ])), [
          [l(Ea), [k, { distance: 350, canLoadMore: y }]]
        ]),
        !l(p) && (((b = l(c)) == null ? void 0 : b.length) ?? 0) === 0 ? ($(), E("div", R6, [
          z("div", L6, [
            Pe(j(w.$t("no_customer_logos_for_production_method", {
              productionMethod: (A = l(i)) == null ? void 0 : A.display_name
            })) + " ", 1),
            l(s) ? Q("", !0) : ($(), E(me, { key: 0 }, [
              x(Jp),
              Pe(" " + j(w.$t("otherwise_change_personalization_type_top_right")), 1)
            ], 64))
          ])
        ])) : Q("", !0)
      ], 64);
    };
  }
}), D6 = {}, N6 = { class: "smake:relative smake:flex smake:min-w-79 smake:shrink-0 smake:flex-col smake:gap-4 smake:overflow-hidden smake:rounded-2xl smake:border smake:border-secondary-2 smake:p-4" };
function V6(e, t) {
  return $(), E("div", N6, [
    Et(e.$slots, "default")
  ]);
}
const ic = /* @__PURE__ */ Gn(D6, [["render", V6]]);
function fi(e, t, n) {
  const o = vt(n == null ? void 0 : n.min), a = vt(n == null ? void 0 : n.max), s = vt(n == null ? void 0 : n.step), i = N(
    typeof e.value == "number" ? _s(e.value, s.value) : ""
  );
  pt(e, (c) => {
    var d;
    const u = (d = t.value) == null ? void 0 : d.getRootNode();
    !(u instanceof Document || u instanceof ShadowRoot) || u.activeElement === t.value || (i.value = typeof c == "number" ? _s(c, s.value) : "");
  }), pt(i, (c) => {
    e.value = typeof c == "number" ? _s(c, s.value, o.value, a.value) : n != null && n.optional ? void 0 : 0;
  });
  function r() {
    i.value = typeof e.value == "number" ? _s(e.value, s.value) : "";
  }
  return { inputValue: i, onBlur: r };
}
function _s(e, t, n, o) {
  return t !== void 0 && (e = Number(
    (Math.round(e / t) * t).toFixed(
      Math.ceil(-Math.log10(t))
    )
  )), n !== void 0 && (e = Math.max(e, n)), o !== void 0 && (e = Math.min(e, o)), e;
}
const U6 = ["disabled"], F6 = ["min", "max", "step", "disabled"], q6 = ["disabled"], $a = /* @__PURE__ */ J({
  __name: "NumberInput",
  props: /* @__PURE__ */ Te({
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    max: {},
    min: {},
    step: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, { max: n, min: o, step: a } = we(t), s = Ue(e, "modelValue"), i = N(), { inputValue: r, onBlur: c } = fi(s, i, { max: n, min: o, step: a });
    return (u, d) => {
      const p = De("FontAwesomeIcon");
      return $(), E("div", {
        class: ye(["smake:flex smake:divide-x smake:divide-secondary-2 smake:overflow-hidden smake:rounded-full smake:border smake:duration-150 smake:focus-within:border-black", {
          "smake:border-secondary-2": !e.invalid,
          "smake:border-danger": e.invalid
        }])
      }, [
        z("button", {
          class: "smake:p-3.5 smake:duration-150 smake:enabled:hover:opacity-60 smake:disabled:opacity-50",
          type: "button",
          disabled: l(o) !== void 0 && (l(a) !== void 0 ? s.value - l(o) < l(a) : s.value <= l(o)) || e.disabled,
          onClick: d[0] || (d[0] = (_) => s.value -= l(o) !== void 0 ? Math.min(1, s.value - l(o)) : 1)
        }, [
          x(p, {
            class: "smake:size-4",
            icon: ["fal", "minus"]
          })
        ], 8, U6),
        kt(z("input", {
          ref_key: "input",
          ref: i,
          "onUpdate:modelValue": d[1] || (d[1] = (_) => Ft(r) ? r.value = _ : null),
          class: "smake:appearance-textfield smake:w-full smake:min-w-8 smake:text-center smake:text-sm smake:font-semibold smake:outline-hidden smake:disabled:opacity-50",
          type: "number",
          min: l(o),
          max: l(n),
          step: l(a),
          disabled: e.disabled,
          onBlur: d[2] || (d[2] = //@ts-ignore
          (..._) => l(c) && l(c)(..._))
        }, null, 40, F6), [
          [zn, l(r)]
        ]),
        z("button", {
          class: "smake:p-3.5 smake:duration-150 smake:enabled:hover:opacity-60 smake:disabled:opacity-50",
          type: "button",
          disabled: l(n) !== void 0 && (l(a) !== void 0 ? l(n) - s.value < l(a) : s.value >= l(n)) || e.disabled,
          onClick: d[3] || (d[3] = (_) => s.value += l(n) !== void 0 ? Math.min(1, l(n) - s.value) : 1)
        }, [
          x(p, {
            class: "smake:size-4",
            icon: ["fal", "plus"]
          })
        ], 8, q6)
      ], 2);
    };
  }
});
function B6(e) {
  const t = vt(e), { appConfiguration: n } = L(st());
  return S(() => {
    if (!n.value || !t.value) return;
    const o = n.value.fonts.find(
      ({ id: a }) => {
        var s;
        return a === ((s = t.value) == null ? void 0 : s.fontId);
      }
    );
    if (o)
      return { max: o.max, min: o.min };
  });
}
const Ws = {
  anchor: { offset: { max: 50, min: -50 } },
  text: {
    offsetLeft: { max: 100, min: 0 },
    paddingBottom: { max: 100, min: 2 }
  }
}, gl = rt("favoriteColors", () => {
  const { userExternalIdentifier: e } = L(Va()), t = Eh(
    `smake-designer-favorite-colors-hex-${e.value ?? ""}`,
    []
  ), n = S(
    () => t.value.map((a) => si(a)).filter((a) => a !== void 0)
  );
  function o(a) {
    const s = rp(a);
    t.value.includes(s) && (t.value = t.value.filter(
      (i) => i !== s
    )), t.value.unshift(s), !(t.value.length <= 20) && t.value.pop();
  }
  return {
    add: o,
    colors: Un(n)
  };
}), H6 = /* @__PURE__ */ J({
  __name: "ColorAreaHue",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Ue(e, "modelValue"), n = Xo("hueArea"), { pressed: o } = Md({ target: n }), { elementX: a, elementY: s } = Id(n);
    pt(
      [s, a, o],
      () => {
        o.value && r(s.value);
      },
      { immediate: !0 }
    );
    const i = S(() => n.value ? {
      top: `${((1 - t.value.hue / 360) * n.value.clientHeight).toString()}px`
    } : void 0);
    function r(c) {
      if (!n.value) return;
      const d = (1 - Kr(c / n.value.clientHeight, 0, 1)) * 360;
      t.value = { ...t.value, hue: d };
    }
    return (c, u) => ($(), E("div", {
      ref_key: "hueArea",
      ref: n,
      class: ye(["smake:relative smake:h-full smake:w-5.5 smake:touch-none smake:rounded-full smake:bg-[linear-gradient(0deg,red,yellow,lime,aqua,blue,magenta,red)]", {
        "smake:cursor-grabbing": l(o),
        "smake:cursor-pointer": !l(o)
      }])
    }, [
      z("div", {
        class: "smake:pointer-events-none smake:absolute smake:h-5 smake:w-5 smake:-translate-y-1/2 smake:rounded-full smake:border-2 smake:border-white",
        style: Qt(i.value)
      }, null, 4)
    ], 2));
  }
}), G6 = /* @__PURE__ */ J({
  __name: "ColorAreaSaturartionValue",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Ue(e, "modelValue"), n = Xo("colorArea");
    function o(c, u) {
      if (!n.value) return;
      const d = Kr(c / n.value.clientWidth, 0, 1), p = Kr(u / n.value.clientHeight, 0, 1);
      t.value = {
        ...t.value,
        saturation: d * 100,
        value: (1 - p) * 100
      };
    }
    const { pressed: a } = Md({ target: n }), { elementX: s, elementY: i } = Id(n);
    pt(
      [i, s, a],
      () => {
        a.value && o(s.value, i.value);
      },
      { immediate: !0 }
    );
    const r = S(() => {
      if (!n.value) return;
      const c = t.value.saturation / 100 * n.value.clientWidth, u = (1 - t.value.value / 100) * n.value.clientHeight;
      return {
        left: `${c.toString()}px`,
        top: `${u.toString()}px`
      };
    });
    return (c, u) => ($(), E("div", {
      ref_key: "colorArea",
      ref: n,
      class: ye(["smake:relative smake:h-full smake:w-full smake:touch-none smake:rounded-md smake:bg-[linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))]", {
        "smake:cursor-grabbing": l(a),
        "smake:cursor-pointer": !l(a)
      }]),
      style: Qt({
        backgroundColor: `hsl(${t.value.hue}deg,100%, 50%)`
      })
    }, [
      z("div", {
        class: "smake:pointer-events-none smake:absolute smake:h-5 smake:w-5 smake:-translate-x-1/2 smake:-translate-y-1/2 smake:rounded-full smake:border-2 smake:border-white",
        style: Qt(r.value),
        colorSelectorStyle: ""
      }, null, 4)
    ], 6));
  }
}), W6 = /* @__PURE__ */ J({
  __name: "ColorButton",
  props: {
    color: {}
  },
  setup(e) {
    const t = e, { color: n } = we(t), { colorRGB: o } = ii(n), a = S(
      () => nc([
        o.value.red,
        o.value.green,
        o.value.blue
      ])
    );
    return (s, i) => ($(), E("button", {
      class: ye(["smake:flex smake:aspect-square smake:size-7.5 smake:items-center smake:justify-center smake:rounded-full smake:border", {
        "smake:border-secondary-2": a.value,
        "smake:border-transparent": !a.value
      }]),
      style: Qt({
        backgroundColor: `rgb(${l(o).red}, ${l(o).green}, ${l(o).blue}) !important`
      })
    }, null, 6));
  }
}), Z6 = { class: "smake:flex smake:flex-col smake:gap-2" }, K6 = { class: "smake:text-sm smake:font-semibold" }, Q6 = { class: "smake:grid smake:grid-cols-8 smake:gap-3" }, X6 = /* @__PURE__ */ J({
  __name: "ColorFavorites",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const { add: t } = gl(), { colors: n } = L(gl()), o = Ue(e, "modelValue");
    function a() {
      t({ ...o.value });
    }
    return (s, i) => ($(), E("div", Z6, [
      z("div", K6, j(s.$t("recently_used")), 1),
      z("div", Q6, [
        x(ft, {
          type: "secondary",
          icon: {
            type: ["fal", "plus"]
          },
          onClick: a
        }),
        ($(!0), E(me, null, Ce(l(n), (r) => ($(), H(W6, {
          key: l(yt)(r),
          color: r,
          onClick: (c) => o.value = { ...r }
        }, null, 8, ["color", "onClick"]))), 128))
      ])
    ]));
  }
}), J6 = ["min", "max", "step"], vo = /* @__PURE__ */ J({
  __name: "NumberInput",
  props: /* @__PURE__ */ Te({
    max: {},
    min: {},
    step: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: t }) {
    const n = e, { max: o, min: a, step: s } = Oh(n), i = Ue(e, "modelValue"), r = N(), { focused: c } = Ed(r), { inputValue: u, onBlur: d } = fi(i, r, { max: o, min: a, step: s });
    return t({
      focused: c
    }), (p, _) => kt(($(), E("input", {
      ref_key: "input",
      ref: r,
      "onUpdate:modelValue": _[0] || (_[0] = (y) => Ft(u) ? u.value = y : null),
      class: "smake:appearance-textfield smake:h-full smake:w-12 smake:rounded smake:border smake:border-secondary-2 smake:px-2 smake:focus:border-secondary-1",
      min: l(a),
      max: l(o),
      step: l(s),
      type: "number",
      onBlur: _[1] || (_[1] = //@ts-ignore
      (...y) => l(d) && l(d)(...y))
    }, null, 40, J6)), [
      [zn, l(u)]
    ]);
  }
}), Y6 = { class: "smake:flex smake:w-full smake:gap-2" }, ew = /* @__PURE__ */ J({
  __name: "ColorInputCmyk",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Ue(e, "modelValue"), { colorCMYK: n } = ii(t);
    return (o, a) => ($(), E("div", Y6, [
      x(vo, {
        "model-value": l(n).cyan,
        min: 0,
        max: 100,
        step: 1,
        "onUpdate:modelValue": a[0] || (a[0] = (s) => n.value = { ...l(n), cyan: s })
      }, null, 8, ["model-value"]),
      x(vo, {
        "model-value": l(n).magenta,
        min: 0,
        max: 100,
        step: 1,
        "onUpdate:modelValue": a[1] || (a[1] = (s) => n.value = { ...l(n), magenta: s })
      }, null, 8, ["model-value"]),
      x(vo, {
        "model-value": l(n).yellow,
        min: 0,
        max: 100,
        step: 1,
        "onUpdate:modelValue": a[2] || (a[2] = (s) => n.value = { ...l(n), yellow: s })
      }, null, 8, ["model-value"]),
      x(vo, {
        "model-value": l(n).key,
        min: 0,
        max: 100,
        step: 1,
        "onUpdate:modelValue": a[3] || (a[3] = (s) => n.value = { ...l(n), key: s })
      }, null, 8, ["model-value"])
    ]));
  }
}), tw = /* @__PURE__ */ J({
  __name: "ColorInputHex",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Ue(e, "modelValue"), { colorHex: n } = ii(t), o = N(n.value), a = S({
      get() {
        return i.value ? o.value : n.value.replace("#", "");
      },
      set(u) {
        n.value = "#" + u, o.value = u;
      }
    }), s = Xo("input"), { focused: i } = Ed(s), r = S(() => si("#" + o.value) !== void 0);
    function c(u) {
      var p;
      u.preventDefault();
      const d = (p = u.clipboardData) == null ? void 0 : p.getData("text").replace("#", "");
      d && (a.value = d);
    }
    return se(() => {
      i.value || (o.value = n.value.replace("#", ""));
    }), (u, d) => ($(), E("div", {
      class: ye(["smake:flex smake:items-center smake:gap-2 smake:overflow-clip smake:rounded smake:border smake:px-2", {
        "smake:border-danger": !r.value,
        "smake:border-secondary-2": r.value
      }])
    }, [
      d[1] || (d[1] = z("div", { class: "smake:-ml-2 smake:flex smake:h-full smake:items-center smake:bg-secondary-3 smake:px-2" }, " # ", -1)),
      kt(z("input", {
        ref_key: "input",
        ref: s,
        "onUpdate:modelValue": d[0] || (d[0] = (p) => a.value = p),
        class: "smake:w-full smake:focus:outline-hidden",
        maxlength: "6",
        onPaste: c
      }, null, 544), [
        [zn, a.value]
      ])
    ], 2));
  }
}), nw = { class: "smake:flex smake:w-full smake:gap-2" }, ow = /* @__PURE__ */ J({
  __name: "ColorInputRgb",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Ue(e, "modelValue"), { colorRGB: n } = ii(t);
    return (o, a) => ($(), E("div", nw, [
      x(vo, {
        "model-value": l(n).red,
        min: 0,
        max: 255,
        step: 1,
        "onUpdate:modelValue": a[0] || (a[0] = (s) => n.value = { ...l(n), red: s })
      }, null, 8, ["model-value"]),
      x(vo, {
        "model-value": l(n).green,
        min: 0,
        max: 255,
        step: 1,
        "onUpdate:modelValue": a[1] || (a[1] = (s) => n.value = { ...l(n), green: s })
      }, null, 8, ["model-value"]),
      x(vo, {
        "model-value": l(n).blue,
        min: 0,
        max: 255,
        step: 1,
        "onUpdate:modelValue": a[2] || (a[2] = (s) => n.value = { ...l(n), blue: s })
      }, null, 8, ["model-value"])
    ]));
  }
}), aw = { class: "smake:flex smake:gap-2" }, sw = /* @__PURE__ */ J({
  __name: "ColorInput",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Ue(e, "modelValue"), n = {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      cmyk: ew,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      hex: tw,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      rgb: ow
    }, o = Object.keys(
      n
    ), a = N(o[2]), { rootElement: s } = L(Vt());
    return (i, r) => {
      const c = De("Icon");
      return $(), E("div", aw, [
        x(l(qd), {
          modelValue: a.value,
          "onUpdate:modelValue": r[0] || (r[0] = (u) => a.value = u)
        }, {
          default: M(() => [
            x(l(Bd), {
              class: "smake:inline-flex smake:h-8.75 smake:w-25 smake:items-center smake:justify-between smake:gap-1.25 smake:rounded smake:border smake:border-secondary-2 smake:px-1.25 smake:outline-hidden",
              "aria-label": "Customise options"
            }, {
              default: M(() => [
                x(l(Hd), { placeholder: "Select a mode" })
              ]),
              _: 1
            }),
            x(l(Gd), { to: l(s) }, {
              default: M(() => [
                x(l(Wd), { class: "smake:data-[side=top]:animate-slideDownAndFade smake:data-[side=right]:animate-slideLeftAndFade smake:data-[side=bottom]:animate-slideUpAndFade smake:data-[side=left]:animate-slideRightAndFade smake:z-100 smake:rounded smake:border smake:border-secondary-2 smake:bg-white smake:will-change-[opacity,transform]" }, {
                  default: M(() => [
                    x(l(Zd), null, {
                      default: M(() => [
                        ($(!0), E(me, null, Ce(l(o), (u, d) => ($(), H(l(Ud), {
                          key: d,
                          class: "smake:relative smake:flex smake:h-6.25 smake:items-center smake:rounded-[3px] smake:px-4 smake:py-4 smake:select-none smake:data-highlighted:bg-secondary-3 smake:data-highlighted:outline-hidden",
                          value: u
                        }, {
                          default: M(() => [
                            x(l(Fd), null, {
                              default: M(() => [
                                Pe(j(u.toUpperCase()), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["value"]))), 128))
                      ]),
                      _: 1
                    }),
                    x(l(M_), { class: "smake:flex smake:h-6.25 smake:cursor-default smake:items-center smake:justify-center smake:bg-white" }, {
                      default: M(() => [
                        x(c, { icon: "radix-icons:chevron-down" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        a.value ? ($(), H($l(n[a.value]), {
          key: 0,
          modelValue: t.value,
          "onUpdate:modelValue": r[1] || (r[1] = (u) => t.value = u),
          class: "smake:w-full"
        }, null, 8, ["modelValue"])) : Q("", !0)
      ]);
    };
  }
}), iw = /* @__PURE__ */ J({
  __name: "EyeDropper",
  emits: ["selected"],
  setup(e, { emit: t }) {
    const { isSupported: n, open: o, sRGBHex: a } = Rh(), s = t;
    se(() => {
      a.value.length !== 0 && s("selected", a.value);
    });
    const { isPending: i, mutate: r } = ct({
      mutationFn: o
    });
    return (c, u) => l(n) ? ($(), H(ft, {
      key: 0,
      type: "secondary",
      disabled: l(i),
      icon: {
        type: ["fak", "colorpicker"]
      },
      onClick: l(r)
    }, null, 8, ["disabled", "onClick"])) : Q("", !0);
  }
}), rw = { class: "smake:flex smake:w-79.5 smake:flex-col smake:justify-center smake:gap-4 smake:@sm:w-87.5" }, lw = { class: "smake:flex smake:h-64 smake:gap-4 smake:px-2" }, cw = { class: "smake:flex smake:items-center smake:gap-3" }, uw = /* @__PURE__ */ J({
  __name: "ColorPicker",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Ue(e, "modelValue"), { colorHSV: n } = O0(t);
    function o(a) {
      const s = si(a);
      s && (n.value = s);
    }
    return (a, s) => ($(), E("div", rw, [
      z("div", lw, [
        x(H6, {
          modelValue: l(n),
          "onUpdate:modelValue": s[0] || (s[0] = (i) => Ft(n) ? n.value = i : null)
        }, null, 8, ["modelValue"]),
        x(G6, {
          modelValue: l(n),
          "onUpdate:modelValue": s[1] || (s[1] = (i) => Ft(n) ? n.value = i : null)
        }, null, 8, ["modelValue"])
      ]),
      z("div", cw, [
        x(iw, { onSelected: o }),
        x(sw, {
          modelValue: l(n),
          "onUpdate:modelValue": s[2] || (s[2] = (i) => Ft(n) ? n.value = i : null)
        }, null, 8, ["modelValue"])
      ]),
      x(X6, {
        modelValue: l(n),
        "onUpdate:modelValue": s[3] || (s[3] = (i) => Ft(n) ? n.value = i : null)
      }, null, 8, ["modelValue"])
    ]));
  }
}), dw = { class: "smake:flex smake:grow smake:flex-col smake:gap-2.5 smake:bg-white" }, mw = { class: "smake:flex smake:grow smake:justify-between smake:gap-6" }, pw = { class: "smake:flex smake:items-center smake:gap-2" }, fw = /* @__PURE__ */ J({
  __name: "ColorPickerButton",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Ue(e, "modelValue"), { rootElement: n } = L(Vt()), { appConfiguration: o } = L(st()), { add: a } = gl(), s = N({ blue: 0, green: 0, red: 255 });
    se(() => {
      var c;
      if ("id" in t.value) {
        const u = (c = o.value) == null ? void 0 : c.colors.find(
          ({ id: d }) => "id" in t.value && t.value.id === d
        );
        if (!u) return;
        s.value = {
          blue: u.blue,
          green: u.green,
          red: u.red
        };
      } else
        s.value = { ...t.value };
    });
    const i = N(!1);
    function r() {
      a(Da(s.value)), i.value = !1, t.value = s.value;
    }
    return (c, u) => ($(), H(l(Qd), {
      open: i.value,
      "onUpdate:open": u[2] || (u[2] = (d) => i.value = d)
    }, {
      default: M(() => [
        x(l(Xd), { class: "smake:flex smake:flex-col smake:items-center smake:gap-2 smake:text-xs" }, {
          default: M(() => [
            z("div", {
              class: ye([
                "smake:rounded-full smake:border smake:p-1",
                "id" in t.value ? "smake:border-transparent" : "smake:border-black"
              ])
            }, [...u[3] || (u[3] = [
              z("div", { class: "smake:relative smake:size-12 smake:rounded-full smake:bg-[conic-gradient(red,yellow,lime,aqua,blue,magenta,red)]" }, [
                z("div", { class: "smake:absolute smake:inset-1/2 smake:size-6 smake:-translate-1/2 smake:rounded-full smake:bg-white" })
              ], -1)
            ])], 2),
            Pe(" " + j(c.$t("custom")), 1)
          ]),
          _: 1
        }),
        x(l(Jd), { to: l(n) }, {
          default: M(() => [
            x(l(Yd), {
              class: "smake:z-50 smake:rounded-2xl smake:border smake:border-secondary-1 smake:bg-white smake:p-5",
              side: "bottom",
              align: "start",
              onInteractOutside: u[1] || (u[1] = (d) => d.preventDefault())
            }, {
              default: M(() => [
                z("div", dw, [
                  z("div", mw, [
                    z("div", {
                      class: "smake:size-10 smake:rounded-full smake:border smake:border-secondary-2",
                      style: Qt({
                        backgroundColor: `rgb(${s.value.red},${s.value.green},${s.value.blue})`
                      })
                    }, null, 4),
                    z("div", pw, [
                      u[4] || (u[4] = z("div", { class: "grow" }, null, -1)),
                      x(Se, {
                        type: "primary",
                        text: c.$t("select_color"),
                        size: "small",
                        icon: {
                          type: ["fak", "check"],
                          position: "after"
                        },
                        onClick: r
                      }, null, 8, ["text"]),
                      x(l(em), { "as-child": "" }, {
                        default: M(() => [
                          x(ft, {
                            type: "secondary",
                            icon: {
                              type: ["fak", "icon-x"]
                            }
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  x(uw, {
                    modelValue: s.value,
                    "onUpdate:modelValue": u[0] || (u[0] = (d) => s.value = d)
                  }, null, 8, ["modelValue"]),
                  x(l(I_), {
                    class: "smake:size-5 smake:-translate-y-2.5 smake:rotate-45 smake:border-r smake:border-b smake:border-secondary-1 smake:bg-white",
                    as: "div"
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["open"]));
  }
}), hw = { class: "smake:absolute smake:inset-0 smake:z-10 smake:flex smake:flex-col smake:gap-4 smake:overflow-y-auto smake:bg-white smake:p-4" }, _w = { class: "smake:grid smake:grid-cols-auto-fill-15.5 smake:gap-4" }, vw = ["onClick"], gw = {
  key: 1,
  class: "smake:border-secondary-2"
}, yw = { class: "smake:grid smake:grid-cols-auto-fill-15.5 smake:gap-4" }, kw = ["onClick"], bw = /* @__PURE__ */ J({
  __name: "ColorSelection",
  props: /* @__PURE__ */ Te({
    productionMethodId: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, { productionMethodId: n } = we(t), o = Ue(e, "modelValue"), { appConfiguration: a } = L(st()), s = S(
      () => {
        var u, d;
        return (d = (u = a.value) == null ? void 0 : u.productionMethods.find(
          ({ id: p }) => p === n.value
        )) == null ? void 0 : d.is_using_color_picker;
      }
    ), i = S(
      () => {
        var u;
        return ((u = a.value) == null ? void 0 : u.colors.filter(
          (d) => d.production_methods.some(
            ({ id: p }) => p === n.value
          )
        )) ?? [];
      }
    ), r = S(
      () => i.value.filter((u) => u.is_customer_logo_color)
    ), c = S(
      () => i.value.filter((u) => u.is_standard)
    );
    return (u, d) => ($(), E("div", hw, [
      r.value.length > 0 ? ($(), E(me, { key: 0 }, [
        Pe(j(u.$t("colors")) + ": ", 1),
        z("div", _w, [
          ($(!0), E(me, null, Ce(r.value, (p) => ($(), E("button", {
            key: p.id,
            type: "button",
            class: "smake:flex smake:flex-col smake:items-center smake:gap-2 smake:text-xs",
            onClick: (_) => o.value = { id: p.id }
          }, [
            z("div", {
              class: ye([
                "smake:rounded-full smake:border smake:p-1",
                "id" in o.value && o.value.id === p.id ? "smake:border-black" : "smake:border-transparent"
              ])
            }, [
              z("div", {
                class: "smake:size-12 smake:rounded-full smake:border smake:border-secondary-2",
                style: Qt({
                  backgroundColor: `rgb(${p.red}, ${p.green}, ${p.blue})`
                })
              }, null, 4)
            ], 2),
            Pe(" " + j(p.display_name), 1)
          ], 8, vw))), 128))
        ])
      ], 64)) : Q("", !0),
      r.value.length > 0 && c.value.length > 0 ? ($(), E("hr", gw)) : Q("", !0),
      c.value.length > 0 ? ($(), E(me, { key: 2 }, [
        Pe(j(u.$t("standard_colors")) + ": ", 1),
        z("div", yw, [
          s.value ? ($(), H(fw, {
            key: 0,
            modelValue: o.value,
            "onUpdate:modelValue": d[0] || (d[0] = (p) => o.value = p)
          }, null, 8, ["modelValue"])) : Q("", !0),
          ($(!0), E(me, null, Ce(c.value, (p) => ($(), E("button", {
            key: p.id,
            type: "button",
            class: "smake:flex smake:flex-col smake:items-center smake:gap-2 smake:text-xs",
            onClick: (_) => o.value = { id: p.id }
          }, [
            z("div", {
              class: ye([
                "smake:rounded-full smake:border smake:p-1",
                "id" in o.value && o.value.id === p.id ? "smake:border-black" : "smake:border-transparent"
              ])
            }, [
              z("div", {
                class: "smake:size-12 smake:rounded-full smake:border smake:border-secondary-2",
                style: Qt({
                  backgroundColor: `rgb(${p.red}, ${p.green}, ${p.blue})`
                })
              }, null, 4)
            ], 2),
            Pe(" " + j(p.display_name), 1)
          ], 8, kw))), 128))
        ])
      ], 64)) : Q("", !0)
    ]));
  }
}), ww = ["title"], yl = /* @__PURE__ */ J({
  __name: "ColorInput",
  props: /* @__PURE__ */ Te({
    disabled: { type: Boolean },
    issue: {},
    productionMethodId: {},
    showName: { type: Boolean }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = Ue(e, "modelValue"), { appConfiguration: n } = L(st()), { t: o } = dt(), a = N(!1), s = S(() => {
      var u;
      if (!("id" in t.value)) return;
      const { id: c } = t.value;
      return (u = n.value) == null ? void 0 : u.colors.find(({ id: d }) => d === c);
    }), i = S(() => {
      var c;
      return ((c = s.value) == null ? void 0 : c.display_name) ?? o("custom");
    }), r = S(() => "id" in t.value ? s.value : t.value);
    return (c, u) => {
      const d = De("FontAwesomeIcon");
      return $(), E(me, null, [
        x(dn, {
          type: "subordinate",
          disabled: e.disabled,
          class: ye(["smake:p-2 smake:disabled:opacity-100", { "smake:border-danger": e.issue }]),
          "no-padding": "",
          onClick: u[0] || (u[0] = (p) => a.value = !0)
        }, {
          default: M(() => [
            z("div", {
              class: "smake:size-7 smake:shrink-0 smake:rounded-full smake:border smake:border-secondary-2 smake:duration-150",
              style: Qt({
                backgroundColor: r.value ? `rgb(${r.value.red}, ${r.value.green}, ${r.value.blue})` : void 0
              })
            }, null, 4),
            e.showName ? ($(), E("div", {
              key: 0,
              class: "smake:grow smake:overflow-hidden smake:text-start smake:text-ellipsis smake:whitespace-nowrap",
              title: i.value
            }, j(i.value), 9, ww)) : Q("", !0),
            e.disabled ? Q("", !0) : ($(), H(d, {
              key: 1,
              class: "smake:mx-1 smake:size-5 smake:shrink-0",
              icon: ["fal", "chevron-right"]
            }))
          ]),
          _: 1
        }, 8, ["disabled", "class"]),
        x(Qe, {
          appear: "",
          "enter-active-class": "smake:duration-300 smake:ease-out",
          "enter-from-class": "smake:opacity-0",
          "leave-active-class": "smake:duration-200 smake:ease-in",
          "leave-to-class": "smake:opacity-0"
        }, {
          default: M(() => [
            a.value ? ($(), H(bw, {
              key: 0,
              modelValue: t.value,
              "onUpdate:modelValue": [
                u[1] || (u[1] = (p) => t.value = p),
                u[2] || (u[2] = (p) => a.value = !1)
              ],
              "production-method-id": e.productionMethodId
            }, null, 8, ["modelValue", "production-method-id"])) : Q("", !0)
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), xw = { class: "smake:flex smake:flex-1 smake:flex-col smake:items-start smake:gap-1" }, $w = { class: "smake:flex smake:w-full smake:justify-between" }, zw = { class: "smake:text-xs smake:font-semibold smake:uppercase" }, Sw = { class: "smak:items-center smake:flex smake:gap-1 smake:overflow-hidden smake:rounded-full smake:border smake:border-secondary-2 smake:px-2 smake:text-xs smake:font-bold smake:duration-150 smake:focus-within:border-black" }, Cw = /* @__PURE__ */ J({
  __name: "BendingRadiusInput",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Ue(e, "modelValue"), n = N(), { inputValue: o, onBlur: a } = fi(t, n, {
      max: 100,
      min: -100,
      step: 5
    });
    return (s, i) => ($(), E("div", xw, [
      z("div", $w, [
        z("span", zw, j(s.$t("bend_text_line")), 1),
        z("div", Sw, [
          kt(z("input", {
            ref_key: "numberInput",
            ref: n,
            "onUpdate:modelValue": i[0] || (i[0] = (r) => Ft(o) ? o.value = r : null),
            class: "smake:appearance-textfield smake:w-7 smake:text-right smake:outline-hidden",
            type: "number",
            max: "100",
            min: "-100",
            step: "5",
            onBlur: i[1] || (i[1] = //@ts-ignore
            (...r) => l(a) && l(a)(...r))
          }, null, 544), [
            [zn, l(o)]
          ]),
          i[3] || (i[3] = z("div", null, "%", -1))
        ])
      ]),
      kt(z("input", {
        "onUpdate:modelValue": i[2] || (i[2] = (r) => t.value = r),
        class: "smake:my-1.5 smake:h-1 smake:w-full smake:appearance-none smake:rounded-full smake:bg-secondary-3 smake:[&::-webkit-slider-thumb]:h-4 smake:[&::-webkit-slider-thumb]:w-4 smake:[&::-webkit-slider-thumb]:cursor-ew-resize smake:[&::-webkit-slider-thumb]:appearance-none smake:[&::-webkit-slider-thumb]:rounded-full smake:[&::-webkit-slider-thumb]:border-2 smake:[&::-webkit-slider-thumb]:border-solid smake:[&::-webkit-slider-thumb]:border-black smake:[&::-webkit-slider-thumb]:bg-white smake:[&::-webkit-slider-thumb]:duration-150 smake:hover:[&::-webkit-slider-thumb]:bg-secondary-3",
        type: "range",
        max: "100",
        min: "-100",
        step: "5"
      }, null, 512), [
        [
          zn,
          t.value,
          void 0,
          { number: !0 }
        ]
      ])
    ]));
  }
}), Aw = { class: "smake:absolute smake:inset-0 smake:z-10 smake:flex smake:flex-col smake:gap-4 smake:overflow-y-auto smake:bg-white smake:p-4" }, Pw = {
  key: 1,
  class: "smake:text-xl smake:font-semibold"
}, Tw = {
  key: 2,
  class: "smake:mb-1 smake:text-sm smake:font-semibold"
}, Mw = {
  key: 0,
  class: "smake:text-xs smake:text-secondary-1"
}, Iw = /* @__PURE__ */ J({
  __name: "FontSelection",
  props: /* @__PURE__ */ Te({
    productionMethodId: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Te(["close"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, { productionMethodId: o } = we(n), a = t, s = Ue(e, "modelValue"), { appConfiguration: i } = L(st()), r = S(() => {
      var d;
      return (d = i.value) == null ? void 0 : d.fonts;
    }), c = S(
      () => {
        var d;
        return Object.values(
          Object.groupBy(
            ((d = r.value) == null ? void 0 : d.filter(
              (p) => p.production_methods.some(
                ({ id: _ }) => _ === o.value
              )
            )) ?? [],
            ({ family_name: p }) => p
          )
        ).map((p) => p == null ? void 0 : p[0]).filter((p) => p !== void 0).sort((p, _) => p.family_name < _.family_name ? -1 : p.family_name > _.family_name ? 1 : 0);
      }
    ), u = S(() => c.value.some(
      (d) => d.letter_case_set === "only-uppercase"
    ));
    return (d, p) => ($(), E("div", Aw, [
      ($(!0), E(me, null, Ce(c.value, (_) => ($(), E("div", {
        key: _.id,
        class: "smake:relative"
      }, [
        x(dn, {
          type: _.id === s.value ? "secondary" : "subordinate",
          class: "smake:w-full",
          onClick: () => {
            s.value = _.id, a("close");
          }
        }, {
          default: M(() => [
            _.preview_url ? ($(), H(Yt, {
              key: 0,
              src: _.preview_url,
              class: "smake:h-6 smake:data-[state=pending]:w-28 smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:rounded-md smake:data-[state=pending]:bg-secondary-2"
            }, null, 8, ["src"])) : ($(), E("span", Pw, j(_.display_name), 1)),
            _.letter_case_set === "only-uppercase" ? ($(), E("span", Tw, " * ")) : Q("", !0)
          ]),
          _: 2
        }, 1032, ["type", "onClick"])
      ]))), 128)),
      p[0] || (p[0] = z("div", { class: "smake:-mt-4 smake:grow" }, null, -1)),
      u.value ? ($(), E("div", Mw, " * " + j(d.$t("only_uppercase")), 1)) : Q("", !0)
    ]));
  }
}), Ew = { class: "smake:flex smake:grow smake:flex-col smake:items-start smake:gap-1" }, Ow = { class: "smake:grow smake:rounded-full smake:bg-secondary-3 smake:p-2 smake:text-xs smake:font-medium" }, Rw = /* @__PURE__ */ J({
  __name: "FontInput",
  props: /* @__PURE__ */ Te({
    issue: {},
    productionMethodId: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = Ue(e, "modelValue"), { appConfiguration: n } = L(st()), o = N(!1), a = S(
      () => {
        var s;
        return (s = n.value) == null ? void 0 : s.fonts.find(({ id: i }) => i === t.value);
      }
    );
    return (s, i) => {
      const r = De("FontAwesomeIcon");
      return $(), E(me, null, [
        z("div", Ew, [
          z("span", {
            class: ye(["smake:flex smake:items-center smake:gap-1 smake:text-xs smake:font-bold smake:uppercase", { "smake:text-danger": e.issue }])
          }, [
            e.issue ? ($(), H(r, {
              key: 0,
              icon: ["fak", "icon-ciconfig-alert-warning"],
              "fixed-width": "",
              class: "smake:size-4"
            })) : Q("", !0),
            Pe(" " + j(s.$t("font")), 1)
          ], 2),
          x(dn, {
            type: "subordinate",
            class: ye(["smake:w-full smake:px-2 smake:py-1", { "smake:border-danger": e.issue }]),
            "no-padding": "",
            onClick: i[0] || (i[0] = (c) => o.value = !0)
          }, {
            default: M(() => {
              var c;
              return [
                z("div", Ow, j(((c = a.value) == null ? void 0 : c.family_name) ?? s.$t("select_font")), 1),
                x(r, {
                  class: "smake:mx-1 smake:size-5",
                  icon: ["fal", "chevron-right"]
                })
              ];
            }),
            _: 1
          }, 8, ["class"])
        ]),
        x(Qe, {
          appear: "",
          "enter-active-class": "smake:duration-300 smake:ease-out",
          "enter-from-class": "smake:opacity-0",
          "leave-active-class": "smake:duration-200 smake:ease-in",
          "leave-to-class": "smake:opacity-0"
        }, {
          default: M(() => [
            o.value ? ($(), H(Iw, {
              key: 0,
              modelValue: t.value,
              "onUpdate:modelValue": [
                i[1] || (i[1] = (c) => t.value = c),
                i[2] || (i[2] = (c) => o.value = !1)
              ],
              "production-method-id": e.productionMethodId,
              onClose: i[3] || (i[3] = (c) => o.value = !1)
            }, null, 8, ["modelValue", "production-method-id"])) : Q("", !0)
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), Lw = { class: "smake:flex smake:gap-4" }, jw = { class: "smake:flex smake:flex-col smake:items-start smake:gap-1" }, Dw = { class: "smake:flex smake:gap-4" }, Nw = { class: "smake:flex smake:flex-1 smake:flex-col smake:items-start smake:gap-1" }, Vw = { class: "smake:flex smake:flex-1 smake:flex-col smake:items-start smake:gap-1" }, Uw = { class: "smake:text-xs smake:font-bold smake:uppercase" }, Fw = { class: "smake:flex smake:gap-4" }, qw = { class: "smake:flex smake:flex-1 smake:flex-col smake:items-start smake:gap-1" }, Bw = { class: "smake:text-xs smake:font-bold smake:uppercase" }, Hw = { class: "smake:flex smake:gap-2" }, Gw = { class: "smake:relative" }, Ww = ["value"], Zw = { class: "smake:group smake:cursor-pointer smake:rounded smake:bg-secondary-3 smake:p-3 smake:duration-150 smake:peer-checked:bg-black smake:peer-focus-visible:outline-2 smake:peer-focus-visible:outline-blue-700 smake:hover:bg-secondary-2 smake:hover:peer-checked:bg-black/80" }, Kw = { class: "smake:relative" }, Qw = ["value"], Xw = { class: "smake:group smake:cursor-pointer smake:rounded smake:bg-secondary-3 smake:p-3 smake:duration-150 smake:peer-checked:bg-black smake:peer-focus-visible:outline-2 smake:peer-focus-visible:outline-blue-700 smake:hover:bg-secondary-2 smake:hover:peer-checked:bg-black/80" }, Jw = { class: "smake:relative" }, Yw = ["value"], e4 = { class: "smake:group smake:cursor-pointer smake:rounded smake:bg-secondary-3 smake:p-3 smake:duration-150 smake:peer-checked:bg-black smake:peer-focus-visible:outline-2 smake:peer-focus-visible:outline-blue-700 smake:hover:bg-secondary-2 smake:hover:peer-checked:bg-black/80" }, t4 = { class: "smake:flex smake:flex-1 smake:flex-col smake:items-start smake:gap-1" }, n4 = { class: "smake:text-xs smake:font-bold smake:uppercase" }, o4 = /* @__PURE__ */ J({
  __name: "TextLine",
  props: {
    data: {},
    issues: {},
    productionMethodId: {}
  },
  setup(e) {
    const t = e, { data: n, productionMethodId: o } = we(t), { offsetLeft: a, paddingBottom: s } = Ws.text, { appConfiguration: i } = L(st()), r = S(
      () => {
        var u;
        return (u = i.value) == null ? void 0 : u.fonts.find(({ id: d }) => d === n.value.fontId);
      }
    );
    pt(r, (u, d) => {
      !u || d || (n.value.size = Ma(n.value.size, u.min, u.max));
    });
    const c = B6(n);
    return (u, d) => {
      var _, y, k, w, f, g, b, A, P;
      const p = De("FontAwesomeIcon");
      return $(), E(me, null, [
        z("div", Lw, [
          x(Rw, {
            modelValue: l(n).fontId,
            "onUpdate:modelValue": d[0] || (d[0] = (I) => l(n).fontId = I),
            issue: (_ = e.issues) == null ? void 0 : _.font,
            "production-method-id": l(o)
          }, null, 8, ["modelValue", "issue", "production-method-id"]),
          z("div", jw, [
            z("span", {
              class: ye(["smake:flex smake:items-center smake:gap-1 smake:text-xs smake:font-bold smake:uppercase", { "smake:text-danger": (y = e.issues) == null ? void 0 : y.color }])
            }, [
              (k = e.issues) != null && k.color ? ($(), H(p, {
                key: 0,
                icon: ["fak", "icon-ciconfig-alert-warning"],
                "fixed-width": "",
                class: "smake:size-4"
              })) : Q("", !0),
              Pe(" " + j(u.$t("color")), 1)
            ], 2),
            x(yl, {
              modelValue: l(n).color,
              "onUpdate:modelValue": d[1] || (d[1] = (I) => l(n).color = I),
              issue: (w = e.issues) == null ? void 0 : w.color,
              "production-method-id": l(o)
            }, null, 8, ["modelValue", "issue", "production-method-id"])
          ])
        ]),
        z("div", Dw, [
          z("div", Nw, [
            z("span", {
              class: ye(["smake:flex smake:items-center smake:gap-1 smake:text-xs smake:font-semibold smake:uppercase", { "smake:text-danger": l(c) && ((f = e.issues) == null ? void 0 : f.size) }])
            }, [
              l(c) && ((g = e.issues) != null && g.size) ? ($(), H(p, {
                key: 0,
                icon: ["fak", "icon-ciconfig-alert-warning"],
                "fixed-width": "",
                class: "smake:size-4"
              })) : Q("", !0),
              Pe(" " + j(u.$t("size")), 1)
            ], 2),
            x($a, {
              modelValue: l(n).size,
              "onUpdate:modelValue": d[2] || (d[2] = (I) => l(n).size = I),
              class: "smake:w-full",
              invalid: l(c) && !!((b = e.issues) != null && b.size),
              disabled: !l(c),
              min: (A = l(c)) == null ? void 0 : A.min,
              max: (P = l(c)) == null ? void 0 : P.max,
              step: 1
            }, null, 8, ["modelValue", "invalid", "disabled", "min", "max"])
          ]),
          z("div", Vw, [
            z("span", Uw, j(u.$t("line_height")), 1),
            x($a, {
              modelValue: l(n).paddingBottom,
              "onUpdate:modelValue": d[3] || (d[3] = (I) => l(n).paddingBottom = I),
              class: "smake:w-full",
              min: l(s).min,
              max: l(s).max,
              step: 1
            }, null, 8, ["modelValue", "min", "max"])
          ])
        ]),
        z("div", Fw, [
          z("div", qw, [
            z("span", Bw, j(u.$t("align")), 1),
            z("div", Hw, [
              z("label", Gw, [
                kt(z("input", {
                  "onUpdate:modelValue": d[4] || (d[4] = (I) => l(n).horizontalAlignment = I),
                  class: "smake:peer smake:absolute smake:appearance-none",
                  type: "radio",
                  name: "horizontalAlignment",
                  value: l(wo).LEFT
                }, null, 8, Ww), [
                  [gs, l(n).horizontalAlignment]
                ]),
                z("div", Zw, [
                  x(p, {
                    class: "smake:h-5.5 smake:duration-150 smake:group-peer-checked:text-white",
                    icon: ["fal", "align-left"]
                  })
                ])
              ]),
              z("label", Kw, [
                kt(z("input", {
                  "onUpdate:modelValue": d[5] || (d[5] = (I) => l(n).horizontalAlignment = I),
                  class: "smake:peer smake:absolute smake:appearance-none",
                  type: "radio",
                  name: "horizontalAlignment",
                  value: l(wo).CENTER
                }, null, 8, Qw), [
                  [gs, l(n).horizontalAlignment]
                ]),
                z("div", Xw, [
                  x(p, {
                    class: "smake:h-5.5 smake:duration-150 smake:group-peer-checked:text-white",
                    icon: ["fal", "align-center"]
                  })
                ])
              ]),
              z("label", Jw, [
                kt(z("input", {
                  "onUpdate:modelValue": d[6] || (d[6] = (I) => l(n).horizontalAlignment = I),
                  class: "smake:peer smake:absolute smake:appearance-none",
                  type: "radio",
                  name: "horizontalAlignment",
                  value: l(wo).RIGHT
                }, null, 8, Yw), [
                  [gs, l(n).horizontalAlignment]
                ]),
                z("div", e4, [
                  x(p, {
                    class: "smake:h-5.5 smake:duration-150 smake:group-peer-checked:text-white",
                    icon: ["fal", "align-right"]
                  })
                ])
              ])
            ])
          ]),
          z("div", t4, [
            z("span", n4, j(u.$t("offset_left")), 1),
            x($a, {
              modelValue: l(n).offsetLeft,
              "onUpdate:modelValue": d[7] || (d[7] = (I) => l(n).offsetLeft = I),
              class: "smake:w-full",
              min: l(a).min,
              max: l(a).max,
              step: 1
            }, null, 8, ["modelValue", "min", "max"])
          ])
        ]),
        x(Cw, {
          modelValue: l(n).bendingRadius,
          "onUpdate:modelValue": d[8] || (d[8] = (I) => l(n).bendingRadius = I)
        }, null, 8, ["modelValue"])
      ], 64);
    };
  }
}), a4 = { class: "smake:flex smake:justify-between" }, s4 = { class: "smake:text-sm smake:font-bold smake:uppercase" }, i4 = ["onUpdate:modelValue", "onFocus", "onKeydown"], r4 = ["disabled"], rc = /* @__PURE__ */ J({
  __name: "TextComponent",
  props: {
    canDeleteAllLines: { type: Boolean },
    data: {},
    deletable: { type: Boolean },
    initialSelectedLine: {},
    isLight: { type: Boolean },
    productionMethodId: {}
  },
  emits: ["delete"],
  setup(e, { emit: t }) {
    const n = e, { data: o, initialSelectedLine: a, isLight: s, productionMethodId: i } = we(n), r = t, c = Gp(i, s), { unsupportedTextLines: u } = To(
      S(() => o.value.lines),
      i
    ), d = N({}), p = N(a.value);
    se(() => {
      p.value && o.value.lines.includes(p.value) || (o.value.lines[0] ? p.value = o.value.lines[0] : r("delete"));
    });
    async function _(g) {
      var P;
      if (o.value.lines.length > 8) return;
      const b = o.value.lines[g], A = b ? { ...to(b), text: "" } : c();
      o.value.lines.splice(g + 1, 0, A), await wl(), (P = d.value[yt(o.value.lines[g + 1])]) == null || P.focus();
    }
    function y() {
      const g = p.value;
      if (g)
        for (const b of o.value.lines)
          b !== g && (b.bendingRadius = g.bendingRadius, b.color = { ...g.color }, b.fontId = g.fontId, b.horizontalAlignment = g.horizontalAlignment, b.paddingBottom = g.paddingBottom, b.size = g.size);
    }
    function k() {
      var b;
      if (!p.value) return;
      const g = o.value.lines[(o.value.lines.indexOf(p.value) + 1) % o.value.lines.length];
      g && ((b = d.value[yt(g)]) == null || b.focus());
    }
    function w() {
      var b;
      if (!p.value) return;
      const g = o.value.lines[(o.value.lines.indexOf(p.value) - 1 + o.value.lines.length) % o.value.lines.length];
      g && ((b = d.value[yt(g)]) == null || b.focus());
    }
    function f(g) {
      if (g === p.value) {
        const b = o.value.lines.indexOf(g), A = o.value.lines[b - 1] ?? o.value.lines[b + 1];
        p.value = A;
      }
      o.value.lines = o.value.lines.filter((b) => b !== g);
    }
    return (g, b) => {
      const A = De("FontAwesomeIcon");
      return $(), H(ic, { "data-testid": "TextComponent" }, {
        default: M(() => {
          var P, I;
          return [
            z("div", a4, [
              z("h3", s4, j(g.$t("texts")), 1),
              e.deletable ? ($(), H(ft, {
                key: 0,
                type: "secondary",
                icon: { type: ["fak", "icon-remove"] },
                onClick: b[0] || (b[0] = (D) => r("delete"))
              })) : Q("", !0)
            ]),
            x(Sh, {
              tag: "div",
              class: "smake:relative smake:flex smake:flex-col smake:gap-2",
              "enter-active-class": "smake:duration-300",
              "enter-from-class": "smake:translate-x-8 smake:opacity-0",
              "leave-active-class": "smake:duration-200",
              "leave-to-class": "smake:translate-x-8 smake:opacity-0",
              "move-class": "smake:duration-300"
            }, {
              default: M(() => [
                ($(!0), E(me, null, Ce(l(o).lines, (D, R) => {
                  var U;
                  return $(), E("div", {
                    key: l(yt)(D),
                    class: ye([
                      "smake:m-px smake:flex smake:items-center smake:overflow-hidden smake:rounded-md smake:border smake:duration-150 smake:focus-within:outline",
                      p.value === D ? "smake:border-black" : "smake:border-secondary-2"
                    ])
                  }, [
                    (U = l(u)) != null && U.some(
                      ({ textLine: G }) => G === D
                    ) ? ($(), H(A, {
                      key: 0,
                      icon: ["fak", "icon-ciconfig-alert-warning"],
                      class: "smake:ml-2 smake:size-4 smake:text-danger",
                      "fixed-width": ""
                    })) : Q("", !0),
                    kt(z("input", {
                      ref_for: !0,
                      ref: (G) => {
                        G === null ? delete d.value[l(yt)(D)] : d.value[l(yt)(D)] = G;
                      },
                      "onUpdate:modelValue": (G) => D.text = G,
                      "data-testId": "TextInput",
                      class: "smake:h-11 smake:min-w-0 smake:grow smake:p-2 smake:outline-hidden",
                      type: "text",
                      onFocus: (G) => p.value = D,
                      onKeydown: [
                        vs(yo(k, ["exact", "prevent"]), ["tab"]),
                        vs(yo(w, ["shift", "exact", "prevent"]), ["tab"]),
                        vs(yo((G) => _(R), ["prevent"]), ["enter"])
                      ]
                    }, null, 40, i4), [
                      [zn, D.text]
                    ]),
                    e.canDeleteAllLines || l(o).lines.length > 1 ? ($(), H(ft, {
                      key: 1,
                      type: "secondary",
                      class: "smake:mr-2",
                      icon: {
                        type: ["fak", "icon-x"]
                      },
                      onClick: (G) => f(D)
                    }, null, 8, ["onClick"])) : Q("", !0)
                  ], 2);
                }), 128))
              ]),
              _: 1
            }),
            z("button", {
              class: "smake:flex smake:items-center smake:justify-center smake:gap-2 smake:text-xs smake:duration-150 smake:enabled:hover:opacity-60 smake:disabled:opacity-50",
              disabled: l(o).lines.length > 8,
              onClick: b[1] || (b[1] = (D) => _(l(o).lines.length - 1))
            }, [
              x(A, {
                class: "smake:size-8 smake:rounded-full smake:bg-black smake:p-1.5 smake:text-white",
                icon: ["fal", "plus"]
              }),
              Pe(" " + j(g.$t("add_text_line")), 1)
            ], 8, r4),
            p.value ? ($(), H(o4, {
              key: l(yt)(p.value),
              data: p.value,
              issues: (I = (P = l(u)) == null ? void 0 : P.find(
                ({ textLine: D }) => D === p.value
              )) == null ? void 0 : I.invalidProperties,
              "production-method-id": l(i)
            }, null, 8, ["data", "issues", "production-method-id"])) : Q("", !0),
            x(Se, {
              type: "secondary",
              size: "small",
              text: g.$t("apply_to_all_lines"),
              onClick: y
            }, null, 8, ["text"])
          ];
        }),
        _: 1
      });
    };
  }
}), l4 = { class: "smake:flex smake:flex-col smake:overflow-clip smake:rounded-xl smake:border smake:border-secondary-2" }, c4 = { class: "smake:bg-secondary-3 smake:p-4 smake:text-sm smake:font-bold smake:uppercase" }, u4 = {
  key: 0,
  class: "smake:m-4 smake:flex smake:grow smake:flex-col smake:items-center smake:justify-center smake:gap-4 smake:rounded-xl smake:bg-secondary-3 smake:p-4 smake:text-center smake:text-sm smake:text-danger"
}, d4 = Symbol("renderingFailedToast"), m4 = /* @__PURE__ */ J({
  __name: "Preview",
  props: {
    productionDesign: {}
  },
  emits: ["status"],
  setup(e, { emit: t }) {
    const n = e, { productionDesign: o } = we(n), a = t, { t: s } = dt(), { open: i } = vn(), r = Wa(
      S(() => o.value.design)
    ), { allTextLinesSupported: c } = To(
      S(() => {
        var _;
        return (_ = r.value) == null ? void 0 : _.lines;
      }),
      S(() => o.value.productionMethodId)
    ), { fetchStatus: u, imageUrl: d, status: p } = ui(
      o,
      S(() => c.value ?? !0)
    );
    return pt(p, (_) => {
      _ === "error" && i(Ot, {
        id: d4,
        input: {
          text: s("error_pusher_rendering_failed"),
          type: "info"
        }
      });
    }), se(() => {
      if (u.value === "fetching") {
        a("status", "pending");
        return;
      }
      if (c.value === !1) {
        a("status", "error");
        return;
      }
      a("status", p.value);
    }), (_, y) => {
      const k = De("FontAwesomeIcon");
      return $(), E("div", l4, [
        z("div", c4, j(_.$t("icon")), 1),
        l(c) === !1 ? ($(), E("div", u4, [
          x(k, {
            icon: ["fak", "icon-ciconfig-alert-warning"],
            "fixed-width": "",
            class: "smake:size-7.5 smake:text-danger smake:@md:size-10"
          }),
          Pe(" " + j(_.$t("please_correct_the_highlighted_errors")), 1)
        ])) : ($(), E("div", {
          key: 1,
          class: ye(["smake:m-4 smake:flex smake:grow smake:items-center smake:justify-center smake:rounded-xl smake:bg-secondary-3 smake:p-4", {
            "smake:animate-pulse": l(p) === "pending" || l(u) === "fetching"
          }])
        }, [
          l(c) && l(d) ? ($(), H(Yt, {
            key: 0,
            src: l(d)
          }, null, 8, ["src"])) : Q("", !0)
        ], 2))
      ]);
    };
  }
}), p4 = { class: "smake:flex smake:grow smake:flex-col smake:gap-4 smake:overflow-y-auto" }, f4 = { class: "smake:text-sm" }, h4 = { class: "smake:flex smake:grow smake:flex-col smake:gap-4 smake:@md:flex-row" }, _4 = { class: "smake:flex smake:flex-col smake:justify-between smake:gap-4 smake:@max-md:justify-center smake:@sm:flex-row" }, v4 = { class: "smake:flex smake:flex-col smake:gap-4 smake:@sm:flex-row" }, g4 = /* @__PURE__ */ J({
  __name: "DesignRepairWizard",
  props: /* @__PURE__ */ Te({
    id: {},
    name: {},
    productionDesign: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Te(["closed", "resolve"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = e, { id: o, name: a, productionDesign: s } = we(n), i = t, r = Ue(e, "open"), { t: c } = dt(), { open: u } = vn(), d = Wa(
      S(() => s.value.design)
    ), { unsupportedTextLines: p } = To(
      S(() => {
        var P;
        return (P = d.value) == null ? void 0 : P.lines;
      }),
      S(() => s.value.productionMethodId)
    ), _ = N("pending"), { mutateAsync: y, status: k } = ct({
      ...Zb(),
      onError: () => {
        u(Ot, {
          input: {
            text: c("boot_error.unexpected"),
            type: "info"
          }
        });
      }
    }), w = N(!1);
    async function f(P) {
      w.value = !!P;
      const I = await y({
        id: o.value,
        favoriteDesign: {
          name: a.value,
          elements: [Qo(s.value)],
          production_method: {
            id: s.value.productionMethodId
          }
        }
      });
      i("resolve", { favoriteDesign: I, load: !!P }), r.value = !1;
    }
    const g = S(
      () => k.value === "pending" && !w.value
    ), b = S(
      () => k.value === "pending" && w.value
    ), A = S(
      () => _.value !== "success" || k.value === "pending"
    );
    return (P, I) => ($(), H(Ro, {
      open: r.value,
      "onUpdate:open": I[3] || (I[3] = (D) => r.value = D),
      title: P.$t("font_update"),
      "prevent-close": l(k) === "pending",
      onClosed: I[4] || (I[4] = (D) => i("closed"))
    }, {
      default: M(() => {
        var D, R;
        return [
          z("div", p4, [
            z("div", f4, j(P.$t("font_update_explanation")), 1),
            z("div", h4, [
              x(m4, {
                class: "smake:@md:flex-1",
                "production-design": l(s),
                onStatus: I[0] || (I[0] = (U) => _.value = U)
              }, null, 8, ["production-design"]),
              l(d) ? ($(), H(rc, {
                key: 0,
                class: "smake:@md:flex-1",
                data: l(d),
                "production-method-id": l(s).productionMethodId,
                "initial-selected-line": (R = (D = l(p)) == null ? void 0 : D[0]) == null ? void 0 : R.textLine,
                "is-light": ""
              }, null, 8, ["data", "production-method-id", "initial-selected-line"])) : Q("", !0)
            ])
          ]),
          z("div", _4, [
            x(l(Wt), { "as-child": "" }, {
              default: M(() => [
                x(Se, {
                  class: "smake:@max-md:hidden",
                  icon: {
                    type: ["fak", "icon-x"]
                  },
                  type: "secondary",
                  disabled: l(k) === "pending",
                  text: P.$t("abort")
                }, null, 8, ["disabled", "text"])
              ]),
              _: 1
            }),
            z("div", v4, [
              x(Se, {
                disabled: A.value,
                type: "secondary",
                icon: {
                  type: g.value ? ["fal", "spinner"] : ["fak", "icon-save"],
                  class: {
                    "smake:animate-spin": g.value
                  }
                },
                text: P.$t("save"),
                onClick: I[1] || (I[1] = (U) => f())
              }, null, 8, ["disabled", "icon", "text"]),
              x(Se, {
                disabled: A.value,
                type: "primary",
                icon: {
                  type: ["fal", b.value ? "spinner" : "check"],
                  class: {
                    "smake:animate-spin": b.value
                  }
                },
                text: P.$t("save_and_load"),
                onClick: I[2] || (I[2] = (U) => f(!0))
              }, null, 8, ["disabled", "icon", "text"])
            ])
          ])
        ];
      }),
      _: 1
    }, 8, ["open", "title", "prevent-close"]));
  }
}), y4 = { class: "smake:absolute smake:top-1/2 smake:left-1/2 smake:mx-auto smake:flex smake:h-fit smake:max-h-full smake:w-auto smake:max-w-150 smake:-translate-x-1/2 smake:-translate-y-1/2 smake:flex-col smake:gap-6 smake:rounded-3xl smake:bg-white smake:p-4" }, k4 = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, b4 = { class: "smake:flex smake:flex-col smake:justify-between smake:gap-5" }, w4 = { class: "smake:flex smake:w-full smake:flex-col smake:gap-4 smake:@md:flex-row" }, x4 = /* @__PURE__ */ J({
  __name: "ConfirmReplacementDialog",
  props: {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  },
  emits: /* @__PURE__ */ Te(["closed", "resolve"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = t, o = Ue(e, "open"), { dialogsRoot: a } = L(Hn());
    return (s, i) => {
      const r = De("FontAwesomeIcon");
      return $(), H(l(rn), {
        open: o.value,
        "onUpdate:open": i[3] || (i[3] = (c) => o.value = c)
      }, {
        default: M(() => [
          x(l(ln), { to: l(a) }, {
            default: M(() => [
              x(Qe, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0",
                onAfterLeave: i[0] || (i[0] = (c) => n("closed"))
              }, {
                default: M(() => [
                  x(l(cn), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              x(Qe, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:scale-95 smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:scale-95 smake:opacity-0"
              }, {
                default: M(() => [
                  x(l(un), { "as-child": "" }, {
                    default: M(() => [
                      z("div", y4, [
                        z("div", k4, [
                          x(l(sn), { class: "smake:flex smake:items-center smake:gap-2" }, {
                            default: M(() => [
                              x(r, {
                                class: "smake:size-4.5",
                                icon: ["fak", "icon-info"],
                                "fixed-width": ""
                              }),
                              z("div", null, j(s.$t(
                                "the_selected_design_will_replace_the_current_selection"
                              )), 1)
                            ]),
                            _: 1
                          }),
                          x(l(Wt), { "as-child": "" }, {
                            default: M(() => [
                              x(ft, {
                                type: "subordinate",
                                icon: {
                                  type: ["fak", "icon-x"]
                                }
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        z("div", b4, [
                          z("div", w4, [
                            x(Se, {
                              type: "subordinate",
                              size: "small",
                              class: "smake:flex-grow",
                              text: s.$t("abort"),
                              onClick: i[1] || (i[1] = (c) => o.value = !1)
                            }, null, 8, ["text"]),
                            x(Se, {
                              class: "smake:flex-grow",
                              type: "primary",
                              size: "small",
                              text: s.$t("replace"),
                              onClick: i[2] || (i[2] = (c) => n("resolve", !0))
                            }, null, 8, ["text"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), $4 = {
  key: 0,
  class: "smake:font-bold"
}, z4 = /* @__PURE__ */ J({
  __name: "DesignFavoredCard",
  props: {
    design: {},
    isSelectConfirmationRequired: { type: Boolean }
  },
  emits: ["repair", "select"],
  setup(e, { emit: t }) {
    const n = e, { design: o } = we(n), a = t, s = S(() => Eo(o.value.elements[0])), i = Wa(s), { allTextLinesSupported: r } = To(
      S(() => {
        var U;
        return (U = i.value) == null ? void 0 : U.lines;
      }),
      S(() => o.value.production_method.id)
    ), c = S(() => r.value === !1), u = N(!1), d = N(!1), p = N(!1), {
      error: _,
      mutate: y,
      reset: k,
      status: w
    } = ct({
      ...re.designs.favored.patch.use(),
      onSuccess: () => u.value = !1
    }), {
      error: f,
      mutate: g,
      status: b
    } = ct({
      ...re.designs.favored.delete.use(),
      onSuccess: () => d.value = !1
    });
    se(() => {
      u.value || k();
    });
    function A() {
      if (!n.isSelectConfirmationRequired) {
        a("select");
        return;
      }
      p.value = !0;
    }
    const P = S(
      () => Yb(...oc(o.value.elements[0]))
    ), I = S(() => o.value.name ?? ""), D = S(() => o.value.preview_url);
    function R(U) {
      U && a("select");
    }
    return (U, G) => ($(), E(me, null, [
      x(Xp, {
        name: I.value,
        image: D.value,
        width: l(o).width,
        height: l(o).height,
        "color-assignments": P.value,
        deletable: !0,
        "production-method-id": l(o).production_method.id,
        "needs-repair": c.value,
        onRename: G[0] || (G[0] = (F) => u.value = !0),
        onDelete: G[1] || (G[1] = (F) => d.value = !0),
        onSelect: A,
        onRepair: G[2] || (G[2] = (F) => a("repair"))
      }, Zr({ _: 2 }, [
        c.value ? {
          name: "repair-label",
          fn: M(() => [
            l(r) ? Q("", !0) : ($(), E("div", $4, j(U.$t("font_not_available")) + "! ", 1))
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["name", "image", "width", "height", "color-assignments", "production-method-id", "needs-repair"]),
      x(Qp, {
        open: u.value,
        "onUpdate:open": G[3] || (G[3] = (F) => u.value = F),
        name: I.value,
        image: D.value,
        error: l(_) ?? void 0,
        "mutation-status": l(w),
        onRename: G[4] || (G[4] = (F) => l(y)({ id: l(o).id, name: F }))
      }, null, 8, ["open", "name", "image", "error", "mutation-status"]),
      x(Kp, {
        open: d.value,
        "onUpdate:open": G[5] || (G[5] = (F) => d.value = F),
        name: I.value,
        image: D.value,
        "mutation-status": l(b),
        error: l(f) ?? void 0,
        onDelete: G[6] || (G[6] = (F) => l(g)(l(o).id))
      }, null, 8, ["open", "name", "image", "mutation-status", "error"]),
      x(x4, {
        open: p.value,
        "onUpdate:open": G[7] || (G[7] = (F) => p.value = F),
        onResolve: R
      }, null, 8, ["open"])
    ], 64));
  }
}), S4 = {
  key: 1,
  class: "smake:-mt-8 smake:flex smake:h-full smake:grow smake:items-center smake:justify-center smake:text-lg"
}, C4 = { class: "smake:max-w-md smake:text-center smake:text-secondary-1 smake:italic" }, A4 = /* @__PURE__ */ J({
  __name: "DesignFavoredSelection",
  props: {
    isSelectConfirmationRequired: { type: Boolean },
    productionMethodId: {}
  },
  emits: ["design-selected"],
  setup(e, { emit: t }) {
    const n = e, { productionMethodId: o } = we(n), a = t, s = Xo("favoriteDesignsContainer"), { y: i } = Od(s, { behavior: "smooth" }), { productionMethod: r } = Tt(o), { open: c } = Bt(), u = S(
      () => ({
        production_method: [o.value]
      })
    ), {
      data: d,
      fetchNextPage: p,
      hasNextPage: _,
      isFetching: y,
      status: k
    } = Jo({
      ...re.designs.favored.list.use(u),
      select: (b) => b.pages.flatMap((A) => A.data),
      staleTime: 1 / 0
    });
    function w() {
      return k.value === "pending" ? !0 : _.value;
    }
    async function f() {
      k.value !== "pending" && await p();
    }
    async function g(b) {
      const A = await c(g4, {
        input: {
          id: b.id,
          name: b.name ?? void 0,
          productionDesign: {
            design: Eo(b.elements[0]),
            productionMethodId: b.production_method.id
          }
        }
      });
      A !== void 0 && (i.value = 0), A != null && A.load && a("design-selected", to(A.favoriteDesign));
    }
    return (b, A) => {
      var P, I;
      return l(y) || (P = l(d)) != null && P.length ? kt(($(), E("div", {
        key: 0,
        ref_key: "favoriteDesignsContainer",
        ref: s,
        class: "smake:grid smake:grid-cols-auto-fill-38 smake:gap-4 smake:overflow-y-auto smake:@sm:grid-cols-auto-fill-45"
      }, [
        ($(!0), E(me, null, Ce(l(d), (D) => ($(), E("div", {
          key: D.id
        }, [
          x(z4, {
            design: D,
            "is-select-confirmation-required": e.isSelectConfirmationRequired,
            onSelect: (R) => a("design-selected", l(to)(D)),
            onRepair: (R) => g(D)
          }, null, 8, ["design", "is-select-confirmation-required", "onSelect", "onRepair"])
        ]))), 128)),
        ($(!0), E(me, null, Ce(l(y) ? 3 : 0, (D) => ($(), E("div", {
          key: D,
          class: "smake:min-h-95 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3"
        }))), 128))
      ])), [
        [l(Ea), [f, { distance: 350, canLoadMore: w }]]
      ]) : ($(), E("div", S4, [
        z("div", C4, j(b.$t("no_designs", {
          productionMethod: (I = l(r)) == null ? void 0 : I.display_name
        })), 1)
      ]));
    };
  }
}), P4 = { class: "smake:flex smake:flex-wrap smake:gap-2" }, T4 = { class: "smake:text-nowrap smake:text-secondary-2" }, M4 = { class: "smake:text-nowrap smake:text-secondary-2" }, lc = /* @__PURE__ */ J({
  __name: "CustomerDesignSelection",
  props: /* @__PURE__ */ Te({
    initialProductionMethodId: {},
    intialTab: { default: "customer-logos" },
    positioningArea: { default: void 0 },
    positioningAreaDesign: { default: void 0 }
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Te(["closed", "resolve"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = t, o = Ue(e, "open"), a = e, {
      initialProductionMethodId: s,
      intialTab: i,
      positioningArea: r,
      positioningAreaDesign: c
    } = we(a), u = N(s.value);
    pt(o, (b) => {
      b && (u.value = s.value);
    });
    const d = S(() => !c.value), { placeDesign: p } = pi();
    function _() {
      o.value = !1, n("resolve", !0);
    }
    async function y(b) {
      const A = Jl(b.logo);
      await p(
        {
          design: A,
          productionMethodId: u.value
        },
        {
          mergePostioningAreaDesign: c.value,
          positioningArea: r.value
        }
      ) === "success" && _();
    }
    async function k(b) {
      const A = Eo(b.elements[0]);
      await p(
        {
          design: A,
          productionMethodId: u.value
        },
        {
          mergePostioningAreaDesign: c.value,
          positioningArea: r.value
        }
      ) === "success" && (o.value = !1, n("resolve", !0));
    }
    const w = N(i.value), { data: f } = zt({
      ...re.customerLogos.count.use(
        S(() => ({
          production_method: [u.value]
        }))
      ),
      retry: !1,
      staleTime: 1 / 0
    }), { data: g } = zt({
      ...re.designs.favored.count.use(
        S(() => ({
          production_method: [u.value]
        }))
      ),
      retry: !1,
      staleTime: 1 / 0
    });
    return (b, A) => ($(), H(Ro, {
      open: o.value,
      "onUpdate:open": A[2] || (A[2] = (P) => o.value = P),
      title: b.$t("logos_and_designs"),
      "fixed-height": "",
      onClosed: A[3] || (A[3] = (P) => n("closed"))
    }, {
      default: M(() => [
        x(l(Sl), {
          modelValue: w.value,
          "onUpdate:modelValue": A[1] || (A[1] = (P) => w.value = P),
          class: "smake:flex smake:h-full smake:flex-col smake:gap-4 smake:overflow-hidden"
        }, {
          default: M(() => [
            x(l(Cl), { class: "smake:mb-4 smake:flex smake:flex-wrap smake:justify-between smake:gap-2" }, {
              default: M(() => [
                z("div", P4, [
                  x(xa, {
                    "selected-value": w.value,
                    text: b.$t("my_files"),
                    value: "customer-logos"
                  }, {
                    default: M(() => [
                      x(H3, { class: "smake:size-3.5" }),
                      Pe(" " + j(b.$t("my_files")) + " ", 1),
                      z("span", T4, j(l(f)), 1)
                    ]),
                    _: 1
                  }, 8, ["selected-value", "text"]),
                  x(xa, {
                    "selected-value": w.value,
                    text: b.$t("saved_designs"),
                    value: "designs"
                  }, {
                    default: M(() => [
                      x(K3, { class: "smake:size-3.5" }),
                      Pe(" " + j(b.$t("saved_designs")) + " ", 1),
                      z("span", M4, j(l(g)), 1)
                    ]),
                    _: 1
                  }, 8, ["selected-value", "text"])
                ]),
                x(Wp, {
                  modelValue: u.value,
                  "onUpdate:modelValue": A[0] || (A[0] = (P) => u.value = P),
                  disabled: !d.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            x(l(wa), {
              "as-child": "",
              value: "customer-logos",
              unmount: !1
            }, {
              default: M(() => [
                x(j6, {
                  "production-method-id": u.value,
                  "positioning-area": l(r),
                  "positioning-area-design": l(c),
                  onCustomerLogoSelected: y,
                  onUploadPlaced: _
                }, null, 8, ["production-method-id", "positioning-area", "positioning-area-design"])
              ]),
              _: 1
            }),
            x(l(wa), {
              value: "designs",
              "as-child": "",
              unmount: !1
            }, {
              default: M(() => [
                x(A4, {
                  "is-select-confirmation-required": l(c) !== void 0,
                  "production-method-id": u.value,
                  onDesignSelected: k
                }, null, 8, ["is-select-confirmation-required", "production-method-id"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
}), I4 = {}, E4 = {
  id: "Ebene_2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 94.03 86.98"
};
function O4(e, t) {
  return $(), E("svg", E4, [...t[0] || (t[0] = [
    Pd('<g id="Ebene_1-2"><g id="Icon_Image_Download"><g id="Pfad_1352"><path fill="currentColor" d="M68.6,86.98c-.61,0-1.22-.08-1.83-.25L5.05,69.81c-3.65-1-5.81-4.79-4.81-8.44l8.31-30.27c.22-.8,1.05-1.27,1.84-1.05.8.22,1.27,1.04,1.05,1.84L3.14,62.16c-.56,2.06.65,4.19,2.71,4.76l61.71,16.93c1,.27,2.04.14,2.94-.37.9-.51,1.54-1.34,1.82-2.34l3.71-13.55c.22-.8,1.04-1.27,1.84-1.05.8.22,1.27,1.04,1.05,1.84l-3.71,13.55c-.49,1.77-1.63,3.24-3.23,4.15-1.05.6-2.21.9-3.39.9Z"></path></g><g id="Pfad_1353"><path fill="currentColor" d="M34.73,27.91c-4.22,0-7.64-3.43-7.65-7.64,0-2.04.79-3.96,2.24-5.41,1.44-1.44,3.36-2.24,5.41-2.24,4.22,0,7.65,3.43,7.65,7.64h0s0,0,0,0c0,2.04-.79,3.96-2.24,5.41-1.44,1.44-3.36,2.24-5.41,2.24h0ZM34.73,15.62c-1.24,0-2.41.48-3.29,1.36-.88.88-1.36,2.04-1.36,3.28,0,2.56,2.08,4.64,4.65,4.64h0c2.56,0,4.64-2.08,4.64-4.65h0c0-2.56-2.08-4.64-4.64-4.64Z"></path></g><path fill="currentColor" d="M89.38,0H20.93c-2.56,0-4.64,2.08-4.64,4.64v53.71c0,2.56,2.08,4.64,4.64,4.64h68.46c2.56,0,4.64-2.08,4.64-4.64V4.64c0-2.56-2.08-4.64-4.64-4.64ZM20.93,3h68.46c.9,0,1.64.73,1.64,1.64v39.21l-20.35-20.35c-.56-.56-1.56-.56-2.12,0l-19.53,19.53-8.88-8.88c-.28-.28-.67-.44-1.07-.44-.4,0-.78.17-1.06.45l-18.71,19.2V4.64c0-.9.73-1.64,1.64-1.64ZM89.38,59.98H20.93c-.9,0-1.64-.73-1.64-1.64v-.68l19.8-20.32,8.87,8.87c.56.56,1.56.56,2.12,0l19.53-19.53,21.42,21.41v10.26c0,.9-.73,1.64-1.64,1.64Z"></path></g></g>', 1)
  ])]);
}
const R4 = /* @__PURE__ */ Gn(I4, [["render", O4]]), L4 = { class: "dashed-border smake:rounded-[10px] smake:border-secondary-2 smake:p-1.75" }, j4 = {
  key: 0,
  class: "smake:flex smake:grow smake:flex-col smake:items-center smake:justify-between"
}, D4 = { class: "smake:flex smake:grow smake:flex-col smake:items-center smake:justify-center smake:gap-4" }, N4 = { class: "smake:relative smake:-ml-1.25 smake:@md:-ml-2.5" }, V4 = { class: "smake:absolute smake:-right-2.5 smake:bottom-2 smake:flex smake:size-5 smake:items-center smake:justify-center smake:rounded-full smake:bg-white smake:p-1 smake:@md:-right-5 smake:@md:bottom-4 smake:@md:size-10" }, U4 = { class: "smake:text-sm smake:font-medium" }, F4 = { class: "smake:flex smake:items-center smake:justify-center smake:gap-4" }, q4 = { class: "smake:text-sm smake:font-medium" }, B4 = { class: "smake:flex smake:flex-col smake:gap-2 smake:text-center smake:font-semibold smake:text-balance smake:text-primary-1" }, H4 = ["href"], G4 = { class: "smake:p-4 smake:text-center smake:text-xs smake:leading-6" }, W4 = ["href"], Z4 = { class: "smake:mt-8 smake:text-center smake:text-xs smake:text-secondary-1" }, K4 = ["href"], Q4 = {
  key: 1,
  class: "smake:flex smake:w-full smake:flex-col smake:items-center smake:justify-center smake:gap-5"
}, X4 = { class: "smake:rounded-full smake:bg-black smake:p-4 smake:shadow-lg" }, J4 = { class: "smake:flex smake:flex-col smake:text-center smake:text-[14px] smake:font-thin" }, Y4 = {
  key: 2,
  class: "smake:flex smake:grow smake:flex-col smake:items-center smake:gap-4 smake:p-5"
}, ex = { class: "smake:flex smake:grow smake:items-center smake:justify-center" }, tx = { class: "smake:flex smake:w-full smake:items-center smake:gap-4 smake:@max-lg:flex-col smake:@max-lg:items-center smake:@max-lg:text-center smake:@lg:justify-between" }, nx = { class: "smake:flex smake:flex-col smake:gap-1 smake:text-sm" }, ox = { class: "smake:font-medium" }, ax = { class: "smake:[overflow-wrap:normal]" }, sx = /* @__PURE__ */ J({
  __name: "CustomerLogoDropzone",
  props: /* @__PURE__ */ Te({
    accept: {},
    disabled: { type: Boolean },
    errors: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Te(["reset"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    var de;
    function n(K) {
      return "id" in K;
    }
    const o = e, { accept: a, disabled: s, errors: i } = we(o), r = N();
    se(() => {
      r.value = i.value;
    });
    const { termsOfServiceLink: c, uploadHelpLink: u } = L(di()), d = S(() => {
      if (r.value) {
        if (r.value.fieldMessages) {
          const K = [];
          for (const [ce, ue] of Object.entries(
            r.value.fieldMessages
          ))
            ce === "content_type" || ce === "path" || K.push(...ue);
          return K;
        }
        if (r.value.message)
          return [r.value.message];
      }
    }), p = S(
      () => {
        var K, ce, ue, Ae;
        return !!((ce = (K = r.value) == null ? void 0 : K.fieldMessages) != null && ce.content_type) || !!((Ae = (ue = r.value) == null ? void 0 : ue.fieldMessages) != null && Ae.path);
      }
    ), _ = t, y = Ue(e, "modelValue"), { designerConfiguration: k } = L(st()), w = S(
      () => {
        var K;
        return (K = k.value) == null ? void 0 : K.settings.settings.units.length;
      }
    ), { decimalFormat: f } = ri(), { locale: g } = dt(), b = S(() => y.value === void 0 ? "empty" : n(y.value) ? "preview" : "processing"), A = S(() => {
      if (y.value && n(y.value))
        return {
          name: y.value.name ?? y.value.logo.name,
          height: f(
            y.value.logo.height ?? 0,
            g.value,
            2
          ),
          previewUrl: y.value.logo.preview_url ?? void 0,
          width: f(
            y.value.logo.width ?? 0,
            g.value,
            2
          )
        };
    });
    function P(K) {
      var ce;
      return (ce = a.value) != null && ce.length ? a.value.some(
        (ue) => ue.startsWith(".") ? K.name.endsWith(ue) : K.type === ue
      ) : !0;
    }
    const I = Xo("dropArea"), { isOverDropZone: D } = Lh(I, {
      multiple: !1,
      onDrop: (K) => {
        if (s.value) return;
        _("reset");
        let ce = K == null ? void 0 : K[0];
        ce && (P(ce) || (ce = void 0, r.value = {
          fieldMessages: {
            content_type: ["invalid"]
          }
        }), y.value = ce);
      }
    }), R = S(() => !s.value && D.value), { onChange: U, open: G } = jh({
      accept: (de = a.value) == null ? void 0 : de.join(","),
      multiple: !1
    });
    function F() {
      _("reset"), G();
    }
    return U((K) => {
      if (!K) return;
      let ce = K[0];
      ce && (P(ce) || (ce = void 0, r.value = {
        fieldMessages: {
          content_type: ["invalid"]
        }
      }), y.value = ce);
    }), (K, ce) => {
      const ue = De("FontAwesomeIcon");
      return $(), E("div", L4, [
        z("div", {
          ref_key: "dropArea",
          ref: I,
          class: ye([{
            "smake:bg-secondary-3": !R.value,
            "smake:bg-secondary-2": R.value
          }, "smake:flex smake:h-full smake:rounded-[10px] smake:p-3 smake:pt-12 smake:pb-4"])
        }, [
          b.value === "empty" ? ($(), E("div", j4, [
            z("div", D4, [
              z("div", N4, [
                x(R4, { class: "smake:size-15 smake:@md:size-30" }),
                z("div", V4, [
                  x(sc, { class: "smake:h-2.5 smake:@md:h-5" })
                ])
              ]),
              z("div", U4, j(K.$t("drag_file_over_area")), 1),
              z("div", F4, [
                z("div", {
                  class: ye(["smake:w-18 smake:border-t-2", {
                    "smake:border-t-secondary-2": !R.value,
                    "smake:border-t-secondary-3": R.value
                  }])
                }, null, 2),
                z("div", q4, j(K.$t("or")), 1),
                z("div", {
                  class: ye(["smake:w-18 smake:border-t-2", {
                    "smake:border-t-secondary-2": !R.value,
                    "smake:border-t-secondary-3": R.value
                  }])
                }, null, 2)
              ]),
              z("div", null, [
                x(Se, {
                  type: "primary",
                  size: "small",
                  disabled: l(s),
                  text: K.$t("select_file"),
                  onClick: F
                }, null, 8, ["disabled", "text"])
              ]),
              z("div", B4, [
                ($(!0), E(me, null, Ce(d.value, (Ae) => ($(), E("div", { key: Ae }, j(Ae), 1))), 128)),
                p.value ? ($(), H(l(Ti), {
                  key: 0,
                  keypath: "upload_error_422_content_type",
                  tag: "span"
                }, {
                  here: M(() => [
                    z("a", {
                      class: "smake:font-bold smake:underline",
                      href: l(u),
                      target: "_blank"
                    }, j(K.$t("here")), 9, H4)
                  ]),
                  _: 1
                })) : Q("", !0)
              ])
            ]),
            z("div", G4, [
              x(l(Ti), {
                keypath: "more_informations_about_upload",
                as: "div"
              }, {
                termsOfServiceLink: M(() => [
                  z("a", {
                    href: l(c),
                    target: "_blank",
                    class: "smake:underline"
                  }, j(K.$t("terms_of_service")), 9, W4)
                ]),
                _: 1
              })
            ]),
            z("div", Z4, [
              x(l(Ti), {
                keypath: "uploaded_content_automatically_checked_using_ai",
                as: "div"
              }, {
                termsOfServiceLink: M(() => [
                  z("a", {
                    href: l(c),
                    target: "_blank",
                    class: "smake:underline"
                  }, j(K.$t("terms_of_service")), 9, K4)
                ]),
                _: 1
              })
            ])
          ])) : Q("", !0),
          b.value === "processing" ? ($(), E("div", Q4, [
            z("div", X4, [
              x(ue, {
                class: "smake:size-5 smake:animate-spin smake:text-white",
                icon: ["fal", "spinner-third"]
              })
            ]),
            z("div", J4, [
              z("div", null, j(K.$t("your_file_is_beeing_uploaded")), 1),
              z("div", null, j(K.$t("please_hold_on_for_a_moment")), 1)
            ])
          ])) : Q("", !0),
          A.value ? ($(), E("div", Y4, [
            z("div", ex, [
              x(Yt, {
                class: "smake:size-90 smake:object-contain smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:rounded-md smake:data-[state=pending]:bg-secondary-2",
                src: A.value.previewUrl
              }, null, 8, ["src"])
            ]),
            z("div", tx, [
              z("div", nx, [
                z("div", ox, j(A.value.name), 1),
                z("div", ax, j(A.value.width) + " x " + j(A.value.height) + " " + j(w.value), 1)
              ]),
              x(Se, {
                size: "small",
                type: "subordinate",
                text: K.$t("upload_another_file"),
                onClick: F
              }, null, 8, ["text"])
            ])
          ])) : Q("", !0)
        ], 2)
      ]);
    };
  }
}), ix = /* @__PURE__ */ Gn(sx, [["__scopeId", "data-v-4a49c851"]]), rx = ["href"], lx = /* @__PURE__ */ J({
  __name: "HelpLink",
  setup(e) {
    const { uploadHelpLink: t } = L(di());
    return (n, o) => {
      const a = De("FontAwesomeIcon");
      return $(), E(me, null, [
        z("a", {
          class: "smake:flex smake:items-center smake:gap-1 smake:text-xs smake:text-secondary-1 smake:underline smake:@md:hidden",
          type: "outline",
          href: l(t),
          target: "_blank"
        }, [
          x(a, {
            class: "smake:h-3",
            icon: ["fal", "circle-question"]
          }),
          Pe(" " + j(n.$t("help_for_upload")), 1)
        ], 8, rx),
        x(dn, {
          as: "a",
          class: "smake:@max-md:hidden",
          type: "subordinate",
          href: l(t),
          target: "_blank"
        }, {
          default: M(() => [
            x(Mo, {
              size: "default",
              type: ["fal", "circle-question"]
            }),
            Pe(" " + j(n.$t("help_for_upload")), 1)
          ]),
          _: 1
        }, 8, ["href"])
      ], 64);
    };
  }
}), cx = { class: "smake:flex smake:size-45 smake:flex-col smake:items-center smake:justify-center smake:gap-5 smake:rounded-lg smake:bg-secondary-3 smake:p-4" }, ux = /* @__PURE__ */ J({
  __name: "CustomerLogo",
  props: {
    data: {},
    disabled: { type: Boolean }
  },
  emits: ["selected"],
  setup(e, { emit: t }) {
    const n = t;
    return (o, a) => ($(), E("div", cx, [
      x(Yt, {
        class: "smake:size-2/3 smake:object-contain smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:rounded-md smake:data-[state=pending]:bg-secondary-2",
        src: e.data.logo.preview_url ?? void 0
      }, null, 8, ["src"]),
      x(Se, {
        type: "subordinate",
        size: "small",
        disabled: e.disabled,
        text: o.$t("choose"),
        onClick: a[0] || (a[0] = (s) => n("selected"))
      }, null, 8, ["disabled", "text"])
    ]));
  }
}), dx = { class: "smake:flex smake:flex-col smake:items-center smake:gap-5" }, mx = {
  key: 0,
  class: "smake:flex smake:size-45 smake:items-center smake:justify-center smake:rounded-lg smake:border-2 smake:border-secondary-3 smake:text-center smake:text-xs smake:text-balance smake:text-secondary-2 smake:italic"
}, px = /* @__PURE__ */ J({
  __name: "RecentCustomerLogoUploads",
  props: {
    disabled: { type: Boolean },
    productionMethodId: {}
  },
  emits: ["selected"],
  setup(e, { emit: t }) {
    const n = e, { productionMethodId: o } = we(n), a = t, { data: s } = Jo({
      ...re.customerLogos.list.use(
        S(() => ({
          production_method: [o.value]
        }))
      ),
      select: (u) => u.pages.flatMap((d) => d.data)
    }), i = S(() => {
      var u;
      return (u = s.value) == null ? void 0 : u.slice(0, 3);
    }), r = S(() => {
      var u;
      return c.value ? 2 : 3 - (((u = i.value) == null ? void 0 : u.length) ?? 0);
    }), c = S(
      () => {
        var u;
        return (((u = i.value) == null ? void 0 : u.length) ?? 0) === 0;
      }
    );
    return (u, d) => {
      var p;
      return $(), E("div", dx, [
        z("span", {
          class: ye(["smake:text-sm smake:font-semibold", {
            "smake:text-secondary-2": (((p = l(s)) == null ? void 0 : p.length) ?? 0) === 0
          }])
        }, j(u.$t("recently_uploaded")) + ": ", 3),
        ($(!0), E(me, null, Ce(i.value, (_) => ($(), H(ux, {
          key: _.id,
          data: _,
          disabled: e.disabled,
          onSelected: (y) => a("selected", _)
        }, null, 8, ["data", "disabled", "onSelected"]))), 128)),
        c.value ? ($(), E("div", mx, j(u.$t("currently_no_uploaded_files")), 1)) : Q("", !0),
        ($(!0), E(me, null, Ce(r.value, (_) => ($(), E("div", {
          key: _,
          class: "smake:size-45 smake:rounded-lg smake:border-2 smake:border-secondary-3"
        }))), 128))
      ]);
    };
  }
}), fx = { class: "smake:flex smake:grow smake:gap-20 smake:text-[14px] smake:tracking-wider" }, hx = { class: "smake:mt-10.75 smake:flex smake:justify-center smake:gap-5" }, _x = /* @__PURE__ */ J({
  __name: "UploadConfirmationDialog",
  props: {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  },
  emits: /* @__PURE__ */ Te(["closed", "resolve"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = Ue(e, "open"), o = t;
    return (a, s) => ($(), H(Ro, {
      open: n.value,
      "onUpdate:open": s[2] || (s[2] = (i) => n.value = i),
      width: "small",
      "mobile-centered": "",
      title: a.$t("confirmation"),
      "confirm-text": a.$t("confirm"),
      "abort-text": a.$t("abort"),
      onClosed: s[3] || (s[3] = (i) => o("closed"))
    }, {
      default: M(() => [
        z("div", fx, j(a.$t("confirmation_description")), 1),
        z("div", hx, [
          x(Se, {
            type: "subordinate",
            class: "smake:grow",
            text: a.$t("abort"),
            onClick: s[0] || (s[0] = (i) => n.value = !1)
          }, null, 8, ["text"]),
          x(Se, {
            type: "primary",
            class: "smake:grow",
            text: a.$t("confirm"),
            onClick: s[1] || (s[1] = (i) => {
              o("resolve", !0), n.value = !1;
            })
          }, null, 8, ["text"])
        ])
      ]),
      _: 1
    }, 8, ["open", "title", "confirm-text", "abort-text"]));
  }
}), vx = {}, gx = {
  id: "Ebene_2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25.83 21.09"
};
function yx(e, t) {
  return $(), E("svg", gx, [...t[0] || (t[0] = [
    z("g", { id: "Ebene_1-2" }, [
      z("path", {
        fill: "currentColor",
        d: "M22.97,0H2.86C1.28,0,0,1.28,0,2.86v15.36c0,1.58,1.28,2.86,2.86,2.86h20.11c1.58,0,2.86-1.28,2.86-2.86V2.86c0-1.58-1.28-2.86-2.86-2.86ZM2.86,1.8h20.11c.59,0,1.06.48,1.06,1.06v10.79l-5.9-5.9c-.31-.31-.82-.31-1.13,0l-6.06,6.06-2.63-2.63c-.15-.15-.35-.23-.57-.23h0c-.21,0-.42.09-.57.24l-5.37,5.51V2.86c0-.59.48-1.06,1.06-1.06ZM22.97,19.29H2.86c-.38,0-.69-.21-.88-.5l5.77-5.91,2.62,2.62c.31.31.82.31,1.13,0l6.06-6.06,6.47,6.47v2.31c0,.59-.48,1.06-1.06,1.06Z"
      }),
      z("path", {
        fill: "currentColor",
        d: "M6.35,9.3c1.53,0,2.78-1.25,2.78-2.78s-1.25-2.78-2.78-2.78-2.78,1.25-2.78,2.78,1.25,2.78,2.78,2.78ZM6.35,5.35c.65,0,1.18.53,1.18,1.18s-.53,1.18-1.18,1.18-1.18-.53-1.18-1.18.53-1.18,1.18-1.18Z"
      })
    ], -1)
  ])]);
}
const kx = /* @__PURE__ */ Gn(vx, [["render", yx]]), bx = {}, wx = {
  id: "Ebene_2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25.83 21.09"
};
function xx(e, t) {
  return $(), E("svg", wx, [...t[0] || (t[0] = [
    z("g", { id: "Ebene_1-2" }, [
      z("path", {
        fill: "currentColor",
        d: "M22.97,0H2.86C1.28,0,0,1.28,0,2.86v15.36c0,1.58,1.28,2.86,2.86,2.86h20.11c1.58,0,2.86-1.28,2.86-2.86V2.86c0-1.58-1.28-2.86-2.86-2.86ZM24.03,18.23c0,.59-.48,1.06-1.06,1.06H2.86c-.59,0-1.06-.48-1.06-1.06V2.86c0-.59.48-1.06,1.06-1.06h20.11c.59,0,1.06.48,1.06,1.06v15.36Z"
      }),
      z("path", {
        fill: "currentColor",
        d: "M17.66,5h-4.04c-.44,0-.8.36-.8.8s.36.8.8.8h2.11l-6.76,6.76v-2.11c0-.44-.36-.8-.8-.8s-.8.36-.8.8v4.04c0,.08.02.15.04.22,0,.03,0,.05.02.08.08.2.24.36.44.44.02,0,.04,0,.06.01.08.02.16.05.24.05h4.04c.44,0,.8-.36.8-.8s-.36-.8-.8-.8h-2.11l6.76-6.76v2.11c0,.44.36.8.8.8s.8-.36.8-.8v-4.04c0-.44-.36-.8-.8-.8Z"
      })
    ], -1)
  ])]);
}
const $x = /* @__PURE__ */ Gn(bx, [["render", xx]]), zx = { class: "smake:flex smake:grow smake:flex-wrap smake:gap-3 smake:text-sm smake:font-semibold smake:@lg:gap-8.75" }, Sx = {
  key: 0,
  class: "smake:flex smake:grow smake:items-center smake:gap-2"
}, Cx = { class: "smake:flex smake:size-11.75 smake:items-center smake:justify-center smake:rounded-full smake:border smake:border-secondary-2 smake:p-0.5" }, Ax = {
  key: 1,
  class: "smake:flex smake:grow smake:items-center smake:gap-2"
}, Px = { class: "smake:flex smake:size-11.75 smake:items-center smake:justify-center smake:rounded-full smake:border smake:border-secondary-2 smake:p-0.5" }, Tx = { class: "smake:uppercase" }, Mx = /* @__PURE__ */ J({
  __name: "ValidationRules",
  props: {
    productionMethodId: {}
  },
  setup(e) {
    const t = e, { productionMethodId: n } = we(t), { allowedExtensions: o, maxFileSizeMb: a } = Tt(n);
    return (s, i) => ($(), E("div", zx, [
      l(a) ? ($(), E("div", Sx, [
        z("div", Cx, [
          x($x, { class: "smake:size-5.25" })
        ]),
        z("div", null, j(s.$t("max_file_size")) + " " + j(l(a)) + " MB", 1)
      ])) : Q("", !0),
      l(o) ? ($(), E("div", Ax, [
        z("div", Px, [
          x(kx, { class: "smake:size-5.25" })
        ]),
        z("div", null, [
          z("div", null, j(s.$t("supported_file_types")) + ":", 1),
          z("div", Tx, j(l(o).join(", ")), 1)
        ])
      ])) : Q("", !0)
    ]));
  }
}), Ix = { class: "smake:flex smake:gap-20" }, Ex = { class: "smake:flex smake:grow smake:flex-col smake:gap-7.5" }, Ox = { class: "smake:flex smake:w-full smake:flex-wrap smake:items-center smake:justify-between smake:gap-4" }, Rx = { class: "smake:mt-10.75 smake:flex smake:flex-col-reverse smake:items-center smake:justify-center smake:gap-5 smake:@md:flex-row" }, Lx = /* @__PURE__ */ J({
  __name: "FileUploadDialogContent",
  props: /* @__PURE__ */ Te({
    positioningArea: {},
    positioningAreaDesign: {},
    productionMethodId: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Te(["resolve", "update:isUploadingCustomerLogo"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = e, { positioningArea: o, positioningAreaDesign: a, productionMethodId: s } = we(n), i = t, { t: r } = dt(), c = Ue(e, "open"), { allowedExtensions: u } = Tt(s), d = N(), p = S(
      () => d.value && "id" in d.value
    ), { selectedProductionMethodId: _ } = L(nt()), { placeDesign: y } = pi();
    function k() {
      i("resolve", !0);
    }
    const { open: w } = Bt();
    async function f(F) {
      const de = Jl(F.logo);
      c.value = !1, await y(
        {
          design: de,
          productionMethodId: s.value
        },
        {
          mergePostioningAreaDesign: a.value,
          positioningArea: o.value
        }
      ) !== "success" && w(Qa, {
        input: {
          positioningArea: o.value,
          positioningAreaDesign: a.value,
          productionMethodId: s.value
        }
      }), k();
    }
    const g = Vb(
      S(() => ({
        ERROR_SVG_CONTAINS_IMAGE: r("upload_error_svg_contains_image"),
        ERROR_SVG_CONTAINS_TEXT: r("upload_error_svg_contains_text"),
        ERROR_UNEXPECTED: r("upload_error_unexpected")
      }))
    ), {
      error: b,
      isPending: A,
      mutate: P,
      reset: I
    } = ct({
      ...g,
      mutationFn: (F) => k_(
        {
          name: "Customer Logo Upload",
          attributes: {
            "file.name": F.file.name,
            "file.size": F.file.size,
            "file.type": F.file.type
          },
          op: "customer-logo-upload"
        },
        async (de) => {
          try {
            const K = await g.mutationFn(F);
            return de.setAttribute("customer-logo.id", K.id), K;
          } catch (K) {
            throw de.setAttribute("error", String(K)), K;
          }
        }
      ),
      onError: () => {
        d.value = void 0;
      },
      onSuccess: (F) => {
        d.value = F;
      }
    }), { mutate: D } = ct({
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      mutationFn: () => w(_x),
      onSuccess: (F) => {
        if (!F) {
          d.value = void 0;
          return;
        }
        d.value instanceof File && P({
          file: d.value,
          productionMethodId: s.value
        });
      }
    });
    se(() => {
      i("update:isUploadingCustomerLogo", A.value);
    });
    const { fieldMessages: R, message: U } = S3(b);
    se(() => {
      d.value instanceof File && D();
    });
    const { mutate: G } = ct({
      mutationFn: async () => _.value === void 0 ? !1 : w(lc, {
        input: {
          initialProductionMethodId: s.value,
          intialTab: "customer-logos",
          positioningArea: o.value,
          positioningAreaDesign: a.value
        }
      }),
      onSuccess: (F) => {
        F && i("resolve", !0);
      }
    });
    return (F, de) => {
      var K;
      return $(), E("div", Ix, [
        x(px, {
          class: "smake:mb-30 smake:@max-lg:hidden",
          "production-method-id": l(s),
          disabled: l(A),
          onSelected: f
        }, null, 8, ["production-method-id", "disabled"]),
        z("div", Ex, [
          z("div", Ox, [
            x(Mx, { "production-method-id": l(s) }, null, 8, ["production-method-id"]),
            x(lx)
          ]),
          x(ix, {
            modelValue: d.value,
            "onUpdate:modelValue": de[0] || (de[0] = (ce) => d.value = ce),
            class: "smake:grow",
            accept: (K = l(u)) == null ? void 0 : K.map((ce) => `.${ce}`),
            errors: {
              message: l(U),
              fieldMessages: l(R)
            },
            disabled: l(A),
            onReset: l(I)
          }, null, 8, ["modelValue", "accept", "errors", "disabled", "onReset"]),
          z("div", Rx, [
            x(Se, {
              type: "secondary",
              class: "smake:shrink-0",
              disabled: l(A),
              icon: {
                type: ["fak", "icon-ciconfig-archive"]
              },
              text: F.$t("show_own_files"),
              onClick: l(G)
            }, null, 8, ["disabled", "text", "onClick"]),
            x(Se, {
              class: "smake:shrink-0",
              type: "primary",
              disabled: !p.value,
              icon: {
                type: ["fal", "check"]
              },
              text: F.$t("place_logo"),
              onClick: de[1] || (de[1] = (ce) => f(d.value))
            }, null, 8, ["disabled", "text"])
          ])
        ])
      ]);
    };
  }
}), Qa = /* @__PURE__ */ J({
  __name: "FileUploadDialog",
  props: /* @__PURE__ */ Te({
    positioningArea: {},
    positioningAreaDesign: {},
    productionMethodId: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Te(["closed", "resolve"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = t, o = Ue(e, "open"), a = N(!1);
    return (s, i) => ($(), H(Ro, {
      open: o.value,
      "onUpdate:open": i[3] || (i[3] = (r) => o.value = r),
      "prevent-close": a.value,
      title: s.$t("upload_own_file"),
      onClosed: i[4] || (i[4] = (r) => n("closed"))
    }, {
      default: M(() => [
        x(Lx, {
          open: o.value,
          "onUpdate:open": i[0] || (i[0] = (r) => o.value = r),
          "positioning-area": e.positioningArea,
          "positioning-area-design": e.positioningAreaDesign,
          "production-method-id": e.productionMethodId,
          onResolve: i[1] || (i[1] = (r) => n("resolve", r)),
          "onUpdate:isUploadingCustomerLogo": i[2] || (i[2] = (r) => a.value = r)
        }, null, 8, ["open", "positioning-area", "positioning-area-design", "production-method-id"])
      ]),
      _: 1
    }, 8, ["open", "prevent-close", "title"]));
  }
}), jx = /* @__PURE__ */ J({
  __name: "FileUploadButton",
  props: {
    positioningArea: {},
    positioningAreaDesign: {}
  },
  setup(e) {
    const { selectedProductionMethodId: t } = L(nt()), { isCustomerLogoUploadEnabled: n } = Tt(
      t
    ), { open: o } = Bt(), a = e, { positioningArea: s, positioningAreaDesign: i } = we(a);
    function r() {
      t.value && o(Qa, {
        input: {
          positioningArea: s.value,
          positioningAreaDesign: i.value,
          productionMethodId: t.value
        }
      });
    }
    return (c, u) => ($(), H(l($s), {
      name: l(Ct).CUSTOMER_LOGO_UPLOAD
    }, {
      default: M(() => [
        l(n) ? ($(), H(zs, {
          key: 0,
          icon: ["fal", "arrow-up-from-bracket"],
          text: c.$t("upload_file"),
          primary: "",
          "data-testid": "CustomerLogoUploadButton",
          onClick: r
        }, null, 8, ["text"])) : Q("", !0)
      ]),
      _: 1
    }, 8, ["name"]));
  }
});
function Ho(e, t, n = []) {
  for (const o of e)
    if (t(o, n) || Ho(o.children, t, [...n, o]))
      return !0;
  return !1;
}
function _d(e) {
  const t = [];
  return Ho(e, (n) => {
    t.push(...n.logos);
  }), new Set(t).size;
}
function Yp(e, t = null) {
  const n = [];
  for (const o of e)
    o.parent_id === t && n.push({
      ...o,
      children: Yp(e, o.id)
    });
  return n.sort((o, a) => o.left - a.left), n;
}
const Lo = rt("logos", () => {
  const { selectedProductionMethodId: e } = L(
    nt()
  ), t = N(), { animateHeight: n } = cp(t), o = N(!1), a = S({
    get: () => o.value,
    set: (R) => {
      R !== o.value && n(
        () => o.value = !o.value
      );
    }
  }), s = N([]), i = N(), r = N(e.value);
  se(() => {
    r.value === void 0 && (r.value = e.value);
  }), pt(r, () => {
    s.value = [];
  });
  const c = N();
  Dh(
    i,
    () => {
      var R;
      c.value = ((R = i.value) == null ? void 0 : R.trim()) ?? void 0;
    },
    {
      debounce: 300,
      maxWait: 700
    }
  );
  const u = re.logos.categories.list.use(
    S(() => ({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      production_method: [r.value]
    }))
  ), { data: d } = zt({
    ...u,
    enabled: S(
      () => u.enabled.value && r.value !== void 0
    ),
    retry: !1,
    staleTime: 1 / 0
  }), p = S(
    () => Yp(d.value ?? [])
  ), _ = S(() => {
    const R = [];
    return Ho(p.value, (U) => {
      s.value.includes(U.id) && R.push(U);
    }), R;
  }), y = S(
    () => ({
      "categories.id": s.value,
      name_or_tags: c.value,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      production_method: [r.value]
    })
  ), { data: k, fetchStatus: w } = zt({
    ...re.logos.count.use(y),
    retry: !1,
    staleTime: 1 / 0
  }), {
    data: f,
    fetchNextPage: g,
    fetchStatus: b,
    hasNextPage: A,
    status: P
  } = Jo({
    ...re.logos.list.use(y),
    retry: !1,
    select: (R) => R.pages.flatMap((U) => U.data),
    staleTime: 1 / 0
  });
  function I() {
    s.value = [], i.value = void 0, r.value = e.value;
  }
  function D(R) {
    if (s.value.includes(R.id)) {
      s.value = s.value.filter(
        (F) => F !== R.id
      );
      return;
    }
    let U = [];
    Ho(p.value, (F, de) => F.id === R.id ? (U = de.map((K) => K.id), !0) : !1);
    const G = [];
    Ho(R.children, (F) => {
      G.push(F.id);
    }), s.value = s.value.filter(
      (F) => !U.includes(F) && !G.includes(F)
    ), s.value.push(R.id), s.value.sort();
  }
  return {
    activeCategories: _,
    activeCategoryIds: s,
    activeProductionMethodId: r,
    categoriesTree: p,
    count: k,
    fetchNextPage: g,
    fetchStatus: b,
    fetchStatusCount: w,
    hasNextPage: A,
    logos: f,
    mobileSearchElement: t,
    mobileSearchOpen: a,
    normalizedSearchQuery: Un(c),
    resetFilters: I,
    searchQuery: i,
    status: P,
    toggleCategory: D
  };
}), Dx = {
  key: 0,
  class: "smake:absolute smake:top-0 smake:right-0 smake:translate-x-1/4 smake:-translate-y-1/4 smake:rounded-full smake:border-2 smake:border-white smake:bg-black smake:px-1.5"
}, Nx = { class: "smake:grid smake:grid-cols-2 smake:gap-x-4 smake:gap-y-2 smake:p-6" }, Vx = { class: "smake:text-secondary-1" }, cc = /* @__PURE__ */ J({
  __name: "Button",
  props: {
    data: {},
    depth: { default: 0 }
  },
  setup(e) {
    const t = e, { data: n } = we(t), o = Lo(), { activeCategoryIds: a } = L(o), { rootElement: s } = L(Vt()), i = S(
      () => a.value.includes(n.value.id)
    ), r = S(() => {
      const d = [];
      return Ho(n.value.children, (p) => {
        a.value.includes(p.id) && d.push(p);
      }), d;
    }), c = S(() => {
      const d = [...r.value];
      return i.value && d.push(n.value), d;
    });
    function u() {
      c.value.length > 0 || o.toggleCategory(n.value);
    }
    return (d, p) => e.depth === 0 ? ($(), E(me, { key: 0 }, [
      l(n).children.length === 0 ? ($(), H(Se, {
        key: 0,
        type: i.value ? "active" : "subordinate",
        text: l(n).name,
        onClick: p[0] || (p[0] = (_) => l(o).toggleCategory(l(n)))
      }, null, 8, ["type", "text"])) : ($(), H(l(Qd), { key: 1 }, {
        default: M(() => [
          x(l(Xd), { "as-child": "" }, {
            default: M(() => [
              x(Se, {
                type: c.value.length > 0 ? "active" : "subordinate",
                text: l(n).name,
                icon: {
                  type: ["fal", "chevron-down"]
                }
              }, {
                default: M(() => [
                  r.value.length > 0 ? ($(), E("div", Dx, j(r.value.length), 1)) : Q("", !0)
                ]),
                _: 1
              }, 8, ["type", "text"])
            ]),
            _: 1
          }),
          x(l(Jd), { to: l(s) }, {
            default: M(() => [
              x(l(Yd), {
                class: "smake:flex smake:flex-col smake:rounded smake:bg-white smake:text-sm smake:shadow-[0px_0px_15px_0px_rgba(0,0,0,0.25)]",
                align: "start",
                "side-offset": 8
              }, {
                default: M(() => [
                  z("div", Nx, [
                    ($(!0), E(me, null, Ce(l(n).children, (_) => ($(), H(cc, {
                      key: _.id,
                      data: _,
                      depth: e.depth + 1
                    }, null, 8, ["data", "depth"]))), 128))
                  ]),
                  x(l(em), { "as-child": "" }, {
                    default: M(() => [
                      x(Se, {
                        type: "primary",
                        class: "smake:rounded-none",
                        text: d.$t("show_X_results", {
                          count: l(_d)(
                            c.value.length === 0 ? [l(n)] : c.value
                          )
                        }),
                        onClick: u
                      }, null, 8, ["text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }))
    ], 64)) : ($(), H(dn, {
      key: 1,
      type: i.value ? "active" : "subordinate",
      onClick: p[1] || (p[1] = (_) => l(o).toggleCategory(l(n)))
    }, {
      default: M(() => [
        Pe(j(l(n).name) + " ", 1),
        z("span", Vx, j(l(_d)([l(n)])), 1)
      ]),
      _: 1
    }, 8, ["type"]));
  }
}), Ux = { class: "smake:relative" }, Fx = {
  key: 0,
  class: "smake:absolute smake:-top-1 smake:-right-1 smake:flex smake:h-6 smake:min-w-6 smake:items-center smake:justify-center smake:rounded-full smake:border smake:border-black smake:bg-white smake:p-0.25 smake:text-xs smake:text-black"
}, qx = { class: "smake:absolute smake:inset-0 smake:top-16 smake:flex smake:flex-col smake:gap-4 smake:rounded-3xl smake:rounded-b-none smake:bg-white smake:p-4" }, Bx = { class: "smake:flex smake:justify-end" }, Hx = { class: "smake:font-bold" }, Gx = { class: "smake:flex smake:flex-col smake:gap-2 smake:pb-2" }, Wx = { class: "smake:flex smake:shrink-0 smake:gap-2 smake:overflow-x-auto" }, Zx = { class: "smake:flex smake:gap-2" }, Kx = /* @__PURE__ */ J({
  __name: "Dialog",
  setup(e) {
    const { rootElement: t } = L(Vt()), n = Lo(), { activeCategories: o, activeCategoryIds: a, categoriesTree: s, count: i } = L(n), r = Nh("(width >= 640px)"), c = N(!1);
    return se(() => {
      r.value && (c.value = !1);
    }), (u, d) => {
      const p = De("FontAwesomeIcon");
      return l(s).length > 0 ? ($(), H(l(rn), {
        key: 0,
        open: c.value,
        "onUpdate:open": d[2] || (d[2] = (_) => c.value = _)
      }, {
        default: M(() => [
          x(l(Vd), { "as-child": "" }, {
            default: M(() => [
              z("div", Ux, [
                x(ft, {
                  size: "default",
                  type: l(o).length > 0 ? "active" : "subordinate",
                  icon: {
                    type: ["fal", "sliders"]
                  }
                }, null, 8, ["type"]),
                l(o).length > 0 ? ($(), E("div", Fx, j(l(o).length), 1)) : Q("", !0)
              ])
            ]),
            _: 1
          }),
          x(l(ln), { to: l(t) }, {
            default: M(() => [
              x(Qe, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0"
              }, {
                default: M(() => [
                  x(l(cn), { class: "smake:fixed smake:inset-0 smake:bg-black/40 smake:@sm:hidden" })
                ]),
                _: 1
              }),
              x(Qe, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:translate-y-full",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:translate-y-full"
              }, {
                default: M(() => [
                  x(l(un), { "as-child": "" }, {
                    default: M(() => [
                      z("div", qx, [
                        z("div", Bx, [
                          x(l(E_), { "as-child": "" }, {
                            default: M(() => [
                              x(l(sn), null, {
                                default: M(() => [...d[3] || (d[3] = [
                                  Pe(" Filter ", -1)
                                ])]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          x(l(Wt), { "as-child": "" }, {
                            default: M(() => [
                              x(ft, {
                                type: "subordinate",
                                icon: {
                                  type: ["fak", "icon-x"]
                                }
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        x(l(O_), {
                          type: "single",
                          collapsible: "",
                          class: "smake:divide-y smake:divide-secondary-2 smake:overflow-y-auto smake:border-y smake:border-secondary-2"
                        }, {
                          default: M(() => [
                            ($(!0), E(me, null, Ce(l(s).filter(
                              ({ children: _ }) => _.length > 0
                            ), (_) => ($(), H(l(R_), {
                              key: _.id,
                              value: _.id.toString()
                            }, {
                              default: M(() => [
                                x(l(L_), { class: "smake:flex" }, {
                                  default: M(() => [
                                    x(l(j_), { class: "smake:group smake:flex smake:flex-1 smake:justify-between smake:gap-2 smake:overflow-hidden smake:py-2" }, {
                                      default: M(() => [
                                        z("span", Hx, j(_.name), 1),
                                        x(p, {
                                          icon: ["fal", "chevron-down"],
                                          class: "smake:h-4.5 smake:duration-250 smake:group-data-[state=open]:rotate-180"
                                        })
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                x(l(D_), { class: "smake:overflow-hidden smake:data-[state=closed]:animate-collapsibleClosed smake:data-[state=open]:animate-collapsibleOpen" }, {
                                  default: M(() => [
                                    z("div", Gx, [
                                      ($(!0), E(me, null, Ce(_.children, (y) => ($(), H(cc, {
                                        key: y.id,
                                        data: y,
                                        depth: 1
                                      }, {
                                        default: M(() => [
                                          Pe(j(y.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["data"]))), 128))
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["value"]))), 128))
                          ]),
                          _: 1
                        }),
                        d[5] || (d[5] = z("div", { class: "smake:-mt-4 smake:grow" }, null, -1)),
                        l(o).length > 0 ? ($(), E(me, { key: 0 }, [
                          z("div", Wx, [
                            ($(!0), E(me, null, Ce(l(o), (_) => ($(), H(Se, {
                              key: _.id,
                              size: "small",
                              type: "active",
                              text: _.name,
                              icon: {
                                type: ["fak", "circle-close"],
                                position: "after"
                              },
                              onClick: (y) => l(n).toggleCategory(_)
                            }, null, 8, ["text", "onClick"]))), 128))
                          ]),
                          d[4] || (d[4] = z("hr", { class: "smake:border smake:border-secondary-2" }, null, -1))
                        ], 64)) : Q("", !0),
                        z("div", Zx, [
                          l(o).length > 0 ? ($(), H(Se, {
                            key: 0,
                            type: "subordinate",
                            size: "small",
                            text: u.$t("clear_filters"),
                            onClick: d[0] || (d[0] = (_) => a.value = [])
                          }, null, 8, ["text"])) : Q("", !0),
                          x(Se, {
                            type: "primary",
                            size: "small",
                            text: u.$t("show_X_results", { count: l(i) }),
                            onClick: d[1] || (d[1] = (_) => c.value = !1)
                          }, null, 8, ["text"])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"])) : Q("", !0);
    };
  }
}), Qx = { class: "smake:hidden smake:@sm:contents" }, Xx = { class: "smake:contents smake:@sm:hidden" }, Jx = /* @__PURE__ */ J({
  __name: "Categories",
  setup(e) {
    const { activeCategoryIds: t, categoriesTree: n } = L(Lo());
    return (o, a) => ($(), E(me, null, [
      z("div", Qx, [
        ($(!0), E(me, null, Ce(l(n), (s) => ($(), H(cc, {
          key: s.id,
          data: s
        }, null, 8, ["data"]))), 128)),
        l(t).length > 0 ? ($(), E(me, { key: 0 }, [
          a[1] || (a[1] = z("div", { class: "smake:h-11.5 smake:border smake:border-secondary-2" }, null, -1)),
          x(Se, {
            type: "subordinate",
            text: o.$t("clear_filters"),
            icon: {
              type: ["fak", "icon-x"]
            },
            onClick: a[0] || (a[0] = (s) => t.value = [])
          }, null, 8, ["text"])
        ], 64)) : Q("", !0)
      ]),
      z("div", Xx, [
        x(Kx)
      ])
    ], 64));
  }
}), Yx = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20$$$/GeneralStr/196=Adobe%20Illustrator%2027.6.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3csvg%20version='1.1'%20id='Ebene_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%2016%2016'%20style='enable-background:new%200%200%2016%2016;'%20xml:space='preserve'%3e%3cstyle%20type='text/css'%3e%20.st0{fill:%230F922E;}%20.st1{fill:%23FFCC00;}%20.st2{fill:%231E4583;}%20.st3{fill:%23E30613;}%20%3c/style%3e%3cg%20id='Gruppe_2314'%20transform='translate(-53%20-287.998)'%3e%3cpath%20id='Differenzmenge_8'%20class='st0'%20d='M61,304L61,304v-4c2.21,0,4-1.79,4-4h4C69,300.42,65.42,304,61,304z'/%3e%3cpath%20id='Differenzmenge_7'%20class='st1'%20d='M69,296h-4c0-2.21-1.79-4-4-4v-4C65.42,288.01,68.99,291.58,69,296z'/%3e%3cpath%20id='Differenzmenge_6'%20class='st2'%20d='M57,296h-4c0.01-4.42,3.58-7.99,8-8v4C58.79,292,57,293.79,57,296z'/%3e%3cpath%20id='Differenzmenge_5'%20class='st3'%20d='M61,304L61,304c-4.42,0-8-3.58-8-8h4c0,2.21,1.79,4,4,4V304z'/%3e%3c/g%3e%3c/svg%3e", e8 = { class: "smake:flex smake:h-full smake:flex-col smake:overflow-clip smake:rounded-3xl smake:border smake:border-secondary-2" }, t8 = { class: "smake:flex smake:grow smake:flex-col smake:items-center smake:gap-1 smake:p-3 smake:text-center" }, n8 = { class: "smake:text-xs smake:font-bold" }, o8 = { class: "smake:text-xs" }, a8 = { class: "smake:flex smake:items-center smake:gap-1 smake:text-xs" }, s8 = /* @__PURE__ */ J({
  __name: "Logo",
  props: {
    data: {}
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, { data: o } = we(n), a = t, { decimalFormat: s } = ri(), { locale: i } = dt();
    function r(_) {
      if (_ !== void 0)
        return s(_, i.value, 2);
    }
    const { appConfiguration: c, designerConfiguration: u } = L(
      st()
    ), d = S(
      () => {
        var _;
        return (_ = u.value) == null ? void 0 : _.settings.settings.units;
      }
    ), p = S(() => {
      var y;
      const _ = (y = c.value) == null ? void 0 : y.productionMethods.find(
        ({ id: k }) => k === o.value.production_method.id
      );
      if (_)
        return ac[_.handle];
    });
    return (_, y) => {
      var w;
      const k = De("FontAwesomeIcon");
      return $(), E("div", e8, [
        z("div", {
          class: "smake:relative smake:cursor-pointer smake:bg-secondary-3 smake:p-6",
          onClick: y[0] || (y[0] = (f) => a("select"))
        }, [
          p.value ? ($(), H(k, {
            key: 0,
            icon: p.value,
            "fixed-width": "",
            class: "smake:absolute smake:top-3 smake:left-3 smake:h-4"
          }, null, 8, ["icon"])) : Q("", !0),
          x(Yt, {
            src: l(o).preview_url ?? void 0,
            class: "smake:aspect-square smake:w-full smake:object-contain smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2"
          }, null, 8, ["src"])
        ]),
        z("div", t8, [
          z("span", n8, j(l(o).name), 1),
          y[3] || (y[3] = z("div", { class: "smake:-mt-1 smake:grow" }, null, -1)),
          z("span", o8, j(r(l(o).width ?? void 0)) + " x " + j(r(l(o).height ?? void 0)) + " " + j((w = d.value) == null ? void 0 : w.length), 1),
          z("div", a8, [
            y[2] || (y[2] = z("img", {
              src: Yx,
              class: "smake:h-4"
            }, null, -1)),
            Pe(" " + j(_.$t(
              l(o).color_assignments.length === 1 ? "mono_colored" : "multi_colored"
            )), 1)
          ]),
          x(Se, {
            "data-testid": "Select",
            type: "secondary",
            class: "smake:mt-2 smake:w-full",
            size: "small",
            text: _.$t("choose"),
            icon: {
              type: ["fal", "plus"]
            },
            onClick: y[1] || (y[1] = (f) => a("select"))
          }, null, 8, ["text"])
        ])
      ]);
    };
  }
}), i8 = { class: "smake:mt-4 smake:flex smake:items-center smake:gap-2 smake:border-y smake:border-secondary-2 smake:pr-2 smake:duration-150 smake:focus-within:border-black" }, r8 = ["placeholder"], l8 = /* @__PURE__ */ J({
  __name: "MobileSearch",
  setup(e) {
    const { mobileSearchElement: t, mobileSearchOpen: n, searchQuery: o } = L(Lo());
    return (a, s) => {
      const i = De("FontAwesomeIcon");
      return $(), E("div", {
        ref_key: "mobileSearchElement",
        ref: t,
        class: ye(["smake:-mt-4 smake:shrink-0 smake:overflow-hidden smake:duration-150 smake:@sm:hidden", { "smake:h-0": !l(n) }])
      }, [
        z("div", i8, [
          kt(z("input", {
            "onUpdate:modelValue": s[0] || (s[0] = (r) => Ft(o) ? o.value = r : null),
            type: "text",
            placeholder: a.$t("search_logo"),
            class: "smake:grow smake:py-2.5 smake:pl-2 smake:outline-hidden"
          }, null, 8, r8), [
            [zn, l(o)]
          ]),
          x(i, {
            icon: ["fal", "magnifying-glass"],
            class: "smake:h-4"
          })
        ])
      ], 2);
    };
  }
}), c8 = { class: "smake:hidden smake:shrink-0 smake:items-center smake:gap-2 smake:overflow-hidden smake:rounded-xl smake:border smake:border-secondary-2 smake:pr-2 smake:duration-150 smake:focus-within:border-black smake:@sm:flex" }, u8 = ["placeholder"], d8 = /* @__PURE__ */ J({
  __name: "Search",
  setup(e) {
    const { mobileSearchOpen: t, searchQuery: n } = L(Lo());
    return (o, a) => {
      const s = De("FontAwesomeIcon");
      return $(), E(me, null, [
        z("div", c8, [
          kt(z("input", {
            "onUpdate:modelValue": a[0] || (a[0] = (i) => Ft(n) ? n.value = i : null),
            type: "text",
            placeholder: o.$t("search_logo"),
            class: "smake:w-40 smake:py-2.5 smake:pl-2 smake:outline-hidden"
          }, null, 8, u8), [
            [zn, l(n)]
          ]),
          x(s, {
            icon: ["fal", "magnifying-glass"],
            class: "smake:h-4"
          })
        ]),
        x(ft, {
          size: "default",
          type: l(t) ? "active" : "subordinate",
          class: "smake:@sm:hidden",
          icon: {
            type: ["fal", "magnifying-glass"]
          },
          onClick: a[1] || (a[1] = (i) => t.value = !l(t))
        }, null, 8, ["type"])
      ], 64);
    };
  }
}), m8 = {
  "data-testid": "LogoSelection",
  class: "smake:absolute smake:inset-0 smake:top-16 smake:mx-auto smake:flex smake:w-320 smake:max-w-full smake:flex-col smake:gap-4 smake:rounded-3xl smake:rounded-b-none smake:bg-white smake:p-4 smake:@sm:inset-12 smake:@sm:max-w-[calc(100%-96px)] smake:@sm:rounded-b-3xl"
}, p8 = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, f8 = { class: "smake:flex smake:shrink-0 smake:flex-wrap smake:items-center smake:gap-2 smake:pt-1 smake:[overflow-wrap:normal]" }, h8 = { class: "smake:flex smake:grow smake:items-center smake:justify-end smake:gap-2" }, _8 = {
  key: 1,
  class: "smake:hidden smake:font-bold smake:@sm:block"
}, v8 = {
  key: 2,
  class: "smake:h-6 smake:w-16 smake:animate-pulse smake:rounded-full smake:bg-secondary-3"
}, g8 = { class: "smake:grid smake:grid-cols-auto-fill-38 smake:gap-4 smake:overflow-y-auto smake:@sm:grid-cols-auto-fill-45" }, ef = /* @__PURE__ */ J({
  __name: "LogoSelection",
  props: /* @__PURE__ */ Te({
    initialProductionMethodId: {},
    positioningArea: {},
    positioningAreaDesign: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Te(["closed", "resolve"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = t, o = Ue(e, "open"), a = e, { initialProductionMethodId: s, positioningArea: i, positioningAreaDesign: r } = we(a), { dialogsRoot: c } = L(Hn()), u = Lo(), {
      activeProductionMethodId: d,
      count: p,
      fetchStatus: _,
      hasNextPage: y,
      logos: k,
      status: w
    } = L(u);
    d.value = s.value;
    const f = S(() => !r.value);
    se(() => {
      o.value && u.resetFilters();
    });
    function g() {
      return w.value === "pending" ? !0 : y.value;
    }
    async function b() {
      w.value !== "pending" && await u.fetchNextPage();
    }
    const { placeDesign: A } = pi();
    async function P(I) {
      if (d.value === void 0) return;
      const D = Jl(I);
      await A(
        {
          design: D,
          productionMethodId: d.value
        },
        {
          mergePostioningAreaDesign: r.value,
          positioningArea: i.value
        }
      ) === "success" && (o.value = !1);
    }
    return (I, D) => ($(), H(l(rn), {
      open: o.value,
      "onUpdate:open": D[2] || (D[2] = (R) => o.value = R)
    }, {
      default: M(() => [
        x(l(ln), { to: l(c) }, {
          default: M(() => [
            x(Qe, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:opacity-0",
              onAfterLeave: D[0] || (D[0] = (R) => n("closed"))
            }, {
              default: M(() => [
                x(l(cn), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
              ]),
              _: 1
            }),
            x(Qe, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0"
            }, {
              default: M(() => [
                x(l(un), { "as-child": "" }, {
                  default: M(() => [
                    z("div", m8, [
                      z("div", p8, [
                        x(l(sn), { class: "smake:text-2xl smake:font-bold smake:uppercase" }, {
                          default: M(() => [
                            Pe(j(I.$t("icon_database")), 1)
                          ]),
                          _: 1
                        }),
                        x(l(Wt), { "as-child": "" }, {
                          default: M(() => [
                            x(ft, {
                              type: "subordinate",
                              icon: {
                                type: ["fak", "icon-x"]
                              }
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      x(l(N_), { class: "smake:hidden smake:@sm:block" }, {
                        default: M(() => [
                          Pe(j(I.$t("icon_database_description")), 1)
                        ]),
                        _: 1
                      }),
                      D[3] || (D[3] = z("hr", { class: "smake:hidden smake:border smake:border-secondary-2 smake:@sm:block" }, null, -1)),
                      z("div", f8, [
                        x(Jx),
                        x(d8),
                        z("div", h8, [
                          l(d) ? ($(), H(Wp, {
                            key: 0,
                            modelValue: l(d),
                            "onUpdate:modelValue": D[1] || (D[1] = (R) => Ft(d) ? d.value = R : null),
                            disabled: !f.value
                          }, null, 8, ["modelValue", "disabled"])) : Q("", !0),
                          l(p) !== void 0 ? ($(), E("span", _8, j(l(p) ?? 0) + " " + j(I.$t("icon", l(p) ?? 0)), 1)) : ($(), E("span", v8))
                        ])
                      ]),
                      x(l8),
                      kt(($(), E("div", g8, [
                        ($(!0), E(me, null, Ce(l(k), (R) => ($(), E("div", {
                          key: R.id
                        }, [
                          x(s8, {
                            "data-testid": `Logo-${R.id}`,
                            data: R,
                            onSelect: (U) => P(R)
                          }, null, 8, ["data-testid", "data", "onSelect"])
                        ]))), 128)),
                        ($(!0), E(me, null, Ce(l(_) === "fetching" ? 3 : 0, (R) => ($(), E("div", {
                          key: R,
                          class: "smake:h-80 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3"
                        }))), 128))
                      ])), [
                        [l(Ea), [
                          b,
                          { distance: 350, canLoadMore: g }
                        ]]
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["open"]));
  }
}), y8 = { class: "smake:flex smake:flex-col smake:gap-1" }, k8 = { class: "smake:flex smake:justify-between" }, b8 = { class: "smake:text-xs smake:font-semibold smake:uppercase" }, w8 = { class: "smake:overflow-hidden smake:rounded-full smake:border smake:border-secondary-2 smake:px-2 smake:text-xs smake:font-bold smake:duration-150 smake:focus-within:border-black" }, x8 = ["min", "max"], $8 = ["min", "max"], z8 = /* @__PURE__ */ J({
  __name: "OffsetInput",
  props: {
    child: {}
  },
  setup(e) {
    const t = e, { child: n } = we(t), o = Ws.anchor.offset, { designerConfiguration: a } = L(st()), s = S(
      () => {
        var d;
        return Oo[((d = a.value) == null ? void 0 : d.settings.settings.units.length) ?? "mm"] ?? 1;
      }
    ), i = S({
      get: () => {
        switch (n.value.anchor[0]) {
          case "b":
            return n.value.offset.y * s.value;
          case "l":
            return -n.value.offset.x * s.value;
          case "r":
            return n.value.offset.x * s.value;
          case "t":
            return -n.value.offset.y * s.value;
          default:
            return 0;
        }
      },
      set: (d) => {
        switch (n.value.anchor[0]) {
          case "b":
            n.value.offset.y = d / s.value;
            break;
          case "l":
            n.value.offset.x = -d / s.value;
            break;
          case "r":
            n.value.offset.x = d / s.value;
            break;
          case "t":
            n.value.offset.y = -d / s.value;
            break;
        }
      }
    }), r = N(), { inputValue: c, onBlur: u } = fi(i, r, {
      max: o.max,
      min: o.min,
      step: 1
    });
    return (d, p) => ($(), E("div", y8, [
      z("div", k8, [
        z("span", b8, j(d.$t("distance_motif_text")), 1),
        z("div", w8, [
          kt(z("input", {
            ref_key: "numberInput",
            ref: r,
            "onUpdate:modelValue": p[0] || (p[0] = (_) => Ft(c) ? c.value = _ : null),
            class: "smake:appearance-textfield smake:w-full smake:text-right smake:outline-hidden",
            type: "number",
            min: l(o).min,
            max: l(o).max,
            step: "1",
            onBlur: p[1] || (p[1] = //@ts-ignore
            (..._) => l(u) && l(u)(..._))
          }, null, 40, x8), [
            [zn, l(c)]
          ])
        ])
      ]),
      kt(z("input", {
        "onUpdate:modelValue": p[2] || (p[2] = (_) => i.value = _),
        class: "smake:my-1.5 smake:h-1 smake:w-full smake:appearance-none smake:rounded-full smake:bg-secondary-3 smake:[&::-webkit-slider-thumb]:h-4 smake:[&::-webkit-slider-thumb]:w-4 smake:[&::-webkit-slider-thumb]:cursor-ew-resize smake:[&::-webkit-slider-thumb]:appearance-none smake:[&::-webkit-slider-thumb]:rounded-full smake:[&::-webkit-slider-thumb]:border-2 smake:[&::-webkit-slider-thumb]:border-solid smake:[&::-webkit-slider-thumb]:border-black smake:[&::-webkit-slider-thumb]:bg-white smake:[&::-webkit-slider-thumb]:duration-150 smake:hover:[&::-webkit-slider-thumb]:bg-secondary-3",
        type: "range",
        min: l(o).min,
        max: l(o).max,
        step: "1"
      }, null, 8, $8), [
        [
          zn,
          i.value,
          void 0,
          { number: !0 }
        ]
      ])
    ]));
  }
}), S8 = { class: "smake:grid smake:grid-cols-[1fr_auto_1fr] smake:items-center smake:gap-x-2 smake:gap-y-1" }, C8 = { class: "smake:text-xs smake:font-semibold smake:uppercase" }, A8 = { class: "smake:text-xs smake:font-semibold smake:uppercase" }, P8 = /* @__PURE__ */ J({
  __name: "SizeInput",
  props: {
    bounds: {},
    disabled: { type: Boolean },
    ratio: {},
    size: {}
  },
  setup(e) {
    const t = e, { bounds: n, ratio: o, size: a } = we(t), s = S({
      get: () => a.value.width,
      set: (r) => {
        a.value.width = r, a.value.height = r / o.value;
      }
    }), i = S({
      get: () => a.value.height,
      set: (r) => {
        a.value.height = r, a.value.width = r * o.value;
      }
    });
    return (r, c) => {
      var d, p, _, y, k, w, f, g;
      const u = De("FontAwesomeIcon");
      return $(), E("div", S8, [
        z("span", C8, j(r.$t("width_abbreviation")), 1),
        c[2] || (c[2] = z("div", null, null, -1)),
        z("span", A8, j(r.$t("height_abbreviation")), 1),
        x($a, {
          modelValue: s.value,
          "onUpdate:modelValue": c[0] || (c[0] = (b) => s.value = b),
          min: (p = (d = l(n)) == null ? void 0 : d.min) == null ? void 0 : p.width,
          max: (y = (_ = l(n)) == null ? void 0 : _.max) == null ? void 0 : y.width,
          step: 0.1,
          disabled: e.disabled
        }, null, 8, ["modelValue", "min", "max", "disabled"]),
        x(u, {
          icon: ["fal", "link"],
          class: "smake:size-6 smake:text-secondary-1"
        }),
        x($a, {
          modelValue: i.value,
          "onUpdate:modelValue": c[1] || (c[1] = (b) => i.value = b),
          min: (w = (k = l(n)) == null ? void 0 : k.min) == null ? void 0 : w.height,
          max: (g = (f = l(n)) == null ? void 0 : f.max) == null ? void 0 : g.height,
          step: 0.1,
          disabled: e.disabled
        }, null, 8, ["modelValue", "min", "max", "disabled"])
      ]);
    };
  }
}), T8 = { class: "smake:flex smake:justify-between" }, M8 = { class: "smake:text-sm smake:font-bold smake:uppercase" }, I8 = {
  class: "smake:grid smake:grid-cols-[auto_1fr_1fr_1fr_auto] smake:place-items-center smake:gap-2",
  style: {
    gridTemplateAreas: '". tl tc tr .""lt preview preview preview rt""lc preview preview preview rc""lb preview preview preview rb"". bl bc br rotate"'
  }
}, E8 = ["value"], O8 = { class: "smake:group smake:size-8 smake:cursor-pointer smake:rounded-md smake:border smake:border-secondary-2 smake:p-1.5 smake:duration-150 smake:peer-checked:border-black smake:peer-checked:bg-black smake:peer-checked:text-white smake:peer-focus-visible:outline-2 smake:peer-focus-visible:outline-blue-700 smake:peer-not-checked:hover:bg-secondary-3 smake:peer-checked:hover:opacity-60" }, R8 = { class: "smake:flex smake:justify-center" }, L8 = { class: "smake:grid smake:w-full smake:grid-cols-2 smake:gap-4" }, j8 = { class: "smake:mt-4 smake:grid smake:grid-cols-2 smake:gap-4" }, D8 = /* @__PURE__ */ J({
  __name: "LogoComponent",
  props: {
    data: {}
  },
  setup(e) {
    const t = e, { data: n } = we(t), { t: o } = dt(), { positioningArea: a, positioningAreaDesign: s } = L(
      gn()
    ), { selectedProductionMethodId: i } = L(nt()), { data: r } = L(qt()), { open: c } = Bt(), { designerConfiguration: u } = L(st()), d = S(
      () => {
        var R;
        return Oo[((R = u.value) == null ? void 0 : R.settings.settings.units.length) ?? "mm"] ?? 1;
      }
    ), p = S(() => {
      if (a.value)
        return r.value.find(
          (R) => (
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            R.positioningAreas.includes(a.value)
          )
        );
    }), { isLight: _ } = ra(a, p), y = N(), k = Za(y, a), { data: w } = zt({
      ...re.logos.get.use(S(() => n.value.logoId)),
      retry: !1,
      staleTime: 1 / 0
    }), f = S(
      () => {
        var R;
        return o((R = w.value) != null && R.is_customer_logo ? "choose_logo" : "choose_icon");
      }
    );
    async function g() {
      var R;
      if (i.value !== void 0 && a.value !== void 0) {
        if ((R = w.value) != null && R.is_customer_logo) {
          await c(lc, {
            input: {
              initialProductionMethodId: i.value,
              positioningArea: a.value,
              positioningAreaDesign: s.value
            }
          });
          return;
        }
        await c(ef, {
          input: {
            initialProductionMethodId: i.value,
            positioningArea: a.value,
            positioningAreaDesign: s.value
          }
        });
      }
    }
    function b() {
      var R, U;
      if (a.value)
        if (((R = s.value) == null ? void 0 : R.design.type) === $e.ANCHOR) {
          const G = (U = s.value.design.children[0]) == null ? void 0 : U.value;
          if ((G == null ? void 0 : G.type) !== $e.TEXT)
            throw new Error(
              "Expected first child of anchor design to be text design"
            );
          s.value.design = G;
        } else
          a.value.designs = a.value.designs.filter(
            (G) => G !== s.value
          ), s.value = void 0;
    }
    function A() {
      s.value && (s.value.rotation = ci(
        s.value.rotation + 90
      ));
    }
    function P() {
      var F;
      if (((F = s.value) == null ? void 0 : F.design.type) !== $e.ANCHOR) return;
      const R = s.value.design.children[0], U = Math.max(
        Math.abs(R.offset.x),
        Math.abs(R.offset.y)
      ), G = R.anchor[0];
      R.offset = {
        x: G === "l" ? -U : G === "r" ? U : 0,
        y: G === "t" ? -U : G === "b" ? U : 0
      };
    }
    const I = S(() => w.value ? w.value.is_scaleable : !0), D = N(!1);
    return (R, U) => {
      const G = De("FontAwesomeIcon");
      return $(), H(ic, { "data-testid": "LogoComponent" }, {
        default: M(() => {
          var F, de, K, ce;
          return [
            z("div", T8, [
              z("h3", M8, j(R.$t("icon")), 1),
              x(ft, {
                icon: {
                  type: ["fak", "icon-remove"]
                },
                type: "secondary",
                onClick: b
              })
            ]),
            z("div", I8, [
              p.value && l(a) ? ($(), H(l(qa), {
                key: 0,
                class: "smake:aspect-square smake:w-full smake:rounded-md",
                style: { gridArea: "preview" }
              }, {
                default: M(() => [
                  x(l(Ga), {
                    data: p.value,
                    "initial-position": l(Ka)(
                      l(a),
                      10 / d.value
                    )
                  }, {
                    default: M(() => [
                      x(l(Ba), {
                        data: l(a),
                        "stroke-color": l(k) ? 16711680 : l(_) ? 4605510 : 14474460
                      }, {
                        default: M(() => [
                          l(s) ? ($(), H(l(Ha), {
                            key: 0,
                            data: l(s),
                            "onUpdate:boundingBox": U[0] || (U[0] = (ue) => y.value = ue)
                          }, null, 8, ["data"])) : Q("", !0)
                        ]),
                        _: 1
                      }, 8, ["data", "stroke-color"])
                    ]),
                    _: 1
                  }, 8, ["data", "initial-position"])
                ]),
                _: 1
              })) : Q("", !0),
              ((F = l(s)) == null ? void 0 : F.design.type) === l($e).ANCHOR ? ($(!0), E(me, { key: 1 }, Ce(l(Io), (ue) => ($(), E("label", {
                key: ue,
                style: Qt({ gridArea: ue })
              }, [
                kt(z("input", {
                  "onUpdate:modelValue": [
                    U[1] || (U[1] = (Ae) => l(s).design.children[0].anchor = Ae),
                    P
                  ],
                  class: "smake:peer smake:absolute smake:appearance-none",
                  type: "radio",
                  name: "outerAnchorPoint",
                  value: ue
                }, null, 8, E8), [
                  [
                    gs,
                    l(s).design.children[0].anchor
                  ]
                ]),
                z("div", O8, [
                  x(G, {
                    icon: ["fak", "icon-text-alignment"],
                    "fixed-width": "",
                    class: "smake:size-4.5 smake:group-peer-not-checked:hidden"
                  })
                ])
              ], 4))), 128)) : Q("", !0),
              z("button", {
                type: "button",
                class: ye(["smake:z-0 smake:rounded-md smake:bg-secondary-3 smake:p-1.75 smake:duration-150 smake:hover:bg-secondary-2", {
                  "smake:-mt-8 smake:-ml-8": ((de = l(s)) == null ? void 0 : de.design.type) !== l($e).ANCHOR
                }]),
                style: { gridArea: "rotate" },
                onClick: A
              }, [
                x(G, {
                  icon: ["fal", "rotate-right"],
                  class: "smake:size-4.5"
                })
              ], 2)
            ]),
            z("div", R8, [
              x(Se, {
                size: "small",
                text: f.value,
                type: "secondary",
                onClick: g
              }, null, 8, ["text"])
            ]),
            ((K = l(s)) == null ? void 0 : K.design.type) === l($e).ANCHOR ? ($(), H(z8, {
              key: 0,
              child: l(s).design.children[0]
            }, null, 8, ["child"])) : Q("", !0),
            x(l(V_), {
              open: D.value,
              "onUpdate:open": U[2] || (U[2] = (ue) => D.value = ue),
              class: "smake:flex smake:flex-col smake:items-center smake:gap-4"
            }, {
              default: M(() => [
                z("div", L8, [
                  ($(!0), E(me, null, Ce(l(n).colorAssignments.slice(0, 4), (ue, Ae) => {
                    var te;
                    return $(), E("div", {
                      key: ue.id,
                      class: "smake:flex smake:flex-col smake:gap-2"
                    }, [
                      Pe(j(R.$t("color")) + " " + j(Ae + 1) + " ", 1),
                      x(yl, {
                        modelValue: ue.color,
                        "onUpdate:modelValue": (X) => ue.color = X,
                        "show-name": "",
                        disabled: !(((te = l(w)) == null ? void 0 : te.is_editable) ?? !0),
                        "production-method-id": l(i)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "production-method-id"])
                    ]);
                  }), 128))
                ]),
                l(n).colorAssignments.length > 4 ? ($(), H(l(U_), {
                  key: 0,
                  class: "smake:-mt-4 smake:w-full smake:overflow-hidden smake:data-[state=closed]:animate-collapsibleClosed smake:data-[state=open]:animate-collapsibleOpen"
                }, {
                  default: M(() => [
                    z("div", j8, [
                      ($(!0), E(me, null, Ce(l(n).colorAssignments.slice(4), (ue, Ae) => {
                        var te;
                        return $(), E("div", {
                          key: ue.id,
                          class: "smake:flex smake:flex-col smake:gap-2"
                        }, [
                          Pe(j(R.$t("color")) + " " + j(Ae + 5) + " ", 1),
                          x(yl, {
                            modelValue: ue.color,
                            "onUpdate:modelValue": (X) => ue.color = X,
                            "show-name": "",
                            disabled: !(((te = l(w)) == null ? void 0 : te.is_editable) ?? !0),
                            "production-method-id": l(i)
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "production-method-id"])
                        ]);
                      }), 128))
                    ])
                  ]),
                  _: 1
                })) : Q("", !0),
                l(n).colorAssignments.length > 4 ? ($(), H(l(F_), {
                  key: 1,
                  "as-child": ""
                }, {
                  default: M(() => [
                    x(Se, {
                      text: D.value ? R.$t("fewer_colors") : R.$t("more_colors"),
                      icon: {
                        type: ["fal", "chevron-up"],
                        position: "after",
                        class: [
                          "smake:duration-250",
                          {
                            "smake:rotate-180": D.value
                          }
                        ]
                      },
                      type: "secondary",
                      size: "small"
                    }, null, 8, ["text", "icon"])
                  ]),
                  _: 1
                })) : Q("", !0)
              ]),
              _: 1
            }, 8, ["open"]),
            l(n).size ? ($(), H(P8, {
              key: 1,
              size: l(n).size,
              disabled: !I.value,
              ratio: (ce = l(w)) != null && ce.width && l(w).height ? l(w).width / l(w).height : l(n).size.width / l(n).size.height,
              bounds: l(w) ? {
                min: l(w).min_width && l(w).min_height ? {
                  width: l(w).min_width,
                  height: l(w).min_height
                } : void 0,
                max: l(w).max_width && l(w).max_height ? {
                  width: l(w).max_width,
                  height: l(w).max_height
                } : void 0
              } : void 0
            }, null, 8, ["size", "disabled", "ratio", "bounds"])) : Q("", !0)
          ];
        }),
        _: 1
      });
    };
  }
}), N8 = { class: "smake:text-sm smake:font-bold smake:uppercase" }, V8 = { class: "smake:relative" }, U8 = /* @__PURE__ */ J({
  __name: "Preview",
  setup(e) {
    const { positioningArea: t, positioningAreaDesign: n } = L(
      gn()
    ), { data: o } = L(qt()), { designerConfiguration: a } = L(st()), s = S(
      () => {
        var _;
        return Oo[((_ = a.value) == null ? void 0 : _.settings.settings.units.length) ?? "mm"] ?? 1;
      }
    ), i = ec(
      S(() => {
        var _;
        return (_ = n.value) == null ? void 0 : _.design;
      }),
      s
    ), r = S(() => {
      if (t.value)
        return o.value.find(
          (_) => (
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            _.positioningAreas.includes(t.value)
          )
        );
    }), { isLight: c } = ra(t, r), u = N(), d = Za(u, t);
    function p() {
      n.value && (n.value.rotation = ci(
        n.value.rotation + 90
      ));
    }
    return (_, y) => {
      const k = De("FontAwesomeIcon");
      return $(), H(ic, null, {
        default: M(() => [
          z("h3", N8, j(_.$t("preview")), 1),
          z("div", V8, [
            r.value && l(t) ? ($(), H(l(qa), {
              key: 0,
              class: "smake:aspect-square smake:w-full smake:rounded-md"
            }, {
              default: M(() => [
                x(l(Ga), {
                  data: r.value,
                  "initial-position": l(Ka)(
                    l(t),
                    10 / s.value
                  )
                }, {
                  default: M(() => [
                    x(l(Ba), {
                      data: l(t),
                      "stroke-color": l(d) ? 16711680 : l(c) ? 4605510 : 14474460
                    }, {
                      default: M(() => [
                        l(n) ? ($(), H(l(Ha), {
                          key: 0,
                          data: l(n),
                          placeholder: {
                            color: 13948116,
                            radius: 6 / s.value,
                            ...l(i)
                          },
                          "onUpdate:boundingBox": y[0] || (y[0] = (w) => u.value = w)
                        }, null, 8, ["data", "placeholder"])) : Q("", !0)
                      ]),
                      _: 1
                    }, 8, ["data", "stroke-color"])
                  ]),
                  _: 1
                }, 8, ["data", "initial-position"])
              ]),
              _: 1
            })) : Q("", !0),
            z("button", {
              type: "button",
              class: "smake:absolute smake:-right-2 smake:-bottom-2 smake:rounded-md smake:bg-secondary-3 smake:p-1.75 smake:duration-150 smake:hover:bg-secondary-2",
              onClick: p
            }, [
              x(k, {
                icon: ["fal", "rotate-right"],
                class: "smake:size-4.5"
              })
            ])
          ])
        ]),
        _: 1
      });
    };
  }
}), F8 = { class: "smake:font-bold" }, q8 = /* @__PURE__ */ J({
  __name: "SavedDesignSuccesfullyToast",
  props: /* @__PURE__ */ Te({
    name: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Te(["closed"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = t, o = Ue(e, "open");
    return (a, s) => {
      const i = De("I18nT");
      return $(), H(Np, {
        open: o.value,
        "onUpdate:open": s[0] || (s[0] = (r) => o.value = r),
        type: "success",
        onClosed: s[1] || (s[1] = (r) => n("closed"))
      }, {
        default: M(() => [
          x(i, {
            keypath: "saved_design_successfully",
            tag: "span"
          }, {
            name: M(() => [
              z("span", F8, j(e.name), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), B8 = { class: "smake:flex smake:justify-between" }, H8 = { class: "smake:text-lg smake:font-semibold" }, G8 = /* @__PURE__ */ J({
  __name: "SavePositioningAreaDesignButton",
  emits: ["saved"],
  setup(e, { emit: t }) {
    const n = t, { positioningArea: o, positioningAreaDesign: a } = L(
      gn()
    ), s = S(
      () => a.value ? Bs(a.value.design) : void 0
    ), { t: i } = dt(), r = N(!1), c = S(() => {
      var f;
      return (f = a.value) == null ? void 0 : f.design;
    });
    pt(
      c,
      () => {
        r.value = !1;
      },
      {
        deep: !0
      }
    );
    const u = S(
      () => s.value !== void 0 && o.value !== void 0
    ), d = S(
      () => u.value ? i("new_design") : i("new_customization")
    ), { open: p } = vn(), { isPending: _, mutate: y } = ct({
      ...re.designs.favored.post.use(),
      onError: () => {
        p(Ot, {
          input: {
            text: i("boot_error.unexpected"),
            type: "info"
          }
        });
      },
      onSuccess: (f) => {
        f.name && (p(q8, {
          input: {
            name: f.name
          }
        }), r.value = !0, n("saved"));
      }
    }), k = S(() => _.value || r.value);
    function w() {
      if (s.value === void 0 || o.value === void 0) return;
      const f = Qo({
        design: s.value,
        productionMethodId: o.value.productionMethodId
      });
      y({
        elements: [f],
        production_method: { id: o.value.productionMethodId }
      });
    }
    return (f, g) => ($(), E("div", B8, [
      z("h2", H8, j(d.value), 1),
      u.value ? ($(), H(Se, {
        key: 0,
        type: "subordinate",
        disabled: k.value,
        text: f.$t("save"),
        size: "small",
        icon: l(_) ? {
          type: ["fal", "spinner"],
          class: "smake:animate-spin"
        } : void 0,
        onClick: w
      }, null, 8, ["disabled", "text", "icon"])) : Q("", !0)
    ]));
  }
}), W8 = { class: "smake:flex smake:grow smake:flex-col smake:gap-4 smake:overflow-y-auto smake:bg-white smake:p-4 smake:@sm:rounded-lg" }, Z8 = {
  key: 6,
  class: "smake:flex smake:grow smake:flex-col smake:items-center smake:justify-end smake:gap-4 smake:text-secondary-1"
}, K8 = { class: "smake:flex smake:justify-center smake:gap-4 smake:px-4 smake:pb-4 smake:@sm:p-0" }, Q8 = /* @__PURE__ */ J({
  __name: "DesignEditDialog",
  setup(e) {
    const {
      open: t,
      positioningArea: n,
      positioningAreaDesign: o,
      positioningAreaDesignBackup: a
    } = L(gn()), { selectedPositioningAreaDesign: s } = L(On()), i = S(
      () => {
        var te;
        return (te = n.value) == null ? void 0 : te.productionMethodId;
      }
    ), { isCustomerLogoUploadEnabled: r } = Tt(i), c = S(() => {
      var te;
      return (te = o.value) == null ? void 0 : te.design;
    }), u = Wa(c), d = tc(c), { fetchStatus: p, normalizedDesign: _, size: y, status: k } = ui(
      S(() => {
        if (i.value !== void 0 && c.value !== void 0)
          return {
            design: c.value,
            productionMethodId: i.value
          };
      })
    ), { data: w } = L(qt()), f = S(
      () => w.value.find(
        (te) => (
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          te.positioningAreas.includes(n.value)
        )
      )
    ), g = Hp(), { open: b } = Bt(), { isLight: A } = ra(n, f), P = Gp(i, A), I = S(
      () => y.value && o.value ? Kl(
        y.value,
        { x: 0, y: 0 },
        o.value.rotation
      ) : void 0
    ), D = Za(I, n), R = re.logos.get.use(
      S(() => {
        var te;
        return (te = d.value) == null ? void 0 : te.logoId;
      })
    ), { data: U, status: G } = zt({
      ...R,
      enabled: S(
        () => R.enabled.value && !!d.value
      ),
      retry: !1,
      staleTime: 1 / 0
    });
    se(() => {
      !u.value || u.value.lines.length > 0 || ce();
    });
    async function F(te) {
      i.value !== void 0 && n.value !== void 0 && await b(lc, {
        input: {
          initialProductionMethodId: i.value,
          intialTab: te,
          positioningArea: n.value,
          positioningAreaDesign: o.value
        }
      });
    }
    async function de() {
      i.value !== void 0 && n.value !== void 0 && await b(ef, {
        input: {
          initialProductionMethodId: i.value,
          positioningArea: n.value,
          positioningAreaDesign: o.value
        }
      });
    }
    function K() {
      var X, ee;
      if (!n.value) return;
      const te = {
        lines: [P()],
        type: $e.TEXT
      };
      if (((X = o.value) == null ? void 0 : X.design.type) === $e.LOGO)
        o.value.design = {
          children: [
            U.value ? {
              anchor: U.value.design_settings.next_element_alignment.anchor_value,
              offset: {
                ...U.value.design_settings.next_element_alignment.offset
              },
              value: te
            } : {
              anchor: Io.BOTTOM_CENTER,
              offset: { x: 0, y: 5 },
              value: te
            }
          ],
          parent: o.value.design,
          type: $e.ANCHOR
        };
      else {
        const ie = {
          design: te,
          rotation: ((ee = g(n.value.id)) == null ? void 0 : ee.direction) ?? 0
        };
        n.value.designs.push(ie), o.value = ie, s.value = ie;
      }
    }
    function ce() {
      var te;
      n.value && (((te = o.value) == null ? void 0 : te.design.type) === $e.ANCHOR ? o.value.design = o.value.design.parent : (n.value.designs = n.value.designs.filter(
        (X) => X !== o.value
      ), o.value = void 0));
    }
    function ue() {
      n.value && (n.value.designs = n.value.designs.filter(
        (te) => te !== o.value
      ), a.value && n.value.designs.push(
        a.value
      )), s.value = void 0, t.value = !1;
    }
    function Ae() {
      o.value && _.value && (o.value.design = _.value), s.value = void 0, t.value = !1;
    }
    return (te, X) => {
      const ee = De("FontAwesomeIcon");
      return $(), H(Qe, {
        appear: "",
        "enter-active-class": "smake:duration-300 smake:ease-out",
        "enter-from-class": "smake:translate-x-full",
        "leave-active-class": "smake:duration-200 smake:ease-in smake:absolute smake:inset-y-0 smake:right-0",
        "leave-to-class": "smake:translate-x-full"
      }, {
        default: M(() => {
          var ie, he;
          return [
            l(n) ? ($(), E("div", {
              key: 0,
              "data-testid": "designEditDialog",
              class: ye(["smake:pointer-events-auto smake:flex smake:w-full smake:max-w-full smake:flex-col smake:gap-4 smake:bg-secondary-3 smake:shadow-[0_0_15px_0_rgba(0,0,0,.25)] smake:@sm:w-120 smake:@sm:p-4", { "smake:hidden": !l(t) }])
            }, [
              z("div", W8, [
                x(G8, {
                  onSaved: X[0] || (X[0] = (ve) => F("designs"))
                }),
                l(d) ? ($(), H(D8, {
                  key: 0,
                  data: l(d)
                }, null, 8, ["data"])) : l(_) ? ($(), H(U8, { key: 1 })) : Q("", !0),
                l(u) ? ($(), H(rc, {
                  key: 2,
                  "can-delete-all-lines": "",
                  deletable: "",
                  data: l(u),
                  "is-light": l(A),
                  "production-method-id": i.value,
                  onDelete: ce
                }, null, 8, ["data", "is-light", "production-method-id"])) : Q("", !0),
                x(jx, {
                  "positioning-area": l(n),
                  "positioning-area-design": l(o)
                }, null, 8, ["positioning-area", "positioning-area-design"]),
                !l(d) || l(G) === "pending" || !((ie = l(U)) != null && ie.is_customer_logo) ? ($(), H(zs, {
                  key: 3,
                  icon: ["fak", "icon-ciconfig-archive"],
                  text: te.$t("logos_and_designs"),
                  loading: l(d) && l(G) === "pending",
                  "data-testid": "AddCustomerLogoOrDesignButton",
                  onClick: X[1] || (X[1] = (ve) => F("customer-logos"))
                }, null, 8, ["text", "loading"])) : Q("", !0),
                !l(d) || l(G) === "pending" || (he = l(U)) != null && he.is_customer_logo ? ($(), H(zs, {
                  key: 4,
                  icon: ["fak", "icon-database"],
                  text: te.$t("icon_database"),
                  loading: l(d) && l(G) === "pending",
                  "data-testid": "AddLogoComponentButton",
                  onClick: de
                }, null, 8, ["text", "loading"])) : Q("", !0),
                l(u) ? Q("", !0) : ($(), H(zs, {
                  key: 5,
                  icon: ["fak", "text"],
                  text: te.$t("texts"),
                  "data-testid": "AddTextComponentButton",
                  onClick: K
                }, null, 8, ["text"])),
                l(r) ? Q("", !0) : ($(), E("div", Z8, [
                  x(ee, {
                    icon: ["fak", "icon-info"],
                    "fixed-width": "",
                    class: "smake:size-7"
                  }),
                  x(Jp, {
                    class: "smake:text-center smake:whitespace-pre-line",
                    "production-method-id": i.value
                  }, null, 8, ["production-method-id"])
                ]))
              ]),
              z("div", K8, [
                x(Se, {
                  type: "other",
                  text: te.$t("abort"),
                  icon: {
                    type: ["fal", "chevron-left"]
                  },
                  onClick: ue
                }, null, 8, ["text"]),
                x(Se, {
                  type: "primary",
                  "data-testid": "PlaceButton",
                  disabled: l(k) !== "success" || l(p) !== "idle" || l(_) === void 0 || l(D),
                  text: te.$t("place"),
                  onClick: Ae
                }, null, 8, ["disabled", "text"])
              ])
            ], 2)) : Q("", !0)
          ];
        }),
        _: 1
      });
    };
  }
});
function X8(e) {
  const { appConfiguration: t } = L(st()), n = S(
    () => {
      if (t.value)
        return t.value.fonts.map((c) => ({
          bounds: { max: c.max, min: c.min },
          fontId: c.id
        }));
    }
  ), o = tc(e), a = S(() => {
    var c;
    return (c = o.value) == null ? void 0 : c.logoId;
  }), s = re.logos.get.use(a), { data: i } = zt({
    ...s,
    enabled: S(
      () => s.enabled.value && !!a.value
    ),
    retry: !1,
    staleTime: 1 / 0
  }), r = S(() => {
    if (i.value)
      return {
        max: Math.min(
          i.value.max_width ?? 1 / 0,
          i.value.max_height ?? 1 / 0
        ),
        min: Math.max(
          i.value.min_width ?? 0,
          i.value.min_height ?? 0
        )
      };
  });
  return S(() => ({
    anchor: Ws.anchor,
    logo: { size: r.value },
    text: {
      ...Ws.text,
      size: n.value
    }
  }));
}
const J8 = Symbol("renderingFailedToast"), Y8 = /* @__PURE__ */ J({
  __name: "PositioningAreaDesign",
  props: /* @__PURE__ */ Te({
    data: {},
    productionMethodId: {}
  }, {
    invalidDesigns: {
      required: !0
    },
    invalidDesignsModifiers: {}
  }),
  emits: ["update:invalidDesigns"],
  setup(e) {
    const t = e, { data: n, productionMethodId: o } = we(t), a = Ue(e, "invalidDesigns"), { close: s, open: i } = vn(), { t: r } = dt(), { designerConfiguration: c } = L(st()), { hidePositioningAreas: u, selectedPositioningAreaDesign: d } = L(On()), {
      forceClose: p,
      open: _,
      positioningArea: y,
      positioningAreaDesign: k
    } = L(gn()), w = Bb(), f = S(() => n.value.design), { selectedProductionMethodId: g } = L(nt()), b = S(
      () => o.value === g.value
    ), A = S(
      () => {
        var Ie;
        return Oo[((Ie = c.value) == null ? void 0 : Ie.settings.settings.units.length) ?? "mm"] ?? 1;
      }
    ), P = ec(f, A), I = N(), D = N("idle"), R = N("pending");
    pt([D, R], ([Ie, ae]) => {
      Ie === "idle" && (ae === "success" ? I.value = to(n.value.design) : ae === "error" && (i(Ot, {
        id: J8,
        input: {
          text: r("error_pusher_rendering_failed"),
          type: "info"
        }
      }), I.value && (n.value.design = I.value)));
    });
    const U = N(), G = Za(U), F = Symbol("elemtOutsidePlacementAreaToast");
    se(() => {
      if (G.value) {
        i(Ot, {
          id: F,
          input: {
            text: r("element_outside_placement_area"),
            type: "error"
          }
        });
        return;
      }
      s(F);
    }), se((Ie) => {
      if (!G.value) return;
      const ae = n.value;
      a.value.push(ae), Ie(() => {
        a.value = a.value.filter(
          (_e) => _e !== ae
        );
      });
    });
    const de = N();
    Fb(n, de, {
      onMove: (Ie, ae) => {
        k.value === n.value && (y.value = ae);
      }
    });
    const K = N(!1);
    se((Ie) => {
      de.value && (p.value = !0, K.value = u.value, u.value = !1, Ie(() => {
        p.value = !1, u.value = K.value;
      }));
    });
    function ce(Ie, ae) {
      const _e = Y_({
        iconName: ae,
        prefix: Ie
      }).icon;
      return {
        height: _e[1],
        path: _e[4],
        width: _e[0]
      };
    }
    const ue = ce("fal", "arrow-rotate-right"), Ae = ce("fak", "icon-remove"), te = ce("fak", "resize"), { isSelectingPositioningArea: X } = L(
      Xt()
    );
    function ee() {
      d.value = n.value, p.value = !0, y.value = w.value, k.value = n.value;
    }
    const ie = tc(f), he = re.logos.get.use(
      S(() => {
        var Ie;
        return (Ie = ie.value) == null ? void 0 : Ie.logoId;
      })
    ), { data: ve } = zt({
      ...he,
      enabled: S(() => he.enabled.value && !!ie.value),
      retry: !1,
      staleTime: 1 / 0
    }), ze = S(() => R.value === "pending" ? !1 : ve.value ? ve.value.is_scaleable : !0), ot = X8(f);
    return (Ie, ae) => ($(), H(l(Ib), {
      disabled: !de.value && l(d) !== l(n)
    }, {
      default: M(() => [
        x(l($b), {
          disabled: !b.value || l(X) || l(_) && l(k) !== l(n),
          "onUpdate:point": ae[3] || (ae[3] = (_e) => de.value = _e),
          onPointerdown: ee
        }, {
          default: M(() => [
            x(l(Ha), {
              data: l(n),
              placeholder: {
                color: 13948116,
                radius: 6 / A.value,
                ...l(P)
              },
              "onUpdate:boundingBox": ae[0] || (ae[0] = (_e) => U.value = _e),
              "onUpdate:fetchStatus": ae[1] || (ae[1] = (_e) => D.value = _e),
              "onUpdate:status": ae[2] || (ae[2] = (_e) => R.value = _e)
            }, {
              default: M(() => [
                x(l(db), {
                  "rotate-icon": l(ue),
                  "delete-icon": l(Ae),
                  "resize-icon": l(te),
                  rotateable: "",
                  deleteable: "",
                  resizeable: ze.value,
                  "rotate-step": 90,
                  hidden: l(n) !== l(d),
                  "design-bounds": l(ot),
                  padding: 3 / A.value,
                  "rotation-control-length": 15 / A.value
                }, null, 8, ["rotate-icon", "delete-icon", "resize-icon", "resizeable", "hidden", "design-bounds", "padding", "rotation-control-length"])
              ]),
              _: 1
            }, 8, ["data", "placeholder"])
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["disabled"]));
  }
}), e5 = /* @__PURE__ */ J({
  __name: "PositioningArea",
  props: {
    data: {},
    isNearestPositioningArea: { type: Boolean }
  },
  setup(e) {
    const t = e, { data: n, isNearestPositioningArea: o } = we(t), {
      hidePositioningAreas: a,
      highlightEmptyPositioningAreas: s,
      selectedPositioningAreaDesign: i
    } = L(On()), { selectPositioningArea: r } = Xt(), { isSelectingPositioningArea: c } = L(
      Xt()
    ), { selectedProductionMethodId: u } = L(nt()), {
      open: d,
      positioningArea: p,
      positioningAreaDesign: _
    } = L(gn()), { isLight: y } = ra(n), k = N([]), w = S(
      () => n.value.productionMethodId !== u.value || !c.value && n.value.designs.length > 1 || c.value && n.value.designs.length > 0 || d.value && p.value !== n.value
    );
    function f(I) {
      if (I.stopPropagation(), i.value = void 0, c.value) {
        r(n.value);
        return;
      }
      if (p.value = n.value, n.value.designs.length === 1) {
        _.value = n.value.designs[0], i.value = n.value.designs[0];
        return;
      }
      _.value = void 0;
    }
    const g = S(() => [1, 1, 1, 0.5]), b = S(() => {
      if (A.value)
        return g.value;
    }), A = S(() => !!(o.value || s.value && P.value)), P = S(() => n.value.designs.length === 0);
    return (I, D) => ($(), H(l(Ba), {
      data: l(n),
      hidden: l(n).productionMethodId !== l(u) || l(a) || l(d) && l(p) !== l(n),
      "stroke-color": k.value.length > 0 ? 16711680 : l(y) ? 4605510 : 14474460,
      "fill-color": b.value,
      "event-mode": w.value ? "passive" : "static",
      cursor: "pointer",
      onPointerdown: f
    }, {
      default: M(() => [
        ($(!0), E(me, null, Ce(l(n).designs, (R) => ($(), H(Y8, {
          key: l(yt)(R),
          "invalid-designs": k.value,
          "onUpdate:invalidDesigns": D[0] || (D[0] = (U) => k.value = U),
          data: R,
          "production-method-id": l(n).productionMethodId
        }, null, 8, ["invalid-designs", "data", "production-method-id"]))), 128))
      ]),
      _: 1
    }, 8, ["data", "hidden", "stroke-color", "fill-color", "event-mode"]));
  }
}), t5 = /* @__PURE__ */ J({
  __name: "Designer",
  setup(e) {
    const { data: t, selectedViewIndex: n } = L(qt()), { designerCore: o, readOnlyZoom: a, selectedPositioningAreaDesign: s, stage: i } = L(On()), { designerConfiguration: r } = L(st()), c = S(
      () => {
        var _;
        return Oo[((_ = r.value) == null ? void 0 : _.settings.settings.units.length) ?? "mm"] ?? 1;
      }
    ), u = qb();
    function d() {
      s.value = void 0;
    }
    function p(_) {
      a.value = _;
    }
    return (_, y) => ($(), H(l(qa), {
      ref_key: "designerCore",
      ref: o,
      "clamp-zoom": { min: 1, max: 2.5 },
      draggable: "",
      stage: l(i),
      onClick: d,
      "onUpdate:zoom": p
    }, {
      default: M(() => [
        ($(!0), E(me, null, Ce(l(t), (k, w) => ($(), H(l(Ga), {
          key: l(yt)(k),
          data: k,
          hidden: w !== l(n),
          placeholder: { color: 15856113, radius: 6 / c.value }
        }, {
          default: M(() => [
            ($(!0), E(me, null, Ce(k.positioningAreas, (f) => ($(), H(e5, {
              key: l(yt)(f),
              data: f,
              "is-nearest-positioning-area": l(u).some(
                ({ positioningArea: g }) => g === f
              )
            }, null, 8, ["data", "is-nearest-positioning-area"]))), 128))
          ]),
          _: 2
        }, 1032, ["data", "hidden", "placeholder"]))), 128))
      ]),
      _: 1
    }, 8, ["stage"]));
  }
}), n5 = /* @__PURE__ */ J({
  __name: "Dialogs",
  setup(e) {
    const { dialogs: t, dialogsRoot: n, hideAllDialogs: o } = L(Hn()), { removeDialog: a } = Hn();
    function s(i, r) {
      r || i.resolve();
    }
    return (i, r) => kt(($(), E("div", {
      ref_key: "dialogsRoot",
      ref: n
    }, [
      ($(!0), E(me, null, Ce(l(t), (c) => ($(), H($l(c.component), Qs({
        key: l(yt)(c)
      }, { ref_for: !0 }, c.input, {
        open: c.open,
        "onUpdate:open": [(u) => c.open = u, (u) => s(c, u)],
        onClosed: (u) => l(a)(c),
        onResolve: c.resolve
      }), null, 16, ["open", "onUpdate:open", "onClosed", "onResolve"]))), 128))
    ], 512)), [
      [Ch, !l(o)]
    ]);
  }
}), o5 = rt("saveAndDownloadPdf", () => {
  const e = ut(), { open: t } = vn(), { t: n } = dt(), { data: o } = L(Jt()), a = S(() => !!i.value), s = mi(), i = S(() => {
    if (o.value && s.value.length !== 0)
      return {
        baseId: o.value.id,
        views: s.value
      };
  }), r = N(), { mutate: c } = ct({
    ...re.variants.pdf.postForDownload.use(),
    // TOdo add toast
    onError: (y) => {
      p.value = !1, t(Ot, {
        input: {
          text: n("boot_error.unexpected"),
          type: "info"
        }
      });
    },
    onMutate: () => p.value = !0,
    onSuccess(y) {
      r.value = y;
    }
  });
  function u() {
    i.value && c(i.value);
  }
  const d = on(
    (y) => e.fetchQuery({
      ...re.variants.pdf.getByVariantId.use(y),
      retry: !1,
      staleTime: 1 / 0
    })
  );
  Dp(
    "customVariant.customizationsCompletedForPDFDownload",
    async ({ id: y, name: k, id_hash: w }) => {
      if (r.value === y) {
        try {
          r.value = void 0, await _(y, `Design ID ${w} - ${k}.pdf`);
        } catch {
          t(Ot, {
            input: {
              text: n("boot_error.unexpected"),
              type: "info"
            }
          });
        }
        p.value = !1;
      }
    }
  );
  const p = N(!1);
  async function _(y, k) {
    const w = await d(y), f = URL.createObjectURL(w), g = document.createElement("a");
    g.href = f, g.download = k, g.click();
  }
  return {
    canDownload: a,
    download: u,
    isPending: p
  };
}), a5 = ["disabled"], s5 = { class: "smake:flex smake:aspect-square smake:h-16 smake:items-center smake:justify-center smake:gap-2 smake:rounded-full smake:border smake:border-secondary-2 smake:bg-white smake:p-2 smake:duration-150 smake:group-enabled:group-hover:border-black" }, i5 = { class: "smake:text-xs" }, r5 = /* @__PURE__ */ J({
  __name: "DownloadPdf",
  setup(e) {
    const t = o5(), { download: n } = t, { canDownload: o, isPending: a } = L(t), { selectedProductionMethodId: s } = L(nt()), i = S(
      () => !o.value || a.value || s.value === void 0
    );
    return (r, c) => {
      const u = De("FontAwesomeIcon");
      return $(), E("button", {
        type: "button",
        "data-testid": "DownloadPdf",
        class: "smake:group smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:gap-2 smake:disabled:opacity-50",
        disabled: i.value,
        onClick: c[0] || (c[0] = //@ts-ignore
        (...d) => l(n) && l(n)(...d))
      }, [
        z("div", s5, [
          l(a) ? ($(), H(u, {
            key: 0,
            class: "smake:h-7 smake:animate-spin",
            icon: ["fal", "spinner"]
          })) : ($(), H(u, {
            key: 1,
            icon: ["fak", "download"],
            "fixed-width": "",
            class: "smake:h-7"
          }))
        ]),
        z("div", i5, j(r.$t("pdf_download")), 1)
      ], 8, a5);
    };
  }
}), l5 = { key: 0 }, c5 = ["disabled"], u5 = { class: "smake:rounded-full smake:bg-secondary-3 smake:p-3" }, d5 = /* @__PURE__ */ J({
  __name: "FileUploadDialogButton",
  setup(e) {
    const { selectedProductionMethodId: t } = L(nt()), { isCustomerLogoUploadEnabled: n } = Tt(
      t
    ), { open: o } = Bt();
    return (a, s) => l(n) ? ($(), E("div", l5, [
      z("button", {
        "data-testid": "FileUploadDialogButton",
        type: "button",
        class: "smake:pointer-events-auto smake:flex smake:w-50 smake:flex-col smake:items-center smake:justify-center smake:gap-2 smake:rounded-2xl smake:border smake:border-secondary-2 smake:bg-white smake:p-3 smake:py-5 smake:text-sm smake:font-medium smake:duration-150 smake:hover:border-black smake:disabled:opacity-50",
        disabled: l(t) === void 0,
        onClick: s[0] || (s[0] = (i) => l(o)(Qa, {
          input: {
            productionMethodId: l(t)
          }
        }))
      }, [
        z("div", u5, [
          x(sc, { class: "smake:size-5" })
        ]),
        Pe(" " + j(a.$t("upload_file")), 1)
      ], 8, c5)
    ])) : Q("", !0);
  }
}), m5 = { key: 0 }, p5 = ["disabled"], f5 = { class: "smake:text-center smake:text-xs" }, h5 = /* @__PURE__ */ J({
  __name: "FileUploadDialogButtonMobile",
  setup(e) {
    const { selectedProductionMethodId: t } = L(nt()), { isCustomerLogoUploadEnabled: n } = Tt(
      t
    ), { open: o } = Bt();
    return (a, s) => l(n) ? ($(), E("div", m5, [
      z("button", {
        class: "smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:justify-center smake:gap-2",
        disabled: l(t) === void 0,
        onClick: s[0] || (s[0] = (i) => l(o)(Qa, {
          input: {
            productionMethodId: l(t)
          }
        }))
      }, [
        x(dn, {
          type: "secondary",
          disabled: l(t) === void 0,
          class: "smake:size-16 smake:rounded-full smake:p-2",
          "no-padding": ""
        }, {
          default: M(() => [
            x(Mo, {
              size: "big",
              type: ["fak", "upload"]
            })
          ]),
          _: 1
        }, 8, ["disabled"]),
        z("div", f5, j(a.$t("upload_file")), 1)
      ], 8, p5)
    ])) : Q("", !0);
  }
}), _5 = ["disabled"], v5 = {
  key: 0,
  class: "smake:text-xs"
}, Hr = /* @__PURE__ */ J({
  __name: "HidePositioningAreas",
  props: {
    hideLabel: { type: Boolean }
  },
  setup(e) {
    const { hidePositioningAreas: t } = L(On()), { isSelectingPositioningArea: n } = L(
      Xt()
    ), { selectedProductionMethodId: o } = L(nt());
    return (a, s) => {
      const i = De("FontAwesomeIcon");
      return $(), E("button", {
        "data-testid": "HidePositioningAreas",
        type: "button",
        class: "smake:group smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:gap-2 smake:disabled:opacity-50",
        disabled: l(n) || l(o) === void 0,
        onClick: s[0] || (s[0] = (r) => t.value = !l(t))
      }, [
        z("div", {
          class: ye(["smake:size-16 smake:rounded-full smake:border smake:border-secondary-1 smake:p-4 smake:duration-150 smake:group-enabled:group-hover:border-black smake:group-enabled:group-hover:bg-white", { "smake:bg-black": !l(t) }])
        }, [
          x(i, {
            class: ye(["smake:h-full smake:duration-150 smake:group-enabled:group-hover:text-black", { "smake:text-white": !l(t) }]),
            icon: ["fak", "icon-ciconfig-areaonoff"],
            "fixed-width": ""
          }, null, 8, ["class"])
        ], 2),
        e.hideLabel ? Q("", !0) : ($(), E("div", v5, j(l(t) ? a.$t("show_areas") : a.$t("hide_areas")), 1))
      ], 8, _5);
    };
  }
});
function kl(e) {
  const t = vt(e), { data: n, fetchNextPage: o, fetchStatus: a, hasNextPage: s, status: i } = Jo({
    ...re.favorites.variants.list.use(
      S(
        () => ({
          filter: {
            collection_name: t.value
          }
        })
      )
    ),
    retry: !1,
    select: (r) => r.pages.flatMap((c) => c.data),
    staleTime: 1 / 0
  });
  return {
    data: n,
    fetchNextPage: o,
    fetchStatus: a,
    hasNextPage: s,
    status: i
  };
}
const Zs = rt("cartVariantsStore", () => {
  const e = N(), t = re.variants.list.use(
    S(() => ({
      id: e.value
    }))
  ), { data: n, fetchNextPage: o, fetchStatus: a, hasNextPage: s, status: i } = Jo({
    ...t,
    enabled: S(
      () => {
        var c;
        return t.enabled.value && (((c = e.value) == null ? void 0 : c.length) ?? 0) > 0;
      }
    ),
    retry: !1,
    select: (c) => c.pages.flatMap((u) => u.data),
    staleTime: 1 / 0
  }), r = S(
    () => {
      var c;
      return (((c = e.value) == null ? void 0 : c.length) ?? 0) > 0 && i.value === "pending";
    }
  );
  return {
    cartItemIds: e,
    data: n,
    fetchNextPage: o,
    fetchStatus: a,
    hasNextPage: s,
    isPending: r,
    status: i
  };
}), bl = rt(
  "favoriteDesignCreateStatus",
  () => {
    const e = N(/* @__PURE__ */ new Set());
    function t(o) {
      e.value.add(o);
    }
    const n = S(
      () => e.value.size > 0
    );
    return At("favorite.rendered", ({ resource_id: o }) => {
      e.value.delete(o);
    }), {
      hasVariantsInRendering: n,
      waitForRendering: t
    };
  }
), uc = /* @__PURE__ */ J({
  __name: "CustomizationPreview",
  props: {
    data: {},
    size: { default: "default" }
  },
  setup(e) {
    return (t, n) => ($(), E("div", {
      class: ye(["smake:flex smake:items-center smake:justify-center smake:rounded-lg", {
        "smake:size-16 smake:@sm:size-20": e.size === "default",
        "smake:size-16 smake:@sm:size-25": e.size === "large"
      }]),
      style: Qt(`background-color: ${e.data.background_color}`)
    }, [
      e.data.design.preview_url ? ($(), H(Yt, {
        key: 0,
        src: e.data.design.preview_url,
        class: "smake:aspect-square smake:object-contain smake:p-2 smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2",
        style: Qt({
          rotate: `${e.data.rotation}deg`
        })
      }, null, 8, ["src", "style"])) : Q("", !0)
    ], 6));
  }
}), g5 = { class: "smake:aspect-square smake:h-4 smake:cursor-default smake:rounded-full smake:border smake:border-black smake:bg-white smake:outline-none smake:hover:bg-slate-50 smake:focus:shadow-black" }, y5 = { class: "smake:relative smake:h-full smake:w-full" }, k5 = { class: "smake:self-end" }, b5 = {
  key: 0,
  class: "smake:absolute smake:top-1 smake:right-1 smake:m-0.75 smake:flex smake:aspect-square smake:h-8 smake:items-center smake:justify-center smake:rounded-full smake:bg-secondary-3"
}, w5 = {
  key: 1,
  class: "smake:absolute smake:inset-0 smake:bg-secondary-1/50"
}, x5 = /* @__PURE__ */ J({
  __name: "PositioningAreaDesignPreviewRadio",
  props: {
    customization: {},
    disabled: { type: Boolean }
  },
  emits: ["showVariantDetails"],
  setup(e, { emit: t }) {
    const n = e, { customization: o } = we(n), a = S(
      () => o.value.positioningArea.production_method.id
    ), { icon: s } = Tt(a), i = S(
      () => Eo(o.value.design.elements[0])
    ), r = Wa(i), { allTextLinesSupported: c } = To(
      S(() => {
        var _;
        return (_ = r.value) == null ? void 0 : _.lines;
      }),
      a
    ), u = S(() => c.value === !1), d = t;
    function p() {
      d("showVariantDetails");
    }
    return (_, y) => {
      const k = De("FontAwesomeIcon");
      return $(), H(l(q_), {
        class: ye(["smake:relative smake:flex smake:justify-between smake:gap-2 smake:rounded-md smake:border smake:border-white smake:p-2 smake:@md:border-secondary-1", {
          "grayscale-[50%] smake:opacity-80": e.disabled,
          "smake:bg-white": !u.value,
          "smake:bg-danger/50": u.value
        }]),
        value: l(o).id.toString(),
        disabled: e.disabled
      }, {
        default: M(() => [
          z("div", g5, [
            x(l(B_), { class: "smake:relative smake:flex smake:size-full smake:items-center smake:justify-center smake:after:block smake:after:aspect-square smake:after:h-2 smake:after:rounded-[50%] smake:after:bg-black smake:after:content-['']" })
          ]),
          z("div", y5, [
            x(uc, {
              data: l(o),
              size: "large"
            }, null, 8, ["data"]),
            u.value ? ($(), H(k, {
              key: 0,
              class: "smake:absolute smake:top-1 smake:left-1 smake:h-4.5 smake:rounded-full smake:bg-danger smake:text-white smake:@md:top-2.5 smake:@md:left-2.5",
              icon: ["fal", "circle-exclamation"]
            })) : Q("", !0)
          ]),
          z("div", k5, [
            z("button", {
              type: "button",
              onClick: yo(p, ["stop"])
            }, [
              x(k, {
                class: ye(["smake:h-4 smake:text-secondary-1", {
                  "smake:text-secondary-1": !u.value,
                  "smake:text-white": u.value
                }]),
                icon: ["fal", "up-right-and-down-left-from-center"]
              }, null, 8, ["class"])
            ])
          ]),
          l(s) ? ($(), E("div", b5, [
            x(k, {
              "fixed-width": "",
              class: "smake:h-4",
              icon: l(s)
            }, null, 8, ["icon"])
          ])) : Q("", !0),
          e.disabled ? ($(), E("div", w5)) : Q("", !0)
        ]),
        _: 1
      }, 8, ["class", "value", "disabled"]);
    };
  }
}), $5 = { class: "smake:absolute smake:inset-x-0 smake:mx-auto smake:flex smake:max-w-150 smake:flex-col smake:gap-4 smake:overflow-y-auto smake:rounded-3xl smake:bg-white smake:p-6 smake:@max-md:bottom-0 smake:@max-md:max-h-[calc(100%-64px)] smake:@max-md:rounded-b-none smake:@md:top-1/2 smake:@md:max-h-[calc(100%-80px)] smake:@md:-translate-y-1/2" }, z5 = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, S5 = { class: "smake:uppercase" }, C5 = { class: "smake:font-bold" }, A5 = { class: "smake:relative smake:mt-3 smake:items-center smake:justify-between smake:bg-white" }, P5 = { class: "smake:mt-10 smake:w-full" }, T5 = { class: "smake:relative smake:flex" }, M5 = { class: "smake:absolute smake:top-0 smake:left-0 smake:flex smake:h-full smake:w-20 smake:items-center smake:justify-center" }, I5 = { class: "smake:absolute smake:top-0 smake:right-0 smake:flex smake:h-full smake:w-20 smake:items-center smake:justify-center" }, E5 = { key: 0 }, O5 = {
  key: 0,
  class: "smake:my-6 smake:border smake:border-t-1 smake:border-secondary-2"
}, R5 = { class: "smake:flex smake:flex-col" }, L5 = { class: "smake:text-[14px] smake:font-bold" }, j5 = {
  key: 0,
  class: "smake:text-[12px] smake:font-bold"
}, D5 = {
  key: 1,
  class: "smake:text-[12px] smake:font-bold"
}, N5 = { class: "smake:text-[12px] smake:text-secondary-2" }, V5 = { key: 0 }, U5 = /* @__PURE__ */ J({
  __name: "VariantPreviewDialog",
  props: /* @__PURE__ */ Te({
    initialViewIndex: {},
    variant: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Te(["closed"], ["update:open"]),
  setup(e, { emit: t }) {
    const { locale: n, t: o } = dt(), a = ri(), { rootElement: s } = L(Vt()), i = N(), { animateHeight: r } = cp(i), c = Ue(e, "open"), { appConfiguration: u, designerConfiguration: d } = L(
      st()
    );
    function p(F) {
      var de;
      return (de = u.value) == null ? void 0 : de.productionMethods.find(
        (K) => K.id === F
      );
    }
    const _ = e, { initialViewIndex: y, variant: k } = we(_), w = N(
      k.value.views[y.value] ? y.value : 0
    ), f = S(() => k.value.views[w.value]), g = S(
      () => {
        var F;
        return ((F = f.value) == null ? void 0 : F.customizations.length) ?? 0;
      }
    ), b = N(g.value > 0);
    pt(g, async () => {
      await r(() => b.value = g.value > 0);
    });
    function A() {
      if (w.value === k.value.views.length - 1) {
        w.value = 0;
        return;
      }
      if (w.value === 0) {
        w.value = 1;
        return;
      }
      w.value = w.value + 1;
    }
    function P() {
      if (w.value === 0) {
        w.value = k.value.views.length - 1;
        return;
      }
      w.value = w.value - 1;
    }
    const I = t;
    function D(F) {
      return a.decimalFormat(
        F.width * F.height,
        n.value
      );
    }
    const R = S(() => k.value.views.map((F) => "xl" in F.mockup_urls && F.mockup_urls.xl ? F.mockup_urls.xl : "md" in F.mockup_urls && F.mockup_urls.md ? F.mockup_urls.md : F.image_urls.xl));
    se(() => {
      c3(R.value);
    });
    const U = S(() => {
      if (f.value)
        return "xl" in f.value.mockup_urls && f.value.mockup_urls.xl ? f.value.mockup_urls.xl : "md" in f.value.mockup_urls && f.value.mockup_urls.md ? f.value.mockup_urls.md : f.value.image_urls.xl;
    }), G = S(() => {
      var F;
      return (F = d.value) == null ? void 0 : F.settings.settings.units;
    });
    return (F, de) => ($(), H(l(rn), {
      open: c.value,
      "onUpdate:open": de[1] || (de[1] = (K) => c.value = K)
    }, {
      default: M(() => [
        x(l(ln), { to: l(s) }, {
          default: M(() => [
            x(Qe, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:opacity-0",
              onAfterLeave: de[0] || (de[0] = (K) => I("closed"))
            }, {
              default: M(() => [
                x(l(cn), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
              ]),
              _: 1
            }),
            x(Qe, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0"
            }, {
              default: M(() => [
                x(l(un), { "as-child": "" }, {
                  default: M(() => [
                    z("div", $5, [
                      z("div", z5, [
                        x(l(sn), { class: "smake:text-xl" }, {
                          default: M(() => {
                            var K;
                            return [
                              z("div", S5, j(l(o)("views_preview_headlide")), 1),
                              z("div", C5, j((K = f.value) == null ? void 0 : K.display_name), 1)
                            ];
                          }),
                          _: 1
                        }),
                        x(l(Wt), { "as-child": "" }, {
                          default: M(() => [
                            x(ft, {
                              type: "subordinate",
                              icon: {
                                type: ["fak", "icon-x"]
                              }
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      z("div", A5, [
                        z("div", P5, [
                          z("div", T5, [
                            U.value !== void 0 ? ($(), H(Yt, {
                              key: 0,
                              src: U.value,
                              class: "smake:aspect-square smake:w-full smake:rounded-2xl smake:object-contain smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2"
                            }, null, 8, ["src"])) : Q("", !0),
                            z("div", M5, [
                              x(ft, {
                                type: "secondary",
                                size: "big",
                                icon: {
                                  type: ["fal", "chevron-left"]
                                },
                                onClick: P
                              })
                            ]),
                            z("div", I5, [
                              x(ft, {
                                type: "secondary",
                                size: "big",
                                icon: {
                                  type: ["fal", "chevron-right"]
                                },
                                onClick: A
                              })
                            ])
                          ]),
                          f.value ? ($(), E("div", E5, [
                            f.value.customizations.length > 0 ? ($(), E("hr", O5)) : Q("", !0),
                            z("div", {
                              ref_key: "customizationPreviews",
                              ref: i
                            }, [
                              z("div", {
                                class: ye(["smake:flex smake:flex-col smake:gap-5", {
                                  "smake:hidden": !b.value
                                }])
                              }, [
                                ($(!0), E(me, null, Ce(f.value.customizations, (K) => {
                                  var ce, ue, Ae;
                                  return $(), E("div", {
                                    key: K.id,
                                    class: "smake:flex smake:gap-4"
                                  }, [
                                    x(uc, { data: K }, null, 8, ["data"]),
                                    z("div", R5, [
                                      z("div", L5, j((ce = p(
                                        K.design.production_method.id
                                      )) == null ? void 0 : ce.display_name), 1),
                                      ($(!0), E(me, null, Ce(l(oc)(
                                        K.design.elements[0]
                                      ), (te) => ($(), E(me, {
                                        key: l(yt)(
                                          te
                                        )
                                      }, [
                                        te.resource_type === "logo" ? ($(), E("div", j5, j(l(o)(
                                          te.resource.is_customer_logo ? "logos" : "icon"
                                        )) + ": " + j(te.resource.name), 1)) : Q("", !0),
                                        te.resource_type === "text" ? ($(), E("div", D5, j(l(o)("texts")) + ": " + j(te.resource.lines.map(
                                          (X) => X.value
                                        ).join(" ")), 1)) : Q("", !0)
                                      ], 64))), 128)),
                                      z("div", N5, [
                                        Pe(j(D(
                                          K
                                        )) + " " + j((ue = G.value) == null ? void 0 : ue.length) + "² ", 1),
                                        (Ae = K.positioningArea) != null && Ae.positioning_area_identifier ? ($(), E("span", V5, " | " + j(K.positioningArea.positioning_area_identifier.name) + " (" + j(K.positioningArea.positioning_area_identifier.handle) + ") ", 1)) : Q("", !0)
                                      ])
                                    ])
                                  ]);
                                }), 128))
                              ], 2)
                            ], 512)
                          ])) : Q("", !0)
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["open"]));
  }
}), F5 = { class: "smake:flex smake:w-full smake:flex-col smake:items-center smake:gap-3 smake:rounded-3xl smake:bg-secondary-3 smake:p-5" }, q5 = { class: "smake:flex smake:w-full smake:items-start smake:justify-between" }, B5 = { class: "smake:flex smake:flex-col smake:items-center smake:justify-center smake:gap-2" }, H5 = { class: "smake:text-xs" }, G5 = { class: "smake:text-center smake:text-lg smake:font-bold" }, W5 = { class: "smake:size-10" }, Z5 = {
  key: 0,
  class: "smake:text-center smake:text-xs smake:text-danger"
}, K5 = {
  key: 0,
  class: "smake:flex smake:items-center smake:gap-2 smake:font-medium"
}, Q5 = { class: "smake:mt-3 smake:flex smake:grow smake:flex-col smake:items-center smake:justify-end smake:gap-4" }, tf = /* @__PURE__ */ J({
  __name: "VariantCard",
  props: {
    disableRepair: { type: Boolean },
    variant: {}
  },
  emits: ["repair", "startSelectingPositioningArea", "variantChanged"],
  setup(e, { emit: t }) {
    const n = e, { disableRepair: o, variant: a } = we(n), s = t, { t: i } = dt(), { open: r } = Bt(), c = Jt(), { variantId: u } = L(c), { availableProductionMethodIds: d } = L(
      nt()
    );
    function p(te) {
      r(U5, {
        input: { initialViewIndex: te, variant: a.value }
      });
    }
    const _ = S(
      () => a.value.views.map((te) => Yl(te))
    ), y = S(
      () => new Date(a.value.created_at).toLocaleDateString("de", {
        dateStyle: "medium"
      })
    ), k = S(
      () => _.value.flatMap(
        (te) => te.positioningAreas.flatMap(
          (X) => X.designs
        )
      )
    ), w = N(), f = S({
      get: () => {
        var te;
        return (te = g.value) == null ? void 0 : te.customization.id.toString();
      },
      set: (te) => w.value = te
    }), g = S(() => {
      var he;
      if (d.value === void 0) return;
      const te = a.value.views.flatMap((ve) => ve.customizations).filter(
        (ve) => {
          var ze;
          return (ze = d.value) == null ? void 0 : ze.has(
            ve.positioningArea.production_method.id
          );
        }
      ), X = te.find(
        (ve) => ve.id.toString() === w.value
      ) ?? te.at(0), ee = a.value.views.find(
        (ve) => ve.customizations.flatMap((ze) => ze.id).includes((X == null ? void 0 : X.id) ?? 0)
      );
      if (!X || !ee) return;
      const ie = (he = Ep(
        X.positioningArea,
        ee
      ).designs.at(0)) == null ? void 0 : he.design;
      if (ie)
        return {
          customization: X,
          design: ie
        };
    }), { placeDesign: b } = pi();
    async function A() {
      if (!g.value) return;
      await b({
        design: g.value.design,
        productionMethodId: g.value.customization.positioningArea.production_method.id
      }) === "aborted-positioning-area-selection" && r(hi);
    }
    const P = S(
      () => k.value.flatMap(
        (te) => {
          var X;
          return ((X = Bo(te.design)) == null ? void 0 : X.lines) ?? [];
        }
      )
    ), I = S(
      () => {
        var te;
        return (te = g.value) == null ? void 0 : te.customization.positioningArea.production_method.id;
      }
    ), { allTextLinesSupported: D } = To(P, I), R = S(() => {
      var te;
      return g.value ? ((te = Bo(g.value.design)) == null ? void 0 : te.lines) ?? [] : [];
    }), { allTextLinesSupported: U } = To(
      R,
      I
    ), { appConfiguration: G } = L(st()), F = S(() => {
      if (G.value)
        return a.value.views.flatMap((te) => te.customizations).some((te) => {
          var ee;
          const X = (ee = Bo(
            Eo(te.design.elements[0])
          )) == null ? void 0 : ee.lines;
          return X ? Hs(
            G.value,
            X,
            te.design.production_method.id
          ).length > 0 : !1;
        });
    }), de = S(
      () => U.value === !1
    );
    async function K() {
      u.value = a.value.id, await c.suspense(), s("variantChanged");
    }
    const { isSelectingPositioningArea: ce } = L(
      Xt()
    );
    se(() => {
      ce.value && s("startSelectingPositioningArea");
    });
    const ue = S(() => {
      const te = !g.value || de.value, X = F.value && o.value || !F.value ? "primary" : "other";
      return {
        disabled: te,
        type: X
      };
    }), Ae = S(() => {
      const te = F.value ? () => {
        s("repair");
      } : K, X = !!F.value && o.value, ee = F.value && !o.value ? i("update_article_with_designs") : i("archive_fetch_variant_with_customizations"), ie = ue.value.type === "primary" ? "other" : "primary";
      return {
        action: te,
        disabled: X,
        text: ee,
        type: ie
      };
    });
    return (te, X) => {
      const ee = De("FontAwesomeIcon");
      return $(), E("div", F5, [
        z("div", q5, [
          X[1] || (X[1] = z("div", { class: "smake:size-10" }, null, -1)),
          z("div", B5, [
            z("div", H5, j(y.value) + " | #" + j(l(a).id_hash), 1),
            z("div", G5, j(l(a).name), 1)
          ]),
          z("div", W5, [
            Et(te.$slots, "header-right")
          ])
        ]),
        x(l(H_), {
          modelValue: f.value,
          "onUpdate:modelValue": X[0] || (X[0] = (ie) => f.value = ie),
          class: "smake:flex smake:w-full smake:flex-wrap smake:justify-center smake:gap-4"
        }, {
          default: M(() => [
            ($(!0), E(me, null, Ce(l(a).views, (ie, he) => ($(), E(me, {
              key: l(yt)(ie)
            }, [
              ($(!0), E(me, null, Ce(ie.customizations, (ve) => {
                var ze;
                return $(), H(x5, {
                  key: ve.id,
                  customization: ve,
                  disabled: !((ze = l(d)) != null && ze.has(
                    ve.positioningArea.production_method.id
                  )),
                  onShowVariantDetails: (ot) => p(he)
                }, null, 8, ["customization", "disabled", "onShowVariantDetails"]);
              }), 128))
            ], 64))), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        F.value ? ($(), E("div", Z5, [
          l(D) === !1 ? ($(), E("div", K5, [
            x(ee, {
              class: "smake:h-6 smake:rounded-full smake:text-danger",
              icon: ["fak", "icon-ciconfig-alert-warning"],
              "fixed-width": ""
            }),
            Pe(" " + j(te.$t("at_least_one_motiv_is_not_available")), 1)
          ])) : Q("", !0)
        ])) : Q("", !0),
        z("div", Q5, [
          x(Se, {
            type: ue.value.type,
            size: "small",
            disabled: ue.value.disabled,
            text: te.$t("archive_fetch_selected_customization"),
            onClick: A
          }, null, 8, ["type", "disabled", "text"]),
          x(Se, {
            type: Ae.value.type,
            size: "small",
            disabled: Ae.value.disabled,
            text: Ae.value.text,
            onClick: Ae.value.action
          }, null, 8, ["type", "disabled", "text", "onClick"])
        ])
      ]);
    };
  }
}), X5 = { class: "smake:grid smake:grid-cols-auto-fill-80 smake:gap-4 smake:overflow-y-auto smake:@sm:grid-cols-auto-fill-97" }, J5 = /* @__PURE__ */ J({
  __name: "CartVariantsTabsContent",
  emits: ["startSelectingPositioningArea", "variantChanged"],
  setup(e, { emit: t }) {
    const n = t, { fetchNextPage: o } = Zs(), { data: a, fetchStatus: s, hasNextPage: i } = L(Zs());
    function r() {
      return s.value === "fetching" ? !0 : i.value;
    }
    async function c() {
      s.value !== "fetching" && await o();
    }
    return (u, d) => kt(($(), E("div", X5, [
      ($(!0), E(me, null, Ce(l(a), (p) => ($(), H(tf, {
        key: p.id,
        variant: p,
        "is-deletable": "",
        "disable-repair": "",
        onVariantChanged: d[0] || (d[0] = (_) => n("variantChanged")),
        onStartSelectingPositioningArea: d[1] || (d[1] = (_) => n("startSelectingPositioningArea"))
      }, null, 8, ["variant"]))), 128)),
      l(s) === "fetching" ? ($(), E(me, { key: 0 }, [
        d[2] || (d[2] = z("div", { class: "smake:h-96 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3 smake:px-5 smake:py-8" }, null, -1)),
        d[3] || (d[3] = z("div", { class: "smake:h-96 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3 smake:px-5 smake:py-8" }, null, -1))
      ], 64)) : Q("", !0)
    ])), [
      [l(Ea), [c, { distance: 350, canLoadMore: r }]]
    ]);
  }
}), Y5 = Symbol("renderingFailedToast"), vd = Symbol(
  "elementOutsidePlacementAreaToast"
), e$ = /* @__PURE__ */ J({
  __name: "Preview",
  props: {
    positioningArea: {},
    positioningAreaDesign: {},
    view: {}
  },
  emits: ["isInvalid", "isLight"],
  setup(e, { emit: t }) {
    const n = e, { positioningArea: o, positioningAreaDesign: a, view: s } = we(n), i = t, { t: r } = dt(), { close: c, open: u } = vn(), { designerConfiguration: d } = L(st()), p = S(
      () => {
        var b;
        return Oo[((b = d.value) == null ? void 0 : b.settings.settings.units.length) ?? "mm"] ?? 1;
      }
    ), { isLight: _ } = ra(o, s), y = N(), k = Za(y, o), w = ec(
      S(() => a.value.design),
      p
    ), f = N("idle"), g = N("pending");
    return pt([f, g], ([b, A]) => {
      A === "error" && b === "idle" && u(Ot, {
        id: Y5,
        input: {
          text: r("error_pusher_rendering_failed"),
          type: "info"
        }
      });
    }), se(() => {
      if (k.value) {
        u(Ot, {
          id: vd,
          input: {
            text: r("element_outside_placement_area"),
            type: "error"
          }
        });
        return;
      }
      c(vd);
    }), se(() => {
      i("isInvalid", k.value);
    }), se(() => {
      i("isLight", _.value);
    }), (b, A) => ($(), H(l(qa), null, {
      default: M(() => [
        x(l(Ga), {
          data: l(s),
          "initial-position": l(Ka)(
            l(o),
            10 / p.value
          )
        }, {
          default: M(() => [
            x(l(Ba), {
              data: l(o),
              "stroke-color": l(k) ? 16711680 : l(_) ? 4605510 : 14474460
            }, {
              default: M(() => [
                x(l(Ha), {
                  data: l(a),
                  placeholder: {
                    color: 13948116,
                    radius: 6 / p.value,
                    ...l(w)
                  },
                  "onUpdate:boundingBox": A[0] || (A[0] = (P) => y.value = P),
                  "onUpdate:fetchStatus": A[1] || (A[1] = (P) => f.value = P),
                  "onUpdate:status": A[2] || (A[2] = (P) => g.value = P)
                }, null, 8, ["data", "placeholder"])
              ]),
              _: 1
            }, 8, ["data", "stroke-color"])
          ]),
          _: 1
        }, 8, ["data", "initial-position"])
      ]),
      _: 1
    }));
  }
}), t$ = { class: "smake:flex smake:flex-col smake:gap-4 smake:@md:flex-row" }, n$ = { class: "smake:flex smake:flex-col smake:overflow-clip smake:rounded-xl smake:border smake:border-secondary-2 smake:@md:flex-1" }, o$ = { class: "smake:bg-secondary-3 smake:p-4 smake:text-sm" }, a$ = { class: "smake:font-bold smake:uppercase" }, s$ = {
  key: 0,
  class: "smake:m-4 smake:flex smake:grow smake:flex-col smake:items-center smake:justify-center smake:gap-4 smake:rounded-xl smake:bg-secondary-3 smake:p-4 smake:text-center smake:text-sm smake:text-danger"
}, i$ = {
  key: 1,
  class: "smake:grow smake:p-4"
}, r$ = /* @__PURE__ */ J({
  __name: "InvalidTextDesign",
  props: {
    name: {},
    index: {},
    length: {},
    positioningArea: {},
    positioningAreaDesign: {},
    textDesign: {},
    unsupportedTextLines: {},
    view: {}
  },
  emits: ["status"],
  setup(e, { emit: t }) {
    const n = e, { positioningArea: o, positioningAreaDesign: a, unsupportedTextLines: s } = we(n), i = t, r = N(!0), c = N(!1), { fetchStatus: u, status: d } = ui(
      S(() => ({
        design: a.value.design,
        productionMethodId: o.value.productionMethodId
      })),
      S(() => s.value.length === 0)
    ), p = S(() => u.value === "fetching" ? "pending" : s.value.length > 0 || c.value ? "error" : d.value);
    return se(() => {
      i("status", p.value);
    }), (_, y) => {
      var w, f;
      const k = De("FontAwesomeIcon");
      return $(), E("div", t$, [
        z("div", n$, [
          z("div", o$, [
            z("span", a$, j(_.$t("icon")) + " " + j(e.index + 1) + "/" + j(e.length) + ": ", 1),
            Pe(" " + j(e.name), 1)
          ]),
          l(s).length > 0 ? ($(), E("div", s$, [
            x(k, {
              icon: ["fak", "icon-ciconfig-alert-warning"],
              "fixed-width": "",
              class: "smake:size-7.5 smake:text-danger smake:@md:size-10"
            }),
            Pe(" " + j(_.$t("please_correct_the_highlighted_errors")), 1)
          ])) : ($(), E("div", i$, [
            x(e$, {
              class: "smake:size-full smake:rounded-xl",
              view: e.view,
              "positioning-area": l(o),
              "positioning-area-design": l(a),
              onIsInvalid: y[0] || (y[0] = (g) => c.value = g),
              onIsLight: y[1] || (y[1] = (g) => r.value = g)
            }, null, 8, ["view", "positioning-area", "positioning-area-design"])
          ]))
        ]),
        x(rc, {
          class: "smake:@md:flex-1",
          "is-light": r.value,
          data: e.textDesign,
          "production-method-id": l(o).productionMethodId,
          "initial-selected-line": (f = (w = l(s)) == null ? void 0 : w[0]) == null ? void 0 : f.textLine
        }, null, 8, ["is-light", "data", "production-method-id", "initial-selected-line"])
      ]);
    };
  }
}), l$ = { class: "smake:flex smake:grow smake:flex-col smake:gap-4 smake:overflow-y-auto" }, c$ = { class: "smake:text-sm" }, u$ = { class: "smake:flex smake:flex-col smake:justify-between smake:gap-4 smake:@max-md:justify-center smake:@sm:flex-row" }, d$ = {
  key: 2,
  class: "smake:flex smake:flex-col smake:gap-4 smake:@sm:flex-row"
}, m$ = /* @__PURE__ */ J({
  __name: "VariantRepairWizard",
  props: /* @__PURE__ */ Te({
    id: {},
    variant: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Te(["closed", "resolve"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = e, { id: o, variant: a } = we(n), s = t, i = Ue(e, "open"), { appConfiguration: r } = L(st()), { t: c } = dt(), { open: u } = vn(), d = N([]), p = N(0);
    se(() => {
      d.value = to(a.value.views), p.value = 0;
    });
    const _ = S(() => r.value ? a.value.views.flatMap(
      (R, U) => R.positioningAreas.flatMap(
        (G, F) => G.designs.map(
          (de, K) => {
            const ce = Bo(
              de.design
            );
            if (!(!ce || Hs(
              r.value,
              ce.lines,
              G.productionMethodId
            ).length === 0))
              return {
                positioningAreaDesignIndex: K,
                positioningAreaIndex: F,
                viewIndex: U
              };
          }
        )
      )
    ).filter(
      (R) => R !== void 0
    ) : []), y = S(() => r.value ? _.value.map(
      ({ positioningAreaDesignIndex: R, positioningAreaIndex: U, viewIndex: G }) => {
        const F = d.value[G], de = (
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          F.positioningAreas[U]
        ), K = (
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          de.designs[R]
        ), ce = Bo(K.design), ue = Hs(
          r.value,
          ce.lines,
          de.productionMethodId
        );
        return {
          positioningArea: de,
          positioningAreaDesign: K,
          textDesign: ce,
          unsupportedTextLines: ue,
          view: F
        };
      }
    ) : []), k = S(() => y.value[p.value]), w = N("pending"), { mutateAsync: f, status: g } = ct({
      ...Xb(),
      onError: () => {
        u(Ot, {
          input: {
            text: c("boot_error.unexpected"),
            type: "info"
          }
        });
      }
    }), b = N(!1);
    async function A(R) {
      b.value = !!R;
      const U = await f({
        favoriteVariantIdToDelete: o.value,
        favoriteVariantToCreate: {
          resource: {
            id: a.value.id,
            views: d.value.map((G) => Op(G))
          }
        }
      });
      s("resolve", { favoriteVariant: U, load: !!R }), i.value = !1;
    }
    const P = S(
      () => g.value === "pending" && !b.value
    ), I = S(
      () => g.value === "pending" && b.value
    ), D = S(
      () => w.value !== "success" || g.value === "pending"
    );
    return (R, U) => ($(), H(Ro, {
      open: i.value,
      "onUpdate:open": U[5] || (U[5] = (G) => i.value = G),
      title: R.$t("font_update"),
      "prevent-close": l(g) === "pending",
      onClosed: U[6] || (U[6] = (G) => s("closed"))
    }, {
      default: M(() => [
        z("div", l$, [
          z("div", c$, j(R.$t("font_update_explanation")), 1),
          k.value ? ($(), H(r$, {
            key: p.value,
            class: "smake:grow",
            index: p.value,
            length: y.value.length,
            name: l(a).name,
            view: k.value.view,
            "positioning-area": k.value.positioningArea,
            "positioning-area-design": k.value.positioningAreaDesign,
            "text-design": k.value.textDesign,
            "unsupported-text-lines": k.value.unsupportedTextLines,
            onStatus: U[0] || (U[0] = (G) => w.value = G)
          }, null, 8, ["index", "length", "name", "view", "positioning-area", "positioning-area-design", "text-design", "unsupported-text-lines"])) : Q("", !0)
        ]),
        z("div", u$, [
          p.value === 0 ? ($(), H(l(Wt), {
            key: 0,
            "as-child": ""
          }, {
            default: M(() => [
              x(Se, {
                class: "smake:@max-md:hidden",
                type: "secondary",
                text: R.$t("abort"),
                icon: {
                  type: ["fak", "icon-x"]
                },
                disabled: l(g) === "pending"
              }, null, 8, ["text", "disabled"])
            ]),
            _: 1
          })) : ($(), H(Se, {
            key: 1,
            type: "secondary",
            disabled: l(g) === "pending",
            icon: {
              type: ["fal", "chevron-left"]
            },
            text: R.$t("back"),
            onClick: U[1] || (U[1] = (G) => p.value -= 1)
          }, null, 8, ["disabled", "text"])),
          p.value + 1 === y.value.length ? ($(), E("div", d$, [
            x(Se, {
              type: "secondary",
              disabled: D.value,
              icon: {
                type: P.value ? ["fal", "spinner"] : ["fak", "icon-save"],
                class: {
                  "smake:animate-spin": P.value
                }
              },
              text: R.$t("save"),
              onClick: U[2] || (U[2] = (G) => A())
            }, null, 8, ["disabled", "icon", "text"]),
            x(Se, {
              type: "primary",
              icon: {
                type: ["fal", I.value ? "spinner" : "check"],
                class: {
                  "smake:animate-spin": I.value
                }
              },
              disabled: D.value,
              text: R.$t("save_and_load"),
              onClick: U[3] || (U[3] = (G) => A(!0))
            }, null, 8, ["icon", "disabled", "text"])
          ])) : ($(), H(Se, {
            key: 3,
            type: "primary",
            disabled: w.value !== "success",
            text: R.$t("next_motif"),
            icon: {
              type: ["fal", "chevron-right"],
              position: "after"
            },
            onClick: U[4] || (U[4] = (G) => p.value += 1)
          }, null, 8, ["disabled", "text"]))
        ])
      ]),
      _: 1
    }, 8, ["open", "title", "prevent-close"]));
  }
}), p$ = { class: "smake:absolute smake:top-1/2 smake:left-1/2 smake:mx-auto smake:flex smake:h-fit smake:max-h-full smake:w-auto smake:max-w-150 smake:-translate-x-1/2 smake:-translate-y-1/2 smake:flex-col smake:gap-6 smake:rounded-3xl smake:bg-white smake:p-4" }, f$ = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, h$ = { class: "smake:font-bold smake:text-primary-1" }, _$ = { class: "smake:relative smake:mt-3 smake:items-center smake:justify-between smake:bg-white" }, v$ = { class: "smake:flex smake:justify-center smake:gap-5" }, g$ = { class: "smake:flex smake:flex-wrap smake:justify-between smake:gap-5" }, y$ = /* @__PURE__ */ J({
  __name: "VariantDeleteDialog",
  props: /* @__PURE__ */ Te({
    apiVariant: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Te(["closed"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = Ue(e, "open"), o = t, { rootElement: a } = L(Vt()), s = e, { apiVariant: i } = we(s), { isPending: r, mutate: c } = ct(
      re.favorites.delete.use()
    );
    function u(d) {
      r.value && d.preventDefault();
    }
    return (d, p) => {
      const _ = De("I18nT");
      return $(), H(l(rn), {
        open: n.value,
        "onUpdate:open": p[2] || (p[2] = (y) => n.value = y)
      }, {
        default: M(() => [
          x(l(ln), { to: l(a) }, {
            default: M(() => [
              x(Qe, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0",
                onAfterLeave: p[0] || (p[0] = (y) => o("closed"))
              }, {
                default: M(() => [
                  x(l(cn), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              x(Qe, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:scale-95 smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:scale-95 smake:opacity-0"
              }, {
                default: M(() => [
                  x(l(un), {
                    "as-child": "",
                    onInteractOutside: u,
                    onEscapeKeyDown: u
                  }, {
                    default: M(() => [
                      z("div", p$, [
                        z("div", f$, [
                          x(l(sn), null, {
                            default: M(() => [
                              x(_, {
                                keypath: "are_you_sure_you_want_to_delete",
                                tag: "div"
                              }, {
                                deleteName: M(() => [
                                  z("span", h$, j(l(i).resource.name), 1)
                                ]),
                                default: M(() => [
                                  p[3] || (p[3] = Pe(" > ", -1))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          x(l(Wt), { "as-child": "" }, {
                            default: M(() => [
                              x(ft, {
                                type: "subordinate",
                                icon: {
                                  type: ["fak", "icon-x"]
                                }
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        z("div", _$, [
                          z("div", v$, [
                            ($(!0), E(me, null, Ce(l(i).resource.views, (y) => ($(), E(me, {
                              key: l(yt)(y)
                            }, [
                              ($(!0), E(me, null, Ce(y.customizations, (k) => ($(), H(uc, {
                                key: k.id,
                                data: k
                              }, null, 8, ["data"]))), 128))
                            ], 64))), 128))
                          ])
                        ]),
                        z("div", g$, [
                          x(l(Wt), { "as-child": "" }, {
                            default: M(() => [
                              x(Se, {
                                class: "smake:grow",
                                type: "subordinate",
                                size: "small",
                                text: d.$t("abort")
                              }, null, 8, ["text"])
                            ]),
                            _: 1
                          }),
                          x(Se, {
                            class: "smake:grow",
                            type: "primary",
                            size: "small",
                            disabled: l(r),
                            text: d.$t("delete"),
                            icon: {
                              type: ["fak", "icon-remove"]
                            },
                            onClick: p[1] || (p[1] = (y) => l(c)(l(i).id))
                          }, null, 8, ["disabled", "text"])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), k$ = /* @__PURE__ */ J({
  __name: "FavoriteVariantCard",
  props: {
    favoriteVariant: {}
  },
  emits: ["repair", "startSelectingPositioningArea", "variantChanged"],
  setup(e, { emit: t }) {
    const n = e, { favoriteVariant: o } = we(n), a = t;
    function s() {
      i(y$, {
        input: { apiVariant: o.value }
      });
    }
    const { open: i } = Bt();
    return (r, c) => ($(), H(tf, {
      variant: l(o).resource,
      onVariantChanged: c[0] || (c[0] = (u) => a("variantChanged")),
      onStartSelectingPositioningArea: c[1] || (c[1] = (u) => a("startSelectingPositioningArea")),
      onRepair: c[2] || (c[2] = (u) => a("repair"))
    }, {
      "header-right": M(() => [
        x(ft, {
          type: "other",
          icon: {
            type: ["fak", "icon-remove"]
          },
          onClick: s
        })
      ]),
      _: 1
    }, 8, ["variant"]));
  }
}), gd = /* @__PURE__ */ J({
  __name: "VariantCollectionTabsContent",
  props: {
    collectionName: {}
  },
  emits: ["startSelectingPositioningArea", "variantChanged"],
  setup(e, { emit: t }) {
    const n = e, { collectionName: o } = we(n), a = t, s = Xo(
      "favoriteVariantCardsContainer"
    ), { y: i } = Od(s, { behavior: "smooth" }), { data: r, fetchNextPage: c, fetchStatus: u, hasNextPage: d } = kl(o), { open: p } = Bt(), _ = Jt(), { variantId: y } = L(_);
    function k() {
      return u.value === "fetching" ? !0 : d.value;
    }
    async function w() {
      u.value !== "fetching" && await c();
    }
    async function f(g) {
      const b = await p(m$, {
        input: {
          id: g.id,
          variant: {
            id: g.resource.id,
            name: g.resource.name,
            views: g.resource.views.map(
              (A) => Yl(A)
            )
          }
        }
      });
      b !== void 0 && (i.value = 0), b != null && b.load && (y.value = b.favoriteVariant.resource.id, await _.suspense(), a("variantChanged"));
    }
    return (g, b) => kt(($(), E("div", {
      ref_key: "favoriteVariantCardsContainer",
      ref: s,
      class: "smake:grid smake:grid-cols-auto-fill-80 smake:gap-4 smake:overflow-y-auto smake:@sm:grid-cols-auto-fill-97"
    }, [
      ($(!0), E(me, null, Ce(l(r), (A) => ($(), H(k$, {
        key: A.id,
        "favorite-variant": A,
        "is-deletable": "",
        onVariantChanged: b[0] || (b[0] = (P) => a("variantChanged")),
        onStartSelectingPositioningArea: b[1] || (b[1] = (P) => a("startSelectingPositioningArea")),
        onRepair: (P) => f(A)
      }, null, 8, ["favorite-variant", "onRepair"]))), 128)),
      l(u) === "fetching" ? ($(), E(me, { key: 0 }, [
        b[2] || (b[2] = z("div", { class: "smake:h-96 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3 smake:px-5 smake:py-8" }, null, -1)),
        b[3] || (b[3] = z("div", { class: "smake:h-96 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3 smake:px-5 smake:py-8" }, null, -1))
      ], 64)) : Q("", !0)
    ])), [
      [l(Ea), [w, { distance: 350, canLoadMore: k }]]
    ]);
  }
}), b$ = { class: "smake:absolute smake:inset-0 smake:top-16 smake:mx-auto smake:flex smake:w-420 smake:max-w-full smake:flex-col smake:gap-4 smake:rounded-3xl smake:rounded-b-none smake:bg-white smake:p-4 smake:@sm:inset-12 smake:@sm:max-w-[calc(100%-96px)] smake:@sm:rounded-b-3xl" }, w$ = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, x$ = {
  key: 0,
  class: "smake:flex smake:gap-2"
}, $$ = {
  key: 0,
  class: "smake:mb-4 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3 smake:px-5 smake:py-8 smake:@md:bg-white"
}, hi = /* @__PURE__ */ J({
  __name: "VariantsDialog",
  props: /* @__PURE__ */ Te({
    defaultTab: { default: "customer-sketch" }
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Te(["closed"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = Ue(e, "open"), o = e, a = t, { defaultTab: s } = we(o), i = N(s.value), { rootElement: r } = L(Vt()), { t: c } = dt(), { data: u, isPending: d } = L(
      Zs()
    ), p = S(() => {
      var I;
      return (((I = u.value) == null ? void 0 : I.length) ?? 0) > 0;
    }), { data: _, status: y } = kl("merchant-sketch"), k = S(
      () => {
        var I;
        return (((I = _.value) == null ? void 0 : I.length) ?? 0) > 0;
      }
    ), { status: w } = kl("customer-sketch"), f = S(
      () => d.value || y.value === "pending" || w.value === "pending"
    );
    function g(I) {
      I.preventDefault();
      const D = I.target;
      !(D instanceof HTMLElement) || D.closest("[data-radix-popper-content-wrapper]");
    }
    function b() {
      n.value = !1;
    }
    function A() {
      n.value = !1;
    }
    const { hasVariantsInRendering: P } = L(
      bl()
    );
    return (I, D) => ($(), H(l(rn), {
      open: n.value,
      "onUpdate:open": D[2] || (D[2] = (R) => n.value = R)
    }, {
      default: M(() => [
        x(l(ln), { to: l(r) }, {
          default: M(() => [
            x(Qe, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:opacity-0",
              onAfterLeave: D[0] || (D[0] = (R) => a("closed"))
            }, {
              default: M(() => [
                x(l(cn), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
              ]),
              _: 1
            }),
            x(Qe, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0"
            }, {
              default: M(() => [
                x(l(un), {
                  "as-child": "",
                  onInteractOutside: g
                }, {
                  default: M(() => [
                    z("div", b$, [
                      z("div", w$, [
                        x(l(sn), { class: "smake:text-2xl smake:font-bold smake:uppercase" }, {
                          default: M(() => [
                            Pe(j(I.$t("my_customizations")), 1)
                          ]),
                          _: 1
                        }),
                        x(l(Wt), { "as-child": "" }, {
                          default: M(() => [
                            x(ft, {
                              type: "subordinate",
                              icon: {
                                type: ["fak", "icon-x"]
                              }
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      f.value ? ($(), E("div", x$, [
                        ($(), E(me, null, Ce(2, (R) => z("div", {
                          key: R,
                          class: "smake:h-10.75 smake:w-64 smake:max-w-1/2 smake:animate-pulse smake:rounded-full smake:bg-secondary-3"
                        })), 64))
                      ])) : Q("", !0),
                      x(l(Sl), {
                        modelValue: i.value,
                        "onUpdate:modelValue": D[1] || (D[1] = (R) => i.value = R),
                        class: "smake:flex smake:grow smake:flex-col smake:gap-4 smake:overflow-hidden"
                      }, {
                        default: M(() => [
                          [p.value, k.value].some(
                            (R) => R === !0
                          ) && !f.value ? ($(), H(l(Cl), {
                            key: 0,
                            class: "smake:flex smake:flex-wrap smake:gap-2"
                          }, {
                            default: M(() => [
                              p.value ? ($(), H(xa, {
                                key: 0,
                                value: "cart",
                                "selected-value": i.value
                              }, {
                                default: M(() => [
                                  Pe(j(I.$t("currently_in_cart")), 1)
                                ]),
                                _: 1
                              }, 8, ["selected-value"])) : Q("", !0),
                              x(xa, {
                                "selected-value": i.value,
                                value: "customer-sketch"
                              }, {
                                default: M(() => [
                                  Pe(j(I.$t("saved")), 1)
                                ]),
                                _: 1
                              }, 8, ["selected-value"]),
                              k.value ? ($(), H(xa, {
                                key: 1,
                                "selected-value": i.value,
                                value: "merchant-sketch"
                              }, {
                                default: M(() => [
                                  Pe(j(I.$t("sketches")), 1)
                                ]),
                                _: 1
                              }, 8, ["selected-value"])) : Q("", !0)
                            ]),
                            _: 1
                          })) : Q("", !0),
                          x(l(wa), {
                            "as-child": "",
                            value: "cart",
                            unmount: !1
                          }, {
                            default: M(() => [
                              x(J5, {
                                onVariantChanged: A,
                                onStartSelectingPositioningArea: b
                              }, null, 8, ["onStartSelectingPositioningArea"])
                            ]),
                            _: 1
                          }),
                          x(l(wa), {
                            value: "customer-sketch",
                            "as-child": "",
                            unmount: !1
                          }, {
                            default: M(() => [
                              l(P) ? ($(), E("div", $$, j(l(c)("archive_new_entry_soon_available")), 1)) : Q("", !0),
                              x(gd, {
                                "collection-name": "customer-sketch",
                                onVariantChanged: A,
                                onStartSelectingPositioningArea: b
                              }, null, 8, ["onStartSelectingPositioningArea"])
                            ]),
                            _: 1
                          }),
                          x(l(wa), {
                            value: "merchant-sketch",
                            "as-child": "",
                            unmount: !1
                          }, {
                            default: M(() => [
                              x(gd, {
                                "collection-name": "merchant-sketch",
                                onVariantChanged: A,
                                onStartSelectingPositioningArea: b
                              }, null, 8, ["onStartSelectingPositioningArea"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["open"]));
  }
}), z$ = { class: "smake:absolute smake:top-1/2 smake:left-1/2 smake:mx-auto smake:flex smake:h-fit smake:max-h-full smake:w-auto smake:max-w-120 smake:-translate-x-1/2 smake:-translate-y-1/2 smake:flex-col smake:gap-6 smake:rounded-3xl smake:bg-white smake:p-4" }, S$ = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, C$ = { class: "smake:@md:hidden" }, A$ = { class: "smake:hidden smake:@md:inline" }, P$ = /* @__PURE__ */ J({
  __name: "MerchantSketchVariantAddedDialog",
  props: {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  },
  emits: /* @__PURE__ */ Te(["closed"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = t, o = Ue(e, "open"), { rootElement: a } = L(Vt()), { open: s } = Bt();
    async function i() {
      o.value = !1, await s(hi, {
        input: { defaultTab: "merchant-sketch" },
        removeOnUnmount: !1
      });
    }
    return (r, c) => {
      const u = De("IconButton");
      return $(), H(l(rn), {
        open: o.value,
        "onUpdate:open": c[1] || (c[1] = (d) => o.value = d)
      }, {
        default: M(() => [
          x(l(ln), { to: l(a) }, {
            default: M(() => [
              x(Qe, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0",
                onAfterLeave: c[0] || (c[0] = (d) => n("closed"))
              }, {
                default: M(() => [
                  x(l(cn), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              x(Qe, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:scale-95 smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:scale-95 smake:opacity-0"
              }, {
                default: M(() => [
                  x(l(un), { "as-child": "" }, {
                    default: M(() => [
                      z("div", z$, [
                        z("div", S$, [
                          x(l(sn), { class: "smake:text-xl smake:font-bold" }, {
                            default: M(() => [
                              Pe(j(r.$t("new_sketch")), 1)
                            ]),
                            _: 1
                          }),
                          x(l(Wt), { "as-child": "" }, {
                            default: M(() => [
                              x(u, {
                                type: "subordinate",
                                icon: {
                                  type: ["fak", "icon-x"]
                                }
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        z("span", C$, j(r.$t("merchant_sketch_variant_added", {
                          buttonName: r.$t("archive")
                        })), 1),
                        z("span", A$, j(r.$t("merchant_sketch_variant_added", {
                          buttonName: r.$t("my_customizations")
                        })), 1),
                        x(Se, {
                          type: "primary",
                          text: r.$t("show_sketches"),
                          onClick: i
                        }, null, 8, ["text"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), Ia = rt(
  "productionMethodSelection",
  () => {
    const { availableProductionMethodIds: e, designsProductionMethodIds: t } = L(nt()), n = N(!1), o = N(!1), a = N(!1);
    se(() => {
      t.value !== void 0 && e.value !== void 0 && (n.value || (n.value = !0, e.value.size !== 1 && t.value.size !== 1 && (o.value = !0)));
    });
    const s = S(
      () => o.value || a.value
    );
    function i() {
      o.value = !1, a.value = !1;
    }
    return {
      closeAllProductionMethodSelections: i,
      isAProductionMethodSelectionOpen: s,
      isProductionMethodSelectionCompactOpen: a,
      isProductionMethodSelectionOpen: o
    };
  }
), T$ = { class: "smake:flex smake:grow smake:flex-col smake:items-center smake:justify-center smake:gap-0.5" }, M$ = { class: "smake:text-sm smake:font-bold" }, I$ = {
  key: 0,
  class: "smake:text-xs"
}, E$ = /* @__PURE__ */ J({
  __name: "SelectButton",
  props: {
    productionMethodId: {}
  },
  setup(e) {
    const t = e, { productionMethodId: n } = we(t), {
      isAvailableOnCurrentVariant: o,
      isSelected: a,
      productionMethod: s,
      shortDescription: i
    } = Tt(n);
    return (r, c) => l(s) ? ($(), H(dn, {
      key: 0,
      type: l(a) ? "active" : "subordinate",
      size: "big",
      "no-padding": "",
      class: ye(["smake:p-1", {
        "smake:text-slate-400 smake:grayscale-[98%]": !l(o)
      }]),
      disabled: !l(o)
    }, {
      default: M(() => [
        x(Yt, {
          src: l(s).preview_url,
          class: "smake:size-16 smake:rounded-full smake:object-cover smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2"
        }, null, 8, ["src"]),
        z("div", T$, [
          z("div", M$, j(l(s).display_name), 1),
          l(i) ? ($(), E("div", I$, j(l(i)), 1)) : Q("", !0)
        ]),
        c[0] || (c[0] = z("div", null, null, -1))
      ]),
      _: 1
    }, 8, ["type", "class", "disabled"])) : Q("", !0);
  }
}), O$ = { class: "smake:absolute smake:inset-x-0 smake:top-20 smake:mx-auto smake:flex smake:max-w-fit smake:flex-col smake:gap-6 smake:rounded-3xl smake:bg-white smake:p-4" }, R$ = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, L$ = { class: "smake:flex smake:flex-col smake:gap-4" }, j$ = /* @__PURE__ */ J({
  __name: "CompactDialog",
  setup(e) {
    const { rootElement: t } = L(Vt()), { activatedProductionMethodIds: n, selectedProductionMethodId: o } = L(nt()), {
      isProductionMethodSelectionCompactOpen: a,
      isProductionMethodSelectionOpen: s
    } = L(Ia());
    function i(u) {
      u.preventDefault();
      const d = u.target;
      !(d instanceof HTMLElement) || d.closest("[data-radix-popper-content-wrapper]");
    }
    function r() {
      a.value = !1, s.value = !0;
    }
    function c(u) {
      o.value = u, a.value = !1;
    }
    return (u, d) => ($(), H(l(rn), {
      open: l(a),
      "onUpdate:open": d[0] || (d[0] = (p) => Ft(a) ? a.value = p : null)
    }, {
      default: M(() => [
        x(l(ln), { to: l(t) }, {
          default: M(() => [
            x(Qe, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:opacity-0"
            }, {
              default: M(() => [
                x(l(cn), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
              ]),
              _: 1
            }),
            x(Qe, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:scale-95 smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:scale-98 smake:opacity-0 smake:-translate-y-5 "
            }, {
              default: M(() => [
                x(l(un), {
                  "as-child": "",
                  onInteractOutside: i
                }, {
                  default: M(() => [
                    z("div", O$, [
                      z("div", R$, [
                        x(l(sn), { class: "smake:text-xl smake:font-bold smake:tracking-wider smake:uppercase" }, {
                          default: M(() => [
                            Pe(j(u.$t("choose_production_method")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      z("div", L$, [
                        ($(!0), E(me, null, Ce(l(n), (p) => ($(), H(E$, {
                          key: p,
                          "production-method-id": p,
                          onClick: (_) => c(p)
                        }, null, 8, ["production-method-id", "onClick"]))), 128))
                      ]),
                      x(Se, {
                        type: "secondary",
                        text: u.$t("go_to_production_method_overview"),
                        icon: {
                          type: ["fal", "chevron-right"],
                          position: "after"
                        },
                        onClick: r
                      }, null, 8, ["text"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["open"]));
  }
}), D$ = { class: "smake:relative smake:flex smake:h-full smake:flex-col smake:overflow-clip smake:rounded-3xl" }, N$ = { class: "relative rounded-t-3xl bg-secondary-2" }, V$ = {
  key: 0,
  class: "smake:absolute smake:top-3 smake:left-3 smake:flex smake:size-10 smake:items-center smake:justify-center smake:rounded-full smake:bg-white smake:p-1"
}, U$ = { class: "smake:flex smake:grow smake:flex-col smake:items-center smake:gap-5 smake:bg-secondary-3 smake:p-4 smake:px-6 smake:text-center smake:[overflow-wrap:anywhere]" }, F$ = { class: "smake:mt-4 smake:text-xl smake:font-bold" }, q$ = { class: "smake:flex smake:min-h-24 smake:w-full smake:flex-col smake:items-start smake:justify-start smake:gap-2 smake:text-left smake:text-sm" }, B$ = { class: "smake:flex smake:items-center smake:gap-3" }, H$ = { class: "smake:flex smake:size-4 smake:items-center smake:justify-center smake:rounded-full smake:bg-white smake:text-xs smake:text-success" }, G$ = { class: "smake:flex smake:items-center smake:gap-3" }, W$ = { class: "smake:flex smake:size-4 smake:items-center smake:justify-center smake:rounded-full smake:bg-white smake:text-xs smake:text-success" }, Z$ = { class: "smake:flex smake:items-center smake:gap-3" }, K$ = { class: "smake:flex smake:size-4 smake:items-center smake:justify-center smake:rounded-full smake:bg-white smake:text-xs smake:text-success" }, Q$ = { class: "smake:mx-2 smake:flex smake:w-full smake:flex-col smake:divide-y smake:divide-secondary-2 smake:rounded-2xl smake:bg-white smake:px-4 smake:py-1 smake:text-sm" }, X$ = { class: "smake:grid smake:grid-cols-2 smake:items-center smake:py-3" }, J$ = { class: "smake:font-bold" }, Y$ = { class: "smake:grid smake:grid-cols-2 smake:items-center smake:py-3" }, e7 = { class: "smake:font-bold" }, t7 = { class: "smake:grid smake:grid-cols-2 smake:items-center smake:py-3" }, n7 = { class: "smake:font-bold" }, o7 = { class: "smake:grid smake:grid-cols-2 smake:items-center smake:py-3" }, a7 = { class: "smake:font-bold" }, s7 = {
  key: 0,
  class: "smake:flex smake:w-full smake:items-center smake:justify-center smake:rounded-b-3xl smake:bg-secondary-3 smake:p-6"
}, i7 = {
  key: 1,
  class: "smake:absolute smake:inset-0 smake:flex smake:items-center smake:justify-center smake:bg-gray-800/20"
}, r7 = { class: "text-center smake:mx-10 smake:rounded-3xl smake:bg-white smake:px-6 smake:py-3 smake:text-black smake:shadow" }, l7 = /* @__PURE__ */ J({
  __name: "SelectCard",
  props: {
    productionMethodId: {}
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = t, o = e, { productionMethodId: a } = we(o), { icon: s, isAvailableOnCurrentVariant: i, productionMethod: r } = Tt(a), { activatedProductionMethodIds: c } = L(
      nt()
    );
    return (u, d) => {
      var _;
      const p = De("FontAwesomeIcon");
      return l(r) ? ($(), E("div", {
        key: 0,
        class: ye({
          "smake:text-slate-400 smake:grayscale-[98%]": !l(i)
        })
      }, [
        z("div", D$, [
          z("div", N$, [
            x(Yt, {
              class: "smake:h-40 smake:w-full smake:object-cover smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2",
              src: l(r).preview_url
            }, null, 8, ["src"]),
            l(s) ? ($(), E("div", V$, [
              x(p, {
                class: "smake:size-6",
                icon: l(s),
                "fixed-width": ""
              }, null, 8, ["icon"])
            ])) : Q("", !0)
          ]),
          z("div", U$, [
            z("div", F$, j(l(r).display_name), 1),
            z("div", q$, [
              z("div", B$, [
                z("div", H$, [
                  x(p, {
                    class: "smake:size-4",
                    icon: ["fal", "check"]
                  })
                ]),
                z("div", null, j(u.$t(`${l(r).handle}_selling_point_1`)), 1)
              ]),
              z("div", G$, [
                z("div", W$, [
                  x(p, {
                    class: "smake:size-4",
                    icon: ["fal", "check"]
                  })
                ]),
                z("div", null, j(u.$t(`${l(r).handle}_selling_point_2`)), 1)
              ]),
              z("div", Z$, [
                z("div", K$, [
                  x(p, {
                    class: "smake:size-4",
                    icon: ["fal", "check"]
                  })
                ]),
                z("div", null, j(u.$t(`${l(r).handle}_selling_point_3`)), 1)
              ])
            ]),
            z("div", Q$, [
              z("div", X$, [
                z("div", J$, j(u.$t("look")), 1),
                z("div", null, j(u.$t(`${l(r).handle}_look`)), 1)
              ]),
              z("div", Y$, [
                z("div", e7, j(u.$t("washablility")), 1),
                z("div", null, j(u.$t(`${l(r).handle}_washability`)), 1)
              ]),
              z("div", t7, [
                z("div", n7, j(u.$t("minimum_quantity")), 1),
                z("div", null, j(u.$t("from_one_piece")), 1)
              ]),
              z("div", o7, [
                z("div", a7, j(u.$t("textiles")), 1),
                z("div", null, j(u.$t(`${l(r).handle}_textiles`)), 1)
              ])
            ])
          ]),
          (((_ = l(c)) == null ? void 0 : _.size) ?? 0) > 1 ? ($(), E("div", s7, [
            x(Se, {
              "data-testid": `selectProductionMethod-${l(a)}`,
              type: "primary",
              disabled: !l(i),
              text: u.$t("continue_with_x", {
                x: l(r).display_name
              }),
              onClick: d[0] || (d[0] = (y) => n("select"))
            }, null, 8, ["data-testid", "disabled", "text"])
          ])) : Q("", !0),
          l(i) ? Q("", !0) : ($(), E("div", i7, [
            z("div", r7, j(u.$t("production_method_not_available_for_variant")), 1)
          ]))
        ])
      ], 2)) : Q("", !0);
    };
  }
}), c7 = {
  "data-testid": "ProductionMethodSelectionExpandedDialog",
  class: "smake:absolute smake:inset-x-0 smake:top-20 smake:mx-auto smake:flex smake:max-h-[calc(100%-80px)] smake:w-md smake:max-w-full smake:flex-col smake:gap-4 smake:overflow-y-auto smake:rounded-3xl smake:bg-white smake:p-6 smake:@max-md:rounded-b-none"
}, u7 = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, d7 = /* @__PURE__ */ J({
  __name: "ExpandedDialog",
  setup(e) {
    const { rootElement: t } = L(Vt()), { activatedProductionMethodIds: n, selectedProductionMethodId: o } = L(nt()), { isProductionMethodSelectionOpen: a } = L(
      Ia()
    ), { closeAllProductionMethodSelections: s } = Ia();
    function i(c) {
      c.preventDefault();
      const u = c.target;
      !(u instanceof HTMLElement) || u.closest("[data-radix-popper-content-wrapper]");
    }
    function r(c) {
      o.value = c, s();
    }
    return (c, u) => ($(), H(l(rn), {
      open: l(a),
      "onUpdate:open": u[0] || (u[0] = (d) => Ft(a) ? a.value = d : null)
    }, {
      default: M(() => [
        x(l(ln), { to: l(t) }, {
          default: M(() => [
            x(Qe, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:opacity-0"
            }, {
              default: M(() => [
                x(l(cn), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
              ]),
              _: 1
            }),
            x(Qe, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:scale-95 smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:scale-98 smake:opacity-0 smake:-translate-y-5 "
            }, {
              default: M(() => [
                x(l(un), {
                  "as-child": "",
                  onInteractOutside: i
                }, {
                  default: M(() => {
                    var d;
                    return [
                      z("div", c7, [
                        z("div", u7, [
                          x(l(sn), { class: "smake:text-xl smake:font-bold smake:tracking-wider smake:uppercase" }, {
                            default: M(() => [
                              Pe(j(c.$t("choose_production_method")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        z("div", {
                          class: ye(["smake:flex smake:shrink-0 smake:gap-6 smake:bg-white smake:@max-md:flex-col smake:@md:overflow-x-auto", {
                            "smake:justify-center": ((d = l(n)) == null ? void 0 : d.size) === 1
                          }])
                        }, [
                          ($(!0), E(me, null, Ce(l(n), (p) => ($(), H(l7, {
                            key: p,
                            class: "smake:shrink-0 smake:@md:basis-[calc(50%-12px)]",
                            "production-method-id": p,
                            onSelect: (_) => r(p)
                          }, null, 8, ["production-method-id", "onSelect"]))), 128))
                        ], 2)
                      ])
                    ];
                  }),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["open"]));
  }
}), m7 = {
  key: 1,
  class: "smake:size-4 smake:animate-pulse smake:rounded-full smake:bg-secondary-2"
}, p7 = {
  key: 2,
  class: "smake:uppercase"
}, f7 = {
  key: 3,
  class: "smake:h-4 smake:w-30 smake:animate-pulse smake:rounded-lg smake:bg-secondary-2"
}, h7 = {
  key: 5,
  class: "smake:size-4 smake:animate-pulse smake:rounded-full smake:bg-secondary-2"
}, _7 = /* @__PURE__ */ J({
  __name: "ProductionMethodSelection",
  setup(e) {
    const { activatedProductionMethodIds: t, selectedProductionMethodId: n } = L(nt()), o = S(() => {
      var k;
      return (k = r.value) == null ? void 0 : k.productionMethods.find(
        ({ id: w }) => w === n.value
      );
    }), {
      isAProductionMethodSelectionOpen: a,
      isProductionMethodSelectionCompactOpen: s
    } = L(Ia()), { closeAllProductionMethodSelections: i } = Ia(), { appConfiguration: r, status: c } = L(st()), { icon: u, productionMethod: d } = Tt(
      n
    ), p = S(() => {
      var k;
      return ((k = t.value) == null ? void 0 : k.size) === 1 ? ["fak", "icon-info"] : a.value ? ["fal", "chevron-up"] : ["fal", "chevron-down"];
    }), _ = S(() => {
      var k;
      return (k = o.value) == null ? void 0 : k.display_name;
    });
    function y() {
      if (a.value) {
        i();
        return;
      }
      s.value = !0;
    }
    return (k, w) => ($(), E(me, null, [
      x(dn, {
        type: "subordinate",
        "data-testid": "ProductionMethodSelection",
        class: ye(["smake:pointer-events-auto smake:bg-white smake:@max-md:min-w-1/2", {
          "smake:z-10 smake:border-black": l(a)
        }]),
        onClick: y
      }, {
        default: M(() => [
          l(u) ? ($(), H(Mo, {
            key: 0,
            type: l(u)
          }, null, 8, ["type"])) : l(d) ? Q("", !0) : ($(), E("div", m7)),
          _.value ? ($(), E("span", p7, j(_.value), 1)) : ($(), E("span", f7)),
          l(c) !== "pending" ? ($(), H(Mo, {
            key: 4,
            type: p.value
          }, null, 8, ["type"])) : ($(), E("div", h7))
        ]),
        _: 1
      }, 8, ["class"]),
      x(d7),
      x(j$)
    ], 64));
  }
}), v7 = ["disabled"], g7 = { class: "smake:flex smake:aspect-square smake:h-16 smake:items-center smake:justify-center smake:gap-2 smake:rounded-full smake:border smake:border-secondary-2 smake:bg-white smake:p-2 smake:duration-150 smake:group-enabled:group-hover:border-black" }, y7 = {
  key: 0,
  class: "smake:text-xs"
}, yd = /* @__PURE__ */ J({
  __name: "SaveVariantAsFavorite",
  props: {
    hideLabel: { type: Boolean }
  },
  setup(e) {
    const { t } = dt(), { selectedProductionMethodId: n } = L(nt()), o = mi(), { data: a } = L(Jt()), s = S(() => {
      if (a.value && o.value.length !== 0)
        return {
          resource: {
            id: a.value.id,
            views: o.value
          }
        };
    });
    function i() {
      s.value && p(s.value);
    }
    const { open: r } = vn(), { waitForRendering: c } = bl(), { hasVariantsInRendering: u } = L(
      bl()
    ), { isPending: d, mutate: p } = ct({
      ...re.favorites.variants.post.use(),
      onError: () => {
        r(Ot, {
          input: {
            text: t("boot_error.unexpected"),
            type: "info"
          }
        });
      },
      onSuccess(k) {
        r(Ot, {
          input: {
            text: t("archived_variant_successfully"),
            type: "success"
          }
        }), c(k);
      }
    }), { isSelectingPositioningArea: _ } = L(
      Xt()
    ), y = S(() => d.value || !s.value || u.value || _.value || n.value === void 0);
    return (k, w) => {
      const f = De("FontAwesomeIcon");
      return $(), E("button", {
        type: "button",
        "data-testid": "SaveVariantAsFavorite",
        class: "smake:group smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:gap-2 smake:disabled:opacity-50",
        disabled: y.value,
        onClick: i
      }, [
        z("div", g7, [
          l(d) || l(u) ? ($(), H(f, {
            key: 0,
            class: "smake:h-7 smake:animate-spin",
            icon: ["fal", "spinner"]
          })) : ($(), H(f, {
            key: 1,
            icon: ["fak", "icon-save"],
            "fixed-width": "",
            class: "smake:h-7"
          }))
        ]),
        e.hideLabel ? Q("", !0) : ($(), E("div", y7, j(k.$t("save_variant")), 1))
      ], 8, v7);
    };
  }
}), k7 = { class: "smake:absolute smake:top-1/2 smake:left-1/2 smake:mx-auto smake:flex smake:h-fit smake:max-h-full smake:w-auto smake:max-w-150 smake:-translate-x-1/2 smake:-translate-y-1/2 smake:flex-col smake:gap-6 smake:rounded-3xl smake:bg-white smake:p-4.5 smake:@md:p-9" }, b7 = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, w7 = {
  key: 0,
  class: "smake:animate-pulse"
}, x7 = { key: 1 }, $7 = /* @__PURE__ */ J({
  __name: "SessionExpiredDialog",
  setup(e) {
    const { isSessionExpired: t } = L(Va()), { dialogsRoot: n } = L(Hn()), o = N(!0), { start: a, stop: s } = Vh(3e4, {
      callback: () => o.value = !1,
      controls: !0
    });
    function i() {
      o.value = !0, a();
    }
    return se(() => {
      t.value && i(), s();
    }), (r, c) => {
      const u = De("FontAwesomeIcon");
      return $(), H(l(rn), { open: l(t) }, {
        default: M(() => [
          x(l(ln), { to: l(n) }, {
            default: M(() => [
              x(Qe, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0"
              }, {
                default: M(() => [
                  x(l(cn), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              x(Qe, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:scale-95 smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:scale-95 smake:opacity-0"
              }, {
                default: M(() => [
                  x(l(un), {
                    "as-child": "",
                    onInteractOutside: c[0] || (c[0] = yo(() => {
                    }, ["prevent"])),
                    onEscapeKeyDown: c[1] || (c[1] = yo(() => {
                    }, ["prevent"]))
                  }, {
                    default: M(() => [
                      z("div", k7, [
                        z("div", b7, [
                          x(l(sn), { class: "smake:flex smake:items-center smake:gap-2 smake:text-xl smake:font-bold smake:uppercase" }, {
                            default: M(() => [
                              x(u, {
                                class: "smake:h-5 smake:text-danger",
                                icon: [
                                  "fak",
                                  "icon-ciconfig-alert-warning"
                                ],
                                "fixed-width": ""
                              }),
                              z("div", null, j(r.$t("session_expired")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        o.value ? ($(), E("div", w7, j(r.$t("trying_to_reconnect_session")), 1)) : ($(), E("div", x7, j(r.$t("session_expired_description")), 1))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), z7 = ["disabled"], S7 = { class: "smake:rounded-full smake:bg-primary-1 smake:p-3" }, C7 = /* @__PURE__ */ J({
  __name: "ShowEmptyPositioningAreas",
  setup(e) {
    const { cancelSelectingPositioningArea: t, waitForSelectingPositioningArea: n } = Xt(), { isSelectingPositioningArea: o } = L(
      Xt()
    ), { selectedProductionMethodId: a } = L(nt()), { positioningArea: s } = L(gn());
    async function i() {
      if (o.value) {
        t();
        return;
      }
      const c = await n();
      s.value = c.data;
    }
    const { hasAccess: r } = Na();
    return (c, u) => {
      const d = De("FontAwesomeIcon");
      return $(), E("button", {
        "data-testid": "ShowEmptyPositioningAreas",
        disabled: l(a) === void 0,
        type: "button",
        class: ye(["smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:justify-center smake:gap-2 smake:rounded-2xl smake:border smake:border-secondary-2 smake:bg-white smake:font-medium smake:duration-150 smake:hover:border-black smake:disabled:opacity-50", {
          "smake:w-50 smake:p-3 smake:py-5 smake:text-sm": l(r)(
            l(Ct).CUSTOMER_LOGO_UPLOAD
          ),
          "smake:size-40 smake:p-5 smake:text-xs": !l(r)(
            l(Ct).CUSTOMER_LOGO_UPLOAD
          )
        }]),
        onClick: u[0] || (u[0] = (p) => i())
      }, [
        z("div", S7, [
          x(d, {
            class: ye(["smake:size-5 smake:text-white smake:transition-all", { "smake:rotate-45": l(o) }]),
            icon: ["fal", "plus"]
          }, null, 8, ["class"])
        ]),
        z("div", null, j(l(o) ? c.$t("abort") : c.$t("new_customization")), 1)
      ], 10, z7);
    };
  }
}), A7 = ["disabled"], P7 = { class: "smake:rounded-full smake:bg-primary-2 smake:p-6 smake:text-white smake:enabled:group-hover:bg-primary-1" }, T7 = { class: "smake:text-xs smake:font-bold" }, M7 = /* @__PURE__ */ J({
  __name: "ShowEmptyPositioningAreasMobile",
  setup(e) {
    const { cancelSelectingPositioningArea: t, waitForSelectingPositioningArea: n } = Xt(), { isSelectingPositioningArea: o } = L(
      Xt()
    ), { selectedProductionMethodId: a } = L(nt()), { positioningArea: s } = L(gn());
    async function i() {
      if (o.value) {
        t();
        return;
      }
      const r = await n();
      s.value = r.data;
    }
    return (r, c) => {
      const u = De("FontAwesomeIcon");
      return $(), E("button", {
        class: "smake:group smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:gap-2 smake:disabled:opacity-50",
        disabled: l(a) === void 0,
        onClick: i
      }, [
        z("div", P7, [
          x(u, {
            class: ye(["smake:size-10 smake:transition-all", { "smake:rotate-45": l(o) }]),
            icon: ["fal", "plus"]
          }, null, 8, ["class"])
        ]),
        z("div", T7, j(l(o) ? r.$t("abort") : r.$t("new_customization")), 1)
      ], 8, A7);
    };
  }
}), I7 = /* @__PURE__ */ J({
  __name: "Stage",
  setup(e) {
    const { data: t, selectedViewIndex: n } = L(qt()), { stage: o } = L(On()), { showLayout: a } = L(Vt()), { open: s } = L(gn()), i = N(), r = N();
    function c() {
      const p = i.value;
      if (!p) return;
      const {
        offsetLeft: _,
        offsetParent: y,
        offsetTop: k
      } = p;
      y instanceof HTMLElement && (r.value = y);
      const { height: w, width: f } = p.getBoundingClientRect();
      o.value = { height: w, width: f, x: _, y: k };
    }
    Ac(i, c), Ac(r, c);
    function u() {
      n.value = (n.value + 1) % t.value.length;
    }
    function d() {
      n.value = (n.value - 1 + t.value.length) % t.value.length;
    }
    return (p, _) => ($(), E("div", {
      ref_key: "stageElement",
      ref: i,
      "data-testid": "stage",
      class: ye(
        l(qp)(
          "smake:relative smake:min-w-14",
          l(a) && "smake:mx-7",
          l(s) && "smake:absolute smake:inset-0 smake:@sm:relative"
        )
      )
    }, [
      x(ft, {
        type: "secondary",
        class: ye(["smake:pointer-events-auto smake:absolute smake:top-1/2 smake:left-0 smake:-translate-x-1/2 smake:-translate-y-1/2", { "smake:hidden": !l(a) }]),
        size: "big",
        icon: { type: ["fal", "chevron-left"] },
        onClick: d
      }, null, 8, ["class"]),
      x(ft, {
        type: "secondary",
        size: "big",
        class: ye(["smake:pointer-events-auto smake:absolute smake:top-1/2 smake:right-0 smake:translate-x-1/2 smake:-translate-y-1/2", { "smake:hidden": !l(a) }]),
        icon: { type: ["fal", "chevron-right"] },
        onClick: u
      }, null, 8, ["class"])
    ], 2));
  }
}), E7 = /* @__PURE__ */ J({
  __name: "Toasts",
  setup(e) {
    const { toasts: t } = L(Vp());
    function n(o) {
      t.value = t.value.filter((a) => a !== o);
    }
    return (o, a) => ($(!0), E(me, null, Ce(l(t), (s) => ($(), H($l(s.component), Qs({
      key: l(yt)(s)
    }, { ref_for: !0 }, s.input, {
      open: s.open,
      "onUpdate:open": (i) => s.open = i,
      onClosed: (i) => n(s)
    }), null, 16, ["open", "onUpdate:open", "onClosed"]))), 128));
  }
}), O7 = ["disabled"], R7 = { class: "smake:rounded-full smake:bg-secondary-3 smake:p-3" }, L7 = /* @__PURE__ */ J({
  __name: "OpenVariantsDialog",
  setup(e) {
    const { isSelectingPositioningArea: t } = L(
      Xt()
    ), { selectedProductionMethodId: n } = L(nt()), { hasAccess: o } = Na(), { open: a } = Bt();
    async function s() {
      await a(hi);
    }
    return (i, r) => {
      const c = De("FontAwesomeIcon");
      return $(), E("button", {
        type: "button",
        "data-testid": "OpenVariantsDialog",
        class: ye(["smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:justify-center smake:gap-2 smake:rounded-2xl smake:border smake:border-secondary-2 smake:bg-white smake:font-medium smake:duration-150 smake:hover:border-black smake:disabled:opacity-50", {
          "smake:w-50 smake:p-3 smake:py-5 smake:text-sm": l(o)(
            l(Ct).CUSTOMER_LOGO_UPLOAD
          ),
          "smake:size-40 smake:p-3 smake:text-xs": !l(o)(
            l(Ct).CUSTOMER_LOGO_UPLOAD
          )
        }]),
        disabled: l(t) || l(n) === void 0,
        onClick: s
      }, [
        z("div", R7, [
          x(c, {
            class: "smake:h-5",
            icon: ["fak", "icon-ciconfig-archive"],
            "fixed-width": ""
          })
        ]),
        z("div", null, j(i.$t("my_customizations")), 1)
      ], 10, O7);
    };
  }
}), j7 = /* @__PURE__ */ J({
  __name: "OpenVariantsDialogMobile",
  setup(e) {
    const { selectedProductionMethodId: t } = L(nt()), { isSelectingPositioningArea: n } = L(
      Xt()
    ), { open: o } = Bt();
    async function a() {
      await o(hi);
    }
    return (s, i) => ($(), H(Se, {
      type: "subordinate",
      disabled: l(n) || l(t) === void 0,
      text: s.$t("archive"),
      icon: {
        type: ["fak", "icon-ciconfig-archive"]
      },
      onClick: a
    }, null, 8, ["disabled", "text"]));
  }
}), D7 = {
  key: 1,
  class: "smake:flex smake:justify-center"
}, N7 = { class: "smake:flex smake:border-t-2 smake:border-secondary-2" }, V7 = /* @__PURE__ */ J({
  __name: "ViewTabs",
  setup(e) {
    const { selectedViewIndex: t } = L(qt()), { data: n } = L(Jt());
    return (o, a) => {
      var s;
      return (s = l(n)) != null && s.views ? ($(), H(l(Sl), {
        key: 0,
        modelValue: l(t),
        "onUpdate:modelValue": a[0] || (a[0] = (i) => Ft(t) ? t.value = i : null),
        class: "smake:flex smake:justify-center"
      }, {
        default: M(() => [
          x(l(Cl), { class: "smake:relative smake:border-t-2 smake:border-secondary-2" }, {
            default: M(() => {
              var i;
              return [
                x(l(G_), { class: "smake:absolute smake:-top-0.5 smake:left-0 smake:h-0.5 smake:w-(--radix-tabs-indicator-size) smake:translate-x-(--radix-tabs-indicator-position) smake:bg-secondary-1 smake:transition-[width,transform] smake:duration-300" }),
                ($(!0), E(me, null, Ce((i = l(n)) == null ? void 0 : i.views, (r, c) => ($(), H(l(Kd), {
                  key: l(yt)(r),
                  class: "smake:pointer-events-auto smake:px-2 smake:py-1 smake:text-xs",
                  value: c
                }, {
                  default: M(() => [
                    Pe(j(r.display_name), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))), 128))
              ];
            }),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])) : ($(), E("div", D7, [
        z("div", N7, [
          ($(), E(me, null, Ce(4, (i) => z("div", {
            key: i,
            class: "smake:mx-2 smake:my-1 smake:h-4 smake:w-8 smake:rounded-full smake:bg-secondary-2 smake:text-xs"
          })), 64))
        ])
      ]));
    };
  }
}), U7 = { class: "smake:group smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:gap-2" }, F7 = { class: "smake:size-16 smake:rounded-full smake:border smake:border-secondary-2 smake:bg-white smake:p-4 smake:group-focus-within:hidden smake:group-hover:hidden" }, q7 = { class: "smake:absolute smake:size-px smake:flex-col smake:items-center smake:gap-2 smake:rounded-full smake:border smake:border-secondary-3 smake:bg-secondary-3 smake:p-4 smake:[clip-path:inset(50%)] smake:[clip:rect(0_0_0_0)] smake:group-focus-within:static smake:group-focus-within:flex smake:group-focus-within:h-auto smake:group-focus-within:w-16 smake:group-focus-within:[clip-path:none] smake:group-focus-within:[clip:auto] smake:group-hover:static smake:group-hover:flex smake:group-hover:h-auto smake:group-hover:w-16 smake:group-hover:[clip-path:none] smake:group-hover:[clip:auto]" }, B7 = { class: "smake:text-xs" }, Gr = 1, Wr = 2.5, H7 = /* @__PURE__ */ J({
  __name: "Zoom",
  setup(e) {
    const { zoom: t } = L(On()), n = S({
      get: () => [t.value],
      set: ([o]) => {
        t.value = o;
      }
    });
    return (o, a) => {
      const s = De("FontAwesomeIcon");
      return $(), E("div", U7, [
        z("div", F7, [
          x(s, {
            class: "smake:w-full",
            "fixed-width": "",
            icon: ["fak", "icon-zoom-in"]
          })
        ]),
        z("div", q7, [
          z("button", {
            type: "button",
            tabindex: "-1",
            onClick: a[0] || (a[0] = (i) => t.value = l(Ma)(l(t) + 0.1, Gr, Wr))
          }, [
            x(s, {
              class: "smake:w-full",
              "fixed-width": "",
              icon: ["fak", "icon-zoom-in"]
            })
          ]),
          x(l(W_), {
            modelValue: n.value,
            "onUpdate:modelValue": a[1] || (a[1] = (i) => n.value = i),
            class: "smake:relative smake:flex smake:h-50 smake:w-5 smake:touch-none smake:flex-col smake:items-center smake:select-none",
            max: Wr,
            min: Gr,
            step: 0.01,
            orientation: "vertical"
          }, {
            default: M(() => [
              x(l(Z_), { class: "smake:relative smake:w-1 smake:grow smake:rounded-full smake:bg-white" }),
              x(l(K_), {
                class: "smake:block smake:size-5 smake:rounded-full smake:bg-black smake:shadow-[0_2px_10px] smake:shadow-black smake:hover:bg-gray-800 smake:focus:shadow-[0_0_0_5px] smake:focus:shadow-slate-400 smake:focus:outline-hidden",
                "aria-label": o.$t("zoom")
              }, null, 8, ["aria-label"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          z("button", {
            type: "button",
            tabindex: "-1",
            onClick: a[2] || (a[2] = (i) => t.value = l(Ma)(l(t) - 0.1, Gr, Wr))
          }, [
            x(s, {
              class: "smake:w-full",
              "fixed-width": "",
              icon: ["fak", "icon-zoom-out"]
            })
          ])
        ]),
        z("div", B7, j(o.$t("zoom")), 1)
      ]);
    };
  }
});
function G7() {
  const { open: e } = vn(), { t } = dt(), { data: n } = L(qt()), { logoIdsToSuppresInfoToast: o } = L(Zp());
  At("customerLogo.deleted", ({ logo_id: a }) => {
    let s = !1;
    for (const i of n.value)
      for (const r of i.positioningAreas)
        for (const c of r.designs) {
          const u = c.design;
          u.type === $e.LOGO && u.logoId === a && (r.designs = r.designs.filter(
            (d) => d !== c
          ), s = !0), u.type === $e.ANCHOR && u.parent.type === $e.LOGO && u.parent.logoId === a && (c.design = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          u.children[0].value, s = !0);
        }
    if (o.value.has(a)) {
      o.value.delete(a);
      return;
    }
    s && e(Ot, {
      input: { text: t("motif_deleted"), type: "info" }
    });
  });
}
function W7(e) {
  const {
    activeCategories: t,
    activeProductionMethodId: n,
    count: o,
    fetchStatus: a,
    fetchStatusCount: s,
    normalizedSearchQuery: i
  } = L(Lo()), r = S(
    () => t.value.map((u) => u.name)
  ), { productionMethod: c } = Tt(n);
  se(() => {
    a.value !== "fetching" && s.value !== "fetching" && (!i.value && r.value.length === 0 || c.value && o.value !== void 0 && e({
      categorieNames: r.value,
      productionMethodHandle: c.value.handle,
      query: i.value,
      resultCount: o.value
    }));
  });
}
function Z7(e) {
  const { data: t } = L(Jt()), n = mi(), { isADialogOpen: o } = L(Up());
  se(() => {
    if (o.value) {
      e();
      return;
    }
    if (!t.value) {
      e();
      return;
    }
    if (n.value.length === 0) {
      e();
      return;
    }
    e({
      id: t.value.id,
      views: n.value
    });
  });
}
function K7(e) {
  const t = {};
  for (const n in e) {
    const o = vt(e, n);
    t[n] = S(() => Q7(o.value));
  }
  return t;
}
function Q7(e) {
  if (typeof e != "string") return e;
  try {
    return JSON.parse(e);
  } catch {
    return e;
  }
}
const X7 = {
  id: "designer-strauss",
  "data-testid": "designer",
  class: "smake:@container smake:h-full smake:text-[16px] smake:[overflow-wrap:anywhere]"
}, J7 = { class: "smake:pointer-events-none smake:absolute smake:inset-0 smake:flex" }, Y7 = { class: "smake:flex smake:grow smake:flex-col" }, e9 = { class: "smake:flex smake:grow smake:justify-center" }, t9 = { class: "smake:flex smake:w-full smake:grow smake:flex-col smake:gap-4" }, n9 = { class: "smake:flex smake:w-full smake:grow smake:gap-4" }, o9 = { class: "smake:flex smake:grow smake:flex-col smake:gap-4" }, a9 = { class: "smake:flex smake:max-w-288 smake:grow smake:items-center smake:justify-center smake:gap-5 smake:@md:justify-end smake:@md:px-10" }, s9 = /* @__PURE__ */ J({
  __name: "App.ce",
  props: {
    apiBaseUrl: { type: String },
    apiToken: { type: String },
    availableVariants: { type: String },
    cartItemIds: { type: String },
    customerLogoUploadInfo: { type: String },
    debug: { type: String },
    featureFlagCustomerLogoDelete: { type: String },
    featureFlagCustomerLogoUpload: { type: String },
    locale: { type: String },
    pusherAppKey: { type: String },
    pusherChannelPrefix: { type: String },
    pusherCluster: { type: String },
    termsOfServiceLink: { type: String },
    uploadHelpLink: { type: String },
    userExternalIdentifier: { type: String },
    variantId: { type: [Number, String] }
  },
  emits: ["custom-variant-created", "search-statistics", "session-expired", "variant-changed"],
  setup(e, { emit: t }) {
    const n = t, o = e, {
      apiBaseUrl: a,
      apiToken: s,
      availableVariants: i,
      cartItemIds: r,
      customerLogoUploadInfo: c,
      debug: u,
      featureFlagCustomerLogoDelete: d,
      featureFlagCustomerLogoUpload: p,
      locale: _,
      pusherAppKey: y,
      pusherChannelPrefix: k,
      pusherCluster: w,
      termsOfServiceLink: f,
      uploadHelpLink: g,
      userExternalIdentifier: b,
      variantId: A
    } = K7(o), { locale: P } = dt(), { acceptLanguage: I, baseUrl: D } = L(Fl()), {
      initialToken: R,
      isSessionExpired: U,
      tokenData: G,
      userExternalIdentifier: F
    } = L(Va()), { variantId: de } = L(Jt()), {
      availableVariants: K,
      customerLogoUploadInfo: ce,
      termsOfServiceLink: ue,
      uploadHelpLink: Ae
    } = L(di()), { rootElement: te, showLayout: X } = L(Vt()), { cartItemIds: ee } = L(Zs()), { designerConfiguration: ie } = L(st()), { open: he } = Bt();
    se(() => {
      D.value = a.value, Nd("api-base-url", a.value);
    }), se(() => {
      const xe = _.value;
      I.value = xe, P.value = xe;
    }), se(() => {
      F.value = b.value;
    }), se(() => {
      R.value = s.value;
    }), se(() => {
      U.value && n("session-expired");
    }), se(() => {
      var xe;
      b_({ id: (xe = G.value) == null ? void 0 : xe.user_id });
    }), se(() => {
      de.value = A.value;
    }), se(() => {
      K.value = i.value;
    }), se(() => {
      ce.value = c.value;
    }), se(() => {
      ee.value = r.value;
    }), se(() => {
      ue.value = f.value;
    }), se(() => {
      Ae.value = g.value;
    });
    const { appKey: ve, channelPrefix: ze, cluster: ot } = L(Wl());
    se(() => {
      ve.value = y.value;
    }), se(() => {
      ot.value = w.value;
    }), se(() => {
      ze.value = k.value;
    }), B2((xe) => {
      console.error(xe);
    });
    const { onContinue: Ie } = L(Bp());
    Ie.value = (xe) => {
      n("custom-variant-created", xe);
    };
    const { giveAccessToFeature: ae, hasAccess: _e, removeAccessFromFeature: _t } = Na();
    se(() => {
      if (d.value === !0) {
        ae(Ct.CUSTOMER_LOGO_DELETE);
        return;
      }
      _t(Ct.CUSTOMER_LOGO_DELETE);
    }), se(() => {
      if (p.value === !0) {
        ae(Ct.CUSTOMER_LOGO_UPLOAD);
        return;
      }
      _t(Ct.CUSTOMER_LOGO_UPLOAD);
    }), W7((xe) => {
      n("search-statistics", {
        category_names: xe.categorieNames,
        production_method_handle: xe.productionMethodHandle,
        query: xe.query,
        result_count: xe.resultCount
      });
    });
    const { selectedProductionMethodId: St } = L(nt()), { isCustomerLogoUploadEnabled: et } = Tt(
      St
    );
    se(() => {
      u.value && console.debug(
        "%c Designer-Strauss Version: 5.7.4",
        "color: #93d50a"
      );
    }), Z7((xe) => {
      n("variant-changed", xe);
    });
    const Ne = S(
      () => {
        var xe;
        return ((xe = ie.value) == null ? void 0 : xe.settings.is_internal) ?? !1;
      }
    );
    return At("favorite.rendered", ({ collection_name: xe }) => {
      xe === "merchant-sketch" && he(P$);
    }), G7(), (xe, Fe) => ($(), H(l(Q_), { "swipe-direction": "up" }, {
      default: M(() => [
        z("div", X7, [
          z("div", {
            ref_key: "rootElement",
            ref: te,
            class: ye(["smake:relative smake:h-full smake:overflow-hidden", {
              "smake:min-h-160": !Ne.value,
              "smake:@md:min-h-193": !Ne.value,
              "smake:min-h-150": Ne.value,
              "smake:@md:min-h-183": !Ne.value
            }])
          }, [
            x(t5, { class: "smake:absolute smake:inset-0 smake:size-full" }),
            z("div", J7, [
              z("div", Y7, [
                z("div", e9, [
                  z("div", {
                    class: ye(["smake:flex smake:w-full smake:max-w-288", { "smake:m-6": l(X) }])
                  }, [
                    z("div", t9, [
                      z("div", {
                        class: ye(["smake:inset-x-0 smake:flex smake:w-full smake:justify-center", { "smake:hidden": !l(X) }])
                      }, [
                        x(_7),
                        x(l($s), {
                          name: l(Ct).CUSTOMER_LOGO_UPLOAD
                        }, {
                          default: M(() => [
                            l(et) ? ($(), H(Hr, {
                              key: 0,
                              "hide-label": "",
                              class: ye([{
                                "smake:block smake:@md:hidden": l(X),
                                "smake:hidden": !l(X)
                              }, "smake:absolute smake:top-21 smake:left-4"])
                            }, null, 8, ["class"])) : Q("", !0)
                          ]),
                          _: 1
                        }, 8, ["name"]),
                        x(yd, {
                          "hide-label": "",
                          class: ye([{
                            "smake:block smake:@md:hidden": l(X),
                            "smake:hidden": !l(X)
                          }, "smake:absolute smake:top-21 smake:right-4"])
                        }, null, 8, ["class"])
                      ], 2),
                      z("div", n9, [
                        z("div", {
                          class: ye(["smake:hidden smake:flex-col smake:justify-end smake:gap-4 smake:@md:grow", {
                            "smake:@md:flex": l(X),
                            "smake:max-w-50": l(_e)(
                              l(Ct).CUSTOMER_LOGO_UPLOAD
                            ),
                            "smake:max-w-40": !l(_e)(
                              l(Ct).CUSTOMER_LOGO_UPLOAD
                            )
                          }])
                        }, [
                          x(H7),
                          x(pd),
                          x(Hr)
                        ], 2),
                        z("div", o9, [
                          x(I7, { class: "smake:grow" }),
                          x(V7, {
                            class: ye({
                              "smake:hidden": !l(X)
                            })
                          }, null, 8, ["class"]),
                          z("div", {
                            class: ye(["smake:mt-4 smake:flex smake:items-end smake:justify-evenly smake:gap-3 smake:@md:hidden", {
                              "smake:hidden": !l(X)
                            }])
                          }, [
                            x(pd),
                            x(M7),
                            x(l($s), {
                              name: l(Ct).CUSTOMER_LOGO_UPLOAD
                            }, {
                              default: M(() => [
                                x(h5)
                              ]),
                              _: 1
                            }, 8, ["name"]),
                            !l(_e)(
                              l(Ct).CUSTOMER_LOGO_UPLOAD
                            ) || !l(et) ? ($(), H(Hr, { key: 0 })) : Q("", !0)
                          ], 2)
                        ]),
                        z("div", {
                          class: ye(["smake:hidden smake:flex-col smake:justify-center smake:gap-4", {
                            "smake:@md:flex": l(X),
                            "smake:max-w-50": l(_e)(
                              l(Ct).CUSTOMER_LOGO_UPLOAD
                            ),
                            "smake:max-w-40": !l(_e)(
                              l(Ct).CUSTOMER_LOGO_UPLOAD
                            )
                          }])
                        }, [
                          x(C7),
                          x(l($s), {
                            name: l(Ct).CUSTOMER_LOGO_UPLOAD
                          }, {
                            default: M(() => [
                              x(d5)
                            ]),
                            _: 1
                          }, 8, ["name"]),
                          x(L7),
                          Fe[0] || (Fe[0] = z("div", { class: "smake:-mt-4 smake:grow" }, null, -1)),
                          x(yd),
                          x(r5)
                        ], 2)
                      ])
                    ])
                  ], 2)
                ]),
                z("div", {
                  class: ye(["smake:pointer-events-auto smake:flex smake:justify-center smake:rounded-t-2xl smake:bg-white smake:px-6 smake:py-3 smake:shadow-[0px_0px_15px_0px_rgba(0,0,0,0.15)]", {
                    "smake:hidden": !l(X),
                    "smake:@md:hidden": Ne.value
                  }])
                }, [
                  z("div", a9, [
                    x(j7, { class: "smake:@md:hidden" }),
                    Ne.value ? Q("", !0) : ($(), H(k3, { key: 0 }))
                  ])
                ], 2)
              ]),
              x(Q8),
              x($7)
            ]),
            x(n5),
            x(E7),
            x(l(X_), { class: "smake:pointer-events-none smake:absolute smake:inset-x-0 smake:top-3 smake:z-10 smake:flex smake:flex-col smake:items-center smake:gap-3" })
          ], 2)
        ])
      ]),
      _: 1
    }));
  }
}), i9 = "zrušit", r9 = "Přidat logo", l9 = "Přidat text", c9 = "Přidat řádek", u9 = "do objednávky", d9 = "zarovnat", m9 = "Na tomto pohledu není volné umístění.", p9 = "použít", f9 = "Použít pro všechny řádky", h9 = "Archiv", _9 = "Načíst vybraný motiv", v9 = "Načíst produkt včetně personalizace", g9 = "Nový záznam v archivu bude brzy k dispozici.", y9 = "Vaše personalizace byla úspěšně uložena.", k9 = "Opravdu chcete smazat { deleteName }?", b9 = "Alespoň jeden motiv již není k dispozici!", w9 = "Upozornění", x9 = "zpět", $9 = "Ohnout text", z9 = { authentication: "Autentizace selhala.", headline: "Při spuštění konfigurátoru došlo k chybě.", unexpected: "Neočekávaná chyba", variant_not_found: "Požadovaná varianta nebyla nalezena." }, S9 = "Nacházíte se na ploše pro {fromProductionMethod}.", C9 = "přepnout na {x}", A9 = "vybrat", P9 = "Vyberte prosím plochu pro umístění.", T9 = "Vybrat jiný motiv", M9 = "Vybrat jiné logo", I9 = "Vybrat typ personalizace", E9 = "smazat všechny filtry", O9 = "Barva", R9 = "Barvy", L9 = "potvrdit", j9 = "Potvrzení", D9 = "Nahráním požadované personalizace potvrzujete, že jste oprávněni nechat personalizaci aplikovat na textil, zejména že personalizace neporušuje práva třetích stran (ochranné známky, autorská práva, designová práva apod.) ani obecné (zejména trestní) zákony. Pokud bychom byli z důvodu vaší konfigurace postaveni před nároky třetích stran nebo zákona, jste povinni nás od všech nároků a škod v této souvislosti osvobodit.", N9 = "kontaktního formuláře", V9 = "pokračovat s {x}", U9 = "Pozor: Neuložené návrhy budou při otevření návrhů ztraceny.", F9 = "Aktuálně v košíku", q9 = "Dosud nebyly nahrány žádné soubory", B9 = "Individuální", H9 = "Typ motivu", G9 = "Personalizace", W9 = "Design|Designy", Z9 = "Vzdálenost motivu/textu (v mm)", K9 = "Chcete přejmenovat {name}?", Q9 = "Přetáhněte soubor přímo do pole", X9 = "živé barvy, rozmanitost", J9 = "výrazný digitální tisk", Y9 = "ideální pro velké potisky", ez = "flexibilní ve velikosti a barvách", tz = "pro vybrané textilie a všechny základy", nz = "Praní v pračce do 40˚C", oz = "Prvek je mimo oblast umístění.", az = "elegantní, jemné", sz = "velmi kvalitní a trvanlivá výšivka", iz = "možné pro mnoho produktů", rz = "mnoho motivů a barev nití", lz = "všechny textilie, včetně silně namáhaných výrobků", cz = "lze prát na vysoké teploty, včetně průmyslového praní", uz = "Archivace varianty se nezdařila. Zkuste to prosím znovu.", dz = "Uložení varianty se nezdařilo. Zkuste to prosím znovu.", mz = "Při načítání došlo k chybě.", pz = "Při zobrazování změn došlo k chybě. Zkuste to prosím (později) znovu.", fz = "Při načítání varianty došlo k neočekávané chybě. Zkuste to prosím (později) znovu nebo vytvořte novou personalizaci.", hz = "Při mazání archivované varianty došlo k chybě. Zkuste to prosím znovu.", _z = "méně barev", vz = "Písmo", gz = "Písmo není k dispozici", yz = "Aktualizace písma", kz = "Některá písma již nejsou k dispozici. Vyberte prosím jiné:", bz = "od 1 ks", wz = "Přehled personalizací", xz = "Výška (v cm)", $z = "Nápověda k nahrání souboru", zz = "zde", Sz = "Skrýt plochy", Cz = "Motiv|Motivy", Az = "Databáze motivů", Pz = "Vyberte motiv z naší stále rostoucí databáze motivů. Poté máte možnost motiv upravit dle vlastních představ.", Tz = "Vložit text", Mz = "kurzíva", Iz = "k", Ez = "Vzdálenost dole", Oz = "načítání", Rz = "Logo|Loga", Lz = "Loga & designy", jz = "Vzhled", Dz = "Velikost souboru: max.", Nz = "Byl dosažen maximální počet řádků.", Vz = 'Pod "{buttonName}" jsou pro vás připraveny nové návrhy.', Uz = "Minimální množství", Fz = "jednobarevné", qz = "další barvy", Bz = "Pro použití „CI Configurator MYDESIGN“ platí následující {termsOfServiceLink}.", Hz = "Pozor: Některé vaše motivy byly smazány. Přidejte nové motivy a zkontrolujte svůj design.", Gz = "Tento motiv je umístěn ve vašem aktuálním návrhu.", Wz = "vícebarevné", Zz = "Moje personalizace", Kz = "Moje soubory", Qz = "Moje loga", Xz = "Nová personalizace", Jz = "Nový design", Yz = "Nový návrh", eS = "další motiv", tS = "Ve vašem účtu zatím nejsou žádná loga pro {productionMethod}. Chcete-li si nechat logo nahrát od nás, kontaktujte nás na: {contact}. Jinak můžete vpravo nahoře změnit typ personalizace.", nS = "Ve vašem zákaznickém účtu nejsou aktuálně uložena žádná loga pro {productionMethod}.", oS = "Ve vašem účtu zatím nejsou žádné designy pro {productionMethod}.", aS = "Pro vaše aktuální filtrování zatím nejsou žádné motivy pro {productionMethod}.", sS = "Odsazení vlevo", iS = "Pouze velká písmena", rS = "nebo", lS = "Případně můžete změnit typ personalizace vpravo nahoře.", cS = "Stáhnout PDF", uS = "umístit", dS = "Umístit motiv", mS = "Prosím, opravte označená pole, aby se zobrazil váš motiv.", pS = "Prosím, chvíli strpení.", fS = "Náhled", hS = "Náhled možných ploch pro umístění", _S = "Cena", vS = "Změnit barvu produktu", gS = "Typ personalizace", yS = "Tento typ personalizace není pro tento produkt možný.", kS = "výrazný digitální tisk", bS = "velmi kvalitní a trvanlivá výšivka", wS = "Množství", xS = "Nedávno nahrané", $S = "Nedávno použité", zS = "přejmenovat", SS = "nahradit", CS = "uložit", AS = "uložit & načíst", PS = "Uložit personalizaci", TS = "Uloženo", MS = "Váš design byl úspěšně uložen pod názvem {name}.", IS = "Uložené designy", ES = "Hledat motiv", OS = "Vybrat barvu", RS = "Vybrat soubor", LS = "Vybrat písmo", jS = "Relace vypršela", DS = "Vaše relace vypršela. Obnovte stránku pro další použití konfigurátoru.", NS = "Zobrazit {count} výsledek|Zobrazit {count} výsledky", VS = "Zobrazit plochy", US = "Zobrazit moje soubory", FS = "Zobrazit návrhy", qS = "Velikost", BS = "Velikost (v cm)", HS = "Návrhy", GS = "Standardní barvy", WS = "Podporované formáty souborů", ZS = "Podmínky užívání", KS = "Textilie", QS = "Text", XS = "Vybraný design nahradí vaši aktuální volbu", JS = "Tuto akci nelze vrátit zpět.", YS = "Chcete-li umístit požadovaný motiv, změňte typ personalizace na {toProductionMethod}. Poté můžete vybrat vhodnou plochu.", eC = "Probíhá pokus o obnovení relace.", tC = "aktualizovat", nC = "Aktualizovat položku včetně personalizace", oC = "Nahrát další soubor", aC = "Chcete, abychom u nás zaevidovali vaše logo? Pošlete nám prosím své logo prostřednictvím {contact_form} a uveďte své zákaznické číslo, čísla položek a požadované umístění na produktech.", sC = "Váš soubor nesplňuje technické požadavky. Nahrajte prosím jiný formát souboru. Další informace naleznete {here}.", iC = "Nahrání není možné – váš SVG soubor obsahuje obrázkové prvky. Odstraňte prosím vložené obrázky a soubor nahrajte znovu.", rC = "Nahrání není možné – váš SVG soubor obsahuje nevložené písmo. Převěďte prosím písmo na křivky a soubor nahrajte znovu.", lC = "Nahrání selhalo – došlo k neočekávané chybě. Zkuste to prosím znovu nebo použijte jiný formát souboru.", cC = "Nahrát soubor", uC = "Nahrát vlastní soubor", dC = "Nahrané soubory", mC = "Upozornění: Váš nahraný obsah (obrázky/grafika/texty) je automaticky kontrolován – mimo jiné i pomocí metod založených na AI – z hlediska právních a kvalitativních požadavků našich podmínek {termsOfServiceLink} (například autorská/práva na ochranné známky, zakázané znaky, osobnostní práva, nenávistný/násilný obsah). Nepravidelnosti ověřují naši zaměstnanci; konečná rozhodnutí nejsou činěna výhradně automaticky. Podrobnosti o zpracování údajů najdete v našich zásadách ochrany osobních údajů.", pC = "Vaše personalizace od", fC = "Možnost praní", hC = "Šířka (v cm)", _C = "Váš soubor se právě nahrává...", vC = "Zoom", gC = {
  abort: i9,
  add_logo: r9,
  add_text: l9,
  add_text_line: c9,
  add_to_cart: u9,
  align: d9,
  all_positioning_areas_are_occupied: m9,
  apply: p9,
  apply_to_all_lines: f9,
  archive: h9,
  archive_fetch_selected_customization: _9,
  archive_fetch_variant_with_customizations: v9,
  archive_new_entry_soon_available: g9,
  archived_variant_successfully: y9,
  are_you_sure_you_want_to_delete: k9,
  at_least_one_motiv_is_not_available: b9,
  attention: w9,
  back: x9,
  bend_text_line: $9,
  boot_error: z9,
  change_production_method_info: S9,
  change_to_x: C9,
  choose: A9,
  choose_a_positioning_area: P9,
  choose_icon: T9,
  choose_logo: M9,
  choose_production_method: I9,
  clear_filters: E9,
  color: O9,
  colors: R9,
  confirm: L9,
  confirmation: j9,
  confirmation_description: D9,
  contact_form: N9,
  continue: "pokračovat",
  continue_with_x: V9,
  current_edited_customization_will_be_aborted: U9,
  currently_in_cart: F9,
  currently_no_uploaded_files: q9,
  custom: B9,
  customization_type: H9,
  customizations: G9,
  delete: "smazat",
  designs: W9,
  distance_motif_text: Z9,
  do_you_want_to_rename: K9,
  drag_file_over_area: Q9,
  dtf_look: X9,
  dtf_selling_point_1: J9,
  dtf_selling_point_2: Y9,
  dtf_selling_point_3: ez,
  dtf_textiles: tz,
  dtf_washability: nz,
  element_outside_placement_area: oz,
  embroidery_look: az,
  embroidery_selling_point_1: sz,
  embroidery_selling_point_2: iz,
  embroidery_selling_point_3: rz,
  embroidery_textiles: lz,
  embroidery_washability: cz,
  error_failed_to_archive_variant: uz,
  error_failed_to_save_variant: dz,
  error_loading: mz,
  error_pusher_rendering_failed: pz,
  error_pusher_rendering_failed_while_loading_variant: fz,
  error_while_deleting_archive_variant: hz,
  fewer_colors: _z,
  font: vz,
  font_not_available: gz,
  font_update: yz,
  font_update_explanation: kz,
  from_one_piece: bz,
  go_to_production_method_overview: wz,
  height_abbreviation: xz,
  help_for_upload: $z,
  here: zz,
  hide_areas: Sz,
  icon: Cz,
  icon_database: Az,
  icon_database_description: Pz,
  insert_text: Tz,
  italic: Mz,
  italic_short: Iz,
  line_height: Ez,
  loading: Oz,
  logos: Rz,
  logos_and_designs: Lz,
  look: jz,
  max_file_size: Dz,
  maximum_number_of_lines: Nz,
  merchant_sketch_variant_added: Vz,
  minimum_quantity: Uz,
  mono_colored: Fz,
  more_colors: qz,
  more_informations_about_upload: Bz,
  motif_deleted: Hz,
  motif_placed_in_current_design: Gz,
  multi_colored: Wz,
  my_customizations: Zz,
  my_files: Kz,
  my_logos: Qz,
  new: "nové",
  new_customization: Xz,
  new_design: Jz,
  new_sketch: Yz,
  next_motif: eS,
  no_customer_logos: tS,
  no_customer_logos_for_production_method: nS,
  no_designs: oS,
  no_motifs: aS,
  offset_left: sS,
  only_uppercase: iS,
  or: rS,
  otherwise_change_personalization_type_top_right: lS,
  pdf_download: cS,
  place: uS,
  place_logo: dS,
  please_correct_the_highlighted_errors: mS,
  please_hold_on_for_a_moment: pS,
  preview: fS,
  preview_of_possibile_positioning_areas: hS,
  price: _S,
  product_colors: vS,
  production_method: gS,
  production_method_not_available_for_variant: yS,
  production_method_summary_dtf: kS,
  production_method_summary_embroidery: bS,
  quantity: wS,
  recently_uploaded: xS,
  recently_used: $S,
  rename: zS,
  replace: SS,
  save: CS,
  save_and_load: AS,
  save_variant: PS,
  saved: TS,
  saved_design_successfully: MS,
  saved_designs: IS,
  search_logo: ES,
  select_color: OS,
  select_file: RS,
  select_font: LS,
  session_expired: jS,
  session_expired_description: DS,
  show_X_results: NS,
  show_areas: VS,
  show_own_files: US,
  show_sketches: FS,
  size: qS,
  size_in_unit: BS,
  sketches: HS,
  standard_colors: GS,
  supported_file_types: WS,
  terms_of_service: ZS,
  textiles: KS,
  texts: QS,
  the_selected_design_will_replace_the_current_selection: XS,
  this_action_can_not_be_undone: JS,
  to_place_motif_change_production_method: YS,
  trying_to_reconnect_session: eC,
  update: tC,
  update_article_with_designs: nC,
  upload_another_file: oC,
  upload_contact_form_hint: aC,
  upload_error_422_content_type: sC,
  upload_error_svg_contains_image: iC,
  upload_error_svg_contains_text: rC,
  upload_error_unexpected: lC,
  upload_file: cC,
  upload_own_file: uC,
  uploads: dC,
  uploaded_content_automatically_checked_using_ai: mC,
  views_preview_headlide: pC,
  washablility: fC,
  width_abbreviation: hC,
  your_file_is_beeing_uploaded: _C,
  zoom: vC
}, yC = "annullér", kC = "Tilføj logo", bC = "Tilføj tekst", wC = "Tilføj linje", xC = "til bestilling", $C = "justér", zC = "Ingen ledig placeringsflade på denne visning.", SC = "anvend", CC = "Anvend på alle linjer", AC = "Arkiv", PC = "Indlæs valgt motiv", TC = "Indlæs produkt inkl. tilpasning", MC = "En ny arkivpost er snart tilgængelig.", IC = "Din tilpasning blev gemt korrekt.", EC = "Vil du virkelig slette { deleteName }?", OC = "Mindst ét motiv er ikke længere tilgængeligt!", RC = "Advarsel", LC = "tilbage", jC = "Bøj tekst", DC = { authentication: "Godkendelse mislykkedes.", headline: "Der opstod en fejl ved opstart af konfiguratoren.", unexpected: "Uventet fejl", variant_not_found: "Den ønskede variant blev ikke fundet." }, NC = "Du er i øjeblikket på en placeringsflade for {fromProductionMethod}.", VC = "skift til {x}", UC = "vælg", FC = "Vælg venligst en placeringsflade.", qC = "Vælg andet motiv", BC = "Vælg andet logo", HC = "Vælg personaliseringstype", GC = "ryd alle filtre", WC = "Farve", ZC = "Farver", KC = "bekræft", QC = "Bekræftelse", XC = "Ved at uploade den ønskede tilpasning bekræfter du, at du har ret til at få tilpasningen på tekstiler, især at tilpasningen ikke krænker navne- og varemærkerettigheder, designrettigheder, ophavsrettigheder eller andre tredjepartsrettigheder samt generelle (især strafferetlige) love. Skulle vi blive gjort ansvarlige på grund af din konfiguration for overtrædelse af tredjemands rettigheder eller lovgivning, er du forpligtet til at friholde os for alle krav og skader i denne forbindelse.", JC = "kontaktformularen", YC = "fortsæt med {x}", eA = "Bemærk: Ugemte designs vil gå tabt ved åbning af udkast.", tA = "Aktuelt i kurven", nA = "Der er endnu ikke uploadet nogen filer", oA = "Individuel", aA = "Motivtype", sA = "Tilpasninger", iA = "Design|Designs", rA = "Afstand motiv/tekst (i mm)", lA = "Vil du omdøbe {name}?", cA = "Træk fil direkte til feltet", uA = "farvestrålende, alsidig", dA = "udtryksfuld digitaltransfer", mA = "optimal til store tryk", pA = "fleksibel i størrelser og farver", fA = "til udvalgte tekstiler og alle basisprodukter", hA = "Maskinvask op til 40˚C", _A = "Elementet er uden for placeringsfladen.", vA = "elegant, detaljeret", gA = "meget høj kvalitet og holdbart broderi", yA = "muligt for mange produkter", kA = "mange motiver og forskellige garnfarver", bA = "alle tekstiler, også kraftigt brugte produkter", wA = "kan vaskes ved høj temperatur, også industrivask", xA = "Arkivering af varianten mislykkedes. Prøv venligst igen.", $A = "Gemning af varianten mislykkedes. Prøv venligst igen.", zA = "Der opstod en fejl under indlæsning.", SA = "Der opstod en fejl under visning af ændringerne. Prøv venligst igen (senere).", CA = "Der opstod en uventet fejl under indlæsning af varianten. Prøv igen (senere) eller opret en ny tilpasning.", AA = "Der opstod en fejl under sletning af arkiv-varianten. Prøv venligst igen.", PA = "færre farver", TA = "Skrifttype", MA = "Skrifttype ikke tilgængelig", IA = "Opdatering af skrifttype", EA = "Nogle skrifttyper er ikke længere tilgængelige. Vælg venligst en anden:", OA = "fra 1 stk.", RA = "Til personaliseringsoversigt", LA = "Højde (i cm)", jA = "Hjælp til fil-upload", DA = "her", NA = "Skjul flader", VA = "Motiv|Motiver", UA = "Motivdatabase", FA = "Vælg et motiv fra vores stadigt voksende motivdatabase. Herefter kan du tilpasse dit motiv.", qA = "Indsæt tekst", BA = "kursiv", HA = "k", GA = "Afstand nederst", WA = "indlæser", ZA = "Logo|Logoer", KA = "Logoer & designs", QA = "Udseende", XA = "Filstørrelse: maks.", JA = "Det maksimale antal linjer er nået.", YA = 'Nye udkast er gjort tilgængelige under "{buttonName}".', eP = "Minimum antal", tP = "enkeltfarvet", nP = "flere farver", oP = "Følgende {termsOfServiceLink} gælder for brug af „CI Configurator MYDESIGN“.", aP = "Advarsel: Et eller flere af dine motiver er blevet slettet. Tilføj nye motiver og gennemgå dit design.", sP = "Dette motiv er placeret i dit aktuelle design.", iP = "flerfarvet", rP = "Mine tilpasninger", lP = "Mine filer", cP = "Mine logoer", uP = "Ny tilpasning", dP = "Nyt design", mP = "Nyt udkast", pP = "næste motiv", fP = "Der er endnu ingen logoer for {productionMethod} tilføjet til din konto. Vil du have os til at tilføje dit logo? Kontakt os på: {contact}. Ellers kan du skifte personaliseringstype øverst til højre.", hP = "Der er i øjeblikket ingen logoer til {productionMethod} gemt på din kundekonto.", _P = "Der er endnu ingen designs for {productionMethod} tilføjet til din konto.", vP = "Der er endnu ingen motiver for {productionMethod} med den aktuelle filtrering.", gP = "Indrykning til venstre", yP = "Kun store bogstaver", kP = "eller", bP = "Ellers kan du skifte personaliseringstype øverst til højre.", wP = "PDF-download", xP = "placer", $P = "Placer motiv", zP = "Ret venligst de markerede felter for at vise dit motiv.", SP = "Vent venligst et øjeblik.", CP = "Forhåndsvisning", AP = "Forhåndsvisning af mulige placeringsflader", PP = "Pris", TP = "Skift produktfarve", MP = "Personaliseringstype", IP = "Denne personaliseringstype er ikke mulig for dette produkt.", EP = "udtryksfuld digitaltransfer", OP = "meget høj kvalitet og holdbart broderi", RP = "Antal", LP = "Senest uploadet", jP = "Senest brugt", DP = "omdøb", NP = "erstat", VP = "gem", UP = "gem & indlæs", FP = "Gem tilpasning", qP = "Gemt", BP = "Dit design blev gemt under navnet {name}.", HP = "Gemte designs", GP = "Søg motiv", WP = "Vælg farve", ZP = "Vælg fil", KP = "Vælg skrifttype", QP = "Session udløbet", XP = "Din session er udløbet. Genindlæs siden for at fortsætte med at bruge konfiguratoren.", JP = "Vis {count} resultat|Vis {count} resultater", YP = "Vis flader", eT = "Vis mine filer", tT = "Se udkast", nT = "Størrelse", oT = "Størrelse (i cm)", aT = "Udkast", sT = "Standardfarver", iT = "Understøttede filformater", rT = "Brugsbetingelser", lT = "Tekstiler", cT = "Tekst", uT = "Det valgte design vil erstatte dit nuværende valg", dT = "Denne handling kan ikke fortrydes.", mT = "For at placere det ønskede motiv skal du skifte personaliseringstype til {toProductionMethod}. Derefter kan du vælge en egnet placeringsflade.", pT = "Forsøger at genoprette sessionen.", fT = "opdater", hT = "Opdater artikel inklusive personalisering", _T = "Upload en fil mere", vT = "Ønsker du, at vi registrerer dit logo hos os? Send venligst dit logo via {contact_form} og oplys dit kundenummer, varenummerne samt den ønskede placering på varerne.", gT = "Din fil opfylder ikke de tekniske krav. Upload venligst et andet filformat. Du kan finde flere oplysninger {here}.", yT = "Upload ikke mulig – din SVG-fil indeholder billed-elementer. Fjern indlejrede billeder og upload filen igen.", kT = "Upload ikke mulig – din SVG-fil indeholder ikke-integrerede skrifttyper. Konverter skrifttyper til stier og upload filen igen.", bT = "Upload mislykkedes – der opstod en uventet fejl. Prøv igen eller brug et andet filformat.", wT = "Upload fil", xT = "Upload egen fil", $T = "Bemærk: Dit uploadede indhold (billeder/grafik/tekster) bliver automatisk kontrolleret – bl.a. med AI-understøttede metoder – for juridiske og kvalitative krav i vores {termsOfServiceLink} (f.eks. ophavsret/varemærkerettigheder, forbudte tegn, personlighedsrettigheder, hade-/voldeligt indhold). Uregelmæssigheder kontrolleres af vores medarbejdere; endelige beslutninger træffes ikke udelukkende automatisk. Nærmere oplysninger om databehandling findes i vores privatlivspolitik.", zT = "Uploads", ST = "Din tilpasning fra", CT = "Vaskeegnethed", AT = "Bredde (i cm)", PT = "Din fil uploades...", TT = "Zoom", MT = {
  abort: yC,
  add_logo: kC,
  add_text: bC,
  add_text_line: wC,
  add_to_cart: xC,
  align: $C,
  all_positioning_areas_are_occupied: zC,
  apply: SC,
  apply_to_all_lines: CC,
  archive: AC,
  archive_fetch_selected_customization: PC,
  archive_fetch_variant_with_customizations: TC,
  archive_new_entry_soon_available: MC,
  archived_variant_successfully: IC,
  are_you_sure_you_want_to_delete: EC,
  at_least_one_motiv_is_not_available: OC,
  attention: RC,
  back: LC,
  bend_text_line: jC,
  boot_error: DC,
  change_production_method_info: NC,
  change_to_x: VC,
  choose: UC,
  choose_a_positioning_area: FC,
  choose_icon: qC,
  choose_logo: BC,
  choose_production_method: HC,
  clear_filters: GC,
  color: WC,
  colors: ZC,
  confirm: KC,
  confirmation: QC,
  confirmation_description: XC,
  contact_form: JC,
  continue: "fortsæt",
  continue_with_x: YC,
  current_edited_customization_will_be_aborted: eA,
  currently_in_cart: tA,
  currently_no_uploaded_files: nA,
  custom: oA,
  customization_type: aA,
  customizations: sA,
  delete: "slet",
  designs: iA,
  distance_motif_text: rA,
  do_you_want_to_rename: lA,
  drag_file_over_area: cA,
  dtf_look: uA,
  dtf_selling_point_1: dA,
  dtf_selling_point_2: mA,
  dtf_selling_point_3: pA,
  dtf_textiles: fA,
  dtf_washability: hA,
  element_outside_placement_area: _A,
  embroidery_look: vA,
  embroidery_selling_point_1: gA,
  embroidery_selling_point_2: yA,
  embroidery_selling_point_3: kA,
  embroidery_textiles: bA,
  embroidery_washability: wA,
  error_failed_to_archive_variant: xA,
  error_failed_to_save_variant: $A,
  error_loading: zA,
  error_pusher_rendering_failed: SA,
  error_pusher_rendering_failed_while_loading_variant: CA,
  error_while_deleting_archive_variant: AA,
  fewer_colors: PA,
  font: TA,
  font_not_available: MA,
  font_update: IA,
  font_update_explanation: EA,
  from_one_piece: OA,
  go_to_production_method_overview: RA,
  height_abbreviation: LA,
  help_for_upload: jA,
  here: DA,
  hide_areas: NA,
  icon: VA,
  icon_database: UA,
  icon_database_description: FA,
  insert_text: qA,
  italic: BA,
  italic_short: HA,
  line_height: GA,
  loading: WA,
  logos: ZA,
  logos_and_designs: KA,
  look: QA,
  max_file_size: XA,
  maximum_number_of_lines: JA,
  merchant_sketch_variant_added: YA,
  minimum_quantity: eP,
  mono_colored: tP,
  more_colors: nP,
  more_informations_about_upload: oP,
  motif_deleted: aP,
  motif_placed_in_current_design: sP,
  multi_colored: iP,
  my_customizations: rP,
  my_files: lP,
  my_logos: cP,
  new: "ny",
  new_customization: uP,
  new_design: dP,
  new_sketch: mP,
  next_motif: pP,
  no_customer_logos: fP,
  no_customer_logos_for_production_method: hP,
  no_designs: _P,
  no_motifs: vP,
  offset_left: gP,
  only_uppercase: yP,
  or: kP,
  otherwise_change_personalization_type_top_right: bP,
  pdf_download: wP,
  place: xP,
  place_logo: $P,
  please_correct_the_highlighted_errors: zP,
  please_hold_on_for_a_moment: SP,
  preview: CP,
  preview_of_possibile_positioning_areas: AP,
  price: PP,
  product_colors: TP,
  production_method: MP,
  production_method_not_available_for_variant: IP,
  production_method_summary_dtf: EP,
  production_method_summary_embroidery: OP,
  quantity: RP,
  recently_uploaded: LP,
  recently_used: jP,
  rename: DP,
  replace: NP,
  save: VP,
  save_and_load: UP,
  save_variant: FP,
  saved: qP,
  saved_design_successfully: BP,
  saved_designs: HP,
  search_logo: GP,
  select_color: WP,
  select_file: ZP,
  select_font: KP,
  session_expired: QP,
  session_expired_description: XP,
  show_X_results: JP,
  show_areas: YP,
  show_own_files: eT,
  show_sketches: tT,
  size: nT,
  size_in_unit: oT,
  sketches: aT,
  standard_colors: sT,
  supported_file_types: iT,
  terms_of_service: rT,
  textiles: lT,
  texts: cT,
  the_selected_design_will_replace_the_current_selection: uT,
  this_action_can_not_be_undone: dT,
  to_place_motif_change_production_method: mT,
  trying_to_reconnect_session: pT,
  update: fT,
  update_article_with_designs: hT,
  upload_another_file: _T,
  upload_contact_form_hint: vT,
  upload_error_422_content_type: gT,
  upload_error_svg_contains_image: yT,
  upload_error_svg_contains_text: kT,
  upload_error_unexpected: bT,
  upload_file: wT,
  upload_own_file: xT,
  uploaded_content_automatically_checked_using_ai: $T,
  uploads: zT,
  views_preview_headlide: ST,
  washablility: CT,
  width_abbreviation: AT,
  your_file_is_beeing_uploaded: PT,
  zoom: TT
}, IT = "abbrechen", ET = "Logo hinzufügen", OT = "Text hinzufügen", RT = "Zeile hinzufügen", LT = "zur Bestellung", jT = "ausrichten", DT = "Keine freie Platzierungsfläche auf dieser Ansicht.", NT = "anwenden", VT = "Für alle Zeilen übernehmen", UT = "Archiv", FT = "Ausgewähltes Motiv laden", qT = "Artikel inklusive Personalisierung laden", BT = "Ein neuer Archiv-Eintrag ist in Kürze verfügbar.", HT = "Ihre Personalisierung wurde erfolgreich gespeichert.", GT = "Möchten Sie { deleteName } wirklich löschen?", WT = "mindestens ein Motiv ist nicht mehr verfügbar!", ZT = "Achtung", KT = "zurück", QT = "Text krümmen", XT = { authentication: "Die Authentifizierung ist fehlgeschlagen.", headline: "Beim Starten des Konfigurators ist ein Fehler aufgetreten.", unexpected: "Unerwarteter Fehler", variant_not_found: "Die gewünschte Variante wurde nicht gefunden." }, JT = "Sie befinden sich aktuell auf einer Platzierungsfläche für {fromProductionMethod}.", YT = "zu {x} wechseln", eM = "auswählen", tM = "Bitte wählen Sie eine Platzierungsfläche.", nM = "Anderes Motiv auswählen", oM = "Anderes Logo auswählen", aM = "Personalisierungsart wählen", sM = "alle Filter löschen", iM = "Farbe", rM = "Farben", lM = "bestätigen", cM = "Bestätigung", uM = "Mit dem Hochladen der gewünschten Personalisierung bestätigen Sie, dass Sie befugt sind, die Personalisierung auf Textilien anbringen zu lassen, insbesondere, dass die Personalisierung nicht gegen Namens- und Markenrechte, Designrechte, Urheberrechte oder sonstige Rechte Dritter ebenso wie gegen allgemeine (insbesondere strafrechtliche) Gesetze verstößt. Sollten wir wegen der von Ihnen vorgenommenen Konfiguration aufgrund der Verletzung von Rechten Dritter oder allgemeiner Gesetze in Anspruch genommen werden, so sind Sie verpflichtet, uns von sämtlichen Ansprüchen und Schäden in diesem Zusammenhang freizustellen.", dM = "Kontaktformular", mM = "mit {x} fortfahren", pM = "Hinweis: Ungespeicherte Designs gehen beim Aufruf der Entwürfe leider verloren.", fM = "Aktuell im Warenkorb", hM = "Bisher wurden keine Dateien hochgeladen", _M = "Individuell", vM = "Motivart", gM = "Personalisierungen", yM = "Design|Designs", kM = "Abstand Motiv/Text (in mm)", bM = "Möchten Sie {name} umbenennen?", wM = "Datei direkt ins Feld ziehen", xM = "farbbrillant, vielfältig", $M = "ausdrucksstarker Digitaltransfer", zM = "optimal für große Aufdrucke", SM = "flexibel in Größen & Farben", CM = "für ausgewählte Textilien & alle Basics", AM = "Maschinenwäsche bis 40˚C", PM = "Element ist außerhalb der Platzierungsfläche.", TM = "edel, filigran", MM = "sehr hochwertiger & langlebiger Stick", IM = "möglich für eine große Zahl an Artikeln", EM = "viele Motive & verschiedene Garnfarben", OM = "alle Textilien, auch stark beanspruchte Artikel", RM = "heiß waschbar, auch Industriewäsche", LM = "Das Archivieren der Variante ist fehlgeschlagen. Bitte versuchen Sie es erneut.", jM = "Das Speichern der Variante ist fehlgeschlagen. Bitte versuchen Sie es erneut.", DM = "Es ist ein Fehler beim Laden aufgetreten.", NM = "Es ist ein Fehler beim Darstellen der Änderungen aufgetreten. Bitte versuchen Sie es (später) erneut.", VM = "Beim Laden der Variante kam es zu einem unerwarteten Fehler. Bitte versuchen Sie es (später) erneut oder erstellen Sie eine neue Personalisierung.", UM = "Beim Löschen der Archiv-Variante ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.", FM = "weniger Farben", qM = "Schrift", BM = "Schrift nicht verfügbar", HM = "Schriftaktualisierung", GM = "Einige Schriften sind nicht mehr verfügbar. Wählen Sie bitte eine andere aus:", WM = "ab 1 Stück", ZM = "Zur Personalisierungsübersicht", KM = "Höhe (in cm)", QM = "Hilfe zum Datei-Upload", XM = "hier", JM = "Flächen ausblenden", YM = "Motiv|Motive", eI = "Motivdatenbank", tI = "Wählen Sie ein Motiv aus unserer stetig wachsenden Motivdatenbank aus. Anschließend haben Sie die Möglichkeit Ihr Motiv zu individualisieren.", nI = "Text einfügen", oI = "kursiv", aI = "k", sI = "Abstand unten", iI = "laden", rI = "Logo|Logos", lI = "Logos & Designs", cI = "Look", uI = "Dateigröße: max.", dI = "Die maximale Zeilenanzahl ist erreicht.", mI = 'Unter "{buttonName}" wurden neue Entwürfe für Sie bereitgestellt.', pI = "Mindestmenge", fI = "einfarbig", hI = "weitere Farben", _I = "Für die Nutzung des „CI Configurator MYDESIGN“ gelten folgende {termsOfServiceLink}.", vI = "Achtung: Ein oder mehrere Motive wurden gelöscht. Bitte fügen Sie neue Motive hinzu und prüfen Sie Ihr Design.", gI = "Dieses Motiv ist in ihrem aktuellen Design platziert.", yI = "mehrfarbig", kI = "Meine Personalisierungen", bI = "Meine Dateien", wI = "Meine Logos", xI = "Neue Personalisierung", $I = "Neues Design", zI = "Neuer Entwurf", SI = "nächstes Motiv", CI = "In Ihrem Kundenkonto sind aktuell noch keine Logos für {productionMethod} hinterlegt.", AI = "In Ihrem Kundenkonto sind aktuell noch keine Designs für {productionMethod} hinterlegt.", PI = "Für Ihre aktuelle Filterung sind aktuell noch keine {productionMethod}-Motive hinterlegt.", TI = "Einzug links", MI = "Nur Großbuchstaben", II = "oder", EI = "Ansonsten können Sie oben rechts die Personalisierungsart wechseln.", OI = "PDF-Download", RI = "platzieren", LI = "Motiv platzieren", jI = "Bitte korrigieren Sie die markierten Felder, um ihr Motiv anzuzeigen.", DI = "Bitte haben Sie einen Augenblick Geduld.", NI = "Vorschau", VI = "Vorschau der möglichen Platzierungsflächen", UI = "Preis", FI = "Artikelfarbe ändern", qI = "Personalisierungsart", BI = "Personalisierungsart auf diesem Artikel leider nicht möglich.", HI = "ausdrucksstarker Digitaltransfer", GI = "sehr hochwertiger & langlebiger Stick", WI = "Menge", ZI = "Zuletzt hochgeladen", KI = "Zuletzt verwendet", QI = "umbenennen", XI = "ersetzen", JI = "speichern", YI = "speichern & laden", eE = "Personalisierung speichern", tE = "Gespeichert", nE = "Ihr Design wurde erfolgreich unter dem Namen {name} gespeichert.", oE = "Gespeicherte Designs", aE = "Motiv suchen", sE = "Farbe auswählen", iE = "Datei auswählen", rE = "Schrift wählen", lE = "Sitzung abgelaufen", cE = "Ihre Sitzung ist abgelaufen. Bitte laden Sie die Seite erneut, um den Konfigurator weiter nutzen zu können.", uE = "{count} Ergebnis anzeigen|{count} Ergebnisse anzeigen", dE = "Flächen einblenden", mE = "Meine Dateien anzeigen", pE = "Entwürfe jetzt ansehen", fE = "Größe", hE = "Größe (in cm)", _E = "Entwürfe", vE = "Standardfarben", gE = "Mögliche Dateiformate", yE = "Nutzungsbedingungen", kE = "Textilien", bE = "Text", wE = "Das ausgewählte Design wird Ihre aktuelle Auswahl ersetzen", xE = "Diese Aktion kann nicht rückgängig gemacht werden.", $E = "Um das gewünschte Motiv zu platzieren, wechseln Sie bitte die Personalisierungsart zu {toProductionMethod}. Im Anschluss können Sie eine passende Platzierungsfläche auswählen.", zE = "Es wird versucht, Ihre Sitzung wiederherzustellen.", SE = "aktualisieren", CE = "Artikel inklusive Personalisierung aktualisieren", AE = "weitere Datei hochladen", PE = "Sie möchten Ihr Logo von uns hinterlegen lassen? Bitte senden Sie uns Ihr Logo per {contact_form} mit Angabe der Kundennummer, Artikelnummern und die gewünschte Platzierung auf den Artikeln. ", TE = "Ihre Datei erfüllt leider nicht die technischen Anforderungen. Bitte laden Sie ein anderes Dateiformat hoch. Weitere Informationen finden Sie {here}.", ME = "Upload nicht möglich – Ihre SVG-Datei enthält Bildelemente. Bitte entfernen Sie eingebettete Bilder und laden Sie die Datei erneut hoch.", IE = "Upload nicht möglich – Ihre SVG-Datei enthält nicht eingebettete Schriften. Bitte wandeln Sie enthaltene Schriften in Pfade um und laden Sie die Datei erneut hoch.", EE = "Upload fehlgeschlagen – ein unerwarteter Fehler ist aufgetreten. Bitte probieren Sie es erneut oder verwenden Sie ein anderes Dateiformat.", OE = "Datei hochladen", RE = "Eigene Datei Hochladen", LE = "Hinweis: Ihre hochgeladenen Inhalte (Bilder/Grafiken/Texte) werden automatisiert, u. a. mit KI-gestützten Verfahren, auf rechtliche und qualitative Vorgaben unserer {termsOfServiceLink} geprüft (z. B. Urheber‑/Markenrechte, verbotene Zeichen, Persönlichkeitsrechte, Hass‑/Gewaltinhalte). Auffälligkeiten werden durch unsere Mitarbeitenden überprüft; endgültige Entscheidungen erfolgen nicht ausschließlich automatisiert. Einzelheiten zur Datenverarbeitung finden Sie in unserer Datenschutzerklärung", jE = "Uploads", DE = "Ihre Personalisierung von", NE = "Waschbarkeit", VE = "Breite (in cm)", UE = "Ihre Datei wird gerade hochgeladen...", FE = "Zoom", qE = {
  abort: IT,
  add_logo: ET,
  add_text: OT,
  add_text_line: RT,
  add_to_cart: LT,
  align: jT,
  all_positioning_areas_are_occupied: DT,
  apply: NT,
  apply_to_all_lines: VT,
  archive: UT,
  archive_fetch_selected_customization: FT,
  archive_fetch_variant_with_customizations: qT,
  archive_new_entry_soon_available: BT,
  archived_variant_successfully: HT,
  are_you_sure_you_want_to_delete: GT,
  at_least_one_motiv_is_not_available: WT,
  attention: ZT,
  back: KT,
  bend_text_line: QT,
  boot_error: XT,
  change_production_method_info: JT,
  change_to_x: YT,
  choose: eM,
  choose_a_positioning_area: tM,
  choose_icon: nM,
  choose_logo: oM,
  choose_production_method: aM,
  clear_filters: sM,
  color: iM,
  colors: rM,
  confirm: lM,
  confirmation: cM,
  confirmation_description: uM,
  contact_form: dM,
  continue: "weiter",
  continue_with_x: mM,
  current_edited_customization_will_be_aborted: pM,
  currently_in_cart: fM,
  currently_no_uploaded_files: hM,
  custom: _M,
  customization_type: vM,
  customizations: gM,
  delete: "löschen",
  designs: yM,
  distance_motif_text: kM,
  do_you_want_to_rename: bM,
  drag_file_over_area: wM,
  dtf_look: xM,
  dtf_selling_point_1: $M,
  dtf_selling_point_2: zM,
  dtf_selling_point_3: SM,
  dtf_textiles: CM,
  dtf_washability: AM,
  element_outside_placement_area: PM,
  embroidery_look: TM,
  embroidery_selling_point_1: MM,
  embroidery_selling_point_2: IM,
  embroidery_selling_point_3: EM,
  embroidery_textiles: OM,
  embroidery_washability: RM,
  error_failed_to_archive_variant: LM,
  error_failed_to_save_variant: jM,
  error_loading: DM,
  error_pusher_rendering_failed: NM,
  error_pusher_rendering_failed_while_loading_variant: VM,
  error_while_deleting_archive_variant: UM,
  fewer_colors: FM,
  font: qM,
  font_not_available: BM,
  font_update: HM,
  font_update_explanation: GM,
  from_one_piece: WM,
  go_to_production_method_overview: ZM,
  height_abbreviation: KM,
  help_for_upload: QM,
  here: XM,
  hide_areas: JM,
  icon: YM,
  icon_database: eI,
  icon_database_description: tI,
  insert_text: nI,
  italic: oI,
  italic_short: aI,
  line_height: sI,
  loading: iI,
  logos: rI,
  logos_and_designs: lI,
  look: cI,
  max_file_size: uI,
  maximum_number_of_lines: dI,
  merchant_sketch_variant_added: mI,
  minimum_quantity: pI,
  mono_colored: fI,
  more_colors: hI,
  more_informations_about_upload: _I,
  motif_deleted: vI,
  motif_placed_in_current_design: gI,
  multi_colored: yI,
  my_customizations: kI,
  my_files: bI,
  my_logos: wI,
  new: "neu",
  new_customization: xI,
  new_design: $I,
  new_sketch: zI,
  next_motif: SI,
  no_customer_logos_for_production_method: CI,
  no_designs: AI,
  no_motifs: PI,
  offset_left: TI,
  only_uppercase: MI,
  or: II,
  otherwise_change_personalization_type_top_right: EI,
  pdf_download: OI,
  place: RI,
  place_logo: LI,
  please_correct_the_highlighted_errors: jI,
  please_hold_on_for_a_moment: DI,
  preview: NI,
  preview_of_possibile_positioning_areas: VI,
  price: UI,
  product_colors: FI,
  production_method: qI,
  production_method_not_available_for_variant: BI,
  production_method_summary_dtf: HI,
  production_method_summary_embroidery: GI,
  quantity: WI,
  recently_uploaded: ZI,
  recently_used: KI,
  rename: QI,
  replace: XI,
  save: JI,
  save_and_load: YI,
  save_variant: eE,
  saved: tE,
  saved_design_successfully: nE,
  saved_designs: oE,
  search_logo: aE,
  select_color: sE,
  select_file: iE,
  select_font: rE,
  session_expired: lE,
  session_expired_description: cE,
  show_X_results: uE,
  show_areas: dE,
  show_own_files: mE,
  show_sketches: pE,
  size: fE,
  size_in_unit: hE,
  sketches: _E,
  standard_colors: vE,
  supported_file_types: gE,
  terms_of_service: yE,
  textiles: kE,
  texts: bE,
  the_selected_design_will_replace_the_current_selection: wE,
  this_action_can_not_be_undone: xE,
  to_place_motif_change_production_method: $E,
  trying_to_reconnect_session: zE,
  update: SE,
  update_article_with_designs: CE,
  upload_another_file: AE,
  upload_contact_form_hint: PE,
  upload_error_422_content_type: TE,
  upload_error_svg_contains_image: ME,
  upload_error_svg_contains_text: IE,
  upload_error_unexpected: EE,
  upload_file: OE,
  upload_own_file: RE,
  uploaded_content_automatically_checked_using_ai: LE,
  uploads: jE,
  views_preview_headlide: DE,
  washablility: NE,
  width_abbreviation: VE,
  your_file_is_beeing_uploaded: UE,
  zoom: FE
}, BE = "Cancel", HE = "Add logo", GE = "Add text", WE = "Add row", ZE = "Add to cart", KE = "Align", QE = "No free positioning area on this screen.", XE = "Apply", JE = "Use for all rows", YE = "Archive", eO = "Load selected motif", tO = "Load item including personalisation", nO = "A new archive entry will be available shortly.", oO = "Your personalisation has been successfully saved.", aO = "Do you really want to delete {deleteName}?", sO = "At least one design is no longer available!", iO = "Attention", rO = "back", lO = "Bend text", cO = { authentication: "Authentication has failed.", headline: "An error occurred when starting the Designer.", unexpected: "Unexpected error", variant_not_found: "The desired variant was not found." }, uO = "You are currently on a placement area for {fromProductionMethod}.", dO = "Switch to {x}", mO = "select", pO = "Please select a positioning area.", fO = "Select another design", hO = "Select a different logo", _O = "Choose production type", vO = "Clear all filters", gO = "Colour", yO = "Colours", kO = "confirm", bO = "Confirmation", wO = "By uploading the desired personalization, you confirm that you are authorized to have the personalization applied to textiles, in particular that the personalization does not violate name and trademark rights, design rights, copyrights, or other third-party rights, as well as general (especially criminal) laws. Should we be held liable due to the configuration you have made because of infringement of third-party rights or general laws, you are obliged to indemnify us against all claims and damages in this context.", xO = "contact form", $O = "continue with {x}", zO = "Note: Unsaved designs will unfortunately be lost when you access the drafts.", SO = "Currently in Cart", CO = "No files uploaded so far", AO = "Custom", PO = "Customization type", TO = "Personalisations", MO = "Designs|Designs", IO = "Spacing between motif/text", EO = "Do you want to rename {name}?", OO = "Drag file directly into the field", RO = "bright, versatile", LO = "expressive digital transfer printing", jO = "optimal for large prints", DO = "flexible in size and colours", NO = "for selected fabrics & all basics", VO = "Machine washable up to 40 °C", UO = "Element is outside the positioning area.", FO = "elegant, delicate", qO = "very high-quality & durable embroidery", BO = "possible for a large number of articles", HO = "many motifs & different thread colours", GO = "all textiles, even heavily used ones", WO = "hot washable, even industrial laundry", ZO = "Archiving of the variants failed. Please try again.", KO = "Saving of the variants failed. Please try again.", QO = "An error occurred during loading.", XO = "An error occurred when showing the changes. Please try again (later).", JO = "An unexpected error occurred when loading the variant. Please try again (later) or create a new personalisation.", YO = "An error occurred when deleting the archive variant. Please try again.", eR = "fewer colours", tR = "Font", nR = "Font not available", oR = "Font update", aR = "Some fonts are no longer available. Please choose another one:", sR = "from 1 piece", iR = "to the personalisation overview", rR = "Height (in cm)", lR = "Help with file upload", cR = "here", uR = "Hide areas", dR = "Motif|Motifs", mR = "Motif database", pR = "Select a design from our continuously growing design database. Then you will have the opportunity to customise your design.", fR = "Insert text", hR = "Italic", _R = "i", vR = "Spacing below", gR = "Loading", yR = "Logo|Logos", kR = "Logos & designs", bR = "Look", wR = "File size: max.", xR = "The maximum number of rows has been reached.", $R = 'Under "{buttonName}" new drafts have been provided for you.', zR = "Minimum quantity", SR = "Single-colour", CR = "More colours", AR = 'The following {termsOfServiceLink} to the use of the "CI Configurator MYDESIGN."', PR = "Attention: One or more of your designs have been deleted. Please add new designs and review your design.", TR = "This motif is placed in your current design.", MR = "Multi-colour", IR = "My Personalisations", ER = "My files", OR = "My logos", RR = "New personalisation", LR = "New design", jR = "New draft", DR = "next design", NR = "There are currently no logos stored in your customer account for {productionMethod}. Would you like us to save your logo? Please contact us at: {contact}. Alternatively, you can switch the personalisation type in the top-right corner.", VR = "There are currently no logos stored in your customer account for {productionMethod}.", UR = "There are currently no designs stored in your customer account for {productionMethod}.", FR = "No motifs could be found for your current filter selection.", qR = "Indent left", BR = "Only upper case characters", HR = "or", GR = "Otherwise, you can switch the personalization type in the top right.", WR = "PDF download", ZR = "Place", KR = "Place design", QR = "Please correct the marked fields to display your motif.", XR = "Please hold on for a moment.", JR = "Preview", YR = "Preview of possible placement areas", eL = "Price", tL = "Change product colour", nL = "Production type", oL = "Unfortunately, this type of personalisation is not possible on this item.", aL = "expressive digital transfer printing", sL = "very high-quality & durable embroidery", iL = "Quantity", rL = "Recently uploaded", lL = "Recently used", cL = "rename", uL = "replace", dL = "Save", mL = "save & load", pL = "Save personalisation", fL = "Saved", hL = "Your design has been successfully saved under the name {name}.", _L = "Saved designs", vL = "Search motif", gL = "select colour", yL = "Select file", kL = "Select font", bL = "Session expired", wL = "Your session has expired. Please reload the page to continue using the designer.", xL = "Show {count} result|Show {count} results", $L = "Show areas", zL = "Show my files", SL = "View drafts now", CL = "Size", AL = "Size (in cm)", PL = "Drafts", TL = "Standard colours", ML = "Supported file formats", IL = "terms of use", EL = "Textiles", OL = "Text", RL = "The selected design will replace your current selection.", LL = "This action cannot be undone.", jL = "To position the desired motif, please switch the personalisation type to {toProductionMethod}. You can then select a suitable placement area.", DL = "An attempt is made to restore your session.", NL = "update", VL = "Update item including personalization", UL = "Upload another file", FL = "Would you like us to set up your logo? Please send us your logo via the contact form, including your customer number, the item numbers, and the desired placement on the items.", qL = "Unfortunately, your file does not meet the technical requirements. Please upload a different file format. You can find more information {here}.", BL = "Upload failed – Your SVG file contains image elements. Please remove embedded images and upload the file again.", HL = "Upload failed – Your SVG file contains non-converted text. Please convert all fonts to outlines and upload the file again.", GL = "Upload failed – An unexpected error occurred. Please try again or use a different file format.", WL = "Upload file", ZL = "Upload own file", KL = "Uploads", QL = "Your personalisation from the", XL = "Washability", JL = "Width (in cm)", YL = "Your file is being uploaded...", ej = "Zoom", tj = "Note: Your uploaded content (images/graphics/texts) is automatically checked—among other things, using AI-supported processes—for legal and qualitative requirements in accordance with our {termsOfServiceLink} (e.g., copyright/trademark rights, prohibited characters, personal rights, hate or violent content). Any anomalies are reviewed by our staff; final decisions are not made exclusively automatically. Details on data processing can be found in our privacy policy.", nj = {
  abort: BE,
  add_logo: HE,
  add_text: GE,
  add_text_line: WE,
  add_to_cart: ZE,
  align: KE,
  all_positioning_areas_are_occupied: QE,
  apply: XE,
  apply_to_all_lines: JE,
  archive: YE,
  archive_fetch_selected_customization: eO,
  archive_fetch_variant_with_customizations: tO,
  archive_new_entry_soon_available: nO,
  archived_variant_successfully: oO,
  are_you_sure_you_want_to_delete: aO,
  at_least_one_motiv_is_not_available: sO,
  attention: iO,
  back: rO,
  bend_text_line: lO,
  boot_error: cO,
  change_production_method_info: uO,
  change_to_x: dO,
  choose: mO,
  choose_a_positioning_area: pO,
  choose_icon: fO,
  choose_logo: hO,
  choose_production_method: _O,
  clear_filters: vO,
  color: gO,
  colors: yO,
  confirm: kO,
  confirmation: bO,
  confirmation_description: wO,
  contact_form: xO,
  continue: "Continue",
  continue_with_x: $O,
  current_edited_customization_will_be_aborted: zO,
  currently_in_cart: SO,
  currently_no_uploaded_files: CO,
  custom: AO,
  customization_type: PO,
  customizations: TO,
  delete: "Delete",
  designs: MO,
  distance_motif_text: IO,
  do_you_want_to_rename: EO,
  drag_file_over_area: OO,
  dtf_look: RO,
  dtf_selling_point_1: LO,
  dtf_selling_point_2: jO,
  dtf_selling_point_3: DO,
  dtf_textiles: NO,
  dtf_washability: VO,
  element_outside_placement_area: UO,
  embroidery_look: FO,
  embroidery_selling_point_1: qO,
  embroidery_selling_point_2: BO,
  embroidery_selling_point_3: HO,
  embroidery_textiles: GO,
  embroidery_washability: WO,
  error_failed_to_archive_variant: ZO,
  error_failed_to_save_variant: KO,
  error_loading: QO,
  error_pusher_rendering_failed: XO,
  error_pusher_rendering_failed_while_loading_variant: JO,
  error_while_deleting_archive_variant: YO,
  fewer_colors: eR,
  font: tR,
  font_not_available: nR,
  font_update: oR,
  font_update_explanation: aR,
  from_one_piece: sR,
  go_to_production_method_overview: iR,
  height_abbreviation: rR,
  help_for_upload: lR,
  here: cR,
  hide_areas: uR,
  icon: dR,
  icon_database: mR,
  icon_database_description: pR,
  insert_text: fR,
  italic: hR,
  italic_short: _R,
  line_height: vR,
  loading: gR,
  logos: yR,
  logos_and_designs: kR,
  look: bR,
  max_file_size: wR,
  maximum_number_of_lines: xR,
  merchant_sketch_variant_added: $R,
  minimum_quantity: zR,
  mono_colored: SR,
  more_colors: CR,
  more_informations_about_upload: AR,
  motif_deleted: PR,
  motif_placed_in_current_design: TR,
  multi_colored: MR,
  my_customizations: IR,
  my_files: ER,
  my_logos: OR,
  new: "new",
  new_customization: RR,
  new_design: LR,
  new_sketch: jR,
  next_motif: DR,
  no_customer_logos: NR,
  no_customer_logos_for_production_method: VR,
  no_designs: UR,
  no_motifs: FR,
  offset_left: qR,
  only_uppercase: BR,
  or: HR,
  otherwise_change_personalization_type_top_right: GR,
  pdf_download: WR,
  place: ZR,
  place_logo: KR,
  please_correct_the_highlighted_errors: QR,
  please_hold_on_for_a_moment: XR,
  preview: JR,
  preview_of_possibile_positioning_areas: YR,
  price: eL,
  product_colors: tL,
  production_method: nL,
  production_method_not_available_for_variant: oL,
  production_method_summary_dtf: aL,
  production_method_summary_embroidery: sL,
  quantity: iL,
  recently_uploaded: rL,
  recently_used: lL,
  rename: cL,
  replace: uL,
  save: dL,
  save_and_load: mL,
  save_variant: pL,
  saved: fL,
  saved_design_successfully: hL,
  saved_designs: _L,
  search_logo: vL,
  select_color: gL,
  select_file: yL,
  select_font: kL,
  session_expired: bL,
  session_expired_description: wL,
  show_X_results: xL,
  show_areas: $L,
  show_own_files: zL,
  show_sketches: SL,
  size: CL,
  size_in_unit: AL,
  sketches: PL,
  standard_colors: TL,
  supported_file_types: ML,
  terms_of_service: IL,
  textiles: EL,
  texts: OL,
  the_selected_design_will_replace_the_current_selection: RL,
  this_action_can_not_be_undone: LL,
  to_place_motif_change_production_method: jL,
  trying_to_reconnect_session: DL,
  update: NL,
  update_article_with_designs: VL,
  upload_another_file: UL,
  upload_contact_form_hint: FL,
  upload_error_422_content_type: qL,
  upload_error_svg_contains_image: BL,
  upload_error_svg_contains_text: HL,
  upload_error_unexpected: GL,
  upload_file: WL,
  upload_own_file: ZL,
  uploads: KL,
  views_preview_headlide: QL,
  washablility: XL,
  width_abbreviation: JL,
  your_file_is_beeing_uploaded: YL,
  zoom: ej,
  uploaded_content_automatically_checked_using_ai: tj
}, oj = "Annuler", aj = "Ajouter un logo", sj = "Ajouter du texte", ij = "Ajouter une ligne", rj = "Vers la commande", lj = "Aligner", cj = "Pas de surface de placement libre sur cette affichage.", uj = "Appliquer", dj = "Reprendre pour toutes les lignes", mj = "Archive", pj = "Charger un motif sélectionné", fj = "Charger l'article avec la personnalisation", hj = "Une nouvelle entrée d'archive sera bientôt disponible.", _j = "Votre personnalisation a été sauvegardée avec succès.", vj = "Voulez-vous vraiment supprimer {deleteName}?", gj = "Au moins un motif n’est plus disponible !", yj = "Attention", kj = "retour", bj = "Courber le texte", wj = { authentication: "L'authentification a échoué.", headline: "Une erreur est survenue lors du lancement du designer.", unexpected: "Erreur inattendue", variant_not_found: "La variante souhaitée n'a pas été trouvée." }, xj = "Vous vous trouvez actuellement sur un emplacement de {fromProductionMethod}.", $j = "Passer à {x}", zj = "Sélectionner", Sj = "Veuillez sélectionner une surface de placement.", Cj = "Sélectionner un autre motif", Aj = "Sélectionner un autre logo", Pj = "Sélectionner le type de personnalisation", Tj = "Supprimer tous les filtres", Mj = "Couleur", Ij = "Couleurs", Ej = "confirmer", Oj = "Confirmation", Rj = "En téléchargeant la personnalisation souhaitée, vous confirmez que vous êtes autorisé à faire apposer la personnalisation sur des textiles, en particulier que cette personnalisation ne viole pas les droits de nom et de marque, les droits de design, les droits d'auteur ou autres droits de tiers, ainsi que les lois générales (notamment pénales). Si nous étions tenus responsables en raison de la configuration que vous avez effectuée pour violation des droits de tiers ou des lois générales, vous êtes tenu de nous indemniser pour toutes les réclamations et dommages y afférents.", Lj = "formulaire de contact", jj = "poursuivre avec {x}", Dj = "Remarque: Les designs non enregistrés seront malheureusement perdus lors de la consultation des projets.", Nj = "Actuellement dans le panier", Vj = "Aucun fichier n'a encore été téléchargé", Uj = "Individuel", Fj = "Type de motif", qj = "Personnalisations", Bj = "Design|Designs", Hj = "Distance motif/texte", Gj = "Voulez-vous renommer {name}?", Wj = "Glisser le fichier directement dans le champ", Zj = "brillance des couleurs, polyvalence", Kj = "impression par transfert digital expressive", Qj = "idéal pour les grandes impressions", Xj = "tailles et couleurs flexibles", Jj = "pour une sélection de textiles et tous les basiques", Yj = "Lavage en machine jusqu’à 40 °C", eD = "L'élément est en-dehors de la surface de placement.", tD = "élégance, discrétion", nD = "Broderie de très haute qualité et durable", oD = "possible pour un grand nombre d'articles", aD = "de nombreux motifs et différentes couleurs de fils", sD = "tous les textiles, même les plus usagés", iD = "lavable très chaud, y compris avec un lavage industriel", rD = "L'archivage de la variante a échoué. Veuillez réessayer.", lD = "L'enregistrement de la variante a échoué. Veuillez réessayer.", cD = "Une erreur est survenue lors du chargement.", uD = "Une erreur est survenue lors de l'affichage des modifications. Veuillez essayer une nouvelle fois (plus tard).", dD = "Une erreur inattendue est survenue lors du chargement de la variante. Veuillez essayer une nouvelle fois (plus tard) ou créez une nouvelle personnalisation.", mD = "Une erreur est survenue lors de la suppression de la variante d'archive. Veuillez réessayer.", pD = "moins de couleurs", fD = "Police", hD = "Police non disponible", _D = "Mise à jour de la police", vD = "Certaines polices ne sont plus disponibles. Veuillez en sélectionner une autre :", gD = "partir de 1 pièce", yD = "Vers l'aperçu de la personnalisation", kD = "Hauteur (en cm)", bD = "Aide au Téléversement", wD = "ici", xD = "Masquer les surfaces", $D = "Motif|Motifs", zD = "Base de données de motifs", SD = "Sélectionnez un motif dans notre base de données de motifs en développement constant. Vous aurez ensuite la possibilité de personnaliser votre motif.", CD = "Insérer un texte", AD = "Italique", PD = "i", TD = "Distance en bas", MD = "Charger", ID = "Logo|Logos", ED = "Logos & designs", OD = "Style", RD = "Taille du fichier : max.", LD = "Le nombre maximum de lignes est atteint.", jD = "Dans «{buttonName}» de nouveaux projets ont été mis à disposition pour vous.", DD = "Quantité minimum", ND = "uni", VD = "Autres couleurs", UD = "Les {termsOfServiceLink} suivantes s’appliquent à l’utilisation du « CI Configurator MYDESIGN ».", FD = "Attention : Un ou plusieurs de vos motifs ont été supprimés. Veuillez ajouter de nouveaux motifs et vérifier votre design.", qD = "Ce motif est utilisé dans votre design actuel.", BD = "multicolore", HD = "Mes personnalisations", GD = "Mes fichiers", WD = "Mes logos", ZD = "Nouvelle personnalisation", KD = "Nouveau design", QD = "Nouveau projet", XD = "motif suivant", JD = "Votre compte client ne contient actuellement pas de logos enregistrés pour {productionMethod}. Vous souhaitez faire enregistrer votre logo par nos services ? Alors veuillez nous contacter sur : {contact}. Sinon, vous pouvez changer le type de personnalisation en haut à droite.", YD = "Aucun logo n’est actuellement enregistré dans votre compte client pour {productionMethod}.", eN = "Votre compte client ne contient actuellement pas de designs {productionMethod}.", tN = "Aucun motif n’a malheureusement pu être trouvé pour votre filtre actuel.", nN = "Justifier à gauche", oN = "Majuscules uniquement", aN = "ou", sN = "Sinon, vous pouvez changer le type de personnalisation en haut à droite.", iN = "Téléchargement PDF", rN = "Positionner", lN = "Placer le motif", cN = "Veuillez corriger les champs marqués pour afficher votre motif.", uN = "Merci de patienter un instant.", dN = "Aperçu", mN = "Aperçu des emplacements possibles", pN = "Prix", fN = "Modifier la couleur de l'article", hN = "Type de personnalisation", _N = "Le type de personnalisation sur cet article n'est malheureusement pas possible.", vN = "impression par transfert digital expressive", gN = "Broderie de très haute qualité et durable", yN = "Quantité", kN = "Récemment téléchargé", bN = "Récemment utilisé", wN = "Renommer", xN = "remplacer", $N = "Enregistrer", zN = "enregistrer & charger", SN = "Enregistrer la personnalisation", CN = "Enregistré", AN = "Votre design a été enregistré avec succès sous le nom {name}.", PN = "Designs enregistrés", TN = "Rechercher un motif", MN = "Choisir la couleur", IN = "Sélectionner un fichier", EN = "Choisir une police", ON = "Session expirée", RN = "Votre session est expirée. Veuillez recharger la page pour pouvoir continuer à utiliser l'outil de conception.", LN = "Afficher {count} résultat|Afficher {count} résultats", jN = "Afficher les surfaces", DN = "Afficher mes fichiers", NN = "Consulter les projets maintenant", VN = "Taille", UN = "TAILLE (en cm)", FN = "Projets", qN = "Couleurs standard", BN = "Formats de fichiers pris en charge", HN = "conditions d’utilisation", GN = "Textiles", WN = "Texte", ZN = "Le design sélectionné remplacera votre sélection actuelle.", KN = "Cette action ne pourra pas être annulée.", QN = "Pour placer le motif souhaité, veuillez changer le type de personnalisation pour {toProductionMethod}. Vous pouvez ensuite choisir un emplacement correspondant.", XN = "Une tentative de restauration de votre session est en cours", JN = "mettre à jour", YN = "Mettre à jour l’article, personnalisation incluse", eV = "Télécharger un autre fichier", tV = "Souhaitez-vous que nous enregistrions votre logo ? Veuillez nous envoyer votre logo via le {contact_form} en indiquant votre numéro client, les numéros d’article et l’emplacement souhaité sur les articles.", nV = "Malheureusement, votre fichier ne répond pas aux exigences techniques. Veuillez télécharger un autre format de fichier. Vous trouverez plus d’informations {here}.", oV = "Échec du téléchargement – Votre fichier SVG contient des éléments d’image. Veuillez supprimer les images intégrées et téléverser le fichier à nouveau.", aV = "Échec du téléchargement – Votre fichier SVG contient des polices non converties. Veuillez convertir les polices en tracés avant de téléverser le fichier à nouveau.", sV = "Échec du téléchargement – Une erreur inattendue est survenue. Veuillez réessayer ou utiliser un autre format de fichier.", iV = "Télécharger un fichier", rV = "Télécharger son propre fichier", lV = "Remarque : Vos contenus téléchargés (images/graphismes/textes) sont automatiquement vérifiés, notamment à l’aide de procédés assistés par l’IA, pour s’assurer qu’ils respectent les exigences légales et qualitatives de nos conditions {termsOfServiceLink} (par ex. droits d’auteur/marques, caractères interdits, droits de la personnalité, contenus haineux/violents). Les anomalies sont vérifiées par notre personnel ; les décisions finales ne sont pas prises exclusivement de façon automatisée. Vous trouverez des informations détaillées sur le traitement des données dans notre politique de confidentialité.", cV = "Téléchargements", uV = "Votre personnalisation à", dV = "Lavabilité", mV = "Largeur (en cm)", pV = "Votre fichier est en cours de téléchargement...", fV = "Zoom", hV = {
  abort: oj,
  add_logo: aj,
  add_text: sj,
  add_text_line: ij,
  add_to_cart: rj,
  align: lj,
  all_positioning_areas_are_occupied: cj,
  apply: uj,
  apply_to_all_lines: dj,
  archive: mj,
  archive_fetch_selected_customization: pj,
  archive_fetch_variant_with_customizations: fj,
  archive_new_entry_soon_available: hj,
  archived_variant_successfully: _j,
  are_you_sure_you_want_to_delete: vj,
  at_least_one_motiv_is_not_available: gj,
  attention: yj,
  back: kj,
  bend_text_line: bj,
  boot_error: wj,
  change_production_method_info: xj,
  change_to_x: $j,
  choose: zj,
  choose_a_positioning_area: Sj,
  choose_icon: Cj,
  choose_logo: Aj,
  choose_production_method: Pj,
  clear_filters: Tj,
  color: Mj,
  colors: Ij,
  confirm: Ej,
  confirmation: Oj,
  confirmation_description: Rj,
  contact_form: Lj,
  continue: "Suite",
  continue_with_x: jj,
  current_edited_customization_will_be_aborted: Dj,
  currently_in_cart: Nj,
  currently_no_uploaded_files: Vj,
  custom: Uj,
  customization_type: Fj,
  customizations: qj,
  delete: "Supprimer",
  designs: Bj,
  distance_motif_text: Hj,
  do_you_want_to_rename: Gj,
  drag_file_over_area: Wj,
  dtf_look: Zj,
  dtf_selling_point_1: Kj,
  dtf_selling_point_2: Qj,
  dtf_selling_point_3: Xj,
  dtf_textiles: Jj,
  dtf_washability: Yj,
  element_outside_placement_area: eD,
  embroidery_look: tD,
  embroidery_selling_point_1: nD,
  embroidery_selling_point_2: oD,
  embroidery_selling_point_3: aD,
  embroidery_textiles: sD,
  embroidery_washability: iD,
  error_failed_to_archive_variant: rD,
  error_failed_to_save_variant: lD,
  error_loading: cD,
  error_pusher_rendering_failed: uD,
  error_pusher_rendering_failed_while_loading_variant: dD,
  error_while_deleting_archive_variant: mD,
  fewer_colors: pD,
  font: fD,
  font_not_available: hD,
  font_update: _D,
  font_update_explanation: vD,
  from_one_piece: gD,
  go_to_production_method_overview: yD,
  height_abbreviation: kD,
  help_for_upload: bD,
  here: wD,
  hide_areas: xD,
  icon: $D,
  icon_database: zD,
  icon_database_description: SD,
  insert_text: CD,
  italic: AD,
  italic_short: PD,
  line_height: TD,
  loading: MD,
  logos: ID,
  logos_and_designs: ED,
  look: OD,
  max_file_size: RD,
  maximum_number_of_lines: LD,
  merchant_sketch_variant_added: jD,
  minimum_quantity: DD,
  mono_colored: ND,
  more_colors: VD,
  more_informations_about_upload: UD,
  motif_deleted: FD,
  motif_placed_in_current_design: qD,
  multi_colored: BD,
  my_customizations: HD,
  my_files: GD,
  my_logos: WD,
  new: "nouveau",
  new_customization: ZD,
  new_design: KD,
  new_sketch: QD,
  next_motif: XD,
  no_customer_logos: JD,
  no_customer_logos_for_production_method: YD,
  no_designs: eN,
  no_motifs: tN,
  offset_left: nN,
  only_uppercase: oN,
  or: aN,
  otherwise_change_personalization_type_top_right: sN,
  pdf_download: iN,
  place: rN,
  place_logo: lN,
  please_correct_the_highlighted_errors: cN,
  please_hold_on_for_a_moment: uN,
  preview: dN,
  preview_of_possibile_positioning_areas: mN,
  price: pN,
  product_colors: fN,
  production_method: hN,
  production_method_not_available_for_variant: _N,
  production_method_summary_dtf: vN,
  production_method_summary_embroidery: gN,
  quantity: yN,
  recently_uploaded: kN,
  recently_used: bN,
  rename: wN,
  replace: xN,
  save: $N,
  save_and_load: zN,
  save_variant: SN,
  saved: CN,
  saved_design_successfully: AN,
  saved_designs: PN,
  search_logo: TN,
  select_color: MN,
  select_file: IN,
  select_font: EN,
  session_expired: ON,
  session_expired_description: RN,
  show_X_results: LN,
  show_areas: jN,
  show_own_files: DN,
  show_sketches: NN,
  size: VN,
  size_in_unit: UN,
  sketches: FN,
  standard_colors: qN,
  supported_file_types: BN,
  terms_of_service: HN,
  textiles: GN,
  texts: WN,
  the_selected_design_will_replace_the_current_selection: ZN,
  this_action_can_not_be_undone: KN,
  to_place_motif_change_production_method: QN,
  trying_to_reconnect_session: XN,
  update: JN,
  update_article_with_designs: YN,
  upload_another_file: eV,
  upload_contact_form_hint: tV,
  upload_error_422_content_type: nV,
  upload_error_svg_contains_image: oV,
  upload_error_svg_contains_text: aV,
  upload_error_unexpected: sV,
  upload_file: iV,
  upload_own_file: rV,
  uploaded_content_automatically_checked_using_ai: lV,
  uploads: cV,
  views_preview_headlide: uV,
  washablility: dV,
  width_abbreviation: mV,
  your_file_is_beeing_uploaded: pV,
  zoom: fV
}, _V = "mégse", vV = "Logó hozzáadása", gV = "Szöveg hozzáadása", yV = "Sor hozzáadása", kV = "a rendeléshez", bV = "igazítás", wV = "Nincs szabad elhelyezési terület ezen a nézeten.", xV = "alkalmaz", $V = "Alkalmazás minden sorra", zV = "Archívum", SV = "Kiválasztott motívum betöltése", CV = "Termék betöltése személyre szabással", AV = "Egy új archív bejegyzés hamarosan elérhető lesz.", PV = "A személyre szabás sikeresen mentve.", TV = "Valóban törölni szeretné: { deleteName }?", MV = "Legalább egy minta már nem érhető el!", IV = "Figyelem", EV = "vissza", OV = "Szöveg hajlítása", RV = { authentication: "A hitelesítés sikertelen.", headline: "Hiba történt a konfigurátor indításakor.", unexpected: "Váratlan hiba", variant_not_found: "A kívánt variáns nem található." }, LV = "Jelenleg a(z) {fromProductionMethod} elhelyezési területén van.", jV = "váltás erre: {x}", DV = "választ", NV = "Kérem válasszon elhelyezési területet.", VV = "Másik motívum választása", UV = "Másik logó választása", FV = "Személyre szabás módjának kiválasztása", qV = "összes szűrő törlése", BV = "Szín", HV = "Színek", GV = "megerősít", WV = "Megerősítés", ZV = "A kívánt személyre szabás feltöltésével megerősíti, hogy jogosult arra, hogy a személyre szabást textíliákra alkalmazzák, különösen hogy a személyre szabás nem sért név- és márkajogokat, formatervezési mintákat, szerzői jogokat vagy más harmadik fél jogokat, valamint általános (különösen büntetőjogi) törvényeket. Ha a konfiguráció miatt harmadik fél igényt vagy kártérítést támaszt, Ön köteles minket minden ilyen igénytől és kártól mentesíteni.", KV = "kapcsolatfelvételi űrlapon", QV = "folytatás ezzel: {x}", XV = "Figyelem: a nem mentett tervek elvesznek a vázlatok megnyitásakor.", JV = "Jelenleg a kosárban", YV = "Eddig nem töltött fel fájlt", eU = "Egyedi", tU = "Motívum típusa", nU = "Személyre szabások", oU = "Design|Designok", aU = "Motívum/szöveg távolság (mm-ben)", sU = "Át szeretné nevezni ezt: {name}?", iU = "Fájl közvetlen húzása a mezőre", rU = "élénk színek, sokféleség", lU = "kifejező digitális transzfer", cU = "optimális nagy nyomatokhoz", uU = "rugalmas méretekben és színekben", dU = "kiválasztott textíliákhoz és minden alapdarabhoz", mU = "Mosógépben mosható 40˚C-ig", pU = "Az elem az elhelyezési területen kívül van.", fU = "elegáns, finom", hU = "nagyon kiváló minőségű és tartós hímzés", _U = "sokféle termékhez elérhető", vU = "sok motívum és fonalszín", gU = "minden textíliához, beleértve az erősen igénybevetteket is", yU = "magas hőfokon is mosható, ipari mosásban is", kU = "A variáns archiválása nem sikerült. Próbálja újra.", bU = "A variáns mentése nem sikerült. Próbálja újra.", wU = "Hiba történt a betöltés során.", xU = "Hiba történt a változások megjelenítésekor. Próbálja meg később.", $U = "A variáns betöltése közben váratlan hiba történt. Próbálja meg később, vagy hozzon létre új személyre szabást.", zU = "Hiba történt az archív variáns törlésekor. Próbálja újra.", SU = "kevesebb szín", CU = "Betűtípus", AU = "A betűtípus nem érhető el", PU = "Betűtípus frissítése", TU = "Néhány betűtípus már nem érhető el. Kérjük, válassz másikat:", MU = "már 1 darabtól", IU = "Személyre szabás áttekintése", EU = "Magasság (cm-ben)", OU = "Feltöltési súgó", RU = "itt", LU = "Területek elrejtése", jU = "Motívum|Motívumok", DU = "Motívum-adatbázis", NU = "Válasszon motívumot folyamatosan bővülő motívum-adatbázisunkból. Ezután testre szabhatja a motívumot.", VU = "Szöveg beillesztése", UU = "dőlt", FU = "d", qU = "Alsó térköz", BU = "betöltés", HU = "Logó|Logók", GU = "Logók & designok", WU = "Megjelenés", ZU = "Fájlméret: max.", KU = "Elérte a maximális sorszámot.", QU = 'Új vázlatok elérhetők a(z) "{buttonName}" alatt.', XU = "Minimális mennyiség", JU = "egyszínű", YU = "további színek", eF = "A „CI Configurator MYDESIGN” használatára a következő {termsOfServiceLink} vonatkozik.", tF = "Figyelem: Egy vagy több motivumot töröltek. Kérjük, adjon hozzá új motivumokat, és ellenőrizze a dizájnját.", nF = "Ez a motívum jelenlegi tervében van elhelyezve.", oF = "többszínű", aF = "Saját személyre szabások", sF = "Saját fájlok", iF = "Saját logók", rF = "Új személyre szabás", lF = "Új design", cF = "Új vázlat", uF = "következő minta", dF = "Fiókjában jelenleg nincs logó ehhez: {productionMethod}. Szeretné, hogy feltöltsük a logóját? Lépjen kapcsolatba velünk: {contact}. Vagy válthat személyre szabási módot jobb felül.", mF = "Jelenleg nincsenek a(z) {productionMethod} számára elmentett logók az ügyfélfiókodban.", pF = "Fiókjában jelenleg nincs design ehhez: {productionMethod}.", fF = "A jelenlegi szűréshez nincs motívum ehhez: {productionMethod}.", hF = "Bal behúzás", _F = "Csak nagybetűk", vF = "vagy", gF = "Ellenkező esetben a jobb felső sarokban átválthatod a testreszabás típusát.", yF = "PDF letöltése", kF = "elhelyez", bF = "Motívum elhelyezése", wF = "Kérjük, javítsa a megjelölt mezőket a motívum megjelenítéséhez.", xF = "Kérem, várjon egy pillanatot.", $F = "Előnézet", zF = "Lehetséges elhelyezési területek előnézete", SF = "Ár", CF = "Termékszín megváltoztatása", AF = "Személyre szabás módja", PF = "Ez a személyre szabás ezen a terméken nem lehetséges.", TF = "kifejező digitális transzfer", MF = "nagyon kiváló minőségű és tartós hímzés", IF = "Mennyiség", EF = "Legutóbb feltöltött", OF = "Legutóbb használt", RF = "átnevez", LF = "cserél", jF = "mentés", DF = "mentés & betöltés", NF = "Személyre szabás mentése", VF = "Elmentve", UF = "A design sikeresen elmentve ezen a néven: {name}.", FF = "Elmentett designok", qF = "Motívum keresése", BF = "Szín kiválasztása", HF = "Fájl kiválasztása", GF = "Betűtípus kiválasztása", WF = "A munkamenet lejárt", ZF = "A munkamenete lejárt. Frissítse az oldalt a konfigurátor folytatásához.", KF = "{count} találat megjelenítése|{count} találat megjelenítése", QF = "Területek megjelenítése", XF = "Saját fájlok megjelenítése", JF = "Vázlatok megtekintése", YF = "Méret", eq = "Méret (cm-ben)", tq = "Vázlatok", nq = "Standard színek", oq = "Támogatott fájltípusok", aq = "Felhasználási feltételek", sq = "Textíliák", iq = "Szöveg", rq = "A kiválasztott design lecseréli az aktuális választást", lq = "Ez a művelet nem vonható vissza.", cq = "A kívánt motívum elhelyezéséhez válasszon másik személyre szabási módot: {toProductionMethod}. Ezután választhat megfelelő területet.", uq = "Munkamenet visszaállítása folyamatban.", dq = "frissítés", mq = "Termék frissítése a testreszabással együtt", pq = "További fájl feltöltése", fq = "Szeretné, ha regisztrálnánk a logóját? Kérjük, küldje el nekünk a logóját a {contact_form} keresztül, és tüntesse fel az ügyfélszámát, a cikkszámokat és a kívánt elhelyezést a termékeken.", hq = "A fájl nem felel meg a technikai követelményeknek. Töltsön fel másik fájlformátumot. További információk {here}.", _q = "Feltöltés nem lehetséges – az SVG fájl képelemeket tartalmaz. Távolítsa el a beágyazott képeket és töltse fel újra a fájlt.", vq = "Feltöltés nem lehetséges – az SVG fájl nem beágyazott betűtípusokat tartalmaz. Alakítsa a betűket görbékké, majd töltse fel újra a fájlt.", gq = "A feltöltés sikertelen – váratlan hiba történt. Próbálja újra vagy válasszon másik fájlformátumot.", yq = "Fájl feltöltése", kq = "Saját fájl feltöltése", bq = "Feltöltések", wq = "Megjegyzés: A feltöltött tartalmakat (képek/grafikák/szövegek) automatikusan, többek között mesterséges intelligencia alapú eljárásokkal is ellenőrizzük jogi és minőségi követelményeinknek {termsOfServiceLink} (pl. szerzői/márkajogok, tiltott karakterek, személyiségi jogok, gyűlöletkeltő/erőszakos tartalom). Az észlelt eltéréseket munkatársaink ellenőrzik; a végső döntéseket nem kizárólag automatikusan hozzuk meg. Az adatkezelés részleteit adatvédelmi tájékoztatónkban találja.", xq = "Személyre szabása innen:", $q = "Moshatóság", zq = "Szélesség (cm-ben)", Sq = "A fájl feltöltése folyamatban...", Cq = "Zoom", Aq = {
  abort: _V,
  add_logo: vV,
  add_text: gV,
  add_text_line: yV,
  add_to_cart: kV,
  align: bV,
  all_positioning_areas_are_occupied: wV,
  apply: xV,
  apply_to_all_lines: $V,
  archive: zV,
  archive_fetch_selected_customization: SV,
  archive_fetch_variant_with_customizations: CV,
  archive_new_entry_soon_available: AV,
  archived_variant_successfully: PV,
  are_you_sure_you_want_to_delete: TV,
  at_least_one_motiv_is_not_available: MV,
  attention: IV,
  back: EV,
  bend_text_line: OV,
  boot_error: RV,
  change_production_method_info: LV,
  change_to_x: jV,
  choose: DV,
  choose_a_positioning_area: NV,
  choose_icon: VV,
  choose_logo: UV,
  choose_production_method: FV,
  clear_filters: qV,
  color: BV,
  colors: HV,
  confirm: GV,
  confirmation: WV,
  confirmation_description: ZV,
  contact_form: KV,
  continue: "folytatás",
  continue_with_x: QV,
  current_edited_customization_will_be_aborted: XV,
  currently_in_cart: JV,
  currently_no_uploaded_files: YV,
  custom: eU,
  customization_type: tU,
  customizations: nU,
  delete: "törlés",
  designs: oU,
  distance_motif_text: aU,
  do_you_want_to_rename: sU,
  drag_file_over_area: iU,
  dtf_look: rU,
  dtf_selling_point_1: lU,
  dtf_selling_point_2: cU,
  dtf_selling_point_3: uU,
  dtf_textiles: dU,
  dtf_washability: mU,
  element_outside_placement_area: pU,
  embroidery_look: fU,
  embroidery_selling_point_1: hU,
  embroidery_selling_point_2: _U,
  embroidery_selling_point_3: vU,
  embroidery_textiles: gU,
  embroidery_washability: yU,
  error_failed_to_archive_variant: kU,
  error_failed_to_save_variant: bU,
  error_loading: wU,
  error_pusher_rendering_failed: xU,
  error_pusher_rendering_failed_while_loading_variant: $U,
  error_while_deleting_archive_variant: zU,
  fewer_colors: SU,
  font: CU,
  font_not_available: AU,
  font_update: PU,
  font_update_explanation: TU,
  from_one_piece: MU,
  go_to_production_method_overview: IU,
  height_abbreviation: EU,
  help_for_upload: OU,
  here: RU,
  hide_areas: LU,
  icon: jU,
  icon_database: DU,
  icon_database_description: NU,
  insert_text: VU,
  italic: UU,
  italic_short: FU,
  line_height: qU,
  loading: BU,
  logos: HU,
  logos_and_designs: GU,
  look: WU,
  max_file_size: ZU,
  maximum_number_of_lines: KU,
  merchant_sketch_variant_added: QU,
  minimum_quantity: XU,
  mono_colored: JU,
  more_colors: YU,
  more_informations_about_upload: eF,
  motif_deleted: tF,
  motif_placed_in_current_design: nF,
  multi_colored: oF,
  my_customizations: aF,
  my_files: sF,
  my_logos: iF,
  new: "új",
  new_customization: rF,
  new_design: lF,
  new_sketch: cF,
  next_motif: uF,
  no_customer_logos: dF,
  no_customer_logos_for_production_method: mF,
  no_designs: pF,
  no_motifs: fF,
  offset_left: hF,
  only_uppercase: _F,
  or: vF,
  otherwise_change_personalization_type_top_right: gF,
  pdf_download: yF,
  place: kF,
  place_logo: bF,
  please_correct_the_highlighted_errors: wF,
  please_hold_on_for_a_moment: xF,
  preview: $F,
  preview_of_possibile_positioning_areas: zF,
  price: SF,
  product_colors: CF,
  production_method: AF,
  production_method_not_available_for_variant: PF,
  production_method_summary_dtf: TF,
  production_method_summary_embroidery: MF,
  quantity: IF,
  recently_uploaded: EF,
  recently_used: OF,
  rename: RF,
  replace: LF,
  save: jF,
  save_and_load: DF,
  save_variant: NF,
  saved: VF,
  saved_design_successfully: UF,
  saved_designs: FF,
  search_logo: qF,
  select_color: BF,
  select_file: HF,
  select_font: GF,
  session_expired: WF,
  session_expired_description: ZF,
  show_X_results: KF,
  show_areas: QF,
  show_own_files: XF,
  show_sketches: JF,
  size: YF,
  size_in_unit: eq,
  sketches: tq,
  standard_colors: nq,
  supported_file_types: oq,
  terms_of_service: aq,
  textiles: sq,
  texts: iq,
  the_selected_design_will_replace_the_current_selection: rq,
  this_action_can_not_be_undone: lq,
  to_place_motif_change_production_method: cq,
  trying_to_reconnect_session: uq,
  update: dq,
  update_article_with_designs: mq,
  upload_another_file: pq,
  upload_contact_form_hint: fq,
  upload_error_422_content_type: hq,
  upload_error_svg_contains_image: _q,
  upload_error_svg_contains_text: vq,
  upload_error_unexpected: gq,
  upload_file: yq,
  upload_own_file: kq,
  uploads: bq,
  uploaded_content_automatically_checked_using_ai: wq,
  views_preview_headlide: xq,
  washablility: $q,
  width_abbreviation: zq,
  your_file_is_beeing_uploaded: Sq,
  zoom: Cq
}, Pq = "annulla", Tq = "Aggiungi logo", Mq = "Aggiungi testo", Iq = "Aggiungi riga", Eq = "aggiungi all’ordine", Oq = "allinea", Rq = "Nessuna area di posizionamento libera in questa vista.", Lq = "applica", jq = "Applica a tutte le righe", Dq = "Archivio", Nq = "Carica motivo selezionato", Vq = "Carica articolo con personalizzazione", Uq = "Una nuova voce d’archivio sarà presto disponibile.", Fq = "La tua personalizzazione è stata salvata con successo.", qq = "Vuoi davvero eliminare { deleteName }?", Bq = "Almeno una grafica non è più disponibile!", Hq = "Attenzione", Gq = "indietro", Wq = "Curva il testo", Zq = { authentication: "Autenticazione fallita.", headline: "Si è verificato un errore all’avvio del configuratore.", unexpected: "Errore inatteso", variant_not_found: "La variante richiesta non è stata trovata." }, Kq = "Sei attualmente nell’area di posizionamento per {fromProductionMethod}.", Qq = "passa a {x}", Xq = "scegli", Jq = "Seleziona un’area di posizionamento.", Yq = "Scegli un altro motivo", eB = "Scegli un altro logo", tB = "Scegli il tipo di personalizzazione", nB = "cancella tutti i filtri", oB = "Colore", aB = "Colori", sB = "conferma", iB = "Conferma", rB = "Caricando la personalizzazione desiderata, confermi di essere autorizzato a far applicare la personalizzazione sui tessuti, in particolare che la personalizzazione non viola diritti su nomi e marchi, diritti di design, diritti d’autore o altri diritti di terzi nonché leggi generali (in particolare penali). Se dovessimo essere chiamati in causa a causa della configurazione da te effettuata per violazione di diritti di terzi o di leggi generali, sarai obbligato a risarcirci da tutte le richieste e i danni connessi.", lB = "modulo di contatto", cB = "continua con {x}", uB = "Attenzione: i design non salvati andranno persi aprendo i bozzetti.", dB = "Attualmente nel carrello", mB = "Nessun file caricato finora", pB = "Personalizzato", fB = "Tipo di motivo", hB = "Personalizzazioni", _B = "Design|Design", vB = "Distanza motivo/testo (in mm)", gB = "Vuoi rinominare {name}?", yB = "Trascina il file direttamente nel campo", kB = "colori vivaci, versatilità", bB = "transfer digitale espressivo", wB = "ottimale per stampe di grandi dimensioni", xB = "flessibile per dimensioni e colori", $B = "per tessuti selezionati e tutti i basici", zB = "Lavaggio in lavatrice fino a 40˚C", SB = "L’elemento è fuori dall’area di posizionamento.", CB = "raffinato, delicato", AB = "ricamo di altissima qualità e durata", PB = "possibile per molti articoli", TB = "molti motivi e colori di filato", MB = "tutti i tessuti, anche prodotti molto usati", IB = "lavabile ad alte temperature, anche industrialmente", EB = "Archiviazione della variante non riuscita. Riprova.", OB = "Salvataggio della variante non riuscito. Riprova.", RB = "Si è verificato un errore durante il caricamento.", LB = "Errore nella visualizzazione delle modifiche. Riprova più tardi.", jB = "Errore imprevisto durante il caricamento della variante. Riprova più tardi o crea una nuova personalizzazione.", DB = "Errore nell’eliminazione della variante archiviata. Riprova.", NB = "meno colori", VB = "Carattere", UB = "Font non disponibile", FB = "Aggiornamento font", qB = "Alcuni font non sono più disponibili. Selezionane un altro:", BB = "da 1 pezzo", HB = "Vai alla panoramica personalizzazione", GB = "Altezza (in cm)", WB = "Aiuto per il caricamento file", ZB = "qui", KB = "Nascondi aree", QB = "Motivo|Motivi", XB = "Database motivi", JB = "Scegli un motivo dal nostro database in continua crescita. Poi puoi personalizzare il tuo motivo.", YB = "Inserisci testo", eH = "corsivo", tH = "c", nH = "Spaziatura inferiore", oH = "caricamento", aH = "Logo|Loghi", sH = "Loghi & design", iH = "Aspetto", rH = "Dimensione file: max.", lH = "Raggiunto il numero massimo di righe.", cH = 'Nuovi bozzetti disponibili in "{buttonName}".', uH = "Quantità minima", dH = "monocolore", mH = "altri colori", pH = "Si applicano le seguenti {termsOfServiceLink} per l’uso di „CI Configurator MYDESIGN“.", fH = "Attenzione: Uno o più dei tuoi motivi sono stati cancellati. Aggiungi nuovi motivi e verifica il tuo design.", hH = "Questo motivo è inserito nel tuo design attuale.", _H = "multicolore", vH = "Le mie personalizzazioni", gH = "I miei file", yH = "I miei loghi", kH = "Nuova personalizzazione", bH = "Nuovo design", wH = "Nuovo bozzetto", xH = "grafica successiva", $H = "Nessun logo per {productionMethod} ancora presente nel tuo account. Vuoi che aggiungiamo il tuo logo? Contattaci: {contact}. Oppure cambia tipo di personalizzazione in alto a destra.", zH = "Nel Suo account cliente al momento non sono presenti loghi per {productionMethod}.", SH = "Nessun design per {productionMethod} ancora presente nel tuo account.", CH = "Nessun motivo per {productionMethod} corrispondente ai filtri attuali.", AH = "Rientro a sinistra", PH = "Solo lettere maiuscole", TH = "oppure", MH = "In caso contrario, può cambiare il tipo di personalizzazione in alto a destra.", IH = "Download PDF", EH = "posiziona", OH = "Posiziona motivo", RH = "Corregga i campi contrassegnati per visualizzare il suo motivo.", LH = "Attendere un attimo.", jH = "Anteprima", DH = "Anteprima delle aree di posizionamento possibili", NH = "Prezzo", VH = "Cambia colore articolo", UH = "Tipo di personalizzazione", FH = "Tipo di personalizzazione non possibile su questo prodotto.", qH = "transfer digitale espressivo", BH = "ricamo di altissima qualità e durata", HH = "Quantità", GH = "Caricato di recente", WH = "Usato di recente", ZH = "rinomina", KH = "sostituisci", QH = "salva", XH = "salva & carica", JH = "Salva personalizzazione", YH = "Salvato", eG = "Il tuo design è stato salvato con il nome {name}.", tG = "Design salvati", nG = "Cerca motivo", oG = "Seleziona colore", aG = "Seleziona file", sG = "seleziona font", iG = "Sessione scaduta", rG = "La tua sessione è scaduta. Ricarica la pagina per continuare a utilizzare il configuratore.", lG = "Mostra {count} risultato|Mostra {count} risultati", cG = "Mostra aree", uG = "Mostra i miei file", dG = "Visualizza bozzetti", mG = "Dimensione", pG = "Dimensione (in cm)", fG = "Bozzetti", hG = "Colori standard", _G = "Formati di file supportati", vG = "Condizioni d’uso", gG = "Tessili", yG = "Testo", kG = "Il design selezionato sostituirà la selezione attuale", bG = "Questa azione non può essere annullata.", wG = "Per posizionare il motivo desiderato, cambia il tipo di personalizzazione in {toProductionMethod}. Poi potrai selezionare un’area adatta.", xG = "Tentativo di ripristino sessione.", $G = "aggiorna", zG = "aggiorna il prodotto, personalizzazione inclusa", SG = "Carica un altro file", CG = "Desidera che registriamo il suo logo? Ci invii il suo logo tramite il {contact_form}, indicando il numero cliente, i codici articolo e la posizione desiderata sugli articoli.", AG = "Il file non soddisfa i requisiti tecnici. Carica un altro formato. Maggiori informazioni {here}.", PG = "Caricamento non possibile – il file SVG contiene elementi immagine. Rimuovi le immagini incorporate e carica di nuovo.", TG = "Caricamento non possibile – il file SVG contiene font non incorporati. Converti i font in tracciati e carica di nuovo.", MG = "Caricamento non riuscito – si è verificato un errore imprevisto. Riprova o usa un altro formato.", IG = "Carica file", EG = "Carica file proprio", OG = "Nota: I tuoi contenuti caricati (immagini/grafiche/testi) vengono controllati automaticamente – anche con procedure supportate da IA – per verificarne la conformità ai requisiti legali e qualitativi previsti dalle nostre condizioni {termsOfServiceLink} (ad esempio diritti d’autore/marchi, caratteri vietati, diritti della personalità, contenuti d'odio/violenti). Eventuali anomalie vengono verificate dal nostro personale; le decisioni finali non sono prese esclusivamente in modo automatizzato. I dettagli sul trattamento dei dati sono disponibili nella nostra informativa sulla privacy.", RG = "Caricamenti", LG = "La tua personalizzazione di", jG = "Lavabilità", DG = "Larghezza (in cm)", NG = "Il file è in fase di caricamento...", VG = "Zoom", UG = {
  abort: Pq,
  add_logo: Tq,
  add_text: Mq,
  add_text_line: Iq,
  add_to_cart: Eq,
  align: Oq,
  all_positioning_areas_are_occupied: Rq,
  apply: Lq,
  apply_to_all_lines: jq,
  archive: Dq,
  archive_fetch_selected_customization: Nq,
  archive_fetch_variant_with_customizations: Vq,
  archive_new_entry_soon_available: Uq,
  archived_variant_successfully: Fq,
  are_you_sure_you_want_to_delete: qq,
  at_least_one_motiv_is_not_available: Bq,
  attention: Hq,
  back: Gq,
  bend_text_line: Wq,
  boot_error: Zq,
  change_production_method_info: Kq,
  change_to_x: Qq,
  choose: Xq,
  choose_a_positioning_area: Jq,
  choose_icon: Yq,
  choose_logo: eB,
  choose_production_method: tB,
  clear_filters: nB,
  color: oB,
  colors: aB,
  confirm: sB,
  confirmation: iB,
  confirmation_description: rB,
  contact_form: lB,
  continue: "continua",
  continue_with_x: cB,
  current_edited_customization_will_be_aborted: uB,
  currently_in_cart: dB,
  currently_no_uploaded_files: mB,
  custom: pB,
  customization_type: fB,
  customizations: hB,
  delete: "elimina",
  designs: _B,
  distance_motif_text: vB,
  do_you_want_to_rename: gB,
  drag_file_over_area: yB,
  dtf_look: kB,
  dtf_selling_point_1: bB,
  dtf_selling_point_2: wB,
  dtf_selling_point_3: xB,
  dtf_textiles: $B,
  dtf_washability: zB,
  element_outside_placement_area: SB,
  embroidery_look: CB,
  embroidery_selling_point_1: AB,
  embroidery_selling_point_2: PB,
  embroidery_selling_point_3: TB,
  embroidery_textiles: MB,
  embroidery_washability: IB,
  error_failed_to_archive_variant: EB,
  error_failed_to_save_variant: OB,
  error_loading: RB,
  error_pusher_rendering_failed: LB,
  error_pusher_rendering_failed_while_loading_variant: jB,
  error_while_deleting_archive_variant: DB,
  fewer_colors: NB,
  font: VB,
  font_not_available: UB,
  font_update: FB,
  font_update_explanation: qB,
  from_one_piece: BB,
  go_to_production_method_overview: HB,
  height_abbreviation: GB,
  help_for_upload: WB,
  here: ZB,
  hide_areas: KB,
  icon: QB,
  icon_database: XB,
  icon_database_description: JB,
  insert_text: YB,
  italic: eH,
  italic_short: tH,
  line_height: nH,
  loading: oH,
  logos: aH,
  logos_and_designs: sH,
  look: iH,
  max_file_size: rH,
  maximum_number_of_lines: lH,
  merchant_sketch_variant_added: cH,
  minimum_quantity: uH,
  mono_colored: dH,
  more_colors: mH,
  more_informations_about_upload: pH,
  motif_deleted: fH,
  motif_placed_in_current_design: hH,
  multi_colored: _H,
  my_customizations: vH,
  my_files: gH,
  my_logos: yH,
  new: "nuovo",
  new_customization: kH,
  new_design: bH,
  new_sketch: wH,
  next_motif: xH,
  no_customer_logos: $H,
  no_customer_logos_for_production_method: zH,
  no_designs: SH,
  no_motifs: CH,
  offset_left: AH,
  only_uppercase: PH,
  or: TH,
  otherwise_change_personalization_type_top_right: MH,
  pdf_download: IH,
  place: EH,
  place_logo: OH,
  please_correct_the_highlighted_errors: RH,
  please_hold_on_for_a_moment: LH,
  preview: jH,
  preview_of_possibile_positioning_areas: DH,
  price: NH,
  product_colors: VH,
  production_method: UH,
  production_method_not_available_for_variant: FH,
  production_method_summary_dtf: qH,
  production_method_summary_embroidery: BH,
  quantity: HH,
  recently_uploaded: GH,
  recently_used: WH,
  rename: ZH,
  replace: KH,
  save: QH,
  save_and_load: XH,
  save_variant: JH,
  saved: YH,
  saved_design_successfully: eG,
  saved_designs: tG,
  search_logo: nG,
  select_color: oG,
  select_file: aG,
  select_font: sG,
  session_expired: iG,
  session_expired_description: rG,
  show_X_results: lG,
  show_areas: cG,
  show_own_files: uG,
  show_sketches: dG,
  size: mG,
  size_in_unit: pG,
  sketches: fG,
  standard_colors: hG,
  supported_file_types: _G,
  terms_of_service: vG,
  textiles: gG,
  texts: yG,
  the_selected_design_will_replace_the_current_selection: kG,
  this_action_can_not_be_undone: bG,
  to_place_motif_change_production_method: wG,
  trying_to_reconnect_session: xG,
  update: $G,
  update_article_with_designs: zG,
  upload_another_file: SG,
  upload_contact_form_hint: CG,
  upload_error_422_content_type: AG,
  upload_error_svg_contains_image: PG,
  upload_error_svg_contains_text: TG,
  upload_error_unexpected: MG,
  upload_file: IG,
  upload_own_file: EG,
  uploaded_content_automatically_checked_using_ai: OG,
  uploads: RG,
  views_preview_headlide: LG,
  washablility: jG,
  width_abbreviation: DG,
  your_file_is_beeing_uploaded: NG,
  zoom: VG
}, FG = "annuleren", qG = "Logo toevoegen", BG = "Tekst toevoegen", HG = "Regel toevoegen", GG = "aan winkelwagen toevoegen", WG = "uitlijnen", ZG = "Geen vrije plaatsingsgebieden op deze weergave.", KG = "toepassen", QG = "Op alle regels toepassen", XG = "Archief", JG = "Geselecteerde aanpassing laden", YG = "Artikel inclusief personalisatie laden", eW = "Een nieuw archief-item is binnenkort beschikbaar.", tW = "Uw personalisatie is succesvol opgeslagen.", nW = "Weet u zeker dat u {deleteName} wilt verwijderen?", oW = "Minstens één ontwerp is niet meer beschikbaar!", aW = "Let op", sW = "terug", iW = "Tekst buigen", rW = { authentication: "De authenticatie is mislukt.", headline: "Er is een fout opgetreden bij het starten van de configurator.", unexpected: "Onverwachte fout", variant_not_found: "De gewenste variant is niet gevonden." }, lW = "U bevindt zich momenteel op een plaatsingsgebied voor {fromProductionMethod}.", cW = "overschakelen naar {x}", uW = "kiezen", dW = "Selecteer een plaatsingsgebied.", mW = "Ander motief selecteren", pW = "Ander logo selecteren", fW = "Personalisatieoptie kiezen", hW = "alle filters wissen", _W = "Kleur", vW = "Kleuren", gW = "bevestigen", yW = "Bevestiging", kW = "Door de gewenste personalisatie te uploaden bevestigt u dat u gemachtigd bent om de personalisatie op textiel te laten aanbrengen, in het bijzonder dat de personalisatie geen inbreuk maakt op naam- en merkrechten, ontwerprechten, auteursrechten of andere rechten van derden, evenals op algemene (vooral strafrechtelijke) wetten. Mocht ons aansprakelijk worden gesteld vanwege de door u aangebrachte configuratie wegens schending van rechten van derden of algemene wetten, dan bent u verplicht ons te vrijwaren van alle aanspraken en schade in dit verband.", bW = "contactformulier", wW = "doorgaan met {x}", xW = "Opmerking: Niet-opgeslagen ontwerpen gaan verloren bij het openen van de ontwerpen.", $W = "Momenteel in winkelwagen", zW = "Er zijn nog geen bestanden geüpload", SW = "Aangepast", CW = "Motieftype", AW = "Personalisaties", PW = "Ontwerp|Ontwerpen", TW = "Afstand Motief/Tekst (in mm)", MW = "Wilt u {name} hernoemen?", IW = "Sleep bestand direct in het veld", EW = "kleurkrachtig, divers", OW = "expressieve digitale transfer", RW = "optimaal voor grote prints", LW = "flexibel in maten & kleuren", jW = "voor geselecteerde textiel & alle basics", DW = "Machinewas tot 40˚C", NW = "Element bevindt zich buiten het plaatsingsgebied.", VW = "elegant, filigraan", UW = "zeer hoogwaardige & duurzame borduring", FW = "mogelijk voor een groot aantal artikelen", qW = "veel motieven & verschillende kleuren garen", BW = "alle textiel, ook sterk belaste artikelen", HW = "heet wasbaar, ook industrieel wassen", GW = "Het archiveren van de variant is mislukt. Probeer het opnieuw.", WW = "Het opslaan van de variant is mislukt. Probeer het opnieuw.", ZW = "Er is een fout opgetreden bij het laden.", KW = "Er is een fout opgetreden bij het weergeven van de wijzigingen. Probeer het later opnieuw.", QW = "Bij het laden van de variant is een onverwachte fout opgetreden. Probeer het later opnieuw of maak een nieuwe personalisatie.", XW = "Er is een fout opgetreden bij het verwijderen van de archiefvariant. Probeer het opnieuw.", JW = "minder kleuren", YW = "Lettertype", eZ = "Lettertype niet beschikbaar", tZ = "Lettertype-update", nZ = "Sommige lettertypen zijn niet meer beschikbaar. Kies alstublieft een ander:", oZ = "vanaf 1 stuk", aZ = "Naar personalisatieoverzicht", sZ = "Hoogte (in cm)", iZ = "Hulp bij uploaden", rZ = "hier", lZ = "gebieden verbergen", cZ = "Motief|Motieven", uZ = "Motiefdatabase", dZ = "Kies een motief uit onze steeds groeiende motiefdatabase. Vervolgens kunt u uw motief personaliseren.", mZ = "Tekst invoegen", pZ = "cursief", fZ = "c", hZ = "Afstand onder", _Z = "laden", vZ = "Logo|Logo's", gZ = "Logo's & Ontwerpen", yZ = "Uiterlijk", kZ = "Bestandsgrootte: max.", bZ = "Het maximale aantal regels is bereikt.", wZ = 'Onder "{buttonName}" zijn nieuwe ontwerpen voor u beschikbaar gesteld.', xZ = "Minimale hoeveelheid", $Z = "eenvoudig", zZ = "meer kleuren", SZ = 'De volgende {termsOfServiceLink} zijn van toepassing op het gebruik van de "CI Configurator MYDESIGN."', CZ = "Let op: Een of meer van je ontwerpen zijn verwijderd. Voeg nieuwe ontwerpen toe en controleer je design.", AZ = "Dit motief is gebruikt in je huidige ontwerp.", PZ = "veelkleurig", TZ = "Mijn personalisaties", MZ = "Mijn bestanden", IZ = "Mijn logo's", EZ = "Nieuwe personalisatie", OZ = "Nieuw ontwerp", RZ = "Nieuw ontwerp", LZ = "volgend ontwerp", jZ = "Er zijn momenteel geen logo's in uw klantenaccount voor {productionMethod} opgeslagen. Wilt u uw logo door ons laten opslaan? Neem dan contact met ons op via: {contact}. U kunt anders de personaliseringsoptie bovenaan rechts wijzigen.", DZ = "Er zijn momenteel geen logo’s voor {productionMethod} opgeslagen in uw klantaccount.", NZ = "Er zijn momenteel geen ontwerpen in uw klantenaccount voor {productionMethod} opgeslagen.", VZ = "Voor uw huidige filter zijn momenteel geen {productionMethod}-motieven opgeslagen.", UZ = "Inspringen links", FZ = "Alleen hoofdletters", qZ = "of", BZ = "U kunt anders rechtsboven het personalisatietype wijzigen.", HZ = "PDF-download", GZ = "plaatsen", WZ = "Motief plaatsen", ZZ = "Corrigeer alstublieft de gemarkeerde velden om uw motief weer te geven.", KZ = "Een ogenblik geduld alstublieft.", QZ = "Voorbeeld", XZ = "Voorbeeld van mogelijke plaatsingsgebieden", JZ = "Prijs", YZ = "Artikelkleur wijzigen", eK = "Productiemethode", tK = "Productiemethode op dit artikel helaas niet mogelijk.", nK = "expressieve digitale transfer", oK = "zeer hoogwaardige & duurzame borduur", aK = "Hoeveelheid", sK = "Recent geüpload", iK = "Recent gebruikt", rK = "hernoemen", lK = "vervangen", cK = "opslaan", uK = "opslaan & laden", dK = "Personalisatie opslaan", mK = "Opgeslagen", pK = "Uw ontwerp is succesvol opgeslagen onder de naam {name}.", fK = "Opgeslagen ontwerpen", hK = "Motief zoeken", _K = "Kleur selecteren", vK = "Bestand selecteren", gK = "Lettertype kiezen", yK = "Sessie verlopen", kK = "Uw sessie is verlopen. Herlaad de pagina om de configurator verder te kunnen gebruiken.", bK = "{count} resultaat tonen|{count} resultaten tonen", wK = "gebieden tonen", xK = "Mijn bestanden weergeven", $K = "Ontwerpen nu bekijken", zK = "Grootte", SK = "Grootte (in cm)", CK = "Ontwerpen", AK = "Standaardkleuren", PK = "Ondersteunde bestandsformaten", TK = "gebruiksvoorwaarden", MK = "Textiel", IK = "Tekst", EK = "Het geselecteerde ontwerp vervangt uw huidige selectie", OK = "Deze actie kan niet ongedaan worden gemaakt.", RK = "Om het gewenste motief te plaatsen, moet u de personalisatieoptie wijzigen naar {toProductionMethod}. Daarna kunt u een geschikt plaatsingsgebied kiezen.", LK = "Proberen de sessie te herstellen.", jK = "bijwerken", DK = "Artikel inclusief personalisatie bijwerken", NK = "Nog een bestand uploaden", VK = "Wilt u dat wij uw logo voor u vastleggen? Stuur ons dan uw logo via het {contact_form}, onder vermelding van uw klantnummer, de artikelnummers en de gewenste plaatsing op de artikelen.", UK = "Helaas voldoet uw bestand niet aan de technische vereisten. Upload alstublieft een ander bestandsformaat. Meer informatie vindt u {here}.", FK = "Upload mislukt – Uw SVG-bestand bevat afbeeldingselementen. Verwijder de ingesloten afbeeldingen en upload het bestand opnieuw.", qK = "Upload mislukt – Uw SVG-bestand bevat niet-omgezette lettertypes. Zet alle tekst om naar contouren en upload het bestand opnieuw.", BK = "Upload mislukt – Er is een onverwachte fout opgetreden. Probeer het opnieuw of gebruik een ander bestandsformaat.", HK = "Bestand uploaden", GK = "Eigen bestand uploaden", WK = "Let op: Uw geüploade inhoud (afbeeldingen/grafieken/teksten) wordt automatisch gecontroleerd, onder meer met AI-ondersteunde methoden, op wettelijke en kwalitatieve eisen van onze {termsOfServiceLink} (bijv. auteursrechten/merkrechten, verboden tekens, persoonlijkheidsrechten, haat- of geweldsinhoud). Opvallende zaken worden door onze medewerkers gecontroleerd; definitieve beslissingen worden niet uitsluitend automatisch genomen. Details over gegevensverwerking vindt u in onze privacyverklaring.", ZK = "Uploads", KK = "Uw personalisatie van", QK = "Wasbaarheid", XK = "Breedte (in cm)", JK = "Uw bestand wordt momenteel geüpload...", YK = "Zoom", eQ = {
  abort: FG,
  add_logo: qG,
  add_text: BG,
  add_text_line: HG,
  add_to_cart: GG,
  align: WG,
  all_positioning_areas_are_occupied: ZG,
  apply: KG,
  apply_to_all_lines: QG,
  archive: XG,
  archive_fetch_selected_customization: JG,
  archive_fetch_variant_with_customizations: YG,
  archive_new_entry_soon_available: eW,
  archived_variant_successfully: tW,
  are_you_sure_you_want_to_delete: nW,
  at_least_one_motiv_is_not_available: oW,
  attention: aW,
  back: sW,
  bend_text_line: iW,
  boot_error: rW,
  change_production_method_info: lW,
  change_to_x: cW,
  choose: uW,
  choose_a_positioning_area: dW,
  choose_icon: mW,
  choose_logo: pW,
  choose_production_method: fW,
  clear_filters: hW,
  color: _W,
  colors: vW,
  confirm: gW,
  confirmation: yW,
  confirmation_description: kW,
  contact_form: bW,
  continue: "doorgaan",
  continue_with_x: wW,
  current_edited_customization_will_be_aborted: xW,
  currently_in_cart: $W,
  currently_no_uploaded_files: zW,
  custom: SW,
  customization_type: CW,
  customizations: AW,
  delete: "verwijderen",
  designs: PW,
  distance_motif_text: TW,
  do_you_want_to_rename: MW,
  drag_file_over_area: IW,
  dtf_look: EW,
  dtf_selling_point_1: OW,
  dtf_selling_point_2: RW,
  dtf_selling_point_3: LW,
  dtf_textiles: jW,
  dtf_washability: DW,
  element_outside_placement_area: NW,
  embroidery_look: VW,
  embroidery_selling_point_1: UW,
  embroidery_selling_point_2: FW,
  embroidery_selling_point_3: qW,
  embroidery_textiles: BW,
  embroidery_washability: HW,
  error_failed_to_archive_variant: GW,
  error_failed_to_save_variant: WW,
  error_loading: ZW,
  error_pusher_rendering_failed: KW,
  error_pusher_rendering_failed_while_loading_variant: QW,
  error_while_deleting_archive_variant: XW,
  fewer_colors: JW,
  font: YW,
  font_not_available: eZ,
  font_update: tZ,
  font_update_explanation: nZ,
  from_one_piece: oZ,
  go_to_production_method_overview: aZ,
  height_abbreviation: sZ,
  help_for_upload: iZ,
  here: rZ,
  hide_areas: lZ,
  icon: cZ,
  icon_database: uZ,
  icon_database_description: dZ,
  insert_text: mZ,
  italic: pZ,
  italic_short: fZ,
  line_height: hZ,
  loading: _Z,
  logos: vZ,
  logos_and_designs: gZ,
  look: yZ,
  max_file_size: kZ,
  maximum_number_of_lines: bZ,
  merchant_sketch_variant_added: wZ,
  minimum_quantity: xZ,
  mono_colored: $Z,
  more_colors: zZ,
  more_informations_about_upload: SZ,
  motif_deleted: CZ,
  motif_placed_in_current_design: AZ,
  multi_colored: PZ,
  my_customizations: TZ,
  my_files: MZ,
  my_logos: IZ,
  new: "nieuw",
  new_customization: EZ,
  new_design: OZ,
  new_sketch: RZ,
  next_motif: LZ,
  no_customer_logos: jZ,
  no_customer_logos_for_production_method: DZ,
  no_designs: NZ,
  no_motifs: VZ,
  offset_left: UZ,
  only_uppercase: FZ,
  or: qZ,
  otherwise_change_personalization_type_top_right: BZ,
  pdf_download: HZ,
  place: GZ,
  place_logo: WZ,
  please_correct_the_highlighted_errors: ZZ,
  please_hold_on_for_a_moment: KZ,
  preview: QZ,
  preview_of_possibile_positioning_areas: XZ,
  price: JZ,
  product_colors: YZ,
  production_method: eK,
  production_method_not_available_for_variant: tK,
  production_method_summary_dtf: nK,
  production_method_summary_embroidery: oK,
  quantity: aK,
  recently_uploaded: sK,
  recently_used: iK,
  rename: rK,
  replace: lK,
  save: cK,
  save_and_load: uK,
  save_variant: dK,
  saved: mK,
  saved_design_successfully: pK,
  saved_designs: fK,
  search_logo: hK,
  select_color: _K,
  select_file: vK,
  select_font: gK,
  session_expired: yK,
  session_expired_description: kK,
  show_X_results: bK,
  show_areas: wK,
  show_own_files: xK,
  show_sketches: $K,
  size: zK,
  size_in_unit: SK,
  sketches: CK,
  standard_colors: AK,
  supported_file_types: PK,
  terms_of_service: TK,
  textiles: MK,
  texts: IK,
  the_selected_design_will_replace_the_current_selection: EK,
  this_action_can_not_be_undone: OK,
  to_place_motif_change_production_method: RK,
  trying_to_reconnect_session: LK,
  update: jK,
  update_article_with_designs: DK,
  upload_another_file: NK,
  upload_contact_form_hint: VK,
  upload_error_422_content_type: UK,
  upload_error_svg_contains_image: FK,
  upload_error_svg_contains_text: qK,
  upload_error_unexpected: BK,
  upload_file: HK,
  upload_own_file: GK,
  uploaded_content_automatically_checked_using_ai: WK,
  uploads: ZK,
  views_preview_headlide: KK,
  washablility: QK,
  width_abbreviation: XK,
  your_file_is_beeing_uploaded: JK,
  zoom: YK
}, tQ = "anuluj", nQ = "Dodaj logo", oQ = "Dodaj tekst", aQ = "Dodaj linię", sQ = "do zamówienia", iQ = "wyrównaj", rQ = "Brak wolnych pól rozmieszczenia na tym widoku.", lQ = "zastosuj", cQ = "Zastosuj do wszystkich linii", uQ = "Archiwum", dQ = "Załaduj wybrany motyw", mQ = "Załaduj produkt z personalizacją", pQ = "Nowy wpis do archiwum będzie wkrótce dostępny.", fQ = "Twoja personalizacja została pomyślnie zapisana.", hQ = "Czy na pewno chcesz usunąć { deleteName }?", _Q = "Co najmniej jeden motyw nie jest już dostępny!", vQ = "Uwaga", gQ = "wróć", yQ = "Wygnij tekst", kQ = { authentication: "Uwierzytelnianie nie powiodło się.", headline: "Wystąpił błąd podczas uruchamiania konfiguratora.", unexpected: "Nieoczekiwany błąd", variant_not_found: "Nie znaleziono wybranego wariantu." }, bQ = "Aktualnie znajdujesz się na polu dla {fromProductionMethod}.", wQ = "zmień na {x}", xQ = "wybierz", $Q = "Wybierz pole rozmieszczenia.", zQ = "Wybierz inny motyw", SQ = "Wybierz inne logo", CQ = "Wybierz typ personalizacji", AQ = "usuń wszystkie filtry", PQ = "Kolor", TQ = "Kolory", MQ = "potwierdź", IQ = "Potwierdzenie", EQ = "Przesyłając wybraną personalizację, potwierdzasz, że masz prawo do umieszczenia personalizacji na tekstyliach, w szczególności, że personalizacja nie narusza praw do nazw i znaków towarowych, praw autorskich, praw do wzorów ani innych praw osób trzecich ani ogólnie obowiązującego prawa. Jeśli z powodu dokonanej przez Ciebie konfiguracji zostaniemy pociągnięci do odpowiedzialności z tytułu naruszenia praw osób trzecich lub przepisów prawa, jesteś zobowiązany do zwolnienia nas z wszelkich roszczeń i szkód z tym związanych.", OQ = "formularz kontaktowy", RQ = "kontynuuj z {x}", LQ = "Uwaga: niezapisane projekty zostaną utracone podczas otwierania szkiców.", jQ = "Aktualnie w koszyku", DQ = "Nie przesłano jeszcze żadnych plików", NQ = "Indywidualny", VQ = "Typ motywu", UQ = "Personalizacje", FQ = "Projekt|Projekty", qQ = "Odstęp motyw/tekst (w mm)", BQ = "Czy chcesz zmienić nazwę {name}?", HQ = "Przeciągnij plik bezpośrednio do pola", GQ = "żywe kolory, różnorodność", WQ = "wyrazisty druk cyfrowy", ZQ = "optymalny dla dużych nadruków", KQ = "elastyczność w rozmiarach i kolorach", QQ = "dla wybranych tekstyliów i wszystkich podstawowych produktów", XQ = "Pranie w pralce do 40˚C", JQ = "Element znajduje się poza polem rozmieszczenia.", YQ = "elegancki, delikatny", eX = "bardzo wysokiej jakości i trwały haft", tX = "możliwe dla wielu produktów", nX = "wiele motywów i różnych kolorów nici", oX = "wszystkie tekstylia, także intensywnie użytkowane produkty", aX = "można prać w wysokich temperaturach, także w pralniach przemysłowych", sX = "Nie udało się zarchiwizować wariantu. Spróbuj ponownie.", iX = "Nie udało się zapisać wariantu. Spróbuj ponownie.", rX = "Wystąpił błąd podczas ładowania.", lX = "Wystąpił błąd podczas renderowania zmian. Spróbuj ponownie (później).", cX = "Podczas ładowania wariantu wystąpił nieoczekiwany błąd. Spróbuj ponownie (później) lub utwórz nową personalizację.", uX = "Wystąpił błąd podczas usuwania wariantu z archiwum. Spróbuj ponownie.", dX = "mniej kolorów", mX = "Czcionka", pX = "Czcionka niedostępna", fX = "Aktualizacja czcionki", hX = "Niektóre czcionki nie są już dostępne. Proszę wybrać inną:", _X = "od 1 szt.", vX = "Przegląd personalizacji", gX = "Wysokość (w cm)", yX = "Pomoc dotycząca przesyłania plików", kX = "tutaj", bX = "Ukryj pola", wX = "Motyw|Motywy", xX = "Baza motywów", $X = "Wybierz motyw z naszej stale rosnącej bazy motywów. Następnie możesz spersonalizować swój motyw.", zX = "Wstaw tekst", SX = "kursywa", CX = "k", AX = "Odstęp na dole", PX = "ładowanie", TX = "Logo|Logotypy", MX = "Logotypy i projekty", IX = "Wygląd", EX = "Maks. rozmiar pliku:", OX = "Osiągnięto maksymalną liczbę linii.", RX = 'Nowe szkice są dostępne pod "{buttonName}".', LX = "Minimalna ilość", jX = "jednokolorowe", DX = "więcej kolorów", NX = "Do korzystania z „CI Configurator MYDESIGN” obowiązują następujące {termsOfServiceLink}.", VX = "Uwaga: Jedno lub więcej z twoich motywów zostało usuniętych. Dodaj nowe motywy i sprawdź swój projekt.", UX = "Ten motyw jest umieszczony w Twoim aktualnym projekcie.", FX = "wielokolorowe", qX = "Moje personalizacje", BX = "Moje pliki", HX = "Moje logotypy", GX = "Nowa personalizacja", WX = "Nowy projekt", ZX = "Nowy szkic", KX = "następny motyw", QX = "W Twoim koncie klienta nie zapisano jeszcze żadnych logotypów dla {productionMethod}. Chcesz, abyśmy zapisali Twoje logo? Skontaktuj się z nami: {contact}. Możesz również zmienić typ personalizacji w prawym górnym rogu.", XX = "Na Twoim koncie klienta nie ma obecnie zapisanych żadnych logo dla {productionMethod}.", JX = "W Twoim koncie klienta nie zapisano jeszcze żadnych projektów dla {productionMethod}.", YX = "Dla Twojego aktualnego filtrowania nie zapisano jeszcze żadnych motywów dla {productionMethod}.", eJ = "Wcięcie z lewej", tJ = "Tylko wielkie litery", nJ = "lub", oJ = "W przeciwnym razie możesz zmienić rodzaj personalizacji w prawym górnym rogu.", aJ = "Pobierz PDF", sJ = "umieść", iJ = "Umieść motyw", rJ = "Proszę poprawić oznaczone pola, aby wyświetlić swój motyw.", lJ = "Proszę czekać.", cJ = "Podgląd", uJ = "Podgląd możliwych pól rozmieszczenia", dJ = "Cena", mJ = "Zmień kolor produktu", pJ = "Typ personalizacji", fJ = "Ten typ personalizacji nie jest możliwy dla tego produktu.", hJ = "wyrazisty druk cyfrowy", _J = "bardzo wysokiej jakości i trwały haft", vJ = "Ilość", gJ = "Ostatnio przesłane", yJ = "Ostatnio używane", kJ = "zmień nazwę", bJ = "zamień", wJ = "zapisz", xJ = "zapisz & wczytaj", $J = "Zapisz personalizację", zJ = "Zapisano", SJ = "Twój projekt został pomyślnie zapisany pod nazwą {name}.", CJ = "Zapisane projekty", AJ = "Szukaj motywu", PJ = "Wybierz kolor", TJ = "Wybierz plik", MJ = "Wybierz czcionkę", IJ = "Sesja wygasła", EJ = "Twoja sesja wygasła. Odśwież stronę, aby kontynuować korzystanie z konfiguratora.", OJ = "Pokaż {count} wynik|Pokaż {count} wyniki", RJ = "Pokaż pola", LJ = "Pokaż moje pliki", jJ = "Zobacz szkice", DJ = "Rozmiar", NJ = "Rozmiar (w cm)", VJ = "Szkice", UJ = "Kolory standardowe", FJ = "Obsługiwane formaty plików", qJ = "Warunki korzystania", BJ = "Tekstylia", HJ = "Tekst", GJ = "Wybrany projekt zastąpi Twój aktualny wybór", WJ = "Tej akcji nie można cofnąć.", ZJ = "Aby umieścić wybrany motyw, zmień typ personalizacji na {toProductionMethod}. Następnie możesz wybrać odpowiednie pole.", KJ = "Próba przywrócenia sesji.", QJ = "aktualizuj", XJ = "Zaktualizuj artykuł wraz z personalizacją", JJ = "Prześlij kolejny plik", YJ = "Czy chcą Państwo, abyśmy zarejestrowali Państwa logo? Prosimy przesłać nam logo poprzez {contact_form}, podając numer klienta, numery artykułów oraz preferowane umiejscowienie na produktach.", eY = "Twój plik nie spełnia wymogów technicznych. Prześlij inny format pliku. Więcej informacji znajdziesz {here}.", tY = "Nie można przesłać – Twój plik SVG zawiera elementy graficzne. Usuń osadzone obrazy i prześlij plik ponownie.", nY = "Nie można przesłać – Twój plik SVG zawiera nieosadzone czcionki. Zamień czcionki na krzywe i prześlij plik ponownie.", oY = "Przesyłanie nie powiodło się – wystąpił nieoczekiwany błąd. Spróbuj ponownie lub użyj innego formatu pliku.", aY = "Prześlij plik", sY = "Prześlij własny plik", iY = "Uwaga: Twoje przesłane treści (obrazy/grafiki/teksty) są automatycznie sprawdzane – m.in. za pomocą metod opartych na AI – pod kątem wymogów prawnych i jakościowych zgodnie z naszymi warunkami {termsOfServiceLink} (np. prawa autorskie/znaki towarowe, zabronione znaki, prawa osobiste, treści nienawistne/przemoc). Nieprawidłowości są sprawdzane przez naszych pracowników; ostateczne decyzje nie są podejmowane wyłącznie automatycznie. Szczegóły przetwarzania danych znajdziesz w naszej polityce prywatności.", rY = "Przesłane pliki", lY = "Twoja personalizacja od", cY = "Możliwość prania", uY = "Szerokość (w cm)", dY = "Twój plik jest właśnie przesyłany...", mY = "Zoom", pY = {
  abort: tQ,
  add_logo: nQ,
  add_text: oQ,
  add_text_line: aQ,
  add_to_cart: sQ,
  align: iQ,
  all_positioning_areas_are_occupied: rQ,
  apply: lQ,
  apply_to_all_lines: cQ,
  archive: uQ,
  archive_fetch_selected_customization: dQ,
  archive_fetch_variant_with_customizations: mQ,
  archive_new_entry_soon_available: pQ,
  archived_variant_successfully: fQ,
  are_you_sure_you_want_to_delete: hQ,
  at_least_one_motiv_is_not_available: _Q,
  attention: vQ,
  back: gQ,
  bend_text_line: yQ,
  boot_error: kQ,
  change_production_method_info: bQ,
  change_to_x: wQ,
  choose: xQ,
  choose_a_positioning_area: $Q,
  choose_icon: zQ,
  choose_logo: SQ,
  choose_production_method: CQ,
  clear_filters: AQ,
  color: PQ,
  colors: TQ,
  confirm: MQ,
  confirmation: IQ,
  confirmation_description: EQ,
  contact_form: OQ,
  continue: "kontynuuj",
  continue_with_x: RQ,
  current_edited_customization_will_be_aborted: LQ,
  currently_in_cart: jQ,
  currently_no_uploaded_files: DQ,
  custom: NQ,
  customization_type: VQ,
  customizations: UQ,
  delete: "usuń",
  designs: FQ,
  distance_motif_text: qQ,
  do_you_want_to_rename: BQ,
  drag_file_over_area: HQ,
  dtf_look: GQ,
  dtf_selling_point_1: WQ,
  dtf_selling_point_2: ZQ,
  dtf_selling_point_3: KQ,
  dtf_textiles: QQ,
  dtf_washability: XQ,
  element_outside_placement_area: JQ,
  embroidery_look: YQ,
  embroidery_selling_point_1: eX,
  embroidery_selling_point_2: tX,
  embroidery_selling_point_3: nX,
  embroidery_textiles: oX,
  embroidery_washability: aX,
  error_failed_to_archive_variant: sX,
  error_failed_to_save_variant: iX,
  error_loading: rX,
  error_pusher_rendering_failed: lX,
  error_pusher_rendering_failed_while_loading_variant: cX,
  error_while_deleting_archive_variant: uX,
  fewer_colors: dX,
  font: mX,
  font_not_available: pX,
  font_update: fX,
  font_update_explanation: hX,
  from_one_piece: _X,
  go_to_production_method_overview: vX,
  height_abbreviation: gX,
  help_for_upload: yX,
  here: kX,
  hide_areas: bX,
  icon: wX,
  icon_database: xX,
  icon_database_description: $X,
  insert_text: zX,
  italic: SX,
  italic_short: CX,
  line_height: AX,
  loading: PX,
  logos: TX,
  logos_and_designs: MX,
  look: IX,
  max_file_size: EX,
  maximum_number_of_lines: OX,
  merchant_sketch_variant_added: RX,
  minimum_quantity: LX,
  mono_colored: jX,
  more_colors: DX,
  more_informations_about_upload: NX,
  motif_deleted: VX,
  motif_placed_in_current_design: UX,
  multi_colored: FX,
  my_customizations: qX,
  my_files: BX,
  my_logos: HX,
  new: "nowe",
  new_customization: GX,
  new_design: WX,
  new_sketch: ZX,
  next_motif: KX,
  no_customer_logos: QX,
  no_customer_logos_for_production_method: XX,
  no_designs: JX,
  no_motifs: YX,
  offset_left: eJ,
  only_uppercase: tJ,
  or: nJ,
  otherwise_change_personalization_type_top_right: oJ,
  pdf_download: aJ,
  place: sJ,
  place_logo: iJ,
  please_correct_the_highlighted_errors: rJ,
  please_hold_on_for_a_moment: lJ,
  preview: cJ,
  preview_of_possibile_positioning_areas: uJ,
  price: dJ,
  product_colors: mJ,
  production_method: pJ,
  production_method_not_available_for_variant: fJ,
  production_method_summary_dtf: hJ,
  production_method_summary_embroidery: _J,
  quantity: vJ,
  recently_uploaded: gJ,
  recently_used: yJ,
  rename: kJ,
  replace: bJ,
  save: wJ,
  save_and_load: xJ,
  save_variant: $J,
  saved: zJ,
  saved_design_successfully: SJ,
  saved_designs: CJ,
  search_logo: AJ,
  select_color: PJ,
  select_file: TJ,
  select_font: MJ,
  session_expired: IJ,
  session_expired_description: EJ,
  show_X_results: OJ,
  show_areas: RJ,
  show_own_files: LJ,
  show_sketches: jJ,
  size: DJ,
  size_in_unit: NJ,
  sketches: VJ,
  standard_colors: UJ,
  supported_file_types: FJ,
  terms_of_service: qJ,
  textiles: BJ,
  texts: HJ,
  the_selected_design_will_replace_the_current_selection: GJ,
  this_action_can_not_be_undone: WJ,
  to_place_motif_change_production_method: ZJ,
  trying_to_reconnect_session: KJ,
  update: QJ,
  update_article_with_designs: XJ,
  upload_another_file: JJ,
  upload_contact_form_hint: YJ,
  upload_error_422_content_type: eY,
  upload_error_svg_contains_image: tY,
  upload_error_svg_contains_text: nY,
  upload_error_unexpected: oY,
  upload_file: aY,
  upload_own_file: sY,
  uploaded_content_automatically_checked_using_ai: iY,
  uploads: rY,
  views_preview_headlide: lY,
  washablility: cY,
  width_abbreviation: uY,
  your_file_is_beeing_uploaded: dY,
  zoom: mY
}, fY = "zrušiť", hY = "Pridať logo", _Y = "Pridať text", vY = "Pridať riadok", gY = "do objednávky", yY = "zarovnať", kY = "Na tomto pohľade nie je voľné miesto na umiestnenie.", bY = "použiť", wY = "Použiť na všetky riadky", xY = "Archív", $Y = "Načítať vybraný motív", zY = "Načítať produkt vrátane personalizácie", SY = "Nový archívny záznam bude čoskoro k dispozícii.", CY = "Vaša personalizácia bola úspešne uložená.", AY = "Naozaj chcete odstrániť { deleteName }?", PY = "Aspoň jeden motív už nie je dostupný!", TY = "Upozornenie", MY = "späť", IY = "Ohniť text", EY = { authentication: "Autentifikácia zlyhala.", headline: "Pri štarte konfigurátora došlo k chybe.", unexpected: "Neočakávaná chyba", variant_not_found: "Požadovaná varianta nebola nájdená." }, OY = "Aktuálne sa nachádzate na ploche pre {fromProductionMethod}.", RY = "prepnúť na {x}", LY = "vybrať", jY = "Prosím vyberte plochu na umiestnenie.", DY = "Vybrať iný motív", NY = "Vybrať iné logo", VY = "Vybrať typ personalizácie", UY = "zmazať všetky filtre", FY = "Farba", qY = "Farby", BY = "potvrdiť", HY = "Potvrdenie", GY = "Nahraním požadovanej personalizácie potvrdzujete, že ste oprávnený dať personalizáciu aplikovať na textílie, najmä že personalizácia neporušuje práva tretích strán (ochranné známky, autorské práva, dizajnové práva a pod.) ani všeobecné (najmä trestnoprávne) zákony. Ak by sme boli z dôvodu vašej konfigurácie vystavení nárokom tretích strán alebo zákona, ste povinný nás od všetkých nárokov a škôd v tejto súvislosti oslobodiť.", WY = "kontaktný formulár", ZY = "pokračovať s {x}", KY = "Upozornenie: neuložené návrhy budú pri otvorení návrhov stratené.", QY = "Aktuálne v košíku", XY = "Zatiaľ neboli nahrané žiadne súbory", JY = "Individuálne", YY = "Typ motívu", eee = "Personalizácie", tee = "Dizajn|Dizajny", nee = "Vzdialenosť motív/text (v mm)", oee = "Chcete premenovať {name}?", aee = "Pretiahnite súbor priamo do poľa", see = "živé farby, rôznorodosť", iee = "výrazná digitálna tlač", ree = "ideálne pre veľké potlače", lee = "flexibilné vo veľkostiach a farbách", cee = "pre vybrané textílie a všetky základné produkty", uee = "Pranie v práčke do 40˚C", dee = "Prvok je mimo plochy umiestnenia.", mee = "elegantné, jemné", pee = "veľmi kvalitná a trvácna výšivka", fee = "možné pre mnoho produktov", hee = "mnoho motívov a farieb nití", _ee = "všetky textílie, aj silne namáhané produkty", vee = "možno prať na vysoké teploty, aj priemyselné pranie", gee = "Archivácia varianty zlyhala. Skúste to prosím znova.", yee = "Uloženie varianty zlyhalo. Skúste to prosím znova.", kee = "Pri načítaní došlo k chybe.", bee = "Pri zobrazovaní zmien došlo k chybe. Skúste to prosím neskôr znova.", wee = "Pri načítaní varianty došlo k neočakávanej chybe. Skúste to neskôr znova alebo vytvorte novú personalizáciu.", xee = "Pri mazaní archivovanej varianty došlo k chybe. Skúste to znova.", $ee = "menej farieb", zee = "Písmo", See = "Písmo nie je k dispozícii", Cee = "Aktualizácia písma", Aee = "Niektoré písma už nie sú k dispozícii. Vyberte prosím iné:", Pee = "od 1 ks", Tee = "Prehľad personalizácie", Mee = "Výška (v cm)", Iee = "Pomoc s nahrávaním súborov", Eee = "tu", Oee = "Skryť plochy", Ree = "Motív|Motívy", Lee = "Databáza motívov", jee = "Vyberte motív z našej stále rastúcej databázy motívov. Následne môžete motív individuálne upraviť.", Dee = "Vložiť text", Nee = "kurzíva", Vee = "k", Uee = "Vzdialenosť dolu", Fee = "načítava sa", qee = "Logo|Logá", Bee = "Logá & dizajny", Hee = "Vzhľad", Gee = "Max. veľkosť súboru:", Wee = "Bol dosiahnutý maximálny počet riadkov.", Zee = "Nové návrhy sú k dispozícii pod „{buttonName}“.", Kee = "Minimálne množstvo", Qee = "jednofarebné", Xee = "viac farieb", Jee = "Pre používanie „CI Configurator MYDESIGN“ platia nasledujúce {termsOfServiceLink}.", Yee = "Upozornenie: Niektoré z vašich motívov boli vymazané. Pridajte nové motívy a skontrolujte svoj dizajn.", ete = "Tento motív je umiestnený vo vašom aktuálnom dizajne.", tte = "viacfarebné", nte = "Moje personalizácie", ote = "Moje súbory", ate = "Moje logá", ste = "Nová personalizácia", ite = "Nový dizajn", rte = "Nový návrh", lte = "ďalší motív", cte = "Vo vašom účte ešte nie sú žiadne logá pre {productionMethod}. Chcete, aby sme vaše logo pridali? Kontaktujte nás: {contact}. Alebo môžete zmeniť typ personalizácie vpravo hore.", ute = "Vo vašom zákazníckom účte momentálne nie sú uložené žiadne logá pre {productionMethod}.", dte = "Vo vašom účte ešte nie sú žiadne dizajny pre {productionMethod}.", mte = "Pre váš aktuálny filter nie sú žiadne motívy pre {productionMethod}.", pte = "Odsadenie vľavo", fte = "Len veľké písmená", hte = "alebo", _te = "Prípadne môžete zmeniť typ personalizácie vpravo hore.", vte = "Stiahnuť PDF", gte = "umiestniť", yte = "Umiestniť motív", kte = "Prosím, opravte označené polia, aby sa zobrazil váš motív.", bte = "Prosím čakajte chvíľu.", wte = "Náhľad", xte = "Náhľad možných plôch na umiestnenie", $te = "Cena", zte = "Zmeniť farbu produktu", Ste = "Typ personalizácie", Cte = "Tento typ personalizácie nie je možný pre tento produkt.", Ate = "výrazná digitálna tlač", Pte = "veľmi kvalitná a trvácna výšivka", Tte = "Množstvo", Mte = "Nedávno nahrané", Ite = "Nedávno použité", Ete = "premenovať", Ote = "nahradiť", Rte = "uložiť", Lte = "uložiť & načítať", jte = "Uložiť personalizáciu", Dte = "Uložené", Nte = "Váš dizajn bol úspešne uložený pod názvom {name}.", Vte = "Uložené dizajny", Ute = "Hľadať motív", Fte = "Vybrať farbu", qte = "Vybrať súbor", Bte = "Vybrať písmo", Hte = "Relácia vypršala", Gte = "Vaša relácia vypršala. Obnovte stránku, aby ste mohli pokračovať v používaní konfigurátora.", Wte = "Zobraziť {count} výsledok|Zobraziť {count} výsledky", Zte = "Zobraziť plochy", Kte = "Zobraziť moje súbory", Qte = "Zobraziť návrhy", Xte = "Veľkosť", Jte = "Veľkosť (v cm)", Yte = "Návrhy", ene = "Štandardné farby", tne = "Podporované typy súborov", nne = "Podmienky používania", one = "Textílie", ane = "Text", sne = "Vybraný dizajn nahradí vašu aktuálnu voľbu", ine = "Túto akciu nemožno vrátiť späť.", rne = "Ak chcete umiestniť požadovaný motív, zmeňte typ personalizácie na {toProductionMethod}. Potom môžete vybrať vhodnú plochu.", lne = "Prebieha pokus o obnovenie relácie.", cne = "aktualizovať", une = "Aktualizovať položku vrátane personalizácie", dne = "Nahrať ďalší súbor", mne = "Chcete, aby sme u nás zaevidovali vaše logo? Pošlite nám, prosím, svoje logo cez {contact_form} a uveďte zákaznícke číslo, čísla položiek a požadované umiestnenie na produktoch.", pne = "Váš súbor nespĺňa technické požiadavky. Nahrajte iný formát súboru. Viac informácií nájdete {here}.", fne = "Nahrávanie nie je možné – váš SVG súbor obsahuje obrázkové prvky. Odstráňte vložené obrázky a nahrajte súbor znova.", hne = "Nahrávanie nie je možné – váš SVG súbor obsahuje nevložené písma. Preveďte písma na krivky a nahrajte súbor znova.", _ne = "Nahrávanie zlyhalo – došlo k neočakávanej chybe. Skúste to znova alebo použite iný formát súboru.", vne = "Nahrať súbor", gne = "Nahrať vlastný súbor", yne = "Upozornenie: Váš nahraný obsah (obrázky/grafika/texty) je automaticky kontrolovaný – okrem iného aj pomocou AI technológií – podľa právnych a kvalitatívnych požiadaviek našich podmienok {termsOfServiceLink} (napr. autorské/právne ochranné známky, zakázané znaky, osobnostné práva, nenávistný/násilný obsah). Nezrovnalosti preverujú naši zamestnanci; konečné rozhodnutia nie sú prijímané výlučne automatizovane. Podrobnosti o spracovaní údajov nájdete v našich zásadách ochrany osobných údajov.", kne = "Nahrané súbory", bne = "Vaša personalizácia od", wne = "Možnosť prania", xne = "Šírka (v cm)", $ne = "Váš súbor sa práve nahráva...", zne = "Zoom", Sne = {
  abort: fY,
  add_logo: hY,
  add_text: _Y,
  add_text_line: vY,
  add_to_cart: gY,
  align: yY,
  all_positioning_areas_are_occupied: kY,
  apply: bY,
  apply_to_all_lines: wY,
  archive: xY,
  archive_fetch_selected_customization: $Y,
  archive_fetch_variant_with_customizations: zY,
  archive_new_entry_soon_available: SY,
  archived_variant_successfully: CY,
  are_you_sure_you_want_to_delete: AY,
  at_least_one_motiv_is_not_available: PY,
  attention: TY,
  back: MY,
  bend_text_line: IY,
  boot_error: EY,
  change_production_method_info: OY,
  change_to_x: RY,
  choose: LY,
  choose_a_positioning_area: jY,
  choose_icon: DY,
  choose_logo: NY,
  choose_production_method: VY,
  clear_filters: UY,
  color: FY,
  colors: qY,
  confirm: BY,
  confirmation: HY,
  confirmation_description: GY,
  contact_form: WY,
  continue: "pokračovať",
  continue_with_x: ZY,
  current_edited_customization_will_be_aborted: KY,
  currently_in_cart: QY,
  currently_no_uploaded_files: XY,
  custom: JY,
  customization_type: YY,
  customizations: eee,
  delete: "odstrániť",
  designs: tee,
  distance_motif_text: nee,
  do_you_want_to_rename: oee,
  drag_file_over_area: aee,
  dtf_look: see,
  dtf_selling_point_1: iee,
  dtf_selling_point_2: ree,
  dtf_selling_point_3: lee,
  dtf_textiles: cee,
  dtf_washability: uee,
  element_outside_placement_area: dee,
  embroidery_look: mee,
  embroidery_selling_point_1: pee,
  embroidery_selling_point_2: fee,
  embroidery_selling_point_3: hee,
  embroidery_textiles: _ee,
  embroidery_washability: vee,
  error_failed_to_archive_variant: gee,
  error_failed_to_save_variant: yee,
  error_loading: kee,
  error_pusher_rendering_failed: bee,
  error_pusher_rendering_failed_while_loading_variant: wee,
  error_while_deleting_archive_variant: xee,
  fewer_colors: $ee,
  font: zee,
  font_not_available: See,
  font_update: Cee,
  font_update_explanation: Aee,
  from_one_piece: Pee,
  go_to_production_method_overview: Tee,
  height_abbreviation: Mee,
  help_for_upload: Iee,
  here: Eee,
  hide_areas: Oee,
  icon: Ree,
  icon_database: Lee,
  icon_database_description: jee,
  insert_text: Dee,
  italic: Nee,
  italic_short: Vee,
  line_height: Uee,
  loading: Fee,
  logos: qee,
  logos_and_designs: Bee,
  look: Hee,
  max_file_size: Gee,
  maximum_number_of_lines: Wee,
  merchant_sketch_variant_added: Zee,
  minimum_quantity: Kee,
  mono_colored: Qee,
  more_colors: Xee,
  more_informations_about_upload: Jee,
  motif_deleted: Yee,
  motif_placed_in_current_design: ete,
  multi_colored: tte,
  my_customizations: nte,
  my_files: ote,
  my_logos: ate,
  new: "nové",
  new_customization: ste,
  new_design: ite,
  new_sketch: rte,
  next_motif: lte,
  no_customer_logos: cte,
  no_customer_logos_for_production_method: ute,
  no_designs: dte,
  no_motifs: mte,
  offset_left: pte,
  only_uppercase: fte,
  or: hte,
  otherwise_change_personalization_type_top_right: _te,
  pdf_download: vte,
  place: gte,
  place_logo: yte,
  please_correct_the_highlighted_errors: kte,
  please_hold_on_for_a_moment: bte,
  preview: wte,
  preview_of_possibile_positioning_areas: xte,
  price: $te,
  product_colors: zte,
  production_method: Ste,
  production_method_not_available_for_variant: Cte,
  production_method_summary_dtf: Ate,
  production_method_summary_embroidery: Pte,
  quantity: Tte,
  recently_uploaded: Mte,
  recently_used: Ite,
  rename: Ete,
  replace: Ote,
  save: Rte,
  save_and_load: Lte,
  save_variant: jte,
  saved: Dte,
  saved_design_successfully: Nte,
  saved_designs: Vte,
  search_logo: Ute,
  select_color: Fte,
  select_file: qte,
  select_font: Bte,
  session_expired: Hte,
  session_expired_description: Gte,
  show_X_results: Wte,
  show_areas: Zte,
  show_own_files: Kte,
  show_sketches: Qte,
  size: Xte,
  size_in_unit: Jte,
  sketches: Yte,
  standard_colors: ene,
  supported_file_types: tne,
  terms_of_service: nne,
  textiles: one,
  texts: ane,
  the_selected_design_will_replace_the_current_selection: sne,
  this_action_can_not_be_undone: ine,
  to_place_motif_change_production_method: rne,
  trying_to_reconnect_session: lne,
  update: cne,
  update_article_with_designs: une,
  upload_another_file: dne,
  upload_contact_form_hint: mne,
  upload_error_422_content_type: pne,
  upload_error_svg_contains_image: fne,
  upload_error_svg_contains_text: hne,
  upload_error_unexpected: _ne,
  upload_file: vne,
  upload_own_file: gne,
  uploaded_content_automatically_checked_using_ai: yne,
  uploads: kne,
  views_preview_headlide: bne,
  washablility: wne,
  width_abbreviation: xne,
  your_file_is_beeing_uploaded: $ne,
  zoom: zne
}, Cne = "avbryt", Ane = "Lägg till logotyp", Pne = "Lägg till text", Tne = "Lägg till rad", Mne = "till beställning", Ine = "justera", Ene = "Ingen ledig placeringsyta i denna vy.", One = "använd", Rne = "Tillämpa på alla rader", Lne = "Arkiv", jne = "Ladda vald motiv", Dne = "Ladda artikel med anpassning", Nne = "En ny arkivpost blir snart tillgänglig.", Vne = "Din anpassning har sparats.", Une = "Vill du verkligen radera { deleteName }?", Fne = "Minst ett motiv är inte längre tillgängligt!", qne = "Varning", Bne = "tillbaka", Hne = "Böj text", Gne = { authentication: "Autentisering misslyckades.", headline: "Ett fel uppstod när konfiguratorn startades.", unexpected: "Oväntat fel", variant_not_found: "Den begärda varianten hittades inte." }, Wne = "Du befinner dig för närvarande på en placeringsyta för {fromProductionMethod}.", Zne = "växla till {x}", Kne = "välj", Qne = "Välj en placeringsyta.", Xne = "Välj annan motiv", Jne = "Välj annan logotyp", Yne = "Välj anpassningstyp", eoe = "rensa alla filter", toe = "Färg", noe = "Färger", ooe = "bekräfta", aoe = "Bekräftelse", soe = "Genom att ladda upp önskad anpassning bekräftar du att du har rätt att låta anpassningen appliceras på textilier, särskilt att anpassningen inte bryter mot namn- och varumärkesrättigheter, designrättigheter, upphovsrätter eller andra tredje parts rättigheter samt mot gällande lagar (särskilt straffrättsliga). Om vi skulle bli föremål för krav på grund av din konfiguration är du skyldig att hålla oss skadeslösa från alla krav och skador.", ioe = "kontaktformuläret", roe = "fortsätt med {x}", loe = "Observera: Osparade designer går förlorade när utkast öppnas.", coe = "Just nu i kundvagnen", uoe = "Inga filer har laddats upp ännu", doe = "Individuell", moe = "Motivtyp", poe = "Anpassningar", foe = "Design|Designer", hoe = "Avstånd motiv/text (i mm)", _oe = "Vill du byta namn på {name}?", voe = "Dra filen direkt till fältet", goe = "färgstark, mångsidig", yoe = "uttrycksfull digitaltransfer", koe = "optimal för stora tryck", boe = "flexibel i storlek och färg", woe = "för utvalda textilier och alla baskläder", xoe = "Maskintvätt upp till 40˚C", $oe = "Elementet är utanför placeringsytan.", zoe = "elegant, detaljrik", Soe = "mycket högkvalitativ och hållbar brodyr", Coe = "möjlig för många produkter", Aoe = "många motiv och olika garnfärger", Poe = "alla textilier, även slitstarka produkter", Toe = "tål hög tvätt, även industrtvätt", Moe = "Arkivering av variant misslyckades. Försök igen.", Ioe = "Sparande av variant misslyckades. Försök igen.", Eoe = "Ett fel uppstod vid laddning.", Ooe = "Ett fel uppstod vid visning av ändringarna. Försök igen senare.", Roe = "Ett oväntat fel uppstod vid laddning av varianten. Försök igen senare eller skapa en ny anpassning.", Loe = "Ett fel uppstod vid radering av arkiverad variant. Försök igen.", joe = "färre färger", Doe = "Typsnitt", Noe = "Typsnitt ej tillgängligt", Voe = "Uppdatering av typsnitt", Uoe = "Vissa typsnitt är inte längre tillgängliga. Välj ett annat:", Foe = "från 1 st", qoe = "Till översikt för anpassning", Boe = "Höjd (i cm)", Hoe = "Hjälp med filuppladdning", Goe = "här", Woe = "Dölj ytor", Zoe = "Motiv|Motiv", Koe = "Motivdatabas", Qoe = "Välj ett motiv från vår ständigt växande motivdatabas. Därefter kan du anpassa ditt motiv.", Xoe = "Infoga text", Joe = "kursiv", Yoe = "k", eae = "Avstånd nedtill", tae = "laddar", nae = "Logotyp|Logotyper", oae = "Logotyper & designer", aae = "Utseende", sae = "Filstorlek: max.", iae = "Maximalt antal rader uppnått.", rae = 'Nya utkast tillgängliga under "{buttonName}".', lae = "Minsta antal", cae = "enfärgad", uae = "fler färger", dae = "Följande {termsOfServiceLink} gäller för användning av „CI Configurator MYDESIGN“.", mae = "Varning: En eller flera av dina motiv har tagits bort. Lägg till nya motiv och kontrollera din design.", pae = "Detta motiv finns i din nuvarande design.", fae = "flerfärgad", hae = "Mina anpassningar", _ae = "Mina filer", vae = "Mina logotyper", gae = "Ny anpassning", yae = "Ny design", kae = "Nytt utkast", bae = "nästa motiv", wae = "Det finns ännu inga logotyper för {productionMethod} på ditt konto. Vill du att vi lägger till din logotyp? Kontakta oss: {contact}. Du kan annars byta anpassningstyp uppe till höger.", xae = "Det finns för närvarande inga logotyper för {productionMethod} sparade i ditt kundkonto.", $ae = "Det finns ännu inga designer för {productionMethod} på ditt konto.", zae = "Inga motiv för {productionMethod} med nuvarande filter.", Sae = "Indrag vänster", Cae = "Endast versaler", Aae = "eller", Pae = "Annars kan du byta typ av personalisering uppe till höger.", Tae = "Ladda ner PDF", Mae = "placera", Iae = "Placera motiv", Eae = "Korrigera de markerade fälten för att visa ditt motiv.", Oae = "Vänligen vänta en stund.", Rae = "Förhandsvisning", Lae = "Förhandsvisning av möjliga placeringsytor", jae = "Pris", Dae = "Byt produktfärg", Nae = "Anpassningstyp", Vae = "Denna anpassningstyp är inte möjlig för denna artikel.", Uae = "uttrycksfull digitaltransfer", Fae = "mycket högkvalitativ och hållbar brodyr", qae = "Antal", Bae = "Senast uppladdad", Hae = "Senast använd", Gae = "byt namn", Wae = "ersätt", Zae = "spara", Kae = "spara & ladda", Qae = "Spara anpassning", Xae = "Sparad", Jae = "Din design har sparats under namnet {name}.", Yae = "Sparade designer", ese = "Sök motiv", tse = "Välj färg", nse = "Välj fil", ose = "Välj typsnitt", ase = "Sessionen har gått ut", sse = "Din session har gått ut. Ladda om sidan för att fortsätta använda konfiguratorn.", ise = "Visa {count} resultat|Visa {count} resultat", rse = "Visa ytor", lse = "Visa mina filer", cse = "Visa utkast", use = "Storlek", dse = "Storlek (i cm)", mse = "Utkast", pse = "Standardfärger", fse = "Stödda filformat", hse = "Användarvillkor", _se = "Textilier", vse = "Text", gse = "Det valda designen ersätter ditt nuvarande val", yse = "Denna åtgärd kan inte ångras.", kse = "För att placera önskat motiv, byt anpassningstyp till {toProductionMethod}. Därefter kan du välja en passande placeringsyta.", bse = "Försöker återansluta sessionen.", wse = "uppdatera", xse = "Uppdatera artikel inklusive personalisering", $se = "Ladda upp ytterligare en fil", zse = "Vill du att vi registrerar din logotyp hos oss? Skicka din logotyp via {contact_form} och ange ditt kundnummer, artikelnummer samt önskad placering på produkterna.", Sse = "Din fil uppfyller inte de tekniska kraven. Ladda upp ett annat filformat. Mer information finns {here}.", Cse = "Uppladdning inte möjlig – din SVG-fil innehåller bildelement. Ta bort inbäddade bilder och ladda upp filen igen.", Ase = "Uppladdning inte möjlig – din SVG-fil innehåller ej inbäddade typsnitt. Omvandla typsnitt till banor och ladda upp filen igen.", Pse = "Uppladdning misslyckades – ett oväntat fel inträffade. Försök igen eller använd ett annat filformat.", Tse = "Ladda upp fil", Mse = "Ladda upp egen fil", Ise = "Observera: Ditt uppladdade material (bilder/grafik/texter) kontrolleras automatiskt, bland annat med AI-assisterade metoder, för att uppfylla juridiska och kvalitativa krav enligt våra {termsOfServiceLink} (exempelvis upphovs-/varumärkesrätt, förbjudna tecken, personliga rättigheter, hat- eller våldsamt innehåll). Avvikelser granskas av vår personal; slutgiltiga beslut fattas inte enbart automatiserat. Detaljer om databehandling finns i vår integritetspolicy.", Ese = "Uppladdningar", Ose = "Din anpassning av", Rse = "Tvättbarhet", Lse = "Bredd (i cm)", jse = "Din fil laddas upp...", Dse = "Zoom", Nse = {
  abort: Cne,
  add_logo: Ane,
  add_text: Pne,
  add_text_line: Tne,
  add_to_cart: Mne,
  align: Ine,
  all_positioning_areas_are_occupied: Ene,
  apply: One,
  apply_to_all_lines: Rne,
  archive: Lne,
  archive_fetch_selected_customization: jne,
  archive_fetch_variant_with_customizations: Dne,
  archive_new_entry_soon_available: Nne,
  archived_variant_successfully: Vne,
  are_you_sure_you_want_to_delete: Une,
  at_least_one_motiv_is_not_available: Fne,
  attention: qne,
  back: Bne,
  bend_text_line: Hne,
  boot_error: Gne,
  change_production_method_info: Wne,
  change_to_x: Zne,
  choose: Kne,
  choose_a_positioning_area: Qne,
  choose_icon: Xne,
  choose_logo: Jne,
  choose_production_method: Yne,
  clear_filters: eoe,
  color: toe,
  colors: noe,
  confirm: ooe,
  confirmation: aoe,
  confirmation_description: soe,
  contact_form: ioe,
  continue: "fortsätt",
  continue_with_x: roe,
  current_edited_customization_will_be_aborted: loe,
  currently_in_cart: coe,
  currently_no_uploaded_files: uoe,
  custom: doe,
  customization_type: moe,
  customizations: poe,
  delete: "radera",
  designs: foe,
  distance_motif_text: hoe,
  do_you_want_to_rename: _oe,
  drag_file_over_area: voe,
  dtf_look: goe,
  dtf_selling_point_1: yoe,
  dtf_selling_point_2: koe,
  dtf_selling_point_3: boe,
  dtf_textiles: woe,
  dtf_washability: xoe,
  element_outside_placement_area: $oe,
  embroidery_look: zoe,
  embroidery_selling_point_1: Soe,
  embroidery_selling_point_2: Coe,
  embroidery_selling_point_3: Aoe,
  embroidery_textiles: Poe,
  embroidery_washability: Toe,
  error_failed_to_archive_variant: Moe,
  error_failed_to_save_variant: Ioe,
  error_loading: Eoe,
  error_pusher_rendering_failed: Ooe,
  error_pusher_rendering_failed_while_loading_variant: Roe,
  error_while_deleting_archive_variant: Loe,
  fewer_colors: joe,
  font: Doe,
  font_not_available: Noe,
  font_update: Voe,
  font_update_explanation: Uoe,
  from_one_piece: Foe,
  go_to_production_method_overview: qoe,
  height_abbreviation: Boe,
  help_for_upload: Hoe,
  here: Goe,
  hide_areas: Woe,
  icon: Zoe,
  icon_database: Koe,
  icon_database_description: Qoe,
  insert_text: Xoe,
  italic: Joe,
  italic_short: Yoe,
  line_height: eae,
  loading: tae,
  logos: nae,
  logos_and_designs: oae,
  look: aae,
  max_file_size: sae,
  maximum_number_of_lines: iae,
  merchant_sketch_variant_added: rae,
  minimum_quantity: lae,
  mono_colored: cae,
  more_colors: uae,
  more_informations_about_upload: dae,
  motif_deleted: mae,
  motif_placed_in_current_design: pae,
  multi_colored: fae,
  my_customizations: hae,
  my_files: _ae,
  my_logos: vae,
  new: "ny",
  new_customization: gae,
  new_design: yae,
  new_sketch: kae,
  next_motif: bae,
  no_customer_logos: wae,
  no_customer_logos_for_production_method: xae,
  no_designs: $ae,
  no_motifs: zae,
  offset_left: Sae,
  only_uppercase: Cae,
  or: Aae,
  otherwise_change_personalization_type_top_right: Pae,
  pdf_download: Tae,
  place: Mae,
  place_logo: Iae,
  please_correct_the_highlighted_errors: Eae,
  please_hold_on_for_a_moment: Oae,
  preview: Rae,
  preview_of_possibile_positioning_areas: Lae,
  price: jae,
  product_colors: Dae,
  production_method: Nae,
  production_method_not_available_for_variant: Vae,
  production_method_summary_dtf: Uae,
  production_method_summary_embroidery: Fae,
  quantity: qae,
  recently_uploaded: Bae,
  recently_used: Hae,
  rename: Gae,
  replace: Wae,
  save: Zae,
  save_and_load: Kae,
  save_variant: Qae,
  saved: Xae,
  saved_design_successfully: Jae,
  saved_designs: Yae,
  search_logo: ese,
  select_color: tse,
  select_file: nse,
  select_font: ose,
  session_expired: ase,
  session_expired_description: sse,
  show_X_results: ise,
  show_areas: rse,
  show_own_files: lse,
  show_sketches: cse,
  size: use,
  size_in_unit: dse,
  sketches: mse,
  standard_colors: pse,
  supported_file_types: fse,
  terms_of_service: hse,
  textiles: _se,
  texts: vse,
  the_selected_design_will_replace_the_current_selection: gse,
  this_action_can_not_be_undone: yse,
  to_place_motif_change_production_method: kse,
  trying_to_reconnect_session: bse,
  update: wse,
  update_article_with_designs: xse,
  upload_another_file: $se,
  upload_contact_form_hint: zse,
  upload_error_422_content_type: Sse,
  upload_error_svg_contains_image: Cse,
  upload_error_svg_contains_text: Ase,
  upload_error_unexpected: Pse,
  upload_file: Tse,
  upload_own_file: Mse,
  uploaded_content_automatically_checked_using_ai: Ise,
  uploads: Ese,
  views_preview_headlide: Ose,
  washablility: Rse,
  width_abbreviation: Lse,
  your_file_is_beeing_uploaded: jse,
  zoom: Dse
};
var Vse = {
  prefix: "fal",
  iconName: "rotate-reverse",
  icon: [
    512,
    512,
    [],
    "e631",
    "M85.9 301.2c-2-7.6-8.6-13.2-16.5-13.2c-10 0-17.6 8.9-15.2 18.6C76.8 397 158.6 464 256 464c59.8 0 113.7-25.3 151.7-65.7L433.4 424c5.1 5.1 12.1 8 19.3 8c15.1 0 27.3-12.2 27.3-27.3L480 304c0-8.8-7.2-16-16-16l-100.7 0c-15.1 0-27.3 12.2-27.3 27.3c0 7.2 2.9 14.2 8 19.3l41 41C352.9 410.3 307 432 256 432c-81.6 0-150.2-55.5-170.1-130.8zM127 136.3C159.1 101.7 205 80 256 80c81.6 0 150.2 55.5 170.1 130.8c2 7.6 8.6 13.2 16.5 13.2c10 0 17.6-8.9 15.2-18.6C435.2 115 353.4 48 256 48c-59.8 0-113.7 25.3-151.7 65.7L78.6 88c-5.1-5.1-12.1-8-19.3-8C44.2 80 32 92.2 32 107.3L32 208c0 8.8 7.2 16 16 16l100.7 0c15.1 0 27.3-12.2 27.3-27.3c0-7.2-2.9-14.2-8-19.3l-41-41zM64 192l0-73.4L137.4 192 64 192zM448 320l0 73.4L374.6 320l73.4 0z"
  ]
}, Use = {
  prefix: "fal",
  iconName: "arrow-rotate-right",
  icon: [
    512,
    512,
    [8635, "arrow-right-rotate", "arrow-rotate-forward", "redo"],
    "f01e",
    "M464 192c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 92.6C408.8 75.5 337.5 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c79.9 0 150-41.8 189.7-104.8c6.6-10.4-1.4-23.2-13.7-23.2c-6 0-11.4 3.2-14.7 8.2C383.1 413 323.6 448 256 448C150 448 64 362 64 256S150 64 256 64c71.1 0 133.1 38.6 166.3 96L336 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0z"
  ]
}, Fse = {
  prefix: "fal",
  iconName: "plus",
  icon: [
    448,
    512,
    [10133, 61543, "add"],
    "2b",
    "M240 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 176L32 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l176 0 0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176 176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0 0-176z"
  ]
}, qse = {
  prefix: "fal",
  iconName: "chevron-left",
  icon: [
    320,
    512,
    [9001],
    "f053",
    "M20.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 256 235.3 436.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-192-192z"
  ]
}, Bse = {
  prefix: "fal",
  iconName: "spinner-third",
  icon: [
    512,
    512,
    [],
    "f3f4",
    "M463.9 376c7.6 4.4 17.5 1.8 21.4-6.1c17.1-34.3 26.7-73 26.7-113.9C512 120 405.9 8.8 272 .5c-8.8-.5-16 6.7-16 15.5s7.2 15.9 16 16.6C388.2 40.8 480 137.7 480 256c0 35.1-8.1 68.3-22.5 97.9c-3.9 8-1.3 17.7 6.4 22.1z"
  ]
}, Hse = {
  prefix: "fal",
  iconName: "chevron-down",
  icon: [
    512,
    512,
    [],
    "f078",
    "M267.3 395.3c-6.2 6.2-16.4 6.2-22.6 0l-192-192c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 361.4 436.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-192 192z"
  ]
}, Gse = {
  prefix: "fal",
  iconName: "rotate-right",
  icon: [
    512,
    512,
    ["redo-alt", "rotate-forward"],
    "f2f9",
    "M417.3 360.2c3.2-5 8.7-8.2 14.7-8.2c12.3 0 20.3 12.8 13.7 23.2C406 438.2 335.9 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c56.1 0 107.4 20.6 146.7 54.7L433.4 56c5.1-5.1 12.1-8 19.3-8C467.8 48 480 60.2 480 75.3L480 176c0 8.8-7.2 16-16 16l-100.7 0c-15.1 0-27.3-12.2-27.3-27.3c0-7.2 2.9-14.2 8-19.3l36-36C346.5 81.1 303.3 64 256 64C150 64 64 150 64 256s86 192 192 192c67.6 0 127.1-35 161.3-87.8zM448 86.6L374.6 160l73.4 0 0-73.4z"
  ]
}, Wse = {
  prefix: "fal",
  iconName: "sliders",
  icon: [
    512,
    512,
    ["sliders-h"],
    "f1de",
    "M0 416c0 8.8 7.2 16 16 16l65.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64L496 432c8.8 0 16-7.2 16-16s-7.2-16-16-16l-257.6 0c-7.4-36.5-39.7-64-78.4-64s-71 27.5-78.4 64L16 400c-8.8 0-16 7.2-16 16zm112 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM304 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48-80c-38.7 0-71 27.5-78.4 64L16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l257.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64l65.6 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-65.6 0c-7.4-36.5-39.7-64-78.4-64zM192 144a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm78.4-64C263 43.5 230.7 16 192 16s-71 27.5-78.4 64L16 80C7.2 80 0 87.2 0 96s7.2 16 16 16l97.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64L496 112c8.8 0 16-7.2 16-16s-7.2-16-16-16L270.4 80z"
  ]
}, Zse = {
  prefix: "fal",
  iconName: "spinner",
  icon: [
    512,
    512,
    [],
    "f110",
    "M256 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 480a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM64 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zm464 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120.2 391.8A16 16 0 1 0 97.6 414.4a16 16 0 1 0 22.6-22.6zM75 437a48 48 0 1 1 67.9-67.9A48 48 0 1 1 75 437zM97.6 120.2a16 16 0 1 0 22.6-22.6A16 16 0 1 0 97.6 120.2zM142.9 75A48 48 0 1 1 75 142.9 48 48 0 1 1 142.9 75zM414.4 414.4a16 16 0 1 0 -22.6-22.6 16 16 0 1 0 22.6 22.6zm-45.3-45.3A48 48 0 1 1 437 437a48 48 0 1 1 -67.9-67.9z"
  ]
}, kd = {
  prefix: "fal",
  iconName: "check",
  icon: [
    448,
    512,
    [10003, 10004],
    "f00c",
    "M443.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-272 272c-6.2 6.2-16.4 6.2-22.6 0l-144-144c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L160 361.4 420.7 100.7c6.2-6.2 16.4-6.2 22.6 0z"
  ]
}, Kse = {
  prefix: "fal",
  iconName: "trash-can",
  icon: [
    448,
    512,
    [61460, "trash-alt"],
    "f2ed",
    "M164.2 39.5L148.9 64l150.3 0L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5l-92.5 0c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64 384 64l32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 336c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80L32 96 16 96C7.2 96 0 88.8 0 80s7.2-16 16-16l16 0 32 0 47.1 0L137 22.6C145.8 8.5 161.2 0 177.7 0l92.5 0c16.6 0 31.9 8.5 40.7 22.6zM64 96l0 336c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-336L64 96zm80 80l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16z"
  ]
}, Qse = Kse, Xse = {
  prefix: "fal",
  iconName: "up-right-and-down-left-from-center",
  icon: [
    512,
    512,
    ["expand-alt"],
    "f424",
    "M321 0c-18.2 0-33 14.8-33 33c0 8.7 3.5 17.1 9.7 23.3L325.4 84l-71.7 71.7c-15.6 15.6-15.6 40.9 0 56.6l46.1 46.1c15.6 15.6 40.9 15.6 56.6 0L428 186.6l27.7 27.7c6.2 6.2 14.6 9.7 23.3 9.7c18.2 0 33-14.8 33-33l0-159c0-17.7-14.3-32-32-32L321 0zm-1 33c0-.5 .4-1 1-1l159 0 0 159c0 .5-.4 1-1 1c-.3 0-.5-.1-.7-.3l-39-39c-6.2-6.2-16.4-6.2-22.6 0l-83 83c-3.1 3.1-8.2 3.1-11.3 0l-46.1-46.1c-3.1-3.1-3.1-8.2 0-11.3l83-83c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-39-39c-.2-.2-.3-.4-.3-.7zM32 512l159 0c18.2 0 33-14.8 33-33c0-8.7-3.5-17.1-9.7-23.3L186.6 428l71.7-71.7c15.6-15.6 15.6-40.9 0-56.6l-46.1-46.1c-15.6-15.6-40.9-15.6-56.6 0L84 325.4 56.3 297.7C50.1 291.5 41.7 288 33 288c-18.2 0-33 14.8-33 33L0 480c0 17.7 14.3 32 32 32zm160-33c0 .5-.4 1-1 1L32 480l0-159c0-.5 .4-1 1-1c.3 0 .5 .1 .7 .3l39 39c6.2 6.2 16.4 6.2 22.6 0l83-83c3.1-3.1 8.2-3.1 11.3 0l46.1 46.1c3.1 3.1 3.1 8.2 0 11.3l-83 83c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l39 39c.2 .2 .3 .4 .3 .7z"
  ]
}, Jse = {
  prefix: "fal",
  iconName: "circle-question",
  icon: [
    512,
    512,
    [62108, "question-circle"],
    "f059",
    "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm168.7-86.2c6.5-24.6 28.7-41.8 54.2-41.8l57.1 0c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L272 268.3l0 19.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-29.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3l-57.1 0c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM232 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
  ]
}, Yse = {
  prefix: "fal",
  iconName: "link",
  icon: [
    640,
    512,
    [128279, "chain"],
    "f0c1",
    "M591.5 256c50-50 50-131 0-181s-131-50-181 0L387.9 97.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6c37.5-37.5 98.3-37.5 135.8 0s37.5 98.3 0 135.8L444.3 357.9c-37.4 37.4-98.1 37.4-135.6 0c-35.6-35.6-37.6-92.6-4.7-130.6l5.3-6.1c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6l-5.3 6.1c-43.9 50.7-41.2 126.7 6.2 174.1c49.9 49.9 130.9 49.9 180.8 0L591.5 256zM48.5 256c-50 50-50 131 0 181s131 50 181 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8L195.7 154.1c37.4-37.4 98.1-37.4 135.6 0c35.6 35.6 37.6 92.6 4.7 130.6l-5.3 6.1c-5.8 6.7-5.1 16.8 1.6 22.6s16.8 5.1 22.6-1.6l5.3-6.1c43.9-50.7 41.2-126.7-6.2-174.1C303.9 81.5 223 81.5 173 131.4L48.5 256z"
  ]
}, eie = {
  prefix: "fal",
  iconName: "circle-exclamation",
  icon: [
    512,
    512,
    ["exclamation-circle"],
    "f06a",
    "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
  ]
}, bd = {
  prefix: "fal",
  iconName: "arrow-up-from-bracket",
  icon: [
    448,
    512,
    [],
    "e09a",
    "M235.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 54.6 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16l0-281.4L340.7 155.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128zM32 336c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48l0-96z"
  ]
}, tie = {
  prefix: "fal",
  iconName: "align-center",
  icon: [
    448,
    512,
    [],
    "f037",
    "M112 48c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L112 48zM16 176c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 176zM96 320c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zM16 432c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 432z"
  ]
}, nie = {
  prefix: "fal",
  iconName: "image",
  icon: [
    512,
    512,
    [],
    "f03e",
    "M64 64C46.3 64 32 78.3 32 96l0 233.4 67.7-67.7c15.6-15.6 40.9-15.6 56.6 0L224 329.4 355.7 197.7c15.6-15.6 40.9-15.6 56.6 0L480 265.4 480 96c0-17.7-14.3-32-32-32L64 64zM32 374.6L32 416c0 17.7 14.3 32 32 32l41.4 0 96-96-67.7-67.7c-3.1-3.1-8.2-3.1-11.3 0L32 374.6zM389.7 220.3c-3.1-3.1-8.2-3.1-11.3 0L150.6 448 448 448c17.7 0 32-14.3 32-32l0-105.4-90.3-90.3zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm160 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
  ]
}, oie = {
  prefix: "fal",
  iconName: "align-right",
  icon: [
    448,
    512,
    [],
    "f038",
    "M432 48c8.8 0 16 7.2 16 16s-7.2 16-16 16L176 80c-8.8 0-16-7.2-16-16s7.2-16 16-16l256 0zm0 128c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 208c-8.8 0-16-7.2-16-16s7.2-16 16-16l416 0zm16 144c0 8.8-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l256 0c8.8 0 16 7.2 16 16zM432 432c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 464c-8.8 0-16-7.2-16-16s7.2-16 16-16l416 0z"
  ]
}, aie = {
  prefix: "fal",
  iconName: "chevron-right",
  icon: [
    320,
    512,
    [9002],
    "f054",
    "M299.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L265.4 256 84.7 75.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l192 192z"
  ]
}, wd = {
  prefix: "fal",
  iconName: "ellipsis-vertical",
  icon: [
    128,
    512,
    ["ellipsis-v"],
    "f142",
    "M64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-160a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM96 96A32 32 0 1 0 32 96a32 32 0 1 0 64 0z"
  ]
}, sie = {
  prefix: "fal",
  iconName: "chevron-up",
  icon: [
    512,
    512,
    [],
    "f077",
    "M244.7 116.7c6.2-6.2 16.4-6.2 22.6 0l192 192c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 150.6 75.3 331.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192z"
  ]
}, iie = {
  prefix: "fal",
  iconName: "align-left",
  icon: [
    448,
    512,
    [],
    "f036",
    "M16 48C7.2 48 0 55.2 0 64s7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 48zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 176zM0 320c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 304c-8.8 0-16 7.2-16 16zM16 432c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 432z"
  ]
}, rie = {
  prefix: "fal",
  iconName: "floppy-disk",
  icon: [
    448,
    512,
    [128190, 128426, "save"],
    "f0c7",
    "M32 96c0-17.7 14.3-32 32-32l0 96c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-94.2c4.5 1.6 8.7 4.2 12.1 7.6l74.5 74.5c6 6 9.4 14.1 9.4 22.6L416 416c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96zM96 64l192 0 0 96L96 160l0-96zM0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-245.5c0-17-6.7-33.3-18.7-45.3L354.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96zM272 320a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z"
  ]
}, xd = rie, lie = {
  prefix: "fal",
  iconName: "magnifying-glass",
  icon: [
    512,
    512,
    [128269, "search"],
    "f002",
    "M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L507.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z"
  ]
}, cie = {
  prefix: "fal",
  iconName: "minus",
  icon: [
    448,
    512,
    [8211, 8722, 10134, "subtract"],
    "f068",
    "M432 256c0 8.8-7.2 16-16 16L32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l384 0c8.8 0 16 7.2 16 16z"
  ]
}, uie = {
  prefix: "fak",
  iconName: "icon-database",
  icon: [
    611,
    512,
    [],
    "e033",
    "M452.3 90.5l-395.9 0C25.3 90.5 0 115.8 0 146.9L0 449.4c0 31.1 25.3 56.4 56.4 56.4l395.9 0c31.1 0 56.3-25.3 56.3-56.4l0-302.5c0-31.1-25.3-56.4-56.3-56.4zM56.4 126l395.9 0c11.5 0 20.9 9.4 20.9 20.9l0 212.4-116.2-116.2c-6.1-6.1-16.1-6.1-22.3 0l-119.3 119.3-51.8-51.8c-3-3-7-4.6-11.1-4.6-3.7-.4-8.3 1.7-11.3 4.8l-105.8 108.6 0-272.3c0-11.5 9.4-20.9 20.9-20.9zM452.3 470.4l-395.9 0c-7.4 0-13.6-4.1-17.3-9.9l113.6-116.3 51.7 51.7c3 3 7 4.6 11.1 4.6s8.2-1.7 11.1-4.6l119.3-119.3 127.4 127.4 0 45.6c0 11.5-9.4 20.9-20.9 20.9zM125 273.7a54.7 54.7 0 1 0 0-109.3 54.7 54.7 0 1 0 0 109.3zm0-31.5a23.2 23.2 0 1 1 0-46.3 23.2 23.2 0 1 1 0 46.3zM540.3 0L144.4 0C113.3 0 88 25.3 88 56.3 88 66.1 96 74.1 105.8 74.1s17.7-7.9 17.7-17.7c0-11.5 9.4-20.9 20.9-20.9l395.9 0c11.5 0 20.9 9.4 20.9 20.9l0 302.5c0 11.5-9.4 20.9-20.9 20.9-9.8 0-17.7 7.9-17.7 17.7s7.9 17.7 17.7 17.7c31.1 0 56.3-25.3 56.3-56.3l0-302.5C596.7 25.3 571.4 0 540.3 0z"
  ]
}, die = {
  prefix: "fak",
  iconName: "tshirt-size",
  icon: [
    608,
    512,
    [],
    "e001",
    "M560.5 84.3L397.1 1.1s-10 11.4-15.8 17.2c-7.4 7.4-17.9 13.7-30.4 18.1-13.6 4.8-29.3 7.4-45.3 7.4-16 0-31.7-2.6-45.3-7.4-12.5-4.4-23-10.7-30.4-18.1-5.8-5.8-15.8-17.2-15.8-17.2L49.3 85c-7.2 3.6-12.7 9.9-15.2 17.6-2.5 7.7-1.8 16 1.9 23.1l46.5 89.8c5.3 10.3 15.8 16.2 26.7 16.2 4.6 0 9.2-1.1 13.6-3.3l38.8-19.7v26.2l.4.4c2.1 2.1 7.2 4.6 14.6 4.6s12.5-2.5 14.6-4.6l.4-.4v-75.2l-82.4 41.9-46.5-89.8 146-72.4c21.4 21.4 57.1 34.4 96.9 34.4 39.8 0 75.6-12.9 96.9-34.4l144.6 71.7-43.4 89.9-84.3-41.2V415c0 6.3-5.1 11.4-11.4 11.4H294.2v30h113.9c22.8 0 41.4-18.6 41.4-41.4V207.8l41.1 20.1c4.1 2 8.7 3.1 13.2 3.1 3.3 0 6.6-.5 9.8-1.6 7.5-2.6 13.7-8.1 17.2-15.3l43.4-89.8c7.1-14.9 1-32.7-13.7-40zM228.1 276.1l76.6 38-23 47.5-44.6-21.8v135.1c0 3.3-2.7 6-6 6H122.5c-3.3 0-6-2.7-6-6V339.8L72.8 362l-24.6-47.5 77.3-38.3c11.3 11.3 30.2 18.2 51.3 18.2 21.1-.1 40-6.9 51.3-18.3m-94.8-37.4l-98.4 48.9c-7.2 3.6-12.7 9.9-15.2 17.6-2.5 7.7-1.8 16 1.9 23.1l24.6 47.5C51.5 386.1 62 392 72.9 392c4.6 0 9.2-1.1 13.6-3.3v86.2c0 19.9 16.2 36 36 36h108.6c19.9 0 36-16.2 36-36v-87l1.4.7c4.1 2 8.7 3.1 13.2 3.1 3.3 0 6.6-.5 9.8-1.6 7.5-2.6 13.7-8.1 17.2-15.3l23-47.5c7.2-14.8 1.1-32.6-13.7-39.9l-97.7-48.5s-7.7 10.5-13.5 16.3c-4.3 4.3-14.8 9.4-30.1 9.4s-25.8-5.1-30.1-9.4c-5.6-6-13.3-16.5-13.3-16.5z"
  ]
}, mie = {
  prefix: "fak",
  iconName: "icon-design-logo",
  icon: [
    512,
    512,
    [],
    "e023",
    "M398.4 215.4l-10.9 3.2c-.6 0-1 .3-1.6 .6c-.3 .6-.6 1.3-.6 1.9c-.3 10.6 0 21.1 1 31.7c0 1.6 .3 2.9 .6 4.5c.6 1 1 1.6 1.6 2.6c1.3 1.6 1.9 3.5 2.2 5.8c0 5.4-4.2 9.6-9.6 9.6s-9.6-4.2-9.6-9.6l0 0c0-2.2 .6-4.2 2.2-5.8c.6-.6 1.3-1.6 1.6-2.6c.3-1.3 .6-2.9 .3-4.5c.3-8.6 1-19.5 1-25c-.3-4.8-.3-9.9 .3-14.7c.3-3.8 3.8-6.7 7.7-6.1c.6 0 1.6 .3 2.2 .6c3.8 1.6 7.4 3.5 10.9 5.8l.6 .3c1.3 .6 .3 1.3 0 1.6l0 0zM381.1 337.3s-4.2 5.1-6.1 8c0 0-.3 .3-.6 .3h-15c-.3 0-.6-.3-.6-.6v-1.6c0-.3 0-.3 .3-.6l16-8 .3 0 .3 0c.6-.3 1-1.3 1-1.9c0-.3 0-.6 0-.6s-4.5-24-6.4-33.3c0-.6 .3-1.3 1-1c3.2 1 6.7 1.6 9.9 1.6c3.5 0 6.7-.6 9.9-1.6c.6 0 1 .3 1 1c-1.9 9.6-6.4 33.3-6.4 33.3c0 .3 0 .6 0 .6c0 .6 .3 1.6 1 1.9l.3 0 .3 0 16 8c.3 0 .3 .3 .3 .3v1.3c0 .3-.3 .6-.6 .6h-15.4c-.3 0-.3 0-.6-.3c-1.9-2.2-5.8-7.4-5.8-7.4m0-56.6c-8.6 0-15.4-7-15.4-15.4c0-3.5 1.3-6.7 3.2-9.3l0-.3 1-1.3 .3-.3-.3-.6 0 0c-2.9-7.4-7.7-13.8-13.8-18.6c-16 5.8-27.2 20.5-28.2 37.4c1.9 21.1 18.2 38.1 39 41c-1-4.8-1.6-9.3-2.6-13.8v0c-.3-2.2 .3-4.5 1.9-6.1s3.8-2.2 5.8-1.9c.3 0 .6 0 1 .3c2.6 .6 5.4 1.3 8 1.3s5.4-.3 8-1.3c.3 0 .6-.3 1-.3c2.2-.3 4.5 .3 5.8 1.9c1.6 1.6 2.2 3.8 1.9 6.1v0c-1 4.5-1.6 9.3-2.6 13.8c20.8-2.9 37.1-19.8 39-41c-1-17-12.2-32-28.2-37.8c-6.4 4.8-11.2 11.2-13.8 18.6l-.3 .6 .3 .6 1 1.3 0 .3c1.9 2.6 2.9 5.8 3.2 9c0 0 0 .3 0 .6c0 8-7 15-15.4 15l0 0zM512 192V176.6c0-14.7-10.2-27.2-24.3-30.4c0-2.9-.6-5.8-1.6-8.3c-3.2-12.2-10.9-22.1-21.8-28.5l-89.6-51.8 0 0c-15.7-11.8-43.2-7.7-61.4-8.3v.3c-6.4 0-12.8 3.5-16 9.6c-10.2 20.2-30.7 33-53.8 33s-43.5-12.8-53.8-33.3c-3.2-6.1-9.3-9.6-15.7-9.6v0c-17.9 .6-44.5-3.2-60.2 7.7L23.4 108.8c-10.9 6.4-18.6 16.3-21.8 28.5c-9.9 25.9 25.3 66.9 35.5 88.6c13.1 22.7 42.2 30.1 64.3 17V416c0 25.9 21.1 46.7 46.7 46.7h191c25.6 0 46.7-21.1 46.7-46.7v-36.8h48c1.9 15.4 15 27.5 31 27.5h15.7c17.3 0 31.4-14.1 31.4-31.4v-15.7c0-16-12.2-29.1-27.5-31V223c15.4-1.9 27.5-15 27.5-31zM350.4 416c0 6.4-5.1 11.5-11.2 11.5h-191c-6.4 0-11.5-5.1-11.5-11.5V212.2c-.3-8.6-7-17-16.3-17.3c-8.3-2.2-30.1 14.4-37.1 17.3c-5.1 3.2-12.5 1.3-15.7-4.2L37.1 154.9c-3.2-5.1-1.3-12.5 4.2-15.4c0 0 90.2-52.2 90.6-52.2l0 0c5.8-4.8 25-2.2 32-2.9c34.2 56.6 125.1 56.6 159.4 0c7.4 .6 26.2-1.9 32.6 2.9l0 0c0 .3 90.6 52.2 90.6 52.5c2.9 1.6 4.8 4.8 5.4 8c-9.6 4.5-16.6 13.8-18.2 24.6H328.3c-1.9-15.4-15-27.5-31-27.5H281.6c-17.3 0-31.4 14.1-31.4 31.4V192c0 16 12.2 29.1 27.5 31v105.3c-15.4 1.9-27.5 15-27.5 31V375c0 17.3 14.1 31.4 31.4 31.4h15.7c16 0 29.1-12.2 31-27.5h22.1c0 22.1 0 37.1 0 37.1zM281.6 200c-4.5 0-8-3.5-8-8V176.6c0-4.5 3.5-8 8-8h15.7c4.5 0 8 3.5 8 8V192c0 4.5-3.5 8-8 8H281.6zM305 359.7v15.7c0 4.5-3.5 8-8 8H281.6c-4.5 0-8-3.5-8-8v-15.7c0-4.5 3.5-8 8-8h15.7c4.2 0 7.7 3.5 7.7 8zm128.6-3.8H328.3c-1.9-14.1-12.8-25.3-27.2-27.2V223c14.1-1.9 25.3-12.8 27.2-27.2h105.3c1.9 14.1 12.8 25.3 27.2 27.2v105.3c-14.1 2.2-25.3 13.1-27.2 27.5zm54.7 3.8v15.7c0 4.5-3.5 8-8 8h-15.7c-4.5 0-8-3.5-8-8v-15.7c0-4.5 3.5-8 8-8h15.7c4.5 0 8 3.5 8 8zm-8-159.7h-15.7c-4.5 0-8-3.5-8-8V176.6c0-4.5 3.5-8 8-8h15.7c4.5 0 8 3.5 8 8V192c0 4.5-3.5 8-8 8z"
  ]
}, pie = {
  prefix: "fak",
  iconName: "icon-info",
  icon: [
    512,
    512,
    [],
    "e013",
    "M256 38.4A218 218 0 1 1 38.4 256 218 218 0 0 1 256 38.4M256 0A256 256 0 1 0 512 256 256 256 0 0 0 256 0zM256 172A25.6 25.6 0 0 1 256 121h.208a25.6 25.6 0 0 1 0 51.2zM256 400a21.3 21.3 0 0 1 -21.3-21.3v-.405c.043-5.77 .043-132 0-138v-.405a21.3 21.3 0 0 1 21.3-21.3c21.3 0 21.4 16.2 21.4 43l.021 47.6-.021 47.6C277 384 277 400 256 400z"
  ]
}, fie = {
  prefix: "fak",
  iconName: "tshirt-color",
  icon: [
    608,
    512,
    [],
    "e000",
    "M407 198.4c15.1 49.2 38.1 82 56.6 108.5 20.1 28.8 34.7 49.6 34.7 80.4 0 51.1-41 92.7-91.3 92.7s-91.3-41.6-91.3-92.7c0-30.7 14.6-51.6 34.8-80.5 18.5-26.5 41.4-59.4 56.5-108.4m0-30c-13.2 0-24.8 8.6-28.7 21.2-13.7 44.6-34.3 74.1-52.5 100.1-21.6 30.9-40.2 57.6-40.2 97.7C285.7 455 340.1 510 407 510s121.3-55 121.3-122.7c0-40.3-18.6-66.8-40.1-97.6-18.2-26-38.8-55.4-52.5-100.1-3.9-12.6-15.5-21.2-28.7-21.2zm153.5-84.1L397.1 1.1s-10 11.4-15.8 17.2c-7.4 7.4-17.9 13.7-30.4 18.1-13.6 4.8-29.3 7.4-45.3 7.4s-31.7-2.6-45.3-7.4c-12.5-4.4-23-10.7-30.4-18.1-5.8-5.8-15.8-17.2-15.8-17.2L49.3 85c-7.2 3.6-12.7 9.9-15.2 17.6-2.5 7.7-1.8 16 1.9 23.1l46.5 89.8c5.3 10.3 15.8 16.2 26.7 16.2 4.6 0 9.2-1.1 13.6-3.3l38.7-19.6V415c0 22.8 18.6 41.4 41.4 41.4h69.2c-4.8-9.5-8.6-19.5-11.4-30H203c-6.3 0-11.4-5.1-11.4-11.4V159.7l-82.4 41.9-46.5-89.8 146-72.4c21.4 21.4 57.1 34.4 96.9 34.4s75.6-12.9 96.9-34.4l144.6 71.7-43.4 89.9-38.9-19c4.9 15.7 10.8 29.4 17.3 41.7l8.6 4.2c4.1 2 8.7 3.1 13.2 3.1 3.3 0 6.6-.5 9.8-1.6 7.5-2.6 13.7-8.1 17.2-15.3l43.4-89.8c7-14.9.9-32.7-13.8-40zm-155 381.4c-8.5 0-34-2.2-53.3-26.6-21.5-27.3-18.9-52.9-18.9-52.9 0-18.1 29.8-20.3 29.8 3.8 0 0-.9 13.3 12.7 30.6 12.7 16.1 29.9 15.2 29.9 15.2 19.2-.1 19.2 29.9-.2 29.9z"
  ]
}, hie = {
  prefix: "fak",
  iconName: "icon-expander-clos",
  icon: [
    1024,
    512,
    [],
    "e00f",
    "M968 502a46 46 0 0 1 -30.6-11.7L507 108 76.7 490A46.1 46.1 0 0 1 15.5 421l461-410a46.2 46.2 0 0 1 61.3 0l461 410a46.1 46.1 0 0 1 -30.6 80.5z"
  ]
}, _ie = {
  prefix: "fak",
  iconName: "icon-close-large",
  icon: [
    512,
    512,
    [],
    "e00b",
    "M256 9.31A247 247 0 1 1 9.31 256 247 247 0 0 1 256 9.31m0-9.31A256 256 0 1 0 512 256 256 256 0 0 0 256 0zM268 256l77.9-77.9A8.38 8.38 0 1 0 334 166l-77.9 77.9L178 166a8.38 8.38 0 1 0 -11.8 11.9l77.9 77.9L166 334a8.38 8.38 0 1 0 11.8 11.9l77.9-77.9 77.9 77.9A8.38 8.38 0 1 0 346 334z"
  ]
}, vie = {
  prefix: "fak",
  iconName: "icon-easytransfer",
  icon: [
    528,
    512,
    [],
    "e026",
    "M441.6 94.4a17.6 30.4 0 1 0 0 60.8 17.6 30.4 0 1 0 0-60.8zM520 124.8c0 70.4-33.6 124.8-78.4 124.8c-20.8 0-38.4-12.8-52.8-32c-4.8 65.6-11.2 160-11.2 185.6c-3.2 41.6-12.8 72-12.8 73.6c-8 25.6-27.2 33.6-36.8 33.6s-1.6 0-3.2 0H12.8c-4.8 0-9.6-3.2-11.2-8S0 491.2 3.2 488c16-19.2 28.8-91.2 28.8-139.2V88s-3.2-25.6 11.2-52.8c16-30.4 46.4-33.6 48-33.6h337.6c4.8-1.6 8-1.6 12.8-1.6C486.4 0 520 54.4 520 124.8zM366.4 166.4c-1.6-12.8-3.2-25.6-3.2-40c0-40 11.2-75.2 28.8-97.6H89.6c1.6 0-16 1.6-25.6 19.2c-9.6 20.8-8 40-8 40v262.4c0 38.4-8 97.6-22.4 134.4h288c6.4 0 14.4-6.4 17.6-16c0 0 9.6-28.8 11.2-67.2c3.2-35.2 12.8-188.8 16-235.2zm124.8-41.6c0-56-25.6-96-49.6-96s-49.6 40-49.6 96 25.6 96 49.6 96 49.6-40 49.6-96zm-270.4-6.4v91.2c0 3.2 3.2 6.4 6.4 6.4h91.2c3.2 0 6.4-3.2 6.4-6.4V118.4c0-3.2-3.2-6.4-6.4-6.4h-91.2c-4.8 0-6.4 3.2-6.4 6.4zM131.2 348.8a52.8 52.8 0 1 0 0 105.6 52.8 52.8 0 1 0 0-105.6zm6.4-174.4c1.6-1.6 4.8-1.6 4.8 0l54.4 92.8c0 1.6-1.6 4.8-3.2 4.8H88c-3.2 0-4.8-3.2-3.2-4.8l52.8-92.8 0 0zM297.6 288l25.6 44.8c1.6 1.6 1.6 4.8 1.6 6.4L299.2 384c-1.6 1.6-4.8 3.2-6.4 3.2H240c-3.2 0-4.8-1.6-6.4-3.2L208 339.2c-1.6-1.6-1.6-4.8 0-6.4l25.6-44.8c1.6-1.6 4.8-3.2 6.4-3.2h52.8c1.6 0 3.2 1.6 4.8 3.2z"
  ]
}, gie = {
  prefix: "fak",
  iconName: "close",
  icon: [
    512,
    512,
    [],
    "e02d",
    "M301.8 251.1l190-189.8c9.1-9.1 12.6-22.3 9.3-34.6s-13-22-25.4-25.3-25.6 .2-34.6 9.3L251.1 200.4 61.3 10.5c-14-14-36.7-14-50.7 0s-14 36.7 0 50.7l189.8 190-190 189.8c-14 14-14 36.7 0 50.7s36.7 14 50.7 0l190-189.8 189.8 190c9.1 9.1 22.3 12.6 34.6 9.3s22-13 25.4-25.3-.2-25.6-9.3-34.6z"
  ]
}, yie = {
  prefix: "fak",
  iconName: "icon-remove",
  icon: [
    448,
    512,
    [],
    "e014",
    "M420 79.8H311V68.1A68.1 68.1 0 0 0 243 0H198A68.1 68.1 0 0 0 129 68.1v11.7H21.3a21.3 21.3 0 1 0 0 42.7h12.6L64 451A61 61 0 0 0 125 512h192a60.6 60.6 0 0 0 61-59.1L407 122h12.4a21.3 21.3 0 0 0 0-42.7zM172 68.1A26 26 0 0 1 198 42.7H243a25.8 25.8 0 0 1 25.8 25.8v11.7H172zm163 384a18.8 18.8 0 0 1 -18.8 18.8h-192a19.2 19.2 0 0 1 -18.8-21.3L76.2 122H365zM220 180a16.4 16.4 0 0 0 -16.4 16.4v199a16.4 16.4 0 0 0 32.9 0V196A16.2 16.2 0 0 0 220 180zM272 196v199a16.4 16.4 0 0 0 32.9 0V196a16.4 16.4 0 0 0 -32.9 0zM153 180a16.4 16.4 0 0 0 -16.4 16.4v199a16.6 16.6 0 0 0 33.1 0V196A16.4 16.4 0 0 0 153 180z"
  ]
}, kie = {
  prefix: "fak",
  iconName: "upload",
  icon: [
    541,
    512,
    [],
    "e027",
    "M277.6 6c-9.1-8-22.5-8-31.9 0l-95 81.4c-10.8 8.2-12.8 23.6-4.6 34.1 8.2 10.8 23.6 12.8 34.1 4.6 .9-.6 1.4-1.1 2-1.7l54.6-46.6 0 218.2c.6 13.4 11.7 24.2 25.3 23.6 12.8-.6 23-10.8 23.6-23.6l0-218.5 54.6 46.6c10 9.1 25.6 8.2 34.4-2s8.2-25.6-2-34.4c0 0-.6-.6-.9-.6L277.6 6zM498.9 300.4c-13.4 0-24.5 10.8-24.5 24.5l0 0 0 87.3c0 13.9-11.4 25-25.3 25L74 437.2c-13.7 0-25-11.1-25.3-24.7l0-87.6c-.6-13.4-11.7-24.2-25.3-23.6-12.8 .6-23 10.8-23.6 23.6l0 87.6c.3 40.7 33.3 73.4 74 73.7l374.9 0c19.6 .9 39-7.1 52.6-21.3 13.9-13.7 21.9-32.7 22.2-52.3l0-87.6c0-13.4-10.8-24.5-24.5-24.5l0 0z"
  ]
}, bie = {
  prefix: "fak",
  iconName: "icon-expander-small-close",
  icon: [
    1110,
    512,
    [],
    "e011",
    "M1016 538a76.5 76.5 0 0 1 -48.6-17.4L546 176 126 520A76.8 76.8 0 1 1 28.5 401l469-384a76.7 76.7 0 0 1 97.3 0l469 384a76.8 76.8 0 0 1 -48.7 136z"
  ]
}, wie = {
  prefix: "fak",
  iconName: "icon-design-text",
  icon: [
    512,
    512,
    [],
    "e022",
    "M420.4 235.8l-33.5 0 0 92.9-13.7 0 0-92.9-33.4 0 0-11.2 80.5 0zm91.5-43.7V176.5c0-14.8-10.4-27.3-24.3-30.6c-.2-2.9-.6-5.7-1.6-8.3c-3.2-12.1-11-22.1-21.8-28.4l-89.7-51.8 0 0c-15.7-11.7-43.3-7.7-61.5-8.3v.2c-6.5 0-12.7 3.4-15.8 9.6c-10.2 20.5-30.8 33.3-53.8 33.3s-43.6-12.7-53.8-33.3c-3.1-6.2-9.3-9.6-15.8-9.6v-.2c-17.8 .6-44.4-3.2-60.3 7.6v0L23.4 108.9c-10.8 6.3-18.6 16.4-21.8 28.4c-10 25.8 25.4 67 35.4 88.5c13 22.7 42.3 30 64.3 16.9v173.2c0 25.8 21 46.8 46.8 46.8H339c25.8 0 46.7-21 46.7-46.8v-36.7h48c2 15.5 15.1 27.5 31 27.5h15.6c17.3 0 31.5-14.1 31.5-31.5v-15.6c0-16-12-29.1-27.5-31V223.2c15.5-2 27.5-15.1 27.5-31.1zM350.3 415.9c0 6.3-5.1 11.4-11.3 11.4H148.1c-6.3 0-11.4-5.1-11.4-11.4V212.2c-.4-8.9-7.1-17-16.3-17.4c-8.2-2.2-30.1 14.5-37.2 17.5c-5.2 3.2-12.5 1.2-15.5-4.2L37 155c-3.2-5.2-1.2-12.6 4.1-15.5c.1-.1 90.4-52.2 90.4-52.3l0 0c6.1-4.5 25.1-2.1 32.2-2.7c34.4 56.7 125.1 56.7 159.4 0c7.5 .6 26.3-2 32.6 2.9l0-.1c0 .4 90.5 52.3 90.7 52.5c3 1.7 4.8 4.7 5.3 8c-9.7 4.4-16.8 13.6-18.2 24.6H328.3c-2-15.5-15.1-27.5-31-27.5H281.6c-17.3 0-31.5 14.1-31.5 31.5v15.6c0 16 12 29.1 27.5 31.1v105.4c-15.5 2-27.5 15.1-27.5 31v15.6c0 17.3 14.1 31.5 31.5 31.5h15.6c16 0 29.1-12 31-27.5h22c0 21.7 0 36.7 0 36.7zM281.6 200c-4.4 0-7.9-3.5-7.9-7.9V176.5c0-4.4 3.5-7.9 7.9-7.9h15.6c4.4 0 7.9 3.5 7.9 7.9v15.6c0 4.4-3.5 7.9-7.9 7.9H281.6zm23.5 159.6v15.6c0 4.4-3.5 7.9-7.9 7.9H281.6c-4.4 0-7.9-3.5-7.9-7.9v-15.6c0-4.4 3.5-7.9 7.9-7.9h15.6c4.4 0 7.9 3.6 7.9 7.9zm128.6-4H328.3c-1.8-14.1-12.9-25.3-27.1-27.1V223.2c14.1-1.8 25.2-12.9 27.1-27.1h105.4c1.8 14.1 13 25.2 27.1 27.1v105.4c-14.1 1.8-25.2 12.9-27.1 27.1zm54.6 4v15.6c0 4.4-3.5 7.9-7.9 7.9h-15.6c-4.4 0-7.9-3.5-7.9-7.9v-15.6c0-4.4 3.5-7.9 7.9-7.9h15.6c4.3 0 7.9 3.6 7.9 7.9zM480.4 200h-15.6c-4.4 0-7.9-3.5-7.9-7.9V176.5c0-4.4 3.5-7.9 7.9-7.9h15.6c4.4 0 7.9 3.5 7.9 7.9v15.6c0 4.4-3.6 7.9-7.9 7.9z"
  ]
}, xie = {
  prefix: "fak",
  iconName: "download",
  icon: [
    640,
    512,
    [],
    "e020",
    "M315.8 8.1A23.8 23.8 0 0 0 296.2 31.5l0 212.3-53.1-45.6a23.8 23.8 0 0 0 -30.9 36.1l92.4 79.2a23.8 23.8 0 0 0 30.9 0l92.4-79.2a23.8 23.8 0 0 0 -30.9-36.1l-53.2 45.6 0-212.3A23.8 23.8 0 0 0 315.8 8.1zM89 323.6A23.8 23.8 0 0 0 65.3 347.3l0 85.3a72.2 72.2 0 0 0 71.9 71.6l365 0a66.3 66.3 0 0 0 51.1-20.8 71.5 71.5 0 0 0 21.5-50.9l0-85.2a23.8 23.8 0 0 0 -23.8-23.8 23.8 23.8 0 0 0 -23.8 23.8l0 85.1a24.6 24.6 0 0 1 -24.7 24.4l-365.2 0a24.5 24.5 0 0 1 -24.5-24.2l0-85.3A23.8 23.8 0 0 0 89 323.6z"
  ]
}, $ie = {
  prefix: "fak",
  iconName: "size",
  icon: [
    606,
    512,
    [],
    "e028",
    "M534.6 0L66.6 0C29.8 0 0 29.8 0 66.6L0 424c0 36.8 29.8 66.6 66.6 66.6l468 0c36.8 0 66.6-29.8 66.6-66.6l0-357.5C601.1 29.8 571.3 0 534.6 0zm24.7 424.3c0 13.7-11.2 24.7-24.7 24.7l-468 0c-13.7 0-24.7-11.2-24.7-24.7l0-357.7c0-13.7 11.2-24.7 24.7-24.7l468 0c13.7 0 24.7 11.2 24.7 24.7l0 357.5zM411 116.4l-94 0c-10.2 0-18.6 8.4-18.6 18.6s8.4 18.6 18.6 18.6l49.1 0-157.3 157.3 0-49.1c0-10.2-8.4-18.6-18.6-18.6s-18.6 8.4-18.6 18.6l0 94c0 1.9 .5 3.5 .9 5.1 0 .7 0 1.2 .5 1.9 1.9 4.7 5.6 8.4 10.2 10.2 .5 0 .9 0 1.4 .2 1.9 .5 3.7 1.2 5.6 1.2l94 0c10.2 0 18.6-8.4 18.6-18.6s-8.4-18.6-18.6-18.6l-49.1 0 157.3-157.3 0 49.1c0 10.2 8.4 18.6 18.6 18.6s18.6-8.4 18.6-18.6l0-94c0-10.2-8.4-18.6-18.6-18.6z"
  ]
}, zie = {
  prefix: "fak",
  iconName: "icon-ciconfig-italic",
  icon: [
    501,
    512,
    [],
    "e00a",
    "M232 296l-13.9 12.1-5.8 33.5h-29.8l28.1-162h29.8l-15.4 88.1 5.8-6.26 33.9-33.9h38.2l-49.9 49 31.7 65.1h-32.7l-20.3-45.5z"
  ]
}, Sie = {
  prefix: "fak",
  iconName: "circle-close",
  icon: [
    512,
    512,
    [],
    "e030",
    "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm272.9 0l63.3-63.3c4.7-4.7 4.7-12.2 0-16.9s-12.2-4.7-16.9 0l-63.3 63.3-63.3-63.3c-4.7-4.7-12.2-4.7-16.9 0s-4.7 12.2 0 16.9l63.3 63.3-63.3 63.3c-4.7 4.7-4.7 12.2 0 16.9s12.2 4.7 16.9 0l63.3-63.3 63.3 63.3c4.7 4.7 12.2 4.7 16.9 0s4.7-12.2 0-16.9z"
  ]
}, Cie = {
  prefix: "fak",
  iconName: "images",
  icon: [
    560,
    512,
    [],
    "e02a",
    "M403.7 511.9c-3.6 0-7.2-.5-10.8-1.5L29.7 410.8C8.2 405-4.5 382.6 1.4 361.2L50.3 183c1.3-4.7 6.2-7.5 10.8-6.2 4.7 1.3 7.5 6.1 6.2 10.8L18.5 365.8c-3.3 12.1 3.8 24.7 15.9 28l363.2 99.6c5.9 1.6 12 .8 17.3-2.2s9.1-7.9 10.7-13.8l21.8-79.7c1.3-4.7 6.1-7.5 10.8-6.2s7.5 6.1 6.2 10.8l-21.8 79.7c-2.9 10.4-9.6 19.1-19 24.4-6.2 3.5-13 5.3-20 5.3zM204.4 164.3c-24.8 0-45-20.2-45-45 0-12 4.6-23.3 13.2-31.8 8.5-8.5 19.8-13.2 31.8-13.2 24.8 0 45 20.2 45 45l0 0 0 0c0 12-4.6 23.3-13.2 31.8-8.5 8.5-19.8 13.2-31.8 13.2l0 0zm0-72.3c-7.3 0-14.2 2.8-19.4 8s-8 12-8 19.3c0 15.1 12.2 27.3 27.4 27.3l0 0c15.1 0 27.3-12.2 27.3-27.4l0 0c0-15.1-12.2-27.3-27.3-27.3zM526 0L123.2 0C108.1 0 95.9 12.2 95.9 27.3l0 316.1c0 15.1 12.2 27.3 27.3 27.3l402.9 0c15.1 0 27.3-12.2 27.3-27.3l0-316.1C553.4 12.2 541.1 0 526.1 0zM123.2 17.7l402.9 0c5.3 0 9.7 4.3 9.7 9.7l0 230.8-119.8-119.8c-3.3-3.3-9.2-3.3-12.5 0L288.5 253.2 236.3 201c-1.6-1.6-3.9-2.6-6.3-2.6s-4.6 1-6.2 2.6l-110.1 113 0-286.7c0-5.3 4.3-9.7 9.7-9.7zM526 353l-402.8 0c-5.3 0-9.7-4.3-9.7-9.7l0-4 116.5-119.6 52.2 52.2c3.3 3.3 9.2 3.3 12.5 0l114.9-114.9 126.1 126 0 60.4c0 5.3-4.3 9.7-9.7 9.7z"
  ]
}, Aie = {
  prefix: "fak",
  iconName: "resize",
  icon: [
    448,
    512,
    [],
    "e003",
    "M249.2 275.5c4.7-4.7 12.3-4.7 17 0L416 425.4V364c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12H332c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h61.4L243.5 298.1c-4.7-4.7-4.7-12.3 0-17l5.7-5.6zM0 44v104c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12V86.6l149.9 149.9c4.7 4.7 12.3 4.7 17 0l5.7-5.7c4.7-4.7 4.7-12.3 0-17L54.6 64H116c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H12C5.4 32 0 37.4 0 44z"
  ]
}, Pie = {
  prefix: "fak",
  iconName: "icon-edit",
  icon: [
    512,
    512,
    [],
    "e00e",
    "M480 47.1 455 21.7a78.5 78.5 0 0 0 -108 0L317 51.1 48.7 320 48.6 320l-.158 .159a18.2 18.2 0 0 0 -4.32 7.32c-.093 .273-.352 .442-.432 .721L.71 478a18.6 18.6 0 0 0 23 23L174 458c.279-.079 .448-.338 .72-.432a18.2 18.2 0 0 0 7.33-4.32l.158-.159 .011-.011L451 185 480 155a76.6 76.6 0 0 0 0-108zM45.7 456l25.1-87.8L134 431zm123-42.3L88 333 330 90.6 411 172zM454 129l-16.3 16.3L357 64.3l16.2-16.3a40.4 40.4 0 0 1 55.7 0l25.4 25.4a39.4 39.4 0 0 1 0 55.7z"
  ]
}, Tie = {
  prefix: "fak",
  iconName: "icon-design-database",
  icon: [
    512,
    512,
    [],
    "e021",
    "M492.8 364.8c-9.6 0-19.2-9.6-19.2-19.2V86.4c0-12.8-9.6-19.2-22.4-19.2H182.4c-9.6-3.2-19.2-9.6-19.2-19.2s9.6-19.2 19.2-19.2h272c28.8 0 57.6 25.6 57.6 54.4l0 262.4c0 9.6-9.6 19.2-19.2 19.2zM377.6 102.4h-320C25.6 102.4 0 128 0 160v265.6c0 32 25.6 57.6 57.6 57.6h320c32 0 57.6-25.6 57.6-57.6V160c0-32-25.6-57.6-57.6-57.6zM35.2 160c0-12.8 9.6-22.4 22.4-22.4h320c12.8 0 22.4 9.6 22.4 22.4v25.6H35.2V160zM400 220.8v121.6l-64-80c-3.2-3.2-9.6-6.4-12.8-6.4c-6.4 0-12.8 3.2-16 6.4L217.6 368l-70.4-64c-6.4-6.4-16-6.4-22.4 0l-89.6 70.4V220.8H400zM377.6 448h-320c-12.8 0-22.4-9.6-22.4-22.4v-3.2l99.2-80 73.6 64c3.2 3.2 9.6 6.4 12.8 3.2c6.4 0 9.6-3.2 12.8-6.4L320 304l76.8 99.2v22.4c3.2 12.8-6.4 22.4-19.2 22.4zm-176-150.4c-9.6 0-19.2-6.4-19.2-19.2c0-9.6 9.6-19.2 19.2-19.2s19.2 9.6 19.2 19.2c0 12.8-9.6 19.2-19.2 19.2zm0-28.8l0 9.6s0 0 0 0l0-9.6z"
  ]
}, Mie = {
  prefix: "fak",
  iconName: "icon-size-small",
  icon: [
    237,
    512,
    [],
    "e016",
    "M119 190a41.4 41.4 0 1 0 -41.4-41.4A41.4 41.4 0 0 0 119 190zm0-68.5A27.2 27.2 0 1 1 91.5 148 27.2 27.2 0 0 1 119 121zM194 245a54.3 54.3 0 0 0 -7.26-29 35.1 35.1 0 0 0 -27.9-17.1 75.1 75.1 0 0 0 -17.8 2.31 107 107 0 0 1 -22.2 2.94 84.5 84.5 0 0 1 -22.3-2.93 74.1 74.1 0 0 0 -17.7-2.32 35.1 35.1 0 0 0 -27.9 17.1 54.2 54.2 0 0 0 -7.25 29c-.623 12.7-1.95 87.9-2.02 91.2a23 23 0 0 0 22.9 22.9 22.7 22.7 0 0 0 8.13-1.56c-.706 35.1-1.45 73.7-1.99 107a27.5 27.5 0 0 0 48.1 18.3A27.5 27.5 0 0 0 167 464c-.692-42.8-1.39-74.2-2.08-106l-.023-1.03a22.7 22.7 0 0 0 8.26 1.6 23 23 0 0 0 22.9-23.1C196 333 194 258 194 245zM173 345a8.75 8.75 0 0 1 -8.73-8.6c-.535-24.5-1.07-50.6-1.6-83.3a7.09 7.09 0 0 0 -7.08-6.98l-.115 .008a7.08 7.08 0 0 0 -6.97 7.2c.527 32.5 1.06 58.4 1.58 82.8-.002 .053-.031 .097-.031 .15 0 .145 .04 .279 .042 .424 .163 7.52 .327 14.9 .488 22.3 .7 31.4 1.39 62.8 2.08 105a13.4 13.4 0 1 1 -26.8 0V359a7.09 7.09 0 0 0 -14.2 0V464a13.4 13.4 0 0 1 -26.8 .115c.608-36.9 1.46-80.8 2.24-119a7.07 7.07 0 0 0 .377-2.18L88.8 253a7.08 7.08 0 0 0 -6.96-7.21l-.123-.008a7.09 7.09 0 0 0 -7.08 6.97L74.4 265c-.304 14.1-.881 41-1.53 72.7A8.68 8.68 0 0 1 55.5 336c.015-.777 1.38-78.2 2-90.7a41.1 41.1 0 0 1 5.03-22.1 21.3 21.3 0 0 1 16.5-10.6 59.9 59.9 0 0 1 14.2 2.02 120 120 0 0 0 25.2 3.24 119 119 0 0 0 25-3.25 63.2 63.2 0 0 1 14.4-2.02A21.3 21.3 0 0 1 174 224a41.2 41.2 0 0 1 5.04 22.1c.608 12.4 1.98 89.9 1.98 90.5A8.77 8.77 0 0 1 173 345z"
  ]
}, Iie = {
  prefix: "fak",
  iconName: "icon-ciconfig-alert-warning",
  icon: [
    512,
    512,
    [],
    "e01b",
    "M256 0A256 256 0 1 0 256 512A256 256 0 1 0 256 0zM256 398c-14.1 0-25.6-11.5-25.6-25.6s11.3-25.6 25.4-25.6h0c14.1 0 25.6 11.5 25.6 25.6s-11.5 25.6-25.6 25.6zM256 300c-11.7 0-21.3-9.6-21.3-21.3v-.427c0-5.76 0-132 0-138v-.427c0-11.7 9.6-21.3 21.3-21.3 21.3 0 21.3 16.2 21.3 42.9v95.1c0 26.9 0 42.9-21.3 42.9z"
  ]
}, Eie = {
  prefix: "fak",
  iconName: "check",
  icon: [
    640,
    512,
    [],
    "e02f",
    "M227.4 472.8c-11.8 .1-23.2-4.5-31.7-12.8L12.8 277.1c-17.5-17.5-17.5-45.9 0-63.4s45.9-17.5 63.4 0L225.4 362.6 533.3 15.1C543.9 2.9 560.1-2.7 576 .4s28.7 14.6 33.8 29.9 1.5 32.2-9.3 44.1L261.2 457.7c-8.2 9.2-19.7 14.6-32 15l-1.9 0z"
  ]
}, Oie = {
  prefix: "fak",
  iconName: "icon-zoom-in",
  icon: [
    512,
    512,
    [],
    "e01d",
    "M439.9 507.3c-16.3 0-30.3-7-41.9-18.6L230.4 321.2c-9.3-9.3-9.3-20.9 0-30.3s20.9-9.3 30.3 0l167.6 167.6c7 7 20.9 7 27.9 0s7-20.9 0-27.9L288.6 263c-7-9.3-7-20.9 0-30.3c9.3-7 20.9-7 27.9 0l167.6 167.6c23.3 23.3 23.3 62.8 0 86.1c-14 14-27.9 20.9-44.2 20.9M172.2 360.7l0 0C72.1 356.1-4.7 272.3 0 172.2S88.4-4.7 188.5 0c95.4 4.7 172.2 83.8 172.2 181.5c0 2.3 0 4.7 0 9.3c0 11.6-9.3 20.9-20.9 20.9s-20.9-9.3-20.9-20.9l0 0c0-2.3 0-4.7 0-7c0-76.8-62.8-139.6-139.6-139.6S39.6 107.1 39.6 183.9c0 74.5 58.2 135 132.7 137.3c11.6 0 20.9 9.3 20.9 20.9s-9.3 18.6-20.9 18.6m65.2-207.1H200.1V116.4c0-11.6-9.3-20.9-20.9-20.9s-20.9 9.3-20.9 20.9v37.2H121c-11.6 0-20.9 9.3-20.9 20.9s9.3 20.9 20.9 20.9h37.2v37.2c0 11.6 9.3 20.9 20.9 20.9s20.9-9.3 20.9-20.9l0 0V195.5h37.2c11.6 0 20.9-9.3 20.9-20.9s-9.3-20.9-20.9-20.9"
  ]
}, Rie = {
  prefix: "fak",
  iconName: "smake",
  icon: [
    410,
    512,
    [],
    "e002",
    "M406.173 273.588c5.21 13.328 1.202 15.734-7.817 8.017-45.899-39.385-134.088-34.474-175.377 5.311-16.636 16.135-17.838 29.364-25.755 28.462-4.31-.502-4.41-6.815-3.408-14.532 12.227-94.503 183.695-100.716 212.357-27.258zM377.01 33.17c11.324 9.12 8.618 20.645 4.61 32.971-13.83 42.291-41.79 72.756-84.281 87.789-12.226 4.309-19.743.801-9.22-8.018 43.093-36.077 52.112-55.318 64.338-107.731 2.706-11.324 17.438-10.823 24.553-5.01zM268.377 18.44c-1.303-2.706-10.824-19.643 3.006-18.34 37.08 3.608 46.7 39.184 43.293 71.153-3.107 28.662-19.542 54.317-40.788 73.157-10.222 9.12-13.228 1.704-9.22-5.411 22.85-39.886 23.551-79.772 3.709-120.56zm-99.514-8.82c30.465-1.503 64.739 19.442 80.272 45.198 15.734 25.855 15.333 60.33 3.708 89.191-3.708 9.22-14.43 17.338-12.527 2.406 6.514-51.41-31.868-98.211-78.87-111.74-26.055-7.517-26.155-23.45 7.417-25.054zM12.026 381.42c44.195-3.809 87.788-24.854 115.448-45.198 11.224-8.217 15.132-4.51 9.921 7.316C122.363 377.311 75.562 420.704 33.672 419c-18.64-.802-51.51-34.975-21.646-37.58zm95.806 103.622c-25.455 3.107-69.45-15.132-28.862-34.474 37.981-18.139 60.53-56.622 72.355-97.51 4.109-14.23 16.035-20.944 17.838 9.621 2.606 43.293-8.819 115.95-61.331 122.363zm55.82-187.503c-5.813-38.182 2.004-77.466 42.49-100.816 16.637-9.621 15.033-14.03-1.703-11.525-43.994 6.514-78.87 32.77-89.091 74.86-11.325 47.002-41.59-8.918-26.657-38.382 23.55-46.3 72.455-49.807 115.047-54.417 16.535-1.804 2.806-8.919-6.414-12.927C144.41 131.382 79.67 139.5 52.112 197.524c-5.512 11.625-15.333 8.619-16.235-2.204-4.41-48.605 34.173-76.765 73.057-80.874 36.478-3.808 62.434 9.02 84.482 20.143 15.934 8.118 21.546 6.113.4-19.642-32.47-39.685-87.387-48.905-132.184-11.625-10.121 8.418-25.655 17.437-19.742-1.203 1.704-5.311 6.514-15.433 17.838-25.955 61.533-57.123 137.195-22.048 162.55 40.386 11.424 28.06 4.209 39.285 13.428 51.712 11.926 16.134 39.084 4.91 79.772 18.64 25.154 8.518 34.273 24.452 11.725 18.139-56.12-15.634-142.306 7.315-150.423 87.989-1.303 13.629-10.823 19.542-13.128 4.51zm87.287 187.002c-9.72 34.274-84.982 34.775-70.652 10.623 26.557-44.897 24.453-91.397 7.516-129.178-11.925-26.757-6.413-30.966 6.414-23.35 48.705 28.962 72.255 87.588 56.722 141.905zm158.54-128.877c-1.803 28.361-16.635 59.428-23.95 32.27-15.233-56.422-76.966-96.107-141.304-67.546-15.534 6.915-10.423 9.721 4.71 11.024 70.05 6.213 100.015 52.312 103.021 100.215 1.604 25.856-14.531 42.291-35.476 51.912-16.536 7.516-25.856 7.316-20.845-14.932 13.429-59.628-19.542-100.216-71.654-124.568-16.736-7.817-28.46-10.021 1.203-32.169 36.077-26.958 83.178-34.574 123.365-22.148 31.367 9.621 63.236 29.865 60.93 65.942z"
  ]
}, Lie = {
  prefix: "fak",
  iconName: "icon-arrow-circle-grey-right",
  icon: [
    512,
    512,
    [],
    "e005",
    "M256 0A256 256 0 1 0 256 512A256 256 0 1 0 256 0zM228 352a10.2 10.2 0 0 1 -7.48-17.2l73.1-78.3-73.1-78.3a10.2 10.2 0 1 1 15-14l79.6 85.3a10.2 10.2 0 0 1 0 14l-79.6 85.3A10.2 10.2 0 0 1 228 352z"
  ]
}, jie = {
  prefix: "fak",
  iconName: "icon-save",
  icon: [
    512,
    512,
    [],
    "e01e",
    "m504.3 135.9L375 6.7C370.7 2.3 364.8 0 358.7 0H74.8C33.5 0 0 33.5 0 74.8v361.5C0 477.4 33.5 511 74.8 511h361.7c41.2 0 74.5-33.5 74.8-74.5V152.1c0-6.1-2.3-12-6.7-16.4zm-142.8 329H149.2V304.4h212.2v160.5zm103.4-28.4c0 15.9-12.8 28.4-28.7 28.4h-28.7V281.3c0-12.8-10.2-23-23-23H126.2c-12.8 0-23 10.2-23 23v183.6H74.5c-15.9 0-28.7-12.8-28.7-28.7V74.8c0-15.9 12.8-28.7 28.7-28.7h28.7v106c0 12.8 10.2 23 23 23h206.6c12.8 0 23-10.2 23-23s-10.2-23-23-23H149.2V46.1h199.9l115.7 115.7v274.7z"
  ]
}, Die = {
  prefix: "fak",
  iconName: "icon-close-medium",
  icon: [
    512,
    512,
    [],
    "e00c",
    "M256 11.4A245 245 0 1 1 11.4 256 245 245 0 0 1 256 11.4m0-11.4A256 256 0 1 0 512 256 256 256 0 0 0 256 0zM270 256l78.1-78.1A10.2 10.2 0 0 0 334 163l-78.1 78.1L178 163A10.2 10.2 0 0 0 163 178l78.1 78.1L163 334a10.2 10.2 0 1 0 14.5 14.5l78.1-78.1L334 349A10.2 10.2 0 0 0 349 334z"
  ]
}, Nie = {
  prefix: "fak",
  iconName: "image",
  icon: [
    606,
    512,
    [],
    "e02b",
    "M534.6 0L66.6 0C29.8 0 0 29.8 0 66.6L0 424c0 36.8 29.8 66.6 66.6 66.6l468 0c36.8 0 66.6-29.8 66.6-66.6l0-357.5C601.1 29.8 571.3 0 534.6 0zM66.6 41.9l468 0c13.7 0 24.7 11.2 24.7 24.7l0 251.1-137.3-137.3c-7.2-7.2-19.1-7.2-26.3 0l-141 141-61.2-61.2c-3.5-3.5-8.1-5.4-13.3-5.4l0 0c-4.9 0-9.8 2.1-13.3 5.6l-125 128.2 0-322.1c0-13.7 11.2-24.7 24.7-24.7zm468 407l-468 0c-8.8 0-16.1-4.9-20.5-11.6l134.3-137.5 61 61c7.2 7.2 19.1 7.2 26.3 0l141-141 150.6 150.6 0 53.8c0 13.7-11.2 24.7-24.7 24.7zM147.8 216.4a64.7 64.7 0 1 0 0-129.4 64.7 64.7 0 1 0 0 129.4zm0-37a27.5 27.5 0 1 1 0-54.9 27.5 27.5 0 1 1 0 54.9z"
  ]
}, Vie = {
  prefix: "fak",
  iconName: "icon-ciconfig-bar-arrow",
  icon: [
    512,
    512,
    [],
    "e008",
    "M256 0C115 0 0 115 0 256s115 256 256 256 256-115 256-256h0C512 115 397 0 256 0h0zM223 370c-4.78 0-9.9-1.71-13.7-5.12-8.53-7.51-9.22-20.5-1.37-29l72-79.9-72-79.9c-7.51-8.53-6.83-21.5 1.37-29 8.19-7.51 21.2-6.83 29 1.37l84.3 93.5c7.17 7.85 7.17 19.5 0 27.3l-84.3 93.5c-4.1 4.44-9.56 6.83-15.4 6.83z"
  ]
}, Uie = {
  prefix: "fak",
  iconName: "icon-x",
  icon: [
    512,
    512,
    [],
    "e01a",
    "M306 260l204-204A32.9 32.9 0 0 0 463 9.64L260 213 56.2 9.64A32.9 32.9 0 0 0 9.64 56.2L213 260 9.64 463a32.9 32.9 0 1 0 46.5 46.5L260 306l204 204a32.9 32.9 0 0 0 46.5-46.5z"
  ]
}, Fie = {
  prefix: "fak",
  iconName: "icon-expander-small-open",
  icon: [
    1110,
    512,
    [],
    "e012",
    "M546 538a76.6 76.6 0 0 1 -48.6-17.4l-469-384A76.8 76.8 0 1 1 126 17.3L546 362 967 17.3A76.8 76.8 0 1 1 1064 136l-469 384A76.6 76.6 0 0 1 546 538z"
  ]
}, qie = {
  prefix: "fak",
  iconName: "icon-text-alignment",
  icon: [
    512,
    512,
    [],
    "e024",
    "M351.7 512H160c-4.5-9-6.4-18.9-6.1-29.1c-.3-9.9 1.6-19.5 5.8-28.5h34.6c12.8 1 24-8.3 25-21.1c0-1.3 0-2.6 0-3.8V85.1c1.6-13.4-8.3-25.9-21.8-27.2c-1.3 0-2.6-.3-3.8 0H136.3c-19.8-1.3-37.1 13.8-38.4 33.6c0 .6 0 1 0 1.6c-1.9 19.5-1.6 39 .6 58.6C88 157.4 76.5 160 64.6 160c-10.6 .6-20.8-2.2-29.4-8c-2.6-40-2.9-80.3-1-120.3c1-18.2 4.2-25 6.4-27.2C47 1 54.4-.3 61.8 .6h389.8c7.4-1 14.7 .3 21.4 3.5c1.9 1.9 5.1 7.7 6.1 26.6c1.9 40.3 1.9 80.6-.3 120.6c-9.9 5.8-21.1 8.3-32.3 8c-11.2 .3-22.1-2.2-32-7.4c1.9-19.8 2.2-39.7 1-59.2v-.6c-1-19.8-17.9-34.9-37.4-33.9h-57.3C307.2 57 295.4 66.6 293.8 80c-.3 1.9 0 3.5 0 5.4v344.3c-1 12.8 8.6 24 21.4 25c1.3 0 2.6 0 3.8 0h34.2c4.2 9 6.1 18.6 5.8 28.5c-1 9.6-2.9 19.5-7.4 28.8z"
  ]
}, Bie = {
  prefix: "fak",
  iconName: "colorpicker",
  icon: [
    512,
    512,
    [],
    "e02e",
    "M481.8 27.6l-5.5-5.4C462.1 8 442.8 0 422.8 0s-39.3 8-53.5 22.2L294.4 97 283.5 86.5c-17.9-17.8-46.8-17.8-64.6 0L207 98.3c-17.8 17.9-17.8 46.8 0 64.6l10.8 10.9-194.7 194.9c-30.9 30.9-30.9 81.1 0 112s81.1 30.9 112 0L329.9 286 340.8 296.9c17.9 17.8 46.8 17.8 64.6 0L417.2 285c8.6-8.6 13.4-20.2 13.4-32.3s-4.8-23.7-13.4-32.3l-10.6-10.6 74.8-74.8c14.2-14.2 22.2-33.5 22.2-53.5s-8-39.3-22.2-53.5zM96.2 441.7c-9.4 9.4-24.6 9.4-34 0s-9.4-24.6 0-34l194.7-194.7 34 34z"
  ]
}, Hie = {
  prefix: "fak",
  iconName: "icon-size-stout",
  icon: [
    237,
    512,
    [],
    "e017",
    "M119 190a41.4 41.4 0 1 0 -41.4-41.4A41.4 41.4 0 0 0 119 190zm0-68.5A27.2 27.2 0 1 1 91.5 148 27.2 27.2 0 0 1 119 121zM203 229a43.3 43.3 0 0 0 -31.8-28.8 85.5 85.5 0 0 0 -27.2 1.67 165 165 0 0 1 -25.3 2.66h-.185a168 168 0 0 1 -25.3-2.66 86.9 86.9 0 0 0 -27.5-1.67 43.3 43.3 0 0 0 -31.8 28.8 223 223 0 0 0 -9.93 68 237 237 0 0 0 4.85 44.6 22.3 22.3 0 0 0 37.5 10.1c-.415 21.9-.904 45.6-1.34 66.6l-.861 42.7a30.6 30.6 0 0 0 54.3 19.4A30.6 30.6 0 0 0 173 461c-.208-11.4-.538-27.2-.9-44.8-.419-20.4-.885-43.2-1.28-64.3a22.3 22.3 0 0 0 37.5-10.3 238 238 0 0 0 4.79-44.4A223 223 0 0 0 203 229zm-4.25 67.7a224 224 0 0 1 -4.41 41.4 8.08 8.08 0 0 1 -7.85 6.09 7.99 7.99 0 0 1 -7.88-7.03A76.2 76.2 0 0 0 186 305a161 161 0 0 0 -13.6-58 7.06 7.06 0 0 0 -9.54-2.82 7.13 7.13 0 0 0 -2.92 9.58A147 147 0 0 1 172 305a66.7 66.7 0 0 1 -12.5 38.1c-.731 1.12-1.33 2.03-1.74 2.74l-1 1.72 .039 1.98c.408 21.8 .9 45.6 1.34 66.9 .362 17.6 .685 33.4 .892 44.7a16.5 16.5 0 1 1 -33.1 0V350a7.09 7.09 0 1 0 -14.2 0V461a16.5 16.5 0 0 1 -33.1 .131l.862-42.5c.454-21.8 .962-46.6 1.38-69.2l.038-1.98-1-1.72c-.408-.708-1.01-1.62-1.74-2.74A66.7 66.7 0 0 1 65.4 305a147 147 0 0 1 11.9-51.3 7.09 7.09 0 0 0 -12.5-6.77A161 161 0 0 0 51.2 305a76.2 76.2 0 0 0 7.18 32.3 8.02 8.02 0 0 1 -15.7 1.12 223 223 0 0 1 -4.46-41.6 211 211 0 0 1 8.84-62.2 29.6 29.6 0 0 1 21.4-20.3 81.1 81.1 0 0 1 22.7 1.74 182 182 0 0 0 27.5 2.84h.215a178 178 0 0 0 27.5-2.84 79.5 79.5 0 0 1 22.4-1.74 29.6 29.6 0 0 1 21.4 20.3A211 211 0 0 1 199 297z"
  ]
}, Gie = {
  prefix: "fak",
  iconName: "icon-size-tall",
  icon: [
    237,
    512,
    [],
    "e018",
    "M118 103a41.4 41.4 0 1 0 -41.4-41.4A41.4 41.4 0 0 0 118 103zm0-68.5a27.2 27.2 0 1 1 -27.2 27.2A27.2 27.2 0 0 1 118 34.3zM189 282c-.035-3.16-.119-12.7-.223-25.1-.285-32.8-.754-87.6-1.04-97.4a55.8 55.8 0 0 0 -5.75-28.6A35 35 0 0 0 160 114a44.8 44.8 0 0 0 -22.4 1.84c-1.02 .277-1.95 .523-2.75 .715a95.1 95.1 0 0 1 -16.6 1.94 110 110 0 0 1 -16.5-1.94c-.808-.192-1.74-.438-2.76-.715a44.7 44.7 0 0 0 -22.4-1.84 35 35 0 0 0 -21.8 17.1 55.8 55.8 0 0 0 -5.75 28.6c-.288 9.82-.758 64.7-1.04 97.4-.104 12.4-.188 21.9-.223 25.1l-.004 .223V283A21.8 21.8 0 0 0 77.1 303L74.4 466a25.6 25.6 0 0 0 44.1 17.6 25.6 25.6 0 0 0 44.1-17.8l-2.62-163a21.8 21.8 0 0 0 29.1-20.5zm-21.8 7.85a7.64 7.64 0 0 1 -7.63-7.62q0-.196-.012-.392l-1.82-113a7.09 7.09 0 0 0 -7.08-6.98l-.119 .008a7.09 7.09 0 0 0 -6.97 7.2l4.77 297a11.4 11.4 0 0 1 -22.8 0V297a7.09 7.09 0 1 0 -14.2 0V466a11.4 11.4 0 0 1 -22.8 .046l4.77-297A7.09 7.09 0 0 0 86.4 162l-.119-.008a7.09 7.09 0 0 0 -7.08 6.98l-1.82 113c-.008 .146-.012 .3-.012 .446a7.63 7.63 0 0 1 -15.3 .092c.038-3.02 .119-12.6 .231-25.3 .281-32.7 .75-87.5 1.03-97.2a42.8 42.8 0 0 1 4.12-22.3 20.8 20.8 0 0 1 13-10.1 34.9 34.9 0 0 1 15 1.85c1.18 .315 2.25 .608 3.19 .823a101 101 0 0 0 19.9 2.32 110 110 0 0 0 19.7-2.32c.927-.215 2-.508 3.18-.823a35 35 0 0 1 15-1.85 20.8 20.8 0 0 1 13 10.1 42.8 42.8 0 0 1 4.12 22.3c.281 9.68 .75 64.4 1.03 97.2 .112 12.6 .192 22.3 .231 25.3A7.64 7.64 0 0 1 167 290z"
  ]
}, Wie = {
  prefix: "fak",
  iconName: "icon-zoom-out",
  icon: [
    512,
    512,
    [],
    "e01c",
    "M439.9 507.3c-16.3 0-30.3-4.7-41.9-18.6L230.4 321.2c-9.3-9.3-9.3-20.9 0-30.3s20.9-9.3 30.3 0l167.6 167.6c7 7 18.6 7 25.6 0s7-18.6 0-25.6L286.3 265.3c-9.3-9.3-9.3-20.9 0-30.3s20.9-9.3 30.3 0l167.6 167.6c23.3 23.3 23.3 62.8 0 86.1c-14 11.6-30.3 18.6-44.2 18.6l0 0zM172.2 360.7s0 0 0 0C74.5 356.1 0 276.9 0 181.5S81.5 0 181.5 0s181.5 81.5 181.5 181.5c0 2.3 0 4.7 0 9.3c-2.3 9.3-14 18.6-23.3 18.6c-11.6 0-20.9-9.3-20.9-20.9c0-2.3 0-4.7 0-7c0-76.8-62.8-139.6-139.6-139.6S39.6 104.7 39.6 181.5s58.2 135 132.7 137.3c11.6 0 20.9 9.3 20.9 20.9s-9.3 20.9-20.9 20.9zm65.2-165.2H121c-11.6 0-20.9-9.3-20.9-20.9s9.3-20.9 20.9-20.9h116.4c11.6 0 20.9 9.3 20.9 20.9s-9.3 20.9-20.9 20.9z"
  ]
}, Zie = {
  prefix: "fak",
  iconName: "icon-ciconfig-bar-check",
  icon: [
    512,
    512,
    [],
    "e009",
    "M256 0C115 0 0 115 0 256s115 256 256 256 256-115 256-256h0C512 115 397 0 256 0h0zM221 362c-5.46 0-10.6-2.05-14.3-6.14l-81.9-81.9c-7.85-7.85-7.85-20.8 0-29 7.85-7.85 20.8-7.85 29 0l66.6 66.6 138-156c7.51-8.53 20.5-9.22 29-1.71 8.53 7.51 9.22 20.5 1.71 29l-152 172c-3.75 4.1-9.22 6.83-14.7 6.83h-.683z"
  ]
}, Kie = {
  prefix: "fak",
  iconName: "icon-size-default",
  icon: [
    237,
    512,
    [],
    "e015",
    "M119 150a41.4 41.4 0 1 0 -41.4-41.4A41.4 41.4 0 0 0 119 150zm0-68.5a27.2 27.2 0 1 1 -27.2 27.2A27.2 27.2 0 0 1 119 81.4zM194 205a54.4 54.4 0 0 0 -7.26-29 35.1 35.1 0 0 0 -27.9-17.1 74.1 74.1 0 0 0 -17.8 2.31 107 107 0 0 1 -22.2 2.94 101 101 0 0 1 -22.3-2.93 73.6 73.6 0 0 0 -17.7-2.32 35.1 35.1 0 0 0 -27.9 17.1A54.5 54.5 0 0 0 43.4 205c-.608 12.7-1.95 94.6-2.01 98.2a22.8 22.8 0 0 0 31.4 21.3c-.8 47.6-1.69 101-2.33 140A27.6 27.6 0 0 0 119 483a27.6 27.6 0 0 0 48.1-18.5c-.715-44.1-1.43-86.4-2.15-129l-.181-10.8a22.7 22.7 0 0 0 8.48 1.67 23 23 0 0 0 22.9-23.1C196 300 194 218 194 205zM173 312a8.77 8.77 0 0 1 -8.75-8.76c0-.164-.083-.301-.092-.463L162 215a7.09 7.09 0 0 0 -7.08-6.98l-.115 .008a7.08 7.08 0 0 0 -6.97 7.2l2.02 121c.723 42.3 1.44 84.5 2.15 129a13.4 13.4 0 0 1 -26.8 0V319a7.09 7.09 0 1 0 -14.2 0v145a13.4 13.4 0 0 1 -26.8 .115c1.35-82.3 3.91-233 4.17-248l.016-1.1a7.08 7.08 0 0 0 -6.95-7.21l-.131-.008a7.09 7.09 0 0 0 -7.08 6.96v.008l-.008 .023c0 .146-.008 .446-.016 .885L73.1 303l.004 .069-.012 .054a8.76 8.76 0 0 1 -17.5 .115c.016-.854 1.39-85.2 1.99-97.6a41.3 41.3 0 0 1 5.03-22.1 21.4 21.4 0 0 1 16.5-10.6 59.7 59.7 0 0 1 14.2 2.02 108 108 0 0 0 25.3 3.24 119 119 0 0 0 25-3.25 58.3 58.3 0 0 1 14.4-2.02 21.3 21.3 0 0 1 16.5 10.6 41.2 41.2 0 0 1 5.03 22.1c.608 12.4 1.98 96.8 1.99 97.5A8.77 8.77 0 0 1 173 312z"
  ]
}, Qie = {
  prefix: "fak",
  iconName: "icon-arrow-circle-grey-left",
  icon: [
    512,
    512,
    [],
    "e004",
    "M256 0A256 256 0 1 0 256 512A256 256 0 1 0 256 0zM284 352a10.2 10.2 0 0 1 -7.48-3.26l-79.6-85.3a10.2 10.2 0 0 1 0-14l79.6-85.3a10.2 10.2 0 1 1 15 14L219 256l73.1 78.3a10.2 10.2 0 0 1 -7.48 17.2z"
  ]
}, Xie = {
  prefix: "fak",
  iconName: "customer-logos",
  icon: [
    649,
    512,
    [],
    "e02c",
    "M553.3 7.9c-6.1-5.5-13.7-8.2-22.2-7.9-8.2 .3-15.7 4.1-21.2 10.2l-200.4 226.3-96.3-96.3c-11.9-11.9-31.4-11.9-43.3 0s-11.9 31.4 0 43.3L289.5 303.1c5.8 5.8 13.7 8.9 21.8 8.9l.7 0 0 0c8.5 0 16.4-4.1 22.2-10.2L556.4 51.2c11.3-12.6 10.2-32.1-2.7-43.3zm61.1 253.3c-16.7 0-30 13.3-30 30l0 107.5c0 17.1-14.3 30.7-31.4 30.7l-461.8 0c-17.1 0-30.7-13.7-31.1-30.7l0-107.5c0-16.7-13.3-30-30-30s-30 13.3-30 30L0 399c.3 50.2 41 90.5 90.8 90.5l461.8 0c24.2 1 47.8-8.5 64.5-26.3 17.4-17.1 27.3-40.3 27.3-64.5l0-107.9c0-16.7-13.3-30-30-30z"
  ]
}, Jie = {
  prefix: "fak",
  iconName: "saved-designs",
  icon: [
    602,
    512,
    [],
    "e029",
    "M530.9 88.8l-236 0-74.1-72.8c-10.5-10.2-24.3-16-39-16L55.4 0C24.9 0 0 24.9 0 55.4l0 388c0 26.9 22 49 49 49l481.9 0c26.9 0 49-22 49-49l0-305.6c0-26.9-22-49-49-49zM40.1 55.4c0-8.5 6.9-15.4 15.4-15.4l126.7 0c4 0 8 1.6 10.9 4.5l45 44.3-197.9 0 0-33.4zM540 443.7c0 4.9-4 8.9-8.9 8.9L49 452.6c-4.9 0-8.9-4-8.9-8.9l0-314.8 490.9 0c4.9 0 8.9 4 8.9 8.9l0 305.6zM220.8 410.9c-3.3 0-6.5-1.1-9.1-2.9-4.9-3.6-7.1-9.3-6.2-15.1l11.8-69-50.1-49c-4.2-4.2-5.8-10.2-4-16 1.8-5.6 6.7-9.8 12.5-10.7l69.2-10 30.9-62.8c5.3-10.7 22.7-10.7 28 0l30.9 62.8 69.2 10c5.8 .9 10.7 4.9 12.5 10.7 1.8 5.6 .2 11.8-4 16l-50.1 49 11.8 69c.9 5.8-1.3 11.8-6.2 15.1-4.9 3.6-11.1 4-16.5 1.1l-62.1-32.5-62.1 32.5c-2.2 1.1-4.7 1.8-7.3 1.8zm69.2-67.7c2.4 0 4.9 .7 7.3 1.8l41.4 21.8-7.8-46.1c-.9-5.1 .9-10.2 4.5-13.8l33.4-32.5-46.3-6.7c-5.1-.7-9.6-4-11.8-8.5l-20.7-41.9-20.7 41.9c-2.2 4.7-6.7 7.8-11.8 8.5l-46.3 6.7 33.4 32.5c3.8 3.6 5.3 8.7 4.5 13.8l-7.8 46.1 41.4-21.8c2.2-1.1 4.7-1.8 7.3-1.8z"
  ]
}, Yie = {
  prefix: "fak",
  iconName: "icon-close-small",
  icon: [
    512,
    512,
    [],
    "e00d",
    "M256 12.8A243 243 0 1 1 12.8 256 243 243 0 0 1 256 12.8m0-12.8A256 256 0 1 0 512 256 256 256 0 0 0 256 0zM272 256 347 181a11.5 11.5 0 0 0 -16.3-16.3l-75.1 75.1L181 165A11.5 11.5 0 0 0 165 181l75 75-75 75.1A11.5 11.5 0 1 0 181 347l75.1-75.1L331 347A11.5 11.5 0 0 0 347 331z"
  ]
}, ere = {
  prefix: "fak",
  iconName: "icon-ciconfig-archive",
  icon: [
    566,
    512,
    [],
    "e006",
    "M343 291h-123c-13.5 0-24.3-10.8-24.3-24.3s10.8-24.3 24.3-24.3h123c13.5 0 24.3 10.8 24.3 24.3s-10.8 24.3-24.3 24.3zM508 0H51.3C23 0 .053 22.9 .053 51.2v57.7c0 24.8 17.8 45.5 41.5 50.1V428c0 43.1 35 78.1 78.1 78.1h320c43.1 0 78.1-35 78.1-78.1V159c23.7-4.58 41.5-25.3 41.5-50.1V51.2c0-28.3-22.9-51.2-51.2-51.2zM48.6 51.2c0-1.35 1.08-2.69 2.69-2.69H508c1.35 0 2.69 1.08 2.69 2.69v57.7c0 1.35-1.08 2.69-2.69 2.69H51.3c-1.35 0-2.69-1.08-2.69-2.69V51.2zm391 407H120c-16.4 0-29.6-13.2-29.6-29.6V160h379V428c0 16.4-13.2 29.6-29.6 29.6z"
  ]
}, tre = {
  prefix: "fak",
  iconName: "icon-ciconfig-areaonoff",
  icon: [
    512,
    512,
    [],
    "e007",
    "M251 321c-31.3 0-56.6-25.3-56.6-56.6s25.3-56.6 56.6-56.6 56.6 25.3 56.6 56.6-25.3 56.6-56.6 56.6zm0-80.8c-13.5 0-24.3 10.8-24.3 24.3s10.8 24.3 24.3 24.3 24.3-10.8 24.3-24.3-10.8-24.3-24.3-24.3zM251 384c-97 0-182-74.9-182-120s85.2-120 182-120 182 74.9 182 120-85.2 120-182 120zm0-208c-86 0-150 67.1-150 87.6s63.9 87.6 150 87.6 150-67.1 150-87.6-63.9-87.6-150-87.6zM21.6 178c-11.9 0-21.6-9.7-21.6-21.6V75.5C0 34 34 0 75.5 0h71.9c11.9 0 21.6 9.7 21.6 21.6s-9.7 21.6-21.6 21.6H75.5c-17.8 0-32.3 14.6-32.3 32.3v80.8c0 11.9-9.7 21.6-21.6 21.6zM147 501H75.5c-41.5 0-75.5-34-75.5-75.5v-53.9c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6v53.9c0 17.8 14.6 32.3 32.3 32.3h71.9c11.9 0 21.6 9.7 21.6 21.6s-9.7 21.6-21.6 21.6zM426 501h-62.8c-11.9 0-21.6-9.7-21.6-21.6s9.7-21.6 21.6-21.6h62.8c17.8 0 32.3-14.6 32.3-32.3v-53.9c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6v53.9c0 41.5-34 75.5-75.5 75.5zM480 178c-11.9 0-21.6-9.7-21.6-21.6V75.5c0-17.8-14.6-32.3-32.3-32.3h-62.8c-11.9 0-21.6-9.7-21.6-21.6s9.7-21.6 21.6-21.6h62.8c41.5 0 75.5 34 75.5 75.5v80.8c0 11.9-9.7 21.6-21.6 21.6z"
  ]
}, nre = {
  prefix: "fak",
  iconName: "icon-direkteinstickung",
  icon: [
    496,
    512,
    [],
    "e025",
    "M492.4 67.7c0-18.2-6.6-33-21.5-47.9S439.6 0 421.4 0c-33 1.7-57.8 29.7-59.5 31.4l-5 6.6c-19.8-9.9-62.8-26.4-112.3-18.2c-56.2 8.3-92.5 38-104.1 84.2c-6.6 21.5-11.6 77.6 56.2 135.4L3.6 483.9c-5 6.6-3.3 14.9 1.7 19.8c3.3 3.3 6.6 3.3 9.9 3.3s6.6-1.7 9.9-3.3l237.8-203.1c29.7 14.9 104.1 62.8 107.4 105.7c0 14.9-3.3 28.1-13.2 38c-21.5 19.8-64.4 29.7-120.6 26.4c-8.3 0-14.9 5-16.5 13.2s5 14.9 13.2 16.5c8.3 0 18.2 1.7 26.4 1.7c52.9 0 94.1-13.2 117.3-36.3c16.5-16.5 23.1-36.3 23.1-61.1c-3.3-57.8-82.6-107.4-112.3-123.9l150.3-128.8c5 16.5 3.3 36.3-3.3 54.5c-9.9 28.1-34.7 26.4-38 24.8c-8.3-1.7-14.9 5-16.5 13.2s5 14.9 13.2 16.5c1.7 0 5 0 8.3 0c18.2 0 47.9-8.3 62.8-44.6c11.6-29.7 9.9-59.5 0-85.9c3.3-6.6 26.4-31.4 28.1-62.8l0 0zM168.7 112.3C177 77.6 203.4 57.8 248 49.5c36.3-5 69.4 5 87.5 13.2L213.3 216.4c-52.9-46.2-49.5-87.5-44.6-104.1zM122.5 381.5l261-330.3s16.5-19.8 38-21.5c0 0 1.7 0 1.7 0c8.3 0 18.2 3.3 26.4 11.6s13.2 16.5 13.2 26.4c0 13.2-9.9 28.1-16.5 36.3c-5-6.6-9.9-13.2-16.5-18.2l1.7-3.3c6.6-6.6 5-14.9 0-21.5s-14.9-5-21.5 0l-28.1 28.1c-6.6 6.6-5 14.9 0 21.5c3.3 3.3 6.6 5 11.6 5s8.3-1.7 9.9-5l3.3-5c6.6 5 11.6 11.6 16.5 16.5L122.5 381.5z"
  ]
}, ore = {
  prefix: "fak",
  iconName: "icon-pdf",
  icon: [
    443,
    512,
    [],
    "e01f",
    "M442.6 146.6L303 7c-4.7-4.7-9.3-7-14-7H70.2C30.7 0 .4 30.3 .4 69.8v370c0 37.2 30.3 69.8 69.8 69.8h309.5c37.2 0 69.8-30.3 69.8-69.8V160.6c-2.3-4.7-4.7-9.3-7-14zM309.9 72.1l67.5 69.8h-41.9c-14 0-25.6-11.6-25.6-25.6l0-44.2zm69.8 393.3H70.2c-14 0-27.9-11.6-27.9-27.9V69.8c0-14 11.6-27.9 27.9-27.9H268V114c0 37.2 30.3 67.5 67.5 69.8h69.8v256c0 14-11.6 25.6-25.6 25.6zm-256-211.8H77.2v132.7h25.6v-46.5h18.6c11.6 0 23.3-2.3 32.6-11.6c7-9.3 11.6-18.6 11.6-30.3s-4.7-23.3-11.6-32.6c-9.3-7-18.6-11.6-30.3-11.6zm11.6 58.2c-2.3 2.3-7 4.7-11.6 4.7H105.1v-41.9h18.6c4.7 0 9.3 2.3 11.6 7s4.7 9.3 4.7 16.3c0 4.7-2.3 11.6-4.7 14zm88.4-58.2H188.9v132.7h34.9c14 0 27.9-4.7 37.2-14c9.3-11.6 14-25.6 14-41.9v-20.9c0-14-4.7-30.3-14-39.6c-9.3-11.6-23.3-16.3-37.2-16.3zm25.6 79.1c0 9.3-2.3 16.3-4.7 23.3c-4.7 4.7-11.6 7-18.6 7h-9.3v-88.4h9.3c7 0 14 2.3 18.6 7c4.7 7 7 16.3 4.7 25.6l0 25.6zm51.2 53.5h25.6v-53.5h41.9v-23.3H326.2v-34.9h46.5v-23.3h-72.1v135z"
  ]
}, are = {
  prefix: "fak",
  iconName: "icon-expander-open",
  icon: [
    1024,
    512,
    [],
    "e010",
    "M507 502A46.1 46.1 0 0 1 476 490l-461-410A46.1 46.1 0 0 1 76.7 11.6L507 394 937 11.6A46.1 46.1 0 0 1 998 80.5l-461 410A46.1 46.1 0 0 1 507 502z"
  ]
}, sre = {
  prefix: "fak",
  iconName: "icon-ciconfig-alert-check",
  icon: [
    512,
    512,
    [],
    "e019",
    "M256 0A256 256 0 1 0 256 512A256 256 0 1 0 256 0zM219 367c-5.55 0-11.1-2.35-15.1-6.19l-85.3-85.3c-8.32-8.32-8.32-21.8 0-30.1s21.8-8.32 30.1 0l69.3 69.3 144-162c7.89-8.75 21.3-9.6 30.1-1.71 8.75 7.89 9.6 21.3 1.71 30.1l-159 179c-3.84 4.48-9.39 7.04-15.4 7.25h-.64z"
  ]
}, ire = {
  prefix: "fak",
  iconName: "text",
  icon: [
    512,
    512,
    [],
    "e031",
    "M473 404.2s0 0 0 0l0-299.5s0 0 0 0c21.3-7.2 36.8-27.1 36.8-50.8 0-29.7-24.1-53.8-53.8-53.8-23.7 0-43.6 15.5-50.8 36.8 0 0 0 0 0 0l-300.6 0s0 0 0 0c-7.2-21.3-27.1-36.8-50.8-36.8-29.7 0-53.8 24.1-53.8 53.8 0 23.7 15.5 43.6 36.8 50.8 0 0 0 0 0 0l0 300.6s0 0 0 0c-21.3 7.2-36.8 27.1-36.8 50.8 0 29.7 24.1 53.8 53.8 53.8 23.7 0 43.6-15.5 50.8-36.8l300.9 0c7.5 20.8 27.2 35.7 50.5 35.7 29.7 0 53.8-24.1 53.8-53.8 0-23.7-15.5-43.6-36.8-50.8zM456 73.5a19.7 19.7 0 1 1 0-39.4 19.7 19.7 0 1 1 0 39.4zm-402.2 0a19.7 19.7 0 1 1 0-39.4 19.7 19.7 0 1 1 0 39.4zm0 362.7a19.7 19.7 0 1 1 0 39.4 19.7 19.7 0 1 1 0-39.4zm351 2.7s0 0 0 0l-300.2 0s0 0 0 0c-5.4-15.9-17.8-28.4-33.8-33.8 0 0 0 0 0 0l0-300.6s0 0 0 0c15.9-5.4 28.4-17.8 33.7-33.7l300.6 0c5.4 15.9 17.8 28.4 33.7 33.7l0 0 0 299.5 0 0c-16.2 5.5-28.9 18.4-34 34.8zm51.1-3.7a19.7 19.7 0 1 1 0 39.4 19.7 19.7 0 1 1 0-39.4zM133.3 145l0 55.4 34.1 0 0-21.3 70.4 0 0 162-33.1 0 0 34.1 33.1 0 17.1 0 49.9 0 0-34.1-32.9 0 0-162 70.4 0 0 21.3 34.1 0 0-55.4-243.1 0z"
  ]
};
const rre = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  faCheck: Eie,
  faCircleClose: Sie,
  faClose: gie,
  faColorpicker: Bie,
  faCustomerLogos: Xie,
  faDownload: xie,
  faIconArrowCircleGreyLeft: Qie,
  faIconArrowCircleGreyRight: Lie,
  faIconCiconfigAlertCheck: sre,
  faIconCiconfigAlertWarning: Iie,
  faIconCiconfigArchive: ere,
  faIconCiconfigAreaonoff: tre,
  faIconCiconfigBarArrow: Vie,
  faIconCiconfigBarCheck: Zie,
  faIconCiconfigItalic: zie,
  faIconCloseLarge: _ie,
  faIconCloseMedium: Die,
  faIconCloseSmall: Yie,
  faIconDatabase: uie,
  faIconDesignDatabase: Tie,
  faIconDesignLogo: mie,
  faIconDesignText: wie,
  faIconDirekteinstickung: nre,
  faIconEasytransfer: vie,
  faIconEdit: Pie,
  faIconExpanderClos: hie,
  faIconExpanderOpen: are,
  faIconExpanderSmallClose: bie,
  faIconExpanderSmallOpen: Fie,
  faIconInfo: pie,
  faIconPdf: ore,
  faIconRemove: yie,
  faIconSave: jie,
  faIconSizeDefault: Kie,
  faIconSizeSmall: Mie,
  faIconSizeStout: Hie,
  faIconSizeTall: Gie,
  faIconTextAlignment: qie,
  faIconX: Uie,
  faIconZoomIn: Oie,
  faIconZoomOut: Wie,
  faImage: Nie,
  faImages: Cie,
  faResize: Aie,
  faSavedDesigns: Jie,
  faSize: $ie,
  faSmake: Rie,
  faText: ire,
  faTshirtColor: fie,
  faTshirtSize: die,
  faUpload: kie
}, Symbol.toStringTag, { value: "Module" }));
ev.autoAddCss = !1;
tv.add(
  rre,
  tie,
  iie,
  oie,
  Use,
  bd,
  kd,
  Hse,
  qse,
  aie,
  sie,
  eie,
  wd,
  Yse,
  lie,
  cie,
  Fse,
  Gse,
  xd,
  Wse,
  Zse,
  Bse,
  Qse,
  Xse,
  kd,
  xd,
  wd,
  bd,
  nie,
  Jse,
  Vse
);
const lre = Ah(s9, {
  configureApp: (e) => {
    e.use(Fh, {
      enableDevtoolsV6Plugin: !0
    }), e.use(Uh());
    const t = g_({
      fallbackLocale: "en",
      legacy: !1,
      messages: { cs: gC, da: MT, de: qE, en: nj, fr: hV, hu: Aq, it: UG, nl: eQ, pl: pY, sk: Sne, sv: Nse }
    });
    e.use(t), e.provide(y_, t), e.component("FontAwesomeIcon", Fo), e.use(Jb), gk((n) => {
      console.debug("Endpoint Validation error", n);
    });
  },
  shadowRoot: !1
});
customElements.define("designer-strauss", lre);
export {
  Ct as FeatureFlags
};
//# sourceMappingURL=index.js.map
